import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  jsonb: any;
  numeric: any;
  smallint: any;
  timestamp: any;
  timestamptz: any;
  timetz: any;
  tsvector: any;
  uuid: any;
  xid8: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "active_option_tickers" */
export type Active_Option_Tickers = {
  __typename?: 'active_option_tickers';
  ticker?: Maybe<Scalars['String']>;
};

/** aggregated selection of "active_option_tickers" */
export type Active_Option_Tickers_Aggregate = {
  __typename?: 'active_option_tickers_aggregate';
  aggregate?: Maybe<Active_Option_Tickers_Aggregate_Fields>;
  nodes: Array<Active_Option_Tickers>;
};

/** aggregate fields of "active_option_tickers" */
export type Active_Option_Tickers_Aggregate_Fields = {
  __typename?: 'active_option_tickers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Active_Option_Tickers_Max_Fields>;
  min?: Maybe<Active_Option_Tickers_Min_Fields>;
};


/** aggregate fields of "active_option_tickers" */
export type Active_Option_Tickers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Active_Option_Tickers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "active_option_tickers". All fields are combined with a logical 'AND'. */
export type Active_Option_Tickers_Bool_Exp = {
  _and?: InputMaybe<Array<Active_Option_Tickers_Bool_Exp>>;
  _not?: InputMaybe<Active_Option_Tickers_Bool_Exp>;
  _or?: InputMaybe<Array<Active_Option_Tickers_Bool_Exp>>;
  ticker?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Active_Option_Tickers_Max_Fields = {
  __typename?: 'active_option_tickers_max_fields';
  ticker?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Active_Option_Tickers_Min_Fields = {
  __typename?: 'active_option_tickers_min_fields';
  ticker?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "active_option_tickers". */
export type Active_Option_Tickers_Order_By = {
  ticker?: InputMaybe<Order_By>;
};

/** select columns of table "active_option_tickers" */
export const Active_Option_Tickers_Select_Column = {
  /** column name */
  Ticker: 'ticker'
} as const;

export type Active_Option_Tickers_Select_Column = typeof Active_Option_Tickers_Select_Column[keyof typeof Active_Option_Tickers_Select_Column];
/** Streaming cursor of the table "active_option_tickers" */
export type Active_Option_Tickers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Active_Option_Tickers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Active_Option_Tickers_Stream_Cursor_Value_Input = {
  ticker?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "affiliate_link_clicks" */
export type Affiliate_Link_Clicks = {
  __typename?: 'affiliate_link_clicks';
  affiliateCodeUsed: Scalars['String'];
  /** An object relationship */
  affiliateUser?: Maybe<Users>;
  affiliateUserId?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  destinationPagePath: Scalars['String'];
  id: Scalars['uuid'];
  ip: Scalars['String'];
  referralUrl: Scalars['String'];
  /** An array relationship */
  sales: Array<Sales>;
  /** An aggregate relationship */
  sales_aggregate: Sales_Aggregate;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "affiliate_link_clicks" */
export type Affiliate_Link_ClicksSalesArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


/** columns and relationships of "affiliate_link_clicks" */
export type Affiliate_Link_ClicksSales_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


/** columns and relationships of "affiliate_link_clicks" */
export type Affiliate_Link_ClicksSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "affiliate_link_clicks" */
export type Affiliate_Link_ClicksSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

/** aggregated selection of "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_Aggregate = {
  __typename?: 'affiliate_link_clicks_aggregate';
  aggregate?: Maybe<Affiliate_Link_Clicks_Aggregate_Fields>;
  nodes: Array<Affiliate_Link_Clicks>;
};

export type Affiliate_Link_Clicks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Affiliate_Link_Clicks_Aggregate_Bool_Exp_Count>;
};

export type Affiliate_Link_Clicks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Affiliate_Link_Clicks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_Aggregate_Fields = {
  __typename?: 'affiliate_link_clicks_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Affiliate_Link_Clicks_Max_Fields>;
  min?: Maybe<Affiliate_Link_Clicks_Min_Fields>;
};


/** aggregate fields of "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Affiliate_Link_Clicks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Affiliate_Link_Clicks_Max_Order_By>;
  min?: InputMaybe<Affiliate_Link_Clicks_Min_Order_By>;
};

/** input type for inserting array relation for remote table "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_Arr_Rel_Insert_Input = {
  data: Array<Affiliate_Link_Clicks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Affiliate_Link_Clicks_On_Conflict>;
};

/** Boolean expression to filter rows from the table "affiliate_link_clicks". All fields are combined with a logical 'AND'. */
export type Affiliate_Link_Clicks_Bool_Exp = {
  _and?: InputMaybe<Array<Affiliate_Link_Clicks_Bool_Exp>>;
  _not?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
  _or?: InputMaybe<Array<Affiliate_Link_Clicks_Bool_Exp>>;
  affiliateCodeUsed?: InputMaybe<String_Comparison_Exp>;
  affiliateUser?: InputMaybe<Users_Bool_Exp>;
  affiliateUserId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  destinationPagePath?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip?: InputMaybe<String_Comparison_Exp>;
  referralUrl?: InputMaybe<String_Comparison_Exp>;
  sales?: InputMaybe<Sales_Bool_Exp>;
  sales_aggregate?: InputMaybe<Sales_Aggregate_Bool_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "affiliate_link_clicks" */
export const Affiliate_Link_Clicks_Constraint = {
  /** unique or primary key constraint on columns "id" */
  AffiliateLinkClicksPkey: 'affiliate_link_clicks_pkey'
} as const;

export type Affiliate_Link_Clicks_Constraint = typeof Affiliate_Link_Clicks_Constraint[keyof typeof Affiliate_Link_Clicks_Constraint];
/** input type for inserting data into table "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_Insert_Input = {
  affiliateCodeUsed?: InputMaybe<Scalars['String']>;
  affiliateUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  affiliateUserId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  destinationPagePath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  referralUrl?: InputMaybe<Scalars['String']>;
  sales?: InputMaybe<Sales_Arr_Rel_Insert_Input>;
  subscriptions?: InputMaybe<Subscriptions_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Affiliate_Link_Clicks_Max_Fields = {
  __typename?: 'affiliate_link_clicks_max_fields';
  affiliateCodeUsed?: Maybe<Scalars['String']>;
  affiliateUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  destinationPagePath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  referralUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_Max_Order_By = {
  affiliateCodeUsed?: InputMaybe<Order_By>;
  affiliateUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  destinationPagePath?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip?: InputMaybe<Order_By>;
  referralUrl?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Affiliate_Link_Clicks_Min_Fields = {
  __typename?: 'affiliate_link_clicks_min_fields';
  affiliateCodeUsed?: Maybe<Scalars['String']>;
  affiliateUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  destinationPagePath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  referralUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_Min_Order_By = {
  affiliateCodeUsed?: InputMaybe<Order_By>;
  affiliateUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  destinationPagePath?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip?: InputMaybe<Order_By>;
  referralUrl?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_Mutation_Response = {
  __typename?: 'affiliate_link_clicks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Affiliate_Link_Clicks>;
};

/** input type for inserting object relation for remote table "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_Obj_Rel_Insert_Input = {
  data: Affiliate_Link_Clicks_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Affiliate_Link_Clicks_On_Conflict>;
};

/** on_conflict condition type for table "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_On_Conflict = {
  constraint: Affiliate_Link_Clicks_Constraint;
  update_columns?: Array<Affiliate_Link_Clicks_Update_Column>;
  where?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
};

/** Ordering options when selecting data from "affiliate_link_clicks". */
export type Affiliate_Link_Clicks_Order_By = {
  affiliateCodeUsed?: InputMaybe<Order_By>;
  affiliateUser?: InputMaybe<Users_Order_By>;
  affiliateUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  destinationPagePath?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip?: InputMaybe<Order_By>;
  referralUrl?: InputMaybe<Order_By>;
  sales_aggregate?: InputMaybe<Sales_Aggregate_Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: affiliate_link_clicks */
export type Affiliate_Link_Clicks_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "affiliate_link_clicks" */
export const Affiliate_Link_Clicks_Select_Column = {
  /** column name */
  AffiliateCodeUsed: 'affiliateCodeUsed',
  /** column name */
  AffiliateUserId: 'affiliateUserId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DestinationPagePath: 'destinationPagePath',
  /** column name */
  Id: 'id',
  /** column name */
  Ip: 'ip',
  /** column name */
  ReferralUrl: 'referralUrl',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Affiliate_Link_Clicks_Select_Column = typeof Affiliate_Link_Clicks_Select_Column[keyof typeof Affiliate_Link_Clicks_Select_Column];
/** input type for updating data in table "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_Set_Input = {
  affiliateCodeUsed?: InputMaybe<Scalars['String']>;
  affiliateUserId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  destinationPagePath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  referralUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "affiliate_link_clicks" */
export type Affiliate_Link_Clicks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Affiliate_Link_Clicks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Affiliate_Link_Clicks_Stream_Cursor_Value_Input = {
  affiliateCodeUsed?: InputMaybe<Scalars['String']>;
  affiliateUserId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  destinationPagePath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  referralUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "affiliate_link_clicks" */
export const Affiliate_Link_Clicks_Update_Column = {
  /** column name */
  AffiliateCodeUsed: 'affiliateCodeUsed',
  /** column name */
  AffiliateUserId: 'affiliateUserId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DestinationPagePath: 'destinationPagePath',
  /** column name */
  Id: 'id',
  /** column name */
  Ip: 'ip',
  /** column name */
  ReferralUrl: 'referralUrl',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Affiliate_Link_Clicks_Update_Column = typeof Affiliate_Link_Clicks_Update_Column[keyof typeof Affiliate_Link_Clicks_Update_Column];
export type Affiliate_Link_Clicks_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Affiliate_Link_Clicks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Affiliate_Link_Clicks_Bool_Exp;
};

/** columns and relationships of "affiliate_payouts" */
export type Affiliate_Payouts = {
  __typename?: 'affiliate_payouts';
  affiliateUserId: Scalars['String'];
  amount: Scalars['numeric'];
  /** An array relationship */
  charges: Array<Charges>;
  /** An aggregate relationship */
  charges_aggregate: Charges_Aggregate;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  month: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  year: Scalars['Int'];
};


/** columns and relationships of "affiliate_payouts" */
export type Affiliate_PayoutsChargesArgs = {
  distinct_on?: InputMaybe<Array<Charges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Charges_Order_By>>;
  where?: InputMaybe<Charges_Bool_Exp>;
};


/** columns and relationships of "affiliate_payouts" */
export type Affiliate_PayoutsCharges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Charges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Charges_Order_By>>;
  where?: InputMaybe<Charges_Bool_Exp>;
};

/** aggregated selection of "affiliate_payouts" */
export type Affiliate_Payouts_Aggregate = {
  __typename?: 'affiliate_payouts_aggregate';
  aggregate?: Maybe<Affiliate_Payouts_Aggregate_Fields>;
  nodes: Array<Affiliate_Payouts>;
};

export type Affiliate_Payouts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Affiliate_Payouts_Aggregate_Bool_Exp_Count>;
};

export type Affiliate_Payouts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Affiliate_Payouts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Affiliate_Payouts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "affiliate_payouts" */
export type Affiliate_Payouts_Aggregate_Fields = {
  __typename?: 'affiliate_payouts_aggregate_fields';
  avg?: Maybe<Affiliate_Payouts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Affiliate_Payouts_Max_Fields>;
  min?: Maybe<Affiliate_Payouts_Min_Fields>;
  stddev?: Maybe<Affiliate_Payouts_Stddev_Fields>;
  stddev_pop?: Maybe<Affiliate_Payouts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Affiliate_Payouts_Stddev_Samp_Fields>;
  sum?: Maybe<Affiliate_Payouts_Sum_Fields>;
  var_pop?: Maybe<Affiliate_Payouts_Var_Pop_Fields>;
  var_samp?: Maybe<Affiliate_Payouts_Var_Samp_Fields>;
  variance?: Maybe<Affiliate_Payouts_Variance_Fields>;
};


/** aggregate fields of "affiliate_payouts" */
export type Affiliate_Payouts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Affiliate_Payouts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "affiliate_payouts" */
export type Affiliate_Payouts_Aggregate_Order_By = {
  avg?: InputMaybe<Affiliate_Payouts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Affiliate_Payouts_Max_Order_By>;
  min?: InputMaybe<Affiliate_Payouts_Min_Order_By>;
  stddev?: InputMaybe<Affiliate_Payouts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Affiliate_Payouts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Affiliate_Payouts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Affiliate_Payouts_Sum_Order_By>;
  var_pop?: InputMaybe<Affiliate_Payouts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Affiliate_Payouts_Var_Samp_Order_By>;
  variance?: InputMaybe<Affiliate_Payouts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "affiliate_payouts" */
export type Affiliate_Payouts_Arr_Rel_Insert_Input = {
  data: Array<Affiliate_Payouts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Affiliate_Payouts_On_Conflict>;
};

/** aggregate avg on columns */
export type Affiliate_Payouts_Avg_Fields = {
  __typename?: 'affiliate_payouts_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "affiliate_payouts" */
export type Affiliate_Payouts_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "affiliate_payouts". All fields are combined with a logical 'AND'. */
export type Affiliate_Payouts_Bool_Exp = {
  _and?: InputMaybe<Array<Affiliate_Payouts_Bool_Exp>>;
  _not?: InputMaybe<Affiliate_Payouts_Bool_Exp>;
  _or?: InputMaybe<Array<Affiliate_Payouts_Bool_Exp>>;
  affiliateUserId?: InputMaybe<String_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  charges?: InputMaybe<Charges_Bool_Exp>;
  charges_aggregate?: InputMaybe<Charges_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  month?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "affiliate_payouts" */
export const Affiliate_Payouts_Constraint = {
  /** unique or primary key constraint on columns "id" */
  AffiliatePayoutsPkey: 'affiliate_payouts_pkey'
} as const;

export type Affiliate_Payouts_Constraint = typeof Affiliate_Payouts_Constraint[keyof typeof Affiliate_Payouts_Constraint];
/** input type for incrementing numeric columns in table "affiliate_payouts" */
export type Affiliate_Payouts_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "affiliate_payouts" */
export type Affiliate_Payouts_Insert_Input = {
  affiliateUserId?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  charges?: InputMaybe<Charges_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  month?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Affiliate_Payouts_Max_Fields = {
  __typename?: 'affiliate_payouts_max_fields';
  affiliateUserId?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "affiliate_payouts" */
export type Affiliate_Payouts_Max_Order_By = {
  affiliateUserId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Affiliate_Payouts_Min_Fields = {
  __typename?: 'affiliate_payouts_min_fields';
  affiliateUserId?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "affiliate_payouts" */
export type Affiliate_Payouts_Min_Order_By = {
  affiliateUserId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "affiliate_payouts" */
export type Affiliate_Payouts_Mutation_Response = {
  __typename?: 'affiliate_payouts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Affiliate_Payouts>;
};

/** input type for inserting object relation for remote table "affiliate_payouts" */
export type Affiliate_Payouts_Obj_Rel_Insert_Input = {
  data: Affiliate_Payouts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Affiliate_Payouts_On_Conflict>;
};

/** on_conflict condition type for table "affiliate_payouts" */
export type Affiliate_Payouts_On_Conflict = {
  constraint: Affiliate_Payouts_Constraint;
  update_columns?: Array<Affiliate_Payouts_Update_Column>;
  where?: InputMaybe<Affiliate_Payouts_Bool_Exp>;
};

/** Ordering options when selecting data from "affiliate_payouts". */
export type Affiliate_Payouts_Order_By = {
  affiliateUserId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  charges_aggregate?: InputMaybe<Charges_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: affiliate_payouts */
export type Affiliate_Payouts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "affiliate_payouts" */
export const Affiliate_Payouts_Select_Column = {
  /** column name */
  AffiliateUserId: 'affiliateUserId',
  /** column name */
  Amount: 'amount',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  Month: 'month',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Year: 'year'
} as const;

export type Affiliate_Payouts_Select_Column = typeof Affiliate_Payouts_Select_Column[keyof typeof Affiliate_Payouts_Select_Column];
/** input type for updating data in table "affiliate_payouts" */
export type Affiliate_Payouts_Set_Input = {
  affiliateUserId?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  month?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Affiliate_Payouts_Stddev_Fields = {
  __typename?: 'affiliate_payouts_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "affiliate_payouts" */
export type Affiliate_Payouts_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Affiliate_Payouts_Stddev_Pop_Fields = {
  __typename?: 'affiliate_payouts_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "affiliate_payouts" */
export type Affiliate_Payouts_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Affiliate_Payouts_Stddev_Samp_Fields = {
  __typename?: 'affiliate_payouts_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "affiliate_payouts" */
export type Affiliate_Payouts_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "affiliate_payouts" */
export type Affiliate_Payouts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Affiliate_Payouts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Affiliate_Payouts_Stream_Cursor_Value_Input = {
  affiliateUserId?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  month?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Affiliate_Payouts_Sum_Fields = {
  __typename?: 'affiliate_payouts_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "affiliate_payouts" */
export type Affiliate_Payouts_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** update columns of table "affiliate_payouts" */
export const Affiliate_Payouts_Update_Column = {
  /** column name */
  AffiliateUserId: 'affiliateUserId',
  /** column name */
  Amount: 'amount',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  Month: 'month',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Year: 'year'
} as const;

export type Affiliate_Payouts_Update_Column = typeof Affiliate_Payouts_Update_Column[keyof typeof Affiliate_Payouts_Update_Column];
export type Affiliate_Payouts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Affiliate_Payouts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Affiliate_Payouts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Affiliate_Payouts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Affiliate_Payouts_Var_Pop_Fields = {
  __typename?: 'affiliate_payouts_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "affiliate_payouts" */
export type Affiliate_Payouts_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Affiliate_Payouts_Var_Samp_Fields = {
  __typename?: 'affiliate_payouts_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "affiliate_payouts" */
export type Affiliate_Payouts_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Affiliate_Payouts_Variance_Fields = {
  __typename?: 'affiliate_payouts_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "affiliate_payouts" */
export type Affiliate_Payouts_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** columns and relationships of "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts = {
  __typename?: 'affiliate_referral_click_counts';
  affiliateUserId?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['bigint']>;
  mostRecentDate?: Maybe<Scalars['timestamptz']>;
  referralUrl?: Maybe<Scalars['String']>;
};

/** aggregated selection of "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Aggregate = {
  __typename?: 'affiliate_referral_click_counts_aggregate';
  aggregate?: Maybe<Affiliate_Referral_Click_Counts_Aggregate_Fields>;
  nodes: Array<Affiliate_Referral_Click_Counts>;
};

export type Affiliate_Referral_Click_Counts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Affiliate_Referral_Click_Counts_Aggregate_Bool_Exp_Count>;
};

export type Affiliate_Referral_Click_Counts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Affiliate_Referral_Click_Counts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Aggregate_Fields = {
  __typename?: 'affiliate_referral_click_counts_aggregate_fields';
  avg?: Maybe<Affiliate_Referral_Click_Counts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Affiliate_Referral_Click_Counts_Max_Fields>;
  min?: Maybe<Affiliate_Referral_Click_Counts_Min_Fields>;
  stddev?: Maybe<Affiliate_Referral_Click_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Affiliate_Referral_Click_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Affiliate_Referral_Click_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Affiliate_Referral_Click_Counts_Sum_Fields>;
  var_pop?: Maybe<Affiliate_Referral_Click_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Affiliate_Referral_Click_Counts_Var_Samp_Fields>;
  variance?: Maybe<Affiliate_Referral_Click_Counts_Variance_Fields>;
};


/** aggregate fields of "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Aggregate_Order_By = {
  avg?: InputMaybe<Affiliate_Referral_Click_Counts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Affiliate_Referral_Click_Counts_Max_Order_By>;
  min?: InputMaybe<Affiliate_Referral_Click_Counts_Min_Order_By>;
  stddev?: InputMaybe<Affiliate_Referral_Click_Counts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Affiliate_Referral_Click_Counts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Affiliate_Referral_Click_Counts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Affiliate_Referral_Click_Counts_Sum_Order_By>;
  var_pop?: InputMaybe<Affiliate_Referral_Click_Counts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Affiliate_Referral_Click_Counts_Var_Samp_Order_By>;
  variance?: InputMaybe<Affiliate_Referral_Click_Counts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Arr_Rel_Insert_Input = {
  data: Array<Affiliate_Referral_Click_Counts_Insert_Input>;
};

/** aggregate avg on columns */
export type Affiliate_Referral_Click_Counts_Avg_Fields = {
  __typename?: 'affiliate_referral_click_counts_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "affiliate_referral_click_counts". All fields are combined with a logical 'AND'. */
export type Affiliate_Referral_Click_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Bool_Exp>>;
  _not?: InputMaybe<Affiliate_Referral_Click_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Bool_Exp>>;
  affiliateUserId?: InputMaybe<String_Comparison_Exp>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  mostRecentDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  referralUrl?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Insert_Input = {
  affiliateUserId?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['bigint']>;
  mostRecentDate?: InputMaybe<Scalars['timestamptz']>;
  referralUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Affiliate_Referral_Click_Counts_Max_Fields = {
  __typename?: 'affiliate_referral_click_counts_max_fields';
  affiliateUserId?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['bigint']>;
  mostRecentDate?: Maybe<Scalars['timestamptz']>;
  referralUrl?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Max_Order_By = {
  affiliateUserId?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  mostRecentDate?: InputMaybe<Order_By>;
  referralUrl?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Affiliate_Referral_Click_Counts_Min_Fields = {
  __typename?: 'affiliate_referral_click_counts_min_fields';
  affiliateUserId?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['bigint']>;
  mostRecentDate?: Maybe<Scalars['timestamptz']>;
  referralUrl?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Min_Order_By = {
  affiliateUserId?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  mostRecentDate?: InputMaybe<Order_By>;
  referralUrl?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "affiliate_referral_click_counts". */
export type Affiliate_Referral_Click_Counts_Order_By = {
  affiliateUserId?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  mostRecentDate?: InputMaybe<Order_By>;
  referralUrl?: InputMaybe<Order_By>;
};

/** select columns of table "affiliate_referral_click_counts" */
export const Affiliate_Referral_Click_Counts_Select_Column = {
  /** column name */
  AffiliateUserId: 'affiliateUserId',
  /** column name */
  Count: 'count',
  /** column name */
  MostRecentDate: 'mostRecentDate',
  /** column name */
  ReferralUrl: 'referralUrl'
} as const;

export type Affiliate_Referral_Click_Counts_Select_Column = typeof Affiliate_Referral_Click_Counts_Select_Column[keyof typeof Affiliate_Referral_Click_Counts_Select_Column];
/** aggregate stddev on columns */
export type Affiliate_Referral_Click_Counts_Stddev_Fields = {
  __typename?: 'affiliate_referral_click_counts_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Affiliate_Referral_Click_Counts_Stddev_Pop_Fields = {
  __typename?: 'affiliate_referral_click_counts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Affiliate_Referral_Click_Counts_Stddev_Samp_Fields = {
  __typename?: 'affiliate_referral_click_counts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Affiliate_Referral_Click_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Affiliate_Referral_Click_Counts_Stream_Cursor_Value_Input = {
  affiliateUserId?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['bigint']>;
  mostRecentDate?: InputMaybe<Scalars['timestamptz']>;
  referralUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Affiliate_Referral_Click_Counts_Sum_Fields = {
  __typename?: 'affiliate_referral_click_counts_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Affiliate_Referral_Click_Counts_Var_Pop_Fields = {
  __typename?: 'affiliate_referral_click_counts_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Affiliate_Referral_Click_Counts_Var_Samp_Fields = {
  __typename?: 'affiliate_referral_click_counts_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Affiliate_Referral_Click_Counts_Variance_Fields = {
  __typename?: 'affiliate_referral_click_counts_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "affiliate_referral_click_counts" */
export type Affiliate_Referral_Click_Counts_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** columns and relationships of "asset_signal_alerts" */
export type Asset_Signal_Alerts = {
  __typename?: 'asset_signal_alerts';
  asset: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  date: Scalars['date'];
  id: Scalars['uuid'];
  price: Scalars['numeric'];
  signal: Scalars['String'];
  text: Scalars['String'];
  ticker: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "asset_signal_alerts" */
export type Asset_Signal_Alerts_Aggregate = {
  __typename?: 'asset_signal_alerts_aggregate';
  aggregate?: Maybe<Asset_Signal_Alerts_Aggregate_Fields>;
  nodes: Array<Asset_Signal_Alerts>;
};

/** aggregate fields of "asset_signal_alerts" */
export type Asset_Signal_Alerts_Aggregate_Fields = {
  __typename?: 'asset_signal_alerts_aggregate_fields';
  avg?: Maybe<Asset_Signal_Alerts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Asset_Signal_Alerts_Max_Fields>;
  min?: Maybe<Asset_Signal_Alerts_Min_Fields>;
  stddev?: Maybe<Asset_Signal_Alerts_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Signal_Alerts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Signal_Alerts_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Signal_Alerts_Sum_Fields>;
  var_pop?: Maybe<Asset_Signal_Alerts_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Signal_Alerts_Var_Samp_Fields>;
  variance?: Maybe<Asset_Signal_Alerts_Variance_Fields>;
};


/** aggregate fields of "asset_signal_alerts" */
export type Asset_Signal_Alerts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Signal_Alerts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Asset_Signal_Alerts_Avg_Fields = {
  __typename?: 'asset_signal_alerts_avg_fields';
  price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "asset_signal_alerts". All fields are combined with a logical 'AND'. */
export type Asset_Signal_Alerts_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Signal_Alerts_Bool_Exp>>;
  _not?: InputMaybe<Asset_Signal_Alerts_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Signal_Alerts_Bool_Exp>>;
  asset?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  signal?: InputMaybe<String_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_signal_alerts" */
export const Asset_Signal_Alerts_Constraint = {
  /** unique or primary key constraint on columns "id" */
  AssetSignalAlertsPkey: 'asset_signal_alerts_pkey'
} as const;

export type Asset_Signal_Alerts_Constraint = typeof Asset_Signal_Alerts_Constraint[keyof typeof Asset_Signal_Alerts_Constraint];
/** input type for incrementing numeric columns in table "asset_signal_alerts" */
export type Asset_Signal_Alerts_Inc_Input = {
  price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "asset_signal_alerts" */
export type Asset_Signal_Alerts_Insert_Input = {
  asset?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['numeric']>;
  signal?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Asset_Signal_Alerts_Max_Fields = {
  __typename?: 'asset_signal_alerts_max_fields';
  asset?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['numeric']>;
  signal?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Asset_Signal_Alerts_Min_Fields = {
  __typename?: 'asset_signal_alerts_min_fields';
  asset?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['numeric']>;
  signal?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "asset_signal_alerts" */
export type Asset_Signal_Alerts_Mutation_Response = {
  __typename?: 'asset_signal_alerts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Signal_Alerts>;
};

/** on_conflict condition type for table "asset_signal_alerts" */
export type Asset_Signal_Alerts_On_Conflict = {
  constraint: Asset_Signal_Alerts_Constraint;
  update_columns?: Array<Asset_Signal_Alerts_Update_Column>;
  where?: InputMaybe<Asset_Signal_Alerts_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_signal_alerts". */
export type Asset_Signal_Alerts_Order_By = {
  asset?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  signal?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_signal_alerts */
export type Asset_Signal_Alerts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "asset_signal_alerts" */
export const Asset_Signal_Alerts_Select_Column = {
  /** column name */
  Asset: 'asset',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  Id: 'id',
  /** column name */
  Price: 'price',
  /** column name */
  Signal: 'signal',
  /** column name */
  Text: 'text',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Asset_Signal_Alerts_Select_Column = typeof Asset_Signal_Alerts_Select_Column[keyof typeof Asset_Signal_Alerts_Select_Column];
/** input type for updating data in table "asset_signal_alerts" */
export type Asset_Signal_Alerts_Set_Input = {
  asset?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['numeric']>;
  signal?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Asset_Signal_Alerts_Stddev_Fields = {
  __typename?: 'asset_signal_alerts_stddev_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Asset_Signal_Alerts_Stddev_Pop_Fields = {
  __typename?: 'asset_signal_alerts_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Asset_Signal_Alerts_Stddev_Samp_Fields = {
  __typename?: 'asset_signal_alerts_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "asset_signal_alerts" */
export type Asset_Signal_Alerts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Signal_Alerts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Signal_Alerts_Stream_Cursor_Value_Input = {
  asset?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['numeric']>;
  signal?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Asset_Signal_Alerts_Sum_Fields = {
  __typename?: 'asset_signal_alerts_sum_fields';
  price?: Maybe<Scalars['numeric']>;
};

/** update columns of table "asset_signal_alerts" */
export const Asset_Signal_Alerts_Update_Column = {
  /** column name */
  Asset: 'asset',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  Id: 'id',
  /** column name */
  Price: 'price',
  /** column name */
  Signal: 'signal',
  /** column name */
  Text: 'text',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Asset_Signal_Alerts_Update_Column = typeof Asset_Signal_Alerts_Update_Column[keyof typeof Asset_Signal_Alerts_Update_Column];
export type Asset_Signal_Alerts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Signal_Alerts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Signal_Alerts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Signal_Alerts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Signal_Alerts_Var_Pop_Fields = {
  __typename?: 'asset_signal_alerts_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Asset_Signal_Alerts_Var_Samp_Fields = {
  __typename?: 'asset_signal_alerts_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Asset_Signal_Alerts_Variance_Fields = {
  __typename?: 'asset_signal_alerts_variance_fields';
  price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "charges" */
export type Charges = {
  __typename?: 'charges';
  affiliateAmountPaid?: Maybe<Scalars['numeric']>;
  affiliatePaidAt?: Maybe<Scalars['timestamptz']>;
  affiliatePaymentStatus: Scalars['String'];
  /** An object relationship */
  affiliatePayout?: Maybe<Affiliate_Payouts>;
  affiliatePayoutId?: Maybe<Scalars['uuid']>;
  amountPaid: Scalars['numeric'];
  amountRefunded: Scalars['numeric'];
  chargeObject: Scalars['jsonb'];
  createdAt: Scalars['timestamptz'];
  externalChargeId: Scalars['String'];
  /** Using the Stripe key instead of internal so we don't have to check when charges come in against our own DB or worry about backfilling in the migration */
  externalInvoiceId: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  invoice: Invoices;
  paid: Scalars['Boolean'];
  refunded: Scalars['Boolean'];
  status: Scalars['String'];
  stripeCustomerId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "charges" */
export type ChargesChargeObjectArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "charges" */
export type Charges_Aggregate = {
  __typename?: 'charges_aggregate';
  aggregate?: Maybe<Charges_Aggregate_Fields>;
  nodes: Array<Charges>;
};

export type Charges_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Charges_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Charges_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Charges_Aggregate_Bool_Exp_Count>;
};

export type Charges_Aggregate_Bool_Exp_Bool_And = {
  arguments: Charges_Select_Column_Charges_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Charges_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Charges_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Charges_Select_Column_Charges_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Charges_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Charges_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Charges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Charges_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "charges" */
export type Charges_Aggregate_Fields = {
  __typename?: 'charges_aggregate_fields';
  avg?: Maybe<Charges_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Charges_Max_Fields>;
  min?: Maybe<Charges_Min_Fields>;
  stddev?: Maybe<Charges_Stddev_Fields>;
  stddev_pop?: Maybe<Charges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Charges_Stddev_Samp_Fields>;
  sum?: Maybe<Charges_Sum_Fields>;
  var_pop?: Maybe<Charges_Var_Pop_Fields>;
  var_samp?: Maybe<Charges_Var_Samp_Fields>;
  variance?: Maybe<Charges_Variance_Fields>;
};


/** aggregate fields of "charges" */
export type Charges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Charges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "charges" */
export type Charges_Aggregate_Order_By = {
  avg?: InputMaybe<Charges_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Charges_Max_Order_By>;
  min?: InputMaybe<Charges_Min_Order_By>;
  stddev?: InputMaybe<Charges_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Charges_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Charges_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Charges_Sum_Order_By>;
  var_pop?: InputMaybe<Charges_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Charges_Var_Samp_Order_By>;
  variance?: InputMaybe<Charges_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Charges_Append_Input = {
  chargeObject?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "charges" */
export type Charges_Arr_Rel_Insert_Input = {
  data: Array<Charges_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Charges_On_Conflict>;
};

/** aggregate avg on columns */
export type Charges_Avg_Fields = {
  __typename?: 'charges_avg_fields';
  affiliateAmountPaid?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "charges" */
export type Charges_Avg_Order_By = {
  affiliateAmountPaid?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  amountRefunded?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "charges". All fields are combined with a logical 'AND'. */
export type Charges_Bool_Exp = {
  _and?: InputMaybe<Array<Charges_Bool_Exp>>;
  _not?: InputMaybe<Charges_Bool_Exp>;
  _or?: InputMaybe<Array<Charges_Bool_Exp>>;
  affiliateAmountPaid?: InputMaybe<Numeric_Comparison_Exp>;
  affiliatePaidAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  affiliatePaymentStatus?: InputMaybe<String_Comparison_Exp>;
  affiliatePayout?: InputMaybe<Affiliate_Payouts_Bool_Exp>;
  affiliatePayoutId?: InputMaybe<Uuid_Comparison_Exp>;
  amountPaid?: InputMaybe<Numeric_Comparison_Exp>;
  amountRefunded?: InputMaybe<Numeric_Comparison_Exp>;
  chargeObject?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  externalChargeId?: InputMaybe<String_Comparison_Exp>;
  externalInvoiceId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice?: InputMaybe<Invoices_Bool_Exp>;
  paid?: InputMaybe<Boolean_Comparison_Exp>;
  refunded?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  stripeCustomerId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "charges" */
export const Charges_Constraint = {
  /** unique or primary key constraint on columns "externalChargeId" */
  ChargesExternalChargeIdKey: 'charges_externalChargeId_key',
  /** unique or primary key constraint on columns "id" */
  ChargesPkey: 'charges_pkey'
} as const;

export type Charges_Constraint = typeof Charges_Constraint[keyof typeof Charges_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Charges_Delete_At_Path_Input = {
  chargeObject?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Charges_Delete_Elem_Input = {
  chargeObject?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Charges_Delete_Key_Input = {
  chargeObject?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "charges" */
export type Charges_Inc_Input = {
  affiliateAmountPaid?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  amountRefunded?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "charges" */
export type Charges_Insert_Input = {
  affiliateAmountPaid?: InputMaybe<Scalars['numeric']>;
  affiliatePaidAt?: InputMaybe<Scalars['timestamptz']>;
  affiliatePaymentStatus?: InputMaybe<Scalars['String']>;
  affiliatePayout?: InputMaybe<Affiliate_Payouts_Obj_Rel_Insert_Input>;
  affiliatePayoutId?: InputMaybe<Scalars['uuid']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  amountRefunded?: InputMaybe<Scalars['numeric']>;
  chargeObject?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalChargeId?: InputMaybe<Scalars['String']>;
  /** Using the Stripe key instead of internal so we don't have to check when charges come in against our own DB or worry about backfilling in the migration */
  externalInvoiceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoice?: InputMaybe<Invoices_Obj_Rel_Insert_Input>;
  paid?: InputMaybe<Scalars['Boolean']>;
  refunded?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Charges_Max_Fields = {
  __typename?: 'charges_max_fields';
  affiliateAmountPaid?: Maybe<Scalars['numeric']>;
  affiliatePaidAt?: Maybe<Scalars['timestamptz']>;
  affiliatePaymentStatus?: Maybe<Scalars['String']>;
  affiliatePayoutId?: Maybe<Scalars['uuid']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  amountRefunded?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalChargeId?: Maybe<Scalars['String']>;
  /** Using the Stripe key instead of internal so we don't have to check when charges come in against our own DB or worry about backfilling in the migration */
  externalInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "charges" */
export type Charges_Max_Order_By = {
  affiliateAmountPaid?: InputMaybe<Order_By>;
  affiliatePaidAt?: InputMaybe<Order_By>;
  affiliatePaymentStatus?: InputMaybe<Order_By>;
  affiliatePayoutId?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  amountRefunded?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  externalChargeId?: InputMaybe<Order_By>;
  /** Using the Stripe key instead of internal so we don't have to check when charges come in against our own DB or worry about backfilling in the migration */
  externalInvoiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Charges_Min_Fields = {
  __typename?: 'charges_min_fields';
  affiliateAmountPaid?: Maybe<Scalars['numeric']>;
  affiliatePaidAt?: Maybe<Scalars['timestamptz']>;
  affiliatePaymentStatus?: Maybe<Scalars['String']>;
  affiliatePayoutId?: Maybe<Scalars['uuid']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  amountRefunded?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalChargeId?: Maybe<Scalars['String']>;
  /** Using the Stripe key instead of internal so we don't have to check when charges come in against our own DB or worry about backfilling in the migration */
  externalInvoiceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "charges" */
export type Charges_Min_Order_By = {
  affiliateAmountPaid?: InputMaybe<Order_By>;
  affiliatePaidAt?: InputMaybe<Order_By>;
  affiliatePaymentStatus?: InputMaybe<Order_By>;
  affiliatePayoutId?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  amountRefunded?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  externalChargeId?: InputMaybe<Order_By>;
  /** Using the Stripe key instead of internal so we don't have to check when charges come in against our own DB or worry about backfilling in the migration */
  externalInvoiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "charges" */
export type Charges_Mutation_Response = {
  __typename?: 'charges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Charges>;
};

/** on_conflict condition type for table "charges" */
export type Charges_On_Conflict = {
  constraint: Charges_Constraint;
  update_columns?: Array<Charges_Update_Column>;
  where?: InputMaybe<Charges_Bool_Exp>;
};

/** Ordering options when selecting data from "charges". */
export type Charges_Order_By = {
  affiliateAmountPaid?: InputMaybe<Order_By>;
  affiliatePaidAt?: InputMaybe<Order_By>;
  affiliatePaymentStatus?: InputMaybe<Order_By>;
  affiliatePayout?: InputMaybe<Affiliate_Payouts_Order_By>;
  affiliatePayoutId?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  amountRefunded?: InputMaybe<Order_By>;
  chargeObject?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  externalChargeId?: InputMaybe<Order_By>;
  externalInvoiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoices_Order_By>;
  paid?: InputMaybe<Order_By>;
  refunded?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: charges */
export type Charges_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Charges_Prepend_Input = {
  chargeObject?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "charges" */
export const Charges_Select_Column = {
  /** column name */
  AffiliateAmountPaid: 'affiliateAmountPaid',
  /** column name */
  AffiliatePaidAt: 'affiliatePaidAt',
  /** column name */
  AffiliatePaymentStatus: 'affiliatePaymentStatus',
  /** column name */
  AffiliatePayoutId: 'affiliatePayoutId',
  /** column name */
  AmountPaid: 'amountPaid',
  /** column name */
  AmountRefunded: 'amountRefunded',
  /** column name */
  ChargeObject: 'chargeObject',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  ExternalChargeId: 'externalChargeId',
  /** column name */
  ExternalInvoiceId: 'externalInvoiceId',
  /** column name */
  Id: 'id',
  /** column name */
  Paid: 'paid',
  /** column name */
  Refunded: 'refunded',
  /** column name */
  Status: 'status',
  /** column name */
  StripeCustomerId: 'stripeCustomerId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Charges_Select_Column = typeof Charges_Select_Column[keyof typeof Charges_Select_Column];
/** select "charges_aggregate_bool_exp_bool_and_arguments_columns" columns of table "charges" */
export const Charges_Select_Column_Charges_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  Paid: 'paid',
  /** column name */
  Refunded: 'refunded'
} as const;

export type Charges_Select_Column_Charges_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Charges_Select_Column_Charges_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Charges_Select_Column_Charges_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "charges_aggregate_bool_exp_bool_or_arguments_columns" columns of table "charges" */
export const Charges_Select_Column_Charges_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  Paid: 'paid',
  /** column name */
  Refunded: 'refunded'
} as const;

export type Charges_Select_Column_Charges_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Charges_Select_Column_Charges_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Charges_Select_Column_Charges_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "charges" */
export type Charges_Set_Input = {
  affiliateAmountPaid?: InputMaybe<Scalars['numeric']>;
  affiliatePaidAt?: InputMaybe<Scalars['timestamptz']>;
  affiliatePaymentStatus?: InputMaybe<Scalars['String']>;
  affiliatePayoutId?: InputMaybe<Scalars['uuid']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  amountRefunded?: InputMaybe<Scalars['numeric']>;
  chargeObject?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalChargeId?: InputMaybe<Scalars['String']>;
  /** Using the Stripe key instead of internal so we don't have to check when charges come in against our own DB or worry about backfilling in the migration */
  externalInvoiceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  refunded?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Charges_Stddev_Fields = {
  __typename?: 'charges_stddev_fields';
  affiliateAmountPaid?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "charges" */
export type Charges_Stddev_Order_By = {
  affiliateAmountPaid?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  amountRefunded?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Charges_Stddev_Pop_Fields = {
  __typename?: 'charges_stddev_pop_fields';
  affiliateAmountPaid?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "charges" */
export type Charges_Stddev_Pop_Order_By = {
  affiliateAmountPaid?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  amountRefunded?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Charges_Stddev_Samp_Fields = {
  __typename?: 'charges_stddev_samp_fields';
  affiliateAmountPaid?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "charges" */
export type Charges_Stddev_Samp_Order_By = {
  affiliateAmountPaid?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  amountRefunded?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "charges" */
export type Charges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Charges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Charges_Stream_Cursor_Value_Input = {
  affiliateAmountPaid?: InputMaybe<Scalars['numeric']>;
  affiliatePaidAt?: InputMaybe<Scalars['timestamptz']>;
  affiliatePaymentStatus?: InputMaybe<Scalars['String']>;
  affiliatePayoutId?: InputMaybe<Scalars['uuid']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  amountRefunded?: InputMaybe<Scalars['numeric']>;
  chargeObject?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalChargeId?: InputMaybe<Scalars['String']>;
  /** Using the Stripe key instead of internal so we don't have to check when charges come in against our own DB or worry about backfilling in the migration */
  externalInvoiceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  refunded?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Charges_Sum_Fields = {
  __typename?: 'charges_sum_fields';
  affiliateAmountPaid?: Maybe<Scalars['numeric']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  amountRefunded?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "charges" */
export type Charges_Sum_Order_By = {
  affiliateAmountPaid?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  amountRefunded?: InputMaybe<Order_By>;
};

/** update columns of table "charges" */
export const Charges_Update_Column = {
  /** column name */
  AffiliateAmountPaid: 'affiliateAmountPaid',
  /** column name */
  AffiliatePaidAt: 'affiliatePaidAt',
  /** column name */
  AffiliatePaymentStatus: 'affiliatePaymentStatus',
  /** column name */
  AffiliatePayoutId: 'affiliatePayoutId',
  /** column name */
  AmountPaid: 'amountPaid',
  /** column name */
  AmountRefunded: 'amountRefunded',
  /** column name */
  ChargeObject: 'chargeObject',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  ExternalChargeId: 'externalChargeId',
  /** column name */
  ExternalInvoiceId: 'externalInvoiceId',
  /** column name */
  Id: 'id',
  /** column name */
  Paid: 'paid',
  /** column name */
  Refunded: 'refunded',
  /** column name */
  Status: 'status',
  /** column name */
  StripeCustomerId: 'stripeCustomerId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Charges_Update_Column = typeof Charges_Update_Column[keyof typeof Charges_Update_Column];
export type Charges_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Charges_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Charges_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Charges_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Charges_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Charges_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Charges_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Charges_Set_Input>;
  /** filter the rows which have to be updated */
  where: Charges_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Charges_Var_Pop_Fields = {
  __typename?: 'charges_var_pop_fields';
  affiliateAmountPaid?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "charges" */
export type Charges_Var_Pop_Order_By = {
  affiliateAmountPaid?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  amountRefunded?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Charges_Var_Samp_Fields = {
  __typename?: 'charges_var_samp_fields';
  affiliateAmountPaid?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "charges" */
export type Charges_Var_Samp_Order_By = {
  affiliateAmountPaid?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  amountRefunded?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Charges_Variance_Fields = {
  __typename?: 'charges_variance_fields';
  affiliateAmountPaid?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  amountRefunded?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "charges" */
export type Charges_Variance_Order_By = {
  affiliateAmountPaid?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  amountRefunded?: InputMaybe<Order_By>;
};

/** columns and relationships of "congress_trades" */
export type Congress_Trades = {
  __typename?: 'congress_trades';
  amountMax: Scalars['numeric'];
  amountMidpoint: Scalars['numeric'];
  amountMin: Scalars['numeric'];
  amountRange: Scalars['String'];
  assetDescription: Scalars['String'];
  assetType?: Maybe<Scalars['String']>;
  capitalGainsOver200USD?: Maybe<Scalars['Boolean']>;
  chamber?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  currentPrice?: Maybe<Scalars['numeric']>;
  dataSource: Scalars['String'];
  daysHeld?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  disclosureDate: Scalars['date'];
  disclosureId: Scalars['String'];
  disclosureUrl: Scalars['String'];
  disclosureYear?: Maybe<Scalars['Int']>;
  district?: Maybe<Scalars['String']>;
  entryPrice?: Maybe<Scalars['numeric']>;
  estimatedShares?: Maybe<Scalars['numeric']>;
  exitPrice?: Maybe<Scalars['numeric']>;
  firstName: Scalars['String'];
  id: Scalars['uuid'];
  lastName: Scalars['String'];
  office?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  profitLoss?: Maybe<Scalars['numeric']>;
  profitLossPercent?: Maybe<Scalars['numeric']>;
  relativePerformance?: Maybe<Scalars['numeric']>;
  sp500LevelAtEntry?: Maybe<Scalars['numeric']>;
  sp500LevelCurrent?: Maybe<Scalars['numeric']>;
  sp500ReturnPercent?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  transactionDate: Scalars['date'];
  transactionType: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "congress_trades" */
export type Congress_Trades_Aggregate = {
  __typename?: 'congress_trades_aggregate';
  aggregate?: Maybe<Congress_Trades_Aggregate_Fields>;
  nodes: Array<Congress_Trades>;
};

/** aggregate fields of "congress_trades" */
export type Congress_Trades_Aggregate_Fields = {
  __typename?: 'congress_trades_aggregate_fields';
  avg?: Maybe<Congress_Trades_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Congress_Trades_Max_Fields>;
  min?: Maybe<Congress_Trades_Min_Fields>;
  stddev?: Maybe<Congress_Trades_Stddev_Fields>;
  stddev_pop?: Maybe<Congress_Trades_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Congress_Trades_Stddev_Samp_Fields>;
  sum?: Maybe<Congress_Trades_Sum_Fields>;
  var_pop?: Maybe<Congress_Trades_Var_Pop_Fields>;
  var_samp?: Maybe<Congress_Trades_Var_Samp_Fields>;
  variance?: Maybe<Congress_Trades_Variance_Fields>;
};


/** aggregate fields of "congress_trades" */
export type Congress_Trades_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Congress_Trades_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Congress_Trades_Avg_Fields = {
  __typename?: 'congress_trades_avg_fields';
  amountMax?: Maybe<Scalars['Float']>;
  amountMidpoint?: Maybe<Scalars['Float']>;
  amountMin?: Maybe<Scalars['Float']>;
  currentPrice?: Maybe<Scalars['Float']>;
  daysHeld?: Maybe<Scalars['Float']>;
  disclosureYear?: Maybe<Scalars['Float']>;
  entryPrice?: Maybe<Scalars['Float']>;
  estimatedShares?: Maybe<Scalars['Float']>;
  exitPrice?: Maybe<Scalars['Float']>;
  profitLoss?: Maybe<Scalars['Float']>;
  profitLossPercent?: Maybe<Scalars['Float']>;
  relativePerformance?: Maybe<Scalars['Float']>;
  sp500LevelAtEntry?: Maybe<Scalars['Float']>;
  sp500LevelCurrent?: Maybe<Scalars['Float']>;
  sp500ReturnPercent?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "congress_trades". All fields are combined with a logical 'AND'. */
export type Congress_Trades_Bool_Exp = {
  _and?: InputMaybe<Array<Congress_Trades_Bool_Exp>>;
  _not?: InputMaybe<Congress_Trades_Bool_Exp>;
  _or?: InputMaybe<Array<Congress_Trades_Bool_Exp>>;
  amountMax?: InputMaybe<Numeric_Comparison_Exp>;
  amountMidpoint?: InputMaybe<Numeric_Comparison_Exp>;
  amountMin?: InputMaybe<Numeric_Comparison_Exp>;
  amountRange?: InputMaybe<String_Comparison_Exp>;
  assetDescription?: InputMaybe<String_Comparison_Exp>;
  assetType?: InputMaybe<String_Comparison_Exp>;
  capitalGainsOver200USD?: InputMaybe<Boolean_Comparison_Exp>;
  chamber?: InputMaybe<String_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentPrice?: InputMaybe<Numeric_Comparison_Exp>;
  dataSource?: InputMaybe<String_Comparison_Exp>;
  daysHeld?: InputMaybe<Int_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  disclosureDate?: InputMaybe<Date_Comparison_Exp>;
  disclosureId?: InputMaybe<String_Comparison_Exp>;
  disclosureUrl?: InputMaybe<String_Comparison_Exp>;
  disclosureYear?: InputMaybe<Int_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  entryPrice?: InputMaybe<Numeric_Comparison_Exp>;
  estimatedShares?: InputMaybe<Numeric_Comparison_Exp>;
  exitPrice?: InputMaybe<Numeric_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  office?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  profitLoss?: InputMaybe<Numeric_Comparison_Exp>;
  profitLossPercent?: InputMaybe<Numeric_Comparison_Exp>;
  relativePerformance?: InputMaybe<Numeric_Comparison_Exp>;
  sp500LevelAtEntry?: InputMaybe<Numeric_Comparison_Exp>;
  sp500LevelCurrent?: InputMaybe<Numeric_Comparison_Exp>;
  sp500ReturnPercent?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  transactionDate?: InputMaybe<Date_Comparison_Exp>;
  transactionType?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "congress_trades" */
export const Congress_Trades_Constraint = {
  /** unique or primary key constraint on columns "id" */
  CongressTradesPkey: 'congress_trades_pkey'
} as const;

export type Congress_Trades_Constraint = typeof Congress_Trades_Constraint[keyof typeof Congress_Trades_Constraint];
/** input type for incrementing numeric columns in table "congress_trades" */
export type Congress_Trades_Inc_Input = {
  amountMax?: InputMaybe<Scalars['numeric']>;
  amountMidpoint?: InputMaybe<Scalars['numeric']>;
  amountMin?: InputMaybe<Scalars['numeric']>;
  currentPrice?: InputMaybe<Scalars['numeric']>;
  daysHeld?: InputMaybe<Scalars['Int']>;
  disclosureYear?: InputMaybe<Scalars['Int']>;
  entryPrice?: InputMaybe<Scalars['numeric']>;
  estimatedShares?: InputMaybe<Scalars['numeric']>;
  exitPrice?: InputMaybe<Scalars['numeric']>;
  profitLoss?: InputMaybe<Scalars['numeric']>;
  profitLossPercent?: InputMaybe<Scalars['numeric']>;
  relativePerformance?: InputMaybe<Scalars['numeric']>;
  sp500LevelAtEntry?: InputMaybe<Scalars['numeric']>;
  sp500LevelCurrent?: InputMaybe<Scalars['numeric']>;
  sp500ReturnPercent?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "congress_trades" */
export type Congress_Trades_Insert_Input = {
  amountMax?: InputMaybe<Scalars['numeric']>;
  amountMidpoint?: InputMaybe<Scalars['numeric']>;
  amountMin?: InputMaybe<Scalars['numeric']>;
  amountRange?: InputMaybe<Scalars['String']>;
  assetDescription?: InputMaybe<Scalars['String']>;
  assetType?: InputMaybe<Scalars['String']>;
  capitalGainsOver200USD?: InputMaybe<Scalars['Boolean']>;
  chamber?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentPrice?: InputMaybe<Scalars['numeric']>;
  dataSource?: InputMaybe<Scalars['String']>;
  daysHeld?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  disclosureDate?: InputMaybe<Scalars['date']>;
  disclosureId?: InputMaybe<Scalars['String']>;
  disclosureUrl?: InputMaybe<Scalars['String']>;
  disclosureYear?: InputMaybe<Scalars['Int']>;
  district?: InputMaybe<Scalars['String']>;
  entryPrice?: InputMaybe<Scalars['numeric']>;
  estimatedShares?: InputMaybe<Scalars['numeric']>;
  exitPrice?: InputMaybe<Scalars['numeric']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  office?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  profitLoss?: InputMaybe<Scalars['numeric']>;
  profitLossPercent?: InputMaybe<Scalars['numeric']>;
  relativePerformance?: InputMaybe<Scalars['numeric']>;
  sp500LevelAtEntry?: InputMaybe<Scalars['numeric']>;
  sp500LevelCurrent?: InputMaybe<Scalars['numeric']>;
  sp500ReturnPercent?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  transactionDate?: InputMaybe<Scalars['date']>;
  transactionType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Congress_Trades_Max_Fields = {
  __typename?: 'congress_trades_max_fields';
  amountMax?: Maybe<Scalars['numeric']>;
  amountMidpoint?: Maybe<Scalars['numeric']>;
  amountMin?: Maybe<Scalars['numeric']>;
  amountRange?: Maybe<Scalars['String']>;
  assetDescription?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  chamber?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentPrice?: Maybe<Scalars['numeric']>;
  dataSource?: Maybe<Scalars['String']>;
  daysHeld?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  disclosureDate?: Maybe<Scalars['date']>;
  disclosureId?: Maybe<Scalars['String']>;
  disclosureUrl?: Maybe<Scalars['String']>;
  disclosureYear?: Maybe<Scalars['Int']>;
  district?: Maybe<Scalars['String']>;
  entryPrice?: Maybe<Scalars['numeric']>;
  estimatedShares?: Maybe<Scalars['numeric']>;
  exitPrice?: Maybe<Scalars['numeric']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  office?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  profitLoss?: Maybe<Scalars['numeric']>;
  profitLossPercent?: Maybe<Scalars['numeric']>;
  relativePerformance?: Maybe<Scalars['numeric']>;
  sp500LevelAtEntry?: Maybe<Scalars['numeric']>;
  sp500LevelCurrent?: Maybe<Scalars['numeric']>;
  sp500ReturnPercent?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['date']>;
  transactionType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Congress_Trades_Min_Fields = {
  __typename?: 'congress_trades_min_fields';
  amountMax?: Maybe<Scalars['numeric']>;
  amountMidpoint?: Maybe<Scalars['numeric']>;
  amountMin?: Maybe<Scalars['numeric']>;
  amountRange?: Maybe<Scalars['String']>;
  assetDescription?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  chamber?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentPrice?: Maybe<Scalars['numeric']>;
  dataSource?: Maybe<Scalars['String']>;
  daysHeld?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  disclosureDate?: Maybe<Scalars['date']>;
  disclosureId?: Maybe<Scalars['String']>;
  disclosureUrl?: Maybe<Scalars['String']>;
  disclosureYear?: Maybe<Scalars['Int']>;
  district?: Maybe<Scalars['String']>;
  entryPrice?: Maybe<Scalars['numeric']>;
  estimatedShares?: Maybe<Scalars['numeric']>;
  exitPrice?: Maybe<Scalars['numeric']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  office?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  profitLoss?: Maybe<Scalars['numeric']>;
  profitLossPercent?: Maybe<Scalars['numeric']>;
  relativePerformance?: Maybe<Scalars['numeric']>;
  sp500LevelAtEntry?: Maybe<Scalars['numeric']>;
  sp500LevelCurrent?: Maybe<Scalars['numeric']>;
  sp500ReturnPercent?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['date']>;
  transactionType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "congress_trades" */
export type Congress_Trades_Mutation_Response = {
  __typename?: 'congress_trades_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Congress_Trades>;
};

/** on_conflict condition type for table "congress_trades" */
export type Congress_Trades_On_Conflict = {
  constraint: Congress_Trades_Constraint;
  update_columns?: Array<Congress_Trades_Update_Column>;
  where?: InputMaybe<Congress_Trades_Bool_Exp>;
};

/** Ordering options when selecting data from "congress_trades". */
export type Congress_Trades_Order_By = {
  amountMax?: InputMaybe<Order_By>;
  amountMidpoint?: InputMaybe<Order_By>;
  amountMin?: InputMaybe<Order_By>;
  amountRange?: InputMaybe<Order_By>;
  assetDescription?: InputMaybe<Order_By>;
  assetType?: InputMaybe<Order_By>;
  capitalGainsOver200USD?: InputMaybe<Order_By>;
  chamber?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentPrice?: InputMaybe<Order_By>;
  dataSource?: InputMaybe<Order_By>;
  daysHeld?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  disclosureDate?: InputMaybe<Order_By>;
  disclosureId?: InputMaybe<Order_By>;
  disclosureUrl?: InputMaybe<Order_By>;
  disclosureYear?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  entryPrice?: InputMaybe<Order_By>;
  estimatedShares?: InputMaybe<Order_By>;
  exitPrice?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  office?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  profitLoss?: InputMaybe<Order_By>;
  profitLossPercent?: InputMaybe<Order_By>;
  relativePerformance?: InputMaybe<Order_By>;
  sp500LevelAtEntry?: InputMaybe<Order_By>;
  sp500LevelCurrent?: InputMaybe<Order_By>;
  sp500ReturnPercent?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  transactionDate?: InputMaybe<Order_By>;
  transactionType?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: congress_trades */
export type Congress_Trades_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "congress_trades" */
export const Congress_Trades_Select_Column = {
  /** column name */
  AmountMax: 'amountMax',
  /** column name */
  AmountMidpoint: 'amountMidpoint',
  /** column name */
  AmountMin: 'amountMin',
  /** column name */
  AmountRange: 'amountRange',
  /** column name */
  AssetDescription: 'assetDescription',
  /** column name */
  AssetType: 'assetType',
  /** column name */
  CapitalGainsOver200Usd: 'capitalGainsOver200USD',
  /** column name */
  Chamber: 'chamber',
  /** column name */
  Comment: 'comment',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentPrice: 'currentPrice',
  /** column name */
  DataSource: 'dataSource',
  /** column name */
  DaysHeld: 'daysHeld',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  DisclosureDate: 'disclosureDate',
  /** column name */
  DisclosureId: 'disclosureId',
  /** column name */
  DisclosureUrl: 'disclosureUrl',
  /** column name */
  DisclosureYear: 'disclosureYear',
  /** column name */
  District: 'district',
  /** column name */
  EntryPrice: 'entryPrice',
  /** column name */
  EstimatedShares: 'estimatedShares',
  /** column name */
  ExitPrice: 'exitPrice',
  /** column name */
  FirstName: 'firstName',
  /** column name */
  Id: 'id',
  /** column name */
  LastName: 'lastName',
  /** column name */
  Office: 'office',
  /** column name */
  Owner: 'owner',
  /** column name */
  ProfitLoss: 'profitLoss',
  /** column name */
  ProfitLossPercent: 'profitLossPercent',
  /** column name */
  RelativePerformance: 'relativePerformance',
  /** column name */
  Sp500LevelAtEntry: 'sp500LevelAtEntry',
  /** column name */
  Sp500LevelCurrent: 'sp500LevelCurrent',
  /** column name */
  Sp500ReturnPercent: 'sp500ReturnPercent',
  /** column name */
  Status: 'status',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TransactionDate: 'transactionDate',
  /** column name */
  TransactionType: 'transactionType',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Congress_Trades_Select_Column = typeof Congress_Trades_Select_Column[keyof typeof Congress_Trades_Select_Column];
/** input type for updating data in table "congress_trades" */
export type Congress_Trades_Set_Input = {
  amountMax?: InputMaybe<Scalars['numeric']>;
  amountMidpoint?: InputMaybe<Scalars['numeric']>;
  amountMin?: InputMaybe<Scalars['numeric']>;
  amountRange?: InputMaybe<Scalars['String']>;
  assetDescription?: InputMaybe<Scalars['String']>;
  assetType?: InputMaybe<Scalars['String']>;
  capitalGainsOver200USD?: InputMaybe<Scalars['Boolean']>;
  chamber?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentPrice?: InputMaybe<Scalars['numeric']>;
  dataSource?: InputMaybe<Scalars['String']>;
  daysHeld?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  disclosureDate?: InputMaybe<Scalars['date']>;
  disclosureId?: InputMaybe<Scalars['String']>;
  disclosureUrl?: InputMaybe<Scalars['String']>;
  disclosureYear?: InputMaybe<Scalars['Int']>;
  district?: InputMaybe<Scalars['String']>;
  entryPrice?: InputMaybe<Scalars['numeric']>;
  estimatedShares?: InputMaybe<Scalars['numeric']>;
  exitPrice?: InputMaybe<Scalars['numeric']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  office?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  profitLoss?: InputMaybe<Scalars['numeric']>;
  profitLossPercent?: InputMaybe<Scalars['numeric']>;
  relativePerformance?: InputMaybe<Scalars['numeric']>;
  sp500LevelAtEntry?: InputMaybe<Scalars['numeric']>;
  sp500LevelCurrent?: InputMaybe<Scalars['numeric']>;
  sp500ReturnPercent?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  transactionDate?: InputMaybe<Scalars['date']>;
  transactionType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Congress_Trades_Stddev_Fields = {
  __typename?: 'congress_trades_stddev_fields';
  amountMax?: Maybe<Scalars['Float']>;
  amountMidpoint?: Maybe<Scalars['Float']>;
  amountMin?: Maybe<Scalars['Float']>;
  currentPrice?: Maybe<Scalars['Float']>;
  daysHeld?: Maybe<Scalars['Float']>;
  disclosureYear?: Maybe<Scalars['Float']>;
  entryPrice?: Maybe<Scalars['Float']>;
  estimatedShares?: Maybe<Scalars['Float']>;
  exitPrice?: Maybe<Scalars['Float']>;
  profitLoss?: Maybe<Scalars['Float']>;
  profitLossPercent?: Maybe<Scalars['Float']>;
  relativePerformance?: Maybe<Scalars['Float']>;
  sp500LevelAtEntry?: Maybe<Scalars['Float']>;
  sp500LevelCurrent?: Maybe<Scalars['Float']>;
  sp500ReturnPercent?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Congress_Trades_Stddev_Pop_Fields = {
  __typename?: 'congress_trades_stddev_pop_fields';
  amountMax?: Maybe<Scalars['Float']>;
  amountMidpoint?: Maybe<Scalars['Float']>;
  amountMin?: Maybe<Scalars['Float']>;
  currentPrice?: Maybe<Scalars['Float']>;
  daysHeld?: Maybe<Scalars['Float']>;
  disclosureYear?: Maybe<Scalars['Float']>;
  entryPrice?: Maybe<Scalars['Float']>;
  estimatedShares?: Maybe<Scalars['Float']>;
  exitPrice?: Maybe<Scalars['Float']>;
  profitLoss?: Maybe<Scalars['Float']>;
  profitLossPercent?: Maybe<Scalars['Float']>;
  relativePerformance?: Maybe<Scalars['Float']>;
  sp500LevelAtEntry?: Maybe<Scalars['Float']>;
  sp500LevelCurrent?: Maybe<Scalars['Float']>;
  sp500ReturnPercent?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Congress_Trades_Stddev_Samp_Fields = {
  __typename?: 'congress_trades_stddev_samp_fields';
  amountMax?: Maybe<Scalars['Float']>;
  amountMidpoint?: Maybe<Scalars['Float']>;
  amountMin?: Maybe<Scalars['Float']>;
  currentPrice?: Maybe<Scalars['Float']>;
  daysHeld?: Maybe<Scalars['Float']>;
  disclosureYear?: Maybe<Scalars['Float']>;
  entryPrice?: Maybe<Scalars['Float']>;
  estimatedShares?: Maybe<Scalars['Float']>;
  exitPrice?: Maybe<Scalars['Float']>;
  profitLoss?: Maybe<Scalars['Float']>;
  profitLossPercent?: Maybe<Scalars['Float']>;
  relativePerformance?: Maybe<Scalars['Float']>;
  sp500LevelAtEntry?: Maybe<Scalars['Float']>;
  sp500LevelCurrent?: Maybe<Scalars['Float']>;
  sp500ReturnPercent?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "congress_trades" */
export type Congress_Trades_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Congress_Trades_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Congress_Trades_Stream_Cursor_Value_Input = {
  amountMax?: InputMaybe<Scalars['numeric']>;
  amountMidpoint?: InputMaybe<Scalars['numeric']>;
  amountMin?: InputMaybe<Scalars['numeric']>;
  amountRange?: InputMaybe<Scalars['String']>;
  assetDescription?: InputMaybe<Scalars['String']>;
  assetType?: InputMaybe<Scalars['String']>;
  capitalGainsOver200USD?: InputMaybe<Scalars['Boolean']>;
  chamber?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentPrice?: InputMaybe<Scalars['numeric']>;
  dataSource?: InputMaybe<Scalars['String']>;
  daysHeld?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  disclosureDate?: InputMaybe<Scalars['date']>;
  disclosureId?: InputMaybe<Scalars['String']>;
  disclosureUrl?: InputMaybe<Scalars['String']>;
  disclosureYear?: InputMaybe<Scalars['Int']>;
  district?: InputMaybe<Scalars['String']>;
  entryPrice?: InputMaybe<Scalars['numeric']>;
  estimatedShares?: InputMaybe<Scalars['numeric']>;
  exitPrice?: InputMaybe<Scalars['numeric']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  office?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  profitLoss?: InputMaybe<Scalars['numeric']>;
  profitLossPercent?: InputMaybe<Scalars['numeric']>;
  relativePerformance?: InputMaybe<Scalars['numeric']>;
  sp500LevelAtEntry?: InputMaybe<Scalars['numeric']>;
  sp500LevelCurrent?: InputMaybe<Scalars['numeric']>;
  sp500ReturnPercent?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  transactionDate?: InputMaybe<Scalars['date']>;
  transactionType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Congress_Trades_Sum_Fields = {
  __typename?: 'congress_trades_sum_fields';
  amountMax?: Maybe<Scalars['numeric']>;
  amountMidpoint?: Maybe<Scalars['numeric']>;
  amountMin?: Maybe<Scalars['numeric']>;
  currentPrice?: Maybe<Scalars['numeric']>;
  daysHeld?: Maybe<Scalars['Int']>;
  disclosureYear?: Maybe<Scalars['Int']>;
  entryPrice?: Maybe<Scalars['numeric']>;
  estimatedShares?: Maybe<Scalars['numeric']>;
  exitPrice?: Maybe<Scalars['numeric']>;
  profitLoss?: Maybe<Scalars['numeric']>;
  profitLossPercent?: Maybe<Scalars['numeric']>;
  relativePerformance?: Maybe<Scalars['numeric']>;
  sp500LevelAtEntry?: Maybe<Scalars['numeric']>;
  sp500LevelCurrent?: Maybe<Scalars['numeric']>;
  sp500ReturnPercent?: Maybe<Scalars['numeric']>;
};

/** update columns of table "congress_trades" */
export const Congress_Trades_Update_Column = {
  /** column name */
  AmountMax: 'amountMax',
  /** column name */
  AmountMidpoint: 'amountMidpoint',
  /** column name */
  AmountMin: 'amountMin',
  /** column name */
  AmountRange: 'amountRange',
  /** column name */
  AssetDescription: 'assetDescription',
  /** column name */
  AssetType: 'assetType',
  /** column name */
  CapitalGainsOver200Usd: 'capitalGainsOver200USD',
  /** column name */
  Chamber: 'chamber',
  /** column name */
  Comment: 'comment',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentPrice: 'currentPrice',
  /** column name */
  DataSource: 'dataSource',
  /** column name */
  DaysHeld: 'daysHeld',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  DisclosureDate: 'disclosureDate',
  /** column name */
  DisclosureId: 'disclosureId',
  /** column name */
  DisclosureUrl: 'disclosureUrl',
  /** column name */
  DisclosureYear: 'disclosureYear',
  /** column name */
  District: 'district',
  /** column name */
  EntryPrice: 'entryPrice',
  /** column name */
  EstimatedShares: 'estimatedShares',
  /** column name */
  ExitPrice: 'exitPrice',
  /** column name */
  FirstName: 'firstName',
  /** column name */
  Id: 'id',
  /** column name */
  LastName: 'lastName',
  /** column name */
  Office: 'office',
  /** column name */
  Owner: 'owner',
  /** column name */
  ProfitLoss: 'profitLoss',
  /** column name */
  ProfitLossPercent: 'profitLossPercent',
  /** column name */
  RelativePerformance: 'relativePerformance',
  /** column name */
  Sp500LevelAtEntry: 'sp500LevelAtEntry',
  /** column name */
  Sp500LevelCurrent: 'sp500LevelCurrent',
  /** column name */
  Sp500ReturnPercent: 'sp500ReturnPercent',
  /** column name */
  Status: 'status',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TransactionDate: 'transactionDate',
  /** column name */
  TransactionType: 'transactionType',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Congress_Trades_Update_Column = typeof Congress_Trades_Update_Column[keyof typeof Congress_Trades_Update_Column];
export type Congress_Trades_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Congress_Trades_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Congress_Trades_Set_Input>;
  /** filter the rows which have to be updated */
  where: Congress_Trades_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Congress_Trades_Var_Pop_Fields = {
  __typename?: 'congress_trades_var_pop_fields';
  amountMax?: Maybe<Scalars['Float']>;
  amountMidpoint?: Maybe<Scalars['Float']>;
  amountMin?: Maybe<Scalars['Float']>;
  currentPrice?: Maybe<Scalars['Float']>;
  daysHeld?: Maybe<Scalars['Float']>;
  disclosureYear?: Maybe<Scalars['Float']>;
  entryPrice?: Maybe<Scalars['Float']>;
  estimatedShares?: Maybe<Scalars['Float']>;
  exitPrice?: Maybe<Scalars['Float']>;
  profitLoss?: Maybe<Scalars['Float']>;
  profitLossPercent?: Maybe<Scalars['Float']>;
  relativePerformance?: Maybe<Scalars['Float']>;
  sp500LevelAtEntry?: Maybe<Scalars['Float']>;
  sp500LevelCurrent?: Maybe<Scalars['Float']>;
  sp500ReturnPercent?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Congress_Trades_Var_Samp_Fields = {
  __typename?: 'congress_trades_var_samp_fields';
  amountMax?: Maybe<Scalars['Float']>;
  amountMidpoint?: Maybe<Scalars['Float']>;
  amountMin?: Maybe<Scalars['Float']>;
  currentPrice?: Maybe<Scalars['Float']>;
  daysHeld?: Maybe<Scalars['Float']>;
  disclosureYear?: Maybe<Scalars['Float']>;
  entryPrice?: Maybe<Scalars['Float']>;
  estimatedShares?: Maybe<Scalars['Float']>;
  exitPrice?: Maybe<Scalars['Float']>;
  profitLoss?: Maybe<Scalars['Float']>;
  profitLossPercent?: Maybe<Scalars['Float']>;
  relativePerformance?: Maybe<Scalars['Float']>;
  sp500LevelAtEntry?: Maybe<Scalars['Float']>;
  sp500LevelCurrent?: Maybe<Scalars['Float']>;
  sp500ReturnPercent?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Congress_Trades_Variance_Fields = {
  __typename?: 'congress_trades_variance_fields';
  amountMax?: Maybe<Scalars['Float']>;
  amountMidpoint?: Maybe<Scalars['Float']>;
  amountMin?: Maybe<Scalars['Float']>;
  currentPrice?: Maybe<Scalars['Float']>;
  daysHeld?: Maybe<Scalars['Float']>;
  disclosureYear?: Maybe<Scalars['Float']>;
  entryPrice?: Maybe<Scalars['Float']>;
  estimatedShares?: Maybe<Scalars['Float']>;
  exitPrice?: Maybe<Scalars['Float']>;
  profitLoss?: Maybe<Scalars['Float']>;
  profitLossPercent?: Maybe<Scalars['Float']>;
  relativePerformance?: Maybe<Scalars['Float']>;
  sp500LevelAtEntry?: Maybe<Scalars['Float']>;
  sp500LevelCurrent?: Maybe<Scalars['Float']>;
  sp500ReturnPercent?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cookie_strings" */
export type Cookie_Strings = {
  __typename?: 'cookie_strings';
  cookie: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "cookie_strings" */
export type Cookie_Strings_Aggregate = {
  __typename?: 'cookie_strings_aggregate';
  aggregate?: Maybe<Cookie_Strings_Aggregate_Fields>;
  nodes: Array<Cookie_Strings>;
};

/** aggregate fields of "cookie_strings" */
export type Cookie_Strings_Aggregate_Fields = {
  __typename?: 'cookie_strings_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Cookie_Strings_Max_Fields>;
  min?: Maybe<Cookie_Strings_Min_Fields>;
};


/** aggregate fields of "cookie_strings" */
export type Cookie_Strings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cookie_Strings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cookie_strings". All fields are combined with a logical 'AND'. */
export type Cookie_Strings_Bool_Exp = {
  _and?: InputMaybe<Array<Cookie_Strings_Bool_Exp>>;
  _not?: InputMaybe<Cookie_Strings_Bool_Exp>;
  _or?: InputMaybe<Array<Cookie_Strings_Bool_Exp>>;
  cookie?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cookie_strings" */
export const Cookie_Strings_Constraint = {
  /** unique or primary key constraint on columns "id" */
  CookieStringsPkey: 'cookie_strings_pkey'
} as const;

export type Cookie_Strings_Constraint = typeof Cookie_Strings_Constraint[keyof typeof Cookie_Strings_Constraint];
/** input type for inserting data into table "cookie_strings" */
export type Cookie_Strings_Insert_Input = {
  cookie?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Cookie_Strings_Max_Fields = {
  __typename?: 'cookie_strings_max_fields';
  cookie?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Cookie_Strings_Min_Fields = {
  __typename?: 'cookie_strings_min_fields';
  cookie?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "cookie_strings" */
export type Cookie_Strings_Mutation_Response = {
  __typename?: 'cookie_strings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cookie_Strings>;
};

/** on_conflict condition type for table "cookie_strings" */
export type Cookie_Strings_On_Conflict = {
  constraint: Cookie_Strings_Constraint;
  update_columns?: Array<Cookie_Strings_Update_Column>;
  where?: InputMaybe<Cookie_Strings_Bool_Exp>;
};

/** Ordering options when selecting data from "cookie_strings". */
export type Cookie_Strings_Order_By = {
  cookie?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cookie_strings */
export type Cookie_Strings_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "cookie_strings" */
export const Cookie_Strings_Select_Column = {
  /** column name */
  Cookie: 'cookie',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Cookie_Strings_Select_Column = typeof Cookie_Strings_Select_Column[keyof typeof Cookie_Strings_Select_Column];
/** input type for updating data in table "cookie_strings" */
export type Cookie_Strings_Set_Input = {
  cookie?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "cookie_strings" */
export type Cookie_Strings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cookie_Strings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cookie_Strings_Stream_Cursor_Value_Input = {
  cookie?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "cookie_strings" */
export const Cookie_Strings_Update_Column = {
  /** column name */
  Cookie: 'cookie',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Cookie_Strings_Update_Column = typeof Cookie_Strings_Update_Column[keyof typeof Cookie_Strings_Update_Column];
export type Cookie_Strings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cookie_Strings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cookie_Strings_Bool_Exp;
};

/** columns and relationships of "course_progress" */
export type Course_Progress = {
  __typename?: 'course_progress';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  lesson_id: Scalars['String'];
  masterclass_id: Scalars['String'];
  section_id: Scalars['String'];
  status: Course_Progress_Status_Enum;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['String'];
};

/** aggregated selection of "course_progress" */
export type Course_Progress_Aggregate = {
  __typename?: 'course_progress_aggregate';
  aggregate?: Maybe<Course_Progress_Aggregate_Fields>;
  nodes: Array<Course_Progress>;
};

export type Course_Progress_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Progress_Aggregate_Bool_Exp_Count>;
};

export type Course_Progress_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Progress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Progress_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_progress" */
export type Course_Progress_Aggregate_Fields = {
  __typename?: 'course_progress_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Progress_Max_Fields>;
  min?: Maybe<Course_Progress_Min_Fields>;
};


/** aggregate fields of "course_progress" */
export type Course_Progress_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Progress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_progress" */
export type Course_Progress_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Progress_Max_Order_By>;
  min?: InputMaybe<Course_Progress_Min_Order_By>;
};

/** input type for inserting array relation for remote table "course_progress" */
export type Course_Progress_Arr_Rel_Insert_Input = {
  data: Array<Course_Progress_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Progress_On_Conflict>;
};

/** Boolean expression to filter rows from the table "course_progress". All fields are combined with a logical 'AND'. */
export type Course_Progress_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Progress_Bool_Exp>>;
  _not?: InputMaybe<Course_Progress_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Progress_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lesson_id?: InputMaybe<String_Comparison_Exp>;
  masterclass_id?: InputMaybe<String_Comparison_Exp>;
  section_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Course_Progress_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_progress" */
export const Course_Progress_Constraint = {
  /** unique or primary key constraint on columns "id" */
  CourseProgressPkey: 'course_progress_pkey',
  /** unique or primary key constraint on columns "user_id", "lesson_id" */
  CourseProgressUserIdLessonIdKey: 'course_progress_user_id_lesson_id_key'
} as const;

export type Course_Progress_Constraint = typeof Course_Progress_Constraint[keyof typeof Course_Progress_Constraint];
/** input type for inserting data into table "course_progress" */
export type Course_Progress_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson_id?: InputMaybe<Scalars['String']>;
  masterclass_id?: InputMaybe<Scalars['String']>;
  section_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Course_Progress_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Progress_Max_Fields = {
  __typename?: 'course_progress_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lesson_id?: Maybe<Scalars['String']>;
  masterclass_id?: Maybe<Scalars['String']>;
  section_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "course_progress" */
export type Course_Progress_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_id?: InputMaybe<Order_By>;
  masterclass_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Progress_Min_Fields = {
  __typename?: 'course_progress_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lesson_id?: Maybe<Scalars['String']>;
  masterclass_id?: Maybe<Scalars['String']>;
  section_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "course_progress" */
export type Course_Progress_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_id?: InputMaybe<Order_By>;
  masterclass_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_progress" */
export type Course_Progress_Mutation_Response = {
  __typename?: 'course_progress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Progress>;
};

/** on_conflict condition type for table "course_progress" */
export type Course_Progress_On_Conflict = {
  constraint: Course_Progress_Constraint;
  update_columns?: Array<Course_Progress_Update_Column>;
  where?: InputMaybe<Course_Progress_Bool_Exp>;
};

/** Ordering options when selecting data from "course_progress". */
export type Course_Progress_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lesson_id?: InputMaybe<Order_By>;
  masterclass_id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_progress */
export type Course_Progress_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_progress" */
export const Course_Progress_Select_Column = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Id: 'id',
  /** column name */
  LessonId: 'lesson_id',
  /** column name */
  MasterclassId: 'masterclass_id',
  /** column name */
  SectionId: 'section_id',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UserId: 'user_id'
} as const;

export type Course_Progress_Select_Column = typeof Course_Progress_Select_Column[keyof typeof Course_Progress_Select_Column];
/** input type for updating data in table "course_progress" */
export type Course_Progress_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson_id?: InputMaybe<Scalars['String']>;
  masterclass_id?: InputMaybe<Scalars['String']>;
  section_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Course_Progress_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "course_progress_status" */
export type Course_Progress_Status = {
  __typename?: 'course_progress_status';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "course_progress_status" */
export type Course_Progress_Status_Aggregate = {
  __typename?: 'course_progress_status_aggregate';
  aggregate?: Maybe<Course_Progress_Status_Aggregate_Fields>;
  nodes: Array<Course_Progress_Status>;
};

/** aggregate fields of "course_progress_status" */
export type Course_Progress_Status_Aggregate_Fields = {
  __typename?: 'course_progress_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Progress_Status_Max_Fields>;
  min?: Maybe<Course_Progress_Status_Min_Fields>;
};


/** aggregate fields of "course_progress_status" */
export type Course_Progress_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Progress_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_progress_status". All fields are combined with a logical 'AND'. */
export type Course_Progress_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Progress_Status_Bool_Exp>>;
  _not?: InputMaybe<Course_Progress_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Progress_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_progress_status" */
export const Course_Progress_Status_Constraint = {
  /** unique or primary key constraint on columns "value" */
  CourseProgressStatusPkey: 'course_progress_status_pkey'
} as const;

export type Course_Progress_Status_Constraint = typeof Course_Progress_Status_Constraint[keyof typeof Course_Progress_Status_Constraint];
export const Course_Progress_Status_Enum = {
  Complete: 'COMPLETE',
  InProgress: 'IN_PROGRESS',
  NeedsReview: 'NEEDS_REVIEW',
  NotStarted: 'NOT_STARTED'
} as const;

export type Course_Progress_Status_Enum = typeof Course_Progress_Status_Enum[keyof typeof Course_Progress_Status_Enum];
/** Boolean expression to compare columns of type "course_progress_status_enum". All fields are combined with logical 'AND'. */
export type Course_Progress_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Progress_Status_Enum>;
  _in?: InputMaybe<Array<Course_Progress_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Progress_Status_Enum>;
  _nin?: InputMaybe<Array<Course_Progress_Status_Enum>>;
};

/** input type for inserting data into table "course_progress_status" */
export type Course_Progress_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Progress_Status_Max_Fields = {
  __typename?: 'course_progress_status_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Progress_Status_Min_Fields = {
  __typename?: 'course_progress_status_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_progress_status" */
export type Course_Progress_Status_Mutation_Response = {
  __typename?: 'course_progress_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Progress_Status>;
};

/** on_conflict condition type for table "course_progress_status" */
export type Course_Progress_Status_On_Conflict = {
  constraint: Course_Progress_Status_Constraint;
  update_columns?: Array<Course_Progress_Status_Update_Column>;
  where?: InputMaybe<Course_Progress_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "course_progress_status". */
export type Course_Progress_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_progress_status */
export type Course_Progress_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "course_progress_status" */
export const Course_Progress_Status_Select_Column = {
  /** column name */
  Description: 'description',
  /** column name */
  Value: 'value'
} as const;

export type Course_Progress_Status_Select_Column = typeof Course_Progress_Status_Select_Column[keyof typeof Course_Progress_Status_Select_Column];
/** input type for updating data in table "course_progress_status" */
export type Course_Progress_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_progress_status" */
export type Course_Progress_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Progress_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Progress_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_progress_status" */
export const Course_Progress_Status_Update_Column = {
  /** column name */
  Description: 'description',
  /** column name */
  Value: 'value'
} as const;

export type Course_Progress_Status_Update_Column = typeof Course_Progress_Status_Update_Column[keyof typeof Course_Progress_Status_Update_Column];
export type Course_Progress_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Progress_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Progress_Status_Bool_Exp;
};

/** Streaming cursor of the table "course_progress" */
export type Course_Progress_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Progress_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Progress_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lesson_id?: InputMaybe<Scalars['String']>;
  masterclass_id?: InputMaybe<Scalars['String']>;
  section_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Course_Progress_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_progress" */
export const Course_Progress_Update_Column = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  DeletedAt: 'deleted_at',
  /** column name */
  Id: 'id',
  /** column name */
  LessonId: 'lesson_id',
  /** column name */
  MasterclassId: 'masterclass_id',
  /** column name */
  SectionId: 'section_id',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updated_at',
  /** column name */
  UserId: 'user_id'
} as const;

export type Course_Progress_Update_Column = typeof Course_Progress_Update_Column[keyof typeof Course_Progress_Update_Column];
export type Course_Progress_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Progress_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Progress_Bool_Exp;
};

/** ordering argument of a cursor */
export const Cursor_Ordering = {
  /** ascending ordering of the cursor */
  Asc: 'ASC',
  /** descending ordering of the cursor */
  Desc: 'DESC'
} as const;

export type Cursor_Ordering = typeof Cursor_Ordering[keyof typeof Cursor_Ordering];
/** columns and relationships of "daily_averages_exclude_today" */
export type Daily_Averages_Exclude_Today = {
  __typename?: 'daily_averages_exclude_today';
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['bigint']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['bigint']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['bigint']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['bigint']>;
  weeklyTotalTrades?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "daily_averages_exclude_today" */
export type Daily_Averages_Exclude_Today_Aggregate = {
  __typename?: 'daily_averages_exclude_today_aggregate';
  aggregate?: Maybe<Daily_Averages_Exclude_Today_Aggregate_Fields>;
  nodes: Array<Daily_Averages_Exclude_Today>;
};

/** aggregate fields of "daily_averages_exclude_today" */
export type Daily_Averages_Exclude_Today_Aggregate_Fields = {
  __typename?: 'daily_averages_exclude_today_aggregate_fields';
  avg?: Maybe<Daily_Averages_Exclude_Today_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Daily_Averages_Exclude_Today_Max_Fields>;
  min?: Maybe<Daily_Averages_Exclude_Today_Min_Fields>;
  stddev?: Maybe<Daily_Averages_Exclude_Today_Stddev_Fields>;
  stddev_pop?: Maybe<Daily_Averages_Exclude_Today_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Daily_Averages_Exclude_Today_Stddev_Samp_Fields>;
  sum?: Maybe<Daily_Averages_Exclude_Today_Sum_Fields>;
  var_pop?: Maybe<Daily_Averages_Exclude_Today_Var_Pop_Fields>;
  var_samp?: Maybe<Daily_Averages_Exclude_Today_Var_Samp_Fields>;
  variance?: Maybe<Daily_Averages_Exclude_Today_Variance_Fields>;
};


/** aggregate fields of "daily_averages_exclude_today" */
export type Daily_Averages_Exclude_Today_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Daily_Averages_Exclude_Today_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Daily_Averages_Exclude_Today_Avg_Fields = {
  __typename?: 'daily_averages_exclude_today_avg_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "daily_averages_exclude_today". All fields are combined with a logical 'AND'. */
export type Daily_Averages_Exclude_Today_Bool_Exp = {
  _and?: InputMaybe<Array<Daily_Averages_Exclude_Today_Bool_Exp>>;
  _not?: InputMaybe<Daily_Averages_Exclude_Today_Bool_Exp>;
  _or?: InputMaybe<Array<Daily_Averages_Exclude_Today_Bool_Exp>>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Bigint_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Bigint_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Bigint_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Bigint_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Daily_Averages_Exclude_Today_Max_Fields = {
  __typename?: 'daily_averages_exclude_today_max_fields';
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['bigint']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['bigint']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['bigint']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['bigint']>;
  weeklyTotalTrades?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Daily_Averages_Exclude_Today_Min_Fields = {
  __typename?: 'daily_averages_exclude_today_min_fields';
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['bigint']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['bigint']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['bigint']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['bigint']>;
  weeklyTotalTrades?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "daily_averages_exclude_today". */
export type Daily_Averages_Exclude_Today_Order_By = {
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
};

/** select columns of table "daily_averages_exclude_today" */
export const Daily_Averages_Exclude_Today_Select_Column = {
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades'
} as const;

export type Daily_Averages_Exclude_Today_Select_Column = typeof Daily_Averages_Exclude_Today_Select_Column[keyof typeof Daily_Averages_Exclude_Today_Select_Column];
/** aggregate stddev on columns */
export type Daily_Averages_Exclude_Today_Stddev_Fields = {
  __typename?: 'daily_averages_exclude_today_stddev_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Daily_Averages_Exclude_Today_Stddev_Pop_Fields = {
  __typename?: 'daily_averages_exclude_today_stddev_pop_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Daily_Averages_Exclude_Today_Stddev_Samp_Fields = {
  __typename?: 'daily_averages_exclude_today_stddev_samp_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "daily_averages_exclude_today" */
export type Daily_Averages_Exclude_Today_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Daily_Averages_Exclude_Today_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Daily_Averages_Exclude_Today_Stream_Cursor_Value_Input = {
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['bigint']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['bigint']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['bigint']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['bigint']>;
  weeklyTotalTrades?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Daily_Averages_Exclude_Today_Sum_Fields = {
  __typename?: 'daily_averages_exclude_today_sum_fields';
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['bigint']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['bigint']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['bigint']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['bigint']>;
  weeklyTotalTrades?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Daily_Averages_Exclude_Today_Var_Pop_Fields = {
  __typename?: 'daily_averages_exclude_today_var_pop_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Daily_Averages_Exclude_Today_Var_Samp_Fields = {
  __typename?: 'daily_averages_exclude_today_var_samp_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Daily_Averages_Exclude_Today_Variance_Fields = {
  __typename?: 'daily_averages_exclude_today_variance_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "daily_averages_include_today" */
export type Daily_Averages_Include_Today = {
  __typename?: 'daily_averages_include_today';
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['bigint']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['bigint']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['bigint']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['bigint']>;
  weeklyTotalTrades?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "daily_averages_include_today" */
export type Daily_Averages_Include_Today_Aggregate = {
  __typename?: 'daily_averages_include_today_aggregate';
  aggregate?: Maybe<Daily_Averages_Include_Today_Aggregate_Fields>;
  nodes: Array<Daily_Averages_Include_Today>;
};

/** aggregate fields of "daily_averages_include_today" */
export type Daily_Averages_Include_Today_Aggregate_Fields = {
  __typename?: 'daily_averages_include_today_aggregate_fields';
  avg?: Maybe<Daily_Averages_Include_Today_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Daily_Averages_Include_Today_Max_Fields>;
  min?: Maybe<Daily_Averages_Include_Today_Min_Fields>;
  stddev?: Maybe<Daily_Averages_Include_Today_Stddev_Fields>;
  stddev_pop?: Maybe<Daily_Averages_Include_Today_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Daily_Averages_Include_Today_Stddev_Samp_Fields>;
  sum?: Maybe<Daily_Averages_Include_Today_Sum_Fields>;
  var_pop?: Maybe<Daily_Averages_Include_Today_Var_Pop_Fields>;
  var_samp?: Maybe<Daily_Averages_Include_Today_Var_Samp_Fields>;
  variance?: Maybe<Daily_Averages_Include_Today_Variance_Fields>;
};


/** aggregate fields of "daily_averages_include_today" */
export type Daily_Averages_Include_Today_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Daily_Averages_Include_Today_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Daily_Averages_Include_Today_Avg_Fields = {
  __typename?: 'daily_averages_include_today_avg_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "daily_averages_include_today". All fields are combined with a logical 'AND'. */
export type Daily_Averages_Include_Today_Bool_Exp = {
  _and?: InputMaybe<Array<Daily_Averages_Include_Today_Bool_Exp>>;
  _not?: InputMaybe<Daily_Averages_Include_Today_Bool_Exp>;
  _or?: InputMaybe<Array<Daily_Averages_Include_Today_Bool_Exp>>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Bigint_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Bigint_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Bigint_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Bigint_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Daily_Averages_Include_Today_Max_Fields = {
  __typename?: 'daily_averages_include_today_max_fields';
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['bigint']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['bigint']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['bigint']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['bigint']>;
  weeklyTotalTrades?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Daily_Averages_Include_Today_Min_Fields = {
  __typename?: 'daily_averages_include_today_min_fields';
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['bigint']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['bigint']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['bigint']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['bigint']>;
  weeklyTotalTrades?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "daily_averages_include_today". */
export type Daily_Averages_Include_Today_Order_By = {
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
};

/** select columns of table "daily_averages_include_today" */
export const Daily_Averages_Include_Today_Select_Column = {
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades'
} as const;

export type Daily_Averages_Include_Today_Select_Column = typeof Daily_Averages_Include_Today_Select_Column[keyof typeof Daily_Averages_Include_Today_Select_Column];
/** aggregate stddev on columns */
export type Daily_Averages_Include_Today_Stddev_Fields = {
  __typename?: 'daily_averages_include_today_stddev_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Daily_Averages_Include_Today_Stddev_Pop_Fields = {
  __typename?: 'daily_averages_include_today_stddev_pop_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Daily_Averages_Include_Today_Stddev_Samp_Fields = {
  __typename?: 'daily_averages_include_today_stddev_samp_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "daily_averages_include_today" */
export type Daily_Averages_Include_Today_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Daily_Averages_Include_Today_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Daily_Averages_Include_Today_Stream_Cursor_Value_Input = {
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['bigint']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['bigint']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['bigint']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['bigint']>;
  weeklyTotalTrades?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Daily_Averages_Include_Today_Sum_Fields = {
  __typename?: 'daily_averages_include_today_sum_fields';
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['bigint']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['bigint']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['bigint']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['bigint']>;
  weeklyTotalTrades?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Daily_Averages_Include_Today_Var_Pop_Fields = {
  __typename?: 'daily_averages_include_today_var_pop_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Daily_Averages_Include_Today_Var_Samp_Fields = {
  __typename?: 'daily_averages_include_today_var_samp_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Daily_Averages_Include_Today_Variance_Fields = {
  __typename?: 'daily_averages_include_today_variance_fields';
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "daily_volume" */
export type Daily_Volume = {
  __typename?: 'daily_volume';
  ticker?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "daily_volume" */
export type Daily_Volume_Aggregate = {
  __typename?: 'daily_volume_aggregate';
  aggregate?: Maybe<Daily_Volume_Aggregate_Fields>;
  nodes: Array<Daily_Volume>;
};

/** aggregate fields of "daily_volume" */
export type Daily_Volume_Aggregate_Fields = {
  __typename?: 'daily_volume_aggregate_fields';
  avg?: Maybe<Daily_Volume_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Daily_Volume_Max_Fields>;
  min?: Maybe<Daily_Volume_Min_Fields>;
  stddev?: Maybe<Daily_Volume_Stddev_Fields>;
  stddev_pop?: Maybe<Daily_Volume_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Daily_Volume_Stddev_Samp_Fields>;
  sum?: Maybe<Daily_Volume_Sum_Fields>;
  var_pop?: Maybe<Daily_Volume_Var_Pop_Fields>;
  var_samp?: Maybe<Daily_Volume_Var_Samp_Fields>;
  variance?: Maybe<Daily_Volume_Variance_Fields>;
};


/** aggregate fields of "daily_volume" */
export type Daily_Volume_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Daily_Volume_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Daily_Volume_Avg_Fields = {
  __typename?: 'daily_volume_avg_fields';
  volume?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "daily_volume". All fields are combined with a logical 'AND'. */
export type Daily_Volume_Bool_Exp = {
  _and?: InputMaybe<Array<Daily_Volume_Bool_Exp>>;
  _not?: InputMaybe<Daily_Volume_Bool_Exp>;
  _or?: InputMaybe<Array<Daily_Volume_Bool_Exp>>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Daily_Volume_Max_Fields = {
  __typename?: 'daily_volume_max_fields';
  ticker?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Daily_Volume_Min_Fields = {
  __typename?: 'daily_volume_min_fields';
  ticker?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "daily_volume". */
export type Daily_Volume_Order_By = {
  ticker?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "daily_volume" */
export const Daily_Volume_Select_Column = {
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Volume: 'volume'
} as const;

export type Daily_Volume_Select_Column = typeof Daily_Volume_Select_Column[keyof typeof Daily_Volume_Select_Column];
/** aggregate stddev on columns */
export type Daily_Volume_Stddev_Fields = {
  __typename?: 'daily_volume_stddev_fields';
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Daily_Volume_Stddev_Pop_Fields = {
  __typename?: 'daily_volume_stddev_pop_fields';
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Daily_Volume_Stddev_Samp_Fields = {
  __typename?: 'daily_volume_stddev_samp_fields';
  volume?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "daily_volume" */
export type Daily_Volume_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Daily_Volume_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Daily_Volume_Stream_Cursor_Value_Input = {
  ticker?: InputMaybe<Scalars['String']>;
  volume?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Daily_Volume_Sum_Fields = {
  __typename?: 'daily_volume_sum_fields';
  volume?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Daily_Volume_Var_Pop_Fields = {
  __typename?: 'daily_volume_var_pop_fields';
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Daily_Volume_Var_Samp_Fields = {
  __typename?: 'daily_volume_var_samp_fields';
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Daily_Volume_Variance_Fields = {
  __typename?: 'daily_volume_variance_fields';
  volume?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "dark_pool_levels" */
export type Dark_Pool_Levels = {
  __typename?: 'dark_pool_levels';
  amount?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  prints?: Maybe<Scalars['bigint']>;
  ticker?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "dark_pool_levels" */
export type Dark_Pool_Levels_Aggregate = {
  __typename?: 'dark_pool_levels_aggregate';
  aggregate?: Maybe<Dark_Pool_Levels_Aggregate_Fields>;
  nodes: Array<Dark_Pool_Levels>;
};

/** aggregate fields of "dark_pool_levels" */
export type Dark_Pool_Levels_Aggregate_Fields = {
  __typename?: 'dark_pool_levels_aggregate_fields';
  avg?: Maybe<Dark_Pool_Levels_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Dark_Pool_Levels_Max_Fields>;
  min?: Maybe<Dark_Pool_Levels_Min_Fields>;
  stddev?: Maybe<Dark_Pool_Levels_Stddev_Fields>;
  stddev_pop?: Maybe<Dark_Pool_Levels_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dark_Pool_Levels_Stddev_Samp_Fields>;
  sum?: Maybe<Dark_Pool_Levels_Sum_Fields>;
  var_pop?: Maybe<Dark_Pool_Levels_Var_Pop_Fields>;
  var_samp?: Maybe<Dark_Pool_Levels_Var_Samp_Fields>;
  variance?: Maybe<Dark_Pool_Levels_Variance_Fields>;
};


/** aggregate fields of "dark_pool_levels" */
export type Dark_Pool_Levels_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dark_Pool_Levels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Dark_Pool_Levels_Avg_Fields = {
  __typename?: 'dark_pool_levels_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "dark_pool_levels". All fields are combined with a logical 'AND'. */
export type Dark_Pool_Levels_Bool_Exp = {
  _and?: InputMaybe<Array<Dark_Pool_Levels_Bool_Exp>>;
  _not?: InputMaybe<Dark_Pool_Levels_Bool_Exp>;
  _or?: InputMaybe<Array<Dark_Pool_Levels_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  prints?: InputMaybe<Bigint_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Dark_Pool_Levels_Max_Fields = {
  __typename?: 'dark_pool_levels_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  prints?: Maybe<Scalars['bigint']>;
  ticker?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Dark_Pool_Levels_Min_Fields = {
  __typename?: 'dark_pool_levels_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  prints?: Maybe<Scalars['bigint']>;
  ticker?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['bigint']>;
};

/** columns and relationships of "dark_pool_levels_monthly" */
export type Dark_Pool_Levels_Monthly = {
  __typename?: 'dark_pool_levels_monthly';
  amount?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  prints?: Maybe<Scalars['bigint']>;
  ticker?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "dark_pool_levels_monthly" */
export type Dark_Pool_Levels_Monthly_Aggregate = {
  __typename?: 'dark_pool_levels_monthly_aggregate';
  aggregate?: Maybe<Dark_Pool_Levels_Monthly_Aggregate_Fields>;
  nodes: Array<Dark_Pool_Levels_Monthly>;
};

/** aggregate fields of "dark_pool_levels_monthly" */
export type Dark_Pool_Levels_Monthly_Aggregate_Fields = {
  __typename?: 'dark_pool_levels_monthly_aggregate_fields';
  avg?: Maybe<Dark_Pool_Levels_Monthly_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Dark_Pool_Levels_Monthly_Max_Fields>;
  min?: Maybe<Dark_Pool_Levels_Monthly_Min_Fields>;
  stddev?: Maybe<Dark_Pool_Levels_Monthly_Stddev_Fields>;
  stddev_pop?: Maybe<Dark_Pool_Levels_Monthly_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dark_Pool_Levels_Monthly_Stddev_Samp_Fields>;
  sum?: Maybe<Dark_Pool_Levels_Monthly_Sum_Fields>;
  var_pop?: Maybe<Dark_Pool_Levels_Monthly_Var_Pop_Fields>;
  var_samp?: Maybe<Dark_Pool_Levels_Monthly_Var_Samp_Fields>;
  variance?: Maybe<Dark_Pool_Levels_Monthly_Variance_Fields>;
};


/** aggregate fields of "dark_pool_levels_monthly" */
export type Dark_Pool_Levels_Monthly_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dark_Pool_Levels_Monthly_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Dark_Pool_Levels_Monthly_Avg_Fields = {
  __typename?: 'dark_pool_levels_monthly_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "dark_pool_levels_monthly". All fields are combined with a logical 'AND'. */
export type Dark_Pool_Levels_Monthly_Bool_Exp = {
  _and?: InputMaybe<Array<Dark_Pool_Levels_Monthly_Bool_Exp>>;
  _not?: InputMaybe<Dark_Pool_Levels_Monthly_Bool_Exp>;
  _or?: InputMaybe<Array<Dark_Pool_Levels_Monthly_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  prints?: InputMaybe<Bigint_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Dark_Pool_Levels_Monthly_Max_Fields = {
  __typename?: 'dark_pool_levels_monthly_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  prints?: Maybe<Scalars['bigint']>;
  ticker?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Dark_Pool_Levels_Monthly_Min_Fields = {
  __typename?: 'dark_pool_levels_monthly_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  prints?: Maybe<Scalars['bigint']>;
  ticker?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "dark_pool_levels_monthly". */
export type Dark_Pool_Levels_Monthly_Order_By = {
  amount?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  prints?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "dark_pool_levels_monthly" */
export const Dark_Pool_Levels_Monthly_Select_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Price: 'price',
  /** column name */
  Prints: 'prints',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Volume: 'volume'
} as const;

export type Dark_Pool_Levels_Monthly_Select_Column = typeof Dark_Pool_Levels_Monthly_Select_Column[keyof typeof Dark_Pool_Levels_Monthly_Select_Column];
/** aggregate stddev on columns */
export type Dark_Pool_Levels_Monthly_Stddev_Fields = {
  __typename?: 'dark_pool_levels_monthly_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Dark_Pool_Levels_Monthly_Stddev_Pop_Fields = {
  __typename?: 'dark_pool_levels_monthly_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Dark_Pool_Levels_Monthly_Stddev_Samp_Fields = {
  __typename?: 'dark_pool_levels_monthly_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "dark_pool_levels_monthly" */
export type Dark_Pool_Levels_Monthly_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dark_Pool_Levels_Monthly_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dark_Pool_Levels_Monthly_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  prints?: InputMaybe<Scalars['bigint']>;
  ticker?: InputMaybe<Scalars['String']>;
  volume?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Dark_Pool_Levels_Monthly_Sum_Fields = {
  __typename?: 'dark_pool_levels_monthly_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  prints?: Maybe<Scalars['bigint']>;
  volume?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Dark_Pool_Levels_Monthly_Var_Pop_Fields = {
  __typename?: 'dark_pool_levels_monthly_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Dark_Pool_Levels_Monthly_Var_Samp_Fields = {
  __typename?: 'dark_pool_levels_monthly_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Dark_Pool_Levels_Monthly_Variance_Fields = {
  __typename?: 'dark_pool_levels_monthly_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** Ordering options when selecting data from "dark_pool_levels". */
export type Dark_Pool_Levels_Order_By = {
  amount?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  prints?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "dark_pool_levels" */
export const Dark_Pool_Levels_Select_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Price: 'price',
  /** column name */
  Prints: 'prints',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Volume: 'volume'
} as const;

export type Dark_Pool_Levels_Select_Column = typeof Dark_Pool_Levels_Select_Column[keyof typeof Dark_Pool_Levels_Select_Column];
/** aggregate stddev on columns */
export type Dark_Pool_Levels_Stddev_Fields = {
  __typename?: 'dark_pool_levels_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Dark_Pool_Levels_Stddev_Pop_Fields = {
  __typename?: 'dark_pool_levels_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Dark_Pool_Levels_Stddev_Samp_Fields = {
  __typename?: 'dark_pool_levels_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "dark_pool_levels" */
export type Dark_Pool_Levels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dark_Pool_Levels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dark_Pool_Levels_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  prints?: InputMaybe<Scalars['bigint']>;
  ticker?: InputMaybe<Scalars['String']>;
  volume?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Dark_Pool_Levels_Sum_Fields = {
  __typename?: 'dark_pool_levels_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  prints?: Maybe<Scalars['bigint']>;
  volume?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Dark_Pool_Levels_Var_Pop_Fields = {
  __typename?: 'dark_pool_levels_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Dark_Pool_Levels_Var_Samp_Fields = {
  __typename?: 'dark_pool_levels_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Dark_Pool_Levels_Variance_Fields = {
  __typename?: 'dark_pool_levels_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  prints?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "demo_filtered_trades_spiderrock" */
export type Demo_Filtered_Trades_Spiderrock = {
  __typename?: 'demo_filtered_trades_spiderrock';
  askCount: Scalars['Int'];
  askVolume: Scalars['Int'];
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount: Scalars['Int'];
  bidVolume: Scalars['Int'];
  cp: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  currentDailyVolume: Scalars['Int'];
  cxlVolume: Scalars['Int'];
  date: Scalars['date'];
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds: Scalars['Int'];
  delta: Scalars['numeric'];
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp: Scalars['bigint'];
  expireDay: Scalars['Int'];
  expireMonth: Scalars['Int'];
  expireYear: Scalars['Int'];
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma: Scalars['numeric'];
  id: Scalars['uuid'];
  impliedVol: Scalars['numeric'];
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge: Scalars['String'];
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  numberOfGroupedTrades: Scalars['Int'];
  openInterest?: Maybe<Scalars['bigint']>;
  orderType: Scalars['String'];
  otmPercent: Scalars['numeric'];
  premium: Scalars['numeric'];
  price: Scalars['numeric'];
  priceExternalApi?: Maybe<Scalars['numeric']>;
  prtProbability: Scalars['numeric'];
  prtTypes?: Maybe<Scalars['jsonb']>;
  rho: Scalars['numeric'];
  size: Scalars['Int'];
  spot: Scalars['numeric'];
  strike: Scalars['numeric'];
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta: Scalars['numeric'];
  ticker: Scalars['String'];
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  vega: Scalars['numeric'];
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry: Scalars['numeric'];
};


/** columns and relationships of "demo_filtered_trades_spiderrock" */
export type Demo_Filtered_Trades_SpiderrockPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "demo_filtered_trades_spiderrock" */
export type Demo_Filtered_Trades_Spiderrock_Aggregate = {
  __typename?: 'demo_filtered_trades_spiderrock_aggregate';
  aggregate?: Maybe<Demo_Filtered_Trades_Spiderrock_Aggregate_Fields>;
  nodes: Array<Demo_Filtered_Trades_Spiderrock>;
};

/** aggregate fields of "demo_filtered_trades_spiderrock" */
export type Demo_Filtered_Trades_Spiderrock_Aggregate_Fields = {
  __typename?: 'demo_filtered_trades_spiderrock_aggregate_fields';
  avg?: Maybe<Demo_Filtered_Trades_Spiderrock_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Demo_Filtered_Trades_Spiderrock_Max_Fields>;
  min?: Maybe<Demo_Filtered_Trades_Spiderrock_Min_Fields>;
  stddev?: Maybe<Demo_Filtered_Trades_Spiderrock_Stddev_Fields>;
  stddev_pop?: Maybe<Demo_Filtered_Trades_Spiderrock_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Demo_Filtered_Trades_Spiderrock_Stddev_Samp_Fields>;
  sum?: Maybe<Demo_Filtered_Trades_Spiderrock_Sum_Fields>;
  var_pop?: Maybe<Demo_Filtered_Trades_Spiderrock_Var_Pop_Fields>;
  var_samp?: Maybe<Demo_Filtered_Trades_Spiderrock_Var_Samp_Fields>;
  variance?: Maybe<Demo_Filtered_Trades_Spiderrock_Variance_Fields>;
};


/** aggregate fields of "demo_filtered_trades_spiderrock" */
export type Demo_Filtered_Trades_Spiderrock_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Demo_Filtered_Trades_Spiderrock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Demo_Filtered_Trades_Spiderrock_Append_Input = {
  prtTypes?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Demo_Filtered_Trades_Spiderrock_Avg_Fields = {
  __typename?: 'demo_filtered_trades_spiderrock_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "demo_filtered_trades_spiderrock". All fields are combined with a logical 'AND'. */
export type Demo_Filtered_Trades_Spiderrock_Bool_Exp = {
  _and?: InputMaybe<Array<Demo_Filtered_Trades_Spiderrock_Bool_Exp>>;
  _not?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Bool_Exp>;
  _or?: InputMaybe<Array<Demo_Filtered_Trades_Spiderrock_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Bigint_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "demo_filtered_trades_spiderrock" */
export const Demo_Filtered_Trades_Spiderrock_Constraint = {
  /** unique or primary key constraint on columns "id" */
  DemoFilteredTradesSpiderrockPkey: 'demo_filtered_trades_spiderrock_pkey'
} as const;

export type Demo_Filtered_Trades_Spiderrock_Constraint = typeof Demo_Filtered_Trades_Spiderrock_Constraint[keyof typeof Demo_Filtered_Trades_Spiderrock_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Demo_Filtered_Trades_Spiderrock_Delete_At_Path_Input = {
  prtTypes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Demo_Filtered_Trades_Spiderrock_Delete_Elem_Input = {
  prtTypes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Demo_Filtered_Trades_Spiderrock_Delete_Key_Input = {
  prtTypes?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "demo_filtered_trades_spiderrock" */
export type Demo_Filtered_Trades_Spiderrock_Inc_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['bigint']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  rho?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "demo_filtered_trades_spiderrock" */
export type Demo_Filtered_Trades_Spiderrock_Insert_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['bigint']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  tradeSide?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vega?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Demo_Filtered_Trades_Spiderrock_Max_Fields = {
  __typename?: 'demo_filtered_trades_spiderrock_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['bigint']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vega?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Demo_Filtered_Trades_Spiderrock_Min_Fields = {
  __typename?: 'demo_filtered_trades_spiderrock_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['bigint']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vega?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "demo_filtered_trades_spiderrock" */
export type Demo_Filtered_Trades_Spiderrock_Mutation_Response = {
  __typename?: 'demo_filtered_trades_spiderrock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Demo_Filtered_Trades_Spiderrock>;
};

/** on_conflict condition type for table "demo_filtered_trades_spiderrock" */
export type Demo_Filtered_Trades_Spiderrock_On_Conflict = {
  constraint: Demo_Filtered_Trades_Spiderrock_Constraint;
  update_columns?: Array<Demo_Filtered_Trades_Spiderrock_Update_Column>;
  where?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Bool_Exp>;
};

/** Ordering options when selecting data from "demo_filtered_trades_spiderrock". */
export type Demo_Filtered_Trades_Spiderrock_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
};

/** primary key columns input for table: demo_filtered_trades_spiderrock */
export type Demo_Filtered_Trades_Spiderrock_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Demo_Filtered_Trades_Spiderrock_Prepend_Input = {
  prtTypes?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "demo_filtered_trades_spiderrock" */
export const Demo_Filtered_Trades_Spiderrock_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  Size: 'size',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vega: 'vega',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry'
} as const;

export type Demo_Filtered_Trades_Spiderrock_Select_Column = typeof Demo_Filtered_Trades_Spiderrock_Select_Column[keyof typeof Demo_Filtered_Trades_Spiderrock_Select_Column];
/** input type for updating data in table "demo_filtered_trades_spiderrock" */
export type Demo_Filtered_Trades_Spiderrock_Set_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['bigint']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vega?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Demo_Filtered_Trades_Spiderrock_Stddev_Fields = {
  __typename?: 'demo_filtered_trades_spiderrock_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Demo_Filtered_Trades_Spiderrock_Stddev_Pop_Fields = {
  __typename?: 'demo_filtered_trades_spiderrock_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Demo_Filtered_Trades_Spiderrock_Stddev_Samp_Fields = {
  __typename?: 'demo_filtered_trades_spiderrock_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "demo_filtered_trades_spiderrock" */
export type Demo_Filtered_Trades_Spiderrock_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Demo_Filtered_Trades_Spiderrock_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Demo_Filtered_Trades_Spiderrock_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['bigint']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vega?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Demo_Filtered_Trades_Spiderrock_Sum_Fields = {
  __typename?: 'demo_filtered_trades_spiderrock_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['bigint']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
};

/** update columns of table "demo_filtered_trades_spiderrock" */
export const Demo_Filtered_Trades_Spiderrock_Update_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  Size: 'size',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vega: 'vega',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry'
} as const;

export type Demo_Filtered_Trades_Spiderrock_Update_Column = typeof Demo_Filtered_Trades_Spiderrock_Update_Column[keyof typeof Demo_Filtered_Trades_Spiderrock_Update_Column];
export type Demo_Filtered_Trades_Spiderrock_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Set_Input>;
  /** filter the rows which have to be updated */
  where: Demo_Filtered_Trades_Spiderrock_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Demo_Filtered_Trades_Spiderrock_Var_Pop_Fields = {
  __typename?: 'demo_filtered_trades_spiderrock_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Demo_Filtered_Trades_Spiderrock_Var_Samp_Fields = {
  __typename?: 'demo_filtered_trades_spiderrock_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Demo_Filtered_Trades_Spiderrock_Variance_Fields = {
  __typename?: 'demo_filtered_trades_spiderrock_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "demo_raw_trades_spiderrock" */
export type Demo_Raw_Trades_Spiderrock = {
  __typename?: 'demo_raw_trades_spiderrock';
  askCount: Scalars['Int'];
  askVolume: Scalars['Int'];
  bidCount: Scalars['Int'];
  bidVolume: Scalars['Int'];
  calcErr: Scalars['String'];
  cxlVolume: Scalars['Int'];
  netTimestamp: Scalars['bigint'];
  okey_at: Scalars['String'];
  okey_cp: Scalars['String'];
  okey_dy: Scalars['Int'];
  okey_mn: Scalars['Int'];
  okey_tk: Scalars['String'];
  okey_ts: Scalars['String'];
  okey_xx: Scalars['numeric'];
  okey_yr: Scalars['Int'];
  prtClusterSize: Scalars['Int'];
  prtDe: Scalars['numeric'];
  prtExch: Scalars['String'];
  prtGa: Scalars['numeric'];
  prtIv: Scalars['numeric'];
  prtNumber: Scalars['bigint'];
  prtOrders: Scalars['Int'];
  prtPrice: Scalars['numeric'];
  prtProbability: Scalars['numeric'];
  prtRo: Scalars['numeric'];
  prtSide: Scalars['String'];
  prtSize: Scalars['Int'];
  prtTh: Scalars['numeric'];
  prtTimestamp: Scalars['bigint'];
  prtType: Scalars['Int'];
  prtVe: Scalars['numeric'];
  prtVolume: Scalars['Int'];
  status: Scalars['String'];
  ticker_at: Scalars['String'];
  ticker_tk: Scalars['String'];
  ticker_ts: Scalars['String'];
  timestamp: Scalars['timetz'];
  timestamp_us: Scalars['Int'];
  uPrc: Scalars['numeric'];
  yrs: Scalars['numeric'];
};

/** aggregated selection of "demo_raw_trades_spiderrock" */
export type Demo_Raw_Trades_Spiderrock_Aggregate = {
  __typename?: 'demo_raw_trades_spiderrock_aggregate';
  aggregate?: Maybe<Demo_Raw_Trades_Spiderrock_Aggregate_Fields>;
  nodes: Array<Demo_Raw_Trades_Spiderrock>;
};

/** aggregate fields of "demo_raw_trades_spiderrock" */
export type Demo_Raw_Trades_Spiderrock_Aggregate_Fields = {
  __typename?: 'demo_raw_trades_spiderrock_aggregate_fields';
  avg?: Maybe<Demo_Raw_Trades_Spiderrock_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Demo_Raw_Trades_Spiderrock_Max_Fields>;
  min?: Maybe<Demo_Raw_Trades_Spiderrock_Min_Fields>;
  stddev?: Maybe<Demo_Raw_Trades_Spiderrock_Stddev_Fields>;
  stddev_pop?: Maybe<Demo_Raw_Trades_Spiderrock_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Demo_Raw_Trades_Spiderrock_Stddev_Samp_Fields>;
  sum?: Maybe<Demo_Raw_Trades_Spiderrock_Sum_Fields>;
  var_pop?: Maybe<Demo_Raw_Trades_Spiderrock_Var_Pop_Fields>;
  var_samp?: Maybe<Demo_Raw_Trades_Spiderrock_Var_Samp_Fields>;
  variance?: Maybe<Demo_Raw_Trades_Spiderrock_Variance_Fields>;
};


/** aggregate fields of "demo_raw_trades_spiderrock" */
export type Demo_Raw_Trades_Spiderrock_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Demo_Raw_Trades_Spiderrock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Demo_Raw_Trades_Spiderrock_Avg_Fields = {
  __typename?: 'demo_raw_trades_spiderrock_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  netTimestamp?: Maybe<Scalars['Float']>;
  okey_dy?: Maybe<Scalars['Float']>;
  okey_mn?: Maybe<Scalars['Float']>;
  okey_xx?: Maybe<Scalars['Float']>;
  okey_yr?: Maybe<Scalars['Float']>;
  prtClusterSize?: Maybe<Scalars['Float']>;
  prtDe?: Maybe<Scalars['Float']>;
  prtGa?: Maybe<Scalars['Float']>;
  prtIv?: Maybe<Scalars['Float']>;
  prtNumber?: Maybe<Scalars['Float']>;
  prtOrders?: Maybe<Scalars['Float']>;
  prtPrice?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  prtRo?: Maybe<Scalars['Float']>;
  prtSize?: Maybe<Scalars['Float']>;
  prtTh?: Maybe<Scalars['Float']>;
  prtTimestamp?: Maybe<Scalars['Float']>;
  prtType?: Maybe<Scalars['Float']>;
  prtVe?: Maybe<Scalars['Float']>;
  prtVolume?: Maybe<Scalars['Float']>;
  timestamp_us?: Maybe<Scalars['Float']>;
  uPrc?: Maybe<Scalars['Float']>;
  yrs?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "demo_raw_trades_spiderrock". All fields are combined with a logical 'AND'. */
export type Demo_Raw_Trades_Spiderrock_Bool_Exp = {
  _and?: InputMaybe<Array<Demo_Raw_Trades_Spiderrock_Bool_Exp>>;
  _not?: InputMaybe<Demo_Raw_Trades_Spiderrock_Bool_Exp>;
  _or?: InputMaybe<Array<Demo_Raw_Trades_Spiderrock_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  calcErr?: InputMaybe<String_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  netTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  okey_at?: InputMaybe<String_Comparison_Exp>;
  okey_cp?: InputMaybe<String_Comparison_Exp>;
  okey_dy?: InputMaybe<Int_Comparison_Exp>;
  okey_mn?: InputMaybe<Int_Comparison_Exp>;
  okey_tk?: InputMaybe<String_Comparison_Exp>;
  okey_ts?: InputMaybe<String_Comparison_Exp>;
  okey_xx?: InputMaybe<Numeric_Comparison_Exp>;
  okey_yr?: InputMaybe<Int_Comparison_Exp>;
  prtClusterSize?: InputMaybe<Int_Comparison_Exp>;
  prtDe?: InputMaybe<Numeric_Comparison_Exp>;
  prtExch?: InputMaybe<String_Comparison_Exp>;
  prtGa?: InputMaybe<Numeric_Comparison_Exp>;
  prtIv?: InputMaybe<Numeric_Comparison_Exp>;
  prtNumber?: InputMaybe<Bigint_Comparison_Exp>;
  prtOrders?: InputMaybe<Int_Comparison_Exp>;
  prtPrice?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtRo?: InputMaybe<Numeric_Comparison_Exp>;
  prtSide?: InputMaybe<String_Comparison_Exp>;
  prtSize?: InputMaybe<Int_Comparison_Exp>;
  prtTh?: InputMaybe<Numeric_Comparison_Exp>;
  prtTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  prtType?: InputMaybe<Int_Comparison_Exp>;
  prtVe?: InputMaybe<Numeric_Comparison_Exp>;
  prtVolume?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  ticker_at?: InputMaybe<String_Comparison_Exp>;
  ticker_tk?: InputMaybe<String_Comparison_Exp>;
  ticker_ts?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Timetz_Comparison_Exp>;
  timestamp_us?: InputMaybe<Int_Comparison_Exp>;
  uPrc?: InputMaybe<Numeric_Comparison_Exp>;
  yrs?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "demo_raw_trades_spiderrock" */
export const Demo_Raw_Trades_Spiderrock_Constraint = {
  /** unique or primary key constraint on columns "prtNumber" */
  DemoRawTradesSpiderrockPkey: 'demo_raw_trades_spiderrock_pkey'
} as const;

export type Demo_Raw_Trades_Spiderrock_Constraint = typeof Demo_Raw_Trades_Spiderrock_Constraint[keyof typeof Demo_Raw_Trades_Spiderrock_Constraint];
/** input type for incrementing numeric columns in table "demo_raw_trades_spiderrock" */
export type Demo_Raw_Trades_Spiderrock_Inc_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  netTimestamp?: InputMaybe<Scalars['bigint']>;
  okey_dy?: InputMaybe<Scalars['Int']>;
  okey_mn?: InputMaybe<Scalars['Int']>;
  okey_xx?: InputMaybe<Scalars['numeric']>;
  okey_yr?: InputMaybe<Scalars['Int']>;
  prtClusterSize?: InputMaybe<Scalars['Int']>;
  prtDe?: InputMaybe<Scalars['numeric']>;
  prtGa?: InputMaybe<Scalars['numeric']>;
  prtIv?: InputMaybe<Scalars['numeric']>;
  prtNumber?: InputMaybe<Scalars['bigint']>;
  prtOrders?: InputMaybe<Scalars['Int']>;
  prtPrice?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtRo?: InputMaybe<Scalars['numeric']>;
  prtSize?: InputMaybe<Scalars['Int']>;
  prtTh?: InputMaybe<Scalars['numeric']>;
  prtTimestamp?: InputMaybe<Scalars['bigint']>;
  prtType?: InputMaybe<Scalars['Int']>;
  prtVe?: InputMaybe<Scalars['numeric']>;
  prtVolume?: InputMaybe<Scalars['Int']>;
  timestamp_us?: InputMaybe<Scalars['Int']>;
  uPrc?: InputMaybe<Scalars['numeric']>;
  yrs?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "demo_raw_trades_spiderrock" */
export type Demo_Raw_Trades_Spiderrock_Insert_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  calcErr?: InputMaybe<Scalars['String']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  netTimestamp?: InputMaybe<Scalars['bigint']>;
  okey_at?: InputMaybe<Scalars['String']>;
  okey_cp?: InputMaybe<Scalars['String']>;
  okey_dy?: InputMaybe<Scalars['Int']>;
  okey_mn?: InputMaybe<Scalars['Int']>;
  okey_tk?: InputMaybe<Scalars['String']>;
  okey_ts?: InputMaybe<Scalars['String']>;
  okey_xx?: InputMaybe<Scalars['numeric']>;
  okey_yr?: InputMaybe<Scalars['Int']>;
  prtClusterSize?: InputMaybe<Scalars['Int']>;
  prtDe?: InputMaybe<Scalars['numeric']>;
  prtExch?: InputMaybe<Scalars['String']>;
  prtGa?: InputMaybe<Scalars['numeric']>;
  prtIv?: InputMaybe<Scalars['numeric']>;
  prtNumber?: InputMaybe<Scalars['bigint']>;
  prtOrders?: InputMaybe<Scalars['Int']>;
  prtPrice?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtRo?: InputMaybe<Scalars['numeric']>;
  prtSide?: InputMaybe<Scalars['String']>;
  prtSize?: InputMaybe<Scalars['Int']>;
  prtTh?: InputMaybe<Scalars['numeric']>;
  prtTimestamp?: InputMaybe<Scalars['bigint']>;
  prtType?: InputMaybe<Scalars['Int']>;
  prtVe?: InputMaybe<Scalars['numeric']>;
  prtVolume?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  ticker_at?: InputMaybe<Scalars['String']>;
  ticker_tk?: InputMaybe<Scalars['String']>;
  ticker_ts?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timetz']>;
  timestamp_us?: InputMaybe<Scalars['Int']>;
  uPrc?: InputMaybe<Scalars['numeric']>;
  yrs?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Demo_Raw_Trades_Spiderrock_Max_Fields = {
  __typename?: 'demo_raw_trades_spiderrock_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  calcErr?: Maybe<Scalars['String']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  netTimestamp?: Maybe<Scalars['bigint']>;
  okey_at?: Maybe<Scalars['String']>;
  okey_cp?: Maybe<Scalars['String']>;
  okey_dy?: Maybe<Scalars['Int']>;
  okey_mn?: Maybe<Scalars['Int']>;
  okey_tk?: Maybe<Scalars['String']>;
  okey_ts?: Maybe<Scalars['String']>;
  okey_xx?: Maybe<Scalars['numeric']>;
  okey_yr?: Maybe<Scalars['Int']>;
  prtClusterSize?: Maybe<Scalars['Int']>;
  prtDe?: Maybe<Scalars['numeric']>;
  prtExch?: Maybe<Scalars['String']>;
  prtGa?: Maybe<Scalars['numeric']>;
  prtIv?: Maybe<Scalars['numeric']>;
  prtNumber?: Maybe<Scalars['bigint']>;
  prtOrders?: Maybe<Scalars['Int']>;
  prtPrice?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtRo?: Maybe<Scalars['numeric']>;
  prtSide?: Maybe<Scalars['String']>;
  prtSize?: Maybe<Scalars['Int']>;
  prtTh?: Maybe<Scalars['numeric']>;
  prtTimestamp?: Maybe<Scalars['bigint']>;
  prtType?: Maybe<Scalars['Int']>;
  prtVe?: Maybe<Scalars['numeric']>;
  prtVolume?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  ticker_at?: Maybe<Scalars['String']>;
  ticker_tk?: Maybe<Scalars['String']>;
  ticker_ts?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timetz']>;
  timestamp_us?: Maybe<Scalars['Int']>;
  uPrc?: Maybe<Scalars['numeric']>;
  yrs?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Demo_Raw_Trades_Spiderrock_Min_Fields = {
  __typename?: 'demo_raw_trades_spiderrock_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  calcErr?: Maybe<Scalars['String']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  netTimestamp?: Maybe<Scalars['bigint']>;
  okey_at?: Maybe<Scalars['String']>;
  okey_cp?: Maybe<Scalars['String']>;
  okey_dy?: Maybe<Scalars['Int']>;
  okey_mn?: Maybe<Scalars['Int']>;
  okey_tk?: Maybe<Scalars['String']>;
  okey_ts?: Maybe<Scalars['String']>;
  okey_xx?: Maybe<Scalars['numeric']>;
  okey_yr?: Maybe<Scalars['Int']>;
  prtClusterSize?: Maybe<Scalars['Int']>;
  prtDe?: Maybe<Scalars['numeric']>;
  prtExch?: Maybe<Scalars['String']>;
  prtGa?: Maybe<Scalars['numeric']>;
  prtIv?: Maybe<Scalars['numeric']>;
  prtNumber?: Maybe<Scalars['bigint']>;
  prtOrders?: Maybe<Scalars['Int']>;
  prtPrice?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtRo?: Maybe<Scalars['numeric']>;
  prtSide?: Maybe<Scalars['String']>;
  prtSize?: Maybe<Scalars['Int']>;
  prtTh?: Maybe<Scalars['numeric']>;
  prtTimestamp?: Maybe<Scalars['bigint']>;
  prtType?: Maybe<Scalars['Int']>;
  prtVe?: Maybe<Scalars['numeric']>;
  prtVolume?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  ticker_at?: Maybe<Scalars['String']>;
  ticker_tk?: Maybe<Scalars['String']>;
  ticker_ts?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timetz']>;
  timestamp_us?: Maybe<Scalars['Int']>;
  uPrc?: Maybe<Scalars['numeric']>;
  yrs?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "demo_raw_trades_spiderrock" */
export type Demo_Raw_Trades_Spiderrock_Mutation_Response = {
  __typename?: 'demo_raw_trades_spiderrock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Demo_Raw_Trades_Spiderrock>;
};

/** on_conflict condition type for table "demo_raw_trades_spiderrock" */
export type Demo_Raw_Trades_Spiderrock_On_Conflict = {
  constraint: Demo_Raw_Trades_Spiderrock_Constraint;
  update_columns?: Array<Demo_Raw_Trades_Spiderrock_Update_Column>;
  where?: InputMaybe<Demo_Raw_Trades_Spiderrock_Bool_Exp>;
};

/** Ordering options when selecting data from "demo_raw_trades_spiderrock". */
export type Demo_Raw_Trades_Spiderrock_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  calcErr?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  netTimestamp?: InputMaybe<Order_By>;
  okey_at?: InputMaybe<Order_By>;
  okey_cp?: InputMaybe<Order_By>;
  okey_dy?: InputMaybe<Order_By>;
  okey_mn?: InputMaybe<Order_By>;
  okey_tk?: InputMaybe<Order_By>;
  okey_ts?: InputMaybe<Order_By>;
  okey_xx?: InputMaybe<Order_By>;
  okey_yr?: InputMaybe<Order_By>;
  prtClusterSize?: InputMaybe<Order_By>;
  prtDe?: InputMaybe<Order_By>;
  prtExch?: InputMaybe<Order_By>;
  prtGa?: InputMaybe<Order_By>;
  prtIv?: InputMaybe<Order_By>;
  prtNumber?: InputMaybe<Order_By>;
  prtOrders?: InputMaybe<Order_By>;
  prtPrice?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtRo?: InputMaybe<Order_By>;
  prtSide?: InputMaybe<Order_By>;
  prtSize?: InputMaybe<Order_By>;
  prtTh?: InputMaybe<Order_By>;
  prtTimestamp?: InputMaybe<Order_By>;
  prtType?: InputMaybe<Order_By>;
  prtVe?: InputMaybe<Order_By>;
  prtVolume?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ticker_at?: InputMaybe<Order_By>;
  ticker_tk?: InputMaybe<Order_By>;
  ticker_ts?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  timestamp_us?: InputMaybe<Order_By>;
  uPrc?: InputMaybe<Order_By>;
  yrs?: InputMaybe<Order_By>;
};

/** primary key columns input for table: demo_raw_trades_spiderrock */
export type Demo_Raw_Trades_Spiderrock_Pk_Columns_Input = {
  prtNumber: Scalars['bigint'];
};

/** select columns of table "demo_raw_trades_spiderrock" */
export const Demo_Raw_Trades_Spiderrock_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  CalcErr: 'calcErr',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  NetTimestamp: 'netTimestamp',
  /** column name */
  OkeyAt: 'okey_at',
  /** column name */
  OkeyCp: 'okey_cp',
  /** column name */
  OkeyDy: 'okey_dy',
  /** column name */
  OkeyMn: 'okey_mn',
  /** column name */
  OkeyTk: 'okey_tk',
  /** column name */
  OkeyTs: 'okey_ts',
  /** column name */
  OkeyXx: 'okey_xx',
  /** column name */
  OkeyYr: 'okey_yr',
  /** column name */
  PrtClusterSize: 'prtClusterSize',
  /** column name */
  PrtDe: 'prtDe',
  /** column name */
  PrtExch: 'prtExch',
  /** column name */
  PrtGa: 'prtGa',
  /** column name */
  PrtIv: 'prtIv',
  /** column name */
  PrtNumber: 'prtNumber',
  /** column name */
  PrtOrders: 'prtOrders',
  /** column name */
  PrtPrice: 'prtPrice',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtRo: 'prtRo',
  /** column name */
  PrtSide: 'prtSide',
  /** column name */
  PrtSize: 'prtSize',
  /** column name */
  PrtTh: 'prtTh',
  /** column name */
  PrtTimestamp: 'prtTimestamp',
  /** column name */
  PrtType: 'prtType',
  /** column name */
  PrtVe: 'prtVe',
  /** column name */
  PrtVolume: 'prtVolume',
  /** column name */
  Status: 'status',
  /** column name */
  TickerAt: 'ticker_at',
  /** column name */
  TickerTk: 'ticker_tk',
  /** column name */
  TickerTs: 'ticker_ts',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TimestampUs: 'timestamp_us',
  /** column name */
  UPrc: 'uPrc',
  /** column name */
  Yrs: 'yrs'
} as const;

export type Demo_Raw_Trades_Spiderrock_Select_Column = typeof Demo_Raw_Trades_Spiderrock_Select_Column[keyof typeof Demo_Raw_Trades_Spiderrock_Select_Column];
/** input type for updating data in table "demo_raw_trades_spiderrock" */
export type Demo_Raw_Trades_Spiderrock_Set_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  calcErr?: InputMaybe<Scalars['String']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  netTimestamp?: InputMaybe<Scalars['bigint']>;
  okey_at?: InputMaybe<Scalars['String']>;
  okey_cp?: InputMaybe<Scalars['String']>;
  okey_dy?: InputMaybe<Scalars['Int']>;
  okey_mn?: InputMaybe<Scalars['Int']>;
  okey_tk?: InputMaybe<Scalars['String']>;
  okey_ts?: InputMaybe<Scalars['String']>;
  okey_xx?: InputMaybe<Scalars['numeric']>;
  okey_yr?: InputMaybe<Scalars['Int']>;
  prtClusterSize?: InputMaybe<Scalars['Int']>;
  prtDe?: InputMaybe<Scalars['numeric']>;
  prtExch?: InputMaybe<Scalars['String']>;
  prtGa?: InputMaybe<Scalars['numeric']>;
  prtIv?: InputMaybe<Scalars['numeric']>;
  prtNumber?: InputMaybe<Scalars['bigint']>;
  prtOrders?: InputMaybe<Scalars['Int']>;
  prtPrice?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtRo?: InputMaybe<Scalars['numeric']>;
  prtSide?: InputMaybe<Scalars['String']>;
  prtSize?: InputMaybe<Scalars['Int']>;
  prtTh?: InputMaybe<Scalars['numeric']>;
  prtTimestamp?: InputMaybe<Scalars['bigint']>;
  prtType?: InputMaybe<Scalars['Int']>;
  prtVe?: InputMaybe<Scalars['numeric']>;
  prtVolume?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  ticker_at?: InputMaybe<Scalars['String']>;
  ticker_tk?: InputMaybe<Scalars['String']>;
  ticker_ts?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timetz']>;
  timestamp_us?: InputMaybe<Scalars['Int']>;
  uPrc?: InputMaybe<Scalars['numeric']>;
  yrs?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Demo_Raw_Trades_Spiderrock_Stddev_Fields = {
  __typename?: 'demo_raw_trades_spiderrock_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  netTimestamp?: Maybe<Scalars['Float']>;
  okey_dy?: Maybe<Scalars['Float']>;
  okey_mn?: Maybe<Scalars['Float']>;
  okey_xx?: Maybe<Scalars['Float']>;
  okey_yr?: Maybe<Scalars['Float']>;
  prtClusterSize?: Maybe<Scalars['Float']>;
  prtDe?: Maybe<Scalars['Float']>;
  prtGa?: Maybe<Scalars['Float']>;
  prtIv?: Maybe<Scalars['Float']>;
  prtNumber?: Maybe<Scalars['Float']>;
  prtOrders?: Maybe<Scalars['Float']>;
  prtPrice?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  prtRo?: Maybe<Scalars['Float']>;
  prtSize?: Maybe<Scalars['Float']>;
  prtTh?: Maybe<Scalars['Float']>;
  prtTimestamp?: Maybe<Scalars['Float']>;
  prtType?: Maybe<Scalars['Float']>;
  prtVe?: Maybe<Scalars['Float']>;
  prtVolume?: Maybe<Scalars['Float']>;
  timestamp_us?: Maybe<Scalars['Float']>;
  uPrc?: Maybe<Scalars['Float']>;
  yrs?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Demo_Raw_Trades_Spiderrock_Stddev_Pop_Fields = {
  __typename?: 'demo_raw_trades_spiderrock_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  netTimestamp?: Maybe<Scalars['Float']>;
  okey_dy?: Maybe<Scalars['Float']>;
  okey_mn?: Maybe<Scalars['Float']>;
  okey_xx?: Maybe<Scalars['Float']>;
  okey_yr?: Maybe<Scalars['Float']>;
  prtClusterSize?: Maybe<Scalars['Float']>;
  prtDe?: Maybe<Scalars['Float']>;
  prtGa?: Maybe<Scalars['Float']>;
  prtIv?: Maybe<Scalars['Float']>;
  prtNumber?: Maybe<Scalars['Float']>;
  prtOrders?: Maybe<Scalars['Float']>;
  prtPrice?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  prtRo?: Maybe<Scalars['Float']>;
  prtSize?: Maybe<Scalars['Float']>;
  prtTh?: Maybe<Scalars['Float']>;
  prtTimestamp?: Maybe<Scalars['Float']>;
  prtType?: Maybe<Scalars['Float']>;
  prtVe?: Maybe<Scalars['Float']>;
  prtVolume?: Maybe<Scalars['Float']>;
  timestamp_us?: Maybe<Scalars['Float']>;
  uPrc?: Maybe<Scalars['Float']>;
  yrs?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Demo_Raw_Trades_Spiderrock_Stddev_Samp_Fields = {
  __typename?: 'demo_raw_trades_spiderrock_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  netTimestamp?: Maybe<Scalars['Float']>;
  okey_dy?: Maybe<Scalars['Float']>;
  okey_mn?: Maybe<Scalars['Float']>;
  okey_xx?: Maybe<Scalars['Float']>;
  okey_yr?: Maybe<Scalars['Float']>;
  prtClusterSize?: Maybe<Scalars['Float']>;
  prtDe?: Maybe<Scalars['Float']>;
  prtGa?: Maybe<Scalars['Float']>;
  prtIv?: Maybe<Scalars['Float']>;
  prtNumber?: Maybe<Scalars['Float']>;
  prtOrders?: Maybe<Scalars['Float']>;
  prtPrice?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  prtRo?: Maybe<Scalars['Float']>;
  prtSize?: Maybe<Scalars['Float']>;
  prtTh?: Maybe<Scalars['Float']>;
  prtTimestamp?: Maybe<Scalars['Float']>;
  prtType?: Maybe<Scalars['Float']>;
  prtVe?: Maybe<Scalars['Float']>;
  prtVolume?: Maybe<Scalars['Float']>;
  timestamp_us?: Maybe<Scalars['Float']>;
  uPrc?: Maybe<Scalars['Float']>;
  yrs?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "demo_raw_trades_spiderrock" */
export type Demo_Raw_Trades_Spiderrock_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Demo_Raw_Trades_Spiderrock_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Demo_Raw_Trades_Spiderrock_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  calcErr?: InputMaybe<Scalars['String']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  netTimestamp?: InputMaybe<Scalars['bigint']>;
  okey_at?: InputMaybe<Scalars['String']>;
  okey_cp?: InputMaybe<Scalars['String']>;
  okey_dy?: InputMaybe<Scalars['Int']>;
  okey_mn?: InputMaybe<Scalars['Int']>;
  okey_tk?: InputMaybe<Scalars['String']>;
  okey_ts?: InputMaybe<Scalars['String']>;
  okey_xx?: InputMaybe<Scalars['numeric']>;
  okey_yr?: InputMaybe<Scalars['Int']>;
  prtClusterSize?: InputMaybe<Scalars['Int']>;
  prtDe?: InputMaybe<Scalars['numeric']>;
  prtExch?: InputMaybe<Scalars['String']>;
  prtGa?: InputMaybe<Scalars['numeric']>;
  prtIv?: InputMaybe<Scalars['numeric']>;
  prtNumber?: InputMaybe<Scalars['bigint']>;
  prtOrders?: InputMaybe<Scalars['Int']>;
  prtPrice?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtRo?: InputMaybe<Scalars['numeric']>;
  prtSide?: InputMaybe<Scalars['String']>;
  prtSize?: InputMaybe<Scalars['Int']>;
  prtTh?: InputMaybe<Scalars['numeric']>;
  prtTimestamp?: InputMaybe<Scalars['bigint']>;
  prtType?: InputMaybe<Scalars['Int']>;
  prtVe?: InputMaybe<Scalars['numeric']>;
  prtVolume?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  ticker_at?: InputMaybe<Scalars['String']>;
  ticker_tk?: InputMaybe<Scalars['String']>;
  ticker_ts?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['timetz']>;
  timestamp_us?: InputMaybe<Scalars['Int']>;
  uPrc?: InputMaybe<Scalars['numeric']>;
  yrs?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Demo_Raw_Trades_Spiderrock_Sum_Fields = {
  __typename?: 'demo_raw_trades_spiderrock_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  netTimestamp?: Maybe<Scalars['bigint']>;
  okey_dy?: Maybe<Scalars['Int']>;
  okey_mn?: Maybe<Scalars['Int']>;
  okey_xx?: Maybe<Scalars['numeric']>;
  okey_yr?: Maybe<Scalars['Int']>;
  prtClusterSize?: Maybe<Scalars['Int']>;
  prtDe?: Maybe<Scalars['numeric']>;
  prtGa?: Maybe<Scalars['numeric']>;
  prtIv?: Maybe<Scalars['numeric']>;
  prtNumber?: Maybe<Scalars['bigint']>;
  prtOrders?: Maybe<Scalars['Int']>;
  prtPrice?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtRo?: Maybe<Scalars['numeric']>;
  prtSize?: Maybe<Scalars['Int']>;
  prtTh?: Maybe<Scalars['numeric']>;
  prtTimestamp?: Maybe<Scalars['bigint']>;
  prtType?: Maybe<Scalars['Int']>;
  prtVe?: Maybe<Scalars['numeric']>;
  prtVolume?: Maybe<Scalars['Int']>;
  timestamp_us?: Maybe<Scalars['Int']>;
  uPrc?: Maybe<Scalars['numeric']>;
  yrs?: Maybe<Scalars['numeric']>;
};

/** update columns of table "demo_raw_trades_spiderrock" */
export const Demo_Raw_Trades_Spiderrock_Update_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  CalcErr: 'calcErr',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  NetTimestamp: 'netTimestamp',
  /** column name */
  OkeyAt: 'okey_at',
  /** column name */
  OkeyCp: 'okey_cp',
  /** column name */
  OkeyDy: 'okey_dy',
  /** column name */
  OkeyMn: 'okey_mn',
  /** column name */
  OkeyTk: 'okey_tk',
  /** column name */
  OkeyTs: 'okey_ts',
  /** column name */
  OkeyXx: 'okey_xx',
  /** column name */
  OkeyYr: 'okey_yr',
  /** column name */
  PrtClusterSize: 'prtClusterSize',
  /** column name */
  PrtDe: 'prtDe',
  /** column name */
  PrtExch: 'prtExch',
  /** column name */
  PrtGa: 'prtGa',
  /** column name */
  PrtIv: 'prtIv',
  /** column name */
  PrtNumber: 'prtNumber',
  /** column name */
  PrtOrders: 'prtOrders',
  /** column name */
  PrtPrice: 'prtPrice',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtRo: 'prtRo',
  /** column name */
  PrtSide: 'prtSide',
  /** column name */
  PrtSize: 'prtSize',
  /** column name */
  PrtTh: 'prtTh',
  /** column name */
  PrtTimestamp: 'prtTimestamp',
  /** column name */
  PrtType: 'prtType',
  /** column name */
  PrtVe: 'prtVe',
  /** column name */
  PrtVolume: 'prtVolume',
  /** column name */
  Status: 'status',
  /** column name */
  TickerAt: 'ticker_at',
  /** column name */
  TickerTk: 'ticker_tk',
  /** column name */
  TickerTs: 'ticker_ts',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TimestampUs: 'timestamp_us',
  /** column name */
  UPrc: 'uPrc',
  /** column name */
  Yrs: 'yrs'
} as const;

export type Demo_Raw_Trades_Spiderrock_Update_Column = typeof Demo_Raw_Trades_Spiderrock_Update_Column[keyof typeof Demo_Raw_Trades_Spiderrock_Update_Column];
export type Demo_Raw_Trades_Spiderrock_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Demo_Raw_Trades_Spiderrock_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Demo_Raw_Trades_Spiderrock_Set_Input>;
  /** filter the rows which have to be updated */
  where: Demo_Raw_Trades_Spiderrock_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Demo_Raw_Trades_Spiderrock_Var_Pop_Fields = {
  __typename?: 'demo_raw_trades_spiderrock_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  netTimestamp?: Maybe<Scalars['Float']>;
  okey_dy?: Maybe<Scalars['Float']>;
  okey_mn?: Maybe<Scalars['Float']>;
  okey_xx?: Maybe<Scalars['Float']>;
  okey_yr?: Maybe<Scalars['Float']>;
  prtClusterSize?: Maybe<Scalars['Float']>;
  prtDe?: Maybe<Scalars['Float']>;
  prtGa?: Maybe<Scalars['Float']>;
  prtIv?: Maybe<Scalars['Float']>;
  prtNumber?: Maybe<Scalars['Float']>;
  prtOrders?: Maybe<Scalars['Float']>;
  prtPrice?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  prtRo?: Maybe<Scalars['Float']>;
  prtSize?: Maybe<Scalars['Float']>;
  prtTh?: Maybe<Scalars['Float']>;
  prtTimestamp?: Maybe<Scalars['Float']>;
  prtType?: Maybe<Scalars['Float']>;
  prtVe?: Maybe<Scalars['Float']>;
  prtVolume?: Maybe<Scalars['Float']>;
  timestamp_us?: Maybe<Scalars['Float']>;
  uPrc?: Maybe<Scalars['Float']>;
  yrs?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Demo_Raw_Trades_Spiderrock_Var_Samp_Fields = {
  __typename?: 'demo_raw_trades_spiderrock_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  netTimestamp?: Maybe<Scalars['Float']>;
  okey_dy?: Maybe<Scalars['Float']>;
  okey_mn?: Maybe<Scalars['Float']>;
  okey_xx?: Maybe<Scalars['Float']>;
  okey_yr?: Maybe<Scalars['Float']>;
  prtClusterSize?: Maybe<Scalars['Float']>;
  prtDe?: Maybe<Scalars['Float']>;
  prtGa?: Maybe<Scalars['Float']>;
  prtIv?: Maybe<Scalars['Float']>;
  prtNumber?: Maybe<Scalars['Float']>;
  prtOrders?: Maybe<Scalars['Float']>;
  prtPrice?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  prtRo?: Maybe<Scalars['Float']>;
  prtSize?: Maybe<Scalars['Float']>;
  prtTh?: Maybe<Scalars['Float']>;
  prtTimestamp?: Maybe<Scalars['Float']>;
  prtType?: Maybe<Scalars['Float']>;
  prtVe?: Maybe<Scalars['Float']>;
  prtVolume?: Maybe<Scalars['Float']>;
  timestamp_us?: Maybe<Scalars['Float']>;
  uPrc?: Maybe<Scalars['Float']>;
  yrs?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Demo_Raw_Trades_Spiderrock_Variance_Fields = {
  __typename?: 'demo_raw_trades_spiderrock_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  netTimestamp?: Maybe<Scalars['Float']>;
  okey_dy?: Maybe<Scalars['Float']>;
  okey_mn?: Maybe<Scalars['Float']>;
  okey_xx?: Maybe<Scalars['Float']>;
  okey_yr?: Maybe<Scalars['Float']>;
  prtClusterSize?: Maybe<Scalars['Float']>;
  prtDe?: Maybe<Scalars['Float']>;
  prtGa?: Maybe<Scalars['Float']>;
  prtIv?: Maybe<Scalars['Float']>;
  prtNumber?: Maybe<Scalars['Float']>;
  prtOrders?: Maybe<Scalars['Float']>;
  prtPrice?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  prtRo?: Maybe<Scalars['Float']>;
  prtSize?: Maybe<Scalars['Float']>;
  prtTh?: Maybe<Scalars['Float']>;
  prtTimestamp?: Maybe<Scalars['Float']>;
  prtType?: Maybe<Scalars['Float']>;
  prtVe?: Maybe<Scalars['Float']>;
  prtVolume?: Maybe<Scalars['Float']>;
  timestamp_us?: Maybe<Scalars['Float']>;
  uPrc?: Maybe<Scalars['Float']>;
  yrs?: Maybe<Scalars['Float']>;
};

/** Earnings from the stock news API */
export type Earnings_Snp = {
  __typename?: 'earnings_snp';
  createdAt: Scalars['timestamptz'];
  date: Scalars['date'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  ticker: Scalars['String'];
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  time: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  url: Scalars['String'];
};

/** aggregated selection of "earnings_snp" */
export type Earnings_Snp_Aggregate = {
  __typename?: 'earnings_snp_aggregate';
  aggregate?: Maybe<Earnings_Snp_Aggregate_Fields>;
  nodes: Array<Earnings_Snp>;
};

export type Earnings_Snp_Aggregate_Bool_Exp = {
  count?: InputMaybe<Earnings_Snp_Aggregate_Bool_Exp_Count>;
};

export type Earnings_Snp_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Earnings_Snp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Earnings_Snp_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "earnings_snp" */
export type Earnings_Snp_Aggregate_Fields = {
  __typename?: 'earnings_snp_aggregate_fields';
  avg?: Maybe<Earnings_Snp_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Earnings_Snp_Max_Fields>;
  min?: Maybe<Earnings_Snp_Min_Fields>;
  stddev?: Maybe<Earnings_Snp_Stddev_Fields>;
  stddev_pop?: Maybe<Earnings_Snp_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Earnings_Snp_Stddev_Samp_Fields>;
  sum?: Maybe<Earnings_Snp_Sum_Fields>;
  var_pop?: Maybe<Earnings_Snp_Var_Pop_Fields>;
  var_samp?: Maybe<Earnings_Snp_Var_Samp_Fields>;
  variance?: Maybe<Earnings_Snp_Variance_Fields>;
};


/** aggregate fields of "earnings_snp" */
export type Earnings_Snp_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Earnings_Snp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "earnings_snp" */
export type Earnings_Snp_Aggregate_Order_By = {
  avg?: InputMaybe<Earnings_Snp_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Earnings_Snp_Max_Order_By>;
  min?: InputMaybe<Earnings_Snp_Min_Order_By>;
  stddev?: InputMaybe<Earnings_Snp_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Earnings_Snp_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Earnings_Snp_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Earnings_Snp_Sum_Order_By>;
  var_pop?: InputMaybe<Earnings_Snp_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Earnings_Snp_Var_Samp_Order_By>;
  variance?: InputMaybe<Earnings_Snp_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "earnings_snp" */
export type Earnings_Snp_Arr_Rel_Insert_Input = {
  data: Array<Earnings_Snp_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Earnings_Snp_On_Conflict>;
};

/** aggregate avg on columns */
export type Earnings_Snp_Avg_Fields = {
  __typename?: 'earnings_snp_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "earnings_snp" */
export type Earnings_Snp_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "earnings_snp". All fields are combined with a logical 'AND'. */
export type Earnings_Snp_Bool_Exp = {
  _and?: InputMaybe<Array<Earnings_Snp_Bool_Exp>>;
  _not?: InputMaybe<Earnings_Snp_Bool_Exp>;
  _or?: InputMaybe<Array<Earnings_Snp_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  time?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "earnings_snp" */
export const Earnings_Snp_Constraint = {
  /** unique or primary key constraint on columns "id" */
  EarningsSnpPkey: 'earnings_snp_pkey'
} as const;

export type Earnings_Snp_Constraint = typeof Earnings_Snp_Constraint[keyof typeof Earnings_Snp_Constraint];
/** input type for incrementing numeric columns in table "earnings_snp" */
export type Earnings_Snp_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "earnings_snp" */
export type Earnings_Snp_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  time?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Earnings_Snp_Max_Fields = {
  __typename?: 'earnings_snp_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "earnings_snp" */
export type Earnings_Snp_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Earnings_Snp_Min_Fields = {
  __typename?: 'earnings_snp_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "earnings_snp" */
export type Earnings_Snp_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "earnings_snp" */
export type Earnings_Snp_Mutation_Response = {
  __typename?: 'earnings_snp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Earnings_Snp>;
};

/** on_conflict condition type for table "earnings_snp" */
export type Earnings_Snp_On_Conflict = {
  constraint: Earnings_Snp_Constraint;
  update_columns?: Array<Earnings_Snp_Update_Column>;
  where?: InputMaybe<Earnings_Snp_Bool_Exp>;
};

/** Ordering options when selecting data from "earnings_snp". */
export type Earnings_Snp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  time?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: earnings_snp */
export type Earnings_Snp_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "earnings_snp" */
export const Earnings_Snp_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Time: 'time',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Url: 'url'
} as const;

export type Earnings_Snp_Select_Column = typeof Earnings_Snp_Select_Column[keyof typeof Earnings_Snp_Select_Column];
/** input type for updating data in table "earnings_snp" */
export type Earnings_Snp_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Earnings_Snp_Stddev_Fields = {
  __typename?: 'earnings_snp_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "earnings_snp" */
export type Earnings_Snp_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Earnings_Snp_Stddev_Pop_Fields = {
  __typename?: 'earnings_snp_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "earnings_snp" */
export type Earnings_Snp_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Earnings_Snp_Stddev_Samp_Fields = {
  __typename?: 'earnings_snp_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "earnings_snp" */
export type Earnings_Snp_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "earnings_snp" */
export type Earnings_Snp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Earnings_Snp_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Earnings_Snp_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Earnings_Snp_Sum_Fields = {
  __typename?: 'earnings_snp_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "earnings_snp" */
export type Earnings_Snp_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "earnings_snp" */
export const Earnings_Snp_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Time: 'time',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Url: 'url'
} as const;

export type Earnings_Snp_Update_Column = typeof Earnings_Snp_Update_Column[keyof typeof Earnings_Snp_Update_Column];
export type Earnings_Snp_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Earnings_Snp_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Earnings_Snp_Set_Input>;
  /** filter the rows which have to be updated */
  where: Earnings_Snp_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Earnings_Snp_Var_Pop_Fields = {
  __typename?: 'earnings_snp_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "earnings_snp" */
export type Earnings_Snp_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Earnings_Snp_Var_Samp_Fields = {
  __typename?: 'earnings_snp_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "earnings_snp" */
export type Earnings_Snp_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Earnings_Snp_Variance_Fields = {
  __typename?: 'earnings_snp_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "earnings_snp" */
export type Earnings_Snp_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "email_alerts" */
export type Email_Alerts = {
  __typename?: 'email_alerts';
  createdAt: Scalars['timestamptz'];
  date: Scalars['String'];
  emailProvider: Scalars['String'];
  emailProviderCampaignId?: Maybe<Scalars['String']>;
  emailProviderTemplateId?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  htmlUrl?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  params: Scalars['jsonb'];
  templateName: Scalars['String'];
  timeId: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "email_alerts" */
export type Email_AlertsParamsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "email_alerts" */
export type Email_Alerts_Aggregate = {
  __typename?: 'email_alerts_aggregate';
  aggregate?: Maybe<Email_Alerts_Aggregate_Fields>;
  nodes: Array<Email_Alerts>;
};

/** aggregate fields of "email_alerts" */
export type Email_Alerts_Aggregate_Fields = {
  __typename?: 'email_alerts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Email_Alerts_Max_Fields>;
  min?: Maybe<Email_Alerts_Min_Fields>;
};


/** aggregate fields of "email_alerts" */
export type Email_Alerts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Alerts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Email_Alerts_Append_Input = {
  params?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "email_alerts". All fields are combined with a logical 'AND'. */
export type Email_Alerts_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Alerts_Bool_Exp>>;
  _not?: InputMaybe<Email_Alerts_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Alerts_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<String_Comparison_Exp>;
  emailProvider?: InputMaybe<String_Comparison_Exp>;
  emailProviderCampaignId?: InputMaybe<String_Comparison_Exp>;
  emailProviderTemplateId?: InputMaybe<String_Comparison_Exp>;
  htmlContent?: InputMaybe<String_Comparison_Exp>;
  htmlUrl?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  params?: InputMaybe<Jsonb_Comparison_Exp>;
  templateName?: InputMaybe<String_Comparison_Exp>;
  timeId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_alerts" */
export const Email_Alerts_Constraint = {
  /** unique or primary key constraint on columns "id" */
  EmailAlertsPkey: 'email_alerts_pkey',
  /** unique or primary key constraint on columns "type", "date", "timeId" */
  EmailAlertsTypeDateTimeIdKey: 'email_alerts_type_date_timeId_key'
} as const;

export type Email_Alerts_Constraint = typeof Email_Alerts_Constraint[keyof typeof Email_Alerts_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Email_Alerts_Delete_At_Path_Input = {
  params?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Email_Alerts_Delete_Elem_Input = {
  params?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Email_Alerts_Delete_Key_Input = {
  params?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "email_alerts" */
export type Email_Alerts_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['String']>;
  emailProvider?: InputMaybe<Scalars['String']>;
  emailProviderCampaignId?: InputMaybe<Scalars['String']>;
  emailProviderTemplateId?: InputMaybe<Scalars['String']>;
  htmlContent?: InputMaybe<Scalars['String']>;
  htmlUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  params?: InputMaybe<Scalars['jsonb']>;
  templateName?: InputMaybe<Scalars['String']>;
  timeId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Email_Alerts_Max_Fields = {
  __typename?: 'email_alerts_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['String']>;
  emailProvider?: Maybe<Scalars['String']>;
  emailProviderCampaignId?: Maybe<Scalars['String']>;
  emailProviderTemplateId?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  htmlUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  templateName?: Maybe<Scalars['String']>;
  timeId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Email_Alerts_Min_Fields = {
  __typename?: 'email_alerts_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['String']>;
  emailProvider?: Maybe<Scalars['String']>;
  emailProviderCampaignId?: Maybe<Scalars['String']>;
  emailProviderTemplateId?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  htmlUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  templateName?: Maybe<Scalars['String']>;
  timeId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "email_alerts" */
export type Email_Alerts_Mutation_Response = {
  __typename?: 'email_alerts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Alerts>;
};

/** on_conflict condition type for table "email_alerts" */
export type Email_Alerts_On_Conflict = {
  constraint: Email_Alerts_Constraint;
  update_columns?: Array<Email_Alerts_Update_Column>;
  where?: InputMaybe<Email_Alerts_Bool_Exp>;
};

/** Ordering options when selecting data from "email_alerts". */
export type Email_Alerts_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  emailProvider?: InputMaybe<Order_By>;
  emailProviderCampaignId?: InputMaybe<Order_By>;
  emailProviderTemplateId?: InputMaybe<Order_By>;
  htmlContent?: InputMaybe<Order_By>;
  htmlUrl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  params?: InputMaybe<Order_By>;
  templateName?: InputMaybe<Order_By>;
  timeId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_alerts */
export type Email_Alerts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Email_Alerts_Prepend_Input = {
  params?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "email_alerts" */
export const Email_Alerts_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  EmailProvider: 'emailProvider',
  /** column name */
  EmailProviderCampaignId: 'emailProviderCampaignId',
  /** column name */
  EmailProviderTemplateId: 'emailProviderTemplateId',
  /** column name */
  HtmlContent: 'htmlContent',
  /** column name */
  HtmlUrl: 'htmlUrl',
  /** column name */
  Id: 'id',
  /** column name */
  Params: 'params',
  /** column name */
  TemplateName: 'templateName',
  /** column name */
  TimeId: 'timeId',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Email_Alerts_Select_Column = typeof Email_Alerts_Select_Column[keyof typeof Email_Alerts_Select_Column];
/** input type for updating data in table "email_alerts" */
export type Email_Alerts_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['String']>;
  emailProvider?: InputMaybe<Scalars['String']>;
  emailProviderCampaignId?: InputMaybe<Scalars['String']>;
  emailProviderTemplateId?: InputMaybe<Scalars['String']>;
  htmlContent?: InputMaybe<Scalars['String']>;
  htmlUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  params?: InputMaybe<Scalars['jsonb']>;
  templateName?: InputMaybe<Scalars['String']>;
  timeId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "email_alerts" */
export type Email_Alerts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Alerts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Alerts_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['String']>;
  emailProvider?: InputMaybe<Scalars['String']>;
  emailProviderCampaignId?: InputMaybe<Scalars['String']>;
  emailProviderTemplateId?: InputMaybe<Scalars['String']>;
  htmlContent?: InputMaybe<Scalars['String']>;
  htmlUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  params?: InputMaybe<Scalars['jsonb']>;
  templateName?: InputMaybe<Scalars['String']>;
  timeId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "email_alerts" */
export const Email_Alerts_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  EmailProvider: 'emailProvider',
  /** column name */
  EmailProviderCampaignId: 'emailProviderCampaignId',
  /** column name */
  EmailProviderTemplateId: 'emailProviderTemplateId',
  /** column name */
  HtmlContent: 'htmlContent',
  /** column name */
  HtmlUrl: 'htmlUrl',
  /** column name */
  Id: 'id',
  /** column name */
  Params: 'params',
  /** column name */
  TemplateName: 'templateName',
  /** column name */
  TimeId: 'timeId',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Email_Alerts_Update_Column = typeof Email_Alerts_Update_Column[keyof typeof Email_Alerts_Update_Column];
export type Email_Alerts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Email_Alerts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Email_Alerts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Email_Alerts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Email_Alerts_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Email_Alerts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Alerts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Alerts_Bool_Exp;
};

/** columns and relationships of "email_list" */
export type Email_List = {
  __typename?: 'email_list';
  createdAt: Scalars['timestamptz'];
  email: Scalars['String'];
  id: Scalars['uuid'];
  ip?: Maybe<Scalars['String']>;
  listId: Scalars['String'];
  provider: Scalars['String'];
  providerListId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "email_list" */
export type Email_List_Aggregate = {
  __typename?: 'email_list_aggregate';
  aggregate?: Maybe<Email_List_Aggregate_Fields>;
  nodes: Array<Email_List>;
};

/** aggregate fields of "email_list" */
export type Email_List_Aggregate_Fields = {
  __typename?: 'email_list_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Email_List_Max_Fields>;
  min?: Maybe<Email_List_Min_Fields>;
};


/** aggregate fields of "email_list" */
export type Email_List_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "email_list". All fields are combined with a logical 'AND'. */
export type Email_List_Bool_Exp = {
  _and?: InputMaybe<Array<Email_List_Bool_Exp>>;
  _not?: InputMaybe<Email_List_Bool_Exp>;
  _or?: InputMaybe<Array<Email_List_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip?: InputMaybe<String_Comparison_Exp>;
  listId?: InputMaybe<String_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  providerListId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_list" */
export const Email_List_Constraint = {
  /** unique or primary key constraint on columns "id" */
  EmailListPkey: 'email_list_pkey'
} as const;

export type Email_List_Constraint = typeof Email_List_Constraint[keyof typeof Email_List_Constraint];
/** input type for inserting data into table "email_list" */
export type Email_List_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  listId?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerListId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Email_List_Max_Fields = {
  __typename?: 'email_list_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerListId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Email_List_Min_Fields = {
  __typename?: 'email_list_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  listId?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  providerListId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "email_list" */
export type Email_List_Mutation_Response = {
  __typename?: 'email_list_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_List>;
};

/** on_conflict condition type for table "email_list" */
export type Email_List_On_Conflict = {
  constraint: Email_List_Constraint;
  update_columns?: Array<Email_List_Update_Column>;
  where?: InputMaybe<Email_List_Bool_Exp>;
};

/** Ordering options when selecting data from "email_list". */
export type Email_List_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip?: InputMaybe<Order_By>;
  listId?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  providerListId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_list */
export type Email_List_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "email_list" */
export const Email_List_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Email: 'email',
  /** column name */
  Id: 'id',
  /** column name */
  Ip: 'ip',
  /** column name */
  ListId: 'listId',
  /** column name */
  Provider: 'provider',
  /** column name */
  ProviderListId: 'providerListId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Email_List_Select_Column = typeof Email_List_Select_Column[keyof typeof Email_List_Select_Column];
/** input type for updating data in table "email_list" */
export type Email_List_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  listId?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerListId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "email_list" */
export type Email_List_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_List_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_List_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  listId?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  providerListId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "email_list" */
export const Email_List_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Email: 'email',
  /** column name */
  Id: 'id',
  /** column name */
  Ip: 'ip',
  /** column name */
  ListId: 'listId',
  /** column name */
  Provider: 'provider',
  /** column name */
  ProviderListId: 'providerListId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Email_List_Update_Column = typeof Email_List_Update_Column[keyof typeof Email_List_Update_Column];
export type Email_List_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_List_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_List_Bool_Exp;
};

/** columns and relationships of "equities_eod" */
export type Equities_Eod = {
  __typename?: 'equities_eod';
  barWindowStartAt: Scalars['timestamptz'];
  closePrice: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  highPrice: Scalars['numeric'];
  id: Scalars['uuid'];
  isSplitAdjusted: Scalars['Boolean'];
  lowPrice: Scalars['numeric'];
  openPrice: Scalars['numeric'];
  source: Scalars['String'];
  ticker: Scalars['String'];
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeDate: Scalars['date'];
  transactionCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['timestamptz'];
  volume: Scalars['bigint'];
  volumeWeightedAveragePrice?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "equities_eod" */
export type Equities_Eod_Aggregate = {
  __typename?: 'equities_eod_aggregate';
  aggregate?: Maybe<Equities_Eod_Aggregate_Fields>;
  nodes: Array<Equities_Eod>;
};

/** aggregate fields of "equities_eod" */
export type Equities_Eod_Aggregate_Fields = {
  __typename?: 'equities_eod_aggregate_fields';
  avg?: Maybe<Equities_Eod_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Equities_Eod_Max_Fields>;
  min?: Maybe<Equities_Eod_Min_Fields>;
  stddev?: Maybe<Equities_Eod_Stddev_Fields>;
  stddev_pop?: Maybe<Equities_Eod_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Equities_Eod_Stddev_Samp_Fields>;
  sum?: Maybe<Equities_Eod_Sum_Fields>;
  var_pop?: Maybe<Equities_Eod_Var_Pop_Fields>;
  var_samp?: Maybe<Equities_Eod_Var_Samp_Fields>;
  variance?: Maybe<Equities_Eod_Variance_Fields>;
};


/** aggregate fields of "equities_eod" */
export type Equities_Eod_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Equities_Eod_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Equities_Eod_Avg_Fields = {
  __typename?: 'equities_eod_avg_fields';
  closePrice?: Maybe<Scalars['Float']>;
  highPrice?: Maybe<Scalars['Float']>;
  lowPrice?: Maybe<Scalars['Float']>;
  openPrice?: Maybe<Scalars['Float']>;
  transactionCount?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  volumeWeightedAveragePrice?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "equities_eod". All fields are combined with a logical 'AND'. */
export type Equities_Eod_Bool_Exp = {
  _and?: InputMaybe<Array<Equities_Eod_Bool_Exp>>;
  _not?: InputMaybe<Equities_Eod_Bool_Exp>;
  _or?: InputMaybe<Array<Equities_Eod_Bool_Exp>>;
  barWindowStartAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  closePrice?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  highPrice?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isSplitAdjusted?: InputMaybe<Boolean_Comparison_Exp>;
  lowPrice?: InputMaybe<Numeric_Comparison_Exp>;
  openPrice?: InputMaybe<Numeric_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeDate?: InputMaybe<Date_Comparison_Exp>;
  transactionCount?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  volume?: InputMaybe<Bigint_Comparison_Exp>;
  volumeWeightedAveragePrice?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "equities_eod" */
export const Equities_Eod_Constraint = {
  /** unique or primary key constraint on columns "id" */
  EquitiesEodPkey: 'equities_eod_pkey',
  /** unique or primary key constraint on columns "ticker", "tradeDate" */
  EquitiesEodTickerTradeDateKey: 'equities_eod_ticker_tradeDate_key'
} as const;

export type Equities_Eod_Constraint = typeof Equities_Eod_Constraint[keyof typeof Equities_Eod_Constraint];
/** input type for incrementing numeric columns in table "equities_eod" */
export type Equities_Eod_Inc_Input = {
  closePrice?: InputMaybe<Scalars['numeric']>;
  highPrice?: InputMaybe<Scalars['numeric']>;
  lowPrice?: InputMaybe<Scalars['numeric']>;
  openPrice?: InputMaybe<Scalars['numeric']>;
  transactionCount?: InputMaybe<Scalars['Int']>;
  volume?: InputMaybe<Scalars['bigint']>;
  volumeWeightedAveragePrice?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "equities_eod" */
export type Equities_Eod_Insert_Input = {
  barWindowStartAt?: InputMaybe<Scalars['timestamptz']>;
  closePrice?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  highPrice?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isSplitAdjusted?: InputMaybe<Scalars['Boolean']>;
  lowPrice?: InputMaybe<Scalars['numeric']>;
  openPrice?: InputMaybe<Scalars['numeric']>;
  source?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  tradeDate?: InputMaybe<Scalars['date']>;
  transactionCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  volume?: InputMaybe<Scalars['bigint']>;
  volumeWeightedAveragePrice?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Equities_Eod_Max_Fields = {
  __typename?: 'equities_eod_max_fields';
  barWindowStartAt?: Maybe<Scalars['timestamptz']>;
  closePrice?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  highPrice?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lowPrice?: Maybe<Scalars['numeric']>;
  openPrice?: Maybe<Scalars['numeric']>;
  source?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  tradeDate?: Maybe<Scalars['date']>;
  transactionCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  volume?: Maybe<Scalars['bigint']>;
  volumeWeightedAveragePrice?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Equities_Eod_Min_Fields = {
  __typename?: 'equities_eod_min_fields';
  barWindowStartAt?: Maybe<Scalars['timestamptz']>;
  closePrice?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  highPrice?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lowPrice?: Maybe<Scalars['numeric']>;
  openPrice?: Maybe<Scalars['numeric']>;
  source?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  tradeDate?: Maybe<Scalars['date']>;
  transactionCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  volume?: Maybe<Scalars['bigint']>;
  volumeWeightedAveragePrice?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "equities_eod" */
export type Equities_Eod_Mutation_Response = {
  __typename?: 'equities_eod_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Equities_Eod>;
};

/** on_conflict condition type for table "equities_eod" */
export type Equities_Eod_On_Conflict = {
  constraint: Equities_Eod_Constraint;
  update_columns?: Array<Equities_Eod_Update_Column>;
  where?: InputMaybe<Equities_Eod_Bool_Exp>;
};

/** Ordering options when selecting data from "equities_eod". */
export type Equities_Eod_Order_By = {
  barWindowStartAt?: InputMaybe<Order_By>;
  closePrice?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  highPrice?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isSplitAdjusted?: InputMaybe<Order_By>;
  lowPrice?: InputMaybe<Order_By>;
  openPrice?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeDate?: InputMaybe<Order_By>;
  transactionCount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
  volumeWeightedAveragePrice?: InputMaybe<Order_By>;
};

/** primary key columns input for table: equities_eod */
export type Equities_Eod_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "equities_eod" */
export const Equities_Eod_Select_Column = {
  /** column name */
  BarWindowStartAt: 'barWindowStartAt',
  /** column name */
  ClosePrice: 'closePrice',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  HighPrice: 'highPrice',
  /** column name */
  Id: 'id',
  /** column name */
  IsSplitAdjusted: 'isSplitAdjusted',
  /** column name */
  LowPrice: 'lowPrice',
  /** column name */
  OpenPrice: 'openPrice',
  /** column name */
  Source: 'source',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeDate: 'tradeDate',
  /** column name */
  TransactionCount: 'transactionCount',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Volume: 'volume',
  /** column name */
  VolumeWeightedAveragePrice: 'volumeWeightedAveragePrice'
} as const;

export type Equities_Eod_Select_Column = typeof Equities_Eod_Select_Column[keyof typeof Equities_Eod_Select_Column];
/** input type for updating data in table "equities_eod" */
export type Equities_Eod_Set_Input = {
  barWindowStartAt?: InputMaybe<Scalars['timestamptz']>;
  closePrice?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  highPrice?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isSplitAdjusted?: InputMaybe<Scalars['Boolean']>;
  lowPrice?: InputMaybe<Scalars['numeric']>;
  openPrice?: InputMaybe<Scalars['numeric']>;
  source?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeDate?: InputMaybe<Scalars['date']>;
  transactionCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  volume?: InputMaybe<Scalars['bigint']>;
  volumeWeightedAveragePrice?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Equities_Eod_Stddev_Fields = {
  __typename?: 'equities_eod_stddev_fields';
  closePrice?: Maybe<Scalars['Float']>;
  highPrice?: Maybe<Scalars['Float']>;
  lowPrice?: Maybe<Scalars['Float']>;
  openPrice?: Maybe<Scalars['Float']>;
  transactionCount?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  volumeWeightedAveragePrice?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Equities_Eod_Stddev_Pop_Fields = {
  __typename?: 'equities_eod_stddev_pop_fields';
  closePrice?: Maybe<Scalars['Float']>;
  highPrice?: Maybe<Scalars['Float']>;
  lowPrice?: Maybe<Scalars['Float']>;
  openPrice?: Maybe<Scalars['Float']>;
  transactionCount?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  volumeWeightedAveragePrice?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Equities_Eod_Stddev_Samp_Fields = {
  __typename?: 'equities_eod_stddev_samp_fields';
  closePrice?: Maybe<Scalars['Float']>;
  highPrice?: Maybe<Scalars['Float']>;
  lowPrice?: Maybe<Scalars['Float']>;
  openPrice?: Maybe<Scalars['Float']>;
  transactionCount?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  volumeWeightedAveragePrice?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "equities_eod" */
export type Equities_Eod_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Equities_Eod_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Equities_Eod_Stream_Cursor_Value_Input = {
  barWindowStartAt?: InputMaybe<Scalars['timestamptz']>;
  closePrice?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  highPrice?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isSplitAdjusted?: InputMaybe<Scalars['Boolean']>;
  lowPrice?: InputMaybe<Scalars['numeric']>;
  openPrice?: InputMaybe<Scalars['numeric']>;
  source?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeDate?: InputMaybe<Scalars['date']>;
  transactionCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  volume?: InputMaybe<Scalars['bigint']>;
  volumeWeightedAveragePrice?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Equities_Eod_Sum_Fields = {
  __typename?: 'equities_eod_sum_fields';
  closePrice?: Maybe<Scalars['numeric']>;
  highPrice?: Maybe<Scalars['numeric']>;
  lowPrice?: Maybe<Scalars['numeric']>;
  openPrice?: Maybe<Scalars['numeric']>;
  transactionCount?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['bigint']>;
  volumeWeightedAveragePrice?: Maybe<Scalars['numeric']>;
};

/** update columns of table "equities_eod" */
export const Equities_Eod_Update_Column = {
  /** column name */
  BarWindowStartAt: 'barWindowStartAt',
  /** column name */
  ClosePrice: 'closePrice',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  HighPrice: 'highPrice',
  /** column name */
  Id: 'id',
  /** column name */
  IsSplitAdjusted: 'isSplitAdjusted',
  /** column name */
  LowPrice: 'lowPrice',
  /** column name */
  OpenPrice: 'openPrice',
  /** column name */
  Source: 'source',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeDate: 'tradeDate',
  /** column name */
  TransactionCount: 'transactionCount',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Volume: 'volume',
  /** column name */
  VolumeWeightedAveragePrice: 'volumeWeightedAveragePrice'
} as const;

export type Equities_Eod_Update_Column = typeof Equities_Eod_Update_Column[keyof typeof Equities_Eod_Update_Column];
export type Equities_Eod_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Equities_Eod_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Equities_Eod_Set_Input>;
  /** filter the rows which have to be updated */
  where: Equities_Eod_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Equities_Eod_Var_Pop_Fields = {
  __typename?: 'equities_eod_var_pop_fields';
  closePrice?: Maybe<Scalars['Float']>;
  highPrice?: Maybe<Scalars['Float']>;
  lowPrice?: Maybe<Scalars['Float']>;
  openPrice?: Maybe<Scalars['Float']>;
  transactionCount?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  volumeWeightedAveragePrice?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Equities_Eod_Var_Samp_Fields = {
  __typename?: 'equities_eod_var_samp_fields';
  closePrice?: Maybe<Scalars['Float']>;
  highPrice?: Maybe<Scalars['Float']>;
  lowPrice?: Maybe<Scalars['Float']>;
  openPrice?: Maybe<Scalars['Float']>;
  transactionCount?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  volumeWeightedAveragePrice?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Equities_Eod_Variance_Fields = {
  __typename?: 'equities_eod_variance_fields';
  closePrice?: Maybe<Scalars['Float']>;
  highPrice?: Maybe<Scalars['Float']>;
  lowPrice?: Maybe<Scalars['Float']>;
  openPrice?: Maybe<Scalars['Float']>;
  transactionCount?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  volumeWeightedAveragePrice?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "equity_pool_prints" */
export type Equity_Pool_Prints = {
  __typename?: 'equity_pool_prints';
  amount: Scalars['numeric'];
  ask: Scalars['numeric'];
  askExchangeId: Scalars['Int'];
  askSize: Scalars['Int'];
  avgPrice: Scalars['numeric'];
  avgVolume: Scalars['numeric'];
  bid: Scalars['numeric'];
  bidSize: Scalars['Int'];
  bigExchangeId: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  dailyPercentChange: Scalars['numeric'];
  dailyPriceChange: Scalars['numeric'];
  date: Scalars['date'];
  dayVolume: Scalars['numeric'];
  eventType: Scalars['String'];
  exchangeId: Scalars['Int'];
  externalTradeId: Scalars['String'];
  high: Scalars['numeric'];
  id: Scalars['uuid'];
  isEtf: Scalars['Boolean'];
  isOpenGreaterThanPrevClose: Scalars['Boolean'];
  isOutsideDailyRange: Scalars['Boolean'];
  isPriceGreaterThanDailyAverage: Scalars['Boolean'];
  isPriceGreaterThanOpen: Scalars['Boolean'];
  isPriceGreaterThanPrevClose: Scalars['Boolean'];
  isSignatureEtfTicker: Scalars['Boolean'];
  isSignatureVolume: Scalars['Boolean'];
  isWithinDailyPriceRange: Scalars['Boolean'];
  lastTradePrice: Scalars['numeric'];
  low: Scalars['numeric'];
  marketCap: Scalars['numeric'];
  open: Scalars['numeric'];
  percentAboveAsk: Scalars['numeric'];
  percentBelowBid: Scalars['numeric'];
  percentOfAvgVolume: Scalars['numeric'];
  percentOfDailyVolume: Scalars['numeric'];
  percentOfMarketCap: Scalars['numeric'];
  prevClose: Scalars['numeric'];
  prevHigh: Scalars['numeric'];
  prevLow: Scalars['numeric'];
  price: Scalars['numeric'];
  quoteObject: Scalars['jsonb'];
  realtimePrice: Scalars['numeric'];
  reportedPrice: Scalars['numeric'];
  size: Scalars['Int'];
  tapeId: Scalars['Int'];
  ticker: Scalars['String'];
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tickerDetailsObject?: Maybe<Scalars['jsonb']>;
  timestamp: Scalars['bigint'];
  tradeConditions: Scalars['jsonb'];
  tradeReportingFacility: Scalars['Int'];
  tradeSide: Scalars['String'];
  tradeWebSocketObject: Scalars['jsonb'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "equity_pool_prints" */
export type Equity_Pool_PrintsQuoteObjectArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "equity_pool_prints" */
export type Equity_Pool_PrintsTickerDetailsObjectArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "equity_pool_prints" */
export type Equity_Pool_PrintsTradeConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "equity_pool_prints" */
export type Equity_Pool_PrintsTradeWebSocketObjectArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "equity_pool_prints" */
export type Equity_Pool_Prints_Aggregate = {
  __typename?: 'equity_pool_prints_aggregate';
  aggregate?: Maybe<Equity_Pool_Prints_Aggregate_Fields>;
  nodes: Array<Equity_Pool_Prints>;
};

/** aggregate fields of "equity_pool_prints" */
export type Equity_Pool_Prints_Aggregate_Fields = {
  __typename?: 'equity_pool_prints_aggregate_fields';
  avg?: Maybe<Equity_Pool_Prints_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Equity_Pool_Prints_Max_Fields>;
  min?: Maybe<Equity_Pool_Prints_Min_Fields>;
  stddev?: Maybe<Equity_Pool_Prints_Stddev_Fields>;
  stddev_pop?: Maybe<Equity_Pool_Prints_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Equity_Pool_Prints_Stddev_Samp_Fields>;
  sum?: Maybe<Equity_Pool_Prints_Sum_Fields>;
  var_pop?: Maybe<Equity_Pool_Prints_Var_Pop_Fields>;
  var_samp?: Maybe<Equity_Pool_Prints_Var_Samp_Fields>;
  variance?: Maybe<Equity_Pool_Prints_Variance_Fields>;
};


/** aggregate fields of "equity_pool_prints" */
export type Equity_Pool_Prints_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Equity_Pool_Prints_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Equity_Pool_Prints_Append_Input = {
  quoteObject?: InputMaybe<Scalars['jsonb']>;
  tickerDetailsObject?: InputMaybe<Scalars['jsonb']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeWebSocketObject?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Equity_Pool_Prints_Avg_Fields = {
  __typename?: 'equity_pool_prints_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askExchangeId?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  bigExchangeId?: Maybe<Scalars['Float']>;
  dailyPercentChange?: Maybe<Scalars['Float']>;
  dailyPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfDailyVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  reportedPrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  tradeReportingFacility?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "equity_pool_prints". All fields are combined with a logical 'AND'. */
export type Equity_Pool_Prints_Bool_Exp = {
  _and?: InputMaybe<Array<Equity_Pool_Prints_Bool_Exp>>;
  _not?: InputMaybe<Equity_Pool_Prints_Bool_Exp>;
  _or?: InputMaybe<Array<Equity_Pool_Prints_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  ask?: InputMaybe<Numeric_Comparison_Exp>;
  askExchangeId?: InputMaybe<Int_Comparison_Exp>;
  askSize?: InputMaybe<Int_Comparison_Exp>;
  avgPrice?: InputMaybe<Numeric_Comparison_Exp>;
  avgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  bid?: InputMaybe<Numeric_Comparison_Exp>;
  bidSize?: InputMaybe<Int_Comparison_Exp>;
  bigExchangeId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dailyPercentChange?: InputMaybe<Numeric_Comparison_Exp>;
  dailyPriceChange?: InputMaybe<Numeric_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  dayVolume?: InputMaybe<Numeric_Comparison_Exp>;
  eventType?: InputMaybe<String_Comparison_Exp>;
  exchangeId?: InputMaybe<Int_Comparison_Exp>;
  externalTradeId?: InputMaybe<String_Comparison_Exp>;
  high?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isEtf?: InputMaybe<Boolean_Comparison_Exp>;
  isOpenGreaterThanPrevClose?: InputMaybe<Boolean_Comparison_Exp>;
  isOutsideDailyRange?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanOpen?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanPrevClose?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureEtfTicker?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureVolume?: InputMaybe<Boolean_Comparison_Exp>;
  isWithinDailyPriceRange?: InputMaybe<Boolean_Comparison_Exp>;
  lastTradePrice?: InputMaybe<Numeric_Comparison_Exp>;
  low?: InputMaybe<Numeric_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  open?: InputMaybe<Numeric_Comparison_Exp>;
  percentAboveAsk?: InputMaybe<Numeric_Comparison_Exp>;
  percentBelowBid?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfAvgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfDailyVolume?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfMarketCap?: InputMaybe<Numeric_Comparison_Exp>;
  prevClose?: InputMaybe<Numeric_Comparison_Exp>;
  prevHigh?: InputMaybe<Numeric_Comparison_Exp>;
  prevLow?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  quoteObject?: InputMaybe<Jsonb_Comparison_Exp>;
  realtimePrice?: InputMaybe<Numeric_Comparison_Exp>;
  reportedPrice?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  tapeId?: InputMaybe<Int_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tickerDetailsObject?: InputMaybe<Jsonb_Comparison_Exp>;
  timestamp?: InputMaybe<Bigint_Comparison_Exp>;
  tradeConditions?: InputMaybe<Jsonb_Comparison_Exp>;
  tradeReportingFacility?: InputMaybe<Int_Comparison_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  tradeWebSocketObject?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "equity_pool_prints" */
export const Equity_Pool_Prints_Constraint = {
  /** unique or primary key constraint on columns "id" */
  EquityPoolPrintsPkey: 'equity_pool_prints_pkey'
} as const;

export type Equity_Pool_Prints_Constraint = typeof Equity_Pool_Prints_Constraint[keyof typeof Equity_Pool_Prints_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Equity_Pool_Prints_Delete_At_Path_Input = {
  quoteObject?: InputMaybe<Array<Scalars['String']>>;
  tickerDetailsObject?: InputMaybe<Array<Scalars['String']>>;
  tradeConditions?: InputMaybe<Array<Scalars['String']>>;
  tradeWebSocketObject?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Equity_Pool_Prints_Delete_Elem_Input = {
  quoteObject?: InputMaybe<Scalars['Int']>;
  tickerDetailsObject?: InputMaybe<Scalars['Int']>;
  tradeConditions?: InputMaybe<Scalars['Int']>;
  tradeWebSocketObject?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Equity_Pool_Prints_Delete_Key_Input = {
  quoteObject?: InputMaybe<Scalars['String']>;
  tickerDetailsObject?: InputMaybe<Scalars['String']>;
  tradeConditions?: InputMaybe<Scalars['String']>;
  tradeWebSocketObject?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "equity_pool_prints" */
export type Equity_Pool_Prints_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askExchangeId?: InputMaybe<Scalars['Int']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  bigExchangeId?: InputMaybe<Scalars['Int']>;
  dailyPercentChange?: InputMaybe<Scalars['numeric']>;
  dailyPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  high?: InputMaybe<Scalars['numeric']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfDailyVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  reportedPrice?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  tradeReportingFacility?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "equity_pool_prints" */
export type Equity_Pool_Prints_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askExchangeId?: InputMaybe<Scalars['Int']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  bigExchangeId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dailyPercentChange?: InputMaybe<Scalars['numeric']>;
  dailyPriceChange?: InputMaybe<Scalars['numeric']>;
  date?: InputMaybe<Scalars['date']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  eventType?: InputMaybe<Scalars['String']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOpenGreaterThanPrevClose?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanPrevClose?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  isWithinDailyPriceRange?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfDailyVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  quoteObject?: InputMaybe<Scalars['jsonb']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  reportedPrice?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  tickerDetailsObject?: InputMaybe<Scalars['jsonb']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeReportingFacility?: InputMaybe<Scalars['Int']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  tradeWebSocketObject?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Equity_Pool_Prints_Max_Fields = {
  __typename?: 'equity_pool_prints_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askExchangeId?: Maybe<Scalars['Int']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  bigExchangeId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dailyPercentChange?: Maybe<Scalars['numeric']>;
  dailyPriceChange?: Maybe<Scalars['numeric']>;
  date?: Maybe<Scalars['date']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  eventType?: Maybe<Scalars['String']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfDailyVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  reportedPrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  tradeReportingFacility?: Maybe<Scalars['Int']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Equity_Pool_Prints_Min_Fields = {
  __typename?: 'equity_pool_prints_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askExchangeId?: Maybe<Scalars['Int']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  bigExchangeId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dailyPercentChange?: Maybe<Scalars['numeric']>;
  dailyPriceChange?: Maybe<Scalars['numeric']>;
  date?: Maybe<Scalars['date']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  eventType?: Maybe<Scalars['String']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfDailyVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  reportedPrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  tradeReportingFacility?: Maybe<Scalars['Int']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "equity_pool_prints" */
export type Equity_Pool_Prints_Mutation_Response = {
  __typename?: 'equity_pool_prints_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Equity_Pool_Prints>;
};

/** on_conflict condition type for table "equity_pool_prints" */
export type Equity_Pool_Prints_On_Conflict = {
  constraint: Equity_Pool_Prints_Constraint;
  update_columns?: Array<Equity_Pool_Prints_Update_Column>;
  where?: InputMaybe<Equity_Pool_Prints_Bool_Exp>;
};

/** Ordering options when selecting data from "equity_pool_prints". */
export type Equity_Pool_Prints_Order_By = {
  amount?: InputMaybe<Order_By>;
  ask?: InputMaybe<Order_By>;
  askExchangeId?: InputMaybe<Order_By>;
  askSize?: InputMaybe<Order_By>;
  avgPrice?: InputMaybe<Order_By>;
  avgVolume?: InputMaybe<Order_By>;
  bid?: InputMaybe<Order_By>;
  bidSize?: InputMaybe<Order_By>;
  bigExchangeId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dailyPercentChange?: InputMaybe<Order_By>;
  dailyPriceChange?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  dayVolume?: InputMaybe<Order_By>;
  eventType?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  externalTradeId?: InputMaybe<Order_By>;
  high?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isEtf?: InputMaybe<Order_By>;
  isOpenGreaterThanPrevClose?: InputMaybe<Order_By>;
  isOutsideDailyRange?: InputMaybe<Order_By>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Order_By>;
  isPriceGreaterThanOpen?: InputMaybe<Order_By>;
  isPriceGreaterThanPrevClose?: InputMaybe<Order_By>;
  isSignatureEtfTicker?: InputMaybe<Order_By>;
  isSignatureVolume?: InputMaybe<Order_By>;
  isWithinDailyPriceRange?: InputMaybe<Order_By>;
  lastTradePrice?: InputMaybe<Order_By>;
  low?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  open?: InputMaybe<Order_By>;
  percentAboveAsk?: InputMaybe<Order_By>;
  percentBelowBid?: InputMaybe<Order_By>;
  percentOfAvgVolume?: InputMaybe<Order_By>;
  percentOfDailyVolume?: InputMaybe<Order_By>;
  percentOfMarketCap?: InputMaybe<Order_By>;
  prevClose?: InputMaybe<Order_By>;
  prevHigh?: InputMaybe<Order_By>;
  prevLow?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quoteObject?: InputMaybe<Order_By>;
  realtimePrice?: InputMaybe<Order_By>;
  reportedPrice?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  tapeId?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tickerDetailsObject?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  tradeConditions?: InputMaybe<Order_By>;
  tradeReportingFacility?: InputMaybe<Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  tradeWebSocketObject?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: equity_pool_prints */
export type Equity_Pool_Prints_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Equity_Pool_Prints_Prepend_Input = {
  quoteObject?: InputMaybe<Scalars['jsonb']>;
  tickerDetailsObject?: InputMaybe<Scalars['jsonb']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeWebSocketObject?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "equity_pool_prints" */
export const Equity_Pool_Prints_Select_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Ask: 'ask',
  /** column name */
  AskExchangeId: 'askExchangeId',
  /** column name */
  AskSize: 'askSize',
  /** column name */
  AvgPrice: 'avgPrice',
  /** column name */
  AvgVolume: 'avgVolume',
  /** column name */
  Bid: 'bid',
  /** column name */
  BidSize: 'bidSize',
  /** column name */
  BigExchangeId: 'bigExchangeId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DailyPercentChange: 'dailyPercentChange',
  /** column name */
  DailyPriceChange: 'dailyPriceChange',
  /** column name */
  Date: 'date',
  /** column name */
  DayVolume: 'dayVolume',
  /** column name */
  EventType: 'eventType',
  /** column name */
  ExchangeId: 'exchangeId',
  /** column name */
  ExternalTradeId: 'externalTradeId',
  /** column name */
  High: 'high',
  /** column name */
  Id: 'id',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsOpenGreaterThanPrevClose: 'isOpenGreaterThanPrevClose',
  /** column name */
  IsOutsideDailyRange: 'isOutsideDailyRange',
  /** column name */
  IsPriceGreaterThanDailyAverage: 'isPriceGreaterThanDailyAverage',
  /** column name */
  IsPriceGreaterThanOpen: 'isPriceGreaterThanOpen',
  /** column name */
  IsPriceGreaterThanPrevClose: 'isPriceGreaterThanPrevClose',
  /** column name */
  IsSignatureEtfTicker: 'isSignatureEtfTicker',
  /** column name */
  IsSignatureVolume: 'isSignatureVolume',
  /** column name */
  IsWithinDailyPriceRange: 'isWithinDailyPriceRange',
  /** column name */
  LastTradePrice: 'lastTradePrice',
  /** column name */
  Low: 'low',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Open: 'open',
  /** column name */
  PercentAboveAsk: 'percentAboveAsk',
  /** column name */
  PercentBelowBid: 'percentBelowBid',
  /** column name */
  PercentOfAvgVolume: 'percentOfAvgVolume',
  /** column name */
  PercentOfDailyVolume: 'percentOfDailyVolume',
  /** column name */
  PercentOfMarketCap: 'percentOfMarketCap',
  /** column name */
  PrevClose: 'prevClose',
  /** column name */
  PrevHigh: 'prevHigh',
  /** column name */
  PrevLow: 'prevLow',
  /** column name */
  Price: 'price',
  /** column name */
  QuoteObject: 'quoteObject',
  /** column name */
  RealtimePrice: 'realtimePrice',
  /** column name */
  ReportedPrice: 'reportedPrice',
  /** column name */
  Size: 'size',
  /** column name */
  TapeId: 'tapeId',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TickerDetailsObject: 'tickerDetailsObject',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TradeConditions: 'tradeConditions',
  /** column name */
  TradeReportingFacility: 'tradeReportingFacility',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  TradeWebSocketObject: 'tradeWebSocketObject',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Equity_Pool_Prints_Select_Column = typeof Equity_Pool_Prints_Select_Column[keyof typeof Equity_Pool_Prints_Select_Column];
/** input type for updating data in table "equity_pool_prints" */
export type Equity_Pool_Prints_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askExchangeId?: InputMaybe<Scalars['Int']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  bigExchangeId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dailyPercentChange?: InputMaybe<Scalars['numeric']>;
  dailyPriceChange?: InputMaybe<Scalars['numeric']>;
  date?: InputMaybe<Scalars['date']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  eventType?: InputMaybe<Scalars['String']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOpenGreaterThanPrevClose?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanPrevClose?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  isWithinDailyPriceRange?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfDailyVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  quoteObject?: InputMaybe<Scalars['jsonb']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  reportedPrice?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetailsObject?: InputMaybe<Scalars['jsonb']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeReportingFacility?: InputMaybe<Scalars['Int']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  tradeWebSocketObject?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Equity_Pool_Prints_Stddev_Fields = {
  __typename?: 'equity_pool_prints_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askExchangeId?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  bigExchangeId?: Maybe<Scalars['Float']>;
  dailyPercentChange?: Maybe<Scalars['Float']>;
  dailyPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfDailyVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  reportedPrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  tradeReportingFacility?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Equity_Pool_Prints_Stddev_Pop_Fields = {
  __typename?: 'equity_pool_prints_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askExchangeId?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  bigExchangeId?: Maybe<Scalars['Float']>;
  dailyPercentChange?: Maybe<Scalars['Float']>;
  dailyPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfDailyVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  reportedPrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  tradeReportingFacility?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Equity_Pool_Prints_Stddev_Samp_Fields = {
  __typename?: 'equity_pool_prints_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askExchangeId?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  bigExchangeId?: Maybe<Scalars['Float']>;
  dailyPercentChange?: Maybe<Scalars['Float']>;
  dailyPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfDailyVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  reportedPrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  tradeReportingFacility?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "equity_pool_prints" */
export type Equity_Pool_Prints_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Equity_Pool_Prints_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Equity_Pool_Prints_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askExchangeId?: InputMaybe<Scalars['Int']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  bigExchangeId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dailyPercentChange?: InputMaybe<Scalars['numeric']>;
  dailyPriceChange?: InputMaybe<Scalars['numeric']>;
  date?: InputMaybe<Scalars['date']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  eventType?: InputMaybe<Scalars['String']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOpenGreaterThanPrevClose?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanPrevClose?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  isWithinDailyPriceRange?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfDailyVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  quoteObject?: InputMaybe<Scalars['jsonb']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  reportedPrice?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetailsObject?: InputMaybe<Scalars['jsonb']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeReportingFacility?: InputMaybe<Scalars['Int']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  tradeWebSocketObject?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Equity_Pool_Prints_Sum_Fields = {
  __typename?: 'equity_pool_prints_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askExchangeId?: Maybe<Scalars['Int']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  bigExchangeId?: Maybe<Scalars['Int']>;
  dailyPercentChange?: Maybe<Scalars['numeric']>;
  dailyPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  high?: Maybe<Scalars['numeric']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfDailyVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  reportedPrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['bigint']>;
  tradeReportingFacility?: Maybe<Scalars['Int']>;
};

/** update columns of table "equity_pool_prints" */
export const Equity_Pool_Prints_Update_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Ask: 'ask',
  /** column name */
  AskExchangeId: 'askExchangeId',
  /** column name */
  AskSize: 'askSize',
  /** column name */
  AvgPrice: 'avgPrice',
  /** column name */
  AvgVolume: 'avgVolume',
  /** column name */
  Bid: 'bid',
  /** column name */
  BidSize: 'bidSize',
  /** column name */
  BigExchangeId: 'bigExchangeId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DailyPercentChange: 'dailyPercentChange',
  /** column name */
  DailyPriceChange: 'dailyPriceChange',
  /** column name */
  Date: 'date',
  /** column name */
  DayVolume: 'dayVolume',
  /** column name */
  EventType: 'eventType',
  /** column name */
  ExchangeId: 'exchangeId',
  /** column name */
  ExternalTradeId: 'externalTradeId',
  /** column name */
  High: 'high',
  /** column name */
  Id: 'id',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsOpenGreaterThanPrevClose: 'isOpenGreaterThanPrevClose',
  /** column name */
  IsOutsideDailyRange: 'isOutsideDailyRange',
  /** column name */
  IsPriceGreaterThanDailyAverage: 'isPriceGreaterThanDailyAverage',
  /** column name */
  IsPriceGreaterThanOpen: 'isPriceGreaterThanOpen',
  /** column name */
  IsPriceGreaterThanPrevClose: 'isPriceGreaterThanPrevClose',
  /** column name */
  IsSignatureEtfTicker: 'isSignatureEtfTicker',
  /** column name */
  IsSignatureVolume: 'isSignatureVolume',
  /** column name */
  IsWithinDailyPriceRange: 'isWithinDailyPriceRange',
  /** column name */
  LastTradePrice: 'lastTradePrice',
  /** column name */
  Low: 'low',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Open: 'open',
  /** column name */
  PercentAboveAsk: 'percentAboveAsk',
  /** column name */
  PercentBelowBid: 'percentBelowBid',
  /** column name */
  PercentOfAvgVolume: 'percentOfAvgVolume',
  /** column name */
  PercentOfDailyVolume: 'percentOfDailyVolume',
  /** column name */
  PercentOfMarketCap: 'percentOfMarketCap',
  /** column name */
  PrevClose: 'prevClose',
  /** column name */
  PrevHigh: 'prevHigh',
  /** column name */
  PrevLow: 'prevLow',
  /** column name */
  Price: 'price',
  /** column name */
  QuoteObject: 'quoteObject',
  /** column name */
  RealtimePrice: 'realtimePrice',
  /** column name */
  ReportedPrice: 'reportedPrice',
  /** column name */
  Size: 'size',
  /** column name */
  TapeId: 'tapeId',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TickerDetailsObject: 'tickerDetailsObject',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TradeConditions: 'tradeConditions',
  /** column name */
  TradeReportingFacility: 'tradeReportingFacility',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  TradeWebSocketObject: 'tradeWebSocketObject',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Equity_Pool_Prints_Update_Column = typeof Equity_Pool_Prints_Update_Column[keyof typeof Equity_Pool_Prints_Update_Column];
export type Equity_Pool_Prints_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Equity_Pool_Prints_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Equity_Pool_Prints_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Equity_Pool_Prints_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Equity_Pool_Prints_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Equity_Pool_Prints_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Equity_Pool_Prints_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Equity_Pool_Prints_Set_Input>;
  /** filter the rows which have to be updated */
  where: Equity_Pool_Prints_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Equity_Pool_Prints_Var_Pop_Fields = {
  __typename?: 'equity_pool_prints_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askExchangeId?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  bigExchangeId?: Maybe<Scalars['Float']>;
  dailyPercentChange?: Maybe<Scalars['Float']>;
  dailyPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfDailyVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  reportedPrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  tradeReportingFacility?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Equity_Pool_Prints_Var_Samp_Fields = {
  __typename?: 'equity_pool_prints_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askExchangeId?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  bigExchangeId?: Maybe<Scalars['Float']>;
  dailyPercentChange?: Maybe<Scalars['Float']>;
  dailyPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfDailyVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  reportedPrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  tradeReportingFacility?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Equity_Pool_Prints_Variance_Fields = {
  __typename?: 'equity_pool_prints_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askExchangeId?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  bigExchangeId?: Maybe<Scalars['Float']>;
  dailyPercentChange?: Maybe<Scalars['Float']>;
  dailyPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfDailyVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  reportedPrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  tradeReportingFacility?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "equity_print_feed_baseline" */
export type Equity_Print_Feed_Baseline = {
  __typename?: 'equity_print_feed_baseline';
  amount: Scalars['numeric'];
  ask: Scalars['numeric'];
  askSize: Scalars['Int'];
  avgPrice: Scalars['numeric'];
  avgVolume: Scalars['numeric'];
  bid: Scalars['numeric'];
  bidSize: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  date: Scalars['date'];
  dayOverDayPercentChange: Scalars['numeric'];
  dayOverDayPriceChange: Scalars['numeric'];
  dayVolume: Scalars['numeric'];
  exchangeId: Scalars['Int'];
  externalTradeId: Scalars['String'];
  high: Scalars['numeric'];
  id: Scalars['uuid'];
  isEtf: Scalars['Boolean'];
  isOutsideDailyRange: Scalars['Boolean'];
  isPriceGreaterThanDailyAverage: Scalars['Boolean'];
  isPriceGreaterThanOpen: Scalars['Boolean'];
  isSignatureEtfTicker: Scalars['Boolean'];
  isSignatureVolume: Scalars['Boolean'];
  lastTradePrice: Scalars['numeric'];
  low: Scalars['numeric'];
  marketCap: Scalars['numeric'];
  open: Scalars['numeric'];
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose: Scalars['numeric'];
  prevHigh: Scalars['numeric'];
  prevLow: Scalars['numeric'];
  price: Scalars['numeric'];
  publication_xid?: Maybe<Scalars['xid8']>;
  realtimePrice: Scalars['numeric'];
  sequenceNumber?: Maybe<Scalars['bigint']>;
  size: Scalars['Int'];
  sourceKey?: Maybe<Scalars['String']>;
  tapeId: Scalars['Int'];
  ticker: Scalars['String'];
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  timestamp: Scalars['bigint'];
  timestampIso: Scalars['timestamptz'];
  tradeConditions: Scalars['jsonb'];
  tradeSide: Scalars['String'];
  trfId?: Maybe<Scalars['Int']>;
  trfTimestamp?: Maybe<Scalars['bigint']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "equity_print_feed_baseline" */
export type Equity_Print_Feed_BaselineTradeConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "equity_print_feed_baseline" */
export type Equity_Print_Feed_Baseline_Aggregate = {
  __typename?: 'equity_print_feed_baseline_aggregate';
  aggregate?: Maybe<Equity_Print_Feed_Baseline_Aggregate_Fields>;
  nodes: Array<Equity_Print_Feed_Baseline>;
};

/** aggregate fields of "equity_print_feed_baseline" */
export type Equity_Print_Feed_Baseline_Aggregate_Fields = {
  __typename?: 'equity_print_feed_baseline_aggregate_fields';
  avg?: Maybe<Equity_Print_Feed_Baseline_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Equity_Print_Feed_Baseline_Max_Fields>;
  min?: Maybe<Equity_Print_Feed_Baseline_Min_Fields>;
  stddev?: Maybe<Equity_Print_Feed_Baseline_Stddev_Fields>;
  stddev_pop?: Maybe<Equity_Print_Feed_Baseline_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Equity_Print_Feed_Baseline_Stddev_Samp_Fields>;
  sum?: Maybe<Equity_Print_Feed_Baseline_Sum_Fields>;
  var_pop?: Maybe<Equity_Print_Feed_Baseline_Var_Pop_Fields>;
  var_samp?: Maybe<Equity_Print_Feed_Baseline_Var_Samp_Fields>;
  variance?: Maybe<Equity_Print_Feed_Baseline_Variance_Fields>;
};


/** aggregate fields of "equity_print_feed_baseline" */
export type Equity_Print_Feed_Baseline_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Equity_Print_Feed_Baseline_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Equity_Print_Feed_Baseline_Append_Input = {
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Equity_Print_Feed_Baseline_Avg_Fields = {
  __typename?: 'equity_print_feed_baseline_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "equity_print_feed_baseline". All fields are combined with a logical 'AND'. */
export type Equity_Print_Feed_Baseline_Bool_Exp = {
  _and?: InputMaybe<Array<Equity_Print_Feed_Baseline_Bool_Exp>>;
  _not?: InputMaybe<Equity_Print_Feed_Baseline_Bool_Exp>;
  _or?: InputMaybe<Array<Equity_Print_Feed_Baseline_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  ask?: InputMaybe<Numeric_Comparison_Exp>;
  askSize?: InputMaybe<Int_Comparison_Exp>;
  avgPrice?: InputMaybe<Numeric_Comparison_Exp>;
  avgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  bid?: InputMaybe<Numeric_Comparison_Exp>;
  bidSize?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  dayOverDayPercentChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayOverDayPriceChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayVolume?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeId?: InputMaybe<Int_Comparison_Exp>;
  externalTradeId?: InputMaybe<String_Comparison_Exp>;
  high?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isEtf?: InputMaybe<Boolean_Comparison_Exp>;
  isOutsideDailyRange?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanOpen?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureEtfTicker?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureVolume?: InputMaybe<Boolean_Comparison_Exp>;
  lastTradePrice?: InputMaybe<Numeric_Comparison_Exp>;
  low?: InputMaybe<Numeric_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  open?: InputMaybe<Numeric_Comparison_Exp>;
  percentAboveAsk?: InputMaybe<Numeric_Comparison_Exp>;
  percentBelowBid?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfAvgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfMarketCap?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfTodaysVolume?: InputMaybe<Numeric_Comparison_Exp>;
  prevClose?: InputMaybe<Numeric_Comparison_Exp>;
  prevHigh?: InputMaybe<Numeric_Comparison_Exp>;
  prevLow?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  publication_xid?: InputMaybe<Xid8_Comparison_Exp>;
  realtimePrice?: InputMaybe<Numeric_Comparison_Exp>;
  sequenceNumber?: InputMaybe<Bigint_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  sourceKey?: InputMaybe<String_Comparison_Exp>;
  tapeId?: InputMaybe<Int_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  timestamp?: InputMaybe<Bigint_Comparison_Exp>;
  timestampIso?: InputMaybe<Timestamptz_Comparison_Exp>;
  tradeConditions?: InputMaybe<Jsonb_Comparison_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  trfId?: InputMaybe<Int_Comparison_Exp>;
  trfTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "equity_print_feed_baseline" */
export const Equity_Print_Feed_Baseline_Constraint = {
  /** unique or primary key constraint on columns "id" */
  EquityPrintFeedBaselinePkey: 'equity_print_feed_baseline_pkey',
  /** unique or primary key constraint on columns "sourceKey" */
  EquityPrintFeedBaselineSourceKeyKey: 'equity_print_feed_baseline_sourceKey_key'
} as const;

export type Equity_Print_Feed_Baseline_Constraint = typeof Equity_Print_Feed_Baseline_Constraint[keyof typeof Equity_Print_Feed_Baseline_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Equity_Print_Feed_Baseline_Delete_At_Path_Input = {
  tradeConditions?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Equity_Print_Feed_Baseline_Delete_Elem_Input = {
  tradeConditions?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Equity_Print_Feed_Baseline_Delete_Key_Input = {
  tradeConditions?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "equity_print_feed_baseline" */
export type Equity_Print_Feed_Baseline_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  high?: InputMaybe<Scalars['numeric']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  sequenceNumber?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['Int']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  trfId?: InputMaybe<Scalars['Int']>;
  trfTimestamp?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "equity_print_feed_baseline" */
export type Equity_Print_Feed_Baseline_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  publication_xid?: InputMaybe<Scalars['xid8']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  sequenceNumber?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['Int']>;
  sourceKey?: InputMaybe<Scalars['String']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  timestampIso?: InputMaybe<Scalars['timestamptz']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  trfId?: InputMaybe<Scalars['Int']>;
  trfTimestamp?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Equity_Print_Feed_Baseline_Max_Fields = {
  __typename?: 'equity_print_feed_baseline_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  sequenceNumber?: Maybe<Scalars['bigint']>;
  size?: Maybe<Scalars['Int']>;
  sourceKey?: Maybe<Scalars['String']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  trfId?: Maybe<Scalars['Int']>;
  trfTimestamp?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Equity_Print_Feed_Baseline_Min_Fields = {
  __typename?: 'equity_print_feed_baseline_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  sequenceNumber?: Maybe<Scalars['bigint']>;
  size?: Maybe<Scalars['Int']>;
  sourceKey?: Maybe<Scalars['String']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  trfId?: Maybe<Scalars['Int']>;
  trfTimestamp?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "equity_print_feed_baseline" */
export type Equity_Print_Feed_Baseline_Mutation_Response = {
  __typename?: 'equity_print_feed_baseline_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Equity_Print_Feed_Baseline>;
};

/** on_conflict condition type for table "equity_print_feed_baseline" */
export type Equity_Print_Feed_Baseline_On_Conflict = {
  constraint: Equity_Print_Feed_Baseline_Constraint;
  update_columns?: Array<Equity_Print_Feed_Baseline_Update_Column>;
  where?: InputMaybe<Equity_Print_Feed_Baseline_Bool_Exp>;
};

/** Ordering options when selecting data from "equity_print_feed_baseline". */
export type Equity_Print_Feed_Baseline_Order_By = {
  amount?: InputMaybe<Order_By>;
  ask?: InputMaybe<Order_By>;
  askSize?: InputMaybe<Order_By>;
  avgPrice?: InputMaybe<Order_By>;
  avgVolume?: InputMaybe<Order_By>;
  bid?: InputMaybe<Order_By>;
  bidSize?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  dayOverDayPercentChange?: InputMaybe<Order_By>;
  dayOverDayPriceChange?: InputMaybe<Order_By>;
  dayVolume?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  externalTradeId?: InputMaybe<Order_By>;
  high?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isEtf?: InputMaybe<Order_By>;
  isOutsideDailyRange?: InputMaybe<Order_By>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Order_By>;
  isPriceGreaterThanOpen?: InputMaybe<Order_By>;
  isSignatureEtfTicker?: InputMaybe<Order_By>;
  isSignatureVolume?: InputMaybe<Order_By>;
  lastTradePrice?: InputMaybe<Order_By>;
  low?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  open?: InputMaybe<Order_By>;
  percentAboveAsk?: InputMaybe<Order_By>;
  percentBelowBid?: InputMaybe<Order_By>;
  percentOfAvgVolume?: InputMaybe<Order_By>;
  percentOfMarketCap?: InputMaybe<Order_By>;
  percentOfTodaysVolume?: InputMaybe<Order_By>;
  prevClose?: InputMaybe<Order_By>;
  prevHigh?: InputMaybe<Order_By>;
  prevLow?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  publication_xid?: InputMaybe<Order_By>;
  realtimePrice?: InputMaybe<Order_By>;
  sequenceNumber?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  sourceKey?: InputMaybe<Order_By>;
  tapeId?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  timestamp?: InputMaybe<Order_By>;
  timestampIso?: InputMaybe<Order_By>;
  tradeConditions?: InputMaybe<Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  trfId?: InputMaybe<Order_By>;
  trfTimestamp?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: equity_print_feed_baseline */
export type Equity_Print_Feed_Baseline_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Equity_Print_Feed_Baseline_Prepend_Input = {
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "equity_print_feed_baseline" */
export const Equity_Print_Feed_Baseline_Select_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Ask: 'ask',
  /** column name */
  AskSize: 'askSize',
  /** column name */
  AvgPrice: 'avgPrice',
  /** column name */
  AvgVolume: 'avgVolume',
  /** column name */
  Bid: 'bid',
  /** column name */
  BidSize: 'bidSize',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DayOverDayPercentChange: 'dayOverDayPercentChange',
  /** column name */
  DayOverDayPriceChange: 'dayOverDayPriceChange',
  /** column name */
  DayVolume: 'dayVolume',
  /** column name */
  ExchangeId: 'exchangeId',
  /** column name */
  ExternalTradeId: 'externalTradeId',
  /** column name */
  High: 'high',
  /** column name */
  Id: 'id',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsOutsideDailyRange: 'isOutsideDailyRange',
  /** column name */
  IsPriceGreaterThanDailyAverage: 'isPriceGreaterThanDailyAverage',
  /** column name */
  IsPriceGreaterThanOpen: 'isPriceGreaterThanOpen',
  /** column name */
  IsSignatureEtfTicker: 'isSignatureEtfTicker',
  /** column name */
  IsSignatureVolume: 'isSignatureVolume',
  /** column name */
  LastTradePrice: 'lastTradePrice',
  /** column name */
  Low: 'low',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Open: 'open',
  /** column name */
  PercentAboveAsk: 'percentAboveAsk',
  /** column name */
  PercentBelowBid: 'percentBelowBid',
  /** column name */
  PercentOfAvgVolume: 'percentOfAvgVolume',
  /** column name */
  PercentOfMarketCap: 'percentOfMarketCap',
  /** column name */
  PercentOfTodaysVolume: 'percentOfTodaysVolume',
  /** column name */
  PrevClose: 'prevClose',
  /** column name */
  PrevHigh: 'prevHigh',
  /** column name */
  PrevLow: 'prevLow',
  /** column name */
  Price: 'price',
  /** column name */
  PublicationXid: 'publication_xid',
  /** column name */
  RealtimePrice: 'realtimePrice',
  /** column name */
  SequenceNumber: 'sequenceNumber',
  /** column name */
  Size: 'size',
  /** column name */
  SourceKey: 'sourceKey',
  /** column name */
  TapeId: 'tapeId',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TimestampIso: 'timestampIso',
  /** column name */
  TradeConditions: 'tradeConditions',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  TrfId: 'trfId',
  /** column name */
  TrfTimestamp: 'trfTimestamp',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Equity_Print_Feed_Baseline_Select_Column = typeof Equity_Print_Feed_Baseline_Select_Column[keyof typeof Equity_Print_Feed_Baseline_Select_Column];
/** input type for updating data in table "equity_print_feed_baseline" */
export type Equity_Print_Feed_Baseline_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  publication_xid?: InputMaybe<Scalars['xid8']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  sequenceNumber?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['Int']>;
  sourceKey?: InputMaybe<Scalars['String']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  timestampIso?: InputMaybe<Scalars['timestamptz']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  trfId?: InputMaybe<Scalars['Int']>;
  trfTimestamp?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Equity_Print_Feed_Baseline_Stddev_Fields = {
  __typename?: 'equity_print_feed_baseline_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Equity_Print_Feed_Baseline_Stddev_Pop_Fields = {
  __typename?: 'equity_print_feed_baseline_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Equity_Print_Feed_Baseline_Stddev_Samp_Fields = {
  __typename?: 'equity_print_feed_baseline_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "equity_print_feed_baseline" */
export type Equity_Print_Feed_Baseline_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Equity_Print_Feed_Baseline_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Equity_Print_Feed_Baseline_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  publication_xid?: InputMaybe<Scalars['xid8']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  sequenceNumber?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['Int']>;
  sourceKey?: InputMaybe<Scalars['String']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  timestampIso?: InputMaybe<Scalars['timestamptz']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  trfId?: InputMaybe<Scalars['Int']>;
  trfTimestamp?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Equity_Print_Feed_Baseline_Sum_Fields = {
  __typename?: 'equity_print_feed_baseline_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  high?: Maybe<Scalars['numeric']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  sequenceNumber?: Maybe<Scalars['bigint']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['bigint']>;
  trfId?: Maybe<Scalars['Int']>;
  trfTimestamp?: Maybe<Scalars['bigint']>;
};

/** update columns of table "equity_print_feed_baseline" */
export const Equity_Print_Feed_Baseline_Update_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Ask: 'ask',
  /** column name */
  AskSize: 'askSize',
  /** column name */
  AvgPrice: 'avgPrice',
  /** column name */
  AvgVolume: 'avgVolume',
  /** column name */
  Bid: 'bid',
  /** column name */
  BidSize: 'bidSize',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DayOverDayPercentChange: 'dayOverDayPercentChange',
  /** column name */
  DayOverDayPriceChange: 'dayOverDayPriceChange',
  /** column name */
  DayVolume: 'dayVolume',
  /** column name */
  ExchangeId: 'exchangeId',
  /** column name */
  ExternalTradeId: 'externalTradeId',
  /** column name */
  High: 'high',
  /** column name */
  Id: 'id',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsOutsideDailyRange: 'isOutsideDailyRange',
  /** column name */
  IsPriceGreaterThanDailyAverage: 'isPriceGreaterThanDailyAverage',
  /** column name */
  IsPriceGreaterThanOpen: 'isPriceGreaterThanOpen',
  /** column name */
  IsSignatureEtfTicker: 'isSignatureEtfTicker',
  /** column name */
  IsSignatureVolume: 'isSignatureVolume',
  /** column name */
  LastTradePrice: 'lastTradePrice',
  /** column name */
  Low: 'low',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Open: 'open',
  /** column name */
  PercentAboveAsk: 'percentAboveAsk',
  /** column name */
  PercentBelowBid: 'percentBelowBid',
  /** column name */
  PercentOfAvgVolume: 'percentOfAvgVolume',
  /** column name */
  PercentOfMarketCap: 'percentOfMarketCap',
  /** column name */
  PercentOfTodaysVolume: 'percentOfTodaysVolume',
  /** column name */
  PrevClose: 'prevClose',
  /** column name */
  PrevHigh: 'prevHigh',
  /** column name */
  PrevLow: 'prevLow',
  /** column name */
  Price: 'price',
  /** column name */
  PublicationXid: 'publication_xid',
  /** column name */
  RealtimePrice: 'realtimePrice',
  /** column name */
  SequenceNumber: 'sequenceNumber',
  /** column name */
  Size: 'size',
  /** column name */
  SourceKey: 'sourceKey',
  /** column name */
  TapeId: 'tapeId',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TimestampIso: 'timestampIso',
  /** column name */
  TradeConditions: 'tradeConditions',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  TrfId: 'trfId',
  /** column name */
  TrfTimestamp: 'trfTimestamp',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Equity_Print_Feed_Baseline_Update_Column = typeof Equity_Print_Feed_Baseline_Update_Column[keyof typeof Equity_Print_Feed_Baseline_Update_Column];
export type Equity_Print_Feed_Baseline_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Equity_Print_Feed_Baseline_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Equity_Print_Feed_Baseline_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Equity_Print_Feed_Baseline_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Equity_Print_Feed_Baseline_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Equity_Print_Feed_Baseline_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Equity_Print_Feed_Baseline_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Equity_Print_Feed_Baseline_Set_Input>;
  /** filter the rows which have to be updated */
  where: Equity_Print_Feed_Baseline_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Equity_Print_Feed_Baseline_Var_Pop_Fields = {
  __typename?: 'equity_print_feed_baseline_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Equity_Print_Feed_Baseline_Var_Samp_Fields = {
  __typename?: 'equity_print_feed_baseline_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Equity_Print_Feed_Baseline_Variance_Fields = {
  __typename?: 'equity_print_feed_baseline_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "equity_print_feed_filtered" */
export type Equity_Print_Feed_Filtered = {
  __typename?: 'equity_print_feed_filtered';
  amount: Scalars['numeric'];
  ask: Scalars['numeric'];
  askSize: Scalars['Int'];
  avgPrice: Scalars['numeric'];
  avgVolume: Scalars['numeric'];
  bid: Scalars['numeric'];
  bidSize: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  date: Scalars['date'];
  dayOverDayPercentChange: Scalars['numeric'];
  dayOverDayPriceChange: Scalars['numeric'];
  dayVolume: Scalars['numeric'];
  exchangeId: Scalars['Int'];
  externalTradeId: Scalars['String'];
  high: Scalars['numeric'];
  id: Scalars['uuid'];
  isEtf: Scalars['Boolean'];
  isOutsideDailyRange: Scalars['Boolean'];
  isPriceGreaterThanDailyAverage: Scalars['Boolean'];
  isPriceGreaterThanOpen: Scalars['Boolean'];
  isSignatureEtfTicker: Scalars['Boolean'];
  isSignatureVolume: Scalars['Boolean'];
  lastTradePrice: Scalars['numeric'];
  low: Scalars['numeric'];
  marketCap: Scalars['numeric'];
  open: Scalars['numeric'];
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose: Scalars['numeric'];
  prevHigh: Scalars['numeric'];
  prevLow: Scalars['numeric'];
  price: Scalars['numeric'];
  publication_xid?: Maybe<Scalars['xid8']>;
  realtimePrice: Scalars['numeric'];
  sequenceNumber?: Maybe<Scalars['bigint']>;
  size: Scalars['Int'];
  sourceKey?: Maybe<Scalars['String']>;
  tapeId: Scalars['Int'];
  ticker: Scalars['String'];
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  timestamp: Scalars['bigint'];
  timestampIso: Scalars['timestamptz'];
  tradeConditions: Scalars['jsonb'];
  tradeSide: Scalars['String'];
  trfId?: Maybe<Scalars['Int']>;
  trfTimestamp?: Maybe<Scalars['bigint']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "equity_print_feed_filtered" */
export type Equity_Print_Feed_FilteredTradeConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "equity_print_feed_filtered" */
export type Equity_Print_Feed_Filtered_Aggregate = {
  __typename?: 'equity_print_feed_filtered_aggregate';
  aggregate?: Maybe<Equity_Print_Feed_Filtered_Aggregate_Fields>;
  nodes: Array<Equity_Print_Feed_Filtered>;
};

/** aggregate fields of "equity_print_feed_filtered" */
export type Equity_Print_Feed_Filtered_Aggregate_Fields = {
  __typename?: 'equity_print_feed_filtered_aggregate_fields';
  avg?: Maybe<Equity_Print_Feed_Filtered_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Equity_Print_Feed_Filtered_Max_Fields>;
  min?: Maybe<Equity_Print_Feed_Filtered_Min_Fields>;
  stddev?: Maybe<Equity_Print_Feed_Filtered_Stddev_Fields>;
  stddev_pop?: Maybe<Equity_Print_Feed_Filtered_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Equity_Print_Feed_Filtered_Stddev_Samp_Fields>;
  sum?: Maybe<Equity_Print_Feed_Filtered_Sum_Fields>;
  var_pop?: Maybe<Equity_Print_Feed_Filtered_Var_Pop_Fields>;
  var_samp?: Maybe<Equity_Print_Feed_Filtered_Var_Samp_Fields>;
  variance?: Maybe<Equity_Print_Feed_Filtered_Variance_Fields>;
};


/** aggregate fields of "equity_print_feed_filtered" */
export type Equity_Print_Feed_Filtered_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Equity_Print_Feed_Filtered_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Equity_Print_Feed_Filtered_Append_Input = {
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Equity_Print_Feed_Filtered_Avg_Fields = {
  __typename?: 'equity_print_feed_filtered_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "equity_print_feed_filtered". All fields are combined with a logical 'AND'. */
export type Equity_Print_Feed_Filtered_Bool_Exp = {
  _and?: InputMaybe<Array<Equity_Print_Feed_Filtered_Bool_Exp>>;
  _not?: InputMaybe<Equity_Print_Feed_Filtered_Bool_Exp>;
  _or?: InputMaybe<Array<Equity_Print_Feed_Filtered_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  ask?: InputMaybe<Numeric_Comparison_Exp>;
  askSize?: InputMaybe<Int_Comparison_Exp>;
  avgPrice?: InputMaybe<Numeric_Comparison_Exp>;
  avgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  bid?: InputMaybe<Numeric_Comparison_Exp>;
  bidSize?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  dayOverDayPercentChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayOverDayPriceChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayVolume?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeId?: InputMaybe<Int_Comparison_Exp>;
  externalTradeId?: InputMaybe<String_Comparison_Exp>;
  high?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isEtf?: InputMaybe<Boolean_Comparison_Exp>;
  isOutsideDailyRange?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanOpen?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureEtfTicker?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureVolume?: InputMaybe<Boolean_Comparison_Exp>;
  lastTradePrice?: InputMaybe<Numeric_Comparison_Exp>;
  low?: InputMaybe<Numeric_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  open?: InputMaybe<Numeric_Comparison_Exp>;
  percentAboveAsk?: InputMaybe<Numeric_Comparison_Exp>;
  percentBelowBid?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfAvgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfMarketCap?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfTodaysVolume?: InputMaybe<Numeric_Comparison_Exp>;
  prevClose?: InputMaybe<Numeric_Comparison_Exp>;
  prevHigh?: InputMaybe<Numeric_Comparison_Exp>;
  prevLow?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  publication_xid?: InputMaybe<Xid8_Comparison_Exp>;
  realtimePrice?: InputMaybe<Numeric_Comparison_Exp>;
  sequenceNumber?: InputMaybe<Bigint_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  sourceKey?: InputMaybe<String_Comparison_Exp>;
  tapeId?: InputMaybe<Int_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  timestamp?: InputMaybe<Bigint_Comparison_Exp>;
  timestampIso?: InputMaybe<Timestamptz_Comparison_Exp>;
  tradeConditions?: InputMaybe<Jsonb_Comparison_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  trfId?: InputMaybe<Int_Comparison_Exp>;
  trfTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "equity_print_feed_filtered" */
export const Equity_Print_Feed_Filtered_Constraint = {
  /** unique or primary key constraint on columns "id" */
  EquityPrintFeedFilteredPkey: 'equity_print_feed_filtered_pkey',
  /** unique or primary key constraint on columns "sourceKey" */
  EquityPrintFeedFilteredSourceKeyKey: 'equity_print_feed_filtered_sourceKey_key'
} as const;

export type Equity_Print_Feed_Filtered_Constraint = typeof Equity_Print_Feed_Filtered_Constraint[keyof typeof Equity_Print_Feed_Filtered_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Equity_Print_Feed_Filtered_Delete_At_Path_Input = {
  tradeConditions?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Equity_Print_Feed_Filtered_Delete_Elem_Input = {
  tradeConditions?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Equity_Print_Feed_Filtered_Delete_Key_Input = {
  tradeConditions?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "equity_print_feed_filtered" */
export type Equity_Print_Feed_Filtered_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  high?: InputMaybe<Scalars['numeric']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  sequenceNumber?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['Int']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  trfId?: InputMaybe<Scalars['Int']>;
  trfTimestamp?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "equity_print_feed_filtered" */
export type Equity_Print_Feed_Filtered_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  publication_xid?: InputMaybe<Scalars['xid8']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  sequenceNumber?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['Int']>;
  sourceKey?: InputMaybe<Scalars['String']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  timestampIso?: InputMaybe<Scalars['timestamptz']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  trfId?: InputMaybe<Scalars['Int']>;
  trfTimestamp?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Equity_Print_Feed_Filtered_Max_Fields = {
  __typename?: 'equity_print_feed_filtered_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  sequenceNumber?: Maybe<Scalars['bigint']>;
  size?: Maybe<Scalars['Int']>;
  sourceKey?: Maybe<Scalars['String']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  trfId?: Maybe<Scalars['Int']>;
  trfTimestamp?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Equity_Print_Feed_Filtered_Min_Fields = {
  __typename?: 'equity_print_feed_filtered_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  sequenceNumber?: Maybe<Scalars['bigint']>;
  size?: Maybe<Scalars['Int']>;
  sourceKey?: Maybe<Scalars['String']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  trfId?: Maybe<Scalars['Int']>;
  trfTimestamp?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "equity_print_feed_filtered" */
export type Equity_Print_Feed_Filtered_Mutation_Response = {
  __typename?: 'equity_print_feed_filtered_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Equity_Print_Feed_Filtered>;
};

/** on_conflict condition type for table "equity_print_feed_filtered" */
export type Equity_Print_Feed_Filtered_On_Conflict = {
  constraint: Equity_Print_Feed_Filtered_Constraint;
  update_columns?: Array<Equity_Print_Feed_Filtered_Update_Column>;
  where?: InputMaybe<Equity_Print_Feed_Filtered_Bool_Exp>;
};

/** Ordering options when selecting data from "equity_print_feed_filtered". */
export type Equity_Print_Feed_Filtered_Order_By = {
  amount?: InputMaybe<Order_By>;
  ask?: InputMaybe<Order_By>;
  askSize?: InputMaybe<Order_By>;
  avgPrice?: InputMaybe<Order_By>;
  avgVolume?: InputMaybe<Order_By>;
  bid?: InputMaybe<Order_By>;
  bidSize?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  dayOverDayPercentChange?: InputMaybe<Order_By>;
  dayOverDayPriceChange?: InputMaybe<Order_By>;
  dayVolume?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  externalTradeId?: InputMaybe<Order_By>;
  high?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isEtf?: InputMaybe<Order_By>;
  isOutsideDailyRange?: InputMaybe<Order_By>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Order_By>;
  isPriceGreaterThanOpen?: InputMaybe<Order_By>;
  isSignatureEtfTicker?: InputMaybe<Order_By>;
  isSignatureVolume?: InputMaybe<Order_By>;
  lastTradePrice?: InputMaybe<Order_By>;
  low?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  open?: InputMaybe<Order_By>;
  percentAboveAsk?: InputMaybe<Order_By>;
  percentBelowBid?: InputMaybe<Order_By>;
  percentOfAvgVolume?: InputMaybe<Order_By>;
  percentOfMarketCap?: InputMaybe<Order_By>;
  percentOfTodaysVolume?: InputMaybe<Order_By>;
  prevClose?: InputMaybe<Order_By>;
  prevHigh?: InputMaybe<Order_By>;
  prevLow?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  publication_xid?: InputMaybe<Order_By>;
  realtimePrice?: InputMaybe<Order_By>;
  sequenceNumber?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  sourceKey?: InputMaybe<Order_By>;
  tapeId?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  timestamp?: InputMaybe<Order_By>;
  timestampIso?: InputMaybe<Order_By>;
  tradeConditions?: InputMaybe<Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  trfId?: InputMaybe<Order_By>;
  trfTimestamp?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: equity_print_feed_filtered */
export type Equity_Print_Feed_Filtered_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Equity_Print_Feed_Filtered_Prepend_Input = {
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "equity_print_feed_filtered" */
export const Equity_Print_Feed_Filtered_Select_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Ask: 'ask',
  /** column name */
  AskSize: 'askSize',
  /** column name */
  AvgPrice: 'avgPrice',
  /** column name */
  AvgVolume: 'avgVolume',
  /** column name */
  Bid: 'bid',
  /** column name */
  BidSize: 'bidSize',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DayOverDayPercentChange: 'dayOverDayPercentChange',
  /** column name */
  DayOverDayPriceChange: 'dayOverDayPriceChange',
  /** column name */
  DayVolume: 'dayVolume',
  /** column name */
  ExchangeId: 'exchangeId',
  /** column name */
  ExternalTradeId: 'externalTradeId',
  /** column name */
  High: 'high',
  /** column name */
  Id: 'id',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsOutsideDailyRange: 'isOutsideDailyRange',
  /** column name */
  IsPriceGreaterThanDailyAverage: 'isPriceGreaterThanDailyAverage',
  /** column name */
  IsPriceGreaterThanOpen: 'isPriceGreaterThanOpen',
  /** column name */
  IsSignatureEtfTicker: 'isSignatureEtfTicker',
  /** column name */
  IsSignatureVolume: 'isSignatureVolume',
  /** column name */
  LastTradePrice: 'lastTradePrice',
  /** column name */
  Low: 'low',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Open: 'open',
  /** column name */
  PercentAboveAsk: 'percentAboveAsk',
  /** column name */
  PercentBelowBid: 'percentBelowBid',
  /** column name */
  PercentOfAvgVolume: 'percentOfAvgVolume',
  /** column name */
  PercentOfMarketCap: 'percentOfMarketCap',
  /** column name */
  PercentOfTodaysVolume: 'percentOfTodaysVolume',
  /** column name */
  PrevClose: 'prevClose',
  /** column name */
  PrevHigh: 'prevHigh',
  /** column name */
  PrevLow: 'prevLow',
  /** column name */
  Price: 'price',
  /** column name */
  PublicationXid: 'publication_xid',
  /** column name */
  RealtimePrice: 'realtimePrice',
  /** column name */
  SequenceNumber: 'sequenceNumber',
  /** column name */
  Size: 'size',
  /** column name */
  SourceKey: 'sourceKey',
  /** column name */
  TapeId: 'tapeId',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TimestampIso: 'timestampIso',
  /** column name */
  TradeConditions: 'tradeConditions',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  TrfId: 'trfId',
  /** column name */
  TrfTimestamp: 'trfTimestamp',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Equity_Print_Feed_Filtered_Select_Column = typeof Equity_Print_Feed_Filtered_Select_Column[keyof typeof Equity_Print_Feed_Filtered_Select_Column];
/** input type for updating data in table "equity_print_feed_filtered" */
export type Equity_Print_Feed_Filtered_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  publication_xid?: InputMaybe<Scalars['xid8']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  sequenceNumber?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['Int']>;
  sourceKey?: InputMaybe<Scalars['String']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  timestampIso?: InputMaybe<Scalars['timestamptz']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  trfId?: InputMaybe<Scalars['Int']>;
  trfTimestamp?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Equity_Print_Feed_Filtered_Stddev_Fields = {
  __typename?: 'equity_print_feed_filtered_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Equity_Print_Feed_Filtered_Stddev_Pop_Fields = {
  __typename?: 'equity_print_feed_filtered_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Equity_Print_Feed_Filtered_Stddev_Samp_Fields = {
  __typename?: 'equity_print_feed_filtered_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "equity_print_feed_filtered" */
export type Equity_Print_Feed_Filtered_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Equity_Print_Feed_Filtered_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Equity_Print_Feed_Filtered_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  publication_xid?: InputMaybe<Scalars['xid8']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  sequenceNumber?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['Int']>;
  sourceKey?: InputMaybe<Scalars['String']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  timestampIso?: InputMaybe<Scalars['timestamptz']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  trfId?: InputMaybe<Scalars['Int']>;
  trfTimestamp?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Equity_Print_Feed_Filtered_Sum_Fields = {
  __typename?: 'equity_print_feed_filtered_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  high?: Maybe<Scalars['numeric']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  sequenceNumber?: Maybe<Scalars['bigint']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['bigint']>;
  trfId?: Maybe<Scalars['Int']>;
  trfTimestamp?: Maybe<Scalars['bigint']>;
};

/** update columns of table "equity_print_feed_filtered" */
export const Equity_Print_Feed_Filtered_Update_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Ask: 'ask',
  /** column name */
  AskSize: 'askSize',
  /** column name */
  AvgPrice: 'avgPrice',
  /** column name */
  AvgVolume: 'avgVolume',
  /** column name */
  Bid: 'bid',
  /** column name */
  BidSize: 'bidSize',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DayOverDayPercentChange: 'dayOverDayPercentChange',
  /** column name */
  DayOverDayPriceChange: 'dayOverDayPriceChange',
  /** column name */
  DayVolume: 'dayVolume',
  /** column name */
  ExchangeId: 'exchangeId',
  /** column name */
  ExternalTradeId: 'externalTradeId',
  /** column name */
  High: 'high',
  /** column name */
  Id: 'id',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsOutsideDailyRange: 'isOutsideDailyRange',
  /** column name */
  IsPriceGreaterThanDailyAverage: 'isPriceGreaterThanDailyAverage',
  /** column name */
  IsPriceGreaterThanOpen: 'isPriceGreaterThanOpen',
  /** column name */
  IsSignatureEtfTicker: 'isSignatureEtfTicker',
  /** column name */
  IsSignatureVolume: 'isSignatureVolume',
  /** column name */
  LastTradePrice: 'lastTradePrice',
  /** column name */
  Low: 'low',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Open: 'open',
  /** column name */
  PercentAboveAsk: 'percentAboveAsk',
  /** column name */
  PercentBelowBid: 'percentBelowBid',
  /** column name */
  PercentOfAvgVolume: 'percentOfAvgVolume',
  /** column name */
  PercentOfMarketCap: 'percentOfMarketCap',
  /** column name */
  PercentOfTodaysVolume: 'percentOfTodaysVolume',
  /** column name */
  PrevClose: 'prevClose',
  /** column name */
  PrevHigh: 'prevHigh',
  /** column name */
  PrevLow: 'prevLow',
  /** column name */
  Price: 'price',
  /** column name */
  PublicationXid: 'publication_xid',
  /** column name */
  RealtimePrice: 'realtimePrice',
  /** column name */
  SequenceNumber: 'sequenceNumber',
  /** column name */
  Size: 'size',
  /** column name */
  SourceKey: 'sourceKey',
  /** column name */
  TapeId: 'tapeId',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TimestampIso: 'timestampIso',
  /** column name */
  TradeConditions: 'tradeConditions',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  TrfId: 'trfId',
  /** column name */
  TrfTimestamp: 'trfTimestamp',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Equity_Print_Feed_Filtered_Update_Column = typeof Equity_Print_Feed_Filtered_Update_Column[keyof typeof Equity_Print_Feed_Filtered_Update_Column];
export type Equity_Print_Feed_Filtered_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Equity_Print_Feed_Filtered_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Equity_Print_Feed_Filtered_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Equity_Print_Feed_Filtered_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Equity_Print_Feed_Filtered_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Equity_Print_Feed_Filtered_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Equity_Print_Feed_Filtered_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Equity_Print_Feed_Filtered_Set_Input>;
  /** filter the rows which have to be updated */
  where: Equity_Print_Feed_Filtered_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Equity_Print_Feed_Filtered_Var_Pop_Fields = {
  __typename?: 'equity_print_feed_filtered_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Equity_Print_Feed_Filtered_Var_Samp_Fields = {
  __typename?: 'equity_print_feed_filtered_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Equity_Print_Feed_Filtered_Variance_Fields = {
  __typename?: 'equity_print_feed_filtered_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
  trfId?: Maybe<Scalars['Float']>;
  trfTimestamp?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "equity_print_flow" */
export type Equity_Print_Flow = {
  __typename?: 'equity_print_flow';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  isEtf?: Maybe<Scalars['Boolean']>;
  isOutsideDailyRange?: Maybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: Maybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: Maybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: Maybe<Scalars['Boolean']>;
  isSignatureVolume?: Maybe<Scalars['Boolean']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeConditions?: Maybe<Scalars['jsonb']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "equity_print_flow" */
export type Equity_Print_FlowTradeConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "equity_print_flow" */
export type Equity_Print_Flow_Aggregate = {
  __typename?: 'equity_print_flow_aggregate';
  aggregate?: Maybe<Equity_Print_Flow_Aggregate_Fields>;
  nodes: Array<Equity_Print_Flow>;
};

/** aggregate fields of "equity_print_flow" */
export type Equity_Print_Flow_Aggregate_Fields = {
  __typename?: 'equity_print_flow_aggregate_fields';
  avg?: Maybe<Equity_Print_Flow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Equity_Print_Flow_Max_Fields>;
  min?: Maybe<Equity_Print_Flow_Min_Fields>;
  stddev?: Maybe<Equity_Print_Flow_Stddev_Fields>;
  stddev_pop?: Maybe<Equity_Print_Flow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Equity_Print_Flow_Stddev_Samp_Fields>;
  sum?: Maybe<Equity_Print_Flow_Sum_Fields>;
  var_pop?: Maybe<Equity_Print_Flow_Var_Pop_Fields>;
  var_samp?: Maybe<Equity_Print_Flow_Var_Samp_Fields>;
  variance?: Maybe<Equity_Print_Flow_Variance_Fields>;
};


/** aggregate fields of "equity_print_flow" */
export type Equity_Print_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Equity_Print_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Equity_Print_Flow_Avg_Fields = {
  __typename?: 'equity_print_flow_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "equity_print_flow". All fields are combined with a logical 'AND'. */
export type Equity_Print_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Equity_Print_Flow_Bool_Exp>>;
  _not?: InputMaybe<Equity_Print_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Equity_Print_Flow_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  ask?: InputMaybe<Numeric_Comparison_Exp>;
  askSize?: InputMaybe<Int_Comparison_Exp>;
  avgPrice?: InputMaybe<Numeric_Comparison_Exp>;
  avgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  bid?: InputMaybe<Numeric_Comparison_Exp>;
  bidSize?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  dayOverDayPercentChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayOverDayPriceChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayVolume?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeId?: InputMaybe<Int_Comparison_Exp>;
  externalTradeId?: InputMaybe<String_Comparison_Exp>;
  high?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isEtf?: InputMaybe<Boolean_Comparison_Exp>;
  isOutsideDailyRange?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanOpen?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureEtfTicker?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureVolume?: InputMaybe<Boolean_Comparison_Exp>;
  lastTradePrice?: InputMaybe<Numeric_Comparison_Exp>;
  low?: InputMaybe<Numeric_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  open?: InputMaybe<Numeric_Comparison_Exp>;
  percentAboveAsk?: InputMaybe<Numeric_Comparison_Exp>;
  percentBelowBid?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfAvgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfMarketCap?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfTodaysVolume?: InputMaybe<Numeric_Comparison_Exp>;
  prevClose?: InputMaybe<Numeric_Comparison_Exp>;
  prevHigh?: InputMaybe<Numeric_Comparison_Exp>;
  prevLow?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  realtimePrice?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  tapeId?: InputMaybe<Int_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  timestamp?: InputMaybe<Bigint_Comparison_Exp>;
  timestampIso?: InputMaybe<Timestamptz_Comparison_Exp>;
  tradeConditions?: InputMaybe<Jsonb_Comparison_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "equity_print_flow_full" */
export type Equity_Print_Flow_Full = {
  __typename?: 'equity_print_flow_full';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  isEtf?: Maybe<Scalars['Boolean']>;
  isOutsideDailyRange?: Maybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: Maybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: Maybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: Maybe<Scalars['Boolean']>;
  isSignatureVolume?: Maybe<Scalars['Boolean']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeConditions?: Maybe<Scalars['jsonb']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "equity_print_flow_full" */
export type Equity_Print_Flow_FullTradeConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "equity_print_flow_full" */
export type Equity_Print_Flow_Full_Aggregate = {
  __typename?: 'equity_print_flow_full_aggregate';
  aggregate?: Maybe<Equity_Print_Flow_Full_Aggregate_Fields>;
  nodes: Array<Equity_Print_Flow_Full>;
};

/** aggregate fields of "equity_print_flow_full" */
export type Equity_Print_Flow_Full_Aggregate_Fields = {
  __typename?: 'equity_print_flow_full_aggregate_fields';
  avg?: Maybe<Equity_Print_Flow_Full_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Equity_Print_Flow_Full_Max_Fields>;
  min?: Maybe<Equity_Print_Flow_Full_Min_Fields>;
  stddev?: Maybe<Equity_Print_Flow_Full_Stddev_Fields>;
  stddev_pop?: Maybe<Equity_Print_Flow_Full_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Equity_Print_Flow_Full_Stddev_Samp_Fields>;
  sum?: Maybe<Equity_Print_Flow_Full_Sum_Fields>;
  var_pop?: Maybe<Equity_Print_Flow_Full_Var_Pop_Fields>;
  var_samp?: Maybe<Equity_Print_Flow_Full_Var_Samp_Fields>;
  variance?: Maybe<Equity_Print_Flow_Full_Variance_Fields>;
};


/** aggregate fields of "equity_print_flow_full" */
export type Equity_Print_Flow_Full_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Equity_Print_Flow_Full_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Equity_Print_Flow_Full_Avg_Fields = {
  __typename?: 'equity_print_flow_full_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "equity_print_flow_full". All fields are combined with a logical 'AND'. */
export type Equity_Print_Flow_Full_Bool_Exp = {
  _and?: InputMaybe<Array<Equity_Print_Flow_Full_Bool_Exp>>;
  _not?: InputMaybe<Equity_Print_Flow_Full_Bool_Exp>;
  _or?: InputMaybe<Array<Equity_Print_Flow_Full_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  ask?: InputMaybe<Numeric_Comparison_Exp>;
  askSize?: InputMaybe<Int_Comparison_Exp>;
  avgPrice?: InputMaybe<Numeric_Comparison_Exp>;
  avgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  bid?: InputMaybe<Numeric_Comparison_Exp>;
  bidSize?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  dayOverDayPercentChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayOverDayPriceChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayVolume?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeId?: InputMaybe<Int_Comparison_Exp>;
  externalTradeId?: InputMaybe<String_Comparison_Exp>;
  high?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isEtf?: InputMaybe<Boolean_Comparison_Exp>;
  isOutsideDailyRange?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanOpen?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureEtfTicker?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureVolume?: InputMaybe<Boolean_Comparison_Exp>;
  lastTradePrice?: InputMaybe<Numeric_Comparison_Exp>;
  low?: InputMaybe<Numeric_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  open?: InputMaybe<Numeric_Comparison_Exp>;
  percentAboveAsk?: InputMaybe<Numeric_Comparison_Exp>;
  percentBelowBid?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfAvgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfMarketCap?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfTodaysVolume?: InputMaybe<Numeric_Comparison_Exp>;
  prevClose?: InputMaybe<Numeric_Comparison_Exp>;
  prevHigh?: InputMaybe<Numeric_Comparison_Exp>;
  prevLow?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  realtimePrice?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  tapeId?: InputMaybe<Int_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  timestamp?: InputMaybe<Bigint_Comparison_Exp>;
  timestampIso?: InputMaybe<Timestamptz_Comparison_Exp>;
  tradeConditions?: InputMaybe<Jsonb_Comparison_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Equity_Print_Flow_Full_Max_Fields = {
  __typename?: 'equity_print_flow_full_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Equity_Print_Flow_Full_Min_Fields = {
  __typename?: 'equity_print_flow_full_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "equity_print_flow_full". */
export type Equity_Print_Flow_Full_Order_By = {
  amount?: InputMaybe<Order_By>;
  ask?: InputMaybe<Order_By>;
  askSize?: InputMaybe<Order_By>;
  avgPrice?: InputMaybe<Order_By>;
  avgVolume?: InputMaybe<Order_By>;
  bid?: InputMaybe<Order_By>;
  bidSize?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  dayOverDayPercentChange?: InputMaybe<Order_By>;
  dayOverDayPriceChange?: InputMaybe<Order_By>;
  dayVolume?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  externalTradeId?: InputMaybe<Order_By>;
  high?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isEtf?: InputMaybe<Order_By>;
  isOutsideDailyRange?: InputMaybe<Order_By>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Order_By>;
  isPriceGreaterThanOpen?: InputMaybe<Order_By>;
  isSignatureEtfTicker?: InputMaybe<Order_By>;
  isSignatureVolume?: InputMaybe<Order_By>;
  lastTradePrice?: InputMaybe<Order_By>;
  low?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  open?: InputMaybe<Order_By>;
  percentAboveAsk?: InputMaybe<Order_By>;
  percentBelowBid?: InputMaybe<Order_By>;
  percentOfAvgVolume?: InputMaybe<Order_By>;
  percentOfMarketCap?: InputMaybe<Order_By>;
  percentOfTodaysVolume?: InputMaybe<Order_By>;
  prevClose?: InputMaybe<Order_By>;
  prevHigh?: InputMaybe<Order_By>;
  prevLow?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  realtimePrice?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  tapeId?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  timestampIso?: InputMaybe<Order_By>;
  tradeConditions?: InputMaybe<Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "equity_print_flow_full" */
export const Equity_Print_Flow_Full_Select_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Ask: 'ask',
  /** column name */
  AskSize: 'askSize',
  /** column name */
  AvgPrice: 'avgPrice',
  /** column name */
  AvgVolume: 'avgVolume',
  /** column name */
  Bid: 'bid',
  /** column name */
  BidSize: 'bidSize',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DayOverDayPercentChange: 'dayOverDayPercentChange',
  /** column name */
  DayOverDayPriceChange: 'dayOverDayPriceChange',
  /** column name */
  DayVolume: 'dayVolume',
  /** column name */
  ExchangeId: 'exchangeId',
  /** column name */
  ExternalTradeId: 'externalTradeId',
  /** column name */
  High: 'high',
  /** column name */
  Id: 'id',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsOutsideDailyRange: 'isOutsideDailyRange',
  /** column name */
  IsPriceGreaterThanDailyAverage: 'isPriceGreaterThanDailyAverage',
  /** column name */
  IsPriceGreaterThanOpen: 'isPriceGreaterThanOpen',
  /** column name */
  IsSignatureEtfTicker: 'isSignatureEtfTicker',
  /** column name */
  IsSignatureVolume: 'isSignatureVolume',
  /** column name */
  LastTradePrice: 'lastTradePrice',
  /** column name */
  Low: 'low',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Open: 'open',
  /** column name */
  PercentAboveAsk: 'percentAboveAsk',
  /** column name */
  PercentBelowBid: 'percentBelowBid',
  /** column name */
  PercentOfAvgVolume: 'percentOfAvgVolume',
  /** column name */
  PercentOfMarketCap: 'percentOfMarketCap',
  /** column name */
  PercentOfTodaysVolume: 'percentOfTodaysVolume',
  /** column name */
  PrevClose: 'prevClose',
  /** column name */
  PrevHigh: 'prevHigh',
  /** column name */
  PrevLow: 'prevLow',
  /** column name */
  Price: 'price',
  /** column name */
  RealtimePrice: 'realtimePrice',
  /** column name */
  Size: 'size',
  /** column name */
  TapeId: 'tapeId',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TimestampIso: 'timestampIso',
  /** column name */
  TradeConditions: 'tradeConditions',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Equity_Print_Flow_Full_Select_Column = typeof Equity_Print_Flow_Full_Select_Column[keyof typeof Equity_Print_Flow_Full_Select_Column];
/** aggregate stddev on columns */
export type Equity_Print_Flow_Full_Stddev_Fields = {
  __typename?: 'equity_print_flow_full_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Equity_Print_Flow_Full_Stddev_Pop_Fields = {
  __typename?: 'equity_print_flow_full_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Equity_Print_Flow_Full_Stddev_Samp_Fields = {
  __typename?: 'equity_print_flow_full_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "equity_print_flow_full" */
export type Equity_Print_Flow_Full_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Equity_Print_Flow_Full_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Equity_Print_Flow_Full_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  timestampIso?: InputMaybe<Scalars['timestamptz']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Equity_Print_Flow_Full_Sum_Fields = {
  __typename?: 'equity_print_flow_full_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  high?: Maybe<Scalars['numeric']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Equity_Print_Flow_Full_Var_Pop_Fields = {
  __typename?: 'equity_print_flow_full_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Equity_Print_Flow_Full_Var_Samp_Fields = {
  __typename?: 'equity_print_flow_full_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Equity_Print_Flow_Full_Variance_Fields = {
  __typename?: 'equity_print_flow_full_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Equity_Print_Flow_Max_Fields = {
  __typename?: 'equity_print_flow_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Equity_Print_Flow_Min_Fields = {
  __typename?: 'equity_print_flow_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "equity_print_flow". */
export type Equity_Print_Flow_Order_By = {
  amount?: InputMaybe<Order_By>;
  ask?: InputMaybe<Order_By>;
  askSize?: InputMaybe<Order_By>;
  avgPrice?: InputMaybe<Order_By>;
  avgVolume?: InputMaybe<Order_By>;
  bid?: InputMaybe<Order_By>;
  bidSize?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  dayOverDayPercentChange?: InputMaybe<Order_By>;
  dayOverDayPriceChange?: InputMaybe<Order_By>;
  dayVolume?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  externalTradeId?: InputMaybe<Order_By>;
  high?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isEtf?: InputMaybe<Order_By>;
  isOutsideDailyRange?: InputMaybe<Order_By>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Order_By>;
  isPriceGreaterThanOpen?: InputMaybe<Order_By>;
  isSignatureEtfTicker?: InputMaybe<Order_By>;
  isSignatureVolume?: InputMaybe<Order_By>;
  lastTradePrice?: InputMaybe<Order_By>;
  low?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  open?: InputMaybe<Order_By>;
  percentAboveAsk?: InputMaybe<Order_By>;
  percentBelowBid?: InputMaybe<Order_By>;
  percentOfAvgVolume?: InputMaybe<Order_By>;
  percentOfMarketCap?: InputMaybe<Order_By>;
  percentOfTodaysVolume?: InputMaybe<Order_By>;
  prevClose?: InputMaybe<Order_By>;
  prevHigh?: InputMaybe<Order_By>;
  prevLow?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  realtimePrice?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  tapeId?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  timestamp?: InputMaybe<Order_By>;
  timestampIso?: InputMaybe<Order_By>;
  tradeConditions?: InputMaybe<Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "equity_print_flow" */
export const Equity_Print_Flow_Select_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Ask: 'ask',
  /** column name */
  AskSize: 'askSize',
  /** column name */
  AvgPrice: 'avgPrice',
  /** column name */
  AvgVolume: 'avgVolume',
  /** column name */
  Bid: 'bid',
  /** column name */
  BidSize: 'bidSize',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DayOverDayPercentChange: 'dayOverDayPercentChange',
  /** column name */
  DayOverDayPriceChange: 'dayOverDayPriceChange',
  /** column name */
  DayVolume: 'dayVolume',
  /** column name */
  ExchangeId: 'exchangeId',
  /** column name */
  ExternalTradeId: 'externalTradeId',
  /** column name */
  High: 'high',
  /** column name */
  Id: 'id',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsOutsideDailyRange: 'isOutsideDailyRange',
  /** column name */
  IsPriceGreaterThanDailyAverage: 'isPriceGreaterThanDailyAverage',
  /** column name */
  IsPriceGreaterThanOpen: 'isPriceGreaterThanOpen',
  /** column name */
  IsSignatureEtfTicker: 'isSignatureEtfTicker',
  /** column name */
  IsSignatureVolume: 'isSignatureVolume',
  /** column name */
  LastTradePrice: 'lastTradePrice',
  /** column name */
  Low: 'low',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Open: 'open',
  /** column name */
  PercentAboveAsk: 'percentAboveAsk',
  /** column name */
  PercentBelowBid: 'percentBelowBid',
  /** column name */
  PercentOfAvgVolume: 'percentOfAvgVolume',
  /** column name */
  PercentOfMarketCap: 'percentOfMarketCap',
  /** column name */
  PercentOfTodaysVolume: 'percentOfTodaysVolume',
  /** column name */
  PrevClose: 'prevClose',
  /** column name */
  PrevHigh: 'prevHigh',
  /** column name */
  PrevLow: 'prevLow',
  /** column name */
  Price: 'price',
  /** column name */
  RealtimePrice: 'realtimePrice',
  /** column name */
  Size: 'size',
  /** column name */
  TapeId: 'tapeId',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TimestampIso: 'timestampIso',
  /** column name */
  TradeConditions: 'tradeConditions',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Equity_Print_Flow_Select_Column = typeof Equity_Print_Flow_Select_Column[keyof typeof Equity_Print_Flow_Select_Column];
/** aggregate stddev on columns */
export type Equity_Print_Flow_Stddev_Fields = {
  __typename?: 'equity_print_flow_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Equity_Print_Flow_Stddev_Pop_Fields = {
  __typename?: 'equity_print_flow_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Equity_Print_Flow_Stddev_Samp_Fields = {
  __typename?: 'equity_print_flow_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "equity_print_flow" */
export type Equity_Print_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Equity_Print_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Equity_Print_Flow_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  timestampIso?: InputMaybe<Scalars['timestamptz']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Equity_Print_Flow_Sum_Fields = {
  __typename?: 'equity_print_flow_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  high?: Maybe<Scalars['numeric']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Equity_Print_Flow_Var_Pop_Fields = {
  __typename?: 'equity_print_flow_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Equity_Print_Flow_Var_Samp_Fields = {
  __typename?: 'equity_print_flow_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Equity_Print_Flow_Variance_Fields = {
  __typename?: 'equity_print_flow_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fa_call_moving_average" */
export type Fa_Call_Moving_Average = {
  __typename?: 'fa_call_moving_average';
  date?: Maybe<Scalars['date']>;
  monthlyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  monthlyTotalPremium?: Maybe<Scalars['numeric']>;
  monthlyTotalQuantity?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  priorDayPremium?: Maybe<Scalars['numeric']>;
  priorDayQuantity?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  totalTradesToday?: Maybe<Scalars['bigint']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalQuantity?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "fa_call_moving_average" */
export type Fa_Call_Moving_Average_Aggregate = {
  __typename?: 'fa_call_moving_average_aggregate';
  aggregate?: Maybe<Fa_Call_Moving_Average_Aggregate_Fields>;
  nodes: Array<Fa_Call_Moving_Average>;
};

/** aggregate fields of "fa_call_moving_average" */
export type Fa_Call_Moving_Average_Aggregate_Fields = {
  __typename?: 'fa_call_moving_average_aggregate_fields';
  avg?: Maybe<Fa_Call_Moving_Average_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fa_Call_Moving_Average_Max_Fields>;
  min?: Maybe<Fa_Call_Moving_Average_Min_Fields>;
  stddev?: Maybe<Fa_Call_Moving_Average_Stddev_Fields>;
  stddev_pop?: Maybe<Fa_Call_Moving_Average_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fa_Call_Moving_Average_Stddev_Samp_Fields>;
  sum?: Maybe<Fa_Call_Moving_Average_Sum_Fields>;
  var_pop?: Maybe<Fa_Call_Moving_Average_Var_Pop_Fields>;
  var_samp?: Maybe<Fa_Call_Moving_Average_Var_Samp_Fields>;
  variance?: Maybe<Fa_Call_Moving_Average_Variance_Fields>;
};


/** aggregate fields of "fa_call_moving_average" */
export type Fa_Call_Moving_Average_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fa_Call_Moving_Average_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fa_Call_Moving_Average_Avg_Fields = {
  __typename?: 'fa_call_moving_average_avg_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fa_call_moving_average". All fields are combined with a logical 'AND'. */
export type Fa_Call_Moving_Average_Bool_Exp = {
  _and?: InputMaybe<Array<Fa_Call_Moving_Average_Bool_Exp>>;
  _not?: InputMaybe<Fa_Call_Moving_Average_Bool_Exp>;
  _or?: InputMaybe<Array<Fa_Call_Moving_Average_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  monthlyMovingAveragePremium?: InputMaybe<Numeric_Comparison_Exp>;
  monthlyMovingAverageQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  monthlyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  monthlyTotalQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  multipleOfMonthlyAveragePremium?: InputMaybe<Numeric_Comparison_Exp>;
  multipleOfMonthlyAverageQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  multipleOfPriorDayPremium?: InputMaybe<Numeric_Comparison_Exp>;
  multipleOfPriorDayQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  multipleOfWeeklyAveragePremium?: InputMaybe<Numeric_Comparison_Exp>;
  multipleOfWeeklyAverageQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  priorDayPremium?: InputMaybe<Numeric_Comparison_Exp>;
  priorDayQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  totalTradesToday?: InputMaybe<Bigint_Comparison_Exp>;
  weeklyMovingAveragePremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyMovingAverageQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalQuantity?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fa_Call_Moving_Average_Max_Fields = {
  __typename?: 'fa_call_moving_average_max_fields';
  date?: Maybe<Scalars['date']>;
  monthlyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  monthlyTotalPremium?: Maybe<Scalars['numeric']>;
  monthlyTotalQuantity?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  priorDayPremium?: Maybe<Scalars['numeric']>;
  priorDayQuantity?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  totalTradesToday?: Maybe<Scalars['bigint']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalQuantity?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Fa_Call_Moving_Average_Min_Fields = {
  __typename?: 'fa_call_moving_average_min_fields';
  date?: Maybe<Scalars['date']>;
  monthlyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  monthlyTotalPremium?: Maybe<Scalars['numeric']>;
  monthlyTotalQuantity?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  priorDayPremium?: Maybe<Scalars['numeric']>;
  priorDayQuantity?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  totalTradesToday?: Maybe<Scalars['bigint']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalQuantity?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "fa_call_moving_average". */
export type Fa_Call_Moving_Average_Order_By = {
  date?: InputMaybe<Order_By>;
  monthlyMovingAveragePremium?: InputMaybe<Order_By>;
  monthlyMovingAverageQuantity?: InputMaybe<Order_By>;
  monthlyTotalPremium?: InputMaybe<Order_By>;
  monthlyTotalQuantity?: InputMaybe<Order_By>;
  multipleOfMonthlyAveragePremium?: InputMaybe<Order_By>;
  multipleOfMonthlyAverageQuantity?: InputMaybe<Order_By>;
  multipleOfPriorDayPremium?: InputMaybe<Order_By>;
  multipleOfPriorDayQuantity?: InputMaybe<Order_By>;
  multipleOfWeeklyAveragePremium?: InputMaybe<Order_By>;
  multipleOfWeeklyAverageQuantity?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  priorDayPremium?: InputMaybe<Order_By>;
  priorDayQuantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  totalTradesToday?: InputMaybe<Order_By>;
  weeklyMovingAveragePremium?: InputMaybe<Order_By>;
  weeklyMovingAverageQuantity?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalQuantity?: InputMaybe<Order_By>;
};

/** select columns of table "fa_call_moving_average" */
export const Fa_Call_Moving_Average_Select_Column = {
  /** column name */
  Date: 'date',
  /** column name */
  MonthlyMovingAveragePremium: 'monthlyMovingAveragePremium',
  /** column name */
  MonthlyMovingAverageQuantity: 'monthlyMovingAverageQuantity',
  /** column name */
  MonthlyTotalPremium: 'monthlyTotalPremium',
  /** column name */
  MonthlyTotalQuantity: 'monthlyTotalQuantity',
  /** column name */
  MultipleOfMonthlyAveragePremium: 'multipleOfMonthlyAveragePremium',
  /** column name */
  MultipleOfMonthlyAverageQuantity: 'multipleOfMonthlyAverageQuantity',
  /** column name */
  MultipleOfPriorDayPremium: 'multipleOfPriorDayPremium',
  /** column name */
  MultipleOfPriorDayQuantity: 'multipleOfPriorDayQuantity',
  /** column name */
  MultipleOfWeeklyAveragePremium: 'multipleOfWeeklyAveragePremium',
  /** column name */
  MultipleOfWeeklyAverageQuantity: 'multipleOfWeeklyAverageQuantity',
  /** column name */
  Premium: 'premium',
  /** column name */
  PriorDayPremium: 'priorDayPremium',
  /** column name */
  PriorDayQuantity: 'priorDayQuantity',
  /** column name */
  Quantity: 'quantity',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TotalTradesToday: 'totalTradesToday',
  /** column name */
  WeeklyMovingAveragePremium: 'weeklyMovingAveragePremium',
  /** column name */
  WeeklyMovingAverageQuantity: 'weeklyMovingAverageQuantity',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalQuantity: 'weeklyTotalQuantity'
} as const;

export type Fa_Call_Moving_Average_Select_Column = typeof Fa_Call_Moving_Average_Select_Column[keyof typeof Fa_Call_Moving_Average_Select_Column];
/** aggregate stddev on columns */
export type Fa_Call_Moving_Average_Stddev_Fields = {
  __typename?: 'fa_call_moving_average_stddev_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fa_Call_Moving_Average_Stddev_Pop_Fields = {
  __typename?: 'fa_call_moving_average_stddev_pop_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fa_Call_Moving_Average_Stddev_Samp_Fields = {
  __typename?: 'fa_call_moving_average_stddev_samp_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fa_call_moving_average" */
export type Fa_Call_Moving_Average_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fa_Call_Moving_Average_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fa_Call_Moving_Average_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['date']>;
  monthlyMovingAveragePremium?: InputMaybe<Scalars['numeric']>;
  monthlyMovingAverageQuantity?: InputMaybe<Scalars['numeric']>;
  monthlyTotalPremium?: InputMaybe<Scalars['numeric']>;
  monthlyTotalQuantity?: InputMaybe<Scalars['numeric']>;
  multipleOfMonthlyAveragePremium?: InputMaybe<Scalars['numeric']>;
  multipleOfMonthlyAverageQuantity?: InputMaybe<Scalars['numeric']>;
  multipleOfPriorDayPremium?: InputMaybe<Scalars['numeric']>;
  multipleOfPriorDayQuantity?: InputMaybe<Scalars['numeric']>;
  multipleOfWeeklyAveragePremium?: InputMaybe<Scalars['numeric']>;
  multipleOfWeeklyAverageQuantity?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  priorDayPremium?: InputMaybe<Scalars['numeric']>;
  priorDayQuantity?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  totalTradesToday?: InputMaybe<Scalars['bigint']>;
  weeklyMovingAveragePremium?: InputMaybe<Scalars['numeric']>;
  weeklyMovingAverageQuantity?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalQuantity?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Fa_Call_Moving_Average_Sum_Fields = {
  __typename?: 'fa_call_moving_average_sum_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  monthlyTotalPremium?: Maybe<Scalars['numeric']>;
  monthlyTotalQuantity?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  priorDayPremium?: Maybe<Scalars['numeric']>;
  priorDayQuantity?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  totalTradesToday?: Maybe<Scalars['bigint']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalQuantity?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Fa_Call_Moving_Average_Var_Pop_Fields = {
  __typename?: 'fa_call_moving_average_var_pop_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fa_Call_Moving_Average_Var_Samp_Fields = {
  __typename?: 'fa_call_moving_average_var_samp_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fa_Call_Moving_Average_Variance_Fields = {
  __typename?: 'fa_call_moving_average_variance_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fa_put_moving_average" */
export type Fa_Put_Moving_Average = {
  __typename?: 'fa_put_moving_average';
  date?: Maybe<Scalars['date']>;
  monthlyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  monthlyTotalPremium?: Maybe<Scalars['numeric']>;
  monthlyTotalQuantity?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  priorDayPremium?: Maybe<Scalars['numeric']>;
  priorDayQuantity?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  totalTradesToday?: Maybe<Scalars['bigint']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalQuantity?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "fa_put_moving_average" */
export type Fa_Put_Moving_Average_Aggregate = {
  __typename?: 'fa_put_moving_average_aggregate';
  aggregate?: Maybe<Fa_Put_Moving_Average_Aggregate_Fields>;
  nodes: Array<Fa_Put_Moving_Average>;
};

/** aggregate fields of "fa_put_moving_average" */
export type Fa_Put_Moving_Average_Aggregate_Fields = {
  __typename?: 'fa_put_moving_average_aggregate_fields';
  avg?: Maybe<Fa_Put_Moving_Average_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fa_Put_Moving_Average_Max_Fields>;
  min?: Maybe<Fa_Put_Moving_Average_Min_Fields>;
  stddev?: Maybe<Fa_Put_Moving_Average_Stddev_Fields>;
  stddev_pop?: Maybe<Fa_Put_Moving_Average_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fa_Put_Moving_Average_Stddev_Samp_Fields>;
  sum?: Maybe<Fa_Put_Moving_Average_Sum_Fields>;
  var_pop?: Maybe<Fa_Put_Moving_Average_Var_Pop_Fields>;
  var_samp?: Maybe<Fa_Put_Moving_Average_Var_Samp_Fields>;
  variance?: Maybe<Fa_Put_Moving_Average_Variance_Fields>;
};


/** aggregate fields of "fa_put_moving_average" */
export type Fa_Put_Moving_Average_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fa_Put_Moving_Average_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fa_Put_Moving_Average_Avg_Fields = {
  __typename?: 'fa_put_moving_average_avg_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fa_put_moving_average". All fields are combined with a logical 'AND'. */
export type Fa_Put_Moving_Average_Bool_Exp = {
  _and?: InputMaybe<Array<Fa_Put_Moving_Average_Bool_Exp>>;
  _not?: InputMaybe<Fa_Put_Moving_Average_Bool_Exp>;
  _or?: InputMaybe<Array<Fa_Put_Moving_Average_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  monthlyMovingAveragePremium?: InputMaybe<Numeric_Comparison_Exp>;
  monthlyMovingAverageQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  monthlyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  monthlyTotalQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  multipleOfMonthlyAveragePremium?: InputMaybe<Numeric_Comparison_Exp>;
  multipleOfMonthlyAverageQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  multipleOfPriorDayPremium?: InputMaybe<Numeric_Comparison_Exp>;
  multipleOfPriorDayQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  multipleOfWeeklyAveragePremium?: InputMaybe<Numeric_Comparison_Exp>;
  multipleOfWeeklyAverageQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  priorDayPremium?: InputMaybe<Numeric_Comparison_Exp>;
  priorDayQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  totalTradesToday?: InputMaybe<Bigint_Comparison_Exp>;
  weeklyMovingAveragePremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyMovingAverageQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalQuantity?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fa_Put_Moving_Average_Max_Fields = {
  __typename?: 'fa_put_moving_average_max_fields';
  date?: Maybe<Scalars['date']>;
  monthlyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  monthlyTotalPremium?: Maybe<Scalars['numeric']>;
  monthlyTotalQuantity?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  priorDayPremium?: Maybe<Scalars['numeric']>;
  priorDayQuantity?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  totalTradesToday?: Maybe<Scalars['bigint']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalQuantity?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Fa_Put_Moving_Average_Min_Fields = {
  __typename?: 'fa_put_moving_average_min_fields';
  date?: Maybe<Scalars['date']>;
  monthlyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  monthlyTotalPremium?: Maybe<Scalars['numeric']>;
  monthlyTotalQuantity?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  priorDayPremium?: Maybe<Scalars['numeric']>;
  priorDayQuantity?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  totalTradesToday?: Maybe<Scalars['bigint']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalQuantity?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "fa_put_moving_average". */
export type Fa_Put_Moving_Average_Order_By = {
  date?: InputMaybe<Order_By>;
  monthlyMovingAveragePremium?: InputMaybe<Order_By>;
  monthlyMovingAverageQuantity?: InputMaybe<Order_By>;
  monthlyTotalPremium?: InputMaybe<Order_By>;
  monthlyTotalQuantity?: InputMaybe<Order_By>;
  multipleOfMonthlyAveragePremium?: InputMaybe<Order_By>;
  multipleOfMonthlyAverageQuantity?: InputMaybe<Order_By>;
  multipleOfPriorDayPremium?: InputMaybe<Order_By>;
  multipleOfPriorDayQuantity?: InputMaybe<Order_By>;
  multipleOfWeeklyAveragePremium?: InputMaybe<Order_By>;
  multipleOfWeeklyAverageQuantity?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  priorDayPremium?: InputMaybe<Order_By>;
  priorDayQuantity?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  totalTradesToday?: InputMaybe<Order_By>;
  weeklyMovingAveragePremium?: InputMaybe<Order_By>;
  weeklyMovingAverageQuantity?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalQuantity?: InputMaybe<Order_By>;
};

/** select columns of table "fa_put_moving_average" */
export const Fa_Put_Moving_Average_Select_Column = {
  /** column name */
  Date: 'date',
  /** column name */
  MonthlyMovingAveragePremium: 'monthlyMovingAveragePremium',
  /** column name */
  MonthlyMovingAverageQuantity: 'monthlyMovingAverageQuantity',
  /** column name */
  MonthlyTotalPremium: 'monthlyTotalPremium',
  /** column name */
  MonthlyTotalQuantity: 'monthlyTotalQuantity',
  /** column name */
  MultipleOfMonthlyAveragePremium: 'multipleOfMonthlyAveragePremium',
  /** column name */
  MultipleOfMonthlyAverageQuantity: 'multipleOfMonthlyAverageQuantity',
  /** column name */
  MultipleOfPriorDayPremium: 'multipleOfPriorDayPremium',
  /** column name */
  MultipleOfPriorDayQuantity: 'multipleOfPriorDayQuantity',
  /** column name */
  MultipleOfWeeklyAveragePremium: 'multipleOfWeeklyAveragePremium',
  /** column name */
  MultipleOfWeeklyAverageQuantity: 'multipleOfWeeklyAverageQuantity',
  /** column name */
  Premium: 'premium',
  /** column name */
  PriorDayPremium: 'priorDayPremium',
  /** column name */
  PriorDayQuantity: 'priorDayQuantity',
  /** column name */
  Quantity: 'quantity',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TotalTradesToday: 'totalTradesToday',
  /** column name */
  WeeklyMovingAveragePremium: 'weeklyMovingAveragePremium',
  /** column name */
  WeeklyMovingAverageQuantity: 'weeklyMovingAverageQuantity',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalQuantity: 'weeklyTotalQuantity'
} as const;

export type Fa_Put_Moving_Average_Select_Column = typeof Fa_Put_Moving_Average_Select_Column[keyof typeof Fa_Put_Moving_Average_Select_Column];
/** aggregate stddev on columns */
export type Fa_Put_Moving_Average_Stddev_Fields = {
  __typename?: 'fa_put_moving_average_stddev_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fa_Put_Moving_Average_Stddev_Pop_Fields = {
  __typename?: 'fa_put_moving_average_stddev_pop_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fa_Put_Moving_Average_Stddev_Samp_Fields = {
  __typename?: 'fa_put_moving_average_stddev_samp_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fa_put_moving_average" */
export type Fa_Put_Moving_Average_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fa_Put_Moving_Average_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fa_Put_Moving_Average_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['date']>;
  monthlyMovingAveragePremium?: InputMaybe<Scalars['numeric']>;
  monthlyMovingAverageQuantity?: InputMaybe<Scalars['numeric']>;
  monthlyTotalPremium?: InputMaybe<Scalars['numeric']>;
  monthlyTotalQuantity?: InputMaybe<Scalars['numeric']>;
  multipleOfMonthlyAveragePremium?: InputMaybe<Scalars['numeric']>;
  multipleOfMonthlyAverageQuantity?: InputMaybe<Scalars['numeric']>;
  multipleOfPriorDayPremium?: InputMaybe<Scalars['numeric']>;
  multipleOfPriorDayQuantity?: InputMaybe<Scalars['numeric']>;
  multipleOfWeeklyAveragePremium?: InputMaybe<Scalars['numeric']>;
  multipleOfWeeklyAverageQuantity?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  priorDayPremium?: InputMaybe<Scalars['numeric']>;
  priorDayQuantity?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  totalTradesToday?: InputMaybe<Scalars['bigint']>;
  weeklyMovingAveragePremium?: InputMaybe<Scalars['numeric']>;
  weeklyMovingAverageQuantity?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalQuantity?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Fa_Put_Moving_Average_Sum_Fields = {
  __typename?: 'fa_put_moving_average_sum_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  monthlyTotalPremium?: Maybe<Scalars['numeric']>;
  monthlyTotalQuantity?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['numeric']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['numeric']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  priorDayPremium?: Maybe<Scalars['numeric']>;
  priorDayQuantity?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  totalTradesToday?: Maybe<Scalars['bigint']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['numeric']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalQuantity?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Fa_Put_Moving_Average_Var_Pop_Fields = {
  __typename?: 'fa_put_moving_average_var_pop_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fa_Put_Moving_Average_Var_Samp_Fields = {
  __typename?: 'fa_put_moving_average_var_samp_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fa_Put_Moving_Average_Variance_Fields = {
  __typename?: 'fa_put_moving_average_variance_fields';
  monthlyMovingAveragePremium?: Maybe<Scalars['Float']>;
  monthlyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  monthlyTotalPremium?: Maybe<Scalars['Float']>;
  monthlyTotalQuantity?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfMonthlyAverageQuantity?: Maybe<Scalars['Float']>;
  multipleOfPriorDayPremium?: Maybe<Scalars['Float']>;
  multipleOfPriorDayQuantity?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAveragePremium?: Maybe<Scalars['Float']>;
  multipleOfWeeklyAverageQuantity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  priorDayPremium?: Maybe<Scalars['Float']>;
  priorDayQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  totalTradesToday?: Maybe<Scalars['Float']>;
  weeklyMovingAveragePremium?: Maybe<Scalars['Float']>;
  weeklyMovingAverageQuantity?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalQuantity?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fa_trade_uploads" */
export type Fa_Trade_Uploads = {
  __typename?: 'fa_trade_uploads';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  numberOfTrades: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "fa_trade_uploads" */
export type Fa_Trade_Uploads_Aggregate = {
  __typename?: 'fa_trade_uploads_aggregate';
  aggregate?: Maybe<Fa_Trade_Uploads_Aggregate_Fields>;
  nodes: Array<Fa_Trade_Uploads>;
};

/** aggregate fields of "fa_trade_uploads" */
export type Fa_Trade_Uploads_Aggregate_Fields = {
  __typename?: 'fa_trade_uploads_aggregate_fields';
  avg?: Maybe<Fa_Trade_Uploads_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fa_Trade_Uploads_Max_Fields>;
  min?: Maybe<Fa_Trade_Uploads_Min_Fields>;
  stddev?: Maybe<Fa_Trade_Uploads_Stddev_Fields>;
  stddev_pop?: Maybe<Fa_Trade_Uploads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fa_Trade_Uploads_Stddev_Samp_Fields>;
  sum?: Maybe<Fa_Trade_Uploads_Sum_Fields>;
  var_pop?: Maybe<Fa_Trade_Uploads_Var_Pop_Fields>;
  var_samp?: Maybe<Fa_Trade_Uploads_Var_Samp_Fields>;
  variance?: Maybe<Fa_Trade_Uploads_Variance_Fields>;
};


/** aggregate fields of "fa_trade_uploads" */
export type Fa_Trade_Uploads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fa_Trade_Uploads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fa_Trade_Uploads_Avg_Fields = {
  __typename?: 'fa_trade_uploads_avg_fields';
  numberOfTrades?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fa_trade_uploads". All fields are combined with a logical 'AND'. */
export type Fa_Trade_Uploads_Bool_Exp = {
  _and?: InputMaybe<Array<Fa_Trade_Uploads_Bool_Exp>>;
  _not?: InputMaybe<Fa_Trade_Uploads_Bool_Exp>;
  _or?: InputMaybe<Array<Fa_Trade_Uploads_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  numberOfTrades?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "fa_trade_uploads" */
export const Fa_Trade_Uploads_Constraint = {
  /** unique or primary key constraint on columns "id" */
  FaTradeUploadsPkey: 'fa_trade_uploads_pkey'
} as const;

export type Fa_Trade_Uploads_Constraint = typeof Fa_Trade_Uploads_Constraint[keyof typeof Fa_Trade_Uploads_Constraint];
/** input type for incrementing numeric columns in table "fa_trade_uploads" */
export type Fa_Trade_Uploads_Inc_Input = {
  numberOfTrades?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "fa_trade_uploads" */
export type Fa_Trade_Uploads_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  numberOfTrades?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Fa_Trade_Uploads_Max_Fields = {
  __typename?: 'fa_trade_uploads_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  numberOfTrades?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Fa_Trade_Uploads_Min_Fields = {
  __typename?: 'fa_trade_uploads_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  numberOfTrades?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "fa_trade_uploads" */
export type Fa_Trade_Uploads_Mutation_Response = {
  __typename?: 'fa_trade_uploads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fa_Trade_Uploads>;
};

/** on_conflict condition type for table "fa_trade_uploads" */
export type Fa_Trade_Uploads_On_Conflict = {
  constraint: Fa_Trade_Uploads_Constraint;
  update_columns?: Array<Fa_Trade_Uploads_Update_Column>;
  where?: InputMaybe<Fa_Trade_Uploads_Bool_Exp>;
};

/** Ordering options when selecting data from "fa_trade_uploads". */
export type Fa_Trade_Uploads_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  numberOfTrades?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fa_trade_uploads */
export type Fa_Trade_Uploads_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "fa_trade_uploads" */
export const Fa_Trade_Uploads_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  NumberOfTrades: 'numberOfTrades',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Fa_Trade_Uploads_Select_Column = typeof Fa_Trade_Uploads_Select_Column[keyof typeof Fa_Trade_Uploads_Select_Column];
/** input type for updating data in table "fa_trade_uploads" */
export type Fa_Trade_Uploads_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  numberOfTrades?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Fa_Trade_Uploads_Stddev_Fields = {
  __typename?: 'fa_trade_uploads_stddev_fields';
  numberOfTrades?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fa_Trade_Uploads_Stddev_Pop_Fields = {
  __typename?: 'fa_trade_uploads_stddev_pop_fields';
  numberOfTrades?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fa_Trade_Uploads_Stddev_Samp_Fields = {
  __typename?: 'fa_trade_uploads_stddev_samp_fields';
  numberOfTrades?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fa_trade_uploads" */
export type Fa_Trade_Uploads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fa_Trade_Uploads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fa_Trade_Uploads_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  numberOfTrades?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Fa_Trade_Uploads_Sum_Fields = {
  __typename?: 'fa_trade_uploads_sum_fields';
  numberOfTrades?: Maybe<Scalars['Int']>;
};

/** update columns of table "fa_trade_uploads" */
export const Fa_Trade_Uploads_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  NumberOfTrades: 'numberOfTrades',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Fa_Trade_Uploads_Update_Column = typeof Fa_Trade_Uploads_Update_Column[keyof typeof Fa_Trade_Uploads_Update_Column];
export type Fa_Trade_Uploads_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fa_Trade_Uploads_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fa_Trade_Uploads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fa_Trade_Uploads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fa_Trade_Uploads_Var_Pop_Fields = {
  __typename?: 'fa_trade_uploads_var_pop_fields';
  numberOfTrades?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fa_Trade_Uploads_Var_Samp_Fields = {
  __typename?: 'fa_trade_uploads_var_samp_fields';
  numberOfTrades?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fa_Trade_Uploads_Variance_Fields = {
  __typename?: 'fa_trade_uploads_variance_fields';
  numberOfTrades?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fa_trades" */
export type Fa_Trades = {
  __typename?: 'fa_trades';
  createdAt: Scalars['timestamptz'];
  date: Scalars['String'];
  expiry: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['uuid'];
  isInPowerbi: Scalars['Boolean'];
  openInterest: Scalars['numeric'];
  optionType: Scalars['String'];
  orderType: Scalars['String'];
  premium: Scalars['String'];
  premiumAsNumber?: Maybe<Scalars['numeric']>;
  price: Scalars['numeric'];
  qty: Scalars['numeric'];
  sector: Scalars['String'];
  spot: Scalars['numeric'];
  strike: Scalars['numeric'];
  ticker: Scalars['String'];
  time: Scalars['String'];
  unusual: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
  volume: Scalars['numeric'];
};

/** aggregated selection of "fa_trades" */
export type Fa_Trades_Aggregate = {
  __typename?: 'fa_trades_aggregate';
  aggregate?: Maybe<Fa_Trades_Aggregate_Fields>;
  nodes: Array<Fa_Trades>;
};

/** aggregate fields of "fa_trades" */
export type Fa_Trades_Aggregate_Fields = {
  __typename?: 'fa_trades_aggregate_fields';
  avg?: Maybe<Fa_Trades_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fa_Trades_Max_Fields>;
  min?: Maybe<Fa_Trades_Min_Fields>;
  stddev?: Maybe<Fa_Trades_Stddev_Fields>;
  stddev_pop?: Maybe<Fa_Trades_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fa_Trades_Stddev_Samp_Fields>;
  sum?: Maybe<Fa_Trades_Sum_Fields>;
  var_pop?: Maybe<Fa_Trades_Var_Pop_Fields>;
  var_samp?: Maybe<Fa_Trades_Var_Samp_Fields>;
  variance?: Maybe<Fa_Trades_Variance_Fields>;
};


/** aggregate fields of "fa_trades" */
export type Fa_Trades_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fa_Trades_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fa_Trades_Avg_Fields = {
  __typename?: 'fa_trades_avg_fields';
  openInterest?: Maybe<Scalars['Float']>;
  premiumAsNumber?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fa_trades". All fields are combined with a logical 'AND'. */
export type Fa_Trades_Bool_Exp = {
  _and?: InputMaybe<Array<Fa_Trades_Bool_Exp>>;
  _not?: InputMaybe<Fa_Trades_Bool_Exp>;
  _or?: InputMaybe<Array<Fa_Trades_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<String_Comparison_Exp>;
  expiry?: InputMaybe<String_Comparison_Exp>;
  externalId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isInPowerbi?: InputMaybe<Boolean_Comparison_Exp>;
  openInterest?: InputMaybe<Numeric_Comparison_Exp>;
  optionType?: InputMaybe<String_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  premium?: InputMaybe<String_Comparison_Exp>;
  premiumAsNumber?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  qty?: InputMaybe<Numeric_Comparison_Exp>;
  sector?: InputMaybe<String_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  time?: InputMaybe<String_Comparison_Exp>;
  unusual?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  volume?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "fa_trades" */
export const Fa_Trades_Constraint = {
  /** unique or primary key constraint on columns "externalId" */
  FaTradesExternalIdKey: 'fa_trades_externalId_key',
  /** unique or primary key constraint on columns "id" */
  FaTradesPkey: 'fa_trades_pkey'
} as const;

export type Fa_Trades_Constraint = typeof Fa_Trades_Constraint[keyof typeof Fa_Trades_Constraint];
/** input type for incrementing numeric columns in table "fa_trades" */
export type Fa_Trades_Inc_Input = {
  openInterest?: InputMaybe<Scalars['numeric']>;
  premiumAsNumber?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  qty?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  volume?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "fa_trades" */
export type Fa_Trades_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['String']>;
  expiry?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInPowerbi?: InputMaybe<Scalars['Boolean']>;
  openInterest?: InputMaybe<Scalars['numeric']>;
  optionType?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  premium?: InputMaybe<Scalars['String']>;
  premiumAsNumber?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  qty?: InputMaybe<Scalars['numeric']>;
  sector?: InputMaybe<Scalars['String']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
  unusual?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  volume?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Fa_Trades_Max_Fields = {
  __typename?: 'fa_trades_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  openInterest?: Maybe<Scalars['numeric']>;
  optionType?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
  premium?: Maybe<Scalars['String']>;
  premiumAsNumber?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  qty?: Maybe<Scalars['numeric']>;
  sector?: Maybe<Scalars['String']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  volume?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Fa_Trades_Min_Fields = {
  __typename?: 'fa_trades_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  openInterest?: Maybe<Scalars['numeric']>;
  optionType?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
  premium?: Maybe<Scalars['String']>;
  premiumAsNumber?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  qty?: Maybe<Scalars['numeric']>;
  sector?: Maybe<Scalars['String']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  volume?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "fa_trades" */
export type Fa_Trades_Mutation_Response = {
  __typename?: 'fa_trades_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fa_Trades>;
};

/** on_conflict condition type for table "fa_trades" */
export type Fa_Trades_On_Conflict = {
  constraint: Fa_Trades_Constraint;
  update_columns?: Array<Fa_Trades_Update_Column>;
  where?: InputMaybe<Fa_Trades_Bool_Exp>;
};

/** Ordering options when selecting data from "fa_trades". */
export type Fa_Trades_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  expiry?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isInPowerbi?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  optionType?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  premiumAsNumber?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  sector?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  unusual?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fa_trades */
export type Fa_Trades_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "fa_trades" */
export const Fa_Trades_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  Expiry: 'expiry',
  /** column name */
  ExternalId: 'externalId',
  /** column name */
  Id: 'id',
  /** column name */
  IsInPowerbi: 'isInPowerbi',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OptionType: 'optionType',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  Premium: 'premium',
  /** column name */
  PremiumAsNumber: 'premiumAsNumber',
  /** column name */
  Price: 'price',
  /** column name */
  Qty: 'qty',
  /** column name */
  Sector: 'sector',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Time: 'time',
  /** column name */
  Unusual: 'unusual',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Volume: 'volume'
} as const;

export type Fa_Trades_Select_Column = typeof Fa_Trades_Select_Column[keyof typeof Fa_Trades_Select_Column];
/** input type for updating data in table "fa_trades" */
export type Fa_Trades_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['String']>;
  expiry?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInPowerbi?: InputMaybe<Scalars['Boolean']>;
  openInterest?: InputMaybe<Scalars['numeric']>;
  optionType?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  premium?: InputMaybe<Scalars['String']>;
  premiumAsNumber?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  qty?: InputMaybe<Scalars['numeric']>;
  sector?: InputMaybe<Scalars['String']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
  unusual?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  volume?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Fa_Trades_Stddev_Fields = {
  __typename?: 'fa_trades_stddev_fields';
  openInterest?: Maybe<Scalars['Float']>;
  premiumAsNumber?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fa_Trades_Stddev_Pop_Fields = {
  __typename?: 'fa_trades_stddev_pop_fields';
  openInterest?: Maybe<Scalars['Float']>;
  premiumAsNumber?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fa_Trades_Stddev_Samp_Fields = {
  __typename?: 'fa_trades_stddev_samp_fields';
  openInterest?: Maybe<Scalars['Float']>;
  premiumAsNumber?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fa_trades" */
export type Fa_Trades_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fa_Trades_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fa_Trades_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['String']>;
  expiry?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInPowerbi?: InputMaybe<Scalars['Boolean']>;
  openInterest?: InputMaybe<Scalars['numeric']>;
  optionType?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  premium?: InputMaybe<Scalars['String']>;
  premiumAsNumber?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  qty?: InputMaybe<Scalars['numeric']>;
  sector?: InputMaybe<Scalars['String']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
  unusual?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  volume?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Fa_Trades_Sum_Fields = {
  __typename?: 'fa_trades_sum_fields';
  openInterest?: Maybe<Scalars['numeric']>;
  premiumAsNumber?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  qty?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  volume?: Maybe<Scalars['numeric']>;
};

/** update columns of table "fa_trades" */
export const Fa_Trades_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  Expiry: 'expiry',
  /** column name */
  ExternalId: 'externalId',
  /** column name */
  Id: 'id',
  /** column name */
  IsInPowerbi: 'isInPowerbi',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OptionType: 'optionType',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  Premium: 'premium',
  /** column name */
  PremiumAsNumber: 'premiumAsNumber',
  /** column name */
  Price: 'price',
  /** column name */
  Qty: 'qty',
  /** column name */
  Sector: 'sector',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Time: 'time',
  /** column name */
  Unusual: 'unusual',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Volume: 'volume'
} as const;

export type Fa_Trades_Update_Column = typeof Fa_Trades_Update_Column[keyof typeof Fa_Trades_Update_Column];
export type Fa_Trades_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fa_Trades_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fa_Trades_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fa_Trades_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fa_Trades_Var_Pop_Fields = {
  __typename?: 'fa_trades_var_pop_fields';
  openInterest?: Maybe<Scalars['Float']>;
  premiumAsNumber?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fa_Trades_Var_Samp_Fields = {
  __typename?: 'fa_trades_var_samp_fields';
  openInterest?: Maybe<Scalars['Float']>;
  premiumAsNumber?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fa_Trades_Variance_Fields = {
  __typename?: 'fa_trades_variance_fields';
  openInterest?: Maybe<Scalars['Float']>;
  premiumAsNumber?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "feedback_boards" */
export type Feedback_Boards = {
  __typename?: 'feedback_boards';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  key: Scalars['String'];
  name: Scalars['String'];
  /** An array relationship */
  posts: Array<Feedback_Posts>;
  /** An aggregate relationship */
  posts_aggregate: Feedback_Posts_Aggregate;
  sortOrder: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "feedback_boards" */
export type Feedback_BoardsPostsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_Bool_Exp>;
};


/** columns and relationships of "feedback_boards" */
export type Feedback_BoardsPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_Bool_Exp>;
};

/** aggregated selection of "feedback_boards" */
export type Feedback_Boards_Aggregate = {
  __typename?: 'feedback_boards_aggregate';
  aggregate?: Maybe<Feedback_Boards_Aggregate_Fields>;
  nodes: Array<Feedback_Boards>;
};

/** aggregate fields of "feedback_boards" */
export type Feedback_Boards_Aggregate_Fields = {
  __typename?: 'feedback_boards_aggregate_fields';
  avg?: Maybe<Feedback_Boards_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Feedback_Boards_Max_Fields>;
  min?: Maybe<Feedback_Boards_Min_Fields>;
  stddev?: Maybe<Feedback_Boards_Stddev_Fields>;
  stddev_pop?: Maybe<Feedback_Boards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feedback_Boards_Stddev_Samp_Fields>;
  sum?: Maybe<Feedback_Boards_Sum_Fields>;
  var_pop?: Maybe<Feedback_Boards_Var_Pop_Fields>;
  var_samp?: Maybe<Feedback_Boards_Var_Samp_Fields>;
  variance?: Maybe<Feedback_Boards_Variance_Fields>;
};


/** aggregate fields of "feedback_boards" */
export type Feedback_Boards_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Boards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Feedback_Boards_Avg_Fields = {
  __typename?: 'feedback_boards_avg_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "feedback_boards". All fields are combined with a logical 'AND'. */
export type Feedback_Boards_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Boards_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Boards_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Boards_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  posts?: InputMaybe<Feedback_Posts_Bool_Exp>;
  posts_aggregate?: InputMaybe<Feedback_Posts_Aggregate_Bool_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedback_boards" */
export const Feedback_Boards_Constraint = {
  /** unique or primary key constraint on columns "key" */
  FeedbackBoardsKeyKey: 'feedback_boards_key_key',
  /** unique or primary key constraint on columns "id" */
  FeedbackBoardsPkey: 'feedback_boards_pkey'
} as const;

export type Feedback_Boards_Constraint = typeof Feedback_Boards_Constraint[keyof typeof Feedback_Boards_Constraint];
/** input type for incrementing numeric columns in table "feedback_boards" */
export type Feedback_Boards_Inc_Input = {
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "feedback_boards" */
export type Feedback_Boards_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  posts?: InputMaybe<Feedback_Posts_Arr_Rel_Insert_Input>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Feedback_Boards_Max_Fields = {
  __typename?: 'feedback_boards_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Feedback_Boards_Min_Fields = {
  __typename?: 'feedback_boards_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "feedback_boards" */
export type Feedback_Boards_Mutation_Response = {
  __typename?: 'feedback_boards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback_Boards>;
};

/** input type for inserting object relation for remote table "feedback_boards" */
export type Feedback_Boards_Obj_Rel_Insert_Input = {
  data: Feedback_Boards_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Feedback_Boards_On_Conflict>;
};

/** on_conflict condition type for table "feedback_boards" */
export type Feedback_Boards_On_Conflict = {
  constraint: Feedback_Boards_Constraint;
  update_columns?: Array<Feedback_Boards_Update_Column>;
  where?: InputMaybe<Feedback_Boards_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback_boards". */
export type Feedback_Boards_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  posts_aggregate?: InputMaybe<Feedback_Posts_Aggregate_Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feedback_boards */
export type Feedback_Boards_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "feedback_boards" */
export const Feedback_Boards_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Key: 'key',
  /** column name */
  Name: 'name',
  /** column name */
  SortOrder: 'sortOrder',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Feedback_Boards_Select_Column = typeof Feedback_Boards_Select_Column[keyof typeof Feedback_Boards_Select_Column];
/** input type for updating data in table "feedback_boards" */
export type Feedback_Boards_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Feedback_Boards_Stddev_Fields = {
  __typename?: 'feedback_boards_stddev_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Feedback_Boards_Stddev_Pop_Fields = {
  __typename?: 'feedback_boards_stddev_pop_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Feedback_Boards_Stddev_Samp_Fields = {
  __typename?: 'feedback_boards_stddev_samp_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "feedback_boards" */
export type Feedback_Boards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Boards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Boards_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Feedback_Boards_Sum_Fields = {
  __typename?: 'feedback_boards_sum_fields';
  sortOrder?: Maybe<Scalars['Int']>;
};

/** update columns of table "feedback_boards" */
export const Feedback_Boards_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Key: 'key',
  /** column name */
  Name: 'name',
  /** column name */
  SortOrder: 'sortOrder',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Feedback_Boards_Update_Column = typeof Feedback_Boards_Update_Column[keyof typeof Feedback_Boards_Update_Column];
export type Feedback_Boards_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feedback_Boards_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Boards_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Boards_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feedback_Boards_Var_Pop_Fields = {
  __typename?: 'feedback_boards_var_pop_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Feedback_Boards_Var_Samp_Fields = {
  __typename?: 'feedback_boards_var_samp_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Feedback_Boards_Variance_Fields = {
  __typename?: 'feedback_boards_variance_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "feedback_comments" */
export type Feedback_Comments = {
  __typename?: 'feedback_comments';
  /** An object relationship */
  author?: Maybe<Users>;
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName: Scalars['String'];
  authorUserId?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  isInternal: Scalars['Boolean'];
  isTeam: Scalars['Boolean'];
  /** An array relationship */
  media: Array<Feedback_Media>;
  /** An aggregate relationship */
  media_aggregate: Feedback_Media_Aggregate;
  /** An object relationship */
  originPost?: Maybe<Feedback_Posts>;
  originPostId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  parent?: Maybe<Feedback_Comments>;
  parentCommentId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  post: Feedback_Posts;
  postId: Scalars['uuid'];
  /** An array relationship */
  replies: Array<Feedback_Comments>;
  /** An aggregate relationship */
  replies_aggregate: Feedback_Comments_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "feedback_comments" */
export type Feedback_CommentsMediaArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Media_Order_By>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};


/** columns and relationships of "feedback_comments" */
export type Feedback_CommentsMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Media_Order_By>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};


/** columns and relationships of "feedback_comments" */
export type Feedback_CommentsRepliesArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Comments_Order_By>>;
  where?: InputMaybe<Feedback_Comments_Bool_Exp>;
};


/** columns and relationships of "feedback_comments" */
export type Feedback_CommentsReplies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Comments_Order_By>>;
  where?: InputMaybe<Feedback_Comments_Bool_Exp>;
};

/** aggregated selection of "feedback_comments" */
export type Feedback_Comments_Aggregate = {
  __typename?: 'feedback_comments_aggregate';
  aggregate?: Maybe<Feedback_Comments_Aggregate_Fields>;
  nodes: Array<Feedback_Comments>;
};

export type Feedback_Comments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Feedback_Comments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Feedback_Comments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Feedback_Comments_Aggregate_Bool_Exp_Count>;
};

export type Feedback_Comments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Feedback_Comments_Select_Column_Feedback_Comments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Feedback_Comments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Feedback_Comments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Feedback_Comments_Select_Column_Feedback_Comments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Feedback_Comments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Feedback_Comments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Feedback_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Feedback_Comments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "feedback_comments" */
export type Feedback_Comments_Aggregate_Fields = {
  __typename?: 'feedback_comments_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Feedback_Comments_Max_Fields>;
  min?: Maybe<Feedback_Comments_Min_Fields>;
};


/** aggregate fields of "feedback_comments" */
export type Feedback_Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "feedback_comments" */
export type Feedback_Comments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Feedback_Comments_Max_Order_By>;
  min?: InputMaybe<Feedback_Comments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "feedback_comments" */
export type Feedback_Comments_Arr_Rel_Insert_Input = {
  data: Array<Feedback_Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Feedback_Comments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "feedback_comments". All fields are combined with a logical 'AND'. */
export type Feedback_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Comments_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Comments_Bool_Exp>>;
  author?: InputMaybe<Users_Bool_Exp>;
  authorAvatarUrl?: InputMaybe<String_Comparison_Exp>;
  authorDisplayName?: InputMaybe<String_Comparison_Exp>;
  authorUserId?: InputMaybe<String_Comparison_Exp>;
  body?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isInternal?: InputMaybe<Boolean_Comparison_Exp>;
  isTeam?: InputMaybe<Boolean_Comparison_Exp>;
  media?: InputMaybe<Feedback_Media_Bool_Exp>;
  media_aggregate?: InputMaybe<Feedback_Media_Aggregate_Bool_Exp>;
  originPost?: InputMaybe<Feedback_Posts_Bool_Exp>;
  originPostId?: InputMaybe<Uuid_Comparison_Exp>;
  parent?: InputMaybe<Feedback_Comments_Bool_Exp>;
  parentCommentId?: InputMaybe<Uuid_Comparison_Exp>;
  post?: InputMaybe<Feedback_Posts_Bool_Exp>;
  postId?: InputMaybe<Uuid_Comparison_Exp>;
  replies?: InputMaybe<Feedback_Comments_Bool_Exp>;
  replies_aggregate?: InputMaybe<Feedback_Comments_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedback_comments" */
export const Feedback_Comments_Constraint = {
  /** unique or primary key constraint on columns "id", "postId" */
  FeedbackCommentsIdPostIdKey: 'feedback_comments_id_postId_key',
  /** unique or primary key constraint on columns "id" */
  FeedbackCommentsPkey: 'feedback_comments_pkey'
} as const;

export type Feedback_Comments_Constraint = typeof Feedback_Comments_Constraint[keyof typeof Feedback_Comments_Constraint];
/** input type for inserting data into table "feedback_comments" */
export type Feedback_Comments_Insert_Input = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  authorAvatarUrl?: InputMaybe<Scalars['String']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorUserId?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInternal?: InputMaybe<Scalars['Boolean']>;
  isTeam?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<Feedback_Media_Arr_Rel_Insert_Input>;
  originPost?: InputMaybe<Feedback_Posts_Obj_Rel_Insert_Input>;
  originPostId?: InputMaybe<Scalars['uuid']>;
  parent?: InputMaybe<Feedback_Comments_Obj_Rel_Insert_Input>;
  parentCommentId?: InputMaybe<Scalars['uuid']>;
  post?: InputMaybe<Feedback_Posts_Obj_Rel_Insert_Input>;
  postId?: InputMaybe<Scalars['uuid']>;
  replies?: InputMaybe<Feedback_Comments_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Feedback_Comments_Max_Fields = {
  __typename?: 'feedback_comments_max_fields';
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName?: Maybe<Scalars['String']>;
  authorUserId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  originPostId?: Maybe<Scalars['uuid']>;
  parentCommentId?: Maybe<Scalars['uuid']>;
  postId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "feedback_comments" */
export type Feedback_Comments_Max_Order_By = {
  authorAvatarUrl?: InputMaybe<Order_By>;
  authorDisplayName?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originPostId?: InputMaybe<Order_By>;
  parentCommentId?: InputMaybe<Order_By>;
  postId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Feedback_Comments_Min_Fields = {
  __typename?: 'feedback_comments_min_fields';
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName?: Maybe<Scalars['String']>;
  authorUserId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  originPostId?: Maybe<Scalars['uuid']>;
  parentCommentId?: Maybe<Scalars['uuid']>;
  postId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "feedback_comments" */
export type Feedback_Comments_Min_Order_By = {
  authorAvatarUrl?: InputMaybe<Order_By>;
  authorDisplayName?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originPostId?: InputMaybe<Order_By>;
  parentCommentId?: InputMaybe<Order_By>;
  postId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "feedback_comments" */
export type Feedback_Comments_Mutation_Response = {
  __typename?: 'feedback_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback_Comments>;
};

/** input type for inserting object relation for remote table "feedback_comments" */
export type Feedback_Comments_Obj_Rel_Insert_Input = {
  data: Feedback_Comments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Feedback_Comments_On_Conflict>;
};

/** on_conflict condition type for table "feedback_comments" */
export type Feedback_Comments_On_Conflict = {
  constraint: Feedback_Comments_Constraint;
  update_columns?: Array<Feedback_Comments_Update_Column>;
  where?: InputMaybe<Feedback_Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback_comments". */
export type Feedback_Comments_Order_By = {
  author?: InputMaybe<Users_Order_By>;
  authorAvatarUrl?: InputMaybe<Order_By>;
  authorDisplayName?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isInternal?: InputMaybe<Order_By>;
  isTeam?: InputMaybe<Order_By>;
  media_aggregate?: InputMaybe<Feedback_Media_Aggregate_Order_By>;
  originPost?: InputMaybe<Feedback_Posts_Order_By>;
  originPostId?: InputMaybe<Order_By>;
  parent?: InputMaybe<Feedback_Comments_Order_By>;
  parentCommentId?: InputMaybe<Order_By>;
  post?: InputMaybe<Feedback_Posts_Order_By>;
  postId?: InputMaybe<Order_By>;
  replies_aggregate?: InputMaybe<Feedback_Comments_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feedback_comments */
export type Feedback_Comments_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "feedback_comments" */
export const Feedback_Comments_Select_Column = {
  /** column name */
  AuthorAvatarUrl: 'authorAvatarUrl',
  /** column name */
  AuthorDisplayName: 'authorDisplayName',
  /** column name */
  AuthorUserId: 'authorUserId',
  /** column name */
  Body: 'body',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  IsInternal: 'isInternal',
  /** column name */
  IsTeam: 'isTeam',
  /** column name */
  OriginPostId: 'originPostId',
  /** column name */
  ParentCommentId: 'parentCommentId',
  /** column name */
  PostId: 'postId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Feedback_Comments_Select_Column = typeof Feedback_Comments_Select_Column[keyof typeof Feedback_Comments_Select_Column];
/** select "feedback_comments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "feedback_comments" */
export const Feedback_Comments_Select_Column_Feedback_Comments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  IsInternal: 'isInternal',
  /** column name */
  IsTeam: 'isTeam'
} as const;

export type Feedback_Comments_Select_Column_Feedback_Comments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Feedback_Comments_Select_Column_Feedback_Comments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Feedback_Comments_Select_Column_Feedback_Comments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "feedback_comments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "feedback_comments" */
export const Feedback_Comments_Select_Column_Feedback_Comments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  IsInternal: 'isInternal',
  /** column name */
  IsTeam: 'isTeam'
} as const;

export type Feedback_Comments_Select_Column_Feedback_Comments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Feedback_Comments_Select_Column_Feedback_Comments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Feedback_Comments_Select_Column_Feedback_Comments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "feedback_comments" */
export type Feedback_Comments_Set_Input = {
  authorAvatarUrl?: InputMaybe<Scalars['String']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorUserId?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInternal?: InputMaybe<Scalars['Boolean']>;
  isTeam?: InputMaybe<Scalars['Boolean']>;
  originPostId?: InputMaybe<Scalars['uuid']>;
  parentCommentId?: InputMaybe<Scalars['uuid']>;
  postId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "feedback_comments" */
export type Feedback_Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Comments_Stream_Cursor_Value_Input = {
  authorAvatarUrl?: InputMaybe<Scalars['String']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorUserId?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInternal?: InputMaybe<Scalars['Boolean']>;
  isTeam?: InputMaybe<Scalars['Boolean']>;
  originPostId?: InputMaybe<Scalars['uuid']>;
  parentCommentId?: InputMaybe<Scalars['uuid']>;
  postId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "feedback_comments" */
export const Feedback_Comments_Update_Column = {
  /** column name */
  AuthorAvatarUrl: 'authorAvatarUrl',
  /** column name */
  AuthorDisplayName: 'authorDisplayName',
  /** column name */
  AuthorUserId: 'authorUserId',
  /** column name */
  Body: 'body',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  IsInternal: 'isInternal',
  /** column name */
  IsTeam: 'isTeam',
  /** column name */
  OriginPostId: 'originPostId',
  /** column name */
  ParentCommentId: 'parentCommentId',
  /** column name */
  PostId: 'postId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Feedback_Comments_Update_Column = typeof Feedback_Comments_Update_Column[keyof typeof Feedback_Comments_Update_Column];
export type Feedback_Comments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Comments_Bool_Exp;
};

/** columns and relationships of "feedback_media" */
export type Feedback_Media = {
  __typename?: 'feedback_media';
  caption?: Maybe<Scalars['String']>;
  /** An object relationship */
  comment?: Maybe<Feedback_Comments>;
  commentId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  mimeType?: Maybe<Scalars['String']>;
  objectKey?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  /** An object relationship */
  post?: Maybe<Feedback_Posts>;
  postId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  release?: Maybe<Feedback_Releases>;
  releaseId?: Maybe<Scalars['uuid']>;
  sizeBytes?: Maybe<Scalars['Int']>;
  sortOrder: Scalars['Int'];
  thumbnailUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  uploadedByUserId?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "feedback_media" */
export type Feedback_Media_Aggregate = {
  __typename?: 'feedback_media_aggregate';
  aggregate?: Maybe<Feedback_Media_Aggregate_Fields>;
  nodes: Array<Feedback_Media>;
};

export type Feedback_Media_Aggregate_Bool_Exp = {
  count?: InputMaybe<Feedback_Media_Aggregate_Bool_Exp_Count>;
};

export type Feedback_Media_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Feedback_Media_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "feedback_media" */
export type Feedback_Media_Aggregate_Fields = {
  __typename?: 'feedback_media_aggregate_fields';
  avg?: Maybe<Feedback_Media_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Feedback_Media_Max_Fields>;
  min?: Maybe<Feedback_Media_Min_Fields>;
  stddev?: Maybe<Feedback_Media_Stddev_Fields>;
  stddev_pop?: Maybe<Feedback_Media_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feedback_Media_Stddev_Samp_Fields>;
  sum?: Maybe<Feedback_Media_Sum_Fields>;
  var_pop?: Maybe<Feedback_Media_Var_Pop_Fields>;
  var_samp?: Maybe<Feedback_Media_Var_Samp_Fields>;
  variance?: Maybe<Feedback_Media_Variance_Fields>;
};


/** aggregate fields of "feedback_media" */
export type Feedback_Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "feedback_media" */
export type Feedback_Media_Aggregate_Order_By = {
  avg?: InputMaybe<Feedback_Media_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Feedback_Media_Max_Order_By>;
  min?: InputMaybe<Feedback_Media_Min_Order_By>;
  stddev?: InputMaybe<Feedback_Media_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Feedback_Media_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Feedback_Media_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Feedback_Media_Sum_Order_By>;
  var_pop?: InputMaybe<Feedback_Media_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Feedback_Media_Var_Samp_Order_By>;
  variance?: InputMaybe<Feedback_Media_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "feedback_media" */
export type Feedback_Media_Arr_Rel_Insert_Input = {
  data: Array<Feedback_Media_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Feedback_Media_On_Conflict>;
};

/** aggregate avg on columns */
export type Feedback_Media_Avg_Fields = {
  __typename?: 'feedback_media_avg_fields';
  height?: Maybe<Scalars['Float']>;
  sizeBytes?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "feedback_media" */
export type Feedback_Media_Avg_Order_By = {
  height?: InputMaybe<Order_By>;
  sizeBytes?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "feedback_media". All fields are combined with a logical 'AND'. */
export type Feedback_Media_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Media_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Media_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Media_Bool_Exp>>;
  caption?: InputMaybe<String_Comparison_Exp>;
  comment?: InputMaybe<Feedback_Comments_Bool_Exp>;
  commentId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  height?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  objectKey?: InputMaybe<String_Comparison_Exp>;
  originalFilename?: InputMaybe<String_Comparison_Exp>;
  post?: InputMaybe<Feedback_Posts_Bool_Exp>;
  postId?: InputMaybe<Uuid_Comparison_Exp>;
  release?: InputMaybe<Feedback_Releases_Bool_Exp>;
  releaseId?: InputMaybe<Uuid_Comparison_Exp>;
  sizeBytes?: InputMaybe<Int_Comparison_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
  thumbnailUrl?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadedByUserId?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  width?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedback_media" */
export const Feedback_Media_Constraint = {
  /** unique or primary key constraint on columns "objectKey" */
  FeedbackMediaObjectKeyUniq: 'feedback_media_object_key_uniq',
  /** unique or primary key constraint on columns "id" */
  FeedbackMediaPkey: 'feedback_media_pkey'
} as const;

export type Feedback_Media_Constraint = typeof Feedback_Media_Constraint[keyof typeof Feedback_Media_Constraint];
/** input type for incrementing numeric columns in table "feedback_media" */
export type Feedback_Media_Inc_Input = {
  height?: InputMaybe<Scalars['Int']>;
  sizeBytes?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "feedback_media" */
export type Feedback_Media_Insert_Input = {
  caption?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Feedback_Comments_Obj_Rel_Insert_Input>;
  commentId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  mimeType?: InputMaybe<Scalars['String']>;
  objectKey?: InputMaybe<Scalars['String']>;
  originalFilename?: InputMaybe<Scalars['String']>;
  post?: InputMaybe<Feedback_Posts_Obj_Rel_Insert_Input>;
  postId?: InputMaybe<Scalars['uuid']>;
  release?: InputMaybe<Feedback_Releases_Obj_Rel_Insert_Input>;
  releaseId?: InputMaybe<Scalars['uuid']>;
  sizeBytes?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadedByUserId?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Feedback_Media_Max_Fields = {
  __typename?: 'feedback_media_max_fields';
  caption?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  mimeType?: Maybe<Scalars['String']>;
  objectKey?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  postId?: Maybe<Scalars['uuid']>;
  releaseId?: Maybe<Scalars['uuid']>;
  sizeBytes?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedByUserId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "feedback_media" */
export type Feedback_Media_Max_Order_By = {
  caption?: InputMaybe<Order_By>;
  commentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  objectKey?: InputMaybe<Order_By>;
  originalFilename?: InputMaybe<Order_By>;
  postId?: InputMaybe<Order_By>;
  releaseId?: InputMaybe<Order_By>;
  sizeBytes?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  thumbnailUrl?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Feedback_Media_Min_Fields = {
  __typename?: 'feedback_media_min_fields';
  caption?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  mimeType?: Maybe<Scalars['String']>;
  objectKey?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  postId?: Maybe<Scalars['uuid']>;
  releaseId?: Maybe<Scalars['uuid']>;
  sizeBytes?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedByUserId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "feedback_media" */
export type Feedback_Media_Min_Order_By = {
  caption?: InputMaybe<Order_By>;
  commentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  objectKey?: InputMaybe<Order_By>;
  originalFilename?: InputMaybe<Order_By>;
  postId?: InputMaybe<Order_By>;
  releaseId?: InputMaybe<Order_By>;
  sizeBytes?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  thumbnailUrl?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "feedback_media" */
export type Feedback_Media_Mutation_Response = {
  __typename?: 'feedback_media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback_Media>;
};

/** on_conflict condition type for table "feedback_media" */
export type Feedback_Media_On_Conflict = {
  constraint: Feedback_Media_Constraint;
  update_columns?: Array<Feedback_Media_Update_Column>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback_media". */
export type Feedback_Media_Order_By = {
  caption?: InputMaybe<Order_By>;
  comment?: InputMaybe<Feedback_Comments_Order_By>;
  commentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  objectKey?: InputMaybe<Order_By>;
  originalFilename?: InputMaybe<Order_By>;
  post?: InputMaybe<Feedback_Posts_Order_By>;
  postId?: InputMaybe<Order_By>;
  release?: InputMaybe<Feedback_Releases_Order_By>;
  releaseId?: InputMaybe<Order_By>;
  sizeBytes?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  thumbnailUrl?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadedByUserId?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feedback_media */
export type Feedback_Media_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "feedback_media" */
export const Feedback_Media_Select_Column = {
  /** column name */
  Caption: 'caption',
  /** column name */
  CommentId: 'commentId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Height: 'height',
  /** column name */
  Id: 'id',
  /** column name */
  MimeType: 'mimeType',
  /** column name */
  ObjectKey: 'objectKey',
  /** column name */
  OriginalFilename: 'originalFilename',
  /** column name */
  PostId: 'postId',
  /** column name */
  ReleaseId: 'releaseId',
  /** column name */
  SizeBytes: 'sizeBytes',
  /** column name */
  SortOrder: 'sortOrder',
  /** column name */
  ThumbnailUrl: 'thumbnailUrl',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UploadedByUserId: 'uploadedByUserId',
  /** column name */
  Url: 'url',
  /** column name */
  Width: 'width'
} as const;

export type Feedback_Media_Select_Column = typeof Feedback_Media_Select_Column[keyof typeof Feedback_Media_Select_Column];
/** input type for updating data in table "feedback_media" */
export type Feedback_Media_Set_Input = {
  caption?: InputMaybe<Scalars['String']>;
  commentId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  mimeType?: InputMaybe<Scalars['String']>;
  objectKey?: InputMaybe<Scalars['String']>;
  originalFilename?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['uuid']>;
  releaseId?: InputMaybe<Scalars['uuid']>;
  sizeBytes?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadedByUserId?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Feedback_Media_Stddev_Fields = {
  __typename?: 'feedback_media_stddev_fields';
  height?: Maybe<Scalars['Float']>;
  sizeBytes?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "feedback_media" */
export type Feedback_Media_Stddev_Order_By = {
  height?: InputMaybe<Order_By>;
  sizeBytes?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Feedback_Media_Stddev_Pop_Fields = {
  __typename?: 'feedback_media_stddev_pop_fields';
  height?: Maybe<Scalars['Float']>;
  sizeBytes?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "feedback_media" */
export type Feedback_Media_Stddev_Pop_Order_By = {
  height?: InputMaybe<Order_By>;
  sizeBytes?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Feedback_Media_Stddev_Samp_Fields = {
  __typename?: 'feedback_media_stddev_samp_fields';
  height?: Maybe<Scalars['Float']>;
  sizeBytes?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "feedback_media" */
export type Feedback_Media_Stddev_Samp_Order_By = {
  height?: InputMaybe<Order_By>;
  sizeBytes?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "feedback_media" */
export type Feedback_Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Media_Stream_Cursor_Value_Input = {
  caption?: InputMaybe<Scalars['String']>;
  commentId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  mimeType?: InputMaybe<Scalars['String']>;
  objectKey?: InputMaybe<Scalars['String']>;
  originalFilename?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['uuid']>;
  releaseId?: InputMaybe<Scalars['uuid']>;
  sizeBytes?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  uploadedByUserId?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Feedback_Media_Sum_Fields = {
  __typename?: 'feedback_media_sum_fields';
  height?: Maybe<Scalars['Int']>;
  sizeBytes?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "feedback_media" */
export type Feedback_Media_Sum_Order_By = {
  height?: InputMaybe<Order_By>;
  sizeBytes?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** update columns of table "feedback_media" */
export const Feedback_Media_Update_Column = {
  /** column name */
  Caption: 'caption',
  /** column name */
  CommentId: 'commentId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Height: 'height',
  /** column name */
  Id: 'id',
  /** column name */
  MimeType: 'mimeType',
  /** column name */
  ObjectKey: 'objectKey',
  /** column name */
  OriginalFilename: 'originalFilename',
  /** column name */
  PostId: 'postId',
  /** column name */
  ReleaseId: 'releaseId',
  /** column name */
  SizeBytes: 'sizeBytes',
  /** column name */
  SortOrder: 'sortOrder',
  /** column name */
  ThumbnailUrl: 'thumbnailUrl',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UploadedByUserId: 'uploadedByUserId',
  /** column name */
  Url: 'url',
  /** column name */
  Width: 'width'
} as const;

export type Feedback_Media_Update_Column = typeof Feedback_Media_Update_Column[keyof typeof Feedback_Media_Update_Column];
export type Feedback_Media_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feedback_Media_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Media_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Media_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feedback_Media_Var_Pop_Fields = {
  __typename?: 'feedback_media_var_pop_fields';
  height?: Maybe<Scalars['Float']>;
  sizeBytes?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "feedback_media" */
export type Feedback_Media_Var_Pop_Order_By = {
  height?: InputMaybe<Order_By>;
  sizeBytes?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Feedback_Media_Var_Samp_Fields = {
  __typename?: 'feedback_media_var_samp_fields';
  height?: Maybe<Scalars['Float']>;
  sizeBytes?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "feedback_media" */
export type Feedback_Media_Var_Samp_Order_By = {
  height?: InputMaybe<Order_By>;
  sizeBytes?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Feedback_Media_Variance_Fields = {
  __typename?: 'feedback_media_variance_fields';
  height?: Maybe<Scalars['Float']>;
  sizeBytes?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "feedback_media" */
export type Feedback_Media_Variance_Order_By = {
  height?: InputMaybe<Order_By>;
  sizeBytes?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** columns and relationships of "feedback_post_contexts" */
export type Feedback_Post_Contexts = {
  __typename?: 'feedback_post_contexts';
  analyticsDistinctId?: Maybe<Scalars['String']>;
  analyticsEventId?: Maybe<Scalars['String']>;
  analyticsSessionId?: Maybe<Scalars['String']>;
  clientAppVersion?: Maybe<Scalars['String']>;
  clientBuildId?: Maybe<Scalars['String']>;
  clientPlatform?: Maybe<Scalars['String']>;
  clientTimezone?: Maybe<Scalars['String']>;
  clientUserAgent?: Maybe<Scalars['String']>;
  contextType: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  isDashboardLifetime?: Maybe<Scalars['Boolean']>;
  isTechnicalAnalysisLifetime?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  post: Feedback_Posts;
  postId: Scalars['uuid'];
  sentryEventId?: Maybe<Scalars['String']>;
  sourceEntityId?: Maybe<Scalars['String']>;
  sourceEntityType?: Maybe<Scalars['String']>;
  sourceFeatureKey?: Maybe<Scalars['String']>;
  sourcePathname?: Maybe<Scalars['String']>;
  sourceRoute?: Maybe<Scalars['String']>;
  sourceSearch?: Maybe<Scalars['String']>;
  sourceSurface?: Maybe<Scalars['String']>;
  sourceTitle?: Maybe<Scalars['String']>;
  subscriptionStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['String']>;
  userPlan?: Maybe<Scalars['String']>;
  viewportHeight?: Maybe<Scalars['Int']>;
  viewportWidth?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "feedback_post_contexts" */
export type Feedback_Post_Contexts_Aggregate = {
  __typename?: 'feedback_post_contexts_aggregate';
  aggregate?: Maybe<Feedback_Post_Contexts_Aggregate_Fields>;
  nodes: Array<Feedback_Post_Contexts>;
};

export type Feedback_Post_Contexts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Feedback_Post_Contexts_Aggregate_Bool_Exp_Count>;
};

export type Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Feedback_Post_Contexts_Select_Column_Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Feedback_Post_Contexts_Select_Column_Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Feedback_Post_Contexts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Feedback_Post_Contexts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "feedback_post_contexts" */
export type Feedback_Post_Contexts_Aggregate_Fields = {
  __typename?: 'feedback_post_contexts_aggregate_fields';
  avg?: Maybe<Feedback_Post_Contexts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Feedback_Post_Contexts_Max_Fields>;
  min?: Maybe<Feedback_Post_Contexts_Min_Fields>;
  stddev?: Maybe<Feedback_Post_Contexts_Stddev_Fields>;
  stddev_pop?: Maybe<Feedback_Post_Contexts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feedback_Post_Contexts_Stddev_Samp_Fields>;
  sum?: Maybe<Feedback_Post_Contexts_Sum_Fields>;
  var_pop?: Maybe<Feedback_Post_Contexts_Var_Pop_Fields>;
  var_samp?: Maybe<Feedback_Post_Contexts_Var_Samp_Fields>;
  variance?: Maybe<Feedback_Post_Contexts_Variance_Fields>;
};


/** aggregate fields of "feedback_post_contexts" */
export type Feedback_Post_Contexts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Post_Contexts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Aggregate_Order_By = {
  avg?: InputMaybe<Feedback_Post_Contexts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Feedback_Post_Contexts_Max_Order_By>;
  min?: InputMaybe<Feedback_Post_Contexts_Min_Order_By>;
  stddev?: InputMaybe<Feedback_Post_Contexts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Feedback_Post_Contexts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Feedback_Post_Contexts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Feedback_Post_Contexts_Sum_Order_By>;
  var_pop?: InputMaybe<Feedback_Post_Contexts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Feedback_Post_Contexts_Var_Samp_Order_By>;
  variance?: InputMaybe<Feedback_Post_Contexts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Arr_Rel_Insert_Input = {
  data: Array<Feedback_Post_Contexts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Feedback_Post_Contexts_On_Conflict>;
};

/** aggregate avg on columns */
export type Feedback_Post_Contexts_Avg_Fields = {
  __typename?: 'feedback_post_contexts_avg_fields';
  viewportHeight?: Maybe<Scalars['Float']>;
  viewportWidth?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Avg_Order_By = {
  viewportHeight?: InputMaybe<Order_By>;
  viewportWidth?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "feedback_post_contexts". All fields are combined with a logical 'AND'. */
export type Feedback_Post_Contexts_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Post_Contexts_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Post_Contexts_Bool_Exp>>;
  analyticsDistinctId?: InputMaybe<String_Comparison_Exp>;
  analyticsEventId?: InputMaybe<String_Comparison_Exp>;
  analyticsSessionId?: InputMaybe<String_Comparison_Exp>;
  clientAppVersion?: InputMaybe<String_Comparison_Exp>;
  clientBuildId?: InputMaybe<String_Comparison_Exp>;
  clientPlatform?: InputMaybe<String_Comparison_Exp>;
  clientTimezone?: InputMaybe<String_Comparison_Exp>;
  clientUserAgent?: InputMaybe<String_Comparison_Exp>;
  contextType?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDashboardLifetime?: InputMaybe<Boolean_Comparison_Exp>;
  isTechnicalAnalysisLifetime?: InputMaybe<Boolean_Comparison_Exp>;
  post?: InputMaybe<Feedback_Posts_Bool_Exp>;
  postId?: InputMaybe<Uuid_Comparison_Exp>;
  sentryEventId?: InputMaybe<String_Comparison_Exp>;
  sourceEntityId?: InputMaybe<String_Comparison_Exp>;
  sourceEntityType?: InputMaybe<String_Comparison_Exp>;
  sourceFeatureKey?: InputMaybe<String_Comparison_Exp>;
  sourcePathname?: InputMaybe<String_Comparison_Exp>;
  sourceRoute?: InputMaybe<String_Comparison_Exp>;
  sourceSearch?: InputMaybe<String_Comparison_Exp>;
  sourceSurface?: InputMaybe<String_Comparison_Exp>;
  sourceTitle?: InputMaybe<String_Comparison_Exp>;
  subscriptionStatus?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
  userPlan?: InputMaybe<String_Comparison_Exp>;
  viewportHeight?: InputMaybe<Int_Comparison_Exp>;
  viewportWidth?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedback_post_contexts" */
export const Feedback_Post_Contexts_Constraint = {
  /** unique or primary key constraint on columns "id" */
  FeedbackPostContextsPkey: 'feedback_post_contexts_pkey'
} as const;

export type Feedback_Post_Contexts_Constraint = typeof Feedback_Post_Contexts_Constraint[keyof typeof Feedback_Post_Contexts_Constraint];
/** input type for incrementing numeric columns in table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Inc_Input = {
  viewportHeight?: InputMaybe<Scalars['Int']>;
  viewportWidth?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Insert_Input = {
  analyticsDistinctId?: InputMaybe<Scalars['String']>;
  analyticsEventId?: InputMaybe<Scalars['String']>;
  analyticsSessionId?: InputMaybe<Scalars['String']>;
  clientAppVersion?: InputMaybe<Scalars['String']>;
  clientBuildId?: InputMaybe<Scalars['String']>;
  clientPlatform?: InputMaybe<Scalars['String']>;
  clientTimezone?: InputMaybe<Scalars['String']>;
  clientUserAgent?: InputMaybe<Scalars['String']>;
  contextType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDashboardLifetime?: InputMaybe<Scalars['Boolean']>;
  isTechnicalAnalysisLifetime?: InputMaybe<Scalars['Boolean']>;
  post?: InputMaybe<Feedback_Posts_Obj_Rel_Insert_Input>;
  postId?: InputMaybe<Scalars['uuid']>;
  sentryEventId?: InputMaybe<Scalars['String']>;
  sourceEntityId?: InputMaybe<Scalars['String']>;
  sourceEntityType?: InputMaybe<Scalars['String']>;
  sourceFeatureKey?: InputMaybe<Scalars['String']>;
  sourcePathname?: InputMaybe<Scalars['String']>;
  sourceRoute?: InputMaybe<Scalars['String']>;
  sourceSearch?: InputMaybe<Scalars['String']>;
  sourceSurface?: InputMaybe<Scalars['String']>;
  sourceTitle?: InputMaybe<Scalars['String']>;
  subscriptionStatus?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
  userPlan?: InputMaybe<Scalars['String']>;
  viewportHeight?: InputMaybe<Scalars['Int']>;
  viewportWidth?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Feedback_Post_Contexts_Max_Fields = {
  __typename?: 'feedback_post_contexts_max_fields';
  analyticsDistinctId?: Maybe<Scalars['String']>;
  analyticsEventId?: Maybe<Scalars['String']>;
  analyticsSessionId?: Maybe<Scalars['String']>;
  clientAppVersion?: Maybe<Scalars['String']>;
  clientBuildId?: Maybe<Scalars['String']>;
  clientPlatform?: Maybe<Scalars['String']>;
  clientTimezone?: Maybe<Scalars['String']>;
  clientUserAgent?: Maybe<Scalars['String']>;
  contextType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postId?: Maybe<Scalars['uuid']>;
  sentryEventId?: Maybe<Scalars['String']>;
  sourceEntityId?: Maybe<Scalars['String']>;
  sourceEntityType?: Maybe<Scalars['String']>;
  sourceFeatureKey?: Maybe<Scalars['String']>;
  sourcePathname?: Maybe<Scalars['String']>;
  sourceRoute?: Maybe<Scalars['String']>;
  sourceSearch?: Maybe<Scalars['String']>;
  sourceSurface?: Maybe<Scalars['String']>;
  sourceTitle?: Maybe<Scalars['String']>;
  subscriptionStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
  userPlan?: Maybe<Scalars['String']>;
  viewportHeight?: Maybe<Scalars['Int']>;
  viewportWidth?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Max_Order_By = {
  analyticsDistinctId?: InputMaybe<Order_By>;
  analyticsEventId?: InputMaybe<Order_By>;
  analyticsSessionId?: InputMaybe<Order_By>;
  clientAppVersion?: InputMaybe<Order_By>;
  clientBuildId?: InputMaybe<Order_By>;
  clientPlatform?: InputMaybe<Order_By>;
  clientTimezone?: InputMaybe<Order_By>;
  clientUserAgent?: InputMaybe<Order_By>;
  contextType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  postId?: InputMaybe<Order_By>;
  sentryEventId?: InputMaybe<Order_By>;
  sourceEntityId?: InputMaybe<Order_By>;
  sourceEntityType?: InputMaybe<Order_By>;
  sourceFeatureKey?: InputMaybe<Order_By>;
  sourcePathname?: InputMaybe<Order_By>;
  sourceRoute?: InputMaybe<Order_By>;
  sourceSearch?: InputMaybe<Order_By>;
  sourceSurface?: InputMaybe<Order_By>;
  sourceTitle?: InputMaybe<Order_By>;
  subscriptionStatus?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  userPlan?: InputMaybe<Order_By>;
  viewportHeight?: InputMaybe<Order_By>;
  viewportWidth?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Feedback_Post_Contexts_Min_Fields = {
  __typename?: 'feedback_post_contexts_min_fields';
  analyticsDistinctId?: Maybe<Scalars['String']>;
  analyticsEventId?: Maybe<Scalars['String']>;
  analyticsSessionId?: Maybe<Scalars['String']>;
  clientAppVersion?: Maybe<Scalars['String']>;
  clientBuildId?: Maybe<Scalars['String']>;
  clientPlatform?: Maybe<Scalars['String']>;
  clientTimezone?: Maybe<Scalars['String']>;
  clientUserAgent?: Maybe<Scalars['String']>;
  contextType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postId?: Maybe<Scalars['uuid']>;
  sentryEventId?: Maybe<Scalars['String']>;
  sourceEntityId?: Maybe<Scalars['String']>;
  sourceEntityType?: Maybe<Scalars['String']>;
  sourceFeatureKey?: Maybe<Scalars['String']>;
  sourcePathname?: Maybe<Scalars['String']>;
  sourceRoute?: Maybe<Scalars['String']>;
  sourceSearch?: Maybe<Scalars['String']>;
  sourceSurface?: Maybe<Scalars['String']>;
  sourceTitle?: Maybe<Scalars['String']>;
  subscriptionStatus?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
  userPlan?: Maybe<Scalars['String']>;
  viewportHeight?: Maybe<Scalars['Int']>;
  viewportWidth?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Min_Order_By = {
  analyticsDistinctId?: InputMaybe<Order_By>;
  analyticsEventId?: InputMaybe<Order_By>;
  analyticsSessionId?: InputMaybe<Order_By>;
  clientAppVersion?: InputMaybe<Order_By>;
  clientBuildId?: InputMaybe<Order_By>;
  clientPlatform?: InputMaybe<Order_By>;
  clientTimezone?: InputMaybe<Order_By>;
  clientUserAgent?: InputMaybe<Order_By>;
  contextType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  postId?: InputMaybe<Order_By>;
  sentryEventId?: InputMaybe<Order_By>;
  sourceEntityId?: InputMaybe<Order_By>;
  sourceEntityType?: InputMaybe<Order_By>;
  sourceFeatureKey?: InputMaybe<Order_By>;
  sourcePathname?: InputMaybe<Order_By>;
  sourceRoute?: InputMaybe<Order_By>;
  sourceSearch?: InputMaybe<Order_By>;
  sourceSurface?: InputMaybe<Order_By>;
  sourceTitle?: InputMaybe<Order_By>;
  subscriptionStatus?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  userPlan?: InputMaybe<Order_By>;
  viewportHeight?: InputMaybe<Order_By>;
  viewportWidth?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Mutation_Response = {
  __typename?: 'feedback_post_contexts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback_Post_Contexts>;
};

/** on_conflict condition type for table "feedback_post_contexts" */
export type Feedback_Post_Contexts_On_Conflict = {
  constraint: Feedback_Post_Contexts_Constraint;
  update_columns?: Array<Feedback_Post_Contexts_Update_Column>;
  where?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback_post_contexts". */
export type Feedback_Post_Contexts_Order_By = {
  analyticsDistinctId?: InputMaybe<Order_By>;
  analyticsEventId?: InputMaybe<Order_By>;
  analyticsSessionId?: InputMaybe<Order_By>;
  clientAppVersion?: InputMaybe<Order_By>;
  clientBuildId?: InputMaybe<Order_By>;
  clientPlatform?: InputMaybe<Order_By>;
  clientTimezone?: InputMaybe<Order_By>;
  clientUserAgent?: InputMaybe<Order_By>;
  contextType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDashboardLifetime?: InputMaybe<Order_By>;
  isTechnicalAnalysisLifetime?: InputMaybe<Order_By>;
  post?: InputMaybe<Feedback_Posts_Order_By>;
  postId?: InputMaybe<Order_By>;
  sentryEventId?: InputMaybe<Order_By>;
  sourceEntityId?: InputMaybe<Order_By>;
  sourceEntityType?: InputMaybe<Order_By>;
  sourceFeatureKey?: InputMaybe<Order_By>;
  sourcePathname?: InputMaybe<Order_By>;
  sourceRoute?: InputMaybe<Order_By>;
  sourceSearch?: InputMaybe<Order_By>;
  sourceSurface?: InputMaybe<Order_By>;
  sourceTitle?: InputMaybe<Order_By>;
  subscriptionStatus?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
  userPlan?: InputMaybe<Order_By>;
  viewportHeight?: InputMaybe<Order_By>;
  viewportWidth?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feedback_post_contexts */
export type Feedback_Post_Contexts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "feedback_post_contexts" */
export const Feedback_Post_Contexts_Select_Column = {
  /** column name */
  AnalyticsDistinctId: 'analyticsDistinctId',
  /** column name */
  AnalyticsEventId: 'analyticsEventId',
  /** column name */
  AnalyticsSessionId: 'analyticsSessionId',
  /** column name */
  ClientAppVersion: 'clientAppVersion',
  /** column name */
  ClientBuildId: 'clientBuildId',
  /** column name */
  ClientPlatform: 'clientPlatform',
  /** column name */
  ClientTimezone: 'clientTimezone',
  /** column name */
  ClientUserAgent: 'clientUserAgent',
  /** column name */
  ContextType: 'contextType',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  IsDashboardLifetime: 'isDashboardLifetime',
  /** column name */
  IsTechnicalAnalysisLifetime: 'isTechnicalAnalysisLifetime',
  /** column name */
  PostId: 'postId',
  /** column name */
  SentryEventId: 'sentryEventId',
  /** column name */
  SourceEntityId: 'sourceEntityId',
  /** column name */
  SourceEntityType: 'sourceEntityType',
  /** column name */
  SourceFeatureKey: 'sourceFeatureKey',
  /** column name */
  SourcePathname: 'sourcePathname',
  /** column name */
  SourceRoute: 'sourceRoute',
  /** column name */
  SourceSearch: 'sourceSearch',
  /** column name */
  SourceSurface: 'sourceSurface',
  /** column name */
  SourceTitle: 'sourceTitle',
  /** column name */
  SubscriptionStatus: 'subscriptionStatus',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId',
  /** column name */
  UserPlan: 'userPlan',
  /** column name */
  ViewportHeight: 'viewportHeight',
  /** column name */
  ViewportWidth: 'viewportWidth'
} as const;

export type Feedback_Post_Contexts_Select_Column = typeof Feedback_Post_Contexts_Select_Column[keyof typeof Feedback_Post_Contexts_Select_Column];
/** select "feedback_post_contexts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "feedback_post_contexts" */
export const Feedback_Post_Contexts_Select_Column_Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  IsDashboardLifetime: 'isDashboardLifetime',
  /** column name */
  IsTechnicalAnalysisLifetime: 'isTechnicalAnalysisLifetime'
} as const;

export type Feedback_Post_Contexts_Select_Column_Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Feedback_Post_Contexts_Select_Column_Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Feedback_Post_Contexts_Select_Column_Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "feedback_post_contexts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "feedback_post_contexts" */
export const Feedback_Post_Contexts_Select_Column_Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  IsDashboardLifetime: 'isDashboardLifetime',
  /** column name */
  IsTechnicalAnalysisLifetime: 'isTechnicalAnalysisLifetime'
} as const;

export type Feedback_Post_Contexts_Select_Column_Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Feedback_Post_Contexts_Select_Column_Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Feedback_Post_Contexts_Select_Column_Feedback_Post_Contexts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Set_Input = {
  analyticsDistinctId?: InputMaybe<Scalars['String']>;
  analyticsEventId?: InputMaybe<Scalars['String']>;
  analyticsSessionId?: InputMaybe<Scalars['String']>;
  clientAppVersion?: InputMaybe<Scalars['String']>;
  clientBuildId?: InputMaybe<Scalars['String']>;
  clientPlatform?: InputMaybe<Scalars['String']>;
  clientTimezone?: InputMaybe<Scalars['String']>;
  clientUserAgent?: InputMaybe<Scalars['String']>;
  contextType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDashboardLifetime?: InputMaybe<Scalars['Boolean']>;
  isTechnicalAnalysisLifetime?: InputMaybe<Scalars['Boolean']>;
  postId?: InputMaybe<Scalars['uuid']>;
  sentryEventId?: InputMaybe<Scalars['String']>;
  sourceEntityId?: InputMaybe<Scalars['String']>;
  sourceEntityType?: InputMaybe<Scalars['String']>;
  sourceFeatureKey?: InputMaybe<Scalars['String']>;
  sourcePathname?: InputMaybe<Scalars['String']>;
  sourceRoute?: InputMaybe<Scalars['String']>;
  sourceSearch?: InputMaybe<Scalars['String']>;
  sourceSurface?: InputMaybe<Scalars['String']>;
  sourceTitle?: InputMaybe<Scalars['String']>;
  subscriptionStatus?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
  userPlan?: InputMaybe<Scalars['String']>;
  viewportHeight?: InputMaybe<Scalars['Int']>;
  viewportWidth?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Feedback_Post_Contexts_Stddev_Fields = {
  __typename?: 'feedback_post_contexts_stddev_fields';
  viewportHeight?: Maybe<Scalars['Float']>;
  viewportWidth?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Stddev_Order_By = {
  viewportHeight?: InputMaybe<Order_By>;
  viewportWidth?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Feedback_Post_Contexts_Stddev_Pop_Fields = {
  __typename?: 'feedback_post_contexts_stddev_pop_fields';
  viewportHeight?: Maybe<Scalars['Float']>;
  viewportWidth?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Stddev_Pop_Order_By = {
  viewportHeight?: InputMaybe<Order_By>;
  viewportWidth?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Feedback_Post_Contexts_Stddev_Samp_Fields = {
  __typename?: 'feedback_post_contexts_stddev_samp_fields';
  viewportHeight?: Maybe<Scalars['Float']>;
  viewportWidth?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Stddev_Samp_Order_By = {
  viewportHeight?: InputMaybe<Order_By>;
  viewportWidth?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Post_Contexts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Post_Contexts_Stream_Cursor_Value_Input = {
  analyticsDistinctId?: InputMaybe<Scalars['String']>;
  analyticsEventId?: InputMaybe<Scalars['String']>;
  analyticsSessionId?: InputMaybe<Scalars['String']>;
  clientAppVersion?: InputMaybe<Scalars['String']>;
  clientBuildId?: InputMaybe<Scalars['String']>;
  clientPlatform?: InputMaybe<Scalars['String']>;
  clientTimezone?: InputMaybe<Scalars['String']>;
  clientUserAgent?: InputMaybe<Scalars['String']>;
  contextType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDashboardLifetime?: InputMaybe<Scalars['Boolean']>;
  isTechnicalAnalysisLifetime?: InputMaybe<Scalars['Boolean']>;
  postId?: InputMaybe<Scalars['uuid']>;
  sentryEventId?: InputMaybe<Scalars['String']>;
  sourceEntityId?: InputMaybe<Scalars['String']>;
  sourceEntityType?: InputMaybe<Scalars['String']>;
  sourceFeatureKey?: InputMaybe<Scalars['String']>;
  sourcePathname?: InputMaybe<Scalars['String']>;
  sourceRoute?: InputMaybe<Scalars['String']>;
  sourceSearch?: InputMaybe<Scalars['String']>;
  sourceSurface?: InputMaybe<Scalars['String']>;
  sourceTitle?: InputMaybe<Scalars['String']>;
  subscriptionStatus?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
  userPlan?: InputMaybe<Scalars['String']>;
  viewportHeight?: InputMaybe<Scalars['Int']>;
  viewportWidth?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Feedback_Post_Contexts_Sum_Fields = {
  __typename?: 'feedback_post_contexts_sum_fields';
  viewportHeight?: Maybe<Scalars['Int']>;
  viewportWidth?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Sum_Order_By = {
  viewportHeight?: InputMaybe<Order_By>;
  viewportWidth?: InputMaybe<Order_By>;
};

/** update columns of table "feedback_post_contexts" */
export const Feedback_Post_Contexts_Update_Column = {
  /** column name */
  AnalyticsDistinctId: 'analyticsDistinctId',
  /** column name */
  AnalyticsEventId: 'analyticsEventId',
  /** column name */
  AnalyticsSessionId: 'analyticsSessionId',
  /** column name */
  ClientAppVersion: 'clientAppVersion',
  /** column name */
  ClientBuildId: 'clientBuildId',
  /** column name */
  ClientPlatform: 'clientPlatform',
  /** column name */
  ClientTimezone: 'clientTimezone',
  /** column name */
  ClientUserAgent: 'clientUserAgent',
  /** column name */
  ContextType: 'contextType',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  IsDashboardLifetime: 'isDashboardLifetime',
  /** column name */
  IsTechnicalAnalysisLifetime: 'isTechnicalAnalysisLifetime',
  /** column name */
  PostId: 'postId',
  /** column name */
  SentryEventId: 'sentryEventId',
  /** column name */
  SourceEntityId: 'sourceEntityId',
  /** column name */
  SourceEntityType: 'sourceEntityType',
  /** column name */
  SourceFeatureKey: 'sourceFeatureKey',
  /** column name */
  SourcePathname: 'sourcePathname',
  /** column name */
  SourceRoute: 'sourceRoute',
  /** column name */
  SourceSearch: 'sourceSearch',
  /** column name */
  SourceSurface: 'sourceSurface',
  /** column name */
  SourceTitle: 'sourceTitle',
  /** column name */
  SubscriptionStatus: 'subscriptionStatus',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId',
  /** column name */
  UserPlan: 'userPlan',
  /** column name */
  ViewportHeight: 'viewportHeight',
  /** column name */
  ViewportWidth: 'viewportWidth'
} as const;

export type Feedback_Post_Contexts_Update_Column = typeof Feedback_Post_Contexts_Update_Column[keyof typeof Feedback_Post_Contexts_Update_Column];
export type Feedback_Post_Contexts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feedback_Post_Contexts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Post_Contexts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Post_Contexts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feedback_Post_Contexts_Var_Pop_Fields = {
  __typename?: 'feedback_post_contexts_var_pop_fields';
  viewportHeight?: Maybe<Scalars['Float']>;
  viewportWidth?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Var_Pop_Order_By = {
  viewportHeight?: InputMaybe<Order_By>;
  viewportWidth?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Feedback_Post_Contexts_Var_Samp_Fields = {
  __typename?: 'feedback_post_contexts_var_samp_fields';
  viewportHeight?: Maybe<Scalars['Float']>;
  viewportWidth?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Var_Samp_Order_By = {
  viewportHeight?: InputMaybe<Order_By>;
  viewportWidth?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Feedback_Post_Contexts_Variance_Fields = {
  __typename?: 'feedback_post_contexts_variance_fields';
  viewportHeight?: Maybe<Scalars['Float']>;
  viewportWidth?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "feedback_post_contexts" */
export type Feedback_Post_Contexts_Variance_Order_By = {
  viewportHeight?: InputMaybe<Order_By>;
  viewportWidth?: InputMaybe<Order_By>;
};

/** columns and relationships of "feedback_post_merges" */
export type Feedback_Post_Merges = {
  __typename?: 'feedback_post_merges';
  /** An object relationship */
  canonicalPost: Feedback_Posts;
  canonicalPostId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  mergedByUser?: Maybe<Users>;
  mergedByUserId?: Maybe<Scalars['String']>;
  /** An object relationship */
  mergedPost: Feedback_Posts;
  mergedPostId: Scalars['uuid'];
  movedCommentCount: Scalars['Int'];
  movedVoteCount: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "feedback_post_merges" */
export type Feedback_Post_Merges_Aggregate = {
  __typename?: 'feedback_post_merges_aggregate';
  aggregate?: Maybe<Feedback_Post_Merges_Aggregate_Fields>;
  nodes: Array<Feedback_Post_Merges>;
};

/** aggregate fields of "feedback_post_merges" */
export type Feedback_Post_Merges_Aggregate_Fields = {
  __typename?: 'feedback_post_merges_aggregate_fields';
  avg?: Maybe<Feedback_Post_Merges_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Feedback_Post_Merges_Max_Fields>;
  min?: Maybe<Feedback_Post_Merges_Min_Fields>;
  stddev?: Maybe<Feedback_Post_Merges_Stddev_Fields>;
  stddev_pop?: Maybe<Feedback_Post_Merges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feedback_Post_Merges_Stddev_Samp_Fields>;
  sum?: Maybe<Feedback_Post_Merges_Sum_Fields>;
  var_pop?: Maybe<Feedback_Post_Merges_Var_Pop_Fields>;
  var_samp?: Maybe<Feedback_Post_Merges_Var_Samp_Fields>;
  variance?: Maybe<Feedback_Post_Merges_Variance_Fields>;
};


/** aggregate fields of "feedback_post_merges" */
export type Feedback_Post_Merges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Post_Merges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Feedback_Post_Merges_Avg_Fields = {
  __typename?: 'feedback_post_merges_avg_fields';
  movedCommentCount?: Maybe<Scalars['Float']>;
  movedVoteCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "feedback_post_merges". All fields are combined with a logical 'AND'. */
export type Feedback_Post_Merges_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Post_Merges_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Post_Merges_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Post_Merges_Bool_Exp>>;
  canonicalPost?: InputMaybe<Feedback_Posts_Bool_Exp>;
  canonicalPostId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mergedByUser?: InputMaybe<Users_Bool_Exp>;
  mergedByUserId?: InputMaybe<String_Comparison_Exp>;
  mergedPost?: InputMaybe<Feedback_Posts_Bool_Exp>;
  mergedPostId?: InputMaybe<Uuid_Comparison_Exp>;
  movedCommentCount?: InputMaybe<Int_Comparison_Exp>;
  movedVoteCount?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedback_post_merges" */
export const Feedback_Post_Merges_Constraint = {
  /** unique or primary key constraint on columns "mergedPostId" */
  FeedbackPostMergesMergedKey: 'feedback_post_merges_merged_key',
  /** unique or primary key constraint on columns "id" */
  FeedbackPostMergesPkey: 'feedback_post_merges_pkey'
} as const;

export type Feedback_Post_Merges_Constraint = typeof Feedback_Post_Merges_Constraint[keyof typeof Feedback_Post_Merges_Constraint];
/** input type for incrementing numeric columns in table "feedback_post_merges" */
export type Feedback_Post_Merges_Inc_Input = {
  movedCommentCount?: InputMaybe<Scalars['Int']>;
  movedVoteCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "feedback_post_merges" */
export type Feedback_Post_Merges_Insert_Input = {
  canonicalPost?: InputMaybe<Feedback_Posts_Obj_Rel_Insert_Input>;
  canonicalPostId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mergedByUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  mergedByUserId?: InputMaybe<Scalars['String']>;
  mergedPost?: InputMaybe<Feedback_Posts_Obj_Rel_Insert_Input>;
  mergedPostId?: InputMaybe<Scalars['uuid']>;
  movedCommentCount?: InputMaybe<Scalars['Int']>;
  movedVoteCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Feedback_Post_Merges_Max_Fields = {
  __typename?: 'feedback_post_merges_max_fields';
  canonicalPostId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mergedByUserId?: Maybe<Scalars['String']>;
  mergedPostId?: Maybe<Scalars['uuid']>;
  movedCommentCount?: Maybe<Scalars['Int']>;
  movedVoteCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Feedback_Post_Merges_Min_Fields = {
  __typename?: 'feedback_post_merges_min_fields';
  canonicalPostId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  mergedByUserId?: Maybe<Scalars['String']>;
  mergedPostId?: Maybe<Scalars['uuid']>;
  movedCommentCount?: Maybe<Scalars['Int']>;
  movedVoteCount?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "feedback_post_merges" */
export type Feedback_Post_Merges_Mutation_Response = {
  __typename?: 'feedback_post_merges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback_Post_Merges>;
};

/** on_conflict condition type for table "feedback_post_merges" */
export type Feedback_Post_Merges_On_Conflict = {
  constraint: Feedback_Post_Merges_Constraint;
  update_columns?: Array<Feedback_Post_Merges_Update_Column>;
  where?: InputMaybe<Feedback_Post_Merges_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback_post_merges". */
export type Feedback_Post_Merges_Order_By = {
  canonicalPost?: InputMaybe<Feedback_Posts_Order_By>;
  canonicalPostId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mergedByUser?: InputMaybe<Users_Order_By>;
  mergedByUserId?: InputMaybe<Order_By>;
  mergedPost?: InputMaybe<Feedback_Posts_Order_By>;
  mergedPostId?: InputMaybe<Order_By>;
  movedCommentCount?: InputMaybe<Order_By>;
  movedVoteCount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feedback_post_merges */
export type Feedback_Post_Merges_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "feedback_post_merges" */
export const Feedback_Post_Merges_Select_Column = {
  /** column name */
  CanonicalPostId: 'canonicalPostId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  MergedByUserId: 'mergedByUserId',
  /** column name */
  MergedPostId: 'mergedPostId',
  /** column name */
  MovedCommentCount: 'movedCommentCount',
  /** column name */
  MovedVoteCount: 'movedVoteCount',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Feedback_Post_Merges_Select_Column = typeof Feedback_Post_Merges_Select_Column[keyof typeof Feedback_Post_Merges_Select_Column];
/** input type for updating data in table "feedback_post_merges" */
export type Feedback_Post_Merges_Set_Input = {
  canonicalPostId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mergedByUserId?: InputMaybe<Scalars['String']>;
  mergedPostId?: InputMaybe<Scalars['uuid']>;
  movedCommentCount?: InputMaybe<Scalars['Int']>;
  movedVoteCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Feedback_Post_Merges_Stddev_Fields = {
  __typename?: 'feedback_post_merges_stddev_fields';
  movedCommentCount?: Maybe<Scalars['Float']>;
  movedVoteCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Feedback_Post_Merges_Stddev_Pop_Fields = {
  __typename?: 'feedback_post_merges_stddev_pop_fields';
  movedCommentCount?: Maybe<Scalars['Float']>;
  movedVoteCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Feedback_Post_Merges_Stddev_Samp_Fields = {
  __typename?: 'feedback_post_merges_stddev_samp_fields';
  movedCommentCount?: Maybe<Scalars['Float']>;
  movedVoteCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "feedback_post_merges" */
export type Feedback_Post_Merges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Post_Merges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Post_Merges_Stream_Cursor_Value_Input = {
  canonicalPostId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mergedByUserId?: InputMaybe<Scalars['String']>;
  mergedPostId?: InputMaybe<Scalars['uuid']>;
  movedCommentCount?: InputMaybe<Scalars['Int']>;
  movedVoteCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Feedback_Post_Merges_Sum_Fields = {
  __typename?: 'feedback_post_merges_sum_fields';
  movedCommentCount?: Maybe<Scalars['Int']>;
  movedVoteCount?: Maybe<Scalars['Int']>;
};

/** update columns of table "feedback_post_merges" */
export const Feedback_Post_Merges_Update_Column = {
  /** column name */
  CanonicalPostId: 'canonicalPostId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  MergedByUserId: 'mergedByUserId',
  /** column name */
  MergedPostId: 'mergedPostId',
  /** column name */
  MovedCommentCount: 'movedCommentCount',
  /** column name */
  MovedVoteCount: 'movedVoteCount',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Feedback_Post_Merges_Update_Column = typeof Feedback_Post_Merges_Update_Column[keyof typeof Feedback_Post_Merges_Update_Column];
export type Feedback_Post_Merges_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feedback_Post_Merges_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Post_Merges_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Post_Merges_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feedback_Post_Merges_Var_Pop_Fields = {
  __typename?: 'feedback_post_merges_var_pop_fields';
  movedCommentCount?: Maybe<Scalars['Float']>;
  movedVoteCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Feedback_Post_Merges_Var_Samp_Fields = {
  __typename?: 'feedback_post_merges_var_samp_fields';
  movedCommentCount?: Maybe<Scalars['Float']>;
  movedVoteCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Feedback_Post_Merges_Variance_Fields = {
  __typename?: 'feedback_post_merges_variance_fields';
  movedCommentCount?: Maybe<Scalars['Float']>;
  movedVoteCount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "feedback_posts" */
export type Feedback_Posts = {
  __typename?: 'feedback_posts';
  actualBehavior?: Maybe<Scalars['String']>;
  aiAnalysisStatus: Scalars['String'];
  aiAnalyzedAt?: Maybe<Scalars['timestamptz']>;
  aiAttempts: Scalars['smallint'];
  aiContentRevision?: Maybe<Scalars['Int']>;
  aiDuplicateConfidence?: Maybe<Scalars['numeric']>;
  aiDuplicateOfPostId?: Maybe<Scalars['uuid']>;
  aiKind?: Maybe<Scalars['String']>;
  aiKindConfidence?: Maybe<Scalars['numeric']>;
  aiModel?: Maybe<Scalars['String']>;
  aiModerationConfidence?: Maybe<Scalars['numeric']>;
  aiPolicyVersion?: Maybe<Scalars['String']>;
  aiReasonCodes?: Maybe<Array<Scalars['String']>>;
  aiRecommendation?: Maybe<Scalars['String']>;
  aiSuggestedTitle?: Maybe<Scalars['String']>;
  aiSummary?: Maybe<Scalars['String']>;
  /** An object relationship */
  author?: Maybe<Users>;
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName: Scalars['String'];
  authorUserId?: Maybe<Scalars['String']>;
  /** An object relationship */
  board: Feedback_Boards;
  boardId: Scalars['uuid'];
  /** An array relationship */
  comments: Array<Feedback_Comments>;
  /** An aggregate relationship */
  comments_aggregate: Feedback_Comments_Aggregate;
  contentRevision: Scalars['Int'];
  /** An array relationship */
  contexts: Array<Feedback_Post_Contexts>;
  /** An aggregate relationship */
  contexts_aggregate: Feedback_Post_Contexts_Aggregate;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  expectedBehavior?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isPinned: Scalars['Boolean'];
  kind: Scalars['String'];
  /** An array relationship */
  media: Array<Feedback_Media>;
  /** An aggregate relationship */
  media_aggregate: Feedback_Media_Aggregate;
  /** An object relationship */
  mergedInto?: Maybe<Feedback_Posts>;
  mergedIntoPostId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  mergedPosts: Array<Feedback_Posts>;
  /** An aggregate relationship */
  mergedPosts_aggregate: Feedback_Posts_Aggregate;
  moderationStatus: Scalars['String'];
  rejectionReason?: Maybe<Scalars['String']>;
  rejectionReasonKey?: Maybe<Scalars['String']>;
  /** An array relationship */
  releasePosts: Array<Feedback_Release_Posts>;
  /** An aggregate relationship */
  releasePosts_aggregate: Feedback_Release_Posts_Aggregate;
  reproSteps?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  reviewedBy?: Maybe<Scalars['String']>;
  reviewedContentRevision?: Maybe<Scalars['Int']>;
  searchText?: Maybe<Scalars['tsvector']>;
  severity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  /** An object relationship */
  status: Feedback_Statuses;
  statusChangedAt?: Maybe<Scalars['timestamptz']>;
  statusChangedBy?: Maybe<Scalars['String']>;
  statusId: Scalars['uuid'];
  statusNote?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  visibility: Scalars['String'];
  /** An array relationship */
  votes: Array<Feedback_Votes>;
  /** An aggregate relationship */
  votes_aggregate: Feedback_Votes_Aggregate;
};


/** columns and relationships of "feedback_posts" */
export type Feedback_PostsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Comments_Order_By>>;
  where?: InputMaybe<Feedback_Comments_Bool_Exp>;
};


/** columns and relationships of "feedback_posts" */
export type Feedback_PostsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Comments_Order_By>>;
  where?: InputMaybe<Feedback_Comments_Bool_Exp>;
};


/** columns and relationships of "feedback_posts" */
export type Feedback_PostsContextsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Post_Contexts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Post_Contexts_Order_By>>;
  where?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
};


/** columns and relationships of "feedback_posts" */
export type Feedback_PostsContexts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Post_Contexts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Post_Contexts_Order_By>>;
  where?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
};


/** columns and relationships of "feedback_posts" */
export type Feedback_PostsMediaArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Media_Order_By>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};


/** columns and relationships of "feedback_posts" */
export type Feedback_PostsMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Media_Order_By>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};


/** columns and relationships of "feedback_posts" */
export type Feedback_PostsMergedPostsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_Bool_Exp>;
};


/** columns and relationships of "feedback_posts" */
export type Feedback_PostsMergedPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_Bool_Exp>;
};


/** columns and relationships of "feedback_posts" */
export type Feedback_PostsReleasePostsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Release_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Release_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
};


/** columns and relationships of "feedback_posts" */
export type Feedback_PostsReleasePosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Release_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Release_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
};


/** columns and relationships of "feedback_posts" */
export type Feedback_PostsVotesArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Votes_Order_By>>;
  where?: InputMaybe<Feedback_Votes_Bool_Exp>;
};


/** columns and relationships of "feedback_posts" */
export type Feedback_PostsVotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Votes_Order_By>>;
  where?: InputMaybe<Feedback_Votes_Bool_Exp>;
};

/** aggregated selection of "feedback_posts" */
export type Feedback_Posts_Aggregate = {
  __typename?: 'feedback_posts_aggregate';
  aggregate?: Maybe<Feedback_Posts_Aggregate_Fields>;
  nodes: Array<Feedback_Posts>;
};

export type Feedback_Posts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Feedback_Posts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Feedback_Posts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Feedback_Posts_Aggregate_Bool_Exp_Count>;
};

export type Feedback_Posts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Feedback_Posts_Select_Column_Feedback_Posts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Feedback_Posts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Feedback_Posts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Feedback_Posts_Select_Column_Feedback_Posts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Feedback_Posts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Feedback_Posts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Feedback_Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Feedback_Posts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "feedback_posts" */
export type Feedback_Posts_Aggregate_Fields = {
  __typename?: 'feedback_posts_aggregate_fields';
  avg?: Maybe<Feedback_Posts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Feedback_Posts_Max_Fields>;
  min?: Maybe<Feedback_Posts_Min_Fields>;
  stddev?: Maybe<Feedback_Posts_Stddev_Fields>;
  stddev_pop?: Maybe<Feedback_Posts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feedback_Posts_Stddev_Samp_Fields>;
  sum?: Maybe<Feedback_Posts_Sum_Fields>;
  var_pop?: Maybe<Feedback_Posts_Var_Pop_Fields>;
  var_samp?: Maybe<Feedback_Posts_Var_Samp_Fields>;
  variance?: Maybe<Feedback_Posts_Variance_Fields>;
};


/** aggregate fields of "feedback_posts" */
export type Feedback_Posts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "feedback_posts" */
export type Feedback_Posts_Aggregate_Order_By = {
  avg?: InputMaybe<Feedback_Posts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Feedback_Posts_Max_Order_By>;
  min?: InputMaybe<Feedback_Posts_Min_Order_By>;
  stddev?: InputMaybe<Feedback_Posts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Feedback_Posts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Feedback_Posts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Feedback_Posts_Sum_Order_By>;
  var_pop?: InputMaybe<Feedback_Posts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Feedback_Posts_Var_Samp_Order_By>;
  variance?: InputMaybe<Feedback_Posts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "feedback_posts" */
export type Feedback_Posts_Arr_Rel_Insert_Input = {
  data: Array<Feedback_Posts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Feedback_Posts_On_Conflict>;
};

/** aggregate avg on columns */
export type Feedback_Posts_Avg_Fields = {
  __typename?: 'feedback_posts_avg_fields';
  aiAttempts?: Maybe<Scalars['Float']>;
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiDuplicateConfidence?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "feedback_posts" */
export type Feedback_Posts_Avg_Order_By = {
  aiAttempts?: InputMaybe<Order_By>;
  aiContentRevision?: InputMaybe<Order_By>;
  aiDuplicateConfidence?: InputMaybe<Order_By>;
  aiKindConfidence?: InputMaybe<Order_By>;
  aiModerationConfidence?: InputMaybe<Order_By>;
  contentRevision?: InputMaybe<Order_By>;
  reviewedContentRevision?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "feedback_posts". All fields are combined with a logical 'AND'. */
export type Feedback_Posts_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Posts_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Posts_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Posts_Bool_Exp>>;
  actualBehavior?: InputMaybe<String_Comparison_Exp>;
  aiAnalysisStatus?: InputMaybe<String_Comparison_Exp>;
  aiAnalyzedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  aiAttempts?: InputMaybe<Smallint_Comparison_Exp>;
  aiContentRevision?: InputMaybe<Int_Comparison_Exp>;
  aiDuplicateConfidence?: InputMaybe<Numeric_Comparison_Exp>;
  aiDuplicateOfPostId?: InputMaybe<Uuid_Comparison_Exp>;
  aiKind?: InputMaybe<String_Comparison_Exp>;
  aiKindConfidence?: InputMaybe<Numeric_Comparison_Exp>;
  aiModel?: InputMaybe<String_Comparison_Exp>;
  aiModerationConfidence?: InputMaybe<Numeric_Comparison_Exp>;
  aiPolicyVersion?: InputMaybe<String_Comparison_Exp>;
  aiReasonCodes?: InputMaybe<String_Array_Comparison_Exp>;
  aiRecommendation?: InputMaybe<String_Comparison_Exp>;
  aiSuggestedTitle?: InputMaybe<String_Comparison_Exp>;
  aiSummary?: InputMaybe<String_Comparison_Exp>;
  author?: InputMaybe<Users_Bool_Exp>;
  authorAvatarUrl?: InputMaybe<String_Comparison_Exp>;
  authorDisplayName?: InputMaybe<String_Comparison_Exp>;
  authorUserId?: InputMaybe<String_Comparison_Exp>;
  board?: InputMaybe<Feedback_Boards_Bool_Exp>;
  boardId?: InputMaybe<Uuid_Comparison_Exp>;
  comments?: InputMaybe<Feedback_Comments_Bool_Exp>;
  comments_aggregate?: InputMaybe<Feedback_Comments_Aggregate_Bool_Exp>;
  contentRevision?: InputMaybe<Int_Comparison_Exp>;
  contexts?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
  contexts_aggregate?: InputMaybe<Feedback_Post_Contexts_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  expectedBehavior?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isPinned?: InputMaybe<Boolean_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  media?: InputMaybe<Feedback_Media_Bool_Exp>;
  media_aggregate?: InputMaybe<Feedback_Media_Aggregate_Bool_Exp>;
  mergedInto?: InputMaybe<Feedback_Posts_Bool_Exp>;
  mergedIntoPostId?: InputMaybe<Uuid_Comparison_Exp>;
  mergedPosts?: InputMaybe<Feedback_Posts_Bool_Exp>;
  mergedPosts_aggregate?: InputMaybe<Feedback_Posts_Aggregate_Bool_Exp>;
  moderationStatus?: InputMaybe<String_Comparison_Exp>;
  rejectionReason?: InputMaybe<String_Comparison_Exp>;
  rejectionReasonKey?: InputMaybe<String_Comparison_Exp>;
  releasePosts?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
  releasePosts_aggregate?: InputMaybe<Feedback_Release_Posts_Aggregate_Bool_Exp>;
  reproSteps?: InputMaybe<String_Comparison_Exp>;
  reviewedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewedBy?: InputMaybe<String_Comparison_Exp>;
  reviewedContentRevision?: InputMaybe<Int_Comparison_Exp>;
  searchText?: InputMaybe<Tsvector_Comparison_Exp>;
  severity?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Feedback_Statuses_Bool_Exp>;
  statusChangedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  statusChangedBy?: InputMaybe<String_Comparison_Exp>;
  statusId?: InputMaybe<Uuid_Comparison_Exp>;
  statusNote?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  visibility?: InputMaybe<String_Comparison_Exp>;
  votes?: InputMaybe<Feedback_Votes_Bool_Exp>;
  votes_aggregate?: InputMaybe<Feedback_Votes_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "feedback_posts" */
export const Feedback_Posts_Constraint = {
  /** unique or primary key constraint on columns "id" */
  FeedbackPostsPkey: 'feedback_posts_pkey',
  /** unique or primary key constraint on columns "slug" */
  FeedbackPostsSlugKey: 'feedback_posts_slug_key'
} as const;

export type Feedback_Posts_Constraint = typeof Feedback_Posts_Constraint[keyof typeof Feedback_Posts_Constraint];
/** input type for incrementing numeric columns in table "feedback_posts" */
export type Feedback_Posts_Inc_Input = {
  aiAttempts?: InputMaybe<Scalars['smallint']>;
  aiContentRevision?: InputMaybe<Scalars['Int']>;
  aiDuplicateConfidence?: InputMaybe<Scalars['numeric']>;
  aiKindConfidence?: InputMaybe<Scalars['numeric']>;
  aiModerationConfidence?: InputMaybe<Scalars['numeric']>;
  contentRevision?: InputMaybe<Scalars['Int']>;
  reviewedContentRevision?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "feedback_posts" */
export type Feedback_Posts_Insert_Input = {
  actualBehavior?: InputMaybe<Scalars['String']>;
  aiAnalysisStatus?: InputMaybe<Scalars['String']>;
  aiAnalyzedAt?: InputMaybe<Scalars['timestamptz']>;
  aiAttempts?: InputMaybe<Scalars['smallint']>;
  aiContentRevision?: InputMaybe<Scalars['Int']>;
  aiDuplicateConfidence?: InputMaybe<Scalars['numeric']>;
  aiDuplicateOfPostId?: InputMaybe<Scalars['uuid']>;
  aiKind?: InputMaybe<Scalars['String']>;
  aiKindConfidence?: InputMaybe<Scalars['numeric']>;
  aiModel?: InputMaybe<Scalars['String']>;
  aiModerationConfidence?: InputMaybe<Scalars['numeric']>;
  aiPolicyVersion?: InputMaybe<Scalars['String']>;
  aiReasonCodes?: InputMaybe<Array<Scalars['String']>>;
  aiRecommendation?: InputMaybe<Scalars['String']>;
  aiSuggestedTitle?: InputMaybe<Scalars['String']>;
  aiSummary?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  authorAvatarUrl?: InputMaybe<Scalars['String']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorUserId?: InputMaybe<Scalars['String']>;
  board?: InputMaybe<Feedback_Boards_Obj_Rel_Insert_Input>;
  boardId?: InputMaybe<Scalars['uuid']>;
  comments?: InputMaybe<Feedback_Comments_Arr_Rel_Insert_Input>;
  contentRevision?: InputMaybe<Scalars['Int']>;
  contexts?: InputMaybe<Feedback_Post_Contexts_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  expectedBehavior?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Feedback_Media_Arr_Rel_Insert_Input>;
  mergedInto?: InputMaybe<Feedback_Posts_Obj_Rel_Insert_Input>;
  mergedIntoPostId?: InputMaybe<Scalars['uuid']>;
  mergedPosts?: InputMaybe<Feedback_Posts_Arr_Rel_Insert_Input>;
  moderationStatus?: InputMaybe<Scalars['String']>;
  rejectionReason?: InputMaybe<Scalars['String']>;
  rejectionReasonKey?: InputMaybe<Scalars['String']>;
  releasePosts?: InputMaybe<Feedback_Release_Posts_Arr_Rel_Insert_Input>;
  reproSteps?: InputMaybe<Scalars['String']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewedBy?: InputMaybe<Scalars['String']>;
  reviewedContentRevision?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Feedback_Statuses_Obj_Rel_Insert_Input>;
  statusChangedAt?: InputMaybe<Scalars['timestamptz']>;
  statusChangedBy?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['uuid']>;
  statusNote?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visibility?: InputMaybe<Scalars['String']>;
  votes?: InputMaybe<Feedback_Votes_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Feedback_Posts_Max_Fields = {
  __typename?: 'feedback_posts_max_fields';
  actualBehavior?: Maybe<Scalars['String']>;
  aiAnalysisStatus?: Maybe<Scalars['String']>;
  aiAnalyzedAt?: Maybe<Scalars['timestamptz']>;
  aiAttempts?: Maybe<Scalars['smallint']>;
  aiContentRevision?: Maybe<Scalars['Int']>;
  aiDuplicateConfidence?: Maybe<Scalars['numeric']>;
  aiDuplicateOfPostId?: Maybe<Scalars['uuid']>;
  aiKind?: Maybe<Scalars['String']>;
  aiKindConfidence?: Maybe<Scalars['numeric']>;
  aiModel?: Maybe<Scalars['String']>;
  aiModerationConfidence?: Maybe<Scalars['numeric']>;
  aiPolicyVersion?: Maybe<Scalars['String']>;
  aiReasonCodes?: Maybe<Array<Scalars['String']>>;
  aiRecommendation?: Maybe<Scalars['String']>;
  aiSuggestedTitle?: Maybe<Scalars['String']>;
  aiSummary?: Maybe<Scalars['String']>;
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName?: Maybe<Scalars['String']>;
  authorUserId?: Maybe<Scalars['String']>;
  boardId?: Maybe<Scalars['uuid']>;
  contentRevision?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  expectedBehavior?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  mergedIntoPostId?: Maybe<Scalars['uuid']>;
  moderationStatus?: Maybe<Scalars['String']>;
  rejectionReason?: Maybe<Scalars['String']>;
  rejectionReasonKey?: Maybe<Scalars['String']>;
  reproSteps?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  reviewedBy?: Maybe<Scalars['String']>;
  reviewedContentRevision?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  statusChangedAt?: Maybe<Scalars['timestamptz']>;
  statusChangedBy?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['uuid']>;
  statusNote?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visibility?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "feedback_posts" */
export type Feedback_Posts_Max_Order_By = {
  actualBehavior?: InputMaybe<Order_By>;
  aiAnalysisStatus?: InputMaybe<Order_By>;
  aiAnalyzedAt?: InputMaybe<Order_By>;
  aiAttempts?: InputMaybe<Order_By>;
  aiContentRevision?: InputMaybe<Order_By>;
  aiDuplicateConfidence?: InputMaybe<Order_By>;
  aiDuplicateOfPostId?: InputMaybe<Order_By>;
  aiKind?: InputMaybe<Order_By>;
  aiKindConfidence?: InputMaybe<Order_By>;
  aiModel?: InputMaybe<Order_By>;
  aiModerationConfidence?: InputMaybe<Order_By>;
  aiPolicyVersion?: InputMaybe<Order_By>;
  aiReasonCodes?: InputMaybe<Order_By>;
  aiRecommendation?: InputMaybe<Order_By>;
  aiSuggestedTitle?: InputMaybe<Order_By>;
  aiSummary?: InputMaybe<Order_By>;
  authorAvatarUrl?: InputMaybe<Order_By>;
  authorDisplayName?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  boardId?: InputMaybe<Order_By>;
  contentRevision?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expectedBehavior?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  mergedIntoPostId?: InputMaybe<Order_By>;
  moderationStatus?: InputMaybe<Order_By>;
  rejectionReason?: InputMaybe<Order_By>;
  rejectionReasonKey?: InputMaybe<Order_By>;
  reproSteps?: InputMaybe<Order_By>;
  reviewedAt?: InputMaybe<Order_By>;
  reviewedBy?: InputMaybe<Order_By>;
  reviewedContentRevision?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  statusChangedAt?: InputMaybe<Order_By>;
  statusChangedBy?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  statusNote?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Feedback_Posts_Min_Fields = {
  __typename?: 'feedback_posts_min_fields';
  actualBehavior?: Maybe<Scalars['String']>;
  aiAnalysisStatus?: Maybe<Scalars['String']>;
  aiAnalyzedAt?: Maybe<Scalars['timestamptz']>;
  aiAttempts?: Maybe<Scalars['smallint']>;
  aiContentRevision?: Maybe<Scalars['Int']>;
  aiDuplicateConfidence?: Maybe<Scalars['numeric']>;
  aiDuplicateOfPostId?: Maybe<Scalars['uuid']>;
  aiKind?: Maybe<Scalars['String']>;
  aiKindConfidence?: Maybe<Scalars['numeric']>;
  aiModel?: Maybe<Scalars['String']>;
  aiModerationConfidence?: Maybe<Scalars['numeric']>;
  aiPolicyVersion?: Maybe<Scalars['String']>;
  aiReasonCodes?: Maybe<Array<Scalars['String']>>;
  aiRecommendation?: Maybe<Scalars['String']>;
  aiSuggestedTitle?: Maybe<Scalars['String']>;
  aiSummary?: Maybe<Scalars['String']>;
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName?: Maybe<Scalars['String']>;
  authorUserId?: Maybe<Scalars['String']>;
  boardId?: Maybe<Scalars['uuid']>;
  contentRevision?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  expectedBehavior?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  mergedIntoPostId?: Maybe<Scalars['uuid']>;
  moderationStatus?: Maybe<Scalars['String']>;
  rejectionReason?: Maybe<Scalars['String']>;
  rejectionReasonKey?: Maybe<Scalars['String']>;
  reproSteps?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  reviewedBy?: Maybe<Scalars['String']>;
  reviewedContentRevision?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  statusChangedAt?: Maybe<Scalars['timestamptz']>;
  statusChangedBy?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['uuid']>;
  statusNote?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visibility?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "feedback_posts" */
export type Feedback_Posts_Min_Order_By = {
  actualBehavior?: InputMaybe<Order_By>;
  aiAnalysisStatus?: InputMaybe<Order_By>;
  aiAnalyzedAt?: InputMaybe<Order_By>;
  aiAttempts?: InputMaybe<Order_By>;
  aiContentRevision?: InputMaybe<Order_By>;
  aiDuplicateConfidence?: InputMaybe<Order_By>;
  aiDuplicateOfPostId?: InputMaybe<Order_By>;
  aiKind?: InputMaybe<Order_By>;
  aiKindConfidence?: InputMaybe<Order_By>;
  aiModel?: InputMaybe<Order_By>;
  aiModerationConfidence?: InputMaybe<Order_By>;
  aiPolicyVersion?: InputMaybe<Order_By>;
  aiReasonCodes?: InputMaybe<Order_By>;
  aiRecommendation?: InputMaybe<Order_By>;
  aiSuggestedTitle?: InputMaybe<Order_By>;
  aiSummary?: InputMaybe<Order_By>;
  authorAvatarUrl?: InputMaybe<Order_By>;
  authorDisplayName?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  boardId?: InputMaybe<Order_By>;
  contentRevision?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expectedBehavior?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  mergedIntoPostId?: InputMaybe<Order_By>;
  moderationStatus?: InputMaybe<Order_By>;
  rejectionReason?: InputMaybe<Order_By>;
  rejectionReasonKey?: InputMaybe<Order_By>;
  reproSteps?: InputMaybe<Order_By>;
  reviewedAt?: InputMaybe<Order_By>;
  reviewedBy?: InputMaybe<Order_By>;
  reviewedContentRevision?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  statusChangedAt?: InputMaybe<Order_By>;
  statusChangedBy?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  statusNote?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "feedback_posts" */
export type Feedback_Posts_Mutation_Response = {
  __typename?: 'feedback_posts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback_Posts>;
};

/** input type for inserting object relation for remote table "feedback_posts" */
export type Feedback_Posts_Obj_Rel_Insert_Input = {
  data: Feedback_Posts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Feedback_Posts_On_Conflict>;
};

/** on_conflict condition type for table "feedback_posts" */
export type Feedback_Posts_On_Conflict = {
  constraint: Feedback_Posts_Constraint;
  update_columns?: Array<Feedback_Posts_Update_Column>;
  where?: InputMaybe<Feedback_Posts_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback_posts". */
export type Feedback_Posts_Order_By = {
  actualBehavior?: InputMaybe<Order_By>;
  aiAnalysisStatus?: InputMaybe<Order_By>;
  aiAnalyzedAt?: InputMaybe<Order_By>;
  aiAttempts?: InputMaybe<Order_By>;
  aiContentRevision?: InputMaybe<Order_By>;
  aiDuplicateConfidence?: InputMaybe<Order_By>;
  aiDuplicateOfPostId?: InputMaybe<Order_By>;
  aiKind?: InputMaybe<Order_By>;
  aiKindConfidence?: InputMaybe<Order_By>;
  aiModel?: InputMaybe<Order_By>;
  aiModerationConfidence?: InputMaybe<Order_By>;
  aiPolicyVersion?: InputMaybe<Order_By>;
  aiReasonCodes?: InputMaybe<Order_By>;
  aiRecommendation?: InputMaybe<Order_By>;
  aiSuggestedTitle?: InputMaybe<Order_By>;
  aiSummary?: InputMaybe<Order_By>;
  author?: InputMaybe<Users_Order_By>;
  authorAvatarUrl?: InputMaybe<Order_By>;
  authorDisplayName?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  board?: InputMaybe<Feedback_Boards_Order_By>;
  boardId?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Feedback_Comments_Aggregate_Order_By>;
  contentRevision?: InputMaybe<Order_By>;
  contexts_aggregate?: InputMaybe<Feedback_Post_Contexts_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expectedBehavior?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isPinned?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  media_aggregate?: InputMaybe<Feedback_Media_Aggregate_Order_By>;
  mergedInto?: InputMaybe<Feedback_Posts_Order_By>;
  mergedIntoPostId?: InputMaybe<Order_By>;
  mergedPosts_aggregate?: InputMaybe<Feedback_Posts_Aggregate_Order_By>;
  moderationStatus?: InputMaybe<Order_By>;
  rejectionReason?: InputMaybe<Order_By>;
  rejectionReasonKey?: InputMaybe<Order_By>;
  releasePosts_aggregate?: InputMaybe<Feedback_Release_Posts_Aggregate_Order_By>;
  reproSteps?: InputMaybe<Order_By>;
  reviewedAt?: InputMaybe<Order_By>;
  reviewedBy?: InputMaybe<Order_By>;
  reviewedContentRevision?: InputMaybe<Order_By>;
  searchText?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Feedback_Statuses_Order_By>;
  statusChangedAt?: InputMaybe<Order_By>;
  statusChangedBy?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  statusNote?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
  votes_aggregate?: InputMaybe<Feedback_Votes_Aggregate_Order_By>;
};

/** primary key columns input for table: feedback_posts */
export type Feedback_Posts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "feedback_posts" */
export const Feedback_Posts_Select_Column = {
  /** column name */
  ActualBehavior: 'actualBehavior',
  /** column name */
  AiAnalysisStatus: 'aiAnalysisStatus',
  /** column name */
  AiAnalyzedAt: 'aiAnalyzedAt',
  /** column name */
  AiAttempts: 'aiAttempts',
  /** column name */
  AiContentRevision: 'aiContentRevision',
  /** column name */
  AiDuplicateConfidence: 'aiDuplicateConfidence',
  /** column name */
  AiDuplicateOfPostId: 'aiDuplicateOfPostId',
  /** column name */
  AiKind: 'aiKind',
  /** column name */
  AiKindConfidence: 'aiKindConfidence',
  /** column name */
  AiModel: 'aiModel',
  /** column name */
  AiModerationConfidence: 'aiModerationConfidence',
  /** column name */
  AiPolicyVersion: 'aiPolicyVersion',
  /** column name */
  AiReasonCodes: 'aiReasonCodes',
  /** column name */
  AiRecommendation: 'aiRecommendation',
  /** column name */
  AiSuggestedTitle: 'aiSuggestedTitle',
  /** column name */
  AiSummary: 'aiSummary',
  /** column name */
  AuthorAvatarUrl: 'authorAvatarUrl',
  /** column name */
  AuthorDisplayName: 'authorDisplayName',
  /** column name */
  AuthorUserId: 'authorUserId',
  /** column name */
  BoardId: 'boardId',
  /** column name */
  ContentRevision: 'contentRevision',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Description: 'description',
  /** column name */
  ExpectedBehavior: 'expectedBehavior',
  /** column name */
  Id: 'id',
  /** column name */
  IsPinned: 'isPinned',
  /** column name */
  Kind: 'kind',
  /** column name */
  MergedIntoPostId: 'mergedIntoPostId',
  /** column name */
  ModerationStatus: 'moderationStatus',
  /** column name */
  RejectionReason: 'rejectionReason',
  /** column name */
  RejectionReasonKey: 'rejectionReasonKey',
  /** column name */
  ReproSteps: 'reproSteps',
  /** column name */
  ReviewedAt: 'reviewedAt',
  /** column name */
  ReviewedBy: 'reviewedBy',
  /** column name */
  ReviewedContentRevision: 'reviewedContentRevision',
  /** column name */
  SearchText: 'searchText',
  /** column name */
  Severity: 'severity',
  /** column name */
  Slug: 'slug',
  /** column name */
  StatusChangedAt: 'statusChangedAt',
  /** column name */
  StatusChangedBy: 'statusChangedBy',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  StatusNote: 'statusNote',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Visibility: 'visibility'
} as const;

export type Feedback_Posts_Select_Column = typeof Feedback_Posts_Select_Column[keyof typeof Feedback_Posts_Select_Column];
/** select "feedback_posts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "feedback_posts" */
export const Feedback_Posts_Select_Column_Feedback_Posts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  IsPinned: 'isPinned'
} as const;

export type Feedback_Posts_Select_Column_Feedback_Posts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Feedback_Posts_Select_Column_Feedback_Posts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Feedback_Posts_Select_Column_Feedback_Posts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "feedback_posts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "feedback_posts" */
export const Feedback_Posts_Select_Column_Feedback_Posts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  IsPinned: 'isPinned'
} as const;

export type Feedback_Posts_Select_Column_Feedback_Posts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Feedback_Posts_Select_Column_Feedback_Posts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Feedback_Posts_Select_Column_Feedback_Posts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "feedback_posts" */
export type Feedback_Posts_Set_Input = {
  actualBehavior?: InputMaybe<Scalars['String']>;
  aiAnalysisStatus?: InputMaybe<Scalars['String']>;
  aiAnalyzedAt?: InputMaybe<Scalars['timestamptz']>;
  aiAttempts?: InputMaybe<Scalars['smallint']>;
  aiContentRevision?: InputMaybe<Scalars['Int']>;
  aiDuplicateConfidence?: InputMaybe<Scalars['numeric']>;
  aiDuplicateOfPostId?: InputMaybe<Scalars['uuid']>;
  aiKind?: InputMaybe<Scalars['String']>;
  aiKindConfidence?: InputMaybe<Scalars['numeric']>;
  aiModel?: InputMaybe<Scalars['String']>;
  aiModerationConfidence?: InputMaybe<Scalars['numeric']>;
  aiPolicyVersion?: InputMaybe<Scalars['String']>;
  aiReasonCodes?: InputMaybe<Array<Scalars['String']>>;
  aiRecommendation?: InputMaybe<Scalars['String']>;
  aiSuggestedTitle?: InputMaybe<Scalars['String']>;
  aiSummary?: InputMaybe<Scalars['String']>;
  authorAvatarUrl?: InputMaybe<Scalars['String']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorUserId?: InputMaybe<Scalars['String']>;
  boardId?: InputMaybe<Scalars['uuid']>;
  contentRevision?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  expectedBehavior?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  mergedIntoPostId?: InputMaybe<Scalars['uuid']>;
  moderationStatus?: InputMaybe<Scalars['String']>;
  rejectionReason?: InputMaybe<Scalars['String']>;
  rejectionReasonKey?: InputMaybe<Scalars['String']>;
  reproSteps?: InputMaybe<Scalars['String']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewedBy?: InputMaybe<Scalars['String']>;
  reviewedContentRevision?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  statusChangedAt?: InputMaybe<Scalars['timestamptz']>;
  statusChangedBy?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['uuid']>;
  statusNote?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visibility?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Feedback_Posts_Stddev_Fields = {
  __typename?: 'feedback_posts_stddev_fields';
  aiAttempts?: Maybe<Scalars['Float']>;
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiDuplicateConfidence?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "feedback_posts" */
export type Feedback_Posts_Stddev_Order_By = {
  aiAttempts?: InputMaybe<Order_By>;
  aiContentRevision?: InputMaybe<Order_By>;
  aiDuplicateConfidence?: InputMaybe<Order_By>;
  aiKindConfidence?: InputMaybe<Order_By>;
  aiModerationConfidence?: InputMaybe<Order_By>;
  contentRevision?: InputMaybe<Order_By>;
  reviewedContentRevision?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Feedback_Posts_Stddev_Pop_Fields = {
  __typename?: 'feedback_posts_stddev_pop_fields';
  aiAttempts?: Maybe<Scalars['Float']>;
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiDuplicateConfidence?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "feedback_posts" */
export type Feedback_Posts_Stddev_Pop_Order_By = {
  aiAttempts?: InputMaybe<Order_By>;
  aiContentRevision?: InputMaybe<Order_By>;
  aiDuplicateConfidence?: InputMaybe<Order_By>;
  aiKindConfidence?: InputMaybe<Order_By>;
  aiModerationConfidence?: InputMaybe<Order_By>;
  contentRevision?: InputMaybe<Order_By>;
  reviewedContentRevision?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Feedback_Posts_Stddev_Samp_Fields = {
  __typename?: 'feedback_posts_stddev_samp_fields';
  aiAttempts?: Maybe<Scalars['Float']>;
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiDuplicateConfidence?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "feedback_posts" */
export type Feedback_Posts_Stddev_Samp_Order_By = {
  aiAttempts?: InputMaybe<Order_By>;
  aiContentRevision?: InputMaybe<Order_By>;
  aiDuplicateConfidence?: InputMaybe<Order_By>;
  aiKindConfidence?: InputMaybe<Order_By>;
  aiModerationConfidence?: InputMaybe<Order_By>;
  contentRevision?: InputMaybe<Order_By>;
  reviewedContentRevision?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "feedback_posts" */
export type Feedback_Posts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Posts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Posts_Stream_Cursor_Value_Input = {
  actualBehavior?: InputMaybe<Scalars['String']>;
  aiAnalysisStatus?: InputMaybe<Scalars['String']>;
  aiAnalyzedAt?: InputMaybe<Scalars['timestamptz']>;
  aiAttempts?: InputMaybe<Scalars['smallint']>;
  aiContentRevision?: InputMaybe<Scalars['Int']>;
  aiDuplicateConfidence?: InputMaybe<Scalars['numeric']>;
  aiDuplicateOfPostId?: InputMaybe<Scalars['uuid']>;
  aiKind?: InputMaybe<Scalars['String']>;
  aiKindConfidence?: InputMaybe<Scalars['numeric']>;
  aiModel?: InputMaybe<Scalars['String']>;
  aiModerationConfidence?: InputMaybe<Scalars['numeric']>;
  aiPolicyVersion?: InputMaybe<Scalars['String']>;
  aiReasonCodes?: InputMaybe<Array<Scalars['String']>>;
  aiRecommendation?: InputMaybe<Scalars['String']>;
  aiSuggestedTitle?: InputMaybe<Scalars['String']>;
  aiSummary?: InputMaybe<Scalars['String']>;
  authorAvatarUrl?: InputMaybe<Scalars['String']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorUserId?: InputMaybe<Scalars['String']>;
  boardId?: InputMaybe<Scalars['uuid']>;
  contentRevision?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  expectedBehavior?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  mergedIntoPostId?: InputMaybe<Scalars['uuid']>;
  moderationStatus?: InputMaybe<Scalars['String']>;
  rejectionReason?: InputMaybe<Scalars['String']>;
  rejectionReasonKey?: InputMaybe<Scalars['String']>;
  reproSteps?: InputMaybe<Scalars['String']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewedBy?: InputMaybe<Scalars['String']>;
  reviewedContentRevision?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['tsvector']>;
  severity?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  statusChangedAt?: InputMaybe<Scalars['timestamptz']>;
  statusChangedBy?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['uuid']>;
  statusNote?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visibility?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Feedback_Posts_Sum_Fields = {
  __typename?: 'feedback_posts_sum_fields';
  aiAttempts?: Maybe<Scalars['smallint']>;
  aiContentRevision?: Maybe<Scalars['Int']>;
  aiDuplicateConfidence?: Maybe<Scalars['numeric']>;
  aiKindConfidence?: Maybe<Scalars['numeric']>;
  aiModerationConfidence?: Maybe<Scalars['numeric']>;
  contentRevision?: Maybe<Scalars['Int']>;
  reviewedContentRevision?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "feedback_posts" */
export type Feedback_Posts_Sum_Order_By = {
  aiAttempts?: InputMaybe<Order_By>;
  aiContentRevision?: InputMaybe<Order_By>;
  aiDuplicateConfidence?: InputMaybe<Order_By>;
  aiKindConfidence?: InputMaybe<Order_By>;
  aiModerationConfidence?: InputMaybe<Order_By>;
  contentRevision?: InputMaybe<Order_By>;
  reviewedContentRevision?: InputMaybe<Order_By>;
};

/** update columns of table "feedback_posts" */
export const Feedback_Posts_Update_Column = {
  /** column name */
  ActualBehavior: 'actualBehavior',
  /** column name */
  AiAnalysisStatus: 'aiAnalysisStatus',
  /** column name */
  AiAnalyzedAt: 'aiAnalyzedAt',
  /** column name */
  AiAttempts: 'aiAttempts',
  /** column name */
  AiContentRevision: 'aiContentRevision',
  /** column name */
  AiDuplicateConfidence: 'aiDuplicateConfidence',
  /** column name */
  AiDuplicateOfPostId: 'aiDuplicateOfPostId',
  /** column name */
  AiKind: 'aiKind',
  /** column name */
  AiKindConfidence: 'aiKindConfidence',
  /** column name */
  AiModel: 'aiModel',
  /** column name */
  AiModerationConfidence: 'aiModerationConfidence',
  /** column name */
  AiPolicyVersion: 'aiPolicyVersion',
  /** column name */
  AiReasonCodes: 'aiReasonCodes',
  /** column name */
  AiRecommendation: 'aiRecommendation',
  /** column name */
  AiSuggestedTitle: 'aiSuggestedTitle',
  /** column name */
  AiSummary: 'aiSummary',
  /** column name */
  AuthorAvatarUrl: 'authorAvatarUrl',
  /** column name */
  AuthorDisplayName: 'authorDisplayName',
  /** column name */
  AuthorUserId: 'authorUserId',
  /** column name */
  BoardId: 'boardId',
  /** column name */
  ContentRevision: 'contentRevision',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Description: 'description',
  /** column name */
  ExpectedBehavior: 'expectedBehavior',
  /** column name */
  Id: 'id',
  /** column name */
  IsPinned: 'isPinned',
  /** column name */
  Kind: 'kind',
  /** column name */
  MergedIntoPostId: 'mergedIntoPostId',
  /** column name */
  ModerationStatus: 'moderationStatus',
  /** column name */
  RejectionReason: 'rejectionReason',
  /** column name */
  RejectionReasonKey: 'rejectionReasonKey',
  /** column name */
  ReproSteps: 'reproSteps',
  /** column name */
  ReviewedAt: 'reviewedAt',
  /** column name */
  ReviewedBy: 'reviewedBy',
  /** column name */
  ReviewedContentRevision: 'reviewedContentRevision',
  /** column name */
  Severity: 'severity',
  /** column name */
  Slug: 'slug',
  /** column name */
  StatusChangedAt: 'statusChangedAt',
  /** column name */
  StatusChangedBy: 'statusChangedBy',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  StatusNote: 'statusNote',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Visibility: 'visibility'
} as const;

export type Feedback_Posts_Update_Column = typeof Feedback_Posts_Update_Column[keyof typeof Feedback_Posts_Update_Column];
export type Feedback_Posts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feedback_Posts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Posts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Posts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feedback_Posts_Var_Pop_Fields = {
  __typename?: 'feedback_posts_var_pop_fields';
  aiAttempts?: Maybe<Scalars['Float']>;
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiDuplicateConfidence?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "feedback_posts" */
export type Feedback_Posts_Var_Pop_Order_By = {
  aiAttempts?: InputMaybe<Order_By>;
  aiContentRevision?: InputMaybe<Order_By>;
  aiDuplicateConfidence?: InputMaybe<Order_By>;
  aiKindConfidence?: InputMaybe<Order_By>;
  aiModerationConfidence?: InputMaybe<Order_By>;
  contentRevision?: InputMaybe<Order_By>;
  reviewedContentRevision?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Feedback_Posts_Var_Samp_Fields = {
  __typename?: 'feedback_posts_var_samp_fields';
  aiAttempts?: Maybe<Scalars['Float']>;
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiDuplicateConfidence?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "feedback_posts" */
export type Feedback_Posts_Var_Samp_Order_By = {
  aiAttempts?: InputMaybe<Order_By>;
  aiContentRevision?: InputMaybe<Order_By>;
  aiDuplicateConfidence?: InputMaybe<Order_By>;
  aiKindConfidence?: InputMaybe<Order_By>;
  aiModerationConfidence?: InputMaybe<Order_By>;
  contentRevision?: InputMaybe<Order_By>;
  reviewedContentRevision?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Feedback_Posts_Variance_Fields = {
  __typename?: 'feedback_posts_variance_fields';
  aiAttempts?: Maybe<Scalars['Float']>;
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiDuplicateConfidence?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "feedback_posts" */
export type Feedback_Posts_Variance_Order_By = {
  aiAttempts?: InputMaybe<Order_By>;
  aiContentRevision?: InputMaybe<Order_By>;
  aiDuplicateConfidence?: InputMaybe<Order_By>;
  aiKindConfidence?: InputMaybe<Order_By>;
  aiModerationConfidence?: InputMaybe<Order_By>;
  contentRevision?: InputMaybe<Order_By>;
  reviewedContentRevision?: InputMaybe<Order_By>;
};

/** columns and relationships of "feedback_posts_with_counts" */
export type Feedback_Posts_With_Counts = {
  __typename?: 'feedback_posts_with_counts';
  actualBehavior?: Maybe<Scalars['String']>;
  aiAnalysisStatus?: Maybe<Scalars['String']>;
  aiAnalyzedAt?: Maybe<Scalars['timestamptz']>;
  aiContentRevision?: Maybe<Scalars['Int']>;
  aiKind?: Maybe<Scalars['String']>;
  aiKindConfidence?: Maybe<Scalars['numeric']>;
  aiModel?: Maybe<Scalars['String']>;
  aiModerationConfidence?: Maybe<Scalars['numeric']>;
  aiPolicyVersion?: Maybe<Scalars['String']>;
  aiReasonCodes?: Maybe<Array<Scalars['String']>>;
  aiRecommendation?: Maybe<Scalars['String']>;
  aiSummary?: Maybe<Scalars['String']>;
  /** An object relationship */
  author?: Maybe<Users>;
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName?: Maybe<Scalars['String']>;
  authorUserId?: Maybe<Scalars['String']>;
  /** An object relationship */
  board?: Maybe<Feedback_Boards>;
  boardId?: Maybe<Scalars['uuid']>;
  commentCount?: Maybe<Scalars['bigint']>;
  contentRevision?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  expectedBehavior?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  isPinned?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<Scalars['String']>;
  /** An array relationship */
  media: Array<Feedback_Media>;
  /** An aggregate relationship */
  media_aggregate: Feedback_Media_Aggregate;
  mergedIntoPostId?: Maybe<Scalars['uuid']>;
  moderationStatus?: Maybe<Scalars['String']>;
  rejectionReason?: Maybe<Scalars['String']>;
  reproSteps?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  reviewedBy?: Maybe<Scalars['String']>;
  reviewedContentRevision?: Maybe<Scalars['Int']>;
  searchText?: Maybe<Scalars['tsvector']>;
  severity?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** An object relationship */
  status?: Maybe<Feedback_Statuses>;
  statusId?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visibility?: Maybe<Scalars['String']>;
  voteCount?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "feedback_posts_with_counts" */
export type Feedback_Posts_With_CountsMediaArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Media_Order_By>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};


/** columns and relationships of "feedback_posts_with_counts" */
export type Feedback_Posts_With_CountsMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Media_Order_By>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};

/** aggregated selection of "feedback_posts_with_counts" */
export type Feedback_Posts_With_Counts_Aggregate = {
  __typename?: 'feedback_posts_with_counts_aggregate';
  aggregate?: Maybe<Feedback_Posts_With_Counts_Aggregate_Fields>;
  nodes: Array<Feedback_Posts_With_Counts>;
};

/** aggregate fields of "feedback_posts_with_counts" */
export type Feedback_Posts_With_Counts_Aggregate_Fields = {
  __typename?: 'feedback_posts_with_counts_aggregate_fields';
  avg?: Maybe<Feedback_Posts_With_Counts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Feedback_Posts_With_Counts_Max_Fields>;
  min?: Maybe<Feedback_Posts_With_Counts_Min_Fields>;
  stddev?: Maybe<Feedback_Posts_With_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Feedback_Posts_With_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feedback_Posts_With_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Feedback_Posts_With_Counts_Sum_Fields>;
  var_pop?: Maybe<Feedback_Posts_With_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Feedback_Posts_With_Counts_Var_Samp_Fields>;
  variance?: Maybe<Feedback_Posts_With_Counts_Variance_Fields>;
};


/** aggregate fields of "feedback_posts_with_counts" */
export type Feedback_Posts_With_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Posts_With_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Feedback_Posts_With_Counts_Avg_Fields = {
  __typename?: 'feedback_posts_with_counts_avg_fields';
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
  voteCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "feedback_posts_with_counts". All fields are combined with a logical 'AND'. */
export type Feedback_Posts_With_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Posts_With_Counts_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Posts_With_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Posts_With_Counts_Bool_Exp>>;
  actualBehavior?: InputMaybe<String_Comparison_Exp>;
  aiAnalysisStatus?: InputMaybe<String_Comparison_Exp>;
  aiAnalyzedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  aiContentRevision?: InputMaybe<Int_Comparison_Exp>;
  aiKind?: InputMaybe<String_Comparison_Exp>;
  aiKindConfidence?: InputMaybe<Numeric_Comparison_Exp>;
  aiModel?: InputMaybe<String_Comparison_Exp>;
  aiModerationConfidence?: InputMaybe<Numeric_Comparison_Exp>;
  aiPolicyVersion?: InputMaybe<String_Comparison_Exp>;
  aiReasonCodes?: InputMaybe<String_Array_Comparison_Exp>;
  aiRecommendation?: InputMaybe<String_Comparison_Exp>;
  aiSummary?: InputMaybe<String_Comparison_Exp>;
  author?: InputMaybe<Users_Bool_Exp>;
  authorAvatarUrl?: InputMaybe<String_Comparison_Exp>;
  authorDisplayName?: InputMaybe<String_Comparison_Exp>;
  authorUserId?: InputMaybe<String_Comparison_Exp>;
  board?: InputMaybe<Feedback_Boards_Bool_Exp>;
  boardId?: InputMaybe<Uuid_Comparison_Exp>;
  commentCount?: InputMaybe<Bigint_Comparison_Exp>;
  contentRevision?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  expectedBehavior?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isPinned?: InputMaybe<Boolean_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  media?: InputMaybe<Feedback_Media_Bool_Exp>;
  media_aggregate?: InputMaybe<Feedback_Media_Aggregate_Bool_Exp>;
  mergedIntoPostId?: InputMaybe<Uuid_Comparison_Exp>;
  moderationStatus?: InputMaybe<String_Comparison_Exp>;
  rejectionReason?: InputMaybe<String_Comparison_Exp>;
  reproSteps?: InputMaybe<String_Comparison_Exp>;
  reviewedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewedBy?: InputMaybe<String_Comparison_Exp>;
  reviewedContentRevision?: InputMaybe<Int_Comparison_Exp>;
  searchText?: InputMaybe<Tsvector_Comparison_Exp>;
  severity?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Feedback_Statuses_Bool_Exp>;
  statusId?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  visibility?: InputMaybe<String_Comparison_Exp>;
  voteCount?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "feedback_posts_with_counts" */
export type Feedback_Posts_With_Counts_Inc_Input = {
  aiContentRevision?: InputMaybe<Scalars['Int']>;
  aiKindConfidence?: InputMaybe<Scalars['numeric']>;
  aiModerationConfidence?: InputMaybe<Scalars['numeric']>;
  commentCount?: InputMaybe<Scalars['bigint']>;
  contentRevision?: InputMaybe<Scalars['Int']>;
  reviewedContentRevision?: InputMaybe<Scalars['Int']>;
  voteCount?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "feedback_posts_with_counts" */
export type Feedback_Posts_With_Counts_Insert_Input = {
  actualBehavior?: InputMaybe<Scalars['String']>;
  aiAnalysisStatus?: InputMaybe<Scalars['String']>;
  aiAnalyzedAt?: InputMaybe<Scalars['timestamptz']>;
  aiContentRevision?: InputMaybe<Scalars['Int']>;
  aiKind?: InputMaybe<Scalars['String']>;
  aiKindConfidence?: InputMaybe<Scalars['numeric']>;
  aiModel?: InputMaybe<Scalars['String']>;
  aiModerationConfidence?: InputMaybe<Scalars['numeric']>;
  aiPolicyVersion?: InputMaybe<Scalars['String']>;
  aiReasonCodes?: InputMaybe<Array<Scalars['String']>>;
  aiRecommendation?: InputMaybe<Scalars['String']>;
  aiSummary?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  authorAvatarUrl?: InputMaybe<Scalars['String']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorUserId?: InputMaybe<Scalars['String']>;
  board?: InputMaybe<Feedback_Boards_Obj_Rel_Insert_Input>;
  boardId?: InputMaybe<Scalars['uuid']>;
  commentCount?: InputMaybe<Scalars['bigint']>;
  contentRevision?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  expectedBehavior?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Feedback_Media_Arr_Rel_Insert_Input>;
  mergedIntoPostId?: InputMaybe<Scalars['uuid']>;
  moderationStatus?: InputMaybe<Scalars['String']>;
  rejectionReason?: InputMaybe<Scalars['String']>;
  reproSteps?: InputMaybe<Scalars['String']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewedBy?: InputMaybe<Scalars['String']>;
  reviewedContentRevision?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['tsvector']>;
  severity?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Feedback_Statuses_Obj_Rel_Insert_Input>;
  statusId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visibility?: InputMaybe<Scalars['String']>;
  voteCount?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Feedback_Posts_With_Counts_Max_Fields = {
  __typename?: 'feedback_posts_with_counts_max_fields';
  actualBehavior?: Maybe<Scalars['String']>;
  aiAnalysisStatus?: Maybe<Scalars['String']>;
  aiAnalyzedAt?: Maybe<Scalars['timestamptz']>;
  aiContentRevision?: Maybe<Scalars['Int']>;
  aiKind?: Maybe<Scalars['String']>;
  aiKindConfidence?: Maybe<Scalars['numeric']>;
  aiModel?: Maybe<Scalars['String']>;
  aiModerationConfidence?: Maybe<Scalars['numeric']>;
  aiPolicyVersion?: Maybe<Scalars['String']>;
  aiReasonCodes?: Maybe<Array<Scalars['String']>>;
  aiRecommendation?: Maybe<Scalars['String']>;
  aiSummary?: Maybe<Scalars['String']>;
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName?: Maybe<Scalars['String']>;
  authorUserId?: Maybe<Scalars['String']>;
  boardId?: Maybe<Scalars['uuid']>;
  commentCount?: Maybe<Scalars['bigint']>;
  contentRevision?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  expectedBehavior?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  mergedIntoPostId?: Maybe<Scalars['uuid']>;
  moderationStatus?: Maybe<Scalars['String']>;
  rejectionReason?: Maybe<Scalars['String']>;
  reproSteps?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  reviewedBy?: Maybe<Scalars['String']>;
  reviewedContentRevision?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visibility?: Maybe<Scalars['String']>;
  voteCount?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Feedback_Posts_With_Counts_Min_Fields = {
  __typename?: 'feedback_posts_with_counts_min_fields';
  actualBehavior?: Maybe<Scalars['String']>;
  aiAnalysisStatus?: Maybe<Scalars['String']>;
  aiAnalyzedAt?: Maybe<Scalars['timestamptz']>;
  aiContentRevision?: Maybe<Scalars['Int']>;
  aiKind?: Maybe<Scalars['String']>;
  aiKindConfidence?: Maybe<Scalars['numeric']>;
  aiModel?: Maybe<Scalars['String']>;
  aiModerationConfidence?: Maybe<Scalars['numeric']>;
  aiPolicyVersion?: Maybe<Scalars['String']>;
  aiReasonCodes?: Maybe<Array<Scalars['String']>>;
  aiRecommendation?: Maybe<Scalars['String']>;
  aiSummary?: Maybe<Scalars['String']>;
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName?: Maybe<Scalars['String']>;
  authorUserId?: Maybe<Scalars['String']>;
  boardId?: Maybe<Scalars['uuid']>;
  commentCount?: Maybe<Scalars['bigint']>;
  contentRevision?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  expectedBehavior?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  kind?: Maybe<Scalars['String']>;
  mergedIntoPostId?: Maybe<Scalars['uuid']>;
  moderationStatus?: Maybe<Scalars['String']>;
  rejectionReason?: Maybe<Scalars['String']>;
  reproSteps?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['timestamptz']>;
  reviewedBy?: Maybe<Scalars['String']>;
  reviewedContentRevision?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visibility?: Maybe<Scalars['String']>;
  voteCount?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "feedback_posts_with_counts" */
export type Feedback_Posts_With_Counts_Mutation_Response = {
  __typename?: 'feedback_posts_with_counts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback_Posts_With_Counts>;
};

/** Ordering options when selecting data from "feedback_posts_with_counts". */
export type Feedback_Posts_With_Counts_Order_By = {
  actualBehavior?: InputMaybe<Order_By>;
  aiAnalysisStatus?: InputMaybe<Order_By>;
  aiAnalyzedAt?: InputMaybe<Order_By>;
  aiContentRevision?: InputMaybe<Order_By>;
  aiKind?: InputMaybe<Order_By>;
  aiKindConfidence?: InputMaybe<Order_By>;
  aiModel?: InputMaybe<Order_By>;
  aiModerationConfidence?: InputMaybe<Order_By>;
  aiPolicyVersion?: InputMaybe<Order_By>;
  aiReasonCodes?: InputMaybe<Order_By>;
  aiRecommendation?: InputMaybe<Order_By>;
  aiSummary?: InputMaybe<Order_By>;
  author?: InputMaybe<Users_Order_By>;
  authorAvatarUrl?: InputMaybe<Order_By>;
  authorDisplayName?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  board?: InputMaybe<Feedback_Boards_Order_By>;
  boardId?: InputMaybe<Order_By>;
  commentCount?: InputMaybe<Order_By>;
  contentRevision?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expectedBehavior?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isPinned?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  media_aggregate?: InputMaybe<Feedback_Media_Aggregate_Order_By>;
  mergedIntoPostId?: InputMaybe<Order_By>;
  moderationStatus?: InputMaybe<Order_By>;
  rejectionReason?: InputMaybe<Order_By>;
  reproSteps?: InputMaybe<Order_By>;
  reviewedAt?: InputMaybe<Order_By>;
  reviewedBy?: InputMaybe<Order_By>;
  reviewedContentRevision?: InputMaybe<Order_By>;
  searchText?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Feedback_Statuses_Order_By>;
  statusId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
  voteCount?: InputMaybe<Order_By>;
};

/** select columns of table "feedback_posts_with_counts" */
export const Feedback_Posts_With_Counts_Select_Column = {
  /** column name */
  ActualBehavior: 'actualBehavior',
  /** column name */
  AiAnalysisStatus: 'aiAnalysisStatus',
  /** column name */
  AiAnalyzedAt: 'aiAnalyzedAt',
  /** column name */
  AiContentRevision: 'aiContentRevision',
  /** column name */
  AiKind: 'aiKind',
  /** column name */
  AiKindConfidence: 'aiKindConfidence',
  /** column name */
  AiModel: 'aiModel',
  /** column name */
  AiModerationConfidence: 'aiModerationConfidence',
  /** column name */
  AiPolicyVersion: 'aiPolicyVersion',
  /** column name */
  AiReasonCodes: 'aiReasonCodes',
  /** column name */
  AiRecommendation: 'aiRecommendation',
  /** column name */
  AiSummary: 'aiSummary',
  /** column name */
  AuthorAvatarUrl: 'authorAvatarUrl',
  /** column name */
  AuthorDisplayName: 'authorDisplayName',
  /** column name */
  AuthorUserId: 'authorUserId',
  /** column name */
  BoardId: 'boardId',
  /** column name */
  CommentCount: 'commentCount',
  /** column name */
  ContentRevision: 'contentRevision',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Description: 'description',
  /** column name */
  ExpectedBehavior: 'expectedBehavior',
  /** column name */
  Id: 'id',
  /** column name */
  IsPinned: 'isPinned',
  /** column name */
  Kind: 'kind',
  /** column name */
  MergedIntoPostId: 'mergedIntoPostId',
  /** column name */
  ModerationStatus: 'moderationStatus',
  /** column name */
  RejectionReason: 'rejectionReason',
  /** column name */
  ReproSteps: 'reproSteps',
  /** column name */
  ReviewedAt: 'reviewedAt',
  /** column name */
  ReviewedBy: 'reviewedBy',
  /** column name */
  ReviewedContentRevision: 'reviewedContentRevision',
  /** column name */
  SearchText: 'searchText',
  /** column name */
  Severity: 'severity',
  /** column name */
  Slug: 'slug',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Visibility: 'visibility',
  /** column name */
  VoteCount: 'voteCount'
} as const;

export type Feedback_Posts_With_Counts_Select_Column = typeof Feedback_Posts_With_Counts_Select_Column[keyof typeof Feedback_Posts_With_Counts_Select_Column];
/** input type for updating data in table "feedback_posts_with_counts" */
export type Feedback_Posts_With_Counts_Set_Input = {
  actualBehavior?: InputMaybe<Scalars['String']>;
  aiAnalysisStatus?: InputMaybe<Scalars['String']>;
  aiAnalyzedAt?: InputMaybe<Scalars['timestamptz']>;
  aiContentRevision?: InputMaybe<Scalars['Int']>;
  aiKind?: InputMaybe<Scalars['String']>;
  aiKindConfidence?: InputMaybe<Scalars['numeric']>;
  aiModel?: InputMaybe<Scalars['String']>;
  aiModerationConfidence?: InputMaybe<Scalars['numeric']>;
  aiPolicyVersion?: InputMaybe<Scalars['String']>;
  aiReasonCodes?: InputMaybe<Array<Scalars['String']>>;
  aiRecommendation?: InputMaybe<Scalars['String']>;
  aiSummary?: InputMaybe<Scalars['String']>;
  authorAvatarUrl?: InputMaybe<Scalars['String']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorUserId?: InputMaybe<Scalars['String']>;
  boardId?: InputMaybe<Scalars['uuid']>;
  commentCount?: InputMaybe<Scalars['bigint']>;
  contentRevision?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  expectedBehavior?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  mergedIntoPostId?: InputMaybe<Scalars['uuid']>;
  moderationStatus?: InputMaybe<Scalars['String']>;
  rejectionReason?: InputMaybe<Scalars['String']>;
  reproSteps?: InputMaybe<Scalars['String']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewedBy?: InputMaybe<Scalars['String']>;
  reviewedContentRevision?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['tsvector']>;
  severity?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visibility?: InputMaybe<Scalars['String']>;
  voteCount?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Feedback_Posts_With_Counts_Stddev_Fields = {
  __typename?: 'feedback_posts_with_counts_stddev_fields';
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
  voteCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Feedback_Posts_With_Counts_Stddev_Pop_Fields = {
  __typename?: 'feedback_posts_with_counts_stddev_pop_fields';
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
  voteCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Feedback_Posts_With_Counts_Stddev_Samp_Fields = {
  __typename?: 'feedback_posts_with_counts_stddev_samp_fields';
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
  voteCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "feedback_posts_with_counts" */
export type Feedback_Posts_With_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Posts_With_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Posts_With_Counts_Stream_Cursor_Value_Input = {
  actualBehavior?: InputMaybe<Scalars['String']>;
  aiAnalysisStatus?: InputMaybe<Scalars['String']>;
  aiAnalyzedAt?: InputMaybe<Scalars['timestamptz']>;
  aiContentRevision?: InputMaybe<Scalars['Int']>;
  aiKind?: InputMaybe<Scalars['String']>;
  aiKindConfidence?: InputMaybe<Scalars['numeric']>;
  aiModel?: InputMaybe<Scalars['String']>;
  aiModerationConfidence?: InputMaybe<Scalars['numeric']>;
  aiPolicyVersion?: InputMaybe<Scalars['String']>;
  aiReasonCodes?: InputMaybe<Array<Scalars['String']>>;
  aiRecommendation?: InputMaybe<Scalars['String']>;
  aiSummary?: InputMaybe<Scalars['String']>;
  authorAvatarUrl?: InputMaybe<Scalars['String']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorUserId?: InputMaybe<Scalars['String']>;
  boardId?: InputMaybe<Scalars['uuid']>;
  commentCount?: InputMaybe<Scalars['bigint']>;
  contentRevision?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  expectedBehavior?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  mergedIntoPostId?: InputMaybe<Scalars['uuid']>;
  moderationStatus?: InputMaybe<Scalars['String']>;
  rejectionReason?: InputMaybe<Scalars['String']>;
  reproSteps?: InputMaybe<Scalars['String']>;
  reviewedAt?: InputMaybe<Scalars['timestamptz']>;
  reviewedBy?: InputMaybe<Scalars['String']>;
  reviewedContentRevision?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['tsvector']>;
  severity?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visibility?: InputMaybe<Scalars['String']>;
  voteCount?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Feedback_Posts_With_Counts_Sum_Fields = {
  __typename?: 'feedback_posts_with_counts_sum_fields';
  aiContentRevision?: Maybe<Scalars['Int']>;
  aiKindConfidence?: Maybe<Scalars['numeric']>;
  aiModerationConfidence?: Maybe<Scalars['numeric']>;
  commentCount?: Maybe<Scalars['bigint']>;
  contentRevision?: Maybe<Scalars['Int']>;
  reviewedContentRevision?: Maybe<Scalars['Int']>;
  voteCount?: Maybe<Scalars['bigint']>;
};

export type Feedback_Posts_With_Counts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feedback_Posts_With_Counts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Posts_With_Counts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Posts_With_Counts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feedback_Posts_With_Counts_Var_Pop_Fields = {
  __typename?: 'feedback_posts_with_counts_var_pop_fields';
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
  voteCount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Feedback_Posts_With_Counts_Var_Samp_Fields = {
  __typename?: 'feedback_posts_with_counts_var_samp_fields';
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
  voteCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Feedback_Posts_With_Counts_Variance_Fields = {
  __typename?: 'feedback_posts_with_counts_variance_fields';
  aiContentRevision?: Maybe<Scalars['Float']>;
  aiKindConfidence?: Maybe<Scalars['Float']>;
  aiModerationConfidence?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  contentRevision?: Maybe<Scalars['Float']>;
  reviewedContentRevision?: Maybe<Scalars['Float']>;
  voteCount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "feedback_release_posts" */
export type Feedback_Release_Posts = {
  __typename?: 'feedback_release_posts';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  post: Feedback_Posts;
  postId: Scalars['uuid'];
  /** An object relationship */
  release: Feedback_Releases;
  releaseId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "feedback_release_posts" */
export type Feedback_Release_Posts_Aggregate = {
  __typename?: 'feedback_release_posts_aggregate';
  aggregate?: Maybe<Feedback_Release_Posts_Aggregate_Fields>;
  nodes: Array<Feedback_Release_Posts>;
};

export type Feedback_Release_Posts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Feedback_Release_Posts_Aggregate_Bool_Exp_Count>;
};

export type Feedback_Release_Posts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Feedback_Release_Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "feedback_release_posts" */
export type Feedback_Release_Posts_Aggregate_Fields = {
  __typename?: 'feedback_release_posts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Feedback_Release_Posts_Max_Fields>;
  min?: Maybe<Feedback_Release_Posts_Min_Fields>;
};


/** aggregate fields of "feedback_release_posts" */
export type Feedback_Release_Posts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Release_Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "feedback_release_posts" */
export type Feedback_Release_Posts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Feedback_Release_Posts_Max_Order_By>;
  min?: InputMaybe<Feedback_Release_Posts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "feedback_release_posts" */
export type Feedback_Release_Posts_Arr_Rel_Insert_Input = {
  data: Array<Feedback_Release_Posts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Feedback_Release_Posts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "feedback_release_posts". All fields are combined with a logical 'AND'. */
export type Feedback_Release_Posts_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Release_Posts_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Release_Posts_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  post?: InputMaybe<Feedback_Posts_Bool_Exp>;
  postId?: InputMaybe<Uuid_Comparison_Exp>;
  release?: InputMaybe<Feedback_Releases_Bool_Exp>;
  releaseId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedback_release_posts" */
export const Feedback_Release_Posts_Constraint = {
  /** unique or primary key constraint on columns "releaseId", "postId" */
  FeedbackReleasePostsPairKey: 'feedback_release_posts_pair_key',
  /** unique or primary key constraint on columns "id" */
  FeedbackReleasePostsPkey: 'feedback_release_posts_pkey'
} as const;

export type Feedback_Release_Posts_Constraint = typeof Feedback_Release_Posts_Constraint[keyof typeof Feedback_Release_Posts_Constraint];
/** input type for inserting data into table "feedback_release_posts" */
export type Feedback_Release_Posts_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  post?: InputMaybe<Feedback_Posts_Obj_Rel_Insert_Input>;
  postId?: InputMaybe<Scalars['uuid']>;
  release?: InputMaybe<Feedback_Releases_Obj_Rel_Insert_Input>;
  releaseId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Feedback_Release_Posts_Max_Fields = {
  __typename?: 'feedback_release_posts_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postId?: Maybe<Scalars['uuid']>;
  releaseId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "feedback_release_posts" */
export type Feedback_Release_Posts_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  postId?: InputMaybe<Order_By>;
  releaseId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Feedback_Release_Posts_Min_Fields = {
  __typename?: 'feedback_release_posts_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postId?: Maybe<Scalars['uuid']>;
  releaseId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "feedback_release_posts" */
export type Feedback_Release_Posts_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  postId?: InputMaybe<Order_By>;
  releaseId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "feedback_release_posts" */
export type Feedback_Release_Posts_Mutation_Response = {
  __typename?: 'feedback_release_posts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback_Release_Posts>;
};

/** on_conflict condition type for table "feedback_release_posts" */
export type Feedback_Release_Posts_On_Conflict = {
  constraint: Feedback_Release_Posts_Constraint;
  update_columns?: Array<Feedback_Release_Posts_Update_Column>;
  where?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback_release_posts". */
export type Feedback_Release_Posts_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post?: InputMaybe<Feedback_Posts_Order_By>;
  postId?: InputMaybe<Order_By>;
  release?: InputMaybe<Feedback_Releases_Order_By>;
  releaseId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feedback_release_posts */
export type Feedback_Release_Posts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "feedback_release_posts" */
export const Feedback_Release_Posts_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  PostId: 'postId',
  /** column name */
  ReleaseId: 'releaseId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Feedback_Release_Posts_Select_Column = typeof Feedback_Release_Posts_Select_Column[keyof typeof Feedback_Release_Posts_Select_Column];
/** input type for updating data in table "feedback_release_posts" */
export type Feedback_Release_Posts_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  postId?: InputMaybe<Scalars['uuid']>;
  releaseId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "feedback_release_posts" */
export type Feedback_Release_Posts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Release_Posts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Release_Posts_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  postId?: InputMaybe<Scalars['uuid']>;
  releaseId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "feedback_release_posts" */
export const Feedback_Release_Posts_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  PostId: 'postId',
  /** column name */
  ReleaseId: 'releaseId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Feedback_Release_Posts_Update_Column = typeof Feedback_Release_Posts_Update_Column[keyof typeof Feedback_Release_Posts_Update_Column];
export type Feedback_Release_Posts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Release_Posts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Release_Posts_Bool_Exp;
};

/** columns and relationships of "feedback_releases" */
export type Feedback_Releases = {
  __typename?: 'feedback_releases';
  aiGenerated: Scalars['Boolean'];
  aiSource?: Maybe<Scalars['String']>;
  /** An object relationship */
  author?: Maybe<Users>;
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName: Scalars['String'];
  authorUserId?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  isPublished: Scalars['Boolean'];
  /** An array relationship */
  media: Array<Feedback_Media>;
  /** An aggregate relationship */
  media_aggregate: Feedback_Media_Aggregate;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  releasePosts: Array<Feedback_Release_Posts>;
  /** An aggregate relationship */
  releasePosts_aggregate: Feedback_Release_Posts_Aggregate;
  slug: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  version?: Maybe<Scalars['String']>;
};


/** columns and relationships of "feedback_releases" */
export type Feedback_ReleasesMediaArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Media_Order_By>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};


/** columns and relationships of "feedback_releases" */
export type Feedback_ReleasesMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Media_Order_By>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};


/** columns and relationships of "feedback_releases" */
export type Feedback_ReleasesReleasePostsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Release_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Release_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
};


/** columns and relationships of "feedback_releases" */
export type Feedback_ReleasesReleasePosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Release_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Release_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
};

/** aggregated selection of "feedback_releases" */
export type Feedback_Releases_Aggregate = {
  __typename?: 'feedback_releases_aggregate';
  aggregate?: Maybe<Feedback_Releases_Aggregate_Fields>;
  nodes: Array<Feedback_Releases>;
};

/** aggregate fields of "feedback_releases" */
export type Feedback_Releases_Aggregate_Fields = {
  __typename?: 'feedback_releases_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Feedback_Releases_Max_Fields>;
  min?: Maybe<Feedback_Releases_Min_Fields>;
};


/** aggregate fields of "feedback_releases" */
export type Feedback_Releases_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Releases_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "feedback_releases". All fields are combined with a logical 'AND'. */
export type Feedback_Releases_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Releases_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Releases_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Releases_Bool_Exp>>;
  aiGenerated?: InputMaybe<Boolean_Comparison_Exp>;
  aiSource?: InputMaybe<String_Comparison_Exp>;
  author?: InputMaybe<Users_Bool_Exp>;
  authorAvatarUrl?: InputMaybe<String_Comparison_Exp>;
  authorDisplayName?: InputMaybe<String_Comparison_Exp>;
  authorUserId?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  coverImageUrl?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isPublished?: InputMaybe<Boolean_Comparison_Exp>;
  media?: InputMaybe<Feedback_Media_Bool_Exp>;
  media_aggregate?: InputMaybe<Feedback_Media_Aggregate_Bool_Exp>;
  publishedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  releasePosts?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
  releasePosts_aggregate?: InputMaybe<Feedback_Release_Posts_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  summary?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedback_releases" */
export const Feedback_Releases_Constraint = {
  /** unique or primary key constraint on columns "id" */
  FeedbackReleasesPkey: 'feedback_releases_pkey',
  /** unique or primary key constraint on columns "slug" */
  FeedbackReleasesSlugKey: 'feedback_releases_slug_key'
} as const;

export type Feedback_Releases_Constraint = typeof Feedback_Releases_Constraint[keyof typeof Feedback_Releases_Constraint];
/** input type for inserting data into table "feedback_releases" */
export type Feedback_Releases_Insert_Input = {
  aiGenerated?: InputMaybe<Scalars['Boolean']>;
  aiSource?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  authorAvatarUrl?: InputMaybe<Scalars['String']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorUserId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<Feedback_Media_Arr_Rel_Insert_Input>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  releasePosts?: InputMaybe<Feedback_Release_Posts_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Feedback_Releases_Max_Fields = {
  __typename?: 'feedback_releases_max_fields';
  aiSource?: Maybe<Scalars['String']>;
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName?: Maybe<Scalars['String']>;
  authorUserId?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  slug?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Feedback_Releases_Min_Fields = {
  __typename?: 'feedback_releases_min_fields';
  aiSource?: Maybe<Scalars['String']>;
  authorAvatarUrl?: Maybe<Scalars['String']>;
  authorDisplayName?: Maybe<Scalars['String']>;
  authorUserId?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  publishedAt?: Maybe<Scalars['timestamptz']>;
  slug?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "feedback_releases" */
export type Feedback_Releases_Mutation_Response = {
  __typename?: 'feedback_releases_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback_Releases>;
};

/** input type for inserting object relation for remote table "feedback_releases" */
export type Feedback_Releases_Obj_Rel_Insert_Input = {
  data: Feedback_Releases_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Feedback_Releases_On_Conflict>;
};

/** on_conflict condition type for table "feedback_releases" */
export type Feedback_Releases_On_Conflict = {
  constraint: Feedback_Releases_Constraint;
  update_columns?: Array<Feedback_Releases_Update_Column>;
  where?: InputMaybe<Feedback_Releases_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback_releases". */
export type Feedback_Releases_Order_By = {
  aiGenerated?: InputMaybe<Order_By>;
  aiSource?: InputMaybe<Order_By>;
  author?: InputMaybe<Users_Order_By>;
  authorAvatarUrl?: InputMaybe<Order_By>;
  authorDisplayName?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  coverImageUrl?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isPublished?: InputMaybe<Order_By>;
  media_aggregate?: InputMaybe<Feedback_Media_Aggregate_Order_By>;
  publishedAt?: InputMaybe<Order_By>;
  releasePosts_aggregate?: InputMaybe<Feedback_Release_Posts_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feedback_releases */
export type Feedback_Releases_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "feedback_releases" */
export const Feedback_Releases_Select_Column = {
  /** column name */
  AiGenerated: 'aiGenerated',
  /** column name */
  AiSource: 'aiSource',
  /** column name */
  AuthorAvatarUrl: 'authorAvatarUrl',
  /** column name */
  AuthorDisplayName: 'authorDisplayName',
  /** column name */
  AuthorUserId: 'authorUserId',
  /** column name */
  Category: 'category',
  /** column name */
  Content: 'content',
  /** column name */
  CoverImageUrl: 'coverImageUrl',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  IsPublished: 'isPublished',
  /** column name */
  PublishedAt: 'publishedAt',
  /** column name */
  Slug: 'slug',
  /** column name */
  Summary: 'summary',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Version: 'version'
} as const;

export type Feedback_Releases_Select_Column = typeof Feedback_Releases_Select_Column[keyof typeof Feedback_Releases_Select_Column];
/** input type for updating data in table "feedback_releases" */
export type Feedback_Releases_Set_Input = {
  aiGenerated?: InputMaybe<Scalars['Boolean']>;
  aiSource?: InputMaybe<Scalars['String']>;
  authorAvatarUrl?: InputMaybe<Scalars['String']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorUserId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  slug?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "feedback_releases" */
export type Feedback_Releases_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Releases_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Releases_Stream_Cursor_Value_Input = {
  aiGenerated?: InputMaybe<Scalars['Boolean']>;
  aiSource?: InputMaybe<Scalars['String']>;
  authorAvatarUrl?: InputMaybe<Scalars['String']>;
  authorDisplayName?: InputMaybe<Scalars['String']>;
  authorUserId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  coverImageUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  publishedAt?: InputMaybe<Scalars['timestamptz']>;
  slug?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** update columns of table "feedback_releases" */
export const Feedback_Releases_Update_Column = {
  /** column name */
  AiGenerated: 'aiGenerated',
  /** column name */
  AiSource: 'aiSource',
  /** column name */
  AuthorAvatarUrl: 'authorAvatarUrl',
  /** column name */
  AuthorDisplayName: 'authorDisplayName',
  /** column name */
  AuthorUserId: 'authorUserId',
  /** column name */
  Category: 'category',
  /** column name */
  Content: 'content',
  /** column name */
  CoverImageUrl: 'coverImageUrl',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  IsPublished: 'isPublished',
  /** column name */
  PublishedAt: 'publishedAt',
  /** column name */
  Slug: 'slug',
  /** column name */
  Summary: 'summary',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Version: 'version'
} as const;

export type Feedback_Releases_Update_Column = typeof Feedback_Releases_Update_Column[keyof typeof Feedback_Releases_Update_Column];
export type Feedback_Releases_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Releases_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Releases_Bool_Exp;
};

/** columns and relationships of "feedback_statuses" */
export type Feedback_Statuses = {
  __typename?: 'feedback_statuses';
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  isComplete: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  /** An array relationship */
  posts: Array<Feedback_Posts>;
  /** An aggregate relationship */
  posts_aggregate: Feedback_Posts_Aggregate;
  sortOrder: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "feedback_statuses" */
export type Feedback_StatusesPostsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_Bool_Exp>;
};


/** columns and relationships of "feedback_statuses" */
export type Feedback_StatusesPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_Bool_Exp>;
};

/** aggregated selection of "feedback_statuses" */
export type Feedback_Statuses_Aggregate = {
  __typename?: 'feedback_statuses_aggregate';
  aggregate?: Maybe<Feedback_Statuses_Aggregate_Fields>;
  nodes: Array<Feedback_Statuses>;
};

/** aggregate fields of "feedback_statuses" */
export type Feedback_Statuses_Aggregate_Fields = {
  __typename?: 'feedback_statuses_aggregate_fields';
  avg?: Maybe<Feedback_Statuses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Feedback_Statuses_Max_Fields>;
  min?: Maybe<Feedback_Statuses_Min_Fields>;
  stddev?: Maybe<Feedback_Statuses_Stddev_Fields>;
  stddev_pop?: Maybe<Feedback_Statuses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feedback_Statuses_Stddev_Samp_Fields>;
  sum?: Maybe<Feedback_Statuses_Sum_Fields>;
  var_pop?: Maybe<Feedback_Statuses_Var_Pop_Fields>;
  var_samp?: Maybe<Feedback_Statuses_Var_Samp_Fields>;
  variance?: Maybe<Feedback_Statuses_Variance_Fields>;
};


/** aggregate fields of "feedback_statuses" */
export type Feedback_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Feedback_Statuses_Avg_Fields = {
  __typename?: 'feedback_statuses_avg_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "feedback_statuses". All fields are combined with a logical 'AND'. */
export type Feedback_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Statuses_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isComplete?: InputMaybe<Boolean_Comparison_Exp>;
  isDefault?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  posts?: InputMaybe<Feedback_Posts_Bool_Exp>;
  posts_aggregate?: InputMaybe<Feedback_Posts_Aggregate_Bool_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedback_statuses" */
export const Feedback_Statuses_Constraint = {
  /** unique or primary key constraint on columns "key" */
  FeedbackStatusesKeyKey: 'feedback_statuses_key_key',
  /** unique or primary key constraint on columns "isDefault" */
  FeedbackStatusesOneDefaultKey: 'feedback_statuses_one_default_key',
  /** unique or primary key constraint on columns "id" */
  FeedbackStatusesPkey: 'feedback_statuses_pkey'
} as const;

export type Feedback_Statuses_Constraint = typeof Feedback_Statuses_Constraint[keyof typeof Feedback_Statuses_Constraint];
/** input type for incrementing numeric columns in table "feedback_statuses" */
export type Feedback_Statuses_Inc_Input = {
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "feedback_statuses" */
export type Feedback_Statuses_Insert_Input = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  posts?: InputMaybe<Feedback_Posts_Arr_Rel_Insert_Input>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Feedback_Statuses_Max_Fields = {
  __typename?: 'feedback_statuses_max_fields';
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Feedback_Statuses_Min_Fields = {
  __typename?: 'feedback_statuses_min_fields';
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "feedback_statuses" */
export type Feedback_Statuses_Mutation_Response = {
  __typename?: 'feedback_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback_Statuses>;
};

/** input type for inserting object relation for remote table "feedback_statuses" */
export type Feedback_Statuses_Obj_Rel_Insert_Input = {
  data: Feedback_Statuses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Feedback_Statuses_On_Conflict>;
};

/** on_conflict condition type for table "feedback_statuses" */
export type Feedback_Statuses_On_Conflict = {
  constraint: Feedback_Statuses_Constraint;
  update_columns?: Array<Feedback_Statuses_Update_Column>;
  where?: InputMaybe<Feedback_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback_statuses". */
export type Feedback_Statuses_Order_By = {
  color?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isComplete?: InputMaybe<Order_By>;
  isDefault?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  posts_aggregate?: InputMaybe<Feedback_Posts_Aggregate_Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feedback_statuses */
export type Feedback_Statuses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "feedback_statuses" */
export const Feedback_Statuses_Select_Column = {
  /** column name */
  Color: 'color',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  IsComplete: 'isComplete',
  /** column name */
  IsDefault: 'isDefault',
  /** column name */
  Key: 'key',
  /** column name */
  Label: 'label',
  /** column name */
  SortOrder: 'sortOrder',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Feedback_Statuses_Select_Column = typeof Feedback_Statuses_Select_Column[keyof typeof Feedback_Statuses_Select_Column];
/** input type for updating data in table "feedback_statuses" */
export type Feedback_Statuses_Set_Input = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Feedback_Statuses_Stddev_Fields = {
  __typename?: 'feedback_statuses_stddev_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Feedback_Statuses_Stddev_Pop_Fields = {
  __typename?: 'feedback_statuses_stddev_pop_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Feedback_Statuses_Stddev_Samp_Fields = {
  __typename?: 'feedback_statuses_stddev_samp_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "feedback_statuses" */
export type Feedback_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Statuses_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Feedback_Statuses_Sum_Fields = {
  __typename?: 'feedback_statuses_sum_fields';
  sortOrder?: Maybe<Scalars['Int']>;
};

/** update columns of table "feedback_statuses" */
export const Feedback_Statuses_Update_Column = {
  /** column name */
  Color: 'color',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  IsComplete: 'isComplete',
  /** column name */
  IsDefault: 'isDefault',
  /** column name */
  Key: 'key',
  /** column name */
  Label: 'label',
  /** column name */
  SortOrder: 'sortOrder',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Feedback_Statuses_Update_Column = typeof Feedback_Statuses_Update_Column[keyof typeof Feedback_Statuses_Update_Column];
export type Feedback_Statuses_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feedback_Statuses_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Statuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Statuses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feedback_Statuses_Var_Pop_Fields = {
  __typename?: 'feedback_statuses_var_pop_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Feedback_Statuses_Var_Samp_Fields = {
  __typename?: 'feedback_statuses_var_samp_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Feedback_Statuses_Variance_Fields = {
  __typename?: 'feedback_statuses_variance_fields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "feedback_votes" */
export type Feedback_Votes = {
  __typename?: 'feedback_votes';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  post: Feedback_Posts;
  postId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};

/** aggregated selection of "feedback_votes" */
export type Feedback_Votes_Aggregate = {
  __typename?: 'feedback_votes_aggregate';
  aggregate?: Maybe<Feedback_Votes_Aggregate_Fields>;
  nodes: Array<Feedback_Votes>;
};

export type Feedback_Votes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Feedback_Votes_Aggregate_Bool_Exp_Count>;
};

export type Feedback_Votes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Feedback_Votes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Feedback_Votes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "feedback_votes" */
export type Feedback_Votes_Aggregate_Fields = {
  __typename?: 'feedback_votes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Feedback_Votes_Max_Fields>;
  min?: Maybe<Feedback_Votes_Min_Fields>;
};


/** aggregate fields of "feedback_votes" */
export type Feedback_Votes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Votes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "feedback_votes" */
export type Feedback_Votes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Feedback_Votes_Max_Order_By>;
  min?: InputMaybe<Feedback_Votes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "feedback_votes" */
export type Feedback_Votes_Arr_Rel_Insert_Input = {
  data: Array<Feedback_Votes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Feedback_Votes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "feedback_votes". All fields are combined with a logical 'AND'. */
export type Feedback_Votes_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Votes_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Votes_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Votes_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  post?: InputMaybe<Feedback_Posts_Bool_Exp>;
  postId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedback_votes" */
export const Feedback_Votes_Constraint = {
  /** unique or primary key constraint on columns "id" */
  FeedbackVotesPkey: 'feedback_votes_pkey',
  /** unique or primary key constraint on columns "userId", "postId" */
  FeedbackVotesPostUserKey: 'feedback_votes_post_user_key'
} as const;

export type Feedback_Votes_Constraint = typeof Feedback_Votes_Constraint[keyof typeof Feedback_Votes_Constraint];
/** input type for inserting data into table "feedback_votes" */
export type Feedback_Votes_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  post?: InputMaybe<Feedback_Posts_Obj_Rel_Insert_Input>;
  postId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Feedback_Votes_Max_Fields = {
  __typename?: 'feedback_votes_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "feedback_votes" */
export type Feedback_Votes_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  postId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Feedback_Votes_Min_Fields = {
  __typename?: 'feedback_votes_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "feedback_votes" */
export type Feedback_Votes_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  postId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "feedback_votes" */
export type Feedback_Votes_Mutation_Response = {
  __typename?: 'feedback_votes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback_Votes>;
};

/** on_conflict condition type for table "feedback_votes" */
export type Feedback_Votes_On_Conflict = {
  constraint: Feedback_Votes_Constraint;
  update_columns?: Array<Feedback_Votes_Update_Column>;
  where?: InputMaybe<Feedback_Votes_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback_votes". */
export type Feedback_Votes_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post?: InputMaybe<Feedback_Posts_Order_By>;
  postId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feedback_votes */
export type Feedback_Votes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "feedback_votes" */
export const Feedback_Votes_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  PostId: 'postId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Feedback_Votes_Select_Column = typeof Feedback_Votes_Select_Column[keyof typeof Feedback_Votes_Select_Column];
/** input type for updating data in table "feedback_votes" */
export type Feedback_Votes_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  postId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "feedback_votes" */
export type Feedback_Votes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Votes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Votes_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  postId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "feedback_votes" */
export const Feedback_Votes_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  PostId: 'postId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Feedback_Votes_Update_Column = typeof Feedback_Votes_Update_Column[keyof typeof Feedback_Votes_Update_Column];
export type Feedback_Votes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Votes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Votes_Bool_Exp;
};

/** columns and relationships of "flow_configurations" */
export type Flow_Configurations = {
  __typename?: 'flow_configurations';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  configuration: Scalars['jsonb'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};


/** columns and relationships of "flow_configurations" */
export type Flow_ConfigurationsConfigurationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "flow_configurations" */
export type Flow_Configurations_Aggregate = {
  __typename?: 'flow_configurations_aggregate';
  aggregate?: Maybe<Flow_Configurations_Aggregate_Fields>;
  nodes: Array<Flow_Configurations>;
};

export type Flow_Configurations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Flow_Configurations_Aggregate_Bool_Exp_Count>;
};

export type Flow_Configurations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Flow_Configurations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Flow_Configurations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "flow_configurations" */
export type Flow_Configurations_Aggregate_Fields = {
  __typename?: 'flow_configurations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Flow_Configurations_Max_Fields>;
  min?: Maybe<Flow_Configurations_Min_Fields>;
};


/** aggregate fields of "flow_configurations" */
export type Flow_Configurations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Flow_Configurations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "flow_configurations" */
export type Flow_Configurations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Flow_Configurations_Max_Order_By>;
  min?: InputMaybe<Flow_Configurations_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Flow_Configurations_Append_Input = {
  configuration?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "flow_configurations" */
export type Flow_Configurations_Arr_Rel_Insert_Input = {
  data: Array<Flow_Configurations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Flow_Configurations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "flow_configurations". All fields are combined with a logical 'AND'. */
export type Flow_Configurations_Bool_Exp = {
  _and?: InputMaybe<Array<Flow_Configurations_Bool_Exp>>;
  _not?: InputMaybe<Flow_Configurations_Bool_Exp>;
  _or?: InputMaybe<Array<Flow_Configurations_Bool_Exp>>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  configuration?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "flow_configurations" */
export const Flow_Configurations_Constraint = {
  /** unique or primary key constraint on columns "id" */
  FlowConfigurationsPkey: 'flow_configurations_pkey'
} as const;

export type Flow_Configurations_Constraint = typeof Flow_Configurations_Constraint[keyof typeof Flow_Configurations_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Flow_Configurations_Delete_At_Path_Input = {
  configuration?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Flow_Configurations_Delete_Elem_Input = {
  configuration?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Flow_Configurations_Delete_Key_Input = {
  configuration?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "flow_configurations" */
export type Flow_Configurations_Insert_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  configuration?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Flow_Configurations_Max_Fields = {
  __typename?: 'flow_configurations_max_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "flow_configurations" */
export type Flow_Configurations_Max_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Flow_Configurations_Min_Fields = {
  __typename?: 'flow_configurations_min_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "flow_configurations" */
export type Flow_Configurations_Min_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "flow_configurations" */
export type Flow_Configurations_Mutation_Response = {
  __typename?: 'flow_configurations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Flow_Configurations>;
};

/** on_conflict condition type for table "flow_configurations" */
export type Flow_Configurations_On_Conflict = {
  constraint: Flow_Configurations_Constraint;
  update_columns?: Array<Flow_Configurations_Update_Column>;
  where?: InputMaybe<Flow_Configurations_Bool_Exp>;
};

/** Ordering options when selecting data from "flow_configurations". */
export type Flow_Configurations_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  configuration?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: flow_configurations */
export type Flow_Configurations_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Flow_Configurations_Prepend_Input = {
  configuration?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "flow_configurations" */
export const Flow_Configurations_Select_Column = {
  /** column name */
  ArchivedAt: 'archivedAt',
  /** column name */
  Configuration: 'configuration',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Flow_Configurations_Select_Column = typeof Flow_Configurations_Select_Column[keyof typeof Flow_Configurations_Select_Column];
/** input type for updating data in table "flow_configurations" */
export type Flow_Configurations_Set_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  configuration?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "flow_configurations" */
export type Flow_Configurations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Flow_Configurations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Flow_Configurations_Stream_Cursor_Value_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  configuration?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "flow_configurations" */
export const Flow_Configurations_Update_Column = {
  /** column name */
  ArchivedAt: 'archivedAt',
  /** column name */
  Configuration: 'configuration',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Flow_Configurations_Update_Column = typeof Flow_Configurations_Update_Column[keyof typeof Flow_Configurations_Update_Column];
export type Flow_Configurations_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Flow_Configurations_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Flow_Configurations_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Flow_Configurations_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Flow_Configurations_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Flow_Configurations_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Flow_Configurations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Flow_Configurations_Bool_Exp;
};

/** columns and relationships of "free_equity_print_flow" */
export type Free_Equity_Print_Flow = {
  __typename?: 'free_equity_print_flow';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  isEtf?: Maybe<Scalars['Boolean']>;
  isOutsideDailyRange?: Maybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: Maybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: Maybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: Maybe<Scalars['Boolean']>;
  isSignatureVolume?: Maybe<Scalars['Boolean']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeConditions?: Maybe<Scalars['jsonb']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "free_equity_print_flow" */
export type Free_Equity_Print_FlowTradeConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "free_equity_print_flow" */
export type Free_Equity_Print_Flow_Aggregate = {
  __typename?: 'free_equity_print_flow_aggregate';
  aggregate?: Maybe<Free_Equity_Print_Flow_Aggregate_Fields>;
  nodes: Array<Free_Equity_Print_Flow>;
};

/** aggregate fields of "free_equity_print_flow" */
export type Free_Equity_Print_Flow_Aggregate_Fields = {
  __typename?: 'free_equity_print_flow_aggregate_fields';
  avg?: Maybe<Free_Equity_Print_Flow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Free_Equity_Print_Flow_Max_Fields>;
  min?: Maybe<Free_Equity_Print_Flow_Min_Fields>;
  stddev?: Maybe<Free_Equity_Print_Flow_Stddev_Fields>;
  stddev_pop?: Maybe<Free_Equity_Print_Flow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Free_Equity_Print_Flow_Stddev_Samp_Fields>;
  sum?: Maybe<Free_Equity_Print_Flow_Sum_Fields>;
  var_pop?: Maybe<Free_Equity_Print_Flow_Var_Pop_Fields>;
  var_samp?: Maybe<Free_Equity_Print_Flow_Var_Samp_Fields>;
  variance?: Maybe<Free_Equity_Print_Flow_Variance_Fields>;
};


/** aggregate fields of "free_equity_print_flow" */
export type Free_Equity_Print_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Free_Equity_Print_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Free_Equity_Print_Flow_Avg_Fields = {
  __typename?: 'free_equity_print_flow_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "free_equity_print_flow". All fields are combined with a logical 'AND'. */
export type Free_Equity_Print_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Free_Equity_Print_Flow_Bool_Exp>>;
  _not?: InputMaybe<Free_Equity_Print_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Free_Equity_Print_Flow_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  ask?: InputMaybe<Numeric_Comparison_Exp>;
  askSize?: InputMaybe<Int_Comparison_Exp>;
  avgPrice?: InputMaybe<Numeric_Comparison_Exp>;
  avgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  bid?: InputMaybe<Numeric_Comparison_Exp>;
  bidSize?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  dayOverDayPercentChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayOverDayPriceChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayVolume?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeId?: InputMaybe<Int_Comparison_Exp>;
  externalTradeId?: InputMaybe<String_Comparison_Exp>;
  high?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isEtf?: InputMaybe<Boolean_Comparison_Exp>;
  isOutsideDailyRange?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanOpen?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureEtfTicker?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureVolume?: InputMaybe<Boolean_Comparison_Exp>;
  lastTradePrice?: InputMaybe<Numeric_Comparison_Exp>;
  low?: InputMaybe<Numeric_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  open?: InputMaybe<Numeric_Comparison_Exp>;
  percentAboveAsk?: InputMaybe<Numeric_Comparison_Exp>;
  percentBelowBid?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfAvgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfMarketCap?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfTodaysVolume?: InputMaybe<Numeric_Comparison_Exp>;
  prevClose?: InputMaybe<Numeric_Comparison_Exp>;
  prevHigh?: InputMaybe<Numeric_Comparison_Exp>;
  prevLow?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  realtimePrice?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  tapeId?: InputMaybe<Int_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  timestamp?: InputMaybe<Bigint_Comparison_Exp>;
  timestampIso?: InputMaybe<Timestamptz_Comparison_Exp>;
  tradeConditions?: InputMaybe<Jsonb_Comparison_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Free_Equity_Print_Flow_Max_Fields = {
  __typename?: 'free_equity_print_flow_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Free_Equity_Print_Flow_Min_Fields = {
  __typename?: 'free_equity_print_flow_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "free_equity_print_flow". */
export type Free_Equity_Print_Flow_Order_By = {
  amount?: InputMaybe<Order_By>;
  ask?: InputMaybe<Order_By>;
  askSize?: InputMaybe<Order_By>;
  avgPrice?: InputMaybe<Order_By>;
  avgVolume?: InputMaybe<Order_By>;
  bid?: InputMaybe<Order_By>;
  bidSize?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  dayOverDayPercentChange?: InputMaybe<Order_By>;
  dayOverDayPriceChange?: InputMaybe<Order_By>;
  dayVolume?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  externalTradeId?: InputMaybe<Order_By>;
  high?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isEtf?: InputMaybe<Order_By>;
  isOutsideDailyRange?: InputMaybe<Order_By>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Order_By>;
  isPriceGreaterThanOpen?: InputMaybe<Order_By>;
  isSignatureEtfTicker?: InputMaybe<Order_By>;
  isSignatureVolume?: InputMaybe<Order_By>;
  lastTradePrice?: InputMaybe<Order_By>;
  low?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  open?: InputMaybe<Order_By>;
  percentAboveAsk?: InputMaybe<Order_By>;
  percentBelowBid?: InputMaybe<Order_By>;
  percentOfAvgVolume?: InputMaybe<Order_By>;
  percentOfMarketCap?: InputMaybe<Order_By>;
  percentOfTodaysVolume?: InputMaybe<Order_By>;
  prevClose?: InputMaybe<Order_By>;
  prevHigh?: InputMaybe<Order_By>;
  prevLow?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  realtimePrice?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  tapeId?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  timestamp?: InputMaybe<Order_By>;
  timestampIso?: InputMaybe<Order_By>;
  tradeConditions?: InputMaybe<Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "free_equity_print_flow" */
export const Free_Equity_Print_Flow_Select_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Ask: 'ask',
  /** column name */
  AskSize: 'askSize',
  /** column name */
  AvgPrice: 'avgPrice',
  /** column name */
  AvgVolume: 'avgVolume',
  /** column name */
  Bid: 'bid',
  /** column name */
  BidSize: 'bidSize',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DayOverDayPercentChange: 'dayOverDayPercentChange',
  /** column name */
  DayOverDayPriceChange: 'dayOverDayPriceChange',
  /** column name */
  DayVolume: 'dayVolume',
  /** column name */
  ExchangeId: 'exchangeId',
  /** column name */
  ExternalTradeId: 'externalTradeId',
  /** column name */
  High: 'high',
  /** column name */
  Id: 'id',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsOutsideDailyRange: 'isOutsideDailyRange',
  /** column name */
  IsPriceGreaterThanDailyAverage: 'isPriceGreaterThanDailyAverage',
  /** column name */
  IsPriceGreaterThanOpen: 'isPriceGreaterThanOpen',
  /** column name */
  IsSignatureEtfTicker: 'isSignatureEtfTicker',
  /** column name */
  IsSignatureVolume: 'isSignatureVolume',
  /** column name */
  LastTradePrice: 'lastTradePrice',
  /** column name */
  Low: 'low',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Open: 'open',
  /** column name */
  PercentAboveAsk: 'percentAboveAsk',
  /** column name */
  PercentBelowBid: 'percentBelowBid',
  /** column name */
  PercentOfAvgVolume: 'percentOfAvgVolume',
  /** column name */
  PercentOfMarketCap: 'percentOfMarketCap',
  /** column name */
  PercentOfTodaysVolume: 'percentOfTodaysVolume',
  /** column name */
  PrevClose: 'prevClose',
  /** column name */
  PrevHigh: 'prevHigh',
  /** column name */
  PrevLow: 'prevLow',
  /** column name */
  Price: 'price',
  /** column name */
  RealtimePrice: 'realtimePrice',
  /** column name */
  Size: 'size',
  /** column name */
  TapeId: 'tapeId',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TimestampIso: 'timestampIso',
  /** column name */
  TradeConditions: 'tradeConditions',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Free_Equity_Print_Flow_Select_Column = typeof Free_Equity_Print_Flow_Select_Column[keyof typeof Free_Equity_Print_Flow_Select_Column];
/** aggregate stddev on columns */
export type Free_Equity_Print_Flow_Stddev_Fields = {
  __typename?: 'free_equity_print_flow_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Free_Equity_Print_Flow_Stddev_Pop_Fields = {
  __typename?: 'free_equity_print_flow_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Free_Equity_Print_Flow_Stddev_Samp_Fields = {
  __typename?: 'free_equity_print_flow_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "free_equity_print_flow" */
export type Free_Equity_Print_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Free_Equity_Print_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Free_Equity_Print_Flow_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  timestampIso?: InputMaybe<Scalars['timestamptz']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Free_Equity_Print_Flow_Sum_Fields = {
  __typename?: 'free_equity_print_flow_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  high?: Maybe<Scalars['numeric']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Free_Equity_Print_Flow_Var_Pop_Fields = {
  __typename?: 'free_equity_print_flow_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Free_Equity_Print_Flow_Var_Samp_Fields = {
  __typename?: 'free_equity_print_flow_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Free_Equity_Print_Flow_Variance_Fields = {
  __typename?: 'free_equity_print_flow_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "free_option_flow" */
export type Free_Option_Flow = {
  __typename?: 'free_option_flow';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtTypes?: Maybe<Scalars['jsonb']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "free_option_flow" */
export type Free_Option_FlowPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "free_option_flow" */
export type Free_Option_Flow_Aggregate = {
  __typename?: 'free_option_flow_aggregate';
  aggregate?: Maybe<Free_Option_Flow_Aggregate_Fields>;
  nodes: Array<Free_Option_Flow>;
};

/** aggregate fields of "free_option_flow" */
export type Free_Option_Flow_Aggregate_Fields = {
  __typename?: 'free_option_flow_aggregate_fields';
  avg?: Maybe<Free_Option_Flow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Free_Option_Flow_Max_Fields>;
  min?: Maybe<Free_Option_Flow_Min_Fields>;
  stddev?: Maybe<Free_Option_Flow_Stddev_Fields>;
  stddev_pop?: Maybe<Free_Option_Flow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Free_Option_Flow_Stddev_Samp_Fields>;
  sum?: Maybe<Free_Option_Flow_Sum_Fields>;
  var_pop?: Maybe<Free_Option_Flow_Var_Pop_Fields>;
  var_samp?: Maybe<Free_Option_Flow_Var_Samp_Fields>;
  variance?: Maybe<Free_Option_Flow_Variance_Fields>;
};


/** aggregate fields of "free_option_flow" */
export type Free_Option_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Free_Option_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "free_option_flow_all_sides" */
export type Free_Option_Flow_All_Sides = {
  __typename?: 'free_option_flow_all_sides';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtTypes?: Maybe<Scalars['jsonb']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "free_option_flow_all_sides" */
export type Free_Option_Flow_All_SidesPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "free_option_flow_all_sides" */
export type Free_Option_Flow_All_Sides_Aggregate = {
  __typename?: 'free_option_flow_all_sides_aggregate';
  aggregate?: Maybe<Free_Option_Flow_All_Sides_Aggregate_Fields>;
  nodes: Array<Free_Option_Flow_All_Sides>;
};

/** aggregate fields of "free_option_flow_all_sides" */
export type Free_Option_Flow_All_Sides_Aggregate_Fields = {
  __typename?: 'free_option_flow_all_sides_aggregate_fields';
  avg?: Maybe<Free_Option_Flow_All_Sides_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Free_Option_Flow_All_Sides_Max_Fields>;
  min?: Maybe<Free_Option_Flow_All_Sides_Min_Fields>;
  stddev?: Maybe<Free_Option_Flow_All_Sides_Stddev_Fields>;
  stddev_pop?: Maybe<Free_Option_Flow_All_Sides_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Free_Option_Flow_All_Sides_Stddev_Samp_Fields>;
  sum?: Maybe<Free_Option_Flow_All_Sides_Sum_Fields>;
  var_pop?: Maybe<Free_Option_Flow_All_Sides_Var_Pop_Fields>;
  var_samp?: Maybe<Free_Option_Flow_All_Sides_Var_Samp_Fields>;
  variance?: Maybe<Free_Option_Flow_All_Sides_Variance_Fields>;
};


/** aggregate fields of "free_option_flow_all_sides" */
export type Free_Option_Flow_All_Sides_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Free_Option_Flow_All_Sides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Free_Option_Flow_All_Sides_Avg_Fields = {
  __typename?: 'free_option_flow_all_sides_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "free_option_flow_all_sides". All fields are combined with a logical 'AND'. */
export type Free_Option_Flow_All_Sides_Bool_Exp = {
  _and?: InputMaybe<Array<Free_Option_Flow_All_Sides_Bool_Exp>>;
  _not?: InputMaybe<Free_Option_Flow_All_Sides_Bool_Exp>;
  _or?: InputMaybe<Array<Free_Option_Flow_All_Sides_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Free_Option_Flow_All_Sides_Max_Fields = {
  __typename?: 'free_option_flow_all_sides_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Free_Option_Flow_All_Sides_Min_Fields = {
  __typename?: 'free_option_flow_all_sides_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "free_option_flow_all_sides". */
export type Free_Option_Flow_All_Sides_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** select columns of table "free_option_flow_all_sides" */
export const Free_Option_Flow_All_Sides_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Free_Option_Flow_All_Sides_Select_Column = typeof Free_Option_Flow_All_Sides_Select_Column[keyof typeof Free_Option_Flow_All_Sides_Select_Column];
/** aggregate stddev on columns */
export type Free_Option_Flow_All_Sides_Stddev_Fields = {
  __typename?: 'free_option_flow_all_sides_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Free_Option_Flow_All_Sides_Stddev_Pop_Fields = {
  __typename?: 'free_option_flow_all_sides_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Free_Option_Flow_All_Sides_Stddev_Samp_Fields = {
  __typename?: 'free_option_flow_all_sides_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "free_option_flow_all_sides" */
export type Free_Option_Flow_All_Sides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Free_Option_Flow_All_Sides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Free_Option_Flow_All_Sides_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Free_Option_Flow_All_Sides_Sum_Fields = {
  __typename?: 'free_option_flow_all_sides_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Free_Option_Flow_All_Sides_Var_Pop_Fields = {
  __typename?: 'free_option_flow_all_sides_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Free_Option_Flow_All_Sides_Var_Samp_Fields = {
  __typename?: 'free_option_flow_all_sides_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Free_Option_Flow_All_Sides_Variance_Fields = {
  __typename?: 'free_option_flow_all_sides_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate avg on columns */
export type Free_Option_Flow_Avg_Fields = {
  __typename?: 'free_option_flow_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "free_option_flow". All fields are combined with a logical 'AND'. */
export type Free_Option_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Free_Option_Flow_Bool_Exp>>;
  _not?: InputMaybe<Free_Option_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Free_Option_Flow_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Free_Option_Flow_Max_Fields = {
  __typename?: 'free_option_flow_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Free_Option_Flow_Min_Fields = {
  __typename?: 'free_option_flow_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "free_option_flow". */
export type Free_Option_Flow_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** select columns of table "free_option_flow" */
export const Free_Option_Flow_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Free_Option_Flow_Select_Column = typeof Free_Option_Flow_Select_Column[keyof typeof Free_Option_Flow_Select_Column];
/** aggregate stddev on columns */
export type Free_Option_Flow_Stddev_Fields = {
  __typename?: 'free_option_flow_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Free_Option_Flow_Stddev_Pop_Fields = {
  __typename?: 'free_option_flow_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Free_Option_Flow_Stddev_Samp_Fields = {
  __typename?: 'free_option_flow_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "free_option_flow" */
export type Free_Option_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Free_Option_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Free_Option_Flow_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Free_Option_Flow_Sum_Fields = {
  __typename?: 'free_option_flow_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Free_Option_Flow_Var_Pop_Fields = {
  __typename?: 'free_option_flow_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Free_Option_Flow_Var_Samp_Fields = {
  __typename?: 'free_option_flow_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Free_Option_Flow_Variance_Fields = {
  __typename?: 'free_option_flow_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "free_ticker_equity_print_flow" */
export type Free_Ticker_Equity_Print_Flow = {
  __typename?: 'free_ticker_equity_print_flow';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  isEtf?: Maybe<Scalars['Boolean']>;
  isOutsideDailyRange?: Maybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: Maybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: Maybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: Maybe<Scalars['Boolean']>;
  isSignatureVolume?: Maybe<Scalars['Boolean']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeConditions?: Maybe<Scalars['jsonb']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "free_ticker_equity_print_flow" */
export type Free_Ticker_Equity_Print_FlowTradeConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "free_ticker_equity_print_flow" */
export type Free_Ticker_Equity_Print_Flow_Aggregate = {
  __typename?: 'free_ticker_equity_print_flow_aggregate';
  aggregate?: Maybe<Free_Ticker_Equity_Print_Flow_Aggregate_Fields>;
  nodes: Array<Free_Ticker_Equity_Print_Flow>;
};

/** aggregate fields of "free_ticker_equity_print_flow" */
export type Free_Ticker_Equity_Print_Flow_Aggregate_Fields = {
  __typename?: 'free_ticker_equity_print_flow_aggregate_fields';
  avg?: Maybe<Free_Ticker_Equity_Print_Flow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Free_Ticker_Equity_Print_Flow_Max_Fields>;
  min?: Maybe<Free_Ticker_Equity_Print_Flow_Min_Fields>;
  stddev?: Maybe<Free_Ticker_Equity_Print_Flow_Stddev_Fields>;
  stddev_pop?: Maybe<Free_Ticker_Equity_Print_Flow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Free_Ticker_Equity_Print_Flow_Stddev_Samp_Fields>;
  sum?: Maybe<Free_Ticker_Equity_Print_Flow_Sum_Fields>;
  var_pop?: Maybe<Free_Ticker_Equity_Print_Flow_Var_Pop_Fields>;
  var_samp?: Maybe<Free_Ticker_Equity_Print_Flow_Var_Samp_Fields>;
  variance?: Maybe<Free_Ticker_Equity_Print_Flow_Variance_Fields>;
};


/** aggregate fields of "free_ticker_equity_print_flow" */
export type Free_Ticker_Equity_Print_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Free_Ticker_Equity_Print_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Free_Ticker_Equity_Print_Flow_Avg_Fields = {
  __typename?: 'free_ticker_equity_print_flow_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "free_ticker_equity_print_flow". All fields are combined with a logical 'AND'. */
export type Free_Ticker_Equity_Print_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Free_Ticker_Equity_Print_Flow_Bool_Exp>>;
  _not?: InputMaybe<Free_Ticker_Equity_Print_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Free_Ticker_Equity_Print_Flow_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  ask?: InputMaybe<Numeric_Comparison_Exp>;
  askSize?: InputMaybe<Int_Comparison_Exp>;
  avgPrice?: InputMaybe<Numeric_Comparison_Exp>;
  avgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  bid?: InputMaybe<Numeric_Comparison_Exp>;
  bidSize?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  dayOverDayPercentChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayOverDayPriceChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayVolume?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeId?: InputMaybe<Int_Comparison_Exp>;
  externalTradeId?: InputMaybe<String_Comparison_Exp>;
  high?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isEtf?: InputMaybe<Boolean_Comparison_Exp>;
  isOutsideDailyRange?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanOpen?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureEtfTicker?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureVolume?: InputMaybe<Boolean_Comparison_Exp>;
  lastTradePrice?: InputMaybe<Numeric_Comparison_Exp>;
  low?: InputMaybe<Numeric_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  open?: InputMaybe<Numeric_Comparison_Exp>;
  percentAboveAsk?: InputMaybe<Numeric_Comparison_Exp>;
  percentBelowBid?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfAvgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfMarketCap?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfTodaysVolume?: InputMaybe<Numeric_Comparison_Exp>;
  prevClose?: InputMaybe<Numeric_Comparison_Exp>;
  prevHigh?: InputMaybe<Numeric_Comparison_Exp>;
  prevLow?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  realtimePrice?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  tapeId?: InputMaybe<Int_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  timestamp?: InputMaybe<Bigint_Comparison_Exp>;
  timestampIso?: InputMaybe<Timestamptz_Comparison_Exp>;
  tradeConditions?: InputMaybe<Jsonb_Comparison_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Free_Ticker_Equity_Print_Flow_Max_Fields = {
  __typename?: 'free_ticker_equity_print_flow_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Free_Ticker_Equity_Print_Flow_Min_Fields = {
  __typename?: 'free_ticker_equity_print_flow_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "free_ticker_equity_print_flow". */
export type Free_Ticker_Equity_Print_Flow_Order_By = {
  amount?: InputMaybe<Order_By>;
  ask?: InputMaybe<Order_By>;
  askSize?: InputMaybe<Order_By>;
  avgPrice?: InputMaybe<Order_By>;
  avgVolume?: InputMaybe<Order_By>;
  bid?: InputMaybe<Order_By>;
  bidSize?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  dayOverDayPercentChange?: InputMaybe<Order_By>;
  dayOverDayPriceChange?: InputMaybe<Order_By>;
  dayVolume?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  externalTradeId?: InputMaybe<Order_By>;
  high?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isEtf?: InputMaybe<Order_By>;
  isOutsideDailyRange?: InputMaybe<Order_By>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Order_By>;
  isPriceGreaterThanOpen?: InputMaybe<Order_By>;
  isSignatureEtfTicker?: InputMaybe<Order_By>;
  isSignatureVolume?: InputMaybe<Order_By>;
  lastTradePrice?: InputMaybe<Order_By>;
  low?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  open?: InputMaybe<Order_By>;
  percentAboveAsk?: InputMaybe<Order_By>;
  percentBelowBid?: InputMaybe<Order_By>;
  percentOfAvgVolume?: InputMaybe<Order_By>;
  percentOfMarketCap?: InputMaybe<Order_By>;
  percentOfTodaysVolume?: InputMaybe<Order_By>;
  prevClose?: InputMaybe<Order_By>;
  prevHigh?: InputMaybe<Order_By>;
  prevLow?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  realtimePrice?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  tapeId?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  timestamp?: InputMaybe<Order_By>;
  timestampIso?: InputMaybe<Order_By>;
  tradeConditions?: InputMaybe<Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "free_ticker_equity_print_flow" */
export const Free_Ticker_Equity_Print_Flow_Select_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Ask: 'ask',
  /** column name */
  AskSize: 'askSize',
  /** column name */
  AvgPrice: 'avgPrice',
  /** column name */
  AvgVolume: 'avgVolume',
  /** column name */
  Bid: 'bid',
  /** column name */
  BidSize: 'bidSize',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DayOverDayPercentChange: 'dayOverDayPercentChange',
  /** column name */
  DayOverDayPriceChange: 'dayOverDayPriceChange',
  /** column name */
  DayVolume: 'dayVolume',
  /** column name */
  ExchangeId: 'exchangeId',
  /** column name */
  ExternalTradeId: 'externalTradeId',
  /** column name */
  High: 'high',
  /** column name */
  Id: 'id',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsOutsideDailyRange: 'isOutsideDailyRange',
  /** column name */
  IsPriceGreaterThanDailyAverage: 'isPriceGreaterThanDailyAverage',
  /** column name */
  IsPriceGreaterThanOpen: 'isPriceGreaterThanOpen',
  /** column name */
  IsSignatureEtfTicker: 'isSignatureEtfTicker',
  /** column name */
  IsSignatureVolume: 'isSignatureVolume',
  /** column name */
  LastTradePrice: 'lastTradePrice',
  /** column name */
  Low: 'low',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Open: 'open',
  /** column name */
  PercentAboveAsk: 'percentAboveAsk',
  /** column name */
  PercentBelowBid: 'percentBelowBid',
  /** column name */
  PercentOfAvgVolume: 'percentOfAvgVolume',
  /** column name */
  PercentOfMarketCap: 'percentOfMarketCap',
  /** column name */
  PercentOfTodaysVolume: 'percentOfTodaysVolume',
  /** column name */
  PrevClose: 'prevClose',
  /** column name */
  PrevHigh: 'prevHigh',
  /** column name */
  PrevLow: 'prevLow',
  /** column name */
  Price: 'price',
  /** column name */
  RealtimePrice: 'realtimePrice',
  /** column name */
  Size: 'size',
  /** column name */
  TapeId: 'tapeId',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TimestampIso: 'timestampIso',
  /** column name */
  TradeConditions: 'tradeConditions',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Free_Ticker_Equity_Print_Flow_Select_Column = typeof Free_Ticker_Equity_Print_Flow_Select_Column[keyof typeof Free_Ticker_Equity_Print_Flow_Select_Column];
/** aggregate stddev on columns */
export type Free_Ticker_Equity_Print_Flow_Stddev_Fields = {
  __typename?: 'free_ticker_equity_print_flow_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Free_Ticker_Equity_Print_Flow_Stddev_Pop_Fields = {
  __typename?: 'free_ticker_equity_print_flow_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Free_Ticker_Equity_Print_Flow_Stddev_Samp_Fields = {
  __typename?: 'free_ticker_equity_print_flow_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "free_ticker_equity_print_flow" */
export type Free_Ticker_Equity_Print_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Free_Ticker_Equity_Print_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Free_Ticker_Equity_Print_Flow_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  timestampIso?: InputMaybe<Scalars['timestamptz']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Free_Ticker_Equity_Print_Flow_Sum_Fields = {
  __typename?: 'free_ticker_equity_print_flow_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  high?: Maybe<Scalars['numeric']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Free_Ticker_Equity_Print_Flow_Var_Pop_Fields = {
  __typename?: 'free_ticker_equity_print_flow_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Free_Ticker_Equity_Print_Flow_Var_Samp_Fields = {
  __typename?: 'free_ticker_equity_print_flow_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Free_Ticker_Equity_Print_Flow_Variance_Fields = {
  __typename?: 'free_ticker_equity_print_flow_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "free_ticker_option_flow" */
export type Free_Ticker_Option_Flow = {
  __typename?: 'free_ticker_option_flow';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtTypes?: Maybe<Scalars['jsonb']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "free_ticker_option_flow" */
export type Free_Ticker_Option_FlowPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "free_ticker_option_flow" */
export type Free_Ticker_Option_Flow_Aggregate = {
  __typename?: 'free_ticker_option_flow_aggregate';
  aggregate?: Maybe<Free_Ticker_Option_Flow_Aggregate_Fields>;
  nodes: Array<Free_Ticker_Option_Flow>;
};

/** aggregate fields of "free_ticker_option_flow" */
export type Free_Ticker_Option_Flow_Aggregate_Fields = {
  __typename?: 'free_ticker_option_flow_aggregate_fields';
  avg?: Maybe<Free_Ticker_Option_Flow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Free_Ticker_Option_Flow_Max_Fields>;
  min?: Maybe<Free_Ticker_Option_Flow_Min_Fields>;
  stddev?: Maybe<Free_Ticker_Option_Flow_Stddev_Fields>;
  stddev_pop?: Maybe<Free_Ticker_Option_Flow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Free_Ticker_Option_Flow_Stddev_Samp_Fields>;
  sum?: Maybe<Free_Ticker_Option_Flow_Sum_Fields>;
  var_pop?: Maybe<Free_Ticker_Option_Flow_Var_Pop_Fields>;
  var_samp?: Maybe<Free_Ticker_Option_Flow_Var_Samp_Fields>;
  variance?: Maybe<Free_Ticker_Option_Flow_Variance_Fields>;
};


/** aggregate fields of "free_ticker_option_flow" */
export type Free_Ticker_Option_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Free_Ticker_Option_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "free_ticker_option_flow_all_sides" */
export type Free_Ticker_Option_Flow_All_Sides = {
  __typename?: 'free_ticker_option_flow_all_sides';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtTypes?: Maybe<Scalars['jsonb']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "free_ticker_option_flow_all_sides" */
export type Free_Ticker_Option_Flow_All_SidesPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "free_ticker_option_flow_all_sides" */
export type Free_Ticker_Option_Flow_All_Sides_Aggregate = {
  __typename?: 'free_ticker_option_flow_all_sides_aggregate';
  aggregate?: Maybe<Free_Ticker_Option_Flow_All_Sides_Aggregate_Fields>;
  nodes: Array<Free_Ticker_Option_Flow_All_Sides>;
};

/** aggregate fields of "free_ticker_option_flow_all_sides" */
export type Free_Ticker_Option_Flow_All_Sides_Aggregate_Fields = {
  __typename?: 'free_ticker_option_flow_all_sides_aggregate_fields';
  avg?: Maybe<Free_Ticker_Option_Flow_All_Sides_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Free_Ticker_Option_Flow_All_Sides_Max_Fields>;
  min?: Maybe<Free_Ticker_Option_Flow_All_Sides_Min_Fields>;
  stddev?: Maybe<Free_Ticker_Option_Flow_All_Sides_Stddev_Fields>;
  stddev_pop?: Maybe<Free_Ticker_Option_Flow_All_Sides_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Free_Ticker_Option_Flow_All_Sides_Stddev_Samp_Fields>;
  sum?: Maybe<Free_Ticker_Option_Flow_All_Sides_Sum_Fields>;
  var_pop?: Maybe<Free_Ticker_Option_Flow_All_Sides_Var_Pop_Fields>;
  var_samp?: Maybe<Free_Ticker_Option_Flow_All_Sides_Var_Samp_Fields>;
  variance?: Maybe<Free_Ticker_Option_Flow_All_Sides_Variance_Fields>;
};


/** aggregate fields of "free_ticker_option_flow_all_sides" */
export type Free_Ticker_Option_Flow_All_Sides_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Free_Ticker_Option_Flow_All_Sides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Free_Ticker_Option_Flow_All_Sides_Avg_Fields = {
  __typename?: 'free_ticker_option_flow_all_sides_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "free_ticker_option_flow_all_sides". All fields are combined with a logical 'AND'. */
export type Free_Ticker_Option_Flow_All_Sides_Bool_Exp = {
  _and?: InputMaybe<Array<Free_Ticker_Option_Flow_All_Sides_Bool_Exp>>;
  _not?: InputMaybe<Free_Ticker_Option_Flow_All_Sides_Bool_Exp>;
  _or?: InputMaybe<Array<Free_Ticker_Option_Flow_All_Sides_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Free_Ticker_Option_Flow_All_Sides_Max_Fields = {
  __typename?: 'free_ticker_option_flow_all_sides_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Free_Ticker_Option_Flow_All_Sides_Min_Fields = {
  __typename?: 'free_ticker_option_flow_all_sides_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "free_ticker_option_flow_all_sides". */
export type Free_Ticker_Option_Flow_All_Sides_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** select columns of table "free_ticker_option_flow_all_sides" */
export const Free_Ticker_Option_Flow_All_Sides_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Free_Ticker_Option_Flow_All_Sides_Select_Column = typeof Free_Ticker_Option_Flow_All_Sides_Select_Column[keyof typeof Free_Ticker_Option_Flow_All_Sides_Select_Column];
/** aggregate stddev on columns */
export type Free_Ticker_Option_Flow_All_Sides_Stddev_Fields = {
  __typename?: 'free_ticker_option_flow_all_sides_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Free_Ticker_Option_Flow_All_Sides_Stddev_Pop_Fields = {
  __typename?: 'free_ticker_option_flow_all_sides_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Free_Ticker_Option_Flow_All_Sides_Stddev_Samp_Fields = {
  __typename?: 'free_ticker_option_flow_all_sides_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "free_ticker_option_flow_all_sides" */
export type Free_Ticker_Option_Flow_All_Sides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Free_Ticker_Option_Flow_All_Sides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Free_Ticker_Option_Flow_All_Sides_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Free_Ticker_Option_Flow_All_Sides_Sum_Fields = {
  __typename?: 'free_ticker_option_flow_all_sides_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Free_Ticker_Option_Flow_All_Sides_Var_Pop_Fields = {
  __typename?: 'free_ticker_option_flow_all_sides_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Free_Ticker_Option_Flow_All_Sides_Var_Samp_Fields = {
  __typename?: 'free_ticker_option_flow_all_sides_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Free_Ticker_Option_Flow_All_Sides_Variance_Fields = {
  __typename?: 'free_ticker_option_flow_all_sides_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate avg on columns */
export type Free_Ticker_Option_Flow_Avg_Fields = {
  __typename?: 'free_ticker_option_flow_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "free_ticker_option_flow". All fields are combined with a logical 'AND'. */
export type Free_Ticker_Option_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Free_Ticker_Option_Flow_Bool_Exp>>;
  _not?: InputMaybe<Free_Ticker_Option_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Free_Ticker_Option_Flow_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Free_Ticker_Option_Flow_Max_Fields = {
  __typename?: 'free_ticker_option_flow_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Free_Ticker_Option_Flow_Min_Fields = {
  __typename?: 'free_ticker_option_flow_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "free_ticker_option_flow". */
export type Free_Ticker_Option_Flow_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** select columns of table "free_ticker_option_flow" */
export const Free_Ticker_Option_Flow_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Free_Ticker_Option_Flow_Select_Column = typeof Free_Ticker_Option_Flow_Select_Column[keyof typeof Free_Ticker_Option_Flow_Select_Column];
/** aggregate stddev on columns */
export type Free_Ticker_Option_Flow_Stddev_Fields = {
  __typename?: 'free_ticker_option_flow_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Free_Ticker_Option_Flow_Stddev_Pop_Fields = {
  __typename?: 'free_ticker_option_flow_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Free_Ticker_Option_Flow_Stddev_Samp_Fields = {
  __typename?: 'free_ticker_option_flow_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "free_ticker_option_flow" */
export type Free_Ticker_Option_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Free_Ticker_Option_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Free_Ticker_Option_Flow_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Free_Ticker_Option_Flow_Sum_Fields = {
  __typename?: 'free_ticker_option_flow_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Free_Ticker_Option_Flow_Var_Pop_Fields = {
  __typename?: 'free_ticker_option_flow_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Free_Ticker_Option_Flow_Var_Samp_Fields = {
  __typename?: 'free_ticker_option_flow_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Free_Ticker_Option_Flow_Variance_Fields = {
  __typename?: 'free_ticker_option_flow_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "full_feed_equity_print_flow" */
export type Full_Feed_Equity_Print_Flow = {
  __typename?: 'full_feed_equity_print_flow';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  isEtf?: Maybe<Scalars['Boolean']>;
  isOutsideDailyRange?: Maybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: Maybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: Maybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: Maybe<Scalars['Boolean']>;
  isSignatureVolume?: Maybe<Scalars['Boolean']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeConditions?: Maybe<Scalars['jsonb']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "full_feed_equity_print_flow" */
export type Full_Feed_Equity_Print_FlowTradeConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "full_feed_equity_print_flow" */
export type Full_Feed_Equity_Print_Flow_Aggregate = {
  __typename?: 'full_feed_equity_print_flow_aggregate';
  aggregate?: Maybe<Full_Feed_Equity_Print_Flow_Aggregate_Fields>;
  nodes: Array<Full_Feed_Equity_Print_Flow>;
};

/** aggregate fields of "full_feed_equity_print_flow" */
export type Full_Feed_Equity_Print_Flow_Aggregate_Fields = {
  __typename?: 'full_feed_equity_print_flow_aggregate_fields';
  avg?: Maybe<Full_Feed_Equity_Print_Flow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Full_Feed_Equity_Print_Flow_Max_Fields>;
  min?: Maybe<Full_Feed_Equity_Print_Flow_Min_Fields>;
  stddev?: Maybe<Full_Feed_Equity_Print_Flow_Stddev_Fields>;
  stddev_pop?: Maybe<Full_Feed_Equity_Print_Flow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Full_Feed_Equity_Print_Flow_Stddev_Samp_Fields>;
  sum?: Maybe<Full_Feed_Equity_Print_Flow_Sum_Fields>;
  var_pop?: Maybe<Full_Feed_Equity_Print_Flow_Var_Pop_Fields>;
  var_samp?: Maybe<Full_Feed_Equity_Print_Flow_Var_Samp_Fields>;
  variance?: Maybe<Full_Feed_Equity_Print_Flow_Variance_Fields>;
};


/** aggregate fields of "full_feed_equity_print_flow" */
export type Full_Feed_Equity_Print_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Full_Feed_Equity_Print_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Full_Feed_Equity_Print_Flow_Avg_Fields = {
  __typename?: 'full_feed_equity_print_flow_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "full_feed_equity_print_flow". All fields are combined with a logical 'AND'. */
export type Full_Feed_Equity_Print_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Full_Feed_Equity_Print_Flow_Bool_Exp>>;
  _not?: InputMaybe<Full_Feed_Equity_Print_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Full_Feed_Equity_Print_Flow_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  ask?: InputMaybe<Numeric_Comparison_Exp>;
  askSize?: InputMaybe<Int_Comparison_Exp>;
  avgPrice?: InputMaybe<Numeric_Comparison_Exp>;
  avgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  bid?: InputMaybe<Numeric_Comparison_Exp>;
  bidSize?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  dayOverDayPercentChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayOverDayPriceChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayVolume?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeId?: InputMaybe<Int_Comparison_Exp>;
  externalTradeId?: InputMaybe<String_Comparison_Exp>;
  high?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isEtf?: InputMaybe<Boolean_Comparison_Exp>;
  isOutsideDailyRange?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanOpen?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureEtfTicker?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureVolume?: InputMaybe<Boolean_Comparison_Exp>;
  lastTradePrice?: InputMaybe<Numeric_Comparison_Exp>;
  low?: InputMaybe<Numeric_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  open?: InputMaybe<Numeric_Comparison_Exp>;
  percentAboveAsk?: InputMaybe<Numeric_Comparison_Exp>;
  percentBelowBid?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfAvgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfMarketCap?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfTodaysVolume?: InputMaybe<Numeric_Comparison_Exp>;
  prevClose?: InputMaybe<Numeric_Comparison_Exp>;
  prevHigh?: InputMaybe<Numeric_Comparison_Exp>;
  prevLow?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  realtimePrice?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  tapeId?: InputMaybe<Int_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  timestamp?: InputMaybe<Bigint_Comparison_Exp>;
  timestampIso?: InputMaybe<Timestamptz_Comparison_Exp>;
  tradeConditions?: InputMaybe<Jsonb_Comparison_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Full_Feed_Equity_Print_Flow_Max_Fields = {
  __typename?: 'full_feed_equity_print_flow_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Full_Feed_Equity_Print_Flow_Min_Fields = {
  __typename?: 'full_feed_equity_print_flow_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "full_feed_equity_print_flow". */
export type Full_Feed_Equity_Print_Flow_Order_By = {
  amount?: InputMaybe<Order_By>;
  ask?: InputMaybe<Order_By>;
  askSize?: InputMaybe<Order_By>;
  avgPrice?: InputMaybe<Order_By>;
  avgVolume?: InputMaybe<Order_By>;
  bid?: InputMaybe<Order_By>;
  bidSize?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  dayOverDayPercentChange?: InputMaybe<Order_By>;
  dayOverDayPriceChange?: InputMaybe<Order_By>;
  dayVolume?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  externalTradeId?: InputMaybe<Order_By>;
  high?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isEtf?: InputMaybe<Order_By>;
  isOutsideDailyRange?: InputMaybe<Order_By>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Order_By>;
  isPriceGreaterThanOpen?: InputMaybe<Order_By>;
  isSignatureEtfTicker?: InputMaybe<Order_By>;
  isSignatureVolume?: InputMaybe<Order_By>;
  lastTradePrice?: InputMaybe<Order_By>;
  low?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  open?: InputMaybe<Order_By>;
  percentAboveAsk?: InputMaybe<Order_By>;
  percentBelowBid?: InputMaybe<Order_By>;
  percentOfAvgVolume?: InputMaybe<Order_By>;
  percentOfMarketCap?: InputMaybe<Order_By>;
  percentOfTodaysVolume?: InputMaybe<Order_By>;
  prevClose?: InputMaybe<Order_By>;
  prevHigh?: InputMaybe<Order_By>;
  prevLow?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  realtimePrice?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  tapeId?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  timestamp?: InputMaybe<Order_By>;
  timestampIso?: InputMaybe<Order_By>;
  tradeConditions?: InputMaybe<Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "full_feed_equity_print_flow" */
export const Full_Feed_Equity_Print_Flow_Select_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Ask: 'ask',
  /** column name */
  AskSize: 'askSize',
  /** column name */
  AvgPrice: 'avgPrice',
  /** column name */
  AvgVolume: 'avgVolume',
  /** column name */
  Bid: 'bid',
  /** column name */
  BidSize: 'bidSize',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DayOverDayPercentChange: 'dayOverDayPercentChange',
  /** column name */
  DayOverDayPriceChange: 'dayOverDayPriceChange',
  /** column name */
  DayVolume: 'dayVolume',
  /** column name */
  ExchangeId: 'exchangeId',
  /** column name */
  ExternalTradeId: 'externalTradeId',
  /** column name */
  High: 'high',
  /** column name */
  Id: 'id',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsOutsideDailyRange: 'isOutsideDailyRange',
  /** column name */
  IsPriceGreaterThanDailyAverage: 'isPriceGreaterThanDailyAverage',
  /** column name */
  IsPriceGreaterThanOpen: 'isPriceGreaterThanOpen',
  /** column name */
  IsSignatureEtfTicker: 'isSignatureEtfTicker',
  /** column name */
  IsSignatureVolume: 'isSignatureVolume',
  /** column name */
  LastTradePrice: 'lastTradePrice',
  /** column name */
  Low: 'low',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Open: 'open',
  /** column name */
  PercentAboveAsk: 'percentAboveAsk',
  /** column name */
  PercentBelowBid: 'percentBelowBid',
  /** column name */
  PercentOfAvgVolume: 'percentOfAvgVolume',
  /** column name */
  PercentOfMarketCap: 'percentOfMarketCap',
  /** column name */
  PercentOfTodaysVolume: 'percentOfTodaysVolume',
  /** column name */
  PrevClose: 'prevClose',
  /** column name */
  PrevHigh: 'prevHigh',
  /** column name */
  PrevLow: 'prevLow',
  /** column name */
  Price: 'price',
  /** column name */
  RealtimePrice: 'realtimePrice',
  /** column name */
  Size: 'size',
  /** column name */
  TapeId: 'tapeId',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TimestampIso: 'timestampIso',
  /** column name */
  TradeConditions: 'tradeConditions',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Full_Feed_Equity_Print_Flow_Select_Column = typeof Full_Feed_Equity_Print_Flow_Select_Column[keyof typeof Full_Feed_Equity_Print_Flow_Select_Column];
/** aggregate stddev on columns */
export type Full_Feed_Equity_Print_Flow_Stddev_Fields = {
  __typename?: 'full_feed_equity_print_flow_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Full_Feed_Equity_Print_Flow_Stddev_Pop_Fields = {
  __typename?: 'full_feed_equity_print_flow_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Full_Feed_Equity_Print_Flow_Stddev_Samp_Fields = {
  __typename?: 'full_feed_equity_print_flow_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "full_feed_equity_print_flow" */
export type Full_Feed_Equity_Print_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Full_Feed_Equity_Print_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Full_Feed_Equity_Print_Flow_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  timestampIso?: InputMaybe<Scalars['timestamptz']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Full_Feed_Equity_Print_Flow_Sum_Fields = {
  __typename?: 'full_feed_equity_print_flow_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  high?: Maybe<Scalars['numeric']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Full_Feed_Equity_Print_Flow_Var_Pop_Fields = {
  __typename?: 'full_feed_equity_print_flow_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Full_Feed_Equity_Print_Flow_Var_Samp_Fields = {
  __typename?: 'full_feed_equity_print_flow_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Full_Feed_Equity_Print_Flow_Variance_Fields = {
  __typename?: 'full_feed_equity_print_flow_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "full_feed_option_flow" */
export type Full_Feed_Option_Flow = {
  __typename?: 'full_feed_option_flow';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtTypes?: Maybe<Scalars['jsonb']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "full_feed_option_flow" */
export type Full_Feed_Option_FlowPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "full_feed_option_flow" */
export type Full_Feed_Option_Flow_Aggregate = {
  __typename?: 'full_feed_option_flow_aggregate';
  aggregate?: Maybe<Full_Feed_Option_Flow_Aggregate_Fields>;
  nodes: Array<Full_Feed_Option_Flow>;
};

/** aggregate fields of "full_feed_option_flow" */
export type Full_Feed_Option_Flow_Aggregate_Fields = {
  __typename?: 'full_feed_option_flow_aggregate_fields';
  avg?: Maybe<Full_Feed_Option_Flow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Full_Feed_Option_Flow_Max_Fields>;
  min?: Maybe<Full_Feed_Option_Flow_Min_Fields>;
  stddev?: Maybe<Full_Feed_Option_Flow_Stddev_Fields>;
  stddev_pop?: Maybe<Full_Feed_Option_Flow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Full_Feed_Option_Flow_Stddev_Samp_Fields>;
  sum?: Maybe<Full_Feed_Option_Flow_Sum_Fields>;
  var_pop?: Maybe<Full_Feed_Option_Flow_Var_Pop_Fields>;
  var_samp?: Maybe<Full_Feed_Option_Flow_Var_Samp_Fields>;
  variance?: Maybe<Full_Feed_Option_Flow_Variance_Fields>;
};


/** aggregate fields of "full_feed_option_flow" */
export type Full_Feed_Option_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Full_Feed_Option_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Full_Feed_Option_Flow_Append_Input = {
  prtTypes?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Full_Feed_Option_Flow_Avg_Fields = {
  __typename?: 'full_feed_option_flow_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "full_feed_option_flow". All fields are combined with a logical 'AND'. */
export type Full_Feed_Option_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Full_Feed_Option_Flow_Bool_Exp>>;
  _not?: InputMaybe<Full_Feed_Option_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Full_Feed_Option_Flow_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Full_Feed_Option_Flow_Delete_At_Path_Input = {
  prtTypes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Full_Feed_Option_Flow_Delete_Elem_Input = {
  prtTypes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Full_Feed_Option_Flow_Delete_Key_Input = {
  prtTypes?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "full_feed_option_flow" */
export type Full_Feed_Option_Flow_Inc_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "full_feed_option_flow" */
export type Full_Feed_Option_Flow_Insert_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Full_Feed_Option_Flow_Max_Fields = {
  __typename?: 'full_feed_option_flow_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Full_Feed_Option_Flow_Min_Fields = {
  __typename?: 'full_feed_option_flow_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "full_feed_option_flow" */
export type Full_Feed_Option_Flow_Mutation_Response = {
  __typename?: 'full_feed_option_flow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Full_Feed_Option_Flow>;
};

/** Ordering options when selecting data from "full_feed_option_flow". */
export type Full_Feed_Option_Flow_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Full_Feed_Option_Flow_Prepend_Input = {
  prtTypes?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "full_feed_option_flow" */
export const Full_Feed_Option_Flow_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Full_Feed_Option_Flow_Select_Column = typeof Full_Feed_Option_Flow_Select_Column[keyof typeof Full_Feed_Option_Flow_Select_Column];
/** input type for updating data in table "full_feed_option_flow" */
export type Full_Feed_Option_Flow_Set_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Full_Feed_Option_Flow_Stddev_Fields = {
  __typename?: 'full_feed_option_flow_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Full_Feed_Option_Flow_Stddev_Pop_Fields = {
  __typename?: 'full_feed_option_flow_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Full_Feed_Option_Flow_Stddev_Samp_Fields = {
  __typename?: 'full_feed_option_flow_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "full_feed_option_flow" */
export type Full_Feed_Option_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Full_Feed_Option_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Full_Feed_Option_Flow_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Full_Feed_Option_Flow_Sum_Fields = {
  __typename?: 'full_feed_option_flow_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

export type Full_Feed_Option_Flow_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Full_Feed_Option_Flow_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Full_Feed_Option_Flow_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Full_Feed_Option_Flow_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Full_Feed_Option_Flow_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Full_Feed_Option_Flow_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Full_Feed_Option_Flow_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Full_Feed_Option_Flow_Set_Input>;
  /** filter the rows which have to be updated */
  where: Full_Feed_Option_Flow_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Full_Feed_Option_Flow_Var_Pop_Fields = {
  __typename?: 'full_feed_option_flow_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Full_Feed_Option_Flow_Var_Samp_Fields = {
  __typename?: 'full_feed_option_flow_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Full_Feed_Option_Flow_Variance_Fields = {
  __typename?: 'full_feed_option_flow_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "health_checks" */
export type Health_Checks = {
  __typename?: 'health_checks';
  createdAt: Scalars['timestamptz'];
  healthyAt: Scalars['timestamptz'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "health_checks" */
export type Health_Checks_Aggregate = {
  __typename?: 'health_checks_aggregate';
  aggregate?: Maybe<Health_Checks_Aggregate_Fields>;
  nodes: Array<Health_Checks>;
};

/** aggregate fields of "health_checks" */
export type Health_Checks_Aggregate_Fields = {
  __typename?: 'health_checks_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Health_Checks_Max_Fields>;
  min?: Maybe<Health_Checks_Min_Fields>;
};


/** aggregate fields of "health_checks" */
export type Health_Checks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Health_Checks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "health_checks". All fields are combined with a logical 'AND'. */
export type Health_Checks_Bool_Exp = {
  _and?: InputMaybe<Array<Health_Checks_Bool_Exp>>;
  _not?: InputMaybe<Health_Checks_Bool_Exp>;
  _or?: InputMaybe<Array<Health_Checks_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  healthyAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "health_checks" */
export const Health_Checks_Constraint = {
  /** unique or primary key constraint on columns "name" */
  HealthChecksPkey: 'health_checks_pkey'
} as const;

export type Health_Checks_Constraint = typeof Health_Checks_Constraint[keyof typeof Health_Checks_Constraint];
/** input type for inserting data into table "health_checks" */
export type Health_Checks_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  healthyAt?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Health_Checks_Max_Fields = {
  __typename?: 'health_checks_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  healthyAt?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Health_Checks_Min_Fields = {
  __typename?: 'health_checks_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  healthyAt?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "health_checks" */
export type Health_Checks_Mutation_Response = {
  __typename?: 'health_checks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Health_Checks>;
};

/** on_conflict condition type for table "health_checks" */
export type Health_Checks_On_Conflict = {
  constraint: Health_Checks_Constraint;
  update_columns?: Array<Health_Checks_Update_Column>;
  where?: InputMaybe<Health_Checks_Bool_Exp>;
};

/** Ordering options when selecting data from "health_checks". */
export type Health_Checks_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  healthyAt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: health_checks */
export type Health_Checks_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "health_checks" */
export const Health_Checks_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  HealthyAt: 'healthyAt',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Health_Checks_Select_Column = typeof Health_Checks_Select_Column[keyof typeof Health_Checks_Select_Column];
/** input type for updating data in table "health_checks" */
export type Health_Checks_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  healthyAt?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "health_checks" */
export type Health_Checks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Health_Checks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Health_Checks_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  healthyAt?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "health_checks" */
export const Health_Checks_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  HealthyAt: 'healthyAt',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Health_Checks_Update_Column = typeof Health_Checks_Update_Column[keyof typeof Health_Checks_Update_Column];
export type Health_Checks_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Health_Checks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Health_Checks_Bool_Exp;
};

/** columns and relationships of "insider_trades" */
export type Insider_Trades = {
  __typename?: 'insider_trades';
  acquistionOrDisposition: Scalars['String'];
  changeInPercentOwned?: Maybe<Scalars['numeric']>;
  companyCik: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  filingDate: Scalars['String'];
  filingDateTimestamp: Scalars['timestamptz'];
  formType: Scalars['String'];
  id: Scalars['uuid'];
  isDirector: Scalars['Boolean'];
  isOfficer: Scalars['Boolean'];
  isTenPercentOwner: Scalars['Boolean'];
  link: Scalars['String'];
  numberOfTransactions: Scalars['Int'];
  ownerJobTitle: Scalars['String'];
  price?: Maybe<Scalars['numeric']>;
  reportingCik: Scalars['String'];
  reportingName: Scalars['String'];
  securitiesOwned: Scalars['numeric'];
  securitiesTransacted: Scalars['numeric'];
  securityName: Scalars['String'];
  ticker: Scalars['String'];
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  transactionDate: Scalars['date'];
  transactionDetails: Scalars['jsonb'];
  transactionKey: Scalars['String'];
  transactionType: Scalars['String'];
  transactionValue: Scalars['numeric'];
  typeOfOwner: Scalars['String'];
  typeOfOwnerCategory: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "insider_trades" */
export type Insider_TradesTransactionDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "insider_trades" */
export type Insider_Trades_Aggregate = {
  __typename?: 'insider_trades_aggregate';
  aggregate?: Maybe<Insider_Trades_Aggregate_Fields>;
  nodes: Array<Insider_Trades>;
};

/** aggregate fields of "insider_trades" */
export type Insider_Trades_Aggregate_Fields = {
  __typename?: 'insider_trades_aggregate_fields';
  avg?: Maybe<Insider_Trades_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Insider_Trades_Max_Fields>;
  min?: Maybe<Insider_Trades_Min_Fields>;
  stddev?: Maybe<Insider_Trades_Stddev_Fields>;
  stddev_pop?: Maybe<Insider_Trades_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insider_Trades_Stddev_Samp_Fields>;
  sum?: Maybe<Insider_Trades_Sum_Fields>;
  var_pop?: Maybe<Insider_Trades_Var_Pop_Fields>;
  var_samp?: Maybe<Insider_Trades_Var_Samp_Fields>;
  variance?: Maybe<Insider_Trades_Variance_Fields>;
};


/** aggregate fields of "insider_trades" */
export type Insider_Trades_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insider_Trades_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Insider_Trades_Append_Input = {
  transactionDetails?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Insider_Trades_Avg_Fields = {
  __typename?: 'insider_trades_avg_fields';
  changeInPercentOwned?: Maybe<Scalars['Float']>;
  numberOfTransactions?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  securitiesOwned?: Maybe<Scalars['Float']>;
  securitiesTransacted?: Maybe<Scalars['Float']>;
  transactionValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "insider_trades". All fields are combined with a logical 'AND'. */
export type Insider_Trades_Bool_Exp = {
  _and?: InputMaybe<Array<Insider_Trades_Bool_Exp>>;
  _not?: InputMaybe<Insider_Trades_Bool_Exp>;
  _or?: InputMaybe<Array<Insider_Trades_Bool_Exp>>;
  acquistionOrDisposition?: InputMaybe<String_Comparison_Exp>;
  changeInPercentOwned?: InputMaybe<Numeric_Comparison_Exp>;
  companyCik?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  filingDate?: InputMaybe<String_Comparison_Exp>;
  filingDateTimestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  formType?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDirector?: InputMaybe<Boolean_Comparison_Exp>;
  isOfficer?: InputMaybe<Boolean_Comparison_Exp>;
  isTenPercentOwner?: InputMaybe<Boolean_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  numberOfTransactions?: InputMaybe<Int_Comparison_Exp>;
  ownerJobTitle?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  reportingCik?: InputMaybe<String_Comparison_Exp>;
  reportingName?: InputMaybe<String_Comparison_Exp>;
  securitiesOwned?: InputMaybe<Numeric_Comparison_Exp>;
  securitiesTransacted?: InputMaybe<Numeric_Comparison_Exp>;
  securityName?: InputMaybe<String_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  transactionDate?: InputMaybe<Date_Comparison_Exp>;
  transactionDetails?: InputMaybe<Jsonb_Comparison_Exp>;
  transactionKey?: InputMaybe<String_Comparison_Exp>;
  transactionType?: InputMaybe<String_Comparison_Exp>;
  transactionValue?: InputMaybe<Numeric_Comparison_Exp>;
  typeOfOwner?: InputMaybe<String_Comparison_Exp>;
  typeOfOwnerCategory?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "insider_trades" */
export const Insider_Trades_Constraint = {
  /** unique or primary key constraint on columns "id" */
  InsiderTradesPkey: 'insider_trades_pkey',
  /** unique or primary key constraint on columns "transactionKey" */
  InsiderTradesTransactionKeyKey: 'insider_trades_transactionKey_key'
} as const;

export type Insider_Trades_Constraint = typeof Insider_Trades_Constraint[keyof typeof Insider_Trades_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Insider_Trades_Delete_At_Path_Input = {
  transactionDetails?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Insider_Trades_Delete_Elem_Input = {
  transactionDetails?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Insider_Trades_Delete_Key_Input = {
  transactionDetails?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "insider_trades" */
export type Insider_Trades_Inc_Input = {
  changeInPercentOwned?: InputMaybe<Scalars['numeric']>;
  numberOfTransactions?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  securitiesOwned?: InputMaybe<Scalars['numeric']>;
  securitiesTransacted?: InputMaybe<Scalars['numeric']>;
  transactionValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "insider_trades" */
export type Insider_Trades_Insert_Input = {
  acquistionOrDisposition?: InputMaybe<Scalars['String']>;
  changeInPercentOwned?: InputMaybe<Scalars['numeric']>;
  companyCik?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  filingDate?: InputMaybe<Scalars['String']>;
  filingDateTimestamp?: InputMaybe<Scalars['timestamptz']>;
  formType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDirector?: InputMaybe<Scalars['Boolean']>;
  isOfficer?: InputMaybe<Scalars['Boolean']>;
  isTenPercentOwner?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<Scalars['String']>;
  numberOfTransactions?: InputMaybe<Scalars['Int']>;
  ownerJobTitle?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  reportingCik?: InputMaybe<Scalars['String']>;
  reportingName?: InputMaybe<Scalars['String']>;
  securitiesOwned?: InputMaybe<Scalars['numeric']>;
  securitiesTransacted?: InputMaybe<Scalars['numeric']>;
  securityName?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  transactionDate?: InputMaybe<Scalars['date']>;
  transactionDetails?: InputMaybe<Scalars['jsonb']>;
  transactionKey?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Scalars['String']>;
  transactionValue?: InputMaybe<Scalars['numeric']>;
  typeOfOwner?: InputMaybe<Scalars['String']>;
  typeOfOwnerCategory?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Insider_Trades_Max_Fields = {
  __typename?: 'insider_trades_max_fields';
  acquistionOrDisposition?: Maybe<Scalars['String']>;
  changeInPercentOwned?: Maybe<Scalars['numeric']>;
  companyCik?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  filingDate?: Maybe<Scalars['String']>;
  filingDateTimestamp?: Maybe<Scalars['timestamptz']>;
  formType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  numberOfTransactions?: Maybe<Scalars['Int']>;
  ownerJobTitle?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  reportingCik?: Maybe<Scalars['String']>;
  reportingName?: Maybe<Scalars['String']>;
  securitiesOwned?: Maybe<Scalars['numeric']>;
  securitiesTransacted?: Maybe<Scalars['numeric']>;
  securityName?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['date']>;
  transactionKey?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
  transactionValue?: Maybe<Scalars['numeric']>;
  typeOfOwner?: Maybe<Scalars['String']>;
  typeOfOwnerCategory?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Insider_Trades_Min_Fields = {
  __typename?: 'insider_trades_min_fields';
  acquistionOrDisposition?: Maybe<Scalars['String']>;
  changeInPercentOwned?: Maybe<Scalars['numeric']>;
  companyCik?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  filingDate?: Maybe<Scalars['String']>;
  filingDateTimestamp?: Maybe<Scalars['timestamptz']>;
  formType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  numberOfTransactions?: Maybe<Scalars['Int']>;
  ownerJobTitle?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  reportingCik?: Maybe<Scalars['String']>;
  reportingName?: Maybe<Scalars['String']>;
  securitiesOwned?: Maybe<Scalars['numeric']>;
  securitiesTransacted?: Maybe<Scalars['numeric']>;
  securityName?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['date']>;
  transactionKey?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
  transactionValue?: Maybe<Scalars['numeric']>;
  typeOfOwner?: Maybe<Scalars['String']>;
  typeOfOwnerCategory?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "insider_trades" */
export type Insider_Trades_Mutation_Response = {
  __typename?: 'insider_trades_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Insider_Trades>;
};

/** on_conflict condition type for table "insider_trades" */
export type Insider_Trades_On_Conflict = {
  constraint: Insider_Trades_Constraint;
  update_columns?: Array<Insider_Trades_Update_Column>;
  where?: InputMaybe<Insider_Trades_Bool_Exp>;
};

/** Ordering options when selecting data from "insider_trades". */
export type Insider_Trades_Order_By = {
  acquistionOrDisposition?: InputMaybe<Order_By>;
  changeInPercentOwned?: InputMaybe<Order_By>;
  companyCik?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  filingDate?: InputMaybe<Order_By>;
  filingDateTimestamp?: InputMaybe<Order_By>;
  formType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDirector?: InputMaybe<Order_By>;
  isOfficer?: InputMaybe<Order_By>;
  isTenPercentOwner?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  numberOfTransactions?: InputMaybe<Order_By>;
  ownerJobTitle?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  reportingCik?: InputMaybe<Order_By>;
  reportingName?: InputMaybe<Order_By>;
  securitiesOwned?: InputMaybe<Order_By>;
  securitiesTransacted?: InputMaybe<Order_By>;
  securityName?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  transactionDate?: InputMaybe<Order_By>;
  transactionDetails?: InputMaybe<Order_By>;
  transactionKey?: InputMaybe<Order_By>;
  transactionType?: InputMaybe<Order_By>;
  transactionValue?: InputMaybe<Order_By>;
  typeOfOwner?: InputMaybe<Order_By>;
  typeOfOwnerCategory?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: insider_trades */
export type Insider_Trades_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Insider_Trades_Prepend_Input = {
  transactionDetails?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "insider_trades" */
export const Insider_Trades_Select_Column = {
  /** column name */
  AcquistionOrDisposition: 'acquistionOrDisposition',
  /** column name */
  ChangeInPercentOwned: 'changeInPercentOwned',
  /** column name */
  CompanyCik: 'companyCik',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  FilingDate: 'filingDate',
  /** column name */
  FilingDateTimestamp: 'filingDateTimestamp',
  /** column name */
  FormType: 'formType',
  /** column name */
  Id: 'id',
  /** column name */
  IsDirector: 'isDirector',
  /** column name */
  IsOfficer: 'isOfficer',
  /** column name */
  IsTenPercentOwner: 'isTenPercentOwner',
  /** column name */
  Link: 'link',
  /** column name */
  NumberOfTransactions: 'numberOfTransactions',
  /** column name */
  OwnerJobTitle: 'ownerJobTitle',
  /** column name */
  Price: 'price',
  /** column name */
  ReportingCik: 'reportingCik',
  /** column name */
  ReportingName: 'reportingName',
  /** column name */
  SecuritiesOwned: 'securitiesOwned',
  /** column name */
  SecuritiesTransacted: 'securitiesTransacted',
  /** column name */
  SecurityName: 'securityName',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TransactionDate: 'transactionDate',
  /** column name */
  TransactionDetails: 'transactionDetails',
  /** column name */
  TransactionKey: 'transactionKey',
  /** column name */
  TransactionType: 'transactionType',
  /** column name */
  TransactionValue: 'transactionValue',
  /** column name */
  TypeOfOwner: 'typeOfOwner',
  /** column name */
  TypeOfOwnerCategory: 'typeOfOwnerCategory',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Insider_Trades_Select_Column = typeof Insider_Trades_Select_Column[keyof typeof Insider_Trades_Select_Column];
/** input type for updating data in table "insider_trades" */
export type Insider_Trades_Set_Input = {
  acquistionOrDisposition?: InputMaybe<Scalars['String']>;
  changeInPercentOwned?: InputMaybe<Scalars['numeric']>;
  companyCik?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  filingDate?: InputMaybe<Scalars['String']>;
  filingDateTimestamp?: InputMaybe<Scalars['timestamptz']>;
  formType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDirector?: InputMaybe<Scalars['Boolean']>;
  isOfficer?: InputMaybe<Scalars['Boolean']>;
  isTenPercentOwner?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<Scalars['String']>;
  numberOfTransactions?: InputMaybe<Scalars['Int']>;
  ownerJobTitle?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  reportingCik?: InputMaybe<Scalars['String']>;
  reportingName?: InputMaybe<Scalars['String']>;
  securitiesOwned?: InputMaybe<Scalars['numeric']>;
  securitiesTransacted?: InputMaybe<Scalars['numeric']>;
  securityName?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  transactionDate?: InputMaybe<Scalars['date']>;
  transactionDetails?: InputMaybe<Scalars['jsonb']>;
  transactionKey?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Scalars['String']>;
  transactionValue?: InputMaybe<Scalars['numeric']>;
  typeOfOwner?: InputMaybe<Scalars['String']>;
  typeOfOwnerCategory?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Insider_Trades_Stddev_Fields = {
  __typename?: 'insider_trades_stddev_fields';
  changeInPercentOwned?: Maybe<Scalars['Float']>;
  numberOfTransactions?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  securitiesOwned?: Maybe<Scalars['Float']>;
  securitiesTransacted?: Maybe<Scalars['Float']>;
  transactionValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Insider_Trades_Stddev_Pop_Fields = {
  __typename?: 'insider_trades_stddev_pop_fields';
  changeInPercentOwned?: Maybe<Scalars['Float']>;
  numberOfTransactions?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  securitiesOwned?: Maybe<Scalars['Float']>;
  securitiesTransacted?: Maybe<Scalars['Float']>;
  transactionValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Insider_Trades_Stddev_Samp_Fields = {
  __typename?: 'insider_trades_stddev_samp_fields';
  changeInPercentOwned?: Maybe<Scalars['Float']>;
  numberOfTransactions?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  securitiesOwned?: Maybe<Scalars['Float']>;
  securitiesTransacted?: Maybe<Scalars['Float']>;
  transactionValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "insider_trades" */
export type Insider_Trades_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insider_Trades_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insider_Trades_Stream_Cursor_Value_Input = {
  acquistionOrDisposition?: InputMaybe<Scalars['String']>;
  changeInPercentOwned?: InputMaybe<Scalars['numeric']>;
  companyCik?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  filingDate?: InputMaybe<Scalars['String']>;
  filingDateTimestamp?: InputMaybe<Scalars['timestamptz']>;
  formType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isDirector?: InputMaybe<Scalars['Boolean']>;
  isOfficer?: InputMaybe<Scalars['Boolean']>;
  isTenPercentOwner?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<Scalars['String']>;
  numberOfTransactions?: InputMaybe<Scalars['Int']>;
  ownerJobTitle?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  reportingCik?: InputMaybe<Scalars['String']>;
  reportingName?: InputMaybe<Scalars['String']>;
  securitiesOwned?: InputMaybe<Scalars['numeric']>;
  securitiesTransacted?: InputMaybe<Scalars['numeric']>;
  securityName?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  transactionDate?: InputMaybe<Scalars['date']>;
  transactionDetails?: InputMaybe<Scalars['jsonb']>;
  transactionKey?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Scalars['String']>;
  transactionValue?: InputMaybe<Scalars['numeric']>;
  typeOfOwner?: InputMaybe<Scalars['String']>;
  typeOfOwnerCategory?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Insider_Trades_Sum_Fields = {
  __typename?: 'insider_trades_sum_fields';
  changeInPercentOwned?: Maybe<Scalars['numeric']>;
  numberOfTransactions?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  securitiesOwned?: Maybe<Scalars['numeric']>;
  securitiesTransacted?: Maybe<Scalars['numeric']>;
  transactionValue?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "insider_trades_top_long" */
export type Insider_Trades_Top_Long = {
  __typename?: 'insider_trades_top_long';
  id?: Maybe<Scalars['String']>;
  netTransactionValue?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
};

/** aggregated selection of "insider_trades_top_long" */
export type Insider_Trades_Top_Long_Aggregate = {
  __typename?: 'insider_trades_top_long_aggregate';
  aggregate?: Maybe<Insider_Trades_Top_Long_Aggregate_Fields>;
  nodes: Array<Insider_Trades_Top_Long>;
};

/** aggregate fields of "insider_trades_top_long" */
export type Insider_Trades_Top_Long_Aggregate_Fields = {
  __typename?: 'insider_trades_top_long_aggregate_fields';
  avg?: Maybe<Insider_Trades_Top_Long_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Insider_Trades_Top_Long_Max_Fields>;
  min?: Maybe<Insider_Trades_Top_Long_Min_Fields>;
  stddev?: Maybe<Insider_Trades_Top_Long_Stddev_Fields>;
  stddev_pop?: Maybe<Insider_Trades_Top_Long_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insider_Trades_Top_Long_Stddev_Samp_Fields>;
  sum?: Maybe<Insider_Trades_Top_Long_Sum_Fields>;
  var_pop?: Maybe<Insider_Trades_Top_Long_Var_Pop_Fields>;
  var_samp?: Maybe<Insider_Trades_Top_Long_Var_Samp_Fields>;
  variance?: Maybe<Insider_Trades_Top_Long_Variance_Fields>;
};


/** aggregate fields of "insider_trades_top_long" */
export type Insider_Trades_Top_Long_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insider_Trades_Top_Long_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Insider_Trades_Top_Long_Avg_Fields = {
  __typename?: 'insider_trades_top_long_avg_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "insider_trades_top_long". All fields are combined with a logical 'AND'. */
export type Insider_Trades_Top_Long_Bool_Exp = {
  _and?: InputMaybe<Array<Insider_Trades_Top_Long_Bool_Exp>>;
  _not?: InputMaybe<Insider_Trades_Top_Long_Bool_Exp>;
  _or?: InputMaybe<Array<Insider_Trades_Top_Long_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  netTransactionValue?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Insider_Trades_Top_Long_Max_Fields = {
  __typename?: 'insider_trades_top_long_max_fields';
  id?: Maybe<Scalars['String']>;
  netTransactionValue?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Insider_Trades_Top_Long_Min_Fields = {
  __typename?: 'insider_trades_top_long_min_fields';
  id?: Maybe<Scalars['String']>;
  netTransactionValue?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "insider_trades_top_long". */
export type Insider_Trades_Top_Long_Order_By = {
  id?: InputMaybe<Order_By>;
  netTransactionValue?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
};

/** select columns of table "insider_trades_top_long" */
export const Insider_Trades_Top_Long_Select_Column = {
  /** column name */
  Id: 'id',
  /** column name */
  NetTransactionValue: 'netTransactionValue',
  /** column name */
  Ticker: 'ticker'
} as const;

export type Insider_Trades_Top_Long_Select_Column = typeof Insider_Trades_Top_Long_Select_Column[keyof typeof Insider_Trades_Top_Long_Select_Column];
/** aggregate stddev on columns */
export type Insider_Trades_Top_Long_Stddev_Fields = {
  __typename?: 'insider_trades_top_long_stddev_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Insider_Trades_Top_Long_Stddev_Pop_Fields = {
  __typename?: 'insider_trades_top_long_stddev_pop_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Insider_Trades_Top_Long_Stddev_Samp_Fields = {
  __typename?: 'insider_trades_top_long_stddev_samp_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "insider_trades_top_long" */
export type Insider_Trades_Top_Long_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insider_Trades_Top_Long_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insider_Trades_Top_Long_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  netTransactionValue?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Insider_Trades_Top_Long_Sum_Fields = {
  __typename?: 'insider_trades_top_long_sum_fields';
  netTransactionValue?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Insider_Trades_Top_Long_Var_Pop_Fields = {
  __typename?: 'insider_trades_top_long_var_pop_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Insider_Trades_Top_Long_Var_Samp_Fields = {
  __typename?: 'insider_trades_top_long_var_samp_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Insider_Trades_Top_Long_Variance_Fields = {
  __typename?: 'insider_trades_top_long_variance_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "insider_trades_top_short" */
export type Insider_Trades_Top_Short = {
  __typename?: 'insider_trades_top_short';
  id?: Maybe<Scalars['String']>;
  netTransactionValue?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
};

/** aggregated selection of "insider_trades_top_short" */
export type Insider_Trades_Top_Short_Aggregate = {
  __typename?: 'insider_trades_top_short_aggregate';
  aggregate?: Maybe<Insider_Trades_Top_Short_Aggregate_Fields>;
  nodes: Array<Insider_Trades_Top_Short>;
};

/** aggregate fields of "insider_trades_top_short" */
export type Insider_Trades_Top_Short_Aggregate_Fields = {
  __typename?: 'insider_trades_top_short_aggregate_fields';
  avg?: Maybe<Insider_Trades_Top_Short_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Insider_Trades_Top_Short_Max_Fields>;
  min?: Maybe<Insider_Trades_Top_Short_Min_Fields>;
  stddev?: Maybe<Insider_Trades_Top_Short_Stddev_Fields>;
  stddev_pop?: Maybe<Insider_Trades_Top_Short_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insider_Trades_Top_Short_Stddev_Samp_Fields>;
  sum?: Maybe<Insider_Trades_Top_Short_Sum_Fields>;
  var_pop?: Maybe<Insider_Trades_Top_Short_Var_Pop_Fields>;
  var_samp?: Maybe<Insider_Trades_Top_Short_Var_Samp_Fields>;
  variance?: Maybe<Insider_Trades_Top_Short_Variance_Fields>;
};


/** aggregate fields of "insider_trades_top_short" */
export type Insider_Trades_Top_Short_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insider_Trades_Top_Short_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Insider_Trades_Top_Short_Avg_Fields = {
  __typename?: 'insider_trades_top_short_avg_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "insider_trades_top_short". All fields are combined with a logical 'AND'. */
export type Insider_Trades_Top_Short_Bool_Exp = {
  _and?: InputMaybe<Array<Insider_Trades_Top_Short_Bool_Exp>>;
  _not?: InputMaybe<Insider_Trades_Top_Short_Bool_Exp>;
  _or?: InputMaybe<Array<Insider_Trades_Top_Short_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  netTransactionValue?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Insider_Trades_Top_Short_Max_Fields = {
  __typename?: 'insider_trades_top_short_max_fields';
  id?: Maybe<Scalars['String']>;
  netTransactionValue?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Insider_Trades_Top_Short_Min_Fields = {
  __typename?: 'insider_trades_top_short_min_fields';
  id?: Maybe<Scalars['String']>;
  netTransactionValue?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "insider_trades_top_short". */
export type Insider_Trades_Top_Short_Order_By = {
  id?: InputMaybe<Order_By>;
  netTransactionValue?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
};

/** select columns of table "insider_trades_top_short" */
export const Insider_Trades_Top_Short_Select_Column = {
  /** column name */
  Id: 'id',
  /** column name */
  NetTransactionValue: 'netTransactionValue',
  /** column name */
  Ticker: 'ticker'
} as const;

export type Insider_Trades_Top_Short_Select_Column = typeof Insider_Trades_Top_Short_Select_Column[keyof typeof Insider_Trades_Top_Short_Select_Column];
/** aggregate stddev on columns */
export type Insider_Trades_Top_Short_Stddev_Fields = {
  __typename?: 'insider_trades_top_short_stddev_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Insider_Trades_Top_Short_Stddev_Pop_Fields = {
  __typename?: 'insider_trades_top_short_stddev_pop_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Insider_Trades_Top_Short_Stddev_Samp_Fields = {
  __typename?: 'insider_trades_top_short_stddev_samp_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "insider_trades_top_short" */
export type Insider_Trades_Top_Short_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insider_Trades_Top_Short_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insider_Trades_Top_Short_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  netTransactionValue?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Insider_Trades_Top_Short_Sum_Fields = {
  __typename?: 'insider_trades_top_short_sum_fields';
  netTransactionValue?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Insider_Trades_Top_Short_Var_Pop_Fields = {
  __typename?: 'insider_trades_top_short_var_pop_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Insider_Trades_Top_Short_Var_Samp_Fields = {
  __typename?: 'insider_trades_top_short_var_samp_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Insider_Trades_Top_Short_Variance_Fields = {
  __typename?: 'insider_trades_top_short_variance_fields';
  netTransactionValue?: Maybe<Scalars['Float']>;
};

/** update columns of table "insider_trades" */
export const Insider_Trades_Update_Column = {
  /** column name */
  AcquistionOrDisposition: 'acquistionOrDisposition',
  /** column name */
  ChangeInPercentOwned: 'changeInPercentOwned',
  /** column name */
  CompanyCik: 'companyCik',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  FilingDate: 'filingDate',
  /** column name */
  FilingDateTimestamp: 'filingDateTimestamp',
  /** column name */
  FormType: 'formType',
  /** column name */
  Id: 'id',
  /** column name */
  IsDirector: 'isDirector',
  /** column name */
  IsOfficer: 'isOfficer',
  /** column name */
  IsTenPercentOwner: 'isTenPercentOwner',
  /** column name */
  Link: 'link',
  /** column name */
  NumberOfTransactions: 'numberOfTransactions',
  /** column name */
  OwnerJobTitle: 'ownerJobTitle',
  /** column name */
  Price: 'price',
  /** column name */
  ReportingCik: 'reportingCik',
  /** column name */
  ReportingName: 'reportingName',
  /** column name */
  SecuritiesOwned: 'securitiesOwned',
  /** column name */
  SecuritiesTransacted: 'securitiesTransacted',
  /** column name */
  SecurityName: 'securityName',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TransactionDate: 'transactionDate',
  /** column name */
  TransactionDetails: 'transactionDetails',
  /** column name */
  TransactionKey: 'transactionKey',
  /** column name */
  TransactionType: 'transactionType',
  /** column name */
  TransactionValue: 'transactionValue',
  /** column name */
  TypeOfOwner: 'typeOfOwner',
  /** column name */
  TypeOfOwnerCategory: 'typeOfOwnerCategory',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Insider_Trades_Update_Column = typeof Insider_Trades_Update_Column[keyof typeof Insider_Trades_Update_Column];
export type Insider_Trades_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Insider_Trades_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Insider_Trades_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Insider_Trades_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Insider_Trades_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insider_Trades_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Insider_Trades_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insider_Trades_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insider_Trades_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insider_Trades_Var_Pop_Fields = {
  __typename?: 'insider_trades_var_pop_fields';
  changeInPercentOwned?: Maybe<Scalars['Float']>;
  numberOfTransactions?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  securitiesOwned?: Maybe<Scalars['Float']>;
  securitiesTransacted?: Maybe<Scalars['Float']>;
  transactionValue?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Insider_Trades_Var_Samp_Fields = {
  __typename?: 'insider_trades_var_samp_fields';
  changeInPercentOwned?: Maybe<Scalars['Float']>;
  numberOfTransactions?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  securitiesOwned?: Maybe<Scalars['Float']>;
  securitiesTransacted?: Maybe<Scalars['Float']>;
  transactionValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Insider_Trades_Variance_Fields = {
  __typename?: 'insider_trades_variance_fields';
  changeInPercentOwned?: Maybe<Scalars['Float']>;
  numberOfTransactions?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  securitiesOwned?: Maybe<Scalars['Float']>;
  securitiesTransacted?: Maybe<Scalars['Float']>;
  transactionValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "invoices" */
export type Invoices = {
  __typename?: 'invoices';
  amountDue: Scalars['numeric'];
  amountPaid: Scalars['numeric'];
  /** An array relationship */
  charges: Array<Charges>;
  /** An aggregate relationship */
  charges_aggregate: Charges_Aggregate;
  createdAt: Scalars['timestamptz'];
  externalInvoiceId: Scalars['String'];
  externalSubscriptionId: Scalars['String'];
  id: Scalars['uuid'];
  invoiceObject?: Maybe<Scalars['jsonb']>;
  paid: Scalars['Boolean'];
  periodEnd: Scalars['timestamptz'];
  periodStart: Scalars['timestamptz'];
  status?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  /** An object relationship */
  subscription: Subscriptions;
  subscriptionId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};


/** columns and relationships of "invoices" */
export type InvoicesChargesArgs = {
  distinct_on?: InputMaybe<Array<Charges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Charges_Order_By>>;
  where?: InputMaybe<Charges_Bool_Exp>;
};


/** columns and relationships of "invoices" */
export type InvoicesCharges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Charges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Charges_Order_By>>;
  where?: InputMaybe<Charges_Bool_Exp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoiceObjectArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "invoices" */
export type Invoices_Aggregate = {
  __typename?: 'invoices_aggregate';
  aggregate?: Maybe<Invoices_Aggregate_Fields>;
  nodes: Array<Invoices>;
};

export type Invoices_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Invoices_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Invoices_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Invoices_Aggregate_Bool_Exp_Count>;
};

export type Invoices_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoices_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoices_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoices_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoices_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoices_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoices" */
export type Invoices_Aggregate_Fields = {
  __typename?: 'invoices_aggregate_fields';
  avg?: Maybe<Invoices_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Invoices_Max_Fields>;
  min?: Maybe<Invoices_Min_Fields>;
  stddev?: Maybe<Invoices_Stddev_Fields>;
  stddev_pop?: Maybe<Invoices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoices_Stddev_Samp_Fields>;
  sum?: Maybe<Invoices_Sum_Fields>;
  var_pop?: Maybe<Invoices_Var_Pop_Fields>;
  var_samp?: Maybe<Invoices_Var_Samp_Fields>;
  variance?: Maybe<Invoices_Variance_Fields>;
};


/** aggregate fields of "invoices" */
export type Invoices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoices" */
export type Invoices_Aggregate_Order_By = {
  avg?: InputMaybe<Invoices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoices_Max_Order_By>;
  min?: InputMaybe<Invoices_Min_Order_By>;
  stddev?: InputMaybe<Invoices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoices_Sum_Order_By>;
  var_pop?: InputMaybe<Invoices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoices_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoices_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Invoices_Append_Input = {
  invoiceObject?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "invoices" */
export type Invoices_Arr_Rel_Insert_Input = {
  data: Array<Invoices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoices_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoices_Avg_Fields = {
  __typename?: 'invoices_avg_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoices" */
export type Invoices_Avg_Order_By = {
  amountDue?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoices". All fields are combined with a logical 'AND'. */
export type Invoices_Bool_Exp = {
  _and?: InputMaybe<Array<Invoices_Bool_Exp>>;
  _not?: InputMaybe<Invoices_Bool_Exp>;
  _or?: InputMaybe<Array<Invoices_Bool_Exp>>;
  amountDue?: InputMaybe<Numeric_Comparison_Exp>;
  amountPaid?: InputMaybe<Numeric_Comparison_Exp>;
  charges?: InputMaybe<Charges_Bool_Exp>;
  charges_aggregate?: InputMaybe<Charges_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  externalInvoiceId?: InputMaybe<String_Comparison_Exp>;
  externalSubscriptionId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiceObject?: InputMaybe<Jsonb_Comparison_Exp>;
  paid?: InputMaybe<Boolean_Comparison_Exp>;
  periodEnd?: InputMaybe<Timestamptz_Comparison_Exp>;
  periodStart?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  stripeCustomerId?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptionId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "invoices" */
export const Invoices_Constraint = {
  /** unique or primary key constraint on columns "externalInvoiceId" */
  InvoicesExternalInvoiceIdKey: 'invoices_externalInvoiceId_key',
  /** unique or primary key constraint on columns "id" */
  InvoicesPkey: 'invoices_pkey'
} as const;

export type Invoices_Constraint = typeof Invoices_Constraint[keyof typeof Invoices_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Invoices_Delete_At_Path_Input = {
  invoiceObject?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Invoices_Delete_Elem_Input = {
  invoiceObject?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Invoices_Delete_Key_Input = {
  invoiceObject?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "invoices" */
export type Invoices_Inc_Input = {
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "invoices" */
export type Invoices_Insert_Input = {
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  charges?: InputMaybe<Charges_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalInvoiceId?: InputMaybe<Scalars['String']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoiceObject?: InputMaybe<Scalars['jsonb']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  periodEnd?: InputMaybe<Scalars['timestamptz']>;
  periodStart?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Subscriptions_Obj_Rel_Insert_Input>;
  subscriptionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Invoices_Max_Fields = {
  __typename?: 'invoices_max_fields';
  amountDue?: Maybe<Scalars['numeric']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalInvoiceId?: Maybe<Scalars['String']>;
  externalSubscriptionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  periodEnd?: Maybe<Scalars['timestamptz']>;
  periodStart?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "invoices" */
export type Invoices_Max_Order_By = {
  amountDue?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  externalInvoiceId?: InputMaybe<Order_By>;
  externalSubscriptionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  periodEnd?: InputMaybe<Order_By>;
  periodStart?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  subscriptionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoices_Min_Fields = {
  __typename?: 'invoices_min_fields';
  amountDue?: Maybe<Scalars['numeric']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalInvoiceId?: Maybe<Scalars['String']>;
  externalSubscriptionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  periodEnd?: Maybe<Scalars['timestamptz']>;
  periodStart?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "invoices" */
export type Invoices_Min_Order_By = {
  amountDue?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  externalInvoiceId?: InputMaybe<Order_By>;
  externalSubscriptionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  periodEnd?: InputMaybe<Order_By>;
  periodStart?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  subscriptionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invoices" */
export type Invoices_Mutation_Response = {
  __typename?: 'invoices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoices>;
};

/** input type for inserting object relation for remote table "invoices" */
export type Invoices_Obj_Rel_Insert_Input = {
  data: Invoices_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoices_On_Conflict>;
};

/** on_conflict condition type for table "invoices" */
export type Invoices_On_Conflict = {
  constraint: Invoices_Constraint;
  update_columns?: Array<Invoices_Update_Column>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};

/** Ordering options when selecting data from "invoices". */
export type Invoices_Order_By = {
  amountDue?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  charges_aggregate?: InputMaybe<Charges_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  externalInvoiceId?: InputMaybe<Order_By>;
  externalSubscriptionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceObject?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  periodEnd?: InputMaybe<Order_By>;
  periodStart?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscriptionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invoices */
export type Invoices_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Invoices_Prepend_Input = {
  invoiceObject?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "invoices" */
export const Invoices_Select_Column = {
  /** column name */
  AmountDue: 'amountDue',
  /** column name */
  AmountPaid: 'amountPaid',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  ExternalInvoiceId: 'externalInvoiceId',
  /** column name */
  ExternalSubscriptionId: 'externalSubscriptionId',
  /** column name */
  Id: 'id',
  /** column name */
  InvoiceObject: 'invoiceObject',
  /** column name */
  Paid: 'paid',
  /** column name */
  PeriodEnd: 'periodEnd',
  /** column name */
  PeriodStart: 'periodStart',
  /** column name */
  Status: 'status',
  /** column name */
  StripeCustomerId: 'stripeCustomerId',
  /** column name */
  SubscriptionId: 'subscriptionId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Invoices_Select_Column = typeof Invoices_Select_Column[keyof typeof Invoices_Select_Column];
/** select "invoices_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invoices" */
export const Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  Paid: 'paid'
} as const;

export type Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "invoices_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invoices" */
export const Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  Paid: 'paid'
} as const;

export type Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "invoices" */
export type Invoices_Set_Input = {
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalInvoiceId?: InputMaybe<Scalars['String']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoiceObject?: InputMaybe<Scalars['jsonb']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  periodEnd?: InputMaybe<Scalars['timestamptz']>;
  periodStart?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Invoices_Stddev_Fields = {
  __typename?: 'invoices_stddev_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoices" */
export type Invoices_Stddev_Order_By = {
  amountDue?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoices_Stddev_Pop_Fields = {
  __typename?: 'invoices_stddev_pop_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "invoices" */
export type Invoices_Stddev_Pop_Order_By = {
  amountDue?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoices_Stddev_Samp_Fields = {
  __typename?: 'invoices_stddev_samp_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "invoices" */
export type Invoices_Stddev_Samp_Order_By = {
  amountDue?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoices" */
export type Invoices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoices_Stream_Cursor_Value_Input = {
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalInvoiceId?: InputMaybe<Scalars['String']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoiceObject?: InputMaybe<Scalars['jsonb']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  periodEnd?: InputMaybe<Scalars['timestamptz']>;
  periodStart?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Invoices_Sum_Fields = {
  __typename?: 'invoices_sum_fields';
  amountDue?: Maybe<Scalars['numeric']>;
  amountPaid?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "invoices" */
export type Invoices_Sum_Order_By = {
  amountDue?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
};

/** update columns of table "invoices" */
export const Invoices_Update_Column = {
  /** column name */
  AmountDue: 'amountDue',
  /** column name */
  AmountPaid: 'amountPaid',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  ExternalInvoiceId: 'externalInvoiceId',
  /** column name */
  ExternalSubscriptionId: 'externalSubscriptionId',
  /** column name */
  Id: 'id',
  /** column name */
  InvoiceObject: 'invoiceObject',
  /** column name */
  Paid: 'paid',
  /** column name */
  PeriodEnd: 'periodEnd',
  /** column name */
  PeriodStart: 'periodStart',
  /** column name */
  Status: 'status',
  /** column name */
  StripeCustomerId: 'stripeCustomerId',
  /** column name */
  SubscriptionId: 'subscriptionId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Invoices_Update_Column = typeof Invoices_Update_Column[keyof typeof Invoices_Update_Column];
export type Invoices_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Invoices_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Invoices_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Invoices_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Invoices_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invoices_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Invoices_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoices_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoices_Var_Pop_Fields = {
  __typename?: 'invoices_var_pop_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "invoices" */
export type Invoices_Var_Pop_Order_By = {
  amountDue?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoices_Var_Samp_Fields = {
  __typename?: 'invoices_var_samp_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "invoices" */
export type Invoices_Var_Samp_Order_By = {
  amountDue?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoices_Variance_Fields = {
  __typename?: 'invoices_variance_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoices" */
export type Invoices_Variance_Order_By = {
  amountDue?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "microsoft_access_tokens" */
export type Microsoft_Access_Tokens = {
  __typename?: 'microsoft_access_tokens';
  accessToken: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['Int'];
  idToken?: Maybe<Scalars['String']>;
  refreshToken: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "microsoft_access_tokens" */
export type Microsoft_Access_Tokens_Aggregate = {
  __typename?: 'microsoft_access_tokens_aggregate';
  aggregate?: Maybe<Microsoft_Access_Tokens_Aggregate_Fields>;
  nodes: Array<Microsoft_Access_Tokens>;
};

/** aggregate fields of "microsoft_access_tokens" */
export type Microsoft_Access_Tokens_Aggregate_Fields = {
  __typename?: 'microsoft_access_tokens_aggregate_fields';
  avg?: Maybe<Microsoft_Access_Tokens_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Microsoft_Access_Tokens_Max_Fields>;
  min?: Maybe<Microsoft_Access_Tokens_Min_Fields>;
  stddev?: Maybe<Microsoft_Access_Tokens_Stddev_Fields>;
  stddev_pop?: Maybe<Microsoft_Access_Tokens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Microsoft_Access_Tokens_Stddev_Samp_Fields>;
  sum?: Maybe<Microsoft_Access_Tokens_Sum_Fields>;
  var_pop?: Maybe<Microsoft_Access_Tokens_Var_Pop_Fields>;
  var_samp?: Maybe<Microsoft_Access_Tokens_Var_Samp_Fields>;
  variance?: Maybe<Microsoft_Access_Tokens_Variance_Fields>;
};


/** aggregate fields of "microsoft_access_tokens" */
export type Microsoft_Access_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Microsoft_Access_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Microsoft_Access_Tokens_Avg_Fields = {
  __typename?: 'microsoft_access_tokens_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "microsoft_access_tokens". All fields are combined with a logical 'AND'. */
export type Microsoft_Access_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Microsoft_Access_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Microsoft_Access_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Microsoft_Access_Tokens_Bool_Exp>>;
  accessToken?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  idToken?: InputMaybe<String_Comparison_Exp>;
  refreshToken?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "microsoft_access_tokens" */
export const Microsoft_Access_Tokens_Constraint = {
  /** unique or primary key constraint on columns "id" */
  MicrosoftAccessTokensPkey: 'microsoft_access_tokens_pkey'
} as const;

export type Microsoft_Access_Tokens_Constraint = typeof Microsoft_Access_Tokens_Constraint[keyof typeof Microsoft_Access_Tokens_Constraint];
/** input type for incrementing numeric columns in table "microsoft_access_tokens" */
export type Microsoft_Access_Tokens_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "microsoft_access_tokens" */
export type Microsoft_Access_Tokens_Insert_Input = {
  accessToken?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  idToken?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Microsoft_Access_Tokens_Max_Fields = {
  __typename?: 'microsoft_access_tokens_max_fields';
  accessToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  idToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Microsoft_Access_Tokens_Min_Fields = {
  __typename?: 'microsoft_access_tokens_min_fields';
  accessToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  idToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "microsoft_access_tokens" */
export type Microsoft_Access_Tokens_Mutation_Response = {
  __typename?: 'microsoft_access_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Microsoft_Access_Tokens>;
};

/** on_conflict condition type for table "microsoft_access_tokens" */
export type Microsoft_Access_Tokens_On_Conflict = {
  constraint: Microsoft_Access_Tokens_Constraint;
  update_columns?: Array<Microsoft_Access_Tokens_Update_Column>;
  where?: InputMaybe<Microsoft_Access_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "microsoft_access_tokens". */
export type Microsoft_Access_Tokens_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idToken?: InputMaybe<Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: microsoft_access_tokens */
export type Microsoft_Access_Tokens_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "microsoft_access_tokens" */
export const Microsoft_Access_Tokens_Select_Column = {
  /** column name */
  AccessToken: 'accessToken',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  IdToken: 'idToken',
  /** column name */
  RefreshToken: 'refreshToken',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Microsoft_Access_Tokens_Select_Column = typeof Microsoft_Access_Tokens_Select_Column[keyof typeof Microsoft_Access_Tokens_Select_Column];
/** input type for updating data in table "microsoft_access_tokens" */
export type Microsoft_Access_Tokens_Set_Input = {
  accessToken?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  idToken?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Microsoft_Access_Tokens_Stddev_Fields = {
  __typename?: 'microsoft_access_tokens_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Microsoft_Access_Tokens_Stddev_Pop_Fields = {
  __typename?: 'microsoft_access_tokens_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Microsoft_Access_Tokens_Stddev_Samp_Fields = {
  __typename?: 'microsoft_access_tokens_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "microsoft_access_tokens" */
export type Microsoft_Access_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Microsoft_Access_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Microsoft_Access_Tokens_Stream_Cursor_Value_Input = {
  accessToken?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  idToken?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Microsoft_Access_Tokens_Sum_Fields = {
  __typename?: 'microsoft_access_tokens_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "microsoft_access_tokens" */
export const Microsoft_Access_Tokens_Update_Column = {
  /** column name */
  AccessToken: 'accessToken',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  IdToken: 'idToken',
  /** column name */
  RefreshToken: 'refreshToken',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Microsoft_Access_Tokens_Update_Column = typeof Microsoft_Access_Tokens_Update_Column[keyof typeof Microsoft_Access_Tokens_Update_Column];
export type Microsoft_Access_Tokens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Microsoft_Access_Tokens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Microsoft_Access_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Microsoft_Access_Tokens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Microsoft_Access_Tokens_Var_Pop_Fields = {
  __typename?: 'microsoft_access_tokens_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Microsoft_Access_Tokens_Var_Samp_Fields = {
  __typename?: 'microsoft_access_tokens_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Microsoft_Access_Tokens_Variance_Fields = {
  __typename?: 'microsoft_access_tokens_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "most_researched_tickers_daily_total" */
export type Most_Researched_Tickers_Daily_Total = {
  __typename?: 'most_researched_tickers_daily_total';
  count?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "most_researched_tickers_daily_total" */
export type Most_Researched_Tickers_Daily_Total_Aggregate = {
  __typename?: 'most_researched_tickers_daily_total_aggregate';
  aggregate?: Maybe<Most_Researched_Tickers_Daily_Total_Aggregate_Fields>;
  nodes: Array<Most_Researched_Tickers_Daily_Total>;
};

/** aggregate fields of "most_researched_tickers_daily_total" */
export type Most_Researched_Tickers_Daily_Total_Aggregate_Fields = {
  __typename?: 'most_researched_tickers_daily_total_aggregate_fields';
  avg?: Maybe<Most_Researched_Tickers_Daily_Total_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Most_Researched_Tickers_Daily_Total_Max_Fields>;
  min?: Maybe<Most_Researched_Tickers_Daily_Total_Min_Fields>;
  stddev?: Maybe<Most_Researched_Tickers_Daily_Total_Stddev_Fields>;
  stddev_pop?: Maybe<Most_Researched_Tickers_Daily_Total_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Most_Researched_Tickers_Daily_Total_Stddev_Samp_Fields>;
  sum?: Maybe<Most_Researched_Tickers_Daily_Total_Sum_Fields>;
  var_pop?: Maybe<Most_Researched_Tickers_Daily_Total_Var_Pop_Fields>;
  var_samp?: Maybe<Most_Researched_Tickers_Daily_Total_Var_Samp_Fields>;
  variance?: Maybe<Most_Researched_Tickers_Daily_Total_Variance_Fields>;
};


/** aggregate fields of "most_researched_tickers_daily_total" */
export type Most_Researched_Tickers_Daily_Total_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Most_Researched_Tickers_Daily_Total_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Most_Researched_Tickers_Daily_Total_Avg_Fields = {
  __typename?: 'most_researched_tickers_daily_total_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "most_researched_tickers_daily_total". All fields are combined with a logical 'AND'. */
export type Most_Researched_Tickers_Daily_Total_Bool_Exp = {
  _and?: InputMaybe<Array<Most_Researched_Tickers_Daily_Total_Bool_Exp>>;
  _not?: InputMaybe<Most_Researched_Tickers_Daily_Total_Bool_Exp>;
  _or?: InputMaybe<Array<Most_Researched_Tickers_Daily_Total_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Most_Researched_Tickers_Daily_Total_Max_Fields = {
  __typename?: 'most_researched_tickers_daily_total_max_fields';
  count?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Most_Researched_Tickers_Daily_Total_Min_Fields = {
  __typename?: 'most_researched_tickers_daily_total_min_fields';
  count?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "most_researched_tickers_daily_total". */
export type Most_Researched_Tickers_Daily_Total_Order_By = {
  count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "most_researched_tickers_daily_total" */
export const Most_Researched_Tickers_Daily_Total_Select_Column = {
  /** column name */
  Count: 'count',
  /** column name */
  Id: 'id'
} as const;

export type Most_Researched_Tickers_Daily_Total_Select_Column = typeof Most_Researched_Tickers_Daily_Total_Select_Column[keyof typeof Most_Researched_Tickers_Daily_Total_Select_Column];
/** aggregate stddev on columns */
export type Most_Researched_Tickers_Daily_Total_Stddev_Fields = {
  __typename?: 'most_researched_tickers_daily_total_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Most_Researched_Tickers_Daily_Total_Stddev_Pop_Fields = {
  __typename?: 'most_researched_tickers_daily_total_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Most_Researched_Tickers_Daily_Total_Stddev_Samp_Fields = {
  __typename?: 'most_researched_tickers_daily_total_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "most_researched_tickers_daily_total" */
export type Most_Researched_Tickers_Daily_Total_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Most_Researched_Tickers_Daily_Total_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Most_Researched_Tickers_Daily_Total_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Most_Researched_Tickers_Daily_Total_Sum_Fields = {
  __typename?: 'most_researched_tickers_daily_total_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Most_Researched_Tickers_Daily_Total_Var_Pop_Fields = {
  __typename?: 'most_researched_tickers_daily_total_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Most_Researched_Tickers_Daily_Total_Var_Samp_Fields = {
  __typename?: 'most_researched_tickers_daily_total_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Most_Researched_Tickers_Daily_Total_Variance_Fields = {
  __typename?: 'most_researched_tickers_daily_total_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "most_researched_tickers_daily_unique" */
export type Most_Researched_Tickers_Daily_Unique = {
  __typename?: 'most_researched_tickers_daily_unique';
  count?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "most_researched_tickers_daily_unique" */
export type Most_Researched_Tickers_Daily_Unique_Aggregate = {
  __typename?: 'most_researched_tickers_daily_unique_aggregate';
  aggregate?: Maybe<Most_Researched_Tickers_Daily_Unique_Aggregate_Fields>;
  nodes: Array<Most_Researched_Tickers_Daily_Unique>;
};

/** aggregate fields of "most_researched_tickers_daily_unique" */
export type Most_Researched_Tickers_Daily_Unique_Aggregate_Fields = {
  __typename?: 'most_researched_tickers_daily_unique_aggregate_fields';
  avg?: Maybe<Most_Researched_Tickers_Daily_Unique_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Most_Researched_Tickers_Daily_Unique_Max_Fields>;
  min?: Maybe<Most_Researched_Tickers_Daily_Unique_Min_Fields>;
  stddev?: Maybe<Most_Researched_Tickers_Daily_Unique_Stddev_Fields>;
  stddev_pop?: Maybe<Most_Researched_Tickers_Daily_Unique_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Most_Researched_Tickers_Daily_Unique_Stddev_Samp_Fields>;
  sum?: Maybe<Most_Researched_Tickers_Daily_Unique_Sum_Fields>;
  var_pop?: Maybe<Most_Researched_Tickers_Daily_Unique_Var_Pop_Fields>;
  var_samp?: Maybe<Most_Researched_Tickers_Daily_Unique_Var_Samp_Fields>;
  variance?: Maybe<Most_Researched_Tickers_Daily_Unique_Variance_Fields>;
};


/** aggregate fields of "most_researched_tickers_daily_unique" */
export type Most_Researched_Tickers_Daily_Unique_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Most_Researched_Tickers_Daily_Unique_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Most_Researched_Tickers_Daily_Unique_Avg_Fields = {
  __typename?: 'most_researched_tickers_daily_unique_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "most_researched_tickers_daily_unique". All fields are combined with a logical 'AND'. */
export type Most_Researched_Tickers_Daily_Unique_Bool_Exp = {
  _and?: InputMaybe<Array<Most_Researched_Tickers_Daily_Unique_Bool_Exp>>;
  _not?: InputMaybe<Most_Researched_Tickers_Daily_Unique_Bool_Exp>;
  _or?: InputMaybe<Array<Most_Researched_Tickers_Daily_Unique_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Most_Researched_Tickers_Daily_Unique_Max_Fields = {
  __typename?: 'most_researched_tickers_daily_unique_max_fields';
  count?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Most_Researched_Tickers_Daily_Unique_Min_Fields = {
  __typename?: 'most_researched_tickers_daily_unique_min_fields';
  count?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "most_researched_tickers_daily_unique". */
export type Most_Researched_Tickers_Daily_Unique_Order_By = {
  count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "most_researched_tickers_daily_unique" */
export const Most_Researched_Tickers_Daily_Unique_Select_Column = {
  /** column name */
  Count: 'count',
  /** column name */
  Id: 'id'
} as const;

export type Most_Researched_Tickers_Daily_Unique_Select_Column = typeof Most_Researched_Tickers_Daily_Unique_Select_Column[keyof typeof Most_Researched_Tickers_Daily_Unique_Select_Column];
/** aggregate stddev on columns */
export type Most_Researched_Tickers_Daily_Unique_Stddev_Fields = {
  __typename?: 'most_researched_tickers_daily_unique_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Most_Researched_Tickers_Daily_Unique_Stddev_Pop_Fields = {
  __typename?: 'most_researched_tickers_daily_unique_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Most_Researched_Tickers_Daily_Unique_Stddev_Samp_Fields = {
  __typename?: 'most_researched_tickers_daily_unique_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "most_researched_tickers_daily_unique" */
export type Most_Researched_Tickers_Daily_Unique_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Most_Researched_Tickers_Daily_Unique_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Most_Researched_Tickers_Daily_Unique_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Most_Researched_Tickers_Daily_Unique_Sum_Fields = {
  __typename?: 'most_researched_tickers_daily_unique_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Most_Researched_Tickers_Daily_Unique_Var_Pop_Fields = {
  __typename?: 'most_researched_tickers_daily_unique_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Most_Researched_Tickers_Daily_Unique_Var_Samp_Fields = {
  __typename?: 'most_researched_tickers_daily_unique_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Most_Researched_Tickers_Daily_Unique_Variance_Fields = {
  __typename?: 'most_researched_tickers_daily_unique_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "affiliate_link_clicks" */
  delete_affiliate_link_clicks?: Maybe<Affiliate_Link_Clicks_Mutation_Response>;
  /** delete single row from the table: "affiliate_link_clicks" */
  delete_affiliate_link_clicks_by_pk?: Maybe<Affiliate_Link_Clicks>;
  /** delete data from the table: "affiliate_payouts" */
  delete_affiliate_payouts?: Maybe<Affiliate_Payouts_Mutation_Response>;
  /** delete single row from the table: "affiliate_payouts" */
  delete_affiliate_payouts_by_pk?: Maybe<Affiliate_Payouts>;
  /** delete data from the table: "asset_signal_alerts" */
  delete_asset_signal_alerts?: Maybe<Asset_Signal_Alerts_Mutation_Response>;
  /** delete single row from the table: "asset_signal_alerts" */
  delete_asset_signal_alerts_by_pk?: Maybe<Asset_Signal_Alerts>;
  /** delete data from the table: "charges" */
  delete_charges?: Maybe<Charges_Mutation_Response>;
  /** delete single row from the table: "charges" */
  delete_charges_by_pk?: Maybe<Charges>;
  /** delete data from the table: "congress_trades" */
  delete_congress_trades?: Maybe<Congress_Trades_Mutation_Response>;
  /** delete single row from the table: "congress_trades" */
  delete_congress_trades_by_pk?: Maybe<Congress_Trades>;
  /** delete data from the table: "cookie_strings" */
  delete_cookie_strings?: Maybe<Cookie_Strings_Mutation_Response>;
  /** delete single row from the table: "cookie_strings" */
  delete_cookie_strings_by_pk?: Maybe<Cookie_Strings>;
  /** delete data from the table: "course_progress" */
  delete_course_progress?: Maybe<Course_Progress_Mutation_Response>;
  /** delete single row from the table: "course_progress" */
  delete_course_progress_by_pk?: Maybe<Course_Progress>;
  /** delete data from the table: "course_progress_status" */
  delete_course_progress_status?: Maybe<Course_Progress_Status_Mutation_Response>;
  /** delete single row from the table: "course_progress_status" */
  delete_course_progress_status_by_pk?: Maybe<Course_Progress_Status>;
  /** delete data from the table: "demo_filtered_trades_spiderrock" */
  delete_demo_filtered_trades_spiderrock?: Maybe<Demo_Filtered_Trades_Spiderrock_Mutation_Response>;
  /** delete single row from the table: "demo_filtered_trades_spiderrock" */
  delete_demo_filtered_trades_spiderrock_by_pk?: Maybe<Demo_Filtered_Trades_Spiderrock>;
  /** delete data from the table: "demo_raw_trades_spiderrock" */
  delete_demo_raw_trades_spiderrock?: Maybe<Demo_Raw_Trades_Spiderrock_Mutation_Response>;
  /** delete single row from the table: "demo_raw_trades_spiderrock" */
  delete_demo_raw_trades_spiderrock_by_pk?: Maybe<Demo_Raw_Trades_Spiderrock>;
  /** delete data from the table: "earnings_snp" */
  delete_earnings_snp?: Maybe<Earnings_Snp_Mutation_Response>;
  /** delete single row from the table: "earnings_snp" */
  delete_earnings_snp_by_pk?: Maybe<Earnings_Snp>;
  /** delete data from the table: "email_alerts" */
  delete_email_alerts?: Maybe<Email_Alerts_Mutation_Response>;
  /** delete single row from the table: "email_alerts" */
  delete_email_alerts_by_pk?: Maybe<Email_Alerts>;
  /** delete data from the table: "email_list" */
  delete_email_list?: Maybe<Email_List_Mutation_Response>;
  /** delete single row from the table: "email_list" */
  delete_email_list_by_pk?: Maybe<Email_List>;
  /** delete data from the table: "equities_eod" */
  delete_equities_eod?: Maybe<Equities_Eod_Mutation_Response>;
  /** delete single row from the table: "equities_eod" */
  delete_equities_eod_by_pk?: Maybe<Equities_Eod>;
  /** delete data from the table: "equity_pool_prints" */
  delete_equity_pool_prints?: Maybe<Equity_Pool_Prints_Mutation_Response>;
  /** delete single row from the table: "equity_pool_prints" */
  delete_equity_pool_prints_by_pk?: Maybe<Equity_Pool_Prints>;
  /** delete data from the table: "equity_print_feed_baseline" */
  delete_equity_print_feed_baseline?: Maybe<Equity_Print_Feed_Baseline_Mutation_Response>;
  /** delete single row from the table: "equity_print_feed_baseline" */
  delete_equity_print_feed_baseline_by_pk?: Maybe<Equity_Print_Feed_Baseline>;
  /** delete data from the table: "equity_print_feed_filtered" */
  delete_equity_print_feed_filtered?: Maybe<Equity_Print_Feed_Filtered_Mutation_Response>;
  /** delete single row from the table: "equity_print_feed_filtered" */
  delete_equity_print_feed_filtered_by_pk?: Maybe<Equity_Print_Feed_Filtered>;
  /** delete data from the table: "fa_trade_uploads" */
  delete_fa_trade_uploads?: Maybe<Fa_Trade_Uploads_Mutation_Response>;
  /** delete single row from the table: "fa_trade_uploads" */
  delete_fa_trade_uploads_by_pk?: Maybe<Fa_Trade_Uploads>;
  /** delete data from the table: "fa_trades" */
  delete_fa_trades?: Maybe<Fa_Trades_Mutation_Response>;
  /** delete single row from the table: "fa_trades" */
  delete_fa_trades_by_pk?: Maybe<Fa_Trades>;
  /** delete data from the table: "feedback_boards" */
  delete_feedback_boards?: Maybe<Feedback_Boards_Mutation_Response>;
  /** delete single row from the table: "feedback_boards" */
  delete_feedback_boards_by_pk?: Maybe<Feedback_Boards>;
  /** delete data from the table: "feedback_comments" */
  delete_feedback_comments?: Maybe<Feedback_Comments_Mutation_Response>;
  /** delete single row from the table: "feedback_comments" */
  delete_feedback_comments_by_pk?: Maybe<Feedback_Comments>;
  /** delete data from the table: "feedback_media" */
  delete_feedback_media?: Maybe<Feedback_Media_Mutation_Response>;
  /** delete single row from the table: "feedback_media" */
  delete_feedback_media_by_pk?: Maybe<Feedback_Media>;
  /** delete data from the table: "feedback_post_contexts" */
  delete_feedback_post_contexts?: Maybe<Feedback_Post_Contexts_Mutation_Response>;
  /** delete single row from the table: "feedback_post_contexts" */
  delete_feedback_post_contexts_by_pk?: Maybe<Feedback_Post_Contexts>;
  /** delete data from the table: "feedback_post_merges" */
  delete_feedback_post_merges?: Maybe<Feedback_Post_Merges_Mutation_Response>;
  /** delete single row from the table: "feedback_post_merges" */
  delete_feedback_post_merges_by_pk?: Maybe<Feedback_Post_Merges>;
  /** delete data from the table: "feedback_posts" */
  delete_feedback_posts?: Maybe<Feedback_Posts_Mutation_Response>;
  /** delete single row from the table: "feedback_posts" */
  delete_feedback_posts_by_pk?: Maybe<Feedback_Posts>;
  /** delete data from the table: "feedback_posts_with_counts" */
  delete_feedback_posts_with_counts?: Maybe<Feedback_Posts_With_Counts_Mutation_Response>;
  /** delete data from the table: "feedback_release_posts" */
  delete_feedback_release_posts?: Maybe<Feedback_Release_Posts_Mutation_Response>;
  /** delete single row from the table: "feedback_release_posts" */
  delete_feedback_release_posts_by_pk?: Maybe<Feedback_Release_Posts>;
  /** delete data from the table: "feedback_releases" */
  delete_feedback_releases?: Maybe<Feedback_Releases_Mutation_Response>;
  /** delete single row from the table: "feedback_releases" */
  delete_feedback_releases_by_pk?: Maybe<Feedback_Releases>;
  /** delete data from the table: "feedback_statuses" */
  delete_feedback_statuses?: Maybe<Feedback_Statuses_Mutation_Response>;
  /** delete single row from the table: "feedback_statuses" */
  delete_feedback_statuses_by_pk?: Maybe<Feedback_Statuses>;
  /** delete data from the table: "feedback_votes" */
  delete_feedback_votes?: Maybe<Feedback_Votes_Mutation_Response>;
  /** delete single row from the table: "feedback_votes" */
  delete_feedback_votes_by_pk?: Maybe<Feedback_Votes>;
  /** delete data from the table: "flow_configurations" */
  delete_flow_configurations?: Maybe<Flow_Configurations_Mutation_Response>;
  /** delete single row from the table: "flow_configurations" */
  delete_flow_configurations_by_pk?: Maybe<Flow_Configurations>;
  /** delete data from the table: "full_feed_option_flow" */
  delete_full_feed_option_flow?: Maybe<Full_Feed_Option_Flow_Mutation_Response>;
  /** delete data from the table: "health_checks" */
  delete_health_checks?: Maybe<Health_Checks_Mutation_Response>;
  /** delete single row from the table: "health_checks" */
  delete_health_checks_by_pk?: Maybe<Health_Checks>;
  /** delete data from the table: "insider_trades" */
  delete_insider_trades?: Maybe<Insider_Trades_Mutation_Response>;
  /** delete single row from the table: "insider_trades" */
  delete_insider_trades_by_pk?: Maybe<Insider_Trades>;
  /** delete data from the table: "invoices" */
  delete_invoices?: Maybe<Invoices_Mutation_Response>;
  /** delete single row from the table: "invoices" */
  delete_invoices_by_pk?: Maybe<Invoices>;
  /** delete data from the table: "microsoft_access_tokens" */
  delete_microsoft_access_tokens?: Maybe<Microsoft_Access_Tokens_Mutation_Response>;
  /** delete single row from the table: "microsoft_access_tokens" */
  delete_microsoft_access_tokens_by_pk?: Maybe<Microsoft_Access_Tokens>;
  /** delete data from the table: "news_cache_stocks" */
  delete_news_cache_stocks?: Maybe<News_Cache_Stocks_Mutation_Response>;
  /** delete single row from the table: "news_cache_stocks" */
  delete_news_cache_stocks_by_pk?: Maybe<News_Cache_Stocks>;
  /** delete data from the table: "newsletter_payloads" */
  delete_newsletter_payloads?: Maybe<Newsletter_Payloads_Mutation_Response>;
  /** delete single row from the table: "newsletter_payloads" */
  delete_newsletter_payloads_by_pk?: Maybe<Newsletter_Payloads>;
  /** delete data from the table: "opc_saved_strategies" */
  delete_opc_saved_strategies?: Maybe<Opc_Saved_Strategies_Mutation_Response>;
  /** delete single row from the table: "opc_saved_strategies" */
  delete_opc_saved_strategies_by_pk?: Maybe<Opc_Saved_Strategies>;
  /** delete data from the table: "opc_saved_strategy_positions" */
  delete_opc_saved_strategy_positions?: Maybe<Opc_Saved_Strategy_Positions_Mutation_Response>;
  /** delete single row from the table: "opc_saved_strategy_positions" */
  delete_opc_saved_strategy_positions_by_pk?: Maybe<Opc_Saved_Strategy_Positions>;
  /** delete data from the table: "option_feed_baseline" */
  delete_option_feed_baseline?: Maybe<Option_Feed_Baseline_Mutation_Response>;
  /** delete single row from the table: "option_feed_baseline" */
  delete_option_feed_baseline_by_pk?: Maybe<Option_Feed_Baseline>;
  /** delete data from the table: "option_feed_filtered" */
  delete_option_feed_filtered?: Maybe<Option_Feed_Filtered_Mutation_Response>;
  /** delete single row from the table: "option_feed_filtered" */
  delete_option_feed_filtered_by_pk?: Maybe<Option_Feed_Filtered>;
  /** delete data from the table: "options_eod" */
  delete_options_eod?: Maybe<Options_Eod_Mutation_Response>;
  /** delete single row from the table: "options_eod" */
  delete_options_eod_by_pk?: Maybe<Options_Eod>;
  /** delete data from the table: "prelaunch_email_list" */
  delete_prelaunch_email_list?: Maybe<Prelaunch_Email_List_Mutation_Response>;
  /** delete single row from the table: "prelaunch_email_list" */
  delete_prelaunch_email_list_by_pk?: Maybe<Prelaunch_Email_List>;
  /** delete data from the table: "ready_check" */
  delete_ready_check?: Maybe<Ready_Check_Mutation_Response>;
  /** delete single row from the table: "ready_check" */
  delete_ready_check_by_pk?: Maybe<Ready_Check>;
  /** delete data from the table: "retention_feedback" */
  delete_retention_feedback?: Maybe<Retention_Feedback_Mutation_Response>;
  /** delete single row from the table: "retention_feedback" */
  delete_retention_feedback_by_pk?: Maybe<Retention_Feedback>;
  /** delete data from the table: "retention_intervention_events" */
  delete_retention_intervention_events?: Maybe<Retention_Intervention_Events_Mutation_Response>;
  /** delete single row from the table: "retention_intervention_events" */
  delete_retention_intervention_events_by_pk?: Maybe<Retention_Intervention_Events>;
  /** delete data from the table: "retention_intervention_sessions" */
  delete_retention_intervention_sessions?: Maybe<Retention_Intervention_Sessions_Mutation_Response>;
  /** delete single row from the table: "retention_intervention_sessions" */
  delete_retention_intervention_sessions_by_pk?: Maybe<Retention_Intervention_Sessions>;
  /** delete data from the table: "retention_notification_deliveries" */
  delete_retention_notification_deliveries?: Maybe<Retention_Notification_Deliveries_Mutation_Response>;
  /** delete single row from the table: "retention_notification_deliveries" */
  delete_retention_notification_deliveries_by_pk?: Maybe<Retention_Notification_Deliveries>;
  /** delete data from the table: "retention_offer_exposures" */
  delete_retention_offer_exposures?: Maybe<Retention_Offer_Exposures_Mutation_Response>;
  /** delete single row from the table: "retention_offer_exposures" */
  delete_retention_offer_exposures_by_pk?: Maybe<Retention_Offer_Exposures>;
  /** delete data from the table: "sales" */
  delete_sales?: Maybe<Sales_Mutation_Response>;
  /** delete single row from the table: "sales" */
  delete_sales_by_pk?: Maybe<Sales>;
  /** delete data from the table: "subscription_entitlements" */
  delete_subscription_entitlements?: Maybe<Subscription_Entitlements_Mutation_Response>;
  /** delete single row from the table: "subscription_entitlements" */
  delete_subscription_entitlements_by_pk?: Maybe<Subscription_Entitlements>;
  /** delete data from the table: "subscriptions" */
  delete_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** delete single row from the table: "subscriptions" */
  delete_subscriptions_by_pk?: Maybe<Subscriptions>;
  /** delete data from the table: "test_oct2023" */
  delete_test_oct2023?: Maybe<Test_Oct2023_Mutation_Response>;
  /** delete single row from the table: "test_oct2023" */
  delete_test_oct2023_by_pk?: Maybe<Test_Oct2023>;
  /** delete data from the table: "ticker_details" */
  delete_ticker_details?: Maybe<Ticker_Details_Mutation_Response>;
  /** delete single row from the table: "ticker_details" */
  delete_ticker_details_by_pk?: Maybe<Ticker_Details>;
  /** delete data from the table: "ticker_research_all_views" */
  delete_ticker_research_all_views?: Maybe<Ticker_Research_All_Views_Mutation_Response>;
  /** delete single row from the table: "ticker_research_all_views" */
  delete_ticker_research_all_views_by_pk?: Maybe<Ticker_Research_All_Views>;
  /** delete data from the table: "ticker_research_daily_views" */
  delete_ticker_research_daily_views?: Maybe<Ticker_Research_Daily_Views_Mutation_Response>;
  /** delete single row from the table: "ticker_research_daily_views" */
  delete_ticker_research_daily_views_by_pk?: Maybe<Ticker_Research_Daily_Views>;
  /** delete data from the table: "timezone_location" */
  delete_timezone_location?: Maybe<Timezone_Location_Mutation_Response>;
  /** delete single row from the table: "timezone_location" */
  delete_timezone_location_by_pk?: Maybe<Timezone_Location>;
  /** delete data from the table: "top_tickers" */
  delete_top_tickers?: Maybe<Top_Tickers_Mutation_Response>;
  /** delete single row from the table: "top_tickers" */
  delete_top_tickers_by_pk?: Maybe<Top_Tickers>;
  /** delete data from the table: "usage_ping" */
  delete_usage_ping?: Maybe<Usage_Ping_Mutation_Response>;
  /** delete single row from the table: "usage_ping" */
  delete_usage_ping_by_pk?: Maybe<Usage_Ping>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "watch_list" */
  delete_watch_list?: Maybe<Watch_List_Mutation_Response>;
  /** delete single row from the table: "watch_list" */
  delete_watch_list_by_pk?: Maybe<Watch_List>;
  /** insert data into the table: "affiliate_link_clicks" */
  insert_affiliate_link_clicks?: Maybe<Affiliate_Link_Clicks_Mutation_Response>;
  /** insert a single row into the table: "affiliate_link_clicks" */
  insert_affiliate_link_clicks_one?: Maybe<Affiliate_Link_Clicks>;
  /** insert data into the table: "affiliate_payouts" */
  insert_affiliate_payouts?: Maybe<Affiliate_Payouts_Mutation_Response>;
  /** insert a single row into the table: "affiliate_payouts" */
  insert_affiliate_payouts_one?: Maybe<Affiliate_Payouts>;
  /** insert data into the table: "asset_signal_alerts" */
  insert_asset_signal_alerts?: Maybe<Asset_Signal_Alerts_Mutation_Response>;
  /** insert a single row into the table: "asset_signal_alerts" */
  insert_asset_signal_alerts_one?: Maybe<Asset_Signal_Alerts>;
  /** insert data into the table: "charges" */
  insert_charges?: Maybe<Charges_Mutation_Response>;
  /** insert a single row into the table: "charges" */
  insert_charges_one?: Maybe<Charges>;
  /** insert data into the table: "congress_trades" */
  insert_congress_trades?: Maybe<Congress_Trades_Mutation_Response>;
  /** insert a single row into the table: "congress_trades" */
  insert_congress_trades_one?: Maybe<Congress_Trades>;
  /** insert data into the table: "cookie_strings" */
  insert_cookie_strings?: Maybe<Cookie_Strings_Mutation_Response>;
  /** insert a single row into the table: "cookie_strings" */
  insert_cookie_strings_one?: Maybe<Cookie_Strings>;
  /** insert data into the table: "course_progress" */
  insert_course_progress?: Maybe<Course_Progress_Mutation_Response>;
  /** insert a single row into the table: "course_progress" */
  insert_course_progress_one?: Maybe<Course_Progress>;
  /** insert data into the table: "course_progress_status" */
  insert_course_progress_status?: Maybe<Course_Progress_Status_Mutation_Response>;
  /** insert a single row into the table: "course_progress_status" */
  insert_course_progress_status_one?: Maybe<Course_Progress_Status>;
  /** insert data into the table: "demo_filtered_trades_spiderrock" */
  insert_demo_filtered_trades_spiderrock?: Maybe<Demo_Filtered_Trades_Spiderrock_Mutation_Response>;
  /** insert a single row into the table: "demo_filtered_trades_spiderrock" */
  insert_demo_filtered_trades_spiderrock_one?: Maybe<Demo_Filtered_Trades_Spiderrock>;
  /** insert data into the table: "demo_raw_trades_spiderrock" */
  insert_demo_raw_trades_spiderrock?: Maybe<Demo_Raw_Trades_Spiderrock_Mutation_Response>;
  /** insert a single row into the table: "demo_raw_trades_spiderrock" */
  insert_demo_raw_trades_spiderrock_one?: Maybe<Demo_Raw_Trades_Spiderrock>;
  /** insert data into the table: "earnings_snp" */
  insert_earnings_snp?: Maybe<Earnings_Snp_Mutation_Response>;
  /** insert a single row into the table: "earnings_snp" */
  insert_earnings_snp_one?: Maybe<Earnings_Snp>;
  /** insert data into the table: "email_alerts" */
  insert_email_alerts?: Maybe<Email_Alerts_Mutation_Response>;
  /** insert a single row into the table: "email_alerts" */
  insert_email_alerts_one?: Maybe<Email_Alerts>;
  /** insert data into the table: "email_list" */
  insert_email_list?: Maybe<Email_List_Mutation_Response>;
  /** insert a single row into the table: "email_list" */
  insert_email_list_one?: Maybe<Email_List>;
  /** insert data into the table: "equities_eod" */
  insert_equities_eod?: Maybe<Equities_Eod_Mutation_Response>;
  /** insert a single row into the table: "equities_eod" */
  insert_equities_eod_one?: Maybe<Equities_Eod>;
  /** insert data into the table: "equity_pool_prints" */
  insert_equity_pool_prints?: Maybe<Equity_Pool_Prints_Mutation_Response>;
  /** insert a single row into the table: "equity_pool_prints" */
  insert_equity_pool_prints_one?: Maybe<Equity_Pool_Prints>;
  /** insert data into the table: "equity_print_feed_baseline" */
  insert_equity_print_feed_baseline?: Maybe<Equity_Print_Feed_Baseline_Mutation_Response>;
  /** insert a single row into the table: "equity_print_feed_baseline" */
  insert_equity_print_feed_baseline_one?: Maybe<Equity_Print_Feed_Baseline>;
  /** insert data into the table: "equity_print_feed_filtered" */
  insert_equity_print_feed_filtered?: Maybe<Equity_Print_Feed_Filtered_Mutation_Response>;
  /** insert a single row into the table: "equity_print_feed_filtered" */
  insert_equity_print_feed_filtered_one?: Maybe<Equity_Print_Feed_Filtered>;
  /** insert data into the table: "fa_trade_uploads" */
  insert_fa_trade_uploads?: Maybe<Fa_Trade_Uploads_Mutation_Response>;
  /** insert a single row into the table: "fa_trade_uploads" */
  insert_fa_trade_uploads_one?: Maybe<Fa_Trade_Uploads>;
  /** insert data into the table: "fa_trades" */
  insert_fa_trades?: Maybe<Fa_Trades_Mutation_Response>;
  /** insert a single row into the table: "fa_trades" */
  insert_fa_trades_one?: Maybe<Fa_Trades>;
  /** insert data into the table: "feedback_boards" */
  insert_feedback_boards?: Maybe<Feedback_Boards_Mutation_Response>;
  /** insert a single row into the table: "feedback_boards" */
  insert_feedback_boards_one?: Maybe<Feedback_Boards>;
  /** insert data into the table: "feedback_comments" */
  insert_feedback_comments?: Maybe<Feedback_Comments_Mutation_Response>;
  /** insert a single row into the table: "feedback_comments" */
  insert_feedback_comments_one?: Maybe<Feedback_Comments>;
  /** insert data into the table: "feedback_media" */
  insert_feedback_media?: Maybe<Feedback_Media_Mutation_Response>;
  /** insert a single row into the table: "feedback_media" */
  insert_feedback_media_one?: Maybe<Feedback_Media>;
  /** insert data into the table: "feedback_post_contexts" */
  insert_feedback_post_contexts?: Maybe<Feedback_Post_Contexts_Mutation_Response>;
  /** insert a single row into the table: "feedback_post_contexts" */
  insert_feedback_post_contexts_one?: Maybe<Feedback_Post_Contexts>;
  /** insert data into the table: "feedback_post_merges" */
  insert_feedback_post_merges?: Maybe<Feedback_Post_Merges_Mutation_Response>;
  /** insert a single row into the table: "feedback_post_merges" */
  insert_feedback_post_merges_one?: Maybe<Feedback_Post_Merges>;
  /** insert data into the table: "feedback_posts" */
  insert_feedback_posts?: Maybe<Feedback_Posts_Mutation_Response>;
  /** insert a single row into the table: "feedback_posts" */
  insert_feedback_posts_one?: Maybe<Feedback_Posts>;
  /** insert data into the table: "feedback_posts_with_counts" */
  insert_feedback_posts_with_counts?: Maybe<Feedback_Posts_With_Counts_Mutation_Response>;
  /** insert a single row into the table: "feedback_posts_with_counts" */
  insert_feedback_posts_with_counts_one?: Maybe<Feedback_Posts_With_Counts>;
  /** insert data into the table: "feedback_release_posts" */
  insert_feedback_release_posts?: Maybe<Feedback_Release_Posts_Mutation_Response>;
  /** insert a single row into the table: "feedback_release_posts" */
  insert_feedback_release_posts_one?: Maybe<Feedback_Release_Posts>;
  /** insert data into the table: "feedback_releases" */
  insert_feedback_releases?: Maybe<Feedback_Releases_Mutation_Response>;
  /** insert a single row into the table: "feedback_releases" */
  insert_feedback_releases_one?: Maybe<Feedback_Releases>;
  /** insert data into the table: "feedback_statuses" */
  insert_feedback_statuses?: Maybe<Feedback_Statuses_Mutation_Response>;
  /** insert a single row into the table: "feedback_statuses" */
  insert_feedback_statuses_one?: Maybe<Feedback_Statuses>;
  /** insert data into the table: "feedback_votes" */
  insert_feedback_votes?: Maybe<Feedback_Votes_Mutation_Response>;
  /** insert a single row into the table: "feedback_votes" */
  insert_feedback_votes_one?: Maybe<Feedback_Votes>;
  /** insert data into the table: "flow_configurations" */
  insert_flow_configurations?: Maybe<Flow_Configurations_Mutation_Response>;
  /** insert a single row into the table: "flow_configurations" */
  insert_flow_configurations_one?: Maybe<Flow_Configurations>;
  /** insert data into the table: "full_feed_option_flow" */
  insert_full_feed_option_flow?: Maybe<Full_Feed_Option_Flow_Mutation_Response>;
  /** insert a single row into the table: "full_feed_option_flow" */
  insert_full_feed_option_flow_one?: Maybe<Full_Feed_Option_Flow>;
  /** insert data into the table: "health_checks" */
  insert_health_checks?: Maybe<Health_Checks_Mutation_Response>;
  /** insert a single row into the table: "health_checks" */
  insert_health_checks_one?: Maybe<Health_Checks>;
  /** insert data into the table: "insider_trades" */
  insert_insider_trades?: Maybe<Insider_Trades_Mutation_Response>;
  /** insert a single row into the table: "insider_trades" */
  insert_insider_trades_one?: Maybe<Insider_Trades>;
  /** insert data into the table: "invoices" */
  insert_invoices?: Maybe<Invoices_Mutation_Response>;
  /** insert a single row into the table: "invoices" */
  insert_invoices_one?: Maybe<Invoices>;
  /** insert data into the table: "microsoft_access_tokens" */
  insert_microsoft_access_tokens?: Maybe<Microsoft_Access_Tokens_Mutation_Response>;
  /** insert a single row into the table: "microsoft_access_tokens" */
  insert_microsoft_access_tokens_one?: Maybe<Microsoft_Access_Tokens>;
  /** insert data into the table: "news_cache_stocks" */
  insert_news_cache_stocks?: Maybe<News_Cache_Stocks_Mutation_Response>;
  /** insert a single row into the table: "news_cache_stocks" */
  insert_news_cache_stocks_one?: Maybe<News_Cache_Stocks>;
  /** insert data into the table: "newsletter_payloads" */
  insert_newsletter_payloads?: Maybe<Newsletter_Payloads_Mutation_Response>;
  /** insert a single row into the table: "newsletter_payloads" */
  insert_newsletter_payloads_one?: Maybe<Newsletter_Payloads>;
  /** insert data into the table: "opc_saved_strategies" */
  insert_opc_saved_strategies?: Maybe<Opc_Saved_Strategies_Mutation_Response>;
  /** insert a single row into the table: "opc_saved_strategies" */
  insert_opc_saved_strategies_one?: Maybe<Opc_Saved_Strategies>;
  /** insert data into the table: "opc_saved_strategy_positions" */
  insert_opc_saved_strategy_positions?: Maybe<Opc_Saved_Strategy_Positions_Mutation_Response>;
  /** insert a single row into the table: "opc_saved_strategy_positions" */
  insert_opc_saved_strategy_positions_one?: Maybe<Opc_Saved_Strategy_Positions>;
  /** insert data into the table: "option_feed_baseline" */
  insert_option_feed_baseline?: Maybe<Option_Feed_Baseline_Mutation_Response>;
  /** insert a single row into the table: "option_feed_baseline" */
  insert_option_feed_baseline_one?: Maybe<Option_Feed_Baseline>;
  /** insert data into the table: "option_feed_filtered" */
  insert_option_feed_filtered?: Maybe<Option_Feed_Filtered_Mutation_Response>;
  /** insert a single row into the table: "option_feed_filtered" */
  insert_option_feed_filtered_one?: Maybe<Option_Feed_Filtered>;
  /** insert data into the table: "options_eod" */
  insert_options_eod?: Maybe<Options_Eod_Mutation_Response>;
  /** insert a single row into the table: "options_eod" */
  insert_options_eod_one?: Maybe<Options_Eod>;
  /** insert data into the table: "prelaunch_email_list" */
  insert_prelaunch_email_list?: Maybe<Prelaunch_Email_List_Mutation_Response>;
  /** insert a single row into the table: "prelaunch_email_list" */
  insert_prelaunch_email_list_one?: Maybe<Prelaunch_Email_List>;
  /** insert data into the table: "ready_check" */
  insert_ready_check?: Maybe<Ready_Check_Mutation_Response>;
  /** insert a single row into the table: "ready_check" */
  insert_ready_check_one?: Maybe<Ready_Check>;
  /** insert data into the table: "retention_feedback" */
  insert_retention_feedback?: Maybe<Retention_Feedback_Mutation_Response>;
  /** insert a single row into the table: "retention_feedback" */
  insert_retention_feedback_one?: Maybe<Retention_Feedback>;
  /** insert data into the table: "retention_intervention_events" */
  insert_retention_intervention_events?: Maybe<Retention_Intervention_Events_Mutation_Response>;
  /** insert a single row into the table: "retention_intervention_events" */
  insert_retention_intervention_events_one?: Maybe<Retention_Intervention_Events>;
  /** insert data into the table: "retention_intervention_sessions" */
  insert_retention_intervention_sessions?: Maybe<Retention_Intervention_Sessions_Mutation_Response>;
  /** insert a single row into the table: "retention_intervention_sessions" */
  insert_retention_intervention_sessions_one?: Maybe<Retention_Intervention_Sessions>;
  /** insert data into the table: "retention_notification_deliveries" */
  insert_retention_notification_deliveries?: Maybe<Retention_Notification_Deliveries_Mutation_Response>;
  /** insert a single row into the table: "retention_notification_deliveries" */
  insert_retention_notification_deliveries_one?: Maybe<Retention_Notification_Deliveries>;
  /** insert data into the table: "retention_offer_exposures" */
  insert_retention_offer_exposures?: Maybe<Retention_Offer_Exposures_Mutation_Response>;
  /** insert a single row into the table: "retention_offer_exposures" */
  insert_retention_offer_exposures_one?: Maybe<Retention_Offer_Exposures>;
  /** insert data into the table: "sales" */
  insert_sales?: Maybe<Sales_Mutation_Response>;
  /** insert a single row into the table: "sales" */
  insert_sales_one?: Maybe<Sales>;
  /** insert data into the table: "subscription_entitlements" */
  insert_subscription_entitlements?: Maybe<Subscription_Entitlements_Mutation_Response>;
  /** insert a single row into the table: "subscription_entitlements" */
  insert_subscription_entitlements_one?: Maybe<Subscription_Entitlements>;
  /** insert data into the table: "subscriptions" */
  insert_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** insert a single row into the table: "subscriptions" */
  insert_subscriptions_one?: Maybe<Subscriptions>;
  /** insert data into the table: "test_oct2023" */
  insert_test_oct2023?: Maybe<Test_Oct2023_Mutation_Response>;
  /** insert a single row into the table: "test_oct2023" */
  insert_test_oct2023_one?: Maybe<Test_Oct2023>;
  /** insert data into the table: "ticker_details" */
  insert_ticker_details?: Maybe<Ticker_Details_Mutation_Response>;
  /** insert a single row into the table: "ticker_details" */
  insert_ticker_details_one?: Maybe<Ticker_Details>;
  /** insert data into the table: "ticker_research_all_views" */
  insert_ticker_research_all_views?: Maybe<Ticker_Research_All_Views_Mutation_Response>;
  /** insert a single row into the table: "ticker_research_all_views" */
  insert_ticker_research_all_views_one?: Maybe<Ticker_Research_All_Views>;
  /** insert data into the table: "ticker_research_daily_views" */
  insert_ticker_research_daily_views?: Maybe<Ticker_Research_Daily_Views_Mutation_Response>;
  /** insert a single row into the table: "ticker_research_daily_views" */
  insert_ticker_research_daily_views_one?: Maybe<Ticker_Research_Daily_Views>;
  /** insert data into the table: "timezone_location" */
  insert_timezone_location?: Maybe<Timezone_Location_Mutation_Response>;
  /** insert a single row into the table: "timezone_location" */
  insert_timezone_location_one?: Maybe<Timezone_Location>;
  /** insert data into the table: "top_tickers" */
  insert_top_tickers?: Maybe<Top_Tickers_Mutation_Response>;
  /** insert a single row into the table: "top_tickers" */
  insert_top_tickers_one?: Maybe<Top_Tickers>;
  /** insert data into the table: "usage_ping" */
  insert_usage_ping?: Maybe<Usage_Ping_Mutation_Response>;
  /** insert a single row into the table: "usage_ping" */
  insert_usage_ping_one?: Maybe<Usage_Ping>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "watch_list" */
  insert_watch_list?: Maybe<Watch_List_Mutation_Response>;
  /** insert a single row into the table: "watch_list" */
  insert_watch_list_one?: Maybe<Watch_List>;
  /** update data of the table: "affiliate_link_clicks" */
  update_affiliate_link_clicks?: Maybe<Affiliate_Link_Clicks_Mutation_Response>;
  /** update single row of the table: "affiliate_link_clicks" */
  update_affiliate_link_clicks_by_pk?: Maybe<Affiliate_Link_Clicks>;
  /** update multiples rows of table: "affiliate_link_clicks" */
  update_affiliate_link_clicks_many?: Maybe<Array<Maybe<Affiliate_Link_Clicks_Mutation_Response>>>;
  /** update data of the table: "affiliate_payouts" */
  update_affiliate_payouts?: Maybe<Affiliate_Payouts_Mutation_Response>;
  /** update single row of the table: "affiliate_payouts" */
  update_affiliate_payouts_by_pk?: Maybe<Affiliate_Payouts>;
  /** update multiples rows of table: "affiliate_payouts" */
  update_affiliate_payouts_many?: Maybe<Array<Maybe<Affiliate_Payouts_Mutation_Response>>>;
  /** update data of the table: "asset_signal_alerts" */
  update_asset_signal_alerts?: Maybe<Asset_Signal_Alerts_Mutation_Response>;
  /** update single row of the table: "asset_signal_alerts" */
  update_asset_signal_alerts_by_pk?: Maybe<Asset_Signal_Alerts>;
  /** update multiples rows of table: "asset_signal_alerts" */
  update_asset_signal_alerts_many?: Maybe<Array<Maybe<Asset_Signal_Alerts_Mutation_Response>>>;
  /** update data of the table: "charges" */
  update_charges?: Maybe<Charges_Mutation_Response>;
  /** update single row of the table: "charges" */
  update_charges_by_pk?: Maybe<Charges>;
  /** update multiples rows of table: "charges" */
  update_charges_many?: Maybe<Array<Maybe<Charges_Mutation_Response>>>;
  /** update data of the table: "congress_trades" */
  update_congress_trades?: Maybe<Congress_Trades_Mutation_Response>;
  /** update single row of the table: "congress_trades" */
  update_congress_trades_by_pk?: Maybe<Congress_Trades>;
  /** update multiples rows of table: "congress_trades" */
  update_congress_trades_many?: Maybe<Array<Maybe<Congress_Trades_Mutation_Response>>>;
  /** update data of the table: "cookie_strings" */
  update_cookie_strings?: Maybe<Cookie_Strings_Mutation_Response>;
  /** update single row of the table: "cookie_strings" */
  update_cookie_strings_by_pk?: Maybe<Cookie_Strings>;
  /** update multiples rows of table: "cookie_strings" */
  update_cookie_strings_many?: Maybe<Array<Maybe<Cookie_Strings_Mutation_Response>>>;
  /** update data of the table: "course_progress" */
  update_course_progress?: Maybe<Course_Progress_Mutation_Response>;
  /** update single row of the table: "course_progress" */
  update_course_progress_by_pk?: Maybe<Course_Progress>;
  /** update multiples rows of table: "course_progress" */
  update_course_progress_many?: Maybe<Array<Maybe<Course_Progress_Mutation_Response>>>;
  /** update data of the table: "course_progress_status" */
  update_course_progress_status?: Maybe<Course_Progress_Status_Mutation_Response>;
  /** update single row of the table: "course_progress_status" */
  update_course_progress_status_by_pk?: Maybe<Course_Progress_Status>;
  /** update multiples rows of table: "course_progress_status" */
  update_course_progress_status_many?: Maybe<Array<Maybe<Course_Progress_Status_Mutation_Response>>>;
  /** update data of the table: "demo_filtered_trades_spiderrock" */
  update_demo_filtered_trades_spiderrock?: Maybe<Demo_Filtered_Trades_Spiderrock_Mutation_Response>;
  /** update single row of the table: "demo_filtered_trades_spiderrock" */
  update_demo_filtered_trades_spiderrock_by_pk?: Maybe<Demo_Filtered_Trades_Spiderrock>;
  /** update multiples rows of table: "demo_filtered_trades_spiderrock" */
  update_demo_filtered_trades_spiderrock_many?: Maybe<Array<Maybe<Demo_Filtered_Trades_Spiderrock_Mutation_Response>>>;
  /** update data of the table: "demo_raw_trades_spiderrock" */
  update_demo_raw_trades_spiderrock?: Maybe<Demo_Raw_Trades_Spiderrock_Mutation_Response>;
  /** update single row of the table: "demo_raw_trades_spiderrock" */
  update_demo_raw_trades_spiderrock_by_pk?: Maybe<Demo_Raw_Trades_Spiderrock>;
  /** update multiples rows of table: "demo_raw_trades_spiderrock" */
  update_demo_raw_trades_spiderrock_many?: Maybe<Array<Maybe<Demo_Raw_Trades_Spiderrock_Mutation_Response>>>;
  /** update data of the table: "earnings_snp" */
  update_earnings_snp?: Maybe<Earnings_Snp_Mutation_Response>;
  /** update single row of the table: "earnings_snp" */
  update_earnings_snp_by_pk?: Maybe<Earnings_Snp>;
  /** update multiples rows of table: "earnings_snp" */
  update_earnings_snp_many?: Maybe<Array<Maybe<Earnings_Snp_Mutation_Response>>>;
  /** update data of the table: "email_alerts" */
  update_email_alerts?: Maybe<Email_Alerts_Mutation_Response>;
  /** update single row of the table: "email_alerts" */
  update_email_alerts_by_pk?: Maybe<Email_Alerts>;
  /** update multiples rows of table: "email_alerts" */
  update_email_alerts_many?: Maybe<Array<Maybe<Email_Alerts_Mutation_Response>>>;
  /** update data of the table: "email_list" */
  update_email_list?: Maybe<Email_List_Mutation_Response>;
  /** update single row of the table: "email_list" */
  update_email_list_by_pk?: Maybe<Email_List>;
  /** update multiples rows of table: "email_list" */
  update_email_list_many?: Maybe<Array<Maybe<Email_List_Mutation_Response>>>;
  /** update data of the table: "equities_eod" */
  update_equities_eod?: Maybe<Equities_Eod_Mutation_Response>;
  /** update single row of the table: "equities_eod" */
  update_equities_eod_by_pk?: Maybe<Equities_Eod>;
  /** update multiples rows of table: "equities_eod" */
  update_equities_eod_many?: Maybe<Array<Maybe<Equities_Eod_Mutation_Response>>>;
  /** update data of the table: "equity_pool_prints" */
  update_equity_pool_prints?: Maybe<Equity_Pool_Prints_Mutation_Response>;
  /** update single row of the table: "equity_pool_prints" */
  update_equity_pool_prints_by_pk?: Maybe<Equity_Pool_Prints>;
  /** update multiples rows of table: "equity_pool_prints" */
  update_equity_pool_prints_many?: Maybe<Array<Maybe<Equity_Pool_Prints_Mutation_Response>>>;
  /** update data of the table: "equity_print_feed_baseline" */
  update_equity_print_feed_baseline?: Maybe<Equity_Print_Feed_Baseline_Mutation_Response>;
  /** update single row of the table: "equity_print_feed_baseline" */
  update_equity_print_feed_baseline_by_pk?: Maybe<Equity_Print_Feed_Baseline>;
  /** update multiples rows of table: "equity_print_feed_baseline" */
  update_equity_print_feed_baseline_many?: Maybe<Array<Maybe<Equity_Print_Feed_Baseline_Mutation_Response>>>;
  /** update data of the table: "equity_print_feed_filtered" */
  update_equity_print_feed_filtered?: Maybe<Equity_Print_Feed_Filtered_Mutation_Response>;
  /** update single row of the table: "equity_print_feed_filtered" */
  update_equity_print_feed_filtered_by_pk?: Maybe<Equity_Print_Feed_Filtered>;
  /** update multiples rows of table: "equity_print_feed_filtered" */
  update_equity_print_feed_filtered_many?: Maybe<Array<Maybe<Equity_Print_Feed_Filtered_Mutation_Response>>>;
  /** update data of the table: "fa_trade_uploads" */
  update_fa_trade_uploads?: Maybe<Fa_Trade_Uploads_Mutation_Response>;
  /** update single row of the table: "fa_trade_uploads" */
  update_fa_trade_uploads_by_pk?: Maybe<Fa_Trade_Uploads>;
  /** update multiples rows of table: "fa_trade_uploads" */
  update_fa_trade_uploads_many?: Maybe<Array<Maybe<Fa_Trade_Uploads_Mutation_Response>>>;
  /** update data of the table: "fa_trades" */
  update_fa_trades?: Maybe<Fa_Trades_Mutation_Response>;
  /** update single row of the table: "fa_trades" */
  update_fa_trades_by_pk?: Maybe<Fa_Trades>;
  /** update multiples rows of table: "fa_trades" */
  update_fa_trades_many?: Maybe<Array<Maybe<Fa_Trades_Mutation_Response>>>;
  /** update data of the table: "feedback_boards" */
  update_feedback_boards?: Maybe<Feedback_Boards_Mutation_Response>;
  /** update single row of the table: "feedback_boards" */
  update_feedback_boards_by_pk?: Maybe<Feedback_Boards>;
  /** update multiples rows of table: "feedback_boards" */
  update_feedback_boards_many?: Maybe<Array<Maybe<Feedback_Boards_Mutation_Response>>>;
  /** update data of the table: "feedback_comments" */
  update_feedback_comments?: Maybe<Feedback_Comments_Mutation_Response>;
  /** update single row of the table: "feedback_comments" */
  update_feedback_comments_by_pk?: Maybe<Feedback_Comments>;
  /** update multiples rows of table: "feedback_comments" */
  update_feedback_comments_many?: Maybe<Array<Maybe<Feedback_Comments_Mutation_Response>>>;
  /** update data of the table: "feedback_media" */
  update_feedback_media?: Maybe<Feedback_Media_Mutation_Response>;
  /** update single row of the table: "feedback_media" */
  update_feedback_media_by_pk?: Maybe<Feedback_Media>;
  /** update multiples rows of table: "feedback_media" */
  update_feedback_media_many?: Maybe<Array<Maybe<Feedback_Media_Mutation_Response>>>;
  /** update data of the table: "feedback_post_contexts" */
  update_feedback_post_contexts?: Maybe<Feedback_Post_Contexts_Mutation_Response>;
  /** update single row of the table: "feedback_post_contexts" */
  update_feedback_post_contexts_by_pk?: Maybe<Feedback_Post_Contexts>;
  /** update multiples rows of table: "feedback_post_contexts" */
  update_feedback_post_contexts_many?: Maybe<Array<Maybe<Feedback_Post_Contexts_Mutation_Response>>>;
  /** update data of the table: "feedback_post_merges" */
  update_feedback_post_merges?: Maybe<Feedback_Post_Merges_Mutation_Response>;
  /** update single row of the table: "feedback_post_merges" */
  update_feedback_post_merges_by_pk?: Maybe<Feedback_Post_Merges>;
  /** update multiples rows of table: "feedback_post_merges" */
  update_feedback_post_merges_many?: Maybe<Array<Maybe<Feedback_Post_Merges_Mutation_Response>>>;
  /** update data of the table: "feedback_posts" */
  update_feedback_posts?: Maybe<Feedback_Posts_Mutation_Response>;
  /** update single row of the table: "feedback_posts" */
  update_feedback_posts_by_pk?: Maybe<Feedback_Posts>;
  /** update multiples rows of table: "feedback_posts" */
  update_feedback_posts_many?: Maybe<Array<Maybe<Feedback_Posts_Mutation_Response>>>;
  /** update data of the table: "feedback_posts_with_counts" */
  update_feedback_posts_with_counts?: Maybe<Feedback_Posts_With_Counts_Mutation_Response>;
  /** update multiples rows of table: "feedback_posts_with_counts" */
  update_feedback_posts_with_counts_many?: Maybe<Array<Maybe<Feedback_Posts_With_Counts_Mutation_Response>>>;
  /** update data of the table: "feedback_release_posts" */
  update_feedback_release_posts?: Maybe<Feedback_Release_Posts_Mutation_Response>;
  /** update single row of the table: "feedback_release_posts" */
  update_feedback_release_posts_by_pk?: Maybe<Feedback_Release_Posts>;
  /** update multiples rows of table: "feedback_release_posts" */
  update_feedback_release_posts_many?: Maybe<Array<Maybe<Feedback_Release_Posts_Mutation_Response>>>;
  /** update data of the table: "feedback_releases" */
  update_feedback_releases?: Maybe<Feedback_Releases_Mutation_Response>;
  /** update single row of the table: "feedback_releases" */
  update_feedback_releases_by_pk?: Maybe<Feedback_Releases>;
  /** update multiples rows of table: "feedback_releases" */
  update_feedback_releases_many?: Maybe<Array<Maybe<Feedback_Releases_Mutation_Response>>>;
  /** update data of the table: "feedback_statuses" */
  update_feedback_statuses?: Maybe<Feedback_Statuses_Mutation_Response>;
  /** update single row of the table: "feedback_statuses" */
  update_feedback_statuses_by_pk?: Maybe<Feedback_Statuses>;
  /** update multiples rows of table: "feedback_statuses" */
  update_feedback_statuses_many?: Maybe<Array<Maybe<Feedback_Statuses_Mutation_Response>>>;
  /** update data of the table: "feedback_votes" */
  update_feedback_votes?: Maybe<Feedback_Votes_Mutation_Response>;
  /** update single row of the table: "feedback_votes" */
  update_feedback_votes_by_pk?: Maybe<Feedback_Votes>;
  /** update multiples rows of table: "feedback_votes" */
  update_feedback_votes_many?: Maybe<Array<Maybe<Feedback_Votes_Mutation_Response>>>;
  /** update data of the table: "flow_configurations" */
  update_flow_configurations?: Maybe<Flow_Configurations_Mutation_Response>;
  /** update single row of the table: "flow_configurations" */
  update_flow_configurations_by_pk?: Maybe<Flow_Configurations>;
  /** update multiples rows of table: "flow_configurations" */
  update_flow_configurations_many?: Maybe<Array<Maybe<Flow_Configurations_Mutation_Response>>>;
  /** update data of the table: "full_feed_option_flow" */
  update_full_feed_option_flow?: Maybe<Full_Feed_Option_Flow_Mutation_Response>;
  /** update multiples rows of table: "full_feed_option_flow" */
  update_full_feed_option_flow_many?: Maybe<Array<Maybe<Full_Feed_Option_Flow_Mutation_Response>>>;
  /** update data of the table: "health_checks" */
  update_health_checks?: Maybe<Health_Checks_Mutation_Response>;
  /** update single row of the table: "health_checks" */
  update_health_checks_by_pk?: Maybe<Health_Checks>;
  /** update multiples rows of table: "health_checks" */
  update_health_checks_many?: Maybe<Array<Maybe<Health_Checks_Mutation_Response>>>;
  /** update data of the table: "insider_trades" */
  update_insider_trades?: Maybe<Insider_Trades_Mutation_Response>;
  /** update single row of the table: "insider_trades" */
  update_insider_trades_by_pk?: Maybe<Insider_Trades>;
  /** update multiples rows of table: "insider_trades" */
  update_insider_trades_many?: Maybe<Array<Maybe<Insider_Trades_Mutation_Response>>>;
  /** update data of the table: "invoices" */
  update_invoices?: Maybe<Invoices_Mutation_Response>;
  /** update single row of the table: "invoices" */
  update_invoices_by_pk?: Maybe<Invoices>;
  /** update multiples rows of table: "invoices" */
  update_invoices_many?: Maybe<Array<Maybe<Invoices_Mutation_Response>>>;
  /** update data of the table: "microsoft_access_tokens" */
  update_microsoft_access_tokens?: Maybe<Microsoft_Access_Tokens_Mutation_Response>;
  /** update single row of the table: "microsoft_access_tokens" */
  update_microsoft_access_tokens_by_pk?: Maybe<Microsoft_Access_Tokens>;
  /** update multiples rows of table: "microsoft_access_tokens" */
  update_microsoft_access_tokens_many?: Maybe<Array<Maybe<Microsoft_Access_Tokens_Mutation_Response>>>;
  /** update data of the table: "news_cache_stocks" */
  update_news_cache_stocks?: Maybe<News_Cache_Stocks_Mutation_Response>;
  /** update single row of the table: "news_cache_stocks" */
  update_news_cache_stocks_by_pk?: Maybe<News_Cache_Stocks>;
  /** update multiples rows of table: "news_cache_stocks" */
  update_news_cache_stocks_many?: Maybe<Array<Maybe<News_Cache_Stocks_Mutation_Response>>>;
  /** update data of the table: "newsletter_payloads" */
  update_newsletter_payloads?: Maybe<Newsletter_Payloads_Mutation_Response>;
  /** update single row of the table: "newsletter_payloads" */
  update_newsletter_payloads_by_pk?: Maybe<Newsletter_Payloads>;
  /** update multiples rows of table: "newsletter_payloads" */
  update_newsletter_payloads_many?: Maybe<Array<Maybe<Newsletter_Payloads_Mutation_Response>>>;
  /** update data of the table: "opc_saved_strategies" */
  update_opc_saved_strategies?: Maybe<Opc_Saved_Strategies_Mutation_Response>;
  /** update single row of the table: "opc_saved_strategies" */
  update_opc_saved_strategies_by_pk?: Maybe<Opc_Saved_Strategies>;
  /** update multiples rows of table: "opc_saved_strategies" */
  update_opc_saved_strategies_many?: Maybe<Array<Maybe<Opc_Saved_Strategies_Mutation_Response>>>;
  /** update data of the table: "opc_saved_strategy_positions" */
  update_opc_saved_strategy_positions?: Maybe<Opc_Saved_Strategy_Positions_Mutation_Response>;
  /** update single row of the table: "opc_saved_strategy_positions" */
  update_opc_saved_strategy_positions_by_pk?: Maybe<Opc_Saved_Strategy_Positions>;
  /** update multiples rows of table: "opc_saved_strategy_positions" */
  update_opc_saved_strategy_positions_many?: Maybe<Array<Maybe<Opc_Saved_Strategy_Positions_Mutation_Response>>>;
  /** update data of the table: "option_feed_baseline" */
  update_option_feed_baseline?: Maybe<Option_Feed_Baseline_Mutation_Response>;
  /** update single row of the table: "option_feed_baseline" */
  update_option_feed_baseline_by_pk?: Maybe<Option_Feed_Baseline>;
  /** update multiples rows of table: "option_feed_baseline" */
  update_option_feed_baseline_many?: Maybe<Array<Maybe<Option_Feed_Baseline_Mutation_Response>>>;
  /** update data of the table: "option_feed_filtered" */
  update_option_feed_filtered?: Maybe<Option_Feed_Filtered_Mutation_Response>;
  /** update single row of the table: "option_feed_filtered" */
  update_option_feed_filtered_by_pk?: Maybe<Option_Feed_Filtered>;
  /** update multiples rows of table: "option_feed_filtered" */
  update_option_feed_filtered_many?: Maybe<Array<Maybe<Option_Feed_Filtered_Mutation_Response>>>;
  /** update data of the table: "options_eod" */
  update_options_eod?: Maybe<Options_Eod_Mutation_Response>;
  /** update single row of the table: "options_eod" */
  update_options_eod_by_pk?: Maybe<Options_Eod>;
  /** update multiples rows of table: "options_eod" */
  update_options_eod_many?: Maybe<Array<Maybe<Options_Eod_Mutation_Response>>>;
  /** update data of the table: "prelaunch_email_list" */
  update_prelaunch_email_list?: Maybe<Prelaunch_Email_List_Mutation_Response>;
  /** update single row of the table: "prelaunch_email_list" */
  update_prelaunch_email_list_by_pk?: Maybe<Prelaunch_Email_List>;
  /** update multiples rows of table: "prelaunch_email_list" */
  update_prelaunch_email_list_many?: Maybe<Array<Maybe<Prelaunch_Email_List_Mutation_Response>>>;
  /** update data of the table: "ready_check" */
  update_ready_check?: Maybe<Ready_Check_Mutation_Response>;
  /** update single row of the table: "ready_check" */
  update_ready_check_by_pk?: Maybe<Ready_Check>;
  /** update multiples rows of table: "ready_check" */
  update_ready_check_many?: Maybe<Array<Maybe<Ready_Check_Mutation_Response>>>;
  /** update data of the table: "retention_feedback" */
  update_retention_feedback?: Maybe<Retention_Feedback_Mutation_Response>;
  /** update single row of the table: "retention_feedback" */
  update_retention_feedback_by_pk?: Maybe<Retention_Feedback>;
  /** update multiples rows of table: "retention_feedback" */
  update_retention_feedback_many?: Maybe<Array<Maybe<Retention_Feedback_Mutation_Response>>>;
  /** update data of the table: "retention_intervention_events" */
  update_retention_intervention_events?: Maybe<Retention_Intervention_Events_Mutation_Response>;
  /** update single row of the table: "retention_intervention_events" */
  update_retention_intervention_events_by_pk?: Maybe<Retention_Intervention_Events>;
  /** update multiples rows of table: "retention_intervention_events" */
  update_retention_intervention_events_many?: Maybe<Array<Maybe<Retention_Intervention_Events_Mutation_Response>>>;
  /** update data of the table: "retention_intervention_sessions" */
  update_retention_intervention_sessions?: Maybe<Retention_Intervention_Sessions_Mutation_Response>;
  /** update single row of the table: "retention_intervention_sessions" */
  update_retention_intervention_sessions_by_pk?: Maybe<Retention_Intervention_Sessions>;
  /** update multiples rows of table: "retention_intervention_sessions" */
  update_retention_intervention_sessions_many?: Maybe<Array<Maybe<Retention_Intervention_Sessions_Mutation_Response>>>;
  /** update data of the table: "retention_notification_deliveries" */
  update_retention_notification_deliveries?: Maybe<Retention_Notification_Deliveries_Mutation_Response>;
  /** update single row of the table: "retention_notification_deliveries" */
  update_retention_notification_deliveries_by_pk?: Maybe<Retention_Notification_Deliveries>;
  /** update multiples rows of table: "retention_notification_deliveries" */
  update_retention_notification_deliveries_many?: Maybe<Array<Maybe<Retention_Notification_Deliveries_Mutation_Response>>>;
  /** update data of the table: "retention_offer_exposures" */
  update_retention_offer_exposures?: Maybe<Retention_Offer_Exposures_Mutation_Response>;
  /** update single row of the table: "retention_offer_exposures" */
  update_retention_offer_exposures_by_pk?: Maybe<Retention_Offer_Exposures>;
  /** update multiples rows of table: "retention_offer_exposures" */
  update_retention_offer_exposures_many?: Maybe<Array<Maybe<Retention_Offer_Exposures_Mutation_Response>>>;
  /** update data of the table: "sales" */
  update_sales?: Maybe<Sales_Mutation_Response>;
  /** update single row of the table: "sales" */
  update_sales_by_pk?: Maybe<Sales>;
  /** update multiples rows of table: "sales" */
  update_sales_many?: Maybe<Array<Maybe<Sales_Mutation_Response>>>;
  /** update data of the table: "subscription_entitlements" */
  update_subscription_entitlements?: Maybe<Subscription_Entitlements_Mutation_Response>;
  /** update single row of the table: "subscription_entitlements" */
  update_subscription_entitlements_by_pk?: Maybe<Subscription_Entitlements>;
  /** update multiples rows of table: "subscription_entitlements" */
  update_subscription_entitlements_many?: Maybe<Array<Maybe<Subscription_Entitlements_Mutation_Response>>>;
  /** update data of the table: "subscriptions" */
  update_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** update single row of the table: "subscriptions" */
  update_subscriptions_by_pk?: Maybe<Subscriptions>;
  /** update multiples rows of table: "subscriptions" */
  update_subscriptions_many?: Maybe<Array<Maybe<Subscriptions_Mutation_Response>>>;
  /** update data of the table: "test_oct2023" */
  update_test_oct2023?: Maybe<Test_Oct2023_Mutation_Response>;
  /** update single row of the table: "test_oct2023" */
  update_test_oct2023_by_pk?: Maybe<Test_Oct2023>;
  /** update multiples rows of table: "test_oct2023" */
  update_test_oct2023_many?: Maybe<Array<Maybe<Test_Oct2023_Mutation_Response>>>;
  /** update data of the table: "ticker_details" */
  update_ticker_details?: Maybe<Ticker_Details_Mutation_Response>;
  /** update single row of the table: "ticker_details" */
  update_ticker_details_by_pk?: Maybe<Ticker_Details>;
  /** update multiples rows of table: "ticker_details" */
  update_ticker_details_many?: Maybe<Array<Maybe<Ticker_Details_Mutation_Response>>>;
  /** update data of the table: "ticker_research_all_views" */
  update_ticker_research_all_views?: Maybe<Ticker_Research_All_Views_Mutation_Response>;
  /** update single row of the table: "ticker_research_all_views" */
  update_ticker_research_all_views_by_pk?: Maybe<Ticker_Research_All_Views>;
  /** update multiples rows of table: "ticker_research_all_views" */
  update_ticker_research_all_views_many?: Maybe<Array<Maybe<Ticker_Research_All_Views_Mutation_Response>>>;
  /** update data of the table: "ticker_research_daily_views" */
  update_ticker_research_daily_views?: Maybe<Ticker_Research_Daily_Views_Mutation_Response>;
  /** update single row of the table: "ticker_research_daily_views" */
  update_ticker_research_daily_views_by_pk?: Maybe<Ticker_Research_Daily_Views>;
  /** update multiples rows of table: "ticker_research_daily_views" */
  update_ticker_research_daily_views_many?: Maybe<Array<Maybe<Ticker_Research_Daily_Views_Mutation_Response>>>;
  /** update data of the table: "timezone_location" */
  update_timezone_location?: Maybe<Timezone_Location_Mutation_Response>;
  /** update single row of the table: "timezone_location" */
  update_timezone_location_by_pk?: Maybe<Timezone_Location>;
  /** update multiples rows of table: "timezone_location" */
  update_timezone_location_many?: Maybe<Array<Maybe<Timezone_Location_Mutation_Response>>>;
  /** update data of the table: "top_tickers" */
  update_top_tickers?: Maybe<Top_Tickers_Mutation_Response>;
  /** update single row of the table: "top_tickers" */
  update_top_tickers_by_pk?: Maybe<Top_Tickers>;
  /** update multiples rows of table: "top_tickers" */
  update_top_tickers_many?: Maybe<Array<Maybe<Top_Tickers_Mutation_Response>>>;
  /** update data of the table: "usage_ping" */
  update_usage_ping?: Maybe<Usage_Ping_Mutation_Response>;
  /** update single row of the table: "usage_ping" */
  update_usage_ping_by_pk?: Maybe<Usage_Ping>;
  /** update multiples rows of table: "usage_ping" */
  update_usage_ping_many?: Maybe<Array<Maybe<Usage_Ping_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "watch_list" */
  update_watch_list?: Maybe<Watch_List_Mutation_Response>;
  /** update single row of the table: "watch_list" */
  update_watch_list_by_pk?: Maybe<Watch_List>;
  /** update multiples rows of table: "watch_list" */
  update_watch_list_many?: Maybe<Array<Maybe<Watch_List_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_Affiliate_Link_ClicksArgs = {
  where: Affiliate_Link_Clicks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Affiliate_Link_Clicks_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Affiliate_PayoutsArgs = {
  where: Affiliate_Payouts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Affiliate_Payouts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_Signal_AlertsArgs = {
  where: Asset_Signal_Alerts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Signal_Alerts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ChargesArgs = {
  where: Charges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Charges_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Congress_TradesArgs = {
  where: Congress_Trades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Congress_Trades_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Cookie_StringsArgs = {
  where: Cookie_Strings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cookie_Strings_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_ProgressArgs = {
  where: Course_Progress_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Progress_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Progress_StatusArgs = {
  where: Course_Progress_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Progress_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Demo_Filtered_Trades_SpiderrockArgs = {
  where: Demo_Filtered_Trades_Spiderrock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Demo_Filtered_Trades_Spiderrock_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Demo_Raw_Trades_SpiderrockArgs = {
  where: Demo_Raw_Trades_Spiderrock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Demo_Raw_Trades_Spiderrock_By_PkArgs = {
  prtNumber: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Earnings_SnpArgs = {
  where: Earnings_Snp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Earnings_Snp_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Email_AlertsArgs = {
  where: Email_Alerts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Alerts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Email_ListArgs = {
  where: Email_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_List_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Equities_EodArgs = {
  where: Equities_Eod_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Equities_Eod_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Equity_Pool_PrintsArgs = {
  where: Equity_Pool_Prints_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Equity_Pool_Prints_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Equity_Print_Feed_BaselineArgs = {
  where: Equity_Print_Feed_Baseline_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Equity_Print_Feed_Baseline_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Equity_Print_Feed_FilteredArgs = {
  where: Equity_Print_Feed_Filtered_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Equity_Print_Feed_Filtered_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Fa_Trade_UploadsArgs = {
  where: Fa_Trade_Uploads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fa_Trade_Uploads_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Fa_TradesArgs = {
  where: Fa_Trades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fa_Trades_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Feedback_BoardsArgs = {
  where: Feedback_Boards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Boards_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Feedback_CommentsArgs = {
  where: Feedback_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Comments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Feedback_MediaArgs = {
  where: Feedback_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Media_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Post_ContextsArgs = {
  where: Feedback_Post_Contexts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Post_Contexts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Post_MergesArgs = {
  where: Feedback_Post_Merges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Post_Merges_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Feedback_PostsArgs = {
  where: Feedback_Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Posts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Posts_With_CountsArgs = {
  where: Feedback_Posts_With_Counts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Release_PostsArgs = {
  where: Feedback_Release_Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Release_Posts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Feedback_ReleasesArgs = {
  where: Feedback_Releases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Releases_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Feedback_StatusesArgs = {
  where: Feedback_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Feedback_VotesArgs = {
  where: Feedback_Votes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_Votes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Flow_ConfigurationsArgs = {
  where: Flow_Configurations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flow_Configurations_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Full_Feed_Option_FlowArgs = {
  where: Full_Feed_Option_Flow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Health_ChecksArgs = {
  where: Health_Checks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Health_Checks_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Insider_TradesArgs = {
  where: Insider_Trades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insider_Trades_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_InvoicesArgs = {
  where: Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoices_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Microsoft_Access_TokensArgs = {
  where: Microsoft_Access_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Microsoft_Access_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_News_Cache_StocksArgs = {
  where: News_Cache_Stocks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_News_Cache_Stocks_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Newsletter_PayloadsArgs = {
  where: Newsletter_Payloads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Newsletter_Payloads_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Opc_Saved_StrategiesArgs = {
  where: Opc_Saved_Strategies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Opc_Saved_Strategies_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Opc_Saved_Strategy_PositionsArgs = {
  where: Opc_Saved_Strategy_Positions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Opc_Saved_Strategy_Positions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Option_Feed_BaselineArgs = {
  where: Option_Feed_Baseline_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Option_Feed_Baseline_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Option_Feed_FilteredArgs = {
  where: Option_Feed_Filtered_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Option_Feed_Filtered_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Options_EodArgs = {
  where: Options_Eod_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Options_Eod_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Prelaunch_Email_ListArgs = {
  where: Prelaunch_Email_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prelaunch_Email_List_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ready_CheckArgs = {
  where: Ready_Check_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ready_Check_By_PkArgs = {
  isReady: Scalars['Boolean'];
};


/** mutation root */
export type Mutation_RootDelete_Retention_FeedbackArgs = {
  where: Retention_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Retention_Feedback_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Retention_Intervention_EventsArgs = {
  where: Retention_Intervention_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Retention_Intervention_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Retention_Intervention_SessionsArgs = {
  where: Retention_Intervention_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Retention_Intervention_Sessions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Retention_Notification_DeliveriesArgs = {
  where: Retention_Notification_Deliveries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Retention_Notification_Deliveries_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Retention_Offer_ExposuresArgs = {
  where: Retention_Offer_Exposures_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Retention_Offer_Exposures_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SalesArgs = {
  where: Sales_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sales_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_EntitlementsArgs = {
  where: Subscription_Entitlements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Entitlements_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_SubscriptionsArgs = {
  where: Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Test_Oct2023Args = {
  where: Test_Oct2023_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Test_Oct2023_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ticker_DetailsArgs = {
  where: Ticker_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ticker_Details_By_PkArgs = {
  ticker: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ticker_Research_All_ViewsArgs = {
  where: Ticker_Research_All_Views_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ticker_Research_All_Views_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ticker_Research_Daily_ViewsArgs = {
  where: Ticker_Research_Daily_Views_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ticker_Research_Daily_Views_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Timezone_LocationArgs = {
  where: Timezone_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Timezone_Location_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Top_TickersArgs = {
  where: Top_Tickers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Top_Tickers_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Usage_PingArgs = {
  where: Usage_Ping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Usage_Ping_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Watch_ListArgs = {
  where: Watch_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Watch_List_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsert_Affiliate_Link_ClicksArgs = {
  objects: Array<Affiliate_Link_Clicks_Insert_Input>;
  on_conflict?: InputMaybe<Affiliate_Link_Clicks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Affiliate_Link_Clicks_OneArgs = {
  object: Affiliate_Link_Clicks_Insert_Input;
  on_conflict?: InputMaybe<Affiliate_Link_Clicks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Affiliate_PayoutsArgs = {
  objects: Array<Affiliate_Payouts_Insert_Input>;
  on_conflict?: InputMaybe<Affiliate_Payouts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Affiliate_Payouts_OneArgs = {
  object: Affiliate_Payouts_Insert_Input;
  on_conflict?: InputMaybe<Affiliate_Payouts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Signal_AlertsArgs = {
  objects: Array<Asset_Signal_Alerts_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Signal_Alerts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Signal_Alerts_OneArgs = {
  object: Asset_Signal_Alerts_Insert_Input;
  on_conflict?: InputMaybe<Asset_Signal_Alerts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ChargesArgs = {
  objects: Array<Charges_Insert_Input>;
  on_conflict?: InputMaybe<Charges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Charges_OneArgs = {
  object: Charges_Insert_Input;
  on_conflict?: InputMaybe<Charges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Congress_TradesArgs = {
  objects: Array<Congress_Trades_Insert_Input>;
  on_conflict?: InputMaybe<Congress_Trades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Congress_Trades_OneArgs = {
  object: Congress_Trades_Insert_Input;
  on_conflict?: InputMaybe<Congress_Trades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cookie_StringsArgs = {
  objects: Array<Cookie_Strings_Insert_Input>;
  on_conflict?: InputMaybe<Cookie_Strings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cookie_Strings_OneArgs = {
  object: Cookie_Strings_Insert_Input;
  on_conflict?: InputMaybe<Cookie_Strings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_ProgressArgs = {
  objects: Array<Course_Progress_Insert_Input>;
  on_conflict?: InputMaybe<Course_Progress_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Progress_OneArgs = {
  object: Course_Progress_Insert_Input;
  on_conflict?: InputMaybe<Course_Progress_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Progress_StatusArgs = {
  objects: Array<Course_Progress_Status_Insert_Input>;
  on_conflict?: InputMaybe<Course_Progress_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Progress_Status_OneArgs = {
  object: Course_Progress_Status_Insert_Input;
  on_conflict?: InputMaybe<Course_Progress_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Demo_Filtered_Trades_SpiderrockArgs = {
  objects: Array<Demo_Filtered_Trades_Spiderrock_Insert_Input>;
  on_conflict?: InputMaybe<Demo_Filtered_Trades_Spiderrock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Demo_Filtered_Trades_Spiderrock_OneArgs = {
  object: Demo_Filtered_Trades_Spiderrock_Insert_Input;
  on_conflict?: InputMaybe<Demo_Filtered_Trades_Spiderrock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Demo_Raw_Trades_SpiderrockArgs = {
  objects: Array<Demo_Raw_Trades_Spiderrock_Insert_Input>;
  on_conflict?: InputMaybe<Demo_Raw_Trades_Spiderrock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Demo_Raw_Trades_Spiderrock_OneArgs = {
  object: Demo_Raw_Trades_Spiderrock_Insert_Input;
  on_conflict?: InputMaybe<Demo_Raw_Trades_Spiderrock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Earnings_SnpArgs = {
  objects: Array<Earnings_Snp_Insert_Input>;
  on_conflict?: InputMaybe<Earnings_Snp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Earnings_Snp_OneArgs = {
  object: Earnings_Snp_Insert_Input;
  on_conflict?: InputMaybe<Earnings_Snp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_AlertsArgs = {
  objects: Array<Email_Alerts_Insert_Input>;
  on_conflict?: InputMaybe<Email_Alerts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Alerts_OneArgs = {
  object: Email_Alerts_Insert_Input;
  on_conflict?: InputMaybe<Email_Alerts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_ListArgs = {
  objects: Array<Email_List_Insert_Input>;
  on_conflict?: InputMaybe<Email_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_List_OneArgs = {
  object: Email_List_Insert_Input;
  on_conflict?: InputMaybe<Email_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Equities_EodArgs = {
  objects: Array<Equities_Eod_Insert_Input>;
  on_conflict?: InputMaybe<Equities_Eod_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Equities_Eod_OneArgs = {
  object: Equities_Eod_Insert_Input;
  on_conflict?: InputMaybe<Equities_Eod_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Equity_Pool_PrintsArgs = {
  objects: Array<Equity_Pool_Prints_Insert_Input>;
  on_conflict?: InputMaybe<Equity_Pool_Prints_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Equity_Pool_Prints_OneArgs = {
  object: Equity_Pool_Prints_Insert_Input;
  on_conflict?: InputMaybe<Equity_Pool_Prints_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Equity_Print_Feed_BaselineArgs = {
  objects: Array<Equity_Print_Feed_Baseline_Insert_Input>;
  on_conflict?: InputMaybe<Equity_Print_Feed_Baseline_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Equity_Print_Feed_Baseline_OneArgs = {
  object: Equity_Print_Feed_Baseline_Insert_Input;
  on_conflict?: InputMaybe<Equity_Print_Feed_Baseline_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Equity_Print_Feed_FilteredArgs = {
  objects: Array<Equity_Print_Feed_Filtered_Insert_Input>;
  on_conflict?: InputMaybe<Equity_Print_Feed_Filtered_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Equity_Print_Feed_Filtered_OneArgs = {
  object: Equity_Print_Feed_Filtered_Insert_Input;
  on_conflict?: InputMaybe<Equity_Print_Feed_Filtered_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fa_Trade_UploadsArgs = {
  objects: Array<Fa_Trade_Uploads_Insert_Input>;
  on_conflict?: InputMaybe<Fa_Trade_Uploads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fa_Trade_Uploads_OneArgs = {
  object: Fa_Trade_Uploads_Insert_Input;
  on_conflict?: InputMaybe<Fa_Trade_Uploads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fa_TradesArgs = {
  objects: Array<Fa_Trades_Insert_Input>;
  on_conflict?: InputMaybe<Fa_Trades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fa_Trades_OneArgs = {
  object: Fa_Trades_Insert_Input;
  on_conflict?: InputMaybe<Fa_Trades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_BoardsArgs = {
  objects: Array<Feedback_Boards_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_Boards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Boards_OneArgs = {
  object: Feedback_Boards_Insert_Input;
  on_conflict?: InputMaybe<Feedback_Boards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_CommentsArgs = {
  objects: Array<Feedback_Comments_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Comments_OneArgs = {
  object: Feedback_Comments_Insert_Input;
  on_conflict?: InputMaybe<Feedback_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_MediaArgs = {
  objects: Array<Feedback_Media_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Media_OneArgs = {
  object: Feedback_Media_Insert_Input;
  on_conflict?: InputMaybe<Feedback_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Post_ContextsArgs = {
  objects: Array<Feedback_Post_Contexts_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_Post_Contexts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Post_Contexts_OneArgs = {
  object: Feedback_Post_Contexts_Insert_Input;
  on_conflict?: InputMaybe<Feedback_Post_Contexts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Post_MergesArgs = {
  objects: Array<Feedback_Post_Merges_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_Post_Merges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Post_Merges_OneArgs = {
  object: Feedback_Post_Merges_Insert_Input;
  on_conflict?: InputMaybe<Feedback_Post_Merges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_PostsArgs = {
  objects: Array<Feedback_Posts_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Posts_OneArgs = {
  object: Feedback_Posts_Insert_Input;
  on_conflict?: InputMaybe<Feedback_Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Posts_With_CountsArgs = {
  objects: Array<Feedback_Posts_With_Counts_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Posts_With_Counts_OneArgs = {
  object: Feedback_Posts_With_Counts_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Release_PostsArgs = {
  objects: Array<Feedback_Release_Posts_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_Release_Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Release_Posts_OneArgs = {
  object: Feedback_Release_Posts_Insert_Input;
  on_conflict?: InputMaybe<Feedback_Release_Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_ReleasesArgs = {
  objects: Array<Feedback_Releases_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_Releases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Releases_OneArgs = {
  object: Feedback_Releases_Insert_Input;
  on_conflict?: InputMaybe<Feedback_Releases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_StatusesArgs = {
  objects: Array<Feedback_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Statuses_OneArgs = {
  object: Feedback_Statuses_Insert_Input;
  on_conflict?: InputMaybe<Feedback_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_VotesArgs = {
  objects: Array<Feedback_Votes_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_Votes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_Votes_OneArgs = {
  object: Feedback_Votes_Insert_Input;
  on_conflict?: InputMaybe<Feedback_Votes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flow_ConfigurationsArgs = {
  objects: Array<Flow_Configurations_Insert_Input>;
  on_conflict?: InputMaybe<Flow_Configurations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flow_Configurations_OneArgs = {
  object: Flow_Configurations_Insert_Input;
  on_conflict?: InputMaybe<Flow_Configurations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Full_Feed_Option_FlowArgs = {
  objects: Array<Full_Feed_Option_Flow_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Full_Feed_Option_Flow_OneArgs = {
  object: Full_Feed_Option_Flow_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Health_ChecksArgs = {
  objects: Array<Health_Checks_Insert_Input>;
  on_conflict?: InputMaybe<Health_Checks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Health_Checks_OneArgs = {
  object: Health_Checks_Insert_Input;
  on_conflict?: InputMaybe<Health_Checks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insider_TradesArgs = {
  objects: Array<Insider_Trades_Insert_Input>;
  on_conflict?: InputMaybe<Insider_Trades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insider_Trades_OneArgs = {
  object: Insider_Trades_Insert_Input;
  on_conflict?: InputMaybe<Insider_Trades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvoicesArgs = {
  objects: Array<Invoices_Insert_Input>;
  on_conflict?: InputMaybe<Invoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoices_OneArgs = {
  object: Invoices_Insert_Input;
  on_conflict?: InputMaybe<Invoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Microsoft_Access_TokensArgs = {
  objects: Array<Microsoft_Access_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Microsoft_Access_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Microsoft_Access_Tokens_OneArgs = {
  object: Microsoft_Access_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Microsoft_Access_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_News_Cache_StocksArgs = {
  objects: Array<News_Cache_Stocks_Insert_Input>;
  on_conflict?: InputMaybe<News_Cache_Stocks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_News_Cache_Stocks_OneArgs = {
  object: News_Cache_Stocks_Insert_Input;
  on_conflict?: InputMaybe<News_Cache_Stocks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Newsletter_PayloadsArgs = {
  objects: Array<Newsletter_Payloads_Insert_Input>;
  on_conflict?: InputMaybe<Newsletter_Payloads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Newsletter_Payloads_OneArgs = {
  object: Newsletter_Payloads_Insert_Input;
  on_conflict?: InputMaybe<Newsletter_Payloads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Opc_Saved_StrategiesArgs = {
  objects: Array<Opc_Saved_Strategies_Insert_Input>;
  on_conflict?: InputMaybe<Opc_Saved_Strategies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Opc_Saved_Strategies_OneArgs = {
  object: Opc_Saved_Strategies_Insert_Input;
  on_conflict?: InputMaybe<Opc_Saved_Strategies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Opc_Saved_Strategy_PositionsArgs = {
  objects: Array<Opc_Saved_Strategy_Positions_Insert_Input>;
  on_conflict?: InputMaybe<Opc_Saved_Strategy_Positions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Opc_Saved_Strategy_Positions_OneArgs = {
  object: Opc_Saved_Strategy_Positions_Insert_Input;
  on_conflict?: InputMaybe<Opc_Saved_Strategy_Positions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Option_Feed_BaselineArgs = {
  objects: Array<Option_Feed_Baseline_Insert_Input>;
  on_conflict?: InputMaybe<Option_Feed_Baseline_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Option_Feed_Baseline_OneArgs = {
  object: Option_Feed_Baseline_Insert_Input;
  on_conflict?: InputMaybe<Option_Feed_Baseline_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Option_Feed_FilteredArgs = {
  objects: Array<Option_Feed_Filtered_Insert_Input>;
  on_conflict?: InputMaybe<Option_Feed_Filtered_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Option_Feed_Filtered_OneArgs = {
  object: Option_Feed_Filtered_Insert_Input;
  on_conflict?: InputMaybe<Option_Feed_Filtered_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Options_EodArgs = {
  objects: Array<Options_Eod_Insert_Input>;
  on_conflict?: InputMaybe<Options_Eod_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Options_Eod_OneArgs = {
  object: Options_Eod_Insert_Input;
  on_conflict?: InputMaybe<Options_Eod_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prelaunch_Email_ListArgs = {
  objects: Array<Prelaunch_Email_List_Insert_Input>;
  on_conflict?: InputMaybe<Prelaunch_Email_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prelaunch_Email_List_OneArgs = {
  object: Prelaunch_Email_List_Insert_Input;
  on_conflict?: InputMaybe<Prelaunch_Email_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ready_CheckArgs = {
  objects: Array<Ready_Check_Insert_Input>;
  on_conflict?: InputMaybe<Ready_Check_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ready_Check_OneArgs = {
  object: Ready_Check_Insert_Input;
  on_conflict?: InputMaybe<Ready_Check_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Retention_FeedbackArgs = {
  objects: Array<Retention_Feedback_Insert_Input>;
  on_conflict?: InputMaybe<Retention_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Retention_Feedback_OneArgs = {
  object: Retention_Feedback_Insert_Input;
  on_conflict?: InputMaybe<Retention_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Retention_Intervention_EventsArgs = {
  objects: Array<Retention_Intervention_Events_Insert_Input>;
  on_conflict?: InputMaybe<Retention_Intervention_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Retention_Intervention_Events_OneArgs = {
  object: Retention_Intervention_Events_Insert_Input;
  on_conflict?: InputMaybe<Retention_Intervention_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Retention_Intervention_SessionsArgs = {
  objects: Array<Retention_Intervention_Sessions_Insert_Input>;
  on_conflict?: InputMaybe<Retention_Intervention_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Retention_Intervention_Sessions_OneArgs = {
  object: Retention_Intervention_Sessions_Insert_Input;
  on_conflict?: InputMaybe<Retention_Intervention_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Retention_Notification_DeliveriesArgs = {
  objects: Array<Retention_Notification_Deliveries_Insert_Input>;
  on_conflict?: InputMaybe<Retention_Notification_Deliveries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Retention_Notification_Deliveries_OneArgs = {
  object: Retention_Notification_Deliveries_Insert_Input;
  on_conflict?: InputMaybe<Retention_Notification_Deliveries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Retention_Offer_ExposuresArgs = {
  objects: Array<Retention_Offer_Exposures_Insert_Input>;
  on_conflict?: InputMaybe<Retention_Offer_Exposures_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Retention_Offer_Exposures_OneArgs = {
  object: Retention_Offer_Exposures_Insert_Input;
  on_conflict?: InputMaybe<Retention_Offer_Exposures_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SalesArgs = {
  objects: Array<Sales_Insert_Input>;
  on_conflict?: InputMaybe<Sales_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sales_OneArgs = {
  object: Sales_Insert_Input;
  on_conflict?: InputMaybe<Sales_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_EntitlementsArgs = {
  objects: Array<Subscription_Entitlements_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Entitlements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Entitlements_OneArgs = {
  object: Subscription_Entitlements_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Entitlements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubscriptionsArgs = {
  objects: Array<Subscriptions_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_OneArgs = {
  object: Subscriptions_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_Oct2023Args = {
  objects: Array<Test_Oct2023_Insert_Input>;
  on_conflict?: InputMaybe<Test_Oct2023_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_Oct2023_OneArgs = {
  object: Test_Oct2023_Insert_Input;
  on_conflict?: InputMaybe<Test_Oct2023_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ticker_DetailsArgs = {
  objects: Array<Ticker_Details_Insert_Input>;
  on_conflict?: InputMaybe<Ticker_Details_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ticker_Details_OneArgs = {
  object: Ticker_Details_Insert_Input;
  on_conflict?: InputMaybe<Ticker_Details_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ticker_Research_All_ViewsArgs = {
  objects: Array<Ticker_Research_All_Views_Insert_Input>;
  on_conflict?: InputMaybe<Ticker_Research_All_Views_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ticker_Research_All_Views_OneArgs = {
  object: Ticker_Research_All_Views_Insert_Input;
  on_conflict?: InputMaybe<Ticker_Research_All_Views_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ticker_Research_Daily_ViewsArgs = {
  objects: Array<Ticker_Research_Daily_Views_Insert_Input>;
  on_conflict?: InputMaybe<Ticker_Research_Daily_Views_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ticker_Research_Daily_Views_OneArgs = {
  object: Ticker_Research_Daily_Views_Insert_Input;
  on_conflict?: InputMaybe<Ticker_Research_Daily_Views_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Timezone_LocationArgs = {
  objects: Array<Timezone_Location_Insert_Input>;
  on_conflict?: InputMaybe<Timezone_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Timezone_Location_OneArgs = {
  object: Timezone_Location_Insert_Input;
  on_conflict?: InputMaybe<Timezone_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Top_TickersArgs = {
  objects: Array<Top_Tickers_Insert_Input>;
  on_conflict?: InputMaybe<Top_Tickers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Top_Tickers_OneArgs = {
  object: Top_Tickers_Insert_Input;
  on_conflict?: InputMaybe<Top_Tickers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Usage_PingArgs = {
  objects: Array<Usage_Ping_Insert_Input>;
  on_conflict?: InputMaybe<Usage_Ping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Usage_Ping_OneArgs = {
  object: Usage_Ping_Insert_Input;
  on_conflict?: InputMaybe<Usage_Ping_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Watch_ListArgs = {
  objects: Array<Watch_List_Insert_Input>;
  on_conflict?: InputMaybe<Watch_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Watch_List_OneArgs = {
  object: Watch_List_Insert_Input;
  on_conflict?: InputMaybe<Watch_List_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_Affiliate_Link_ClicksArgs = {
  _set?: InputMaybe<Affiliate_Link_Clicks_Set_Input>;
  where: Affiliate_Link_Clicks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Affiliate_Link_Clicks_By_PkArgs = {
  _set?: InputMaybe<Affiliate_Link_Clicks_Set_Input>;
  pk_columns: Affiliate_Link_Clicks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Affiliate_Link_Clicks_ManyArgs = {
  updates: Array<Affiliate_Link_Clicks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Affiliate_PayoutsArgs = {
  _inc?: InputMaybe<Affiliate_Payouts_Inc_Input>;
  _set?: InputMaybe<Affiliate_Payouts_Set_Input>;
  where: Affiliate_Payouts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Affiliate_Payouts_By_PkArgs = {
  _inc?: InputMaybe<Affiliate_Payouts_Inc_Input>;
  _set?: InputMaybe<Affiliate_Payouts_Set_Input>;
  pk_columns: Affiliate_Payouts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Affiliate_Payouts_ManyArgs = {
  updates: Array<Affiliate_Payouts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Signal_AlertsArgs = {
  _inc?: InputMaybe<Asset_Signal_Alerts_Inc_Input>;
  _set?: InputMaybe<Asset_Signal_Alerts_Set_Input>;
  where: Asset_Signal_Alerts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Signal_Alerts_By_PkArgs = {
  _inc?: InputMaybe<Asset_Signal_Alerts_Inc_Input>;
  _set?: InputMaybe<Asset_Signal_Alerts_Set_Input>;
  pk_columns: Asset_Signal_Alerts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Signal_Alerts_ManyArgs = {
  updates: Array<Asset_Signal_Alerts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ChargesArgs = {
  _append?: InputMaybe<Charges_Append_Input>;
  _delete_at_path?: InputMaybe<Charges_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Charges_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Charges_Delete_Key_Input>;
  _inc?: InputMaybe<Charges_Inc_Input>;
  _prepend?: InputMaybe<Charges_Prepend_Input>;
  _set?: InputMaybe<Charges_Set_Input>;
  where: Charges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Charges_By_PkArgs = {
  _append?: InputMaybe<Charges_Append_Input>;
  _delete_at_path?: InputMaybe<Charges_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Charges_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Charges_Delete_Key_Input>;
  _inc?: InputMaybe<Charges_Inc_Input>;
  _prepend?: InputMaybe<Charges_Prepend_Input>;
  _set?: InputMaybe<Charges_Set_Input>;
  pk_columns: Charges_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Charges_ManyArgs = {
  updates: Array<Charges_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Congress_TradesArgs = {
  _inc?: InputMaybe<Congress_Trades_Inc_Input>;
  _set?: InputMaybe<Congress_Trades_Set_Input>;
  where: Congress_Trades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Congress_Trades_By_PkArgs = {
  _inc?: InputMaybe<Congress_Trades_Inc_Input>;
  _set?: InputMaybe<Congress_Trades_Set_Input>;
  pk_columns: Congress_Trades_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Congress_Trades_ManyArgs = {
  updates: Array<Congress_Trades_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cookie_StringsArgs = {
  _set?: InputMaybe<Cookie_Strings_Set_Input>;
  where: Cookie_Strings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cookie_Strings_By_PkArgs = {
  _set?: InputMaybe<Cookie_Strings_Set_Input>;
  pk_columns: Cookie_Strings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cookie_Strings_ManyArgs = {
  updates: Array<Cookie_Strings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_ProgressArgs = {
  _set?: InputMaybe<Course_Progress_Set_Input>;
  where: Course_Progress_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Progress_By_PkArgs = {
  _set?: InputMaybe<Course_Progress_Set_Input>;
  pk_columns: Course_Progress_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Progress_ManyArgs = {
  updates: Array<Course_Progress_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Progress_StatusArgs = {
  _set?: InputMaybe<Course_Progress_Status_Set_Input>;
  where: Course_Progress_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Progress_Status_By_PkArgs = {
  _set?: InputMaybe<Course_Progress_Status_Set_Input>;
  pk_columns: Course_Progress_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Progress_Status_ManyArgs = {
  updates: Array<Course_Progress_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Demo_Filtered_Trades_SpiderrockArgs = {
  _append?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Append_Input>;
  _delete_at_path?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Delete_Key_Input>;
  _inc?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Inc_Input>;
  _prepend?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Prepend_Input>;
  _set?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Set_Input>;
  where: Demo_Filtered_Trades_Spiderrock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Demo_Filtered_Trades_Spiderrock_By_PkArgs = {
  _append?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Append_Input>;
  _delete_at_path?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Delete_Key_Input>;
  _inc?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Inc_Input>;
  _prepend?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Prepend_Input>;
  _set?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Set_Input>;
  pk_columns: Demo_Filtered_Trades_Spiderrock_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Demo_Filtered_Trades_Spiderrock_ManyArgs = {
  updates: Array<Demo_Filtered_Trades_Spiderrock_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Demo_Raw_Trades_SpiderrockArgs = {
  _inc?: InputMaybe<Demo_Raw_Trades_Spiderrock_Inc_Input>;
  _set?: InputMaybe<Demo_Raw_Trades_Spiderrock_Set_Input>;
  where: Demo_Raw_Trades_Spiderrock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Demo_Raw_Trades_Spiderrock_By_PkArgs = {
  _inc?: InputMaybe<Demo_Raw_Trades_Spiderrock_Inc_Input>;
  _set?: InputMaybe<Demo_Raw_Trades_Spiderrock_Set_Input>;
  pk_columns: Demo_Raw_Trades_Spiderrock_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Demo_Raw_Trades_Spiderrock_ManyArgs = {
  updates: Array<Demo_Raw_Trades_Spiderrock_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Earnings_SnpArgs = {
  _inc?: InputMaybe<Earnings_Snp_Inc_Input>;
  _set?: InputMaybe<Earnings_Snp_Set_Input>;
  where: Earnings_Snp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Earnings_Snp_By_PkArgs = {
  _inc?: InputMaybe<Earnings_Snp_Inc_Input>;
  _set?: InputMaybe<Earnings_Snp_Set_Input>;
  pk_columns: Earnings_Snp_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Earnings_Snp_ManyArgs = {
  updates: Array<Earnings_Snp_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_AlertsArgs = {
  _append?: InputMaybe<Email_Alerts_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Alerts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Alerts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Alerts_Delete_Key_Input>;
  _prepend?: InputMaybe<Email_Alerts_Prepend_Input>;
  _set?: InputMaybe<Email_Alerts_Set_Input>;
  where: Email_Alerts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Alerts_By_PkArgs = {
  _append?: InputMaybe<Email_Alerts_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Alerts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Alerts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Alerts_Delete_Key_Input>;
  _prepend?: InputMaybe<Email_Alerts_Prepend_Input>;
  _set?: InputMaybe<Email_Alerts_Set_Input>;
  pk_columns: Email_Alerts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Alerts_ManyArgs = {
  updates: Array<Email_Alerts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_ListArgs = {
  _set?: InputMaybe<Email_List_Set_Input>;
  where: Email_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_List_By_PkArgs = {
  _set?: InputMaybe<Email_List_Set_Input>;
  pk_columns: Email_List_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_List_ManyArgs = {
  updates: Array<Email_List_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Equities_EodArgs = {
  _inc?: InputMaybe<Equities_Eod_Inc_Input>;
  _set?: InputMaybe<Equities_Eod_Set_Input>;
  where: Equities_Eod_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Equities_Eod_By_PkArgs = {
  _inc?: InputMaybe<Equities_Eod_Inc_Input>;
  _set?: InputMaybe<Equities_Eod_Set_Input>;
  pk_columns: Equities_Eod_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Equities_Eod_ManyArgs = {
  updates: Array<Equities_Eod_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Equity_Pool_PrintsArgs = {
  _append?: InputMaybe<Equity_Pool_Prints_Append_Input>;
  _delete_at_path?: InputMaybe<Equity_Pool_Prints_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Equity_Pool_Prints_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Equity_Pool_Prints_Delete_Key_Input>;
  _inc?: InputMaybe<Equity_Pool_Prints_Inc_Input>;
  _prepend?: InputMaybe<Equity_Pool_Prints_Prepend_Input>;
  _set?: InputMaybe<Equity_Pool_Prints_Set_Input>;
  where: Equity_Pool_Prints_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Equity_Pool_Prints_By_PkArgs = {
  _append?: InputMaybe<Equity_Pool_Prints_Append_Input>;
  _delete_at_path?: InputMaybe<Equity_Pool_Prints_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Equity_Pool_Prints_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Equity_Pool_Prints_Delete_Key_Input>;
  _inc?: InputMaybe<Equity_Pool_Prints_Inc_Input>;
  _prepend?: InputMaybe<Equity_Pool_Prints_Prepend_Input>;
  _set?: InputMaybe<Equity_Pool_Prints_Set_Input>;
  pk_columns: Equity_Pool_Prints_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Equity_Pool_Prints_ManyArgs = {
  updates: Array<Equity_Pool_Prints_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Equity_Print_Feed_BaselineArgs = {
  _append?: InputMaybe<Equity_Print_Feed_Baseline_Append_Input>;
  _delete_at_path?: InputMaybe<Equity_Print_Feed_Baseline_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Equity_Print_Feed_Baseline_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Equity_Print_Feed_Baseline_Delete_Key_Input>;
  _inc?: InputMaybe<Equity_Print_Feed_Baseline_Inc_Input>;
  _prepend?: InputMaybe<Equity_Print_Feed_Baseline_Prepend_Input>;
  _set?: InputMaybe<Equity_Print_Feed_Baseline_Set_Input>;
  where: Equity_Print_Feed_Baseline_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Equity_Print_Feed_Baseline_By_PkArgs = {
  _append?: InputMaybe<Equity_Print_Feed_Baseline_Append_Input>;
  _delete_at_path?: InputMaybe<Equity_Print_Feed_Baseline_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Equity_Print_Feed_Baseline_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Equity_Print_Feed_Baseline_Delete_Key_Input>;
  _inc?: InputMaybe<Equity_Print_Feed_Baseline_Inc_Input>;
  _prepend?: InputMaybe<Equity_Print_Feed_Baseline_Prepend_Input>;
  _set?: InputMaybe<Equity_Print_Feed_Baseline_Set_Input>;
  pk_columns: Equity_Print_Feed_Baseline_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Equity_Print_Feed_Baseline_ManyArgs = {
  updates: Array<Equity_Print_Feed_Baseline_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Equity_Print_Feed_FilteredArgs = {
  _append?: InputMaybe<Equity_Print_Feed_Filtered_Append_Input>;
  _delete_at_path?: InputMaybe<Equity_Print_Feed_Filtered_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Equity_Print_Feed_Filtered_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Equity_Print_Feed_Filtered_Delete_Key_Input>;
  _inc?: InputMaybe<Equity_Print_Feed_Filtered_Inc_Input>;
  _prepend?: InputMaybe<Equity_Print_Feed_Filtered_Prepend_Input>;
  _set?: InputMaybe<Equity_Print_Feed_Filtered_Set_Input>;
  where: Equity_Print_Feed_Filtered_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Equity_Print_Feed_Filtered_By_PkArgs = {
  _append?: InputMaybe<Equity_Print_Feed_Filtered_Append_Input>;
  _delete_at_path?: InputMaybe<Equity_Print_Feed_Filtered_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Equity_Print_Feed_Filtered_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Equity_Print_Feed_Filtered_Delete_Key_Input>;
  _inc?: InputMaybe<Equity_Print_Feed_Filtered_Inc_Input>;
  _prepend?: InputMaybe<Equity_Print_Feed_Filtered_Prepend_Input>;
  _set?: InputMaybe<Equity_Print_Feed_Filtered_Set_Input>;
  pk_columns: Equity_Print_Feed_Filtered_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Equity_Print_Feed_Filtered_ManyArgs = {
  updates: Array<Equity_Print_Feed_Filtered_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fa_Trade_UploadsArgs = {
  _inc?: InputMaybe<Fa_Trade_Uploads_Inc_Input>;
  _set?: InputMaybe<Fa_Trade_Uploads_Set_Input>;
  where: Fa_Trade_Uploads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fa_Trade_Uploads_By_PkArgs = {
  _inc?: InputMaybe<Fa_Trade_Uploads_Inc_Input>;
  _set?: InputMaybe<Fa_Trade_Uploads_Set_Input>;
  pk_columns: Fa_Trade_Uploads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fa_Trade_Uploads_ManyArgs = {
  updates: Array<Fa_Trade_Uploads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fa_TradesArgs = {
  _inc?: InputMaybe<Fa_Trades_Inc_Input>;
  _set?: InputMaybe<Fa_Trades_Set_Input>;
  where: Fa_Trades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fa_Trades_By_PkArgs = {
  _inc?: InputMaybe<Fa_Trades_Inc_Input>;
  _set?: InputMaybe<Fa_Trades_Set_Input>;
  pk_columns: Fa_Trades_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fa_Trades_ManyArgs = {
  updates: Array<Fa_Trades_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_BoardsArgs = {
  _inc?: InputMaybe<Feedback_Boards_Inc_Input>;
  _set?: InputMaybe<Feedback_Boards_Set_Input>;
  where: Feedback_Boards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Boards_By_PkArgs = {
  _inc?: InputMaybe<Feedback_Boards_Inc_Input>;
  _set?: InputMaybe<Feedback_Boards_Set_Input>;
  pk_columns: Feedback_Boards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Boards_ManyArgs = {
  updates: Array<Feedback_Boards_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_CommentsArgs = {
  _set?: InputMaybe<Feedback_Comments_Set_Input>;
  where: Feedback_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Comments_By_PkArgs = {
  _set?: InputMaybe<Feedback_Comments_Set_Input>;
  pk_columns: Feedback_Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Comments_ManyArgs = {
  updates: Array<Feedback_Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_MediaArgs = {
  _inc?: InputMaybe<Feedback_Media_Inc_Input>;
  _set?: InputMaybe<Feedback_Media_Set_Input>;
  where: Feedback_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Media_By_PkArgs = {
  _inc?: InputMaybe<Feedback_Media_Inc_Input>;
  _set?: InputMaybe<Feedback_Media_Set_Input>;
  pk_columns: Feedback_Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Media_ManyArgs = {
  updates: Array<Feedback_Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Post_ContextsArgs = {
  _inc?: InputMaybe<Feedback_Post_Contexts_Inc_Input>;
  _set?: InputMaybe<Feedback_Post_Contexts_Set_Input>;
  where: Feedback_Post_Contexts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Post_Contexts_By_PkArgs = {
  _inc?: InputMaybe<Feedback_Post_Contexts_Inc_Input>;
  _set?: InputMaybe<Feedback_Post_Contexts_Set_Input>;
  pk_columns: Feedback_Post_Contexts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Post_Contexts_ManyArgs = {
  updates: Array<Feedback_Post_Contexts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Post_MergesArgs = {
  _inc?: InputMaybe<Feedback_Post_Merges_Inc_Input>;
  _set?: InputMaybe<Feedback_Post_Merges_Set_Input>;
  where: Feedback_Post_Merges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Post_Merges_By_PkArgs = {
  _inc?: InputMaybe<Feedback_Post_Merges_Inc_Input>;
  _set?: InputMaybe<Feedback_Post_Merges_Set_Input>;
  pk_columns: Feedback_Post_Merges_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Post_Merges_ManyArgs = {
  updates: Array<Feedback_Post_Merges_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_PostsArgs = {
  _inc?: InputMaybe<Feedback_Posts_Inc_Input>;
  _set?: InputMaybe<Feedback_Posts_Set_Input>;
  where: Feedback_Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Posts_By_PkArgs = {
  _inc?: InputMaybe<Feedback_Posts_Inc_Input>;
  _set?: InputMaybe<Feedback_Posts_Set_Input>;
  pk_columns: Feedback_Posts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Posts_ManyArgs = {
  updates: Array<Feedback_Posts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Posts_With_CountsArgs = {
  _inc?: InputMaybe<Feedback_Posts_With_Counts_Inc_Input>;
  _set?: InputMaybe<Feedback_Posts_With_Counts_Set_Input>;
  where: Feedback_Posts_With_Counts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Posts_With_Counts_ManyArgs = {
  updates: Array<Feedback_Posts_With_Counts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Release_PostsArgs = {
  _set?: InputMaybe<Feedback_Release_Posts_Set_Input>;
  where: Feedback_Release_Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Release_Posts_By_PkArgs = {
  _set?: InputMaybe<Feedback_Release_Posts_Set_Input>;
  pk_columns: Feedback_Release_Posts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Release_Posts_ManyArgs = {
  updates: Array<Feedback_Release_Posts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_ReleasesArgs = {
  _set?: InputMaybe<Feedback_Releases_Set_Input>;
  where: Feedback_Releases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Releases_By_PkArgs = {
  _set?: InputMaybe<Feedback_Releases_Set_Input>;
  pk_columns: Feedback_Releases_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Releases_ManyArgs = {
  updates: Array<Feedback_Releases_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_StatusesArgs = {
  _inc?: InputMaybe<Feedback_Statuses_Inc_Input>;
  _set?: InputMaybe<Feedback_Statuses_Set_Input>;
  where: Feedback_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Statuses_By_PkArgs = {
  _inc?: InputMaybe<Feedback_Statuses_Inc_Input>;
  _set?: InputMaybe<Feedback_Statuses_Set_Input>;
  pk_columns: Feedback_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Statuses_ManyArgs = {
  updates: Array<Feedback_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_VotesArgs = {
  _set?: InputMaybe<Feedback_Votes_Set_Input>;
  where: Feedback_Votes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Votes_By_PkArgs = {
  _set?: InputMaybe<Feedback_Votes_Set_Input>;
  pk_columns: Feedback_Votes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_Votes_ManyArgs = {
  updates: Array<Feedback_Votes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Flow_ConfigurationsArgs = {
  _append?: InputMaybe<Flow_Configurations_Append_Input>;
  _delete_at_path?: InputMaybe<Flow_Configurations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Flow_Configurations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Flow_Configurations_Delete_Key_Input>;
  _prepend?: InputMaybe<Flow_Configurations_Prepend_Input>;
  _set?: InputMaybe<Flow_Configurations_Set_Input>;
  where: Flow_Configurations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flow_Configurations_By_PkArgs = {
  _append?: InputMaybe<Flow_Configurations_Append_Input>;
  _delete_at_path?: InputMaybe<Flow_Configurations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Flow_Configurations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Flow_Configurations_Delete_Key_Input>;
  _prepend?: InputMaybe<Flow_Configurations_Prepend_Input>;
  _set?: InputMaybe<Flow_Configurations_Set_Input>;
  pk_columns: Flow_Configurations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flow_Configurations_ManyArgs = {
  updates: Array<Flow_Configurations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Full_Feed_Option_FlowArgs = {
  _append?: InputMaybe<Full_Feed_Option_Flow_Append_Input>;
  _delete_at_path?: InputMaybe<Full_Feed_Option_Flow_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Full_Feed_Option_Flow_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Full_Feed_Option_Flow_Delete_Key_Input>;
  _inc?: InputMaybe<Full_Feed_Option_Flow_Inc_Input>;
  _prepend?: InputMaybe<Full_Feed_Option_Flow_Prepend_Input>;
  _set?: InputMaybe<Full_Feed_Option_Flow_Set_Input>;
  where: Full_Feed_Option_Flow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Full_Feed_Option_Flow_ManyArgs = {
  updates: Array<Full_Feed_Option_Flow_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Health_ChecksArgs = {
  _set?: InputMaybe<Health_Checks_Set_Input>;
  where: Health_Checks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Health_Checks_By_PkArgs = {
  _set?: InputMaybe<Health_Checks_Set_Input>;
  pk_columns: Health_Checks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Health_Checks_ManyArgs = {
  updates: Array<Health_Checks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insider_TradesArgs = {
  _append?: InputMaybe<Insider_Trades_Append_Input>;
  _delete_at_path?: InputMaybe<Insider_Trades_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Insider_Trades_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Insider_Trades_Delete_Key_Input>;
  _inc?: InputMaybe<Insider_Trades_Inc_Input>;
  _prepend?: InputMaybe<Insider_Trades_Prepend_Input>;
  _set?: InputMaybe<Insider_Trades_Set_Input>;
  where: Insider_Trades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insider_Trades_By_PkArgs = {
  _append?: InputMaybe<Insider_Trades_Append_Input>;
  _delete_at_path?: InputMaybe<Insider_Trades_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Insider_Trades_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Insider_Trades_Delete_Key_Input>;
  _inc?: InputMaybe<Insider_Trades_Inc_Input>;
  _prepend?: InputMaybe<Insider_Trades_Prepend_Input>;
  _set?: InputMaybe<Insider_Trades_Set_Input>;
  pk_columns: Insider_Trades_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insider_Trades_ManyArgs = {
  updates: Array<Insider_Trades_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvoicesArgs = {
  _append?: InputMaybe<Invoices_Append_Input>;
  _delete_at_path?: InputMaybe<Invoices_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Invoices_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Invoices_Delete_Key_Input>;
  _inc?: InputMaybe<Invoices_Inc_Input>;
  _prepend?: InputMaybe<Invoices_Prepend_Input>;
  _set?: InputMaybe<Invoices_Set_Input>;
  where: Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoices_By_PkArgs = {
  _append?: InputMaybe<Invoices_Append_Input>;
  _delete_at_path?: InputMaybe<Invoices_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Invoices_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Invoices_Delete_Key_Input>;
  _inc?: InputMaybe<Invoices_Inc_Input>;
  _prepend?: InputMaybe<Invoices_Prepend_Input>;
  _set?: InputMaybe<Invoices_Set_Input>;
  pk_columns: Invoices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoices_ManyArgs = {
  updates: Array<Invoices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Microsoft_Access_TokensArgs = {
  _inc?: InputMaybe<Microsoft_Access_Tokens_Inc_Input>;
  _set?: InputMaybe<Microsoft_Access_Tokens_Set_Input>;
  where: Microsoft_Access_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Microsoft_Access_Tokens_By_PkArgs = {
  _inc?: InputMaybe<Microsoft_Access_Tokens_Inc_Input>;
  _set?: InputMaybe<Microsoft_Access_Tokens_Set_Input>;
  pk_columns: Microsoft_Access_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Microsoft_Access_Tokens_ManyArgs = {
  updates: Array<Microsoft_Access_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_News_Cache_StocksArgs = {
  _append?: InputMaybe<News_Cache_Stocks_Append_Input>;
  _delete_at_path?: InputMaybe<News_Cache_Stocks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<News_Cache_Stocks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<News_Cache_Stocks_Delete_Key_Input>;
  _prepend?: InputMaybe<News_Cache_Stocks_Prepend_Input>;
  _set?: InputMaybe<News_Cache_Stocks_Set_Input>;
  where: News_Cache_Stocks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_News_Cache_Stocks_By_PkArgs = {
  _append?: InputMaybe<News_Cache_Stocks_Append_Input>;
  _delete_at_path?: InputMaybe<News_Cache_Stocks_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<News_Cache_Stocks_Delete_Elem_Input>;
  _delete_key?: InputMaybe<News_Cache_Stocks_Delete_Key_Input>;
  _prepend?: InputMaybe<News_Cache_Stocks_Prepend_Input>;
  _set?: InputMaybe<News_Cache_Stocks_Set_Input>;
  pk_columns: News_Cache_Stocks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_News_Cache_Stocks_ManyArgs = {
  updates: Array<News_Cache_Stocks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Newsletter_PayloadsArgs = {
  _append?: InputMaybe<Newsletter_Payloads_Append_Input>;
  _delete_at_path?: InputMaybe<Newsletter_Payloads_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Newsletter_Payloads_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Newsletter_Payloads_Delete_Key_Input>;
  _prepend?: InputMaybe<Newsletter_Payloads_Prepend_Input>;
  _set?: InputMaybe<Newsletter_Payloads_Set_Input>;
  where: Newsletter_Payloads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Newsletter_Payloads_By_PkArgs = {
  _append?: InputMaybe<Newsletter_Payloads_Append_Input>;
  _delete_at_path?: InputMaybe<Newsletter_Payloads_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Newsletter_Payloads_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Newsletter_Payloads_Delete_Key_Input>;
  _prepend?: InputMaybe<Newsletter_Payloads_Prepend_Input>;
  _set?: InputMaybe<Newsletter_Payloads_Set_Input>;
  pk_columns: Newsletter_Payloads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Newsletter_Payloads_ManyArgs = {
  updates: Array<Newsletter_Payloads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Opc_Saved_StrategiesArgs = {
  _append?: InputMaybe<Opc_Saved_Strategies_Append_Input>;
  _delete_at_path?: InputMaybe<Opc_Saved_Strategies_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Opc_Saved_Strategies_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Opc_Saved_Strategies_Delete_Key_Input>;
  _inc?: InputMaybe<Opc_Saved_Strategies_Inc_Input>;
  _prepend?: InputMaybe<Opc_Saved_Strategies_Prepend_Input>;
  _set?: InputMaybe<Opc_Saved_Strategies_Set_Input>;
  where: Opc_Saved_Strategies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Opc_Saved_Strategies_By_PkArgs = {
  _append?: InputMaybe<Opc_Saved_Strategies_Append_Input>;
  _delete_at_path?: InputMaybe<Opc_Saved_Strategies_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Opc_Saved_Strategies_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Opc_Saved_Strategies_Delete_Key_Input>;
  _inc?: InputMaybe<Opc_Saved_Strategies_Inc_Input>;
  _prepend?: InputMaybe<Opc_Saved_Strategies_Prepend_Input>;
  _set?: InputMaybe<Opc_Saved_Strategies_Set_Input>;
  pk_columns: Opc_Saved_Strategies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Opc_Saved_Strategies_ManyArgs = {
  updates: Array<Opc_Saved_Strategies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Opc_Saved_Strategy_PositionsArgs = {
  _inc?: InputMaybe<Opc_Saved_Strategy_Positions_Inc_Input>;
  _set?: InputMaybe<Opc_Saved_Strategy_Positions_Set_Input>;
  where: Opc_Saved_Strategy_Positions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Opc_Saved_Strategy_Positions_By_PkArgs = {
  _inc?: InputMaybe<Opc_Saved_Strategy_Positions_Inc_Input>;
  _set?: InputMaybe<Opc_Saved_Strategy_Positions_Set_Input>;
  pk_columns: Opc_Saved_Strategy_Positions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Opc_Saved_Strategy_Positions_ManyArgs = {
  updates: Array<Opc_Saved_Strategy_Positions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Option_Feed_BaselineArgs = {
  _append?: InputMaybe<Option_Feed_Baseline_Append_Input>;
  _delete_at_path?: InputMaybe<Option_Feed_Baseline_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Option_Feed_Baseline_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Option_Feed_Baseline_Delete_Key_Input>;
  _inc?: InputMaybe<Option_Feed_Baseline_Inc_Input>;
  _prepend?: InputMaybe<Option_Feed_Baseline_Prepend_Input>;
  _set?: InputMaybe<Option_Feed_Baseline_Set_Input>;
  where: Option_Feed_Baseline_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Option_Feed_Baseline_By_PkArgs = {
  _append?: InputMaybe<Option_Feed_Baseline_Append_Input>;
  _delete_at_path?: InputMaybe<Option_Feed_Baseline_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Option_Feed_Baseline_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Option_Feed_Baseline_Delete_Key_Input>;
  _inc?: InputMaybe<Option_Feed_Baseline_Inc_Input>;
  _prepend?: InputMaybe<Option_Feed_Baseline_Prepend_Input>;
  _set?: InputMaybe<Option_Feed_Baseline_Set_Input>;
  pk_columns: Option_Feed_Baseline_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Option_Feed_Baseline_ManyArgs = {
  updates: Array<Option_Feed_Baseline_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Option_Feed_FilteredArgs = {
  _append?: InputMaybe<Option_Feed_Filtered_Append_Input>;
  _delete_at_path?: InputMaybe<Option_Feed_Filtered_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Option_Feed_Filtered_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Option_Feed_Filtered_Delete_Key_Input>;
  _inc?: InputMaybe<Option_Feed_Filtered_Inc_Input>;
  _prepend?: InputMaybe<Option_Feed_Filtered_Prepend_Input>;
  _set?: InputMaybe<Option_Feed_Filtered_Set_Input>;
  where: Option_Feed_Filtered_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Option_Feed_Filtered_By_PkArgs = {
  _append?: InputMaybe<Option_Feed_Filtered_Append_Input>;
  _delete_at_path?: InputMaybe<Option_Feed_Filtered_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Option_Feed_Filtered_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Option_Feed_Filtered_Delete_Key_Input>;
  _inc?: InputMaybe<Option_Feed_Filtered_Inc_Input>;
  _prepend?: InputMaybe<Option_Feed_Filtered_Prepend_Input>;
  _set?: InputMaybe<Option_Feed_Filtered_Set_Input>;
  pk_columns: Option_Feed_Filtered_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Option_Feed_Filtered_ManyArgs = {
  updates: Array<Option_Feed_Filtered_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Options_EodArgs = {
  _append?: InputMaybe<Options_Eod_Append_Input>;
  _delete_at_path?: InputMaybe<Options_Eod_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Options_Eod_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Options_Eod_Delete_Key_Input>;
  _inc?: InputMaybe<Options_Eod_Inc_Input>;
  _prepend?: InputMaybe<Options_Eod_Prepend_Input>;
  _set?: InputMaybe<Options_Eod_Set_Input>;
  where: Options_Eod_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Options_Eod_By_PkArgs = {
  _append?: InputMaybe<Options_Eod_Append_Input>;
  _delete_at_path?: InputMaybe<Options_Eod_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Options_Eod_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Options_Eod_Delete_Key_Input>;
  _inc?: InputMaybe<Options_Eod_Inc_Input>;
  _prepend?: InputMaybe<Options_Eod_Prepend_Input>;
  _set?: InputMaybe<Options_Eod_Set_Input>;
  pk_columns: Options_Eod_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Options_Eod_ManyArgs = {
  updates: Array<Options_Eod_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Prelaunch_Email_ListArgs = {
  _set?: InputMaybe<Prelaunch_Email_List_Set_Input>;
  where: Prelaunch_Email_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prelaunch_Email_List_By_PkArgs = {
  _set?: InputMaybe<Prelaunch_Email_List_Set_Input>;
  pk_columns: Prelaunch_Email_List_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prelaunch_Email_List_ManyArgs = {
  updates: Array<Prelaunch_Email_List_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ready_CheckArgs = {
  _set?: InputMaybe<Ready_Check_Set_Input>;
  where: Ready_Check_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ready_Check_By_PkArgs = {
  _set?: InputMaybe<Ready_Check_Set_Input>;
  pk_columns: Ready_Check_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ready_Check_ManyArgs = {
  updates: Array<Ready_Check_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_FeedbackArgs = {
  _set?: InputMaybe<Retention_Feedback_Set_Input>;
  where: Retention_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Feedback_By_PkArgs = {
  _set?: InputMaybe<Retention_Feedback_Set_Input>;
  pk_columns: Retention_Feedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Feedback_ManyArgs = {
  updates: Array<Retention_Feedback_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Intervention_EventsArgs = {
  _append?: InputMaybe<Retention_Intervention_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Retention_Intervention_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Retention_Intervention_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Retention_Intervention_Events_Delete_Key_Input>;
  _inc?: InputMaybe<Retention_Intervention_Events_Inc_Input>;
  _prepend?: InputMaybe<Retention_Intervention_Events_Prepend_Input>;
  _set?: InputMaybe<Retention_Intervention_Events_Set_Input>;
  where: Retention_Intervention_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Intervention_Events_By_PkArgs = {
  _append?: InputMaybe<Retention_Intervention_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Retention_Intervention_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Retention_Intervention_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Retention_Intervention_Events_Delete_Key_Input>;
  _inc?: InputMaybe<Retention_Intervention_Events_Inc_Input>;
  _prepend?: InputMaybe<Retention_Intervention_Events_Prepend_Input>;
  _set?: InputMaybe<Retention_Intervention_Events_Set_Input>;
  pk_columns: Retention_Intervention_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Intervention_Events_ManyArgs = {
  updates: Array<Retention_Intervention_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Intervention_SessionsArgs = {
  _append?: InputMaybe<Retention_Intervention_Sessions_Append_Input>;
  _delete_at_path?: InputMaybe<Retention_Intervention_Sessions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Retention_Intervention_Sessions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Retention_Intervention_Sessions_Delete_Key_Input>;
  _prepend?: InputMaybe<Retention_Intervention_Sessions_Prepend_Input>;
  _set?: InputMaybe<Retention_Intervention_Sessions_Set_Input>;
  where: Retention_Intervention_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Intervention_Sessions_By_PkArgs = {
  _append?: InputMaybe<Retention_Intervention_Sessions_Append_Input>;
  _delete_at_path?: InputMaybe<Retention_Intervention_Sessions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Retention_Intervention_Sessions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Retention_Intervention_Sessions_Delete_Key_Input>;
  _prepend?: InputMaybe<Retention_Intervention_Sessions_Prepend_Input>;
  _set?: InputMaybe<Retention_Intervention_Sessions_Set_Input>;
  pk_columns: Retention_Intervention_Sessions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Intervention_Sessions_ManyArgs = {
  updates: Array<Retention_Intervention_Sessions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Notification_DeliveriesArgs = {
  _set?: InputMaybe<Retention_Notification_Deliveries_Set_Input>;
  where: Retention_Notification_Deliveries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Notification_Deliveries_By_PkArgs = {
  _set?: InputMaybe<Retention_Notification_Deliveries_Set_Input>;
  pk_columns: Retention_Notification_Deliveries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Notification_Deliveries_ManyArgs = {
  updates: Array<Retention_Notification_Deliveries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Offer_ExposuresArgs = {
  _inc?: InputMaybe<Retention_Offer_Exposures_Inc_Input>;
  _set?: InputMaybe<Retention_Offer_Exposures_Set_Input>;
  where: Retention_Offer_Exposures_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Offer_Exposures_By_PkArgs = {
  _inc?: InputMaybe<Retention_Offer_Exposures_Inc_Input>;
  _set?: InputMaybe<Retention_Offer_Exposures_Set_Input>;
  pk_columns: Retention_Offer_Exposures_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Retention_Offer_Exposures_ManyArgs = {
  updates: Array<Retention_Offer_Exposures_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SalesArgs = {
  _append?: InputMaybe<Sales_Append_Input>;
  _delete_at_path?: InputMaybe<Sales_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sales_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sales_Delete_Key_Input>;
  _inc?: InputMaybe<Sales_Inc_Input>;
  _prepend?: InputMaybe<Sales_Prepend_Input>;
  _set?: InputMaybe<Sales_Set_Input>;
  where: Sales_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sales_By_PkArgs = {
  _append?: InputMaybe<Sales_Append_Input>;
  _delete_at_path?: InputMaybe<Sales_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sales_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sales_Delete_Key_Input>;
  _inc?: InputMaybe<Sales_Inc_Input>;
  _prepend?: InputMaybe<Sales_Prepend_Input>;
  _set?: InputMaybe<Sales_Set_Input>;
  pk_columns: Sales_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sales_ManyArgs = {
  updates: Array<Sales_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_EntitlementsArgs = {
  _set?: InputMaybe<Subscription_Entitlements_Set_Input>;
  where: Subscription_Entitlements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Entitlements_By_PkArgs = {
  _set?: InputMaybe<Subscription_Entitlements_Set_Input>;
  pk_columns: Subscription_Entitlements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Entitlements_ManyArgs = {
  updates: Array<Subscription_Entitlements_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubscriptionsArgs = {
  _append?: InputMaybe<Subscriptions_Append_Input>;
  _delete_at_path?: InputMaybe<Subscriptions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Subscriptions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Subscriptions_Delete_Key_Input>;
  _prepend?: InputMaybe<Subscriptions_Prepend_Input>;
  _set?: InputMaybe<Subscriptions_Set_Input>;
  where: Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_By_PkArgs = {
  _append?: InputMaybe<Subscriptions_Append_Input>;
  _delete_at_path?: InputMaybe<Subscriptions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Subscriptions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Subscriptions_Delete_Key_Input>;
  _prepend?: InputMaybe<Subscriptions_Prepend_Input>;
  _set?: InputMaybe<Subscriptions_Set_Input>;
  pk_columns: Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_ManyArgs = {
  updates: Array<Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Test_Oct2023Args = {
  _set?: InputMaybe<Test_Oct2023_Set_Input>;
  where: Test_Oct2023_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Test_Oct2023_By_PkArgs = {
  _set?: InputMaybe<Test_Oct2023_Set_Input>;
  pk_columns: Test_Oct2023_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Test_Oct2023_ManyArgs = {
  updates: Array<Test_Oct2023_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ticker_DetailsArgs = {
  _inc?: InputMaybe<Ticker_Details_Inc_Input>;
  _set?: InputMaybe<Ticker_Details_Set_Input>;
  where: Ticker_Details_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ticker_Details_By_PkArgs = {
  _inc?: InputMaybe<Ticker_Details_Inc_Input>;
  _set?: InputMaybe<Ticker_Details_Set_Input>;
  pk_columns: Ticker_Details_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ticker_Details_ManyArgs = {
  updates: Array<Ticker_Details_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ticker_Research_All_ViewsArgs = {
  _set?: InputMaybe<Ticker_Research_All_Views_Set_Input>;
  where: Ticker_Research_All_Views_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ticker_Research_All_Views_By_PkArgs = {
  _set?: InputMaybe<Ticker_Research_All_Views_Set_Input>;
  pk_columns: Ticker_Research_All_Views_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ticker_Research_All_Views_ManyArgs = {
  updates: Array<Ticker_Research_All_Views_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ticker_Research_Daily_ViewsArgs = {
  _set?: InputMaybe<Ticker_Research_Daily_Views_Set_Input>;
  where: Ticker_Research_Daily_Views_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ticker_Research_Daily_Views_By_PkArgs = {
  _set?: InputMaybe<Ticker_Research_Daily_Views_Set_Input>;
  pk_columns: Ticker_Research_Daily_Views_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ticker_Research_Daily_Views_ManyArgs = {
  updates: Array<Ticker_Research_Daily_Views_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Timezone_LocationArgs = {
  _set?: InputMaybe<Timezone_Location_Set_Input>;
  where: Timezone_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Timezone_Location_By_PkArgs = {
  _set?: InputMaybe<Timezone_Location_Set_Input>;
  pk_columns: Timezone_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Timezone_Location_ManyArgs = {
  updates: Array<Timezone_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Top_TickersArgs = {
  _set?: InputMaybe<Top_Tickers_Set_Input>;
  where: Top_Tickers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Top_Tickers_By_PkArgs = {
  _set?: InputMaybe<Top_Tickers_Set_Input>;
  pk_columns: Top_Tickers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Top_Tickers_ManyArgs = {
  updates: Array<Top_Tickers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Usage_PingArgs = {
  _set?: InputMaybe<Usage_Ping_Set_Input>;
  where: Usage_Ping_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Usage_Ping_By_PkArgs = {
  _set?: InputMaybe<Usage_Ping_Set_Input>;
  pk_columns: Usage_Ping_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Usage_Ping_ManyArgs = {
  updates: Array<Usage_Ping_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Watch_ListArgs = {
  _set?: InputMaybe<Watch_List_Set_Input>;
  where: Watch_List_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Watch_List_By_PkArgs = {
  _set?: InputMaybe<Watch_List_Set_Input>;
  pk_columns: Watch_List_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Watch_List_ManyArgs = {
  updates: Array<Watch_List_Updates>;
};

/** columns and relationships of "news_cache_stocks" */
export type News_Cache_Stocks = {
  __typename?: 'news_cache_stocks';
  createdAt: Scalars['timestamptz'];
  id: Scalars['String'];
  response: Scalars['jsonb'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "news_cache_stocks" */
export type News_Cache_StocksResponseArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "news_cache_stocks" */
export type News_Cache_Stocks_Aggregate = {
  __typename?: 'news_cache_stocks_aggregate';
  aggregate?: Maybe<News_Cache_Stocks_Aggregate_Fields>;
  nodes: Array<News_Cache_Stocks>;
};

/** aggregate fields of "news_cache_stocks" */
export type News_Cache_Stocks_Aggregate_Fields = {
  __typename?: 'news_cache_stocks_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<News_Cache_Stocks_Max_Fields>;
  min?: Maybe<News_Cache_Stocks_Min_Fields>;
};


/** aggregate fields of "news_cache_stocks" */
export type News_Cache_Stocks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<News_Cache_Stocks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type News_Cache_Stocks_Append_Input = {
  response?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "news_cache_stocks". All fields are combined with a logical 'AND'. */
export type News_Cache_Stocks_Bool_Exp = {
  _and?: InputMaybe<Array<News_Cache_Stocks_Bool_Exp>>;
  _not?: InputMaybe<News_Cache_Stocks_Bool_Exp>;
  _or?: InputMaybe<Array<News_Cache_Stocks_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  response?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "news_cache_stocks" */
export const News_Cache_Stocks_Constraint = {
  /** unique or primary key constraint on columns "id" */
  NewsCacheStocksPkey: 'news_cache_stocks_pkey'
} as const;

export type News_Cache_Stocks_Constraint = typeof News_Cache_Stocks_Constraint[keyof typeof News_Cache_Stocks_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type News_Cache_Stocks_Delete_At_Path_Input = {
  response?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type News_Cache_Stocks_Delete_Elem_Input = {
  response?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type News_Cache_Stocks_Delete_Key_Input = {
  response?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "news_cache_stocks" */
export type News_Cache_Stocks_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type News_Cache_Stocks_Max_Fields = {
  __typename?: 'news_cache_stocks_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type News_Cache_Stocks_Min_Fields = {
  __typename?: 'news_cache_stocks_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "news_cache_stocks" */
export type News_Cache_Stocks_Mutation_Response = {
  __typename?: 'news_cache_stocks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<News_Cache_Stocks>;
};

/** on_conflict condition type for table "news_cache_stocks" */
export type News_Cache_Stocks_On_Conflict = {
  constraint: News_Cache_Stocks_Constraint;
  update_columns?: Array<News_Cache_Stocks_Update_Column>;
  where?: InputMaybe<News_Cache_Stocks_Bool_Exp>;
};

/** Ordering options when selecting data from "news_cache_stocks". */
export type News_Cache_Stocks_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: news_cache_stocks */
export type News_Cache_Stocks_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type News_Cache_Stocks_Prepend_Input = {
  response?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "news_cache_stocks" */
export const News_Cache_Stocks_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  Response: 'response',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type News_Cache_Stocks_Select_Column = typeof News_Cache_Stocks_Select_Column[keyof typeof News_Cache_Stocks_Select_Column];
/** input type for updating data in table "news_cache_stocks" */
export type News_Cache_Stocks_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "news_cache_stocks" */
export type News_Cache_Stocks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: News_Cache_Stocks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type News_Cache_Stocks_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "news_cache_stocks" */
export const News_Cache_Stocks_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  Response: 'response',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type News_Cache_Stocks_Update_Column = typeof News_Cache_Stocks_Update_Column[keyof typeof News_Cache_Stocks_Update_Column];
export type News_Cache_Stocks_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<News_Cache_Stocks_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<News_Cache_Stocks_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<News_Cache_Stocks_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<News_Cache_Stocks_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<News_Cache_Stocks_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<News_Cache_Stocks_Set_Input>;
  /** filter the rows which have to be updated */
  where: News_Cache_Stocks_Bool_Exp;
};

/** columns and relationships of "newsletter_payloads" */
export type Newsletter_Payloads = {
  __typename?: 'newsletter_payloads';
  created_at: Scalars['timestamptz'];
  id: Scalars['String'];
  payload: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "newsletter_payloads" */
export type Newsletter_PayloadsPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "newsletter_payloads" */
export type Newsletter_Payloads_Aggregate = {
  __typename?: 'newsletter_payloads_aggregate';
  aggregate?: Maybe<Newsletter_Payloads_Aggregate_Fields>;
  nodes: Array<Newsletter_Payloads>;
};

/** aggregate fields of "newsletter_payloads" */
export type Newsletter_Payloads_Aggregate_Fields = {
  __typename?: 'newsletter_payloads_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Newsletter_Payloads_Max_Fields>;
  min?: Maybe<Newsletter_Payloads_Min_Fields>;
};


/** aggregate fields of "newsletter_payloads" */
export type Newsletter_Payloads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Newsletter_Payloads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Newsletter_Payloads_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "newsletter_payloads". All fields are combined with a logical 'AND'. */
export type Newsletter_Payloads_Bool_Exp = {
  _and?: InputMaybe<Array<Newsletter_Payloads_Bool_Exp>>;
  _not?: InputMaybe<Newsletter_Payloads_Bool_Exp>;
  _or?: InputMaybe<Array<Newsletter_Payloads_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "newsletter_payloads" */
export const Newsletter_Payloads_Constraint = {
  /** unique or primary key constraint on columns "id" */
  NewsletterPayloadsPkey: 'newsletter_payloads_pkey'
} as const;

export type Newsletter_Payloads_Constraint = typeof Newsletter_Payloads_Constraint[keyof typeof Newsletter_Payloads_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Newsletter_Payloads_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Newsletter_Payloads_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Newsletter_Payloads_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "newsletter_payloads" */
export type Newsletter_Payloads_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Newsletter_Payloads_Max_Fields = {
  __typename?: 'newsletter_payloads_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Newsletter_Payloads_Min_Fields = {
  __typename?: 'newsletter_payloads_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "newsletter_payloads" */
export type Newsletter_Payloads_Mutation_Response = {
  __typename?: 'newsletter_payloads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Newsletter_Payloads>;
};

/** on_conflict condition type for table "newsletter_payloads" */
export type Newsletter_Payloads_On_Conflict = {
  constraint: Newsletter_Payloads_Constraint;
  update_columns?: Array<Newsletter_Payloads_Update_Column>;
  where?: InputMaybe<Newsletter_Payloads_Bool_Exp>;
};

/** Ordering options when selecting data from "newsletter_payloads". */
export type Newsletter_Payloads_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: newsletter_payloads */
export type Newsletter_Payloads_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Newsletter_Payloads_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "newsletter_payloads" */
export const Newsletter_Payloads_Select_Column = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Payload: 'payload',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type Newsletter_Payloads_Select_Column = typeof Newsletter_Payloads_Select_Column[keyof typeof Newsletter_Payloads_Select_Column];
/** input type for updating data in table "newsletter_payloads" */
export type Newsletter_Payloads_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "newsletter_payloads" */
export type Newsletter_Payloads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Newsletter_Payloads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Newsletter_Payloads_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "newsletter_payloads" */
export const Newsletter_Payloads_Update_Column = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  Payload: 'payload',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type Newsletter_Payloads_Update_Column = typeof Newsletter_Payloads_Update_Column[keyof typeof Newsletter_Payloads_Update_Column];
export type Newsletter_Payloads_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Newsletter_Payloads_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Newsletter_Payloads_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Newsletter_Payloads_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Newsletter_Payloads_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Newsletter_Payloads_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Newsletter_Payloads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Newsletter_Payloads_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "opc_saved_strategies" */
export type Opc_Saved_Strategies = {
  __typename?: 'opc_saved_strategies';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  breakEvenPrices: Scalars['jsonb'];
  cash: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  delta: Scalars['numeric'];
  description: Scalars['String'];
  expiration: Scalars['date'];
  gamma: Scalars['numeric'];
  id: Scalars['uuid'];
  impliedVolatility: Scalars['numeric'];
  isStrategyShared: Scalars['Boolean'];
  maxLoss?: Maybe<Scalars['numeric']>;
  maxProfit?: Maybe<Scalars['numeric']>;
  netCreditDebit: Scalars['numeric'];
  /** An array relationship */
  positions: Array<Opc_Saved_Strategy_Positions>;
  /** An aggregate relationship */
  positions_aggregate: Opc_Saved_Strategy_Positions_Aggregate;
  premiumTransacted: Scalars['numeric'];
  probabilityOfProfit: Scalars['numeric'];
  profitIndex: Scalars['numeric'];
  rho: Scalars['numeric'];
  riskFreeRate: Scalars['numeric'];
  stockPrice: Scalars['numeric'];
  stockShares: Scalars['numeric'];
  theta: Scalars['numeric'];
  ticker: Scalars['String'];
  /** An object relationship */
  tickerDetails: Ticker_Details;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
  /** The sum of the option premium received/paid and the stock position */
  value: Scalars['numeric'];
  vega: Scalars['numeric'];
};


/** columns and relationships of "opc_saved_strategies" */
export type Opc_Saved_StrategiesBreakEvenPricesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "opc_saved_strategies" */
export type Opc_Saved_StrategiesPositionsArgs = {
  distinct_on?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Order_By>>;
  where?: InputMaybe<Opc_Saved_Strategy_Positions_Bool_Exp>;
};


/** columns and relationships of "opc_saved_strategies" */
export type Opc_Saved_StrategiesPositions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Order_By>>;
  where?: InputMaybe<Opc_Saved_Strategy_Positions_Bool_Exp>;
};

/** aggregated selection of "opc_saved_strategies" */
export type Opc_Saved_Strategies_Aggregate = {
  __typename?: 'opc_saved_strategies_aggregate';
  aggregate?: Maybe<Opc_Saved_Strategies_Aggregate_Fields>;
  nodes: Array<Opc_Saved_Strategies>;
};

export type Opc_Saved_Strategies_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Opc_Saved_Strategies_Aggregate_Bool_Exp_Count>;
};

export type Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_And = {
  arguments: Opc_Saved_Strategies_Select_Column_Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Opc_Saved_Strategies_Select_Column_Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Opc_Saved_Strategies_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Opc_Saved_Strategies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "opc_saved_strategies" */
export type Opc_Saved_Strategies_Aggregate_Fields = {
  __typename?: 'opc_saved_strategies_aggregate_fields';
  avg?: Maybe<Opc_Saved_Strategies_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Opc_Saved_Strategies_Max_Fields>;
  min?: Maybe<Opc_Saved_Strategies_Min_Fields>;
  stddev?: Maybe<Opc_Saved_Strategies_Stddev_Fields>;
  stddev_pop?: Maybe<Opc_Saved_Strategies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Opc_Saved_Strategies_Stddev_Samp_Fields>;
  sum?: Maybe<Opc_Saved_Strategies_Sum_Fields>;
  var_pop?: Maybe<Opc_Saved_Strategies_Var_Pop_Fields>;
  var_samp?: Maybe<Opc_Saved_Strategies_Var_Samp_Fields>;
  variance?: Maybe<Opc_Saved_Strategies_Variance_Fields>;
};


/** aggregate fields of "opc_saved_strategies" */
export type Opc_Saved_Strategies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Opc_Saved_Strategies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Aggregate_Order_By = {
  avg?: InputMaybe<Opc_Saved_Strategies_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Opc_Saved_Strategies_Max_Order_By>;
  min?: InputMaybe<Opc_Saved_Strategies_Min_Order_By>;
  stddev?: InputMaybe<Opc_Saved_Strategies_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Opc_Saved_Strategies_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Opc_Saved_Strategies_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Opc_Saved_Strategies_Sum_Order_By>;
  var_pop?: InputMaybe<Opc_Saved_Strategies_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Opc_Saved_Strategies_Var_Samp_Order_By>;
  variance?: InputMaybe<Opc_Saved_Strategies_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Opc_Saved_Strategies_Append_Input = {
  breakEvenPrices?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Arr_Rel_Insert_Input = {
  data: Array<Opc_Saved_Strategies_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Opc_Saved_Strategies_On_Conflict>;
};

/** aggregate avg on columns */
export type Opc_Saved_Strategies_Avg_Fields = {
  __typename?: 'opc_saved_strategies_avg_fields';
  cash?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  maxLoss?: Maybe<Scalars['Float']>;
  maxProfit?: Maybe<Scalars['Float']>;
  netCreditDebit?: Maybe<Scalars['Float']>;
  premiumTransacted?: Maybe<Scalars['Float']>;
  probabilityOfProfit?: Maybe<Scalars['Float']>;
  profitIndex?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  stockPrice?: Maybe<Scalars['Float']>;
  stockShares?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Avg_Order_By = {
  cash?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  maxLoss?: InputMaybe<Order_By>;
  maxProfit?: InputMaybe<Order_By>;
  netCreditDebit?: InputMaybe<Order_By>;
  premiumTransacted?: InputMaybe<Order_By>;
  probabilityOfProfit?: InputMaybe<Order_By>;
  profitIndex?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  stockPrice?: InputMaybe<Order_By>;
  stockShares?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "opc_saved_strategies". All fields are combined with a logical 'AND'. */
export type Opc_Saved_Strategies_Bool_Exp = {
  _and?: InputMaybe<Array<Opc_Saved_Strategies_Bool_Exp>>;
  _not?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
  _or?: InputMaybe<Array<Opc_Saved_Strategies_Bool_Exp>>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  breakEvenPrices?: InputMaybe<Jsonb_Comparison_Exp>;
  cash?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  expiration?: InputMaybe<Date_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  impliedVolatility?: InputMaybe<Numeric_Comparison_Exp>;
  isStrategyShared?: InputMaybe<Boolean_Comparison_Exp>;
  maxLoss?: InputMaybe<Numeric_Comparison_Exp>;
  maxProfit?: InputMaybe<Numeric_Comparison_Exp>;
  netCreditDebit?: InputMaybe<Numeric_Comparison_Exp>;
  positions?: InputMaybe<Opc_Saved_Strategy_Positions_Bool_Exp>;
  positions_aggregate?: InputMaybe<Opc_Saved_Strategy_Positions_Aggregate_Bool_Exp>;
  premiumTransacted?: InputMaybe<Numeric_Comparison_Exp>;
  probabilityOfProfit?: InputMaybe<Numeric_Comparison_Exp>;
  profitIndex?: InputMaybe<Numeric_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  stockPrice?: InputMaybe<Numeric_Comparison_Exp>;
  stockShares?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "opc_saved_strategies" */
export const Opc_Saved_Strategies_Constraint = {
  /** unique or primary key constraint on columns "id" */
  OpcSavedStrategiesPkey: 'opc_saved_strategies_pkey'
} as const;

export type Opc_Saved_Strategies_Constraint = typeof Opc_Saved_Strategies_Constraint[keyof typeof Opc_Saved_Strategies_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Opc_Saved_Strategies_Delete_At_Path_Input = {
  breakEvenPrices?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Opc_Saved_Strategies_Delete_Elem_Input = {
  breakEvenPrices?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Opc_Saved_Strategies_Delete_Key_Input = {
  breakEvenPrices?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Inc_Input = {
  cash?: InputMaybe<Scalars['numeric']>;
  delta?: InputMaybe<Scalars['numeric']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  impliedVolatility?: InputMaybe<Scalars['numeric']>;
  maxLoss?: InputMaybe<Scalars['numeric']>;
  maxProfit?: InputMaybe<Scalars['numeric']>;
  netCreditDebit?: InputMaybe<Scalars['numeric']>;
  premiumTransacted?: InputMaybe<Scalars['numeric']>;
  probabilityOfProfit?: InputMaybe<Scalars['numeric']>;
  profitIndex?: InputMaybe<Scalars['numeric']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  stockPrice?: InputMaybe<Scalars['numeric']>;
  stockShares?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Insert_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  breakEvenPrices?: InputMaybe<Scalars['jsonb']>;
  cash?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  delta?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  expiration?: InputMaybe<Scalars['date']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  impliedVolatility?: InputMaybe<Scalars['numeric']>;
  isStrategyShared?: InputMaybe<Scalars['Boolean']>;
  maxLoss?: InputMaybe<Scalars['numeric']>;
  maxProfit?: InputMaybe<Scalars['numeric']>;
  netCreditDebit?: InputMaybe<Scalars['numeric']>;
  positions?: InputMaybe<Opc_Saved_Strategy_Positions_Arr_Rel_Insert_Input>;
  premiumTransacted?: InputMaybe<Scalars['numeric']>;
  probabilityOfProfit?: InputMaybe<Scalars['numeric']>;
  profitIndex?: InputMaybe<Scalars['numeric']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  stockPrice?: InputMaybe<Scalars['numeric']>;
  stockShares?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Opc_Saved_Strategies_Max_Fields = {
  __typename?: 'opc_saved_strategies_max_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  cash?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  delta?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['date']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  impliedVolatility?: Maybe<Scalars['numeric']>;
  maxLoss?: Maybe<Scalars['numeric']>;
  maxProfit?: Maybe<Scalars['numeric']>;
  netCreditDebit?: Maybe<Scalars['numeric']>;
  premiumTransacted?: Maybe<Scalars['numeric']>;
  probabilityOfProfit?: Maybe<Scalars['numeric']>;
  profitIndex?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  stockPrice?: Maybe<Scalars['numeric']>;
  stockShares?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Max_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  cash?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  maxLoss?: InputMaybe<Order_By>;
  maxProfit?: InputMaybe<Order_By>;
  netCreditDebit?: InputMaybe<Order_By>;
  premiumTransacted?: InputMaybe<Order_By>;
  probabilityOfProfit?: InputMaybe<Order_By>;
  profitIndex?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  stockPrice?: InputMaybe<Order_By>;
  stockShares?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Opc_Saved_Strategies_Min_Fields = {
  __typename?: 'opc_saved_strategies_min_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  cash?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  delta?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['date']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  impliedVolatility?: Maybe<Scalars['numeric']>;
  maxLoss?: Maybe<Scalars['numeric']>;
  maxProfit?: Maybe<Scalars['numeric']>;
  netCreditDebit?: Maybe<Scalars['numeric']>;
  premiumTransacted?: Maybe<Scalars['numeric']>;
  probabilityOfProfit?: Maybe<Scalars['numeric']>;
  profitIndex?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  stockPrice?: Maybe<Scalars['numeric']>;
  stockShares?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Min_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  cash?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  maxLoss?: InputMaybe<Order_By>;
  maxProfit?: InputMaybe<Order_By>;
  netCreditDebit?: InputMaybe<Order_By>;
  premiumTransacted?: InputMaybe<Order_By>;
  probabilityOfProfit?: InputMaybe<Order_By>;
  profitIndex?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  stockPrice?: InputMaybe<Order_By>;
  stockShares?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Mutation_Response = {
  __typename?: 'opc_saved_strategies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Opc_Saved_Strategies>;
};

/** input type for inserting object relation for remote table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Obj_Rel_Insert_Input = {
  data: Opc_Saved_Strategies_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Opc_Saved_Strategies_On_Conflict>;
};

/** on_conflict condition type for table "opc_saved_strategies" */
export type Opc_Saved_Strategies_On_Conflict = {
  constraint: Opc_Saved_Strategies_Constraint;
  update_columns?: Array<Opc_Saved_Strategies_Update_Column>;
  where?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
};

/** Ordering options when selecting data from "opc_saved_strategies". */
export type Opc_Saved_Strategies_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  breakEvenPrices?: InputMaybe<Order_By>;
  cash?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  isStrategyShared?: InputMaybe<Order_By>;
  maxLoss?: InputMaybe<Order_By>;
  maxProfit?: InputMaybe<Order_By>;
  netCreditDebit?: InputMaybe<Order_By>;
  positions_aggregate?: InputMaybe<Opc_Saved_Strategy_Positions_Aggregate_Order_By>;
  premiumTransacted?: InputMaybe<Order_By>;
  probabilityOfProfit?: InputMaybe<Order_By>;
  profitIndex?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  stockPrice?: InputMaybe<Order_By>;
  stockShares?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** primary key columns input for table: opc_saved_strategies */
export type Opc_Saved_Strategies_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Opc_Saved_Strategies_Prepend_Input = {
  breakEvenPrices?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "opc_saved_strategies" */
export const Opc_Saved_Strategies_Select_Column = {
  /** column name */
  ArchivedAt: 'archivedAt',
  /** column name */
  BreakEvenPrices: 'breakEvenPrices',
  /** column name */
  Cash: 'cash',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Delta: 'delta',
  /** column name */
  Description: 'description',
  /** column name */
  Expiration: 'expiration',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVolatility: 'impliedVolatility',
  /** column name */
  IsStrategyShared: 'isStrategyShared',
  /** column name */
  MaxLoss: 'maxLoss',
  /** column name */
  MaxProfit: 'maxProfit',
  /** column name */
  NetCreditDebit: 'netCreditDebit',
  /** column name */
  PremiumTransacted: 'premiumTransacted',
  /** column name */
  ProbabilityOfProfit: 'probabilityOfProfit',
  /** column name */
  ProfitIndex: 'profitIndex',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  StockPrice: 'stockPrice',
  /** column name */
  StockShares: 'stockShares',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId',
  /** column name */
  Value: 'value',
  /** column name */
  Vega: 'vega'
} as const;

export type Opc_Saved_Strategies_Select_Column = typeof Opc_Saved_Strategies_Select_Column[keyof typeof Opc_Saved_Strategies_Select_Column];
/** select "opc_saved_strategies_aggregate_bool_exp_bool_and_arguments_columns" columns of table "opc_saved_strategies" */
export const Opc_Saved_Strategies_Select_Column_Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  IsStrategyShared: 'isStrategyShared'
} as const;

export type Opc_Saved_Strategies_Select_Column_Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Opc_Saved_Strategies_Select_Column_Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Opc_Saved_Strategies_Select_Column_Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "opc_saved_strategies_aggregate_bool_exp_bool_or_arguments_columns" columns of table "opc_saved_strategies" */
export const Opc_Saved_Strategies_Select_Column_Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  IsStrategyShared: 'isStrategyShared'
} as const;

export type Opc_Saved_Strategies_Select_Column_Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Opc_Saved_Strategies_Select_Column_Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Opc_Saved_Strategies_Select_Column_Opc_Saved_Strategies_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Set_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  breakEvenPrices?: InputMaybe<Scalars['jsonb']>;
  cash?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  delta?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  expiration?: InputMaybe<Scalars['date']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  impliedVolatility?: InputMaybe<Scalars['numeric']>;
  isStrategyShared?: InputMaybe<Scalars['Boolean']>;
  maxLoss?: InputMaybe<Scalars['numeric']>;
  maxProfit?: InputMaybe<Scalars['numeric']>;
  netCreditDebit?: InputMaybe<Scalars['numeric']>;
  premiumTransacted?: InputMaybe<Scalars['numeric']>;
  probabilityOfProfit?: InputMaybe<Scalars['numeric']>;
  profitIndex?: InputMaybe<Scalars['numeric']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  stockPrice?: InputMaybe<Scalars['numeric']>;
  stockShares?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Opc_Saved_Strategies_Stddev_Fields = {
  __typename?: 'opc_saved_strategies_stddev_fields';
  cash?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  maxLoss?: Maybe<Scalars['Float']>;
  maxProfit?: Maybe<Scalars['Float']>;
  netCreditDebit?: Maybe<Scalars['Float']>;
  premiumTransacted?: Maybe<Scalars['Float']>;
  probabilityOfProfit?: Maybe<Scalars['Float']>;
  profitIndex?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  stockPrice?: Maybe<Scalars['Float']>;
  stockShares?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Stddev_Order_By = {
  cash?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  maxLoss?: InputMaybe<Order_By>;
  maxProfit?: InputMaybe<Order_By>;
  netCreditDebit?: InputMaybe<Order_By>;
  premiumTransacted?: InputMaybe<Order_By>;
  probabilityOfProfit?: InputMaybe<Order_By>;
  profitIndex?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  stockPrice?: InputMaybe<Order_By>;
  stockShares?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Opc_Saved_Strategies_Stddev_Pop_Fields = {
  __typename?: 'opc_saved_strategies_stddev_pop_fields';
  cash?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  maxLoss?: Maybe<Scalars['Float']>;
  maxProfit?: Maybe<Scalars['Float']>;
  netCreditDebit?: Maybe<Scalars['Float']>;
  premiumTransacted?: Maybe<Scalars['Float']>;
  probabilityOfProfit?: Maybe<Scalars['Float']>;
  profitIndex?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  stockPrice?: Maybe<Scalars['Float']>;
  stockShares?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Stddev_Pop_Order_By = {
  cash?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  maxLoss?: InputMaybe<Order_By>;
  maxProfit?: InputMaybe<Order_By>;
  netCreditDebit?: InputMaybe<Order_By>;
  premiumTransacted?: InputMaybe<Order_By>;
  probabilityOfProfit?: InputMaybe<Order_By>;
  profitIndex?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  stockPrice?: InputMaybe<Order_By>;
  stockShares?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Opc_Saved_Strategies_Stddev_Samp_Fields = {
  __typename?: 'opc_saved_strategies_stddev_samp_fields';
  cash?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  maxLoss?: Maybe<Scalars['Float']>;
  maxProfit?: Maybe<Scalars['Float']>;
  netCreditDebit?: Maybe<Scalars['Float']>;
  premiumTransacted?: Maybe<Scalars['Float']>;
  probabilityOfProfit?: Maybe<Scalars['Float']>;
  profitIndex?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  stockPrice?: Maybe<Scalars['Float']>;
  stockShares?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Stddev_Samp_Order_By = {
  cash?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  maxLoss?: InputMaybe<Order_By>;
  maxProfit?: InputMaybe<Order_By>;
  netCreditDebit?: InputMaybe<Order_By>;
  premiumTransacted?: InputMaybe<Order_By>;
  probabilityOfProfit?: InputMaybe<Order_By>;
  profitIndex?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  stockPrice?: InputMaybe<Order_By>;
  stockShares?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Opc_Saved_Strategies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Opc_Saved_Strategies_Stream_Cursor_Value_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  breakEvenPrices?: InputMaybe<Scalars['jsonb']>;
  cash?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  delta?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  expiration?: InputMaybe<Scalars['date']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  impliedVolatility?: InputMaybe<Scalars['numeric']>;
  isStrategyShared?: InputMaybe<Scalars['Boolean']>;
  maxLoss?: InputMaybe<Scalars['numeric']>;
  maxProfit?: InputMaybe<Scalars['numeric']>;
  netCreditDebit?: InputMaybe<Scalars['numeric']>;
  premiumTransacted?: InputMaybe<Scalars['numeric']>;
  probabilityOfProfit?: InputMaybe<Scalars['numeric']>;
  profitIndex?: InputMaybe<Scalars['numeric']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  stockPrice?: InputMaybe<Scalars['numeric']>;
  stockShares?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Opc_Saved_Strategies_Sum_Fields = {
  __typename?: 'opc_saved_strategies_sum_fields';
  cash?: Maybe<Scalars['numeric']>;
  delta?: Maybe<Scalars['numeric']>;
  gamma?: Maybe<Scalars['numeric']>;
  impliedVolatility?: Maybe<Scalars['numeric']>;
  maxLoss?: Maybe<Scalars['numeric']>;
  maxProfit?: Maybe<Scalars['numeric']>;
  netCreditDebit?: Maybe<Scalars['numeric']>;
  premiumTransacted?: Maybe<Scalars['numeric']>;
  probabilityOfProfit?: Maybe<Scalars['numeric']>;
  profitIndex?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  stockPrice?: Maybe<Scalars['numeric']>;
  stockShares?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Sum_Order_By = {
  cash?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  maxLoss?: InputMaybe<Order_By>;
  maxProfit?: InputMaybe<Order_By>;
  netCreditDebit?: InputMaybe<Order_By>;
  premiumTransacted?: InputMaybe<Order_By>;
  probabilityOfProfit?: InputMaybe<Order_By>;
  profitIndex?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  stockPrice?: InputMaybe<Order_By>;
  stockShares?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** update columns of table "opc_saved_strategies" */
export const Opc_Saved_Strategies_Update_Column = {
  /** column name */
  ArchivedAt: 'archivedAt',
  /** column name */
  BreakEvenPrices: 'breakEvenPrices',
  /** column name */
  Cash: 'cash',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Delta: 'delta',
  /** column name */
  Description: 'description',
  /** column name */
  Expiration: 'expiration',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVolatility: 'impliedVolatility',
  /** column name */
  IsStrategyShared: 'isStrategyShared',
  /** column name */
  MaxLoss: 'maxLoss',
  /** column name */
  MaxProfit: 'maxProfit',
  /** column name */
  NetCreditDebit: 'netCreditDebit',
  /** column name */
  PremiumTransacted: 'premiumTransacted',
  /** column name */
  ProbabilityOfProfit: 'probabilityOfProfit',
  /** column name */
  ProfitIndex: 'profitIndex',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  StockPrice: 'stockPrice',
  /** column name */
  StockShares: 'stockShares',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId',
  /** column name */
  Value: 'value',
  /** column name */
  Vega: 'vega'
} as const;

export type Opc_Saved_Strategies_Update_Column = typeof Opc_Saved_Strategies_Update_Column[keyof typeof Opc_Saved_Strategies_Update_Column];
export type Opc_Saved_Strategies_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Opc_Saved_Strategies_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Opc_Saved_Strategies_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Opc_Saved_Strategies_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Opc_Saved_Strategies_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Opc_Saved_Strategies_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Opc_Saved_Strategies_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Opc_Saved_Strategies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Opc_Saved_Strategies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Opc_Saved_Strategies_Var_Pop_Fields = {
  __typename?: 'opc_saved_strategies_var_pop_fields';
  cash?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  maxLoss?: Maybe<Scalars['Float']>;
  maxProfit?: Maybe<Scalars['Float']>;
  netCreditDebit?: Maybe<Scalars['Float']>;
  premiumTransacted?: Maybe<Scalars['Float']>;
  probabilityOfProfit?: Maybe<Scalars['Float']>;
  profitIndex?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  stockPrice?: Maybe<Scalars['Float']>;
  stockShares?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Var_Pop_Order_By = {
  cash?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  maxLoss?: InputMaybe<Order_By>;
  maxProfit?: InputMaybe<Order_By>;
  netCreditDebit?: InputMaybe<Order_By>;
  premiumTransacted?: InputMaybe<Order_By>;
  probabilityOfProfit?: InputMaybe<Order_By>;
  profitIndex?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  stockPrice?: InputMaybe<Order_By>;
  stockShares?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Opc_Saved_Strategies_Var_Samp_Fields = {
  __typename?: 'opc_saved_strategies_var_samp_fields';
  cash?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  maxLoss?: Maybe<Scalars['Float']>;
  maxProfit?: Maybe<Scalars['Float']>;
  netCreditDebit?: Maybe<Scalars['Float']>;
  premiumTransacted?: Maybe<Scalars['Float']>;
  probabilityOfProfit?: Maybe<Scalars['Float']>;
  profitIndex?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  stockPrice?: Maybe<Scalars['Float']>;
  stockShares?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Var_Samp_Order_By = {
  cash?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  maxLoss?: InputMaybe<Order_By>;
  maxProfit?: InputMaybe<Order_By>;
  netCreditDebit?: InputMaybe<Order_By>;
  premiumTransacted?: InputMaybe<Order_By>;
  probabilityOfProfit?: InputMaybe<Order_By>;
  profitIndex?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  stockPrice?: InputMaybe<Order_By>;
  stockShares?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Opc_Saved_Strategies_Variance_Fields = {
  __typename?: 'opc_saved_strategies_variance_fields';
  cash?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  maxLoss?: Maybe<Scalars['Float']>;
  maxProfit?: Maybe<Scalars['Float']>;
  netCreditDebit?: Maybe<Scalars['Float']>;
  premiumTransacted?: Maybe<Scalars['Float']>;
  probabilityOfProfit?: Maybe<Scalars['Float']>;
  profitIndex?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  stockPrice?: Maybe<Scalars['Float']>;
  stockShares?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  /** The sum of the option premium received/paid and the stock position */
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "opc_saved_strategies" */
export type Opc_Saved_Strategies_Variance_Order_By = {
  cash?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  maxLoss?: InputMaybe<Order_By>;
  maxProfit?: InputMaybe<Order_By>;
  netCreditDebit?: InputMaybe<Order_By>;
  premiumTransacted?: InputMaybe<Order_By>;
  probabilityOfProfit?: InputMaybe<Order_By>;
  profitIndex?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  stockPrice?: InputMaybe<Order_By>;
  stockShares?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  /** The sum of the option premium received/paid and the stock position */
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** columns and relationships of "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions = {
  __typename?: 'opc_saved_strategy_positions';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  delta: Scalars['numeric'];
  expiration: Scalars['date'];
  gamma: Scalars['numeric'];
  id: Scalars['uuid'];
  impliedVolatility: Scalars['numeric'];
  opcSavedStrategyId: Scalars['uuid'];
  optionType: Scalars['String'];
  premium: Scalars['numeric'];
  purchaseDirection: Scalars['String'];
  quantity: Scalars['Int'];
  rho: Scalars['numeric'];
  /** An object relationship */
  strategy: Opc_Saved_Strategies;
  strike: Scalars['numeric'];
  theta: Scalars['numeric'];
  updatedAt: Scalars['timestamptz'];
  value: Scalars['numeric'];
  vega: Scalars['numeric'];
};

/** aggregated selection of "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Aggregate = {
  __typename?: 'opc_saved_strategy_positions_aggregate';
  aggregate?: Maybe<Opc_Saved_Strategy_Positions_Aggregate_Fields>;
  nodes: Array<Opc_Saved_Strategy_Positions>;
};

export type Opc_Saved_Strategy_Positions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Opc_Saved_Strategy_Positions_Aggregate_Bool_Exp_Count>;
};

export type Opc_Saved_Strategy_Positions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Opc_Saved_Strategy_Positions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Aggregate_Fields = {
  __typename?: 'opc_saved_strategy_positions_aggregate_fields';
  avg?: Maybe<Opc_Saved_Strategy_Positions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Opc_Saved_Strategy_Positions_Max_Fields>;
  min?: Maybe<Opc_Saved_Strategy_Positions_Min_Fields>;
  stddev?: Maybe<Opc_Saved_Strategy_Positions_Stddev_Fields>;
  stddev_pop?: Maybe<Opc_Saved_Strategy_Positions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Opc_Saved_Strategy_Positions_Stddev_Samp_Fields>;
  sum?: Maybe<Opc_Saved_Strategy_Positions_Sum_Fields>;
  var_pop?: Maybe<Opc_Saved_Strategy_Positions_Var_Pop_Fields>;
  var_samp?: Maybe<Opc_Saved_Strategy_Positions_Var_Samp_Fields>;
  variance?: Maybe<Opc_Saved_Strategy_Positions_Variance_Fields>;
};


/** aggregate fields of "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Aggregate_Order_By = {
  avg?: InputMaybe<Opc_Saved_Strategy_Positions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Opc_Saved_Strategy_Positions_Max_Order_By>;
  min?: InputMaybe<Opc_Saved_Strategy_Positions_Min_Order_By>;
  stddev?: InputMaybe<Opc_Saved_Strategy_Positions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Opc_Saved_Strategy_Positions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Opc_Saved_Strategy_Positions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Opc_Saved_Strategy_Positions_Sum_Order_By>;
  var_pop?: InputMaybe<Opc_Saved_Strategy_Positions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Opc_Saved_Strategy_Positions_Var_Samp_Order_By>;
  variance?: InputMaybe<Opc_Saved_Strategy_Positions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Arr_Rel_Insert_Input = {
  data: Array<Opc_Saved_Strategy_Positions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Opc_Saved_Strategy_Positions_On_Conflict>;
};

/** aggregate avg on columns */
export type Opc_Saved_Strategy_Positions_Avg_Fields = {
  __typename?: 'opc_saved_strategy_positions_avg_fields';
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Avg_Order_By = {
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "opc_saved_strategy_positions". All fields are combined with a logical 'AND'. */
export type Opc_Saved_Strategy_Positions_Bool_Exp = {
  _and?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Bool_Exp>>;
  _not?: InputMaybe<Opc_Saved_Strategy_Positions_Bool_Exp>;
  _or?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  expiration?: InputMaybe<Date_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  impliedVolatility?: InputMaybe<Numeric_Comparison_Exp>;
  opcSavedStrategyId?: InputMaybe<Uuid_Comparison_Exp>;
  optionType?: InputMaybe<String_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  purchaseDirection?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  strategy?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "opc_saved_strategy_positions" */
export const Opc_Saved_Strategy_Positions_Constraint = {
  /** unique or primary key constraint on columns "id" */
  OpcSavedStrategyPositionsPkey: 'opc_saved_strategy_positions_pkey'
} as const;

export type Opc_Saved_Strategy_Positions_Constraint = typeof Opc_Saved_Strategy_Positions_Constraint[keyof typeof Opc_Saved_Strategy_Positions_Constraint];
/** input type for incrementing numeric columns in table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Inc_Input = {
  delta?: InputMaybe<Scalars['numeric']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  impliedVolatility?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['Int']>;
  rho?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  value?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  delta?: InputMaybe<Scalars['numeric']>;
  expiration?: InputMaybe<Scalars['date']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  impliedVolatility?: InputMaybe<Scalars['numeric']>;
  opcSavedStrategyId?: InputMaybe<Scalars['uuid']>;
  optionType?: InputMaybe<Scalars['String']>;
  premium?: InputMaybe<Scalars['numeric']>;
  purchaseDirection?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  rho?: InputMaybe<Scalars['numeric']>;
  strategy?: InputMaybe<Opc_Saved_Strategies_Obj_Rel_Insert_Input>;
  strike?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Opc_Saved_Strategy_Positions_Max_Fields = {
  __typename?: 'opc_saved_strategy_positions_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  delta?: Maybe<Scalars['numeric']>;
  expiration?: Maybe<Scalars['date']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  impliedVolatility?: Maybe<Scalars['numeric']>;
  opcSavedStrategyId?: Maybe<Scalars['uuid']>;
  optionType?: Maybe<Scalars['String']>;
  premium?: Maybe<Scalars['numeric']>;
  purchaseDirection?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  rho?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  opcSavedStrategyId?: InputMaybe<Order_By>;
  optionType?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  purchaseDirection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Opc_Saved_Strategy_Positions_Min_Fields = {
  __typename?: 'opc_saved_strategy_positions_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  delta?: Maybe<Scalars['numeric']>;
  expiration?: Maybe<Scalars['date']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  impliedVolatility?: Maybe<Scalars['numeric']>;
  opcSavedStrategyId?: Maybe<Scalars['uuid']>;
  optionType?: Maybe<Scalars['String']>;
  premium?: Maybe<Scalars['numeric']>;
  purchaseDirection?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  rho?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  opcSavedStrategyId?: InputMaybe<Order_By>;
  optionType?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  purchaseDirection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Mutation_Response = {
  __typename?: 'opc_saved_strategy_positions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Opc_Saved_Strategy_Positions>;
};

/** on_conflict condition type for table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_On_Conflict = {
  constraint: Opc_Saved_Strategy_Positions_Constraint;
  update_columns?: Array<Opc_Saved_Strategy_Positions_Update_Column>;
  where?: InputMaybe<Opc_Saved_Strategy_Positions_Bool_Exp>;
};

/** Ordering options when selecting data from "opc_saved_strategy_positions". */
export type Opc_Saved_Strategy_Positions_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  opcSavedStrategyId?: InputMaybe<Order_By>;
  optionType?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  purchaseDirection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  strategy?: InputMaybe<Opc_Saved_Strategies_Order_By>;
  strike?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** primary key columns input for table: opc_saved_strategy_positions */
export type Opc_Saved_Strategy_Positions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "opc_saved_strategy_positions" */
export const Opc_Saved_Strategy_Positions_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Delta: 'delta',
  /** column name */
  Expiration: 'expiration',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVolatility: 'impliedVolatility',
  /** column name */
  OpcSavedStrategyId: 'opcSavedStrategyId',
  /** column name */
  OptionType: 'optionType',
  /** column name */
  Premium: 'premium',
  /** column name */
  PurchaseDirection: 'purchaseDirection',
  /** column name */
  Quantity: 'quantity',
  /** column name */
  Rho: 'rho',
  /** column name */
  Strike: 'strike',
  /** column name */
  Theta: 'theta',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Value: 'value',
  /** column name */
  Vega: 'vega'
} as const;

export type Opc_Saved_Strategy_Positions_Select_Column = typeof Opc_Saved_Strategy_Positions_Select_Column[keyof typeof Opc_Saved_Strategy_Positions_Select_Column];
/** input type for updating data in table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  delta?: InputMaybe<Scalars['numeric']>;
  expiration?: InputMaybe<Scalars['date']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  impliedVolatility?: InputMaybe<Scalars['numeric']>;
  opcSavedStrategyId?: InputMaybe<Scalars['uuid']>;
  optionType?: InputMaybe<Scalars['String']>;
  premium?: InputMaybe<Scalars['numeric']>;
  purchaseDirection?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  rho?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Opc_Saved_Strategy_Positions_Stddev_Fields = {
  __typename?: 'opc_saved_strategy_positions_stddev_fields';
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Stddev_Order_By = {
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Opc_Saved_Strategy_Positions_Stddev_Pop_Fields = {
  __typename?: 'opc_saved_strategy_positions_stddev_pop_fields';
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Stddev_Pop_Order_By = {
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Opc_Saved_Strategy_Positions_Stddev_Samp_Fields = {
  __typename?: 'opc_saved_strategy_positions_stddev_samp_fields';
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Stddev_Samp_Order_By = {
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Opc_Saved_Strategy_Positions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Opc_Saved_Strategy_Positions_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  delta?: InputMaybe<Scalars['numeric']>;
  expiration?: InputMaybe<Scalars['date']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  impliedVolatility?: InputMaybe<Scalars['numeric']>;
  opcSavedStrategyId?: InputMaybe<Scalars['uuid']>;
  optionType?: InputMaybe<Scalars['String']>;
  premium?: InputMaybe<Scalars['numeric']>;
  purchaseDirection?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  rho?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Opc_Saved_Strategy_Positions_Sum_Fields = {
  __typename?: 'opc_saved_strategy_positions_sum_fields';
  delta?: Maybe<Scalars['numeric']>;
  gamma?: Maybe<Scalars['numeric']>;
  impliedVolatility?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['Int']>;
  rho?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  value?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Sum_Order_By = {
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** update columns of table "opc_saved_strategy_positions" */
export const Opc_Saved_Strategy_Positions_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Delta: 'delta',
  /** column name */
  Expiration: 'expiration',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVolatility: 'impliedVolatility',
  /** column name */
  OpcSavedStrategyId: 'opcSavedStrategyId',
  /** column name */
  OptionType: 'optionType',
  /** column name */
  Premium: 'premium',
  /** column name */
  PurchaseDirection: 'purchaseDirection',
  /** column name */
  Quantity: 'quantity',
  /** column name */
  Rho: 'rho',
  /** column name */
  Strike: 'strike',
  /** column name */
  Theta: 'theta',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Value: 'value',
  /** column name */
  Vega: 'vega'
} as const;

export type Opc_Saved_Strategy_Positions_Update_Column = typeof Opc_Saved_Strategy_Positions_Update_Column[keyof typeof Opc_Saved_Strategy_Positions_Update_Column];
export type Opc_Saved_Strategy_Positions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Opc_Saved_Strategy_Positions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Opc_Saved_Strategy_Positions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Opc_Saved_Strategy_Positions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Opc_Saved_Strategy_Positions_Var_Pop_Fields = {
  __typename?: 'opc_saved_strategy_positions_var_pop_fields';
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Var_Pop_Order_By = {
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Opc_Saved_Strategy_Positions_Var_Samp_Fields = {
  __typename?: 'opc_saved_strategy_positions_var_samp_fields';
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Var_Samp_Order_By = {
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Opc_Saved_Strategy_Positions_Variance_Fields = {
  __typename?: 'opc_saved_strategy_positions_variance_fields';
  delta?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  impliedVolatility?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "opc_saved_strategy_positions" */
export type Opc_Saved_Strategy_Positions_Variance_Order_By = {
  delta?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  impliedVolatility?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
};

/** columns and relationships of "option_feed_baseline" */
export type Option_Feed_Baseline = {
  __typename?: 'option_feed_baseline';
  askCount: Scalars['Int'];
  askVolume: Scalars['Int'];
  avgContractsPerDay: Scalars['numeric'];
  avgContractsPerTrade: Scalars['numeric'];
  avgImpliedVolPerTrade: Scalars['numeric'];
  avgOpenInterestPerDay: Scalars['numeric'];
  avgOpenInterestPerTrade: Scalars['numeric'];
  avgPremiumPerDay: Scalars['numeric'];
  avgPremiumPerTrade: Scalars['numeric'];
  avgTradesPerDay: Scalars['numeric'];
  bidCount: Scalars['Int'];
  bidVolume: Scalars['Int'];
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  currentDailyVolume: Scalars['Int'];
  cxlVolume: Scalars['Int'];
  date: Scalars['date'];
  datetimeCentral: Scalars['timestamp'];
  datetimeMicroSeconds: Scalars['Int'];
  delta: Scalars['numeric'];
  eventId?: Maybe<Scalars['uuid']>;
  exchangeAge: Scalars['numeric'];
  exchangeAsk: Scalars['numeric'];
  exchangeAskSize: Scalars['Int'];
  exchangeBid: Scalars['numeric'];
  exchangeBidSize: Scalars['Int'];
  exchangeTimestamp: Scalars['bigint'];
  expireDay: Scalars['Int'];
  expireMonth: Scalars['Int'];
  expireYear: Scalars['Int'];
  firstPrintNumber: Scalars['bigint'];
  gamma: Scalars['numeric'];
  id: Scalars['bigint'];
  impliedVol: Scalars['numeric'];
  lambda?: Maybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber: Scalars['bigint'];
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge: Scalars['String'];
  nbboAsk: Scalars['numeric'];
  nbboAskSize: Scalars['Int'];
  nbboBid: Scalars['numeric'];
  nbboBidSize: Scalars['Int'];
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades: Scalars['Int'];
  openInterest: Scalars['Int'];
  optionSymbol?: Maybe<Scalars['String']>;
  orderType: Scalars['String'];
  otmPercent: Scalars['numeric'];
  premium: Scalars['numeric'];
  price: Scalars['numeric'];
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability: Scalars['numeric'];
  prtTypes: Scalars['jsonb'];
  publication_xid?: Maybe<Scalars['xid8']>;
  rho: Scalars['numeric'];
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size: Scalars['Int'];
  speed?: Maybe<Scalars['numeric']>;
  spot: Scalars['numeric'];
  strike: Scalars['numeric'];
  surfAtmVol: Scalars['numeric'];
  surfPrice: Scalars['numeric'];
  surfVol: Scalars['numeric'];
  theta: Scalars['numeric'];
  ticker: Scalars['String'];
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide: Scalars['String'];
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamptz'];
  vanna?: Maybe<Scalars['numeric']>;
  vega: Scalars['numeric'];
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol: Scalars['numeric'];
  weeklyTotalOpenInterest: Scalars['numeric'];
  weeklyTotalPremium: Scalars['numeric'];
  weeklyTotalSize: Scalars['numeric'];
  weeklyTotalTrades: Scalars['Int'];
  yearsToExpiry: Scalars['numeric'];
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "option_feed_baseline" */
export type Option_Feed_BaselinePrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "option_feed_baseline" */
export type Option_Feed_Baseline_Aggregate = {
  __typename?: 'option_feed_baseline_aggregate';
  aggregate?: Maybe<Option_Feed_Baseline_Aggregate_Fields>;
  nodes: Array<Option_Feed_Baseline>;
};

/** aggregate fields of "option_feed_baseline" */
export type Option_Feed_Baseline_Aggregate_Fields = {
  __typename?: 'option_feed_baseline_aggregate_fields';
  avg?: Maybe<Option_Feed_Baseline_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Option_Feed_Baseline_Max_Fields>;
  min?: Maybe<Option_Feed_Baseline_Min_Fields>;
  stddev?: Maybe<Option_Feed_Baseline_Stddev_Fields>;
  stddev_pop?: Maybe<Option_Feed_Baseline_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Option_Feed_Baseline_Stddev_Samp_Fields>;
  sum?: Maybe<Option_Feed_Baseline_Sum_Fields>;
  var_pop?: Maybe<Option_Feed_Baseline_Var_Pop_Fields>;
  var_samp?: Maybe<Option_Feed_Baseline_Var_Samp_Fields>;
  variance?: Maybe<Option_Feed_Baseline_Variance_Fields>;
};


/** aggregate fields of "option_feed_baseline" */
export type Option_Feed_Baseline_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Option_Feed_Baseline_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Option_Feed_Baseline_Append_Input = {
  prtTypes?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Option_Feed_Baseline_Avg_Fields = {
  __typename?: 'option_feed_baseline_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "option_feed_baseline". All fields are combined with a logical 'AND'. */
export type Option_Feed_Baseline_Bool_Exp = {
  _and?: InputMaybe<Array<Option_Feed_Baseline_Bool_Exp>>;
  _not?: InputMaybe<Option_Feed_Baseline_Bool_Exp>;
  _or?: InputMaybe<Array<Option_Feed_Baseline_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  optionSymbol?: InputMaybe<String_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  publication_xid?: InputMaybe<Xid8_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "option_feed_baseline" */
export const Option_Feed_Baseline_Constraint = {
  /** unique or primary key constraint on columns "eventId" */
  OptionFeedBaselineEventIdKey: 'option_feed_baseline_eventId_key',
  /** unique or primary key constraint on columns "id" */
  OptionFeedBaselinePkey: 'option_feed_baseline_pkey'
} as const;

export type Option_Feed_Baseline_Constraint = typeof Option_Feed_Baseline_Constraint[keyof typeof Option_Feed_Baseline_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Option_Feed_Baseline_Delete_At_Path_Input = {
  prtTypes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Option_Feed_Baseline_Delete_Elem_Input = {
  prtTypes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Option_Feed_Baseline_Delete_Key_Input = {
  prtTypes?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "option_feed_baseline" */
export type Option_Feed_Baseline_Inc_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "option_feed_baseline" */
export type Option_Feed_Baseline_Insert_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  optionSymbol?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  publication_xid?: InputMaybe<Scalars['xid8']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Option_Feed_Baseline_Max_Fields = {
  __typename?: 'option_feed_baseline_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  eventId?: Maybe<Scalars['uuid']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  optionSymbol?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Option_Feed_Baseline_Min_Fields = {
  __typename?: 'option_feed_baseline_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  eventId?: Maybe<Scalars['uuid']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  optionSymbol?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "option_feed_baseline" */
export type Option_Feed_Baseline_Mutation_Response = {
  __typename?: 'option_feed_baseline_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Option_Feed_Baseline>;
};

/** on_conflict condition type for table "option_feed_baseline" */
export type Option_Feed_Baseline_On_Conflict = {
  constraint: Option_Feed_Baseline_Constraint;
  update_columns?: Array<Option_Feed_Baseline_Update_Column>;
  where?: InputMaybe<Option_Feed_Baseline_Bool_Exp>;
};

/** Ordering options when selecting data from "option_feed_baseline". */
export type Option_Feed_Baseline_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  optionSymbol?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  publication_xid?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** primary key columns input for table: option_feed_baseline */
export type Option_Feed_Baseline_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Option_Feed_Baseline_Prepend_Input = {
  prtTypes?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "option_feed_baseline" */
export const Option_Feed_Baseline_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  EventId: 'eventId',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OptionSymbol: 'optionSymbol',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  PublicationXid: 'publication_xid',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Option_Feed_Baseline_Select_Column = typeof Option_Feed_Baseline_Select_Column[keyof typeof Option_Feed_Baseline_Select_Column];
/** input type for updating data in table "option_feed_baseline" */
export type Option_Feed_Baseline_Set_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  optionSymbol?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  publication_xid?: InputMaybe<Scalars['xid8']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Option_Feed_Baseline_Stddev_Fields = {
  __typename?: 'option_feed_baseline_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Option_Feed_Baseline_Stddev_Pop_Fields = {
  __typename?: 'option_feed_baseline_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Option_Feed_Baseline_Stddev_Samp_Fields = {
  __typename?: 'option_feed_baseline_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "option_feed_baseline" */
export type Option_Feed_Baseline_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Option_Feed_Baseline_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Option_Feed_Baseline_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  optionSymbol?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  publication_xid?: InputMaybe<Scalars['xid8']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Option_Feed_Baseline_Sum_Fields = {
  __typename?: 'option_feed_baseline_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** update columns of table "option_feed_baseline" */
export const Option_Feed_Baseline_Update_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  EventId: 'eventId',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OptionSymbol: 'optionSymbol',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  PublicationXid: 'publication_xid',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Option_Feed_Baseline_Update_Column = typeof Option_Feed_Baseline_Update_Column[keyof typeof Option_Feed_Baseline_Update_Column];
export type Option_Feed_Baseline_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Option_Feed_Baseline_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Option_Feed_Baseline_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Option_Feed_Baseline_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Option_Feed_Baseline_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Option_Feed_Baseline_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Option_Feed_Baseline_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Option_Feed_Baseline_Set_Input>;
  /** filter the rows which have to be updated */
  where: Option_Feed_Baseline_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Option_Feed_Baseline_Var_Pop_Fields = {
  __typename?: 'option_feed_baseline_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Option_Feed_Baseline_Var_Samp_Fields = {
  __typename?: 'option_feed_baseline_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Option_Feed_Baseline_Variance_Fields = {
  __typename?: 'option_feed_baseline_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "option_feed_filtered" */
export type Option_Feed_Filtered = {
  __typename?: 'option_feed_filtered';
  askCount: Scalars['Int'];
  askVolume: Scalars['Int'];
  avgContractsPerDay: Scalars['numeric'];
  avgContractsPerTrade: Scalars['numeric'];
  avgImpliedVolPerTrade: Scalars['numeric'];
  avgOpenInterestPerDay: Scalars['numeric'];
  avgOpenInterestPerTrade: Scalars['numeric'];
  avgPremiumPerDay: Scalars['numeric'];
  avgPremiumPerTrade: Scalars['numeric'];
  avgTradesPerDay: Scalars['numeric'];
  bidCount: Scalars['Int'];
  bidVolume: Scalars['Int'];
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  currentDailyVolume: Scalars['Int'];
  cxlVolume: Scalars['Int'];
  date: Scalars['date'];
  datetimeCentral: Scalars['timestamp'];
  datetimeMicroSeconds: Scalars['Int'];
  delta: Scalars['numeric'];
  eventId?: Maybe<Scalars['uuid']>;
  exchangeAge: Scalars['numeric'];
  exchangeAsk: Scalars['numeric'];
  exchangeAskSize: Scalars['Int'];
  exchangeBid: Scalars['numeric'];
  exchangeBidSize: Scalars['Int'];
  exchangeTimestamp: Scalars['bigint'];
  expireDay: Scalars['Int'];
  expireMonth: Scalars['Int'];
  expireYear: Scalars['Int'];
  firstPrintNumber: Scalars['bigint'];
  gamma: Scalars['numeric'];
  id: Scalars['bigint'];
  impliedVol: Scalars['numeric'];
  lambda?: Maybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber: Scalars['bigint'];
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge: Scalars['String'];
  nbboAsk: Scalars['numeric'];
  nbboAskSize: Scalars['Int'];
  nbboBid: Scalars['numeric'];
  nbboBidSize: Scalars['Int'];
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades: Scalars['Int'];
  openInterest: Scalars['Int'];
  optionSymbol?: Maybe<Scalars['String']>;
  orderType: Scalars['String'];
  otmPercent: Scalars['numeric'];
  premium: Scalars['numeric'];
  price: Scalars['numeric'];
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability: Scalars['numeric'];
  prtTypes: Scalars['jsonb'];
  publication_xid?: Maybe<Scalars['xid8']>;
  rho: Scalars['numeric'];
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size: Scalars['Int'];
  speed?: Maybe<Scalars['numeric']>;
  spot: Scalars['numeric'];
  strike: Scalars['numeric'];
  surfAtmVol: Scalars['numeric'];
  surfPrice: Scalars['numeric'];
  surfVol: Scalars['numeric'];
  theta: Scalars['numeric'];
  ticker: Scalars['String'];
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide: Scalars['String'];
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamptz'];
  vanna?: Maybe<Scalars['numeric']>;
  vega: Scalars['numeric'];
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol: Scalars['numeric'];
  weeklyTotalOpenInterest: Scalars['numeric'];
  weeklyTotalPremium: Scalars['numeric'];
  weeklyTotalSize: Scalars['numeric'];
  weeklyTotalTrades: Scalars['Int'];
  yearsToExpiry: Scalars['numeric'];
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "option_feed_filtered" */
export type Option_Feed_FilteredPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "option_feed_filtered" */
export type Option_Feed_Filtered_Aggregate = {
  __typename?: 'option_feed_filtered_aggregate';
  aggregate?: Maybe<Option_Feed_Filtered_Aggregate_Fields>;
  nodes: Array<Option_Feed_Filtered>;
};

/** aggregate fields of "option_feed_filtered" */
export type Option_Feed_Filtered_Aggregate_Fields = {
  __typename?: 'option_feed_filtered_aggregate_fields';
  avg?: Maybe<Option_Feed_Filtered_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Option_Feed_Filtered_Max_Fields>;
  min?: Maybe<Option_Feed_Filtered_Min_Fields>;
  stddev?: Maybe<Option_Feed_Filtered_Stddev_Fields>;
  stddev_pop?: Maybe<Option_Feed_Filtered_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Option_Feed_Filtered_Stddev_Samp_Fields>;
  sum?: Maybe<Option_Feed_Filtered_Sum_Fields>;
  var_pop?: Maybe<Option_Feed_Filtered_Var_Pop_Fields>;
  var_samp?: Maybe<Option_Feed_Filtered_Var_Samp_Fields>;
  variance?: Maybe<Option_Feed_Filtered_Variance_Fields>;
};


/** aggregate fields of "option_feed_filtered" */
export type Option_Feed_Filtered_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Option_Feed_Filtered_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Option_Feed_Filtered_Append_Input = {
  prtTypes?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Option_Feed_Filtered_Avg_Fields = {
  __typename?: 'option_feed_filtered_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "option_feed_filtered". All fields are combined with a logical 'AND'. */
export type Option_Feed_Filtered_Bool_Exp = {
  _and?: InputMaybe<Array<Option_Feed_Filtered_Bool_Exp>>;
  _not?: InputMaybe<Option_Feed_Filtered_Bool_Exp>;
  _or?: InputMaybe<Array<Option_Feed_Filtered_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  optionSymbol?: InputMaybe<String_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  publication_xid?: InputMaybe<Xid8_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "option_feed_filtered" */
export const Option_Feed_Filtered_Constraint = {
  /** unique or primary key constraint on columns "eventId" */
  OptionFeedFilteredEventIdKey: 'option_feed_filtered_eventId_key',
  /** unique or primary key constraint on columns "id" */
  OptionFeedFilteredPkey: 'option_feed_filtered_pkey'
} as const;

export type Option_Feed_Filtered_Constraint = typeof Option_Feed_Filtered_Constraint[keyof typeof Option_Feed_Filtered_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Option_Feed_Filtered_Delete_At_Path_Input = {
  prtTypes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Option_Feed_Filtered_Delete_Elem_Input = {
  prtTypes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Option_Feed_Filtered_Delete_Key_Input = {
  prtTypes?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "option_feed_filtered" */
export type Option_Feed_Filtered_Inc_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "option_feed_filtered" */
export type Option_Feed_Filtered_Insert_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  optionSymbol?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  publication_xid?: InputMaybe<Scalars['xid8']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Option_Feed_Filtered_Max_Fields = {
  __typename?: 'option_feed_filtered_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  eventId?: Maybe<Scalars['uuid']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  optionSymbol?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Option_Feed_Filtered_Min_Fields = {
  __typename?: 'option_feed_filtered_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  eventId?: Maybe<Scalars['uuid']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  optionSymbol?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "option_feed_filtered" */
export type Option_Feed_Filtered_Mutation_Response = {
  __typename?: 'option_feed_filtered_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Option_Feed_Filtered>;
};

/** on_conflict condition type for table "option_feed_filtered" */
export type Option_Feed_Filtered_On_Conflict = {
  constraint: Option_Feed_Filtered_Constraint;
  update_columns?: Array<Option_Feed_Filtered_Update_Column>;
  where?: InputMaybe<Option_Feed_Filtered_Bool_Exp>;
};

/** Ordering options when selecting data from "option_feed_filtered". */
export type Option_Feed_Filtered_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  optionSymbol?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  publication_xid?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** primary key columns input for table: option_feed_filtered */
export type Option_Feed_Filtered_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Option_Feed_Filtered_Prepend_Input = {
  prtTypes?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "option_feed_filtered" */
export const Option_Feed_Filtered_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  EventId: 'eventId',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OptionSymbol: 'optionSymbol',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  PublicationXid: 'publication_xid',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Option_Feed_Filtered_Select_Column = typeof Option_Feed_Filtered_Select_Column[keyof typeof Option_Feed_Filtered_Select_Column];
/** input type for updating data in table "option_feed_filtered" */
export type Option_Feed_Filtered_Set_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  optionSymbol?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  publication_xid?: InputMaybe<Scalars['xid8']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Option_Feed_Filtered_Stddev_Fields = {
  __typename?: 'option_feed_filtered_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Option_Feed_Filtered_Stddev_Pop_Fields = {
  __typename?: 'option_feed_filtered_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Option_Feed_Filtered_Stddev_Samp_Fields = {
  __typename?: 'option_feed_filtered_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "option_feed_filtered" */
export type Option_Feed_Filtered_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Option_Feed_Filtered_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Option_Feed_Filtered_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  optionSymbol?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  publication_xid?: InputMaybe<Scalars['xid8']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Option_Feed_Filtered_Sum_Fields = {
  __typename?: 'option_feed_filtered_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** update columns of table "option_feed_filtered" */
export const Option_Feed_Filtered_Update_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  EventId: 'eventId',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OptionSymbol: 'optionSymbol',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  PublicationXid: 'publication_xid',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Option_Feed_Filtered_Update_Column = typeof Option_Feed_Filtered_Update_Column[keyof typeof Option_Feed_Filtered_Update_Column];
export type Option_Feed_Filtered_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Option_Feed_Filtered_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Option_Feed_Filtered_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Option_Feed_Filtered_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Option_Feed_Filtered_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Option_Feed_Filtered_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Option_Feed_Filtered_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Option_Feed_Filtered_Set_Input>;
  /** filter the rows which have to be updated */
  where: Option_Feed_Filtered_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Option_Feed_Filtered_Var_Pop_Fields = {
  __typename?: 'option_feed_filtered_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Option_Feed_Filtered_Var_Samp_Fields = {
  __typename?: 'option_feed_filtered_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Option_Feed_Filtered_Variance_Fields = {
  __typename?: 'option_feed_filtered_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  /** Exchange time of the last constituent print, epoch nanoseconds. exchangeTimestamp is the first print. */
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "option_flow" */
export type Option_Flow = {
  __typename?: 'option_flow';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtTypes?: Maybe<Scalars['jsonb']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "option_flow" */
export type Option_FlowPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "option_flow" */
export type Option_Flow_Aggregate = {
  __typename?: 'option_flow_aggregate';
  aggregate?: Maybe<Option_Flow_Aggregate_Fields>;
  nodes: Array<Option_Flow>;
};

/** aggregate fields of "option_flow" */
export type Option_Flow_Aggregate_Fields = {
  __typename?: 'option_flow_aggregate_fields';
  avg?: Maybe<Option_Flow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Option_Flow_Max_Fields>;
  min?: Maybe<Option_Flow_Min_Fields>;
  stddev?: Maybe<Option_Flow_Stddev_Fields>;
  stddev_pop?: Maybe<Option_Flow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Option_Flow_Stddev_Samp_Fields>;
  sum?: Maybe<Option_Flow_Sum_Fields>;
  var_pop?: Maybe<Option_Flow_Var_Pop_Fields>;
  var_samp?: Maybe<Option_Flow_Var_Samp_Fields>;
  variance?: Maybe<Option_Flow_Variance_Fields>;
};


/** aggregate fields of "option_flow" */
export type Option_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Option_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "option_flow_all_sides" */
export type Option_Flow_All_Sides = {
  __typename?: 'option_flow_all_sides';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  eventId?: Maybe<Scalars['uuid']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtTypes?: Maybe<Scalars['jsonb']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "option_flow_all_sides" */
export type Option_Flow_All_SidesPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "option_flow_all_sides" */
export type Option_Flow_All_Sides_Aggregate = {
  __typename?: 'option_flow_all_sides_aggregate';
  aggregate?: Maybe<Option_Flow_All_Sides_Aggregate_Fields>;
  nodes: Array<Option_Flow_All_Sides>;
};

/** aggregate fields of "option_flow_all_sides" */
export type Option_Flow_All_Sides_Aggregate_Fields = {
  __typename?: 'option_flow_all_sides_aggregate_fields';
  avg?: Maybe<Option_Flow_All_Sides_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Option_Flow_All_Sides_Max_Fields>;
  min?: Maybe<Option_Flow_All_Sides_Min_Fields>;
  stddev?: Maybe<Option_Flow_All_Sides_Stddev_Fields>;
  stddev_pop?: Maybe<Option_Flow_All_Sides_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Option_Flow_All_Sides_Stddev_Samp_Fields>;
  sum?: Maybe<Option_Flow_All_Sides_Sum_Fields>;
  var_pop?: Maybe<Option_Flow_All_Sides_Var_Pop_Fields>;
  var_samp?: Maybe<Option_Flow_All_Sides_Var_Samp_Fields>;
  variance?: Maybe<Option_Flow_All_Sides_Variance_Fields>;
};


/** aggregate fields of "option_flow_all_sides" */
export type Option_Flow_All_Sides_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Option_Flow_All_Sides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Option_Flow_All_Sides_Avg_Fields = {
  __typename?: 'option_flow_all_sides_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "option_flow_all_sides". All fields are combined with a logical 'AND'. */
export type Option_Flow_All_Sides_Bool_Exp = {
  _and?: InputMaybe<Array<Option_Flow_All_Sides_Bool_Exp>>;
  _not?: InputMaybe<Option_Flow_All_Sides_Bool_Exp>;
  _or?: InputMaybe<Array<Option_Flow_All_Sides_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Option_Flow_All_Sides_Max_Fields = {
  __typename?: 'option_flow_all_sides_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  eventId?: Maybe<Scalars['uuid']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Option_Flow_All_Sides_Min_Fields = {
  __typename?: 'option_flow_all_sides_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  eventId?: Maybe<Scalars['uuid']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "option_flow_all_sides". */
export type Option_Flow_All_Sides_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** select columns of table "option_flow_all_sides" */
export const Option_Flow_All_Sides_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  EventId: 'eventId',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Option_Flow_All_Sides_Select_Column = typeof Option_Flow_All_Sides_Select_Column[keyof typeof Option_Flow_All_Sides_Select_Column];
/** aggregate stddev on columns */
export type Option_Flow_All_Sides_Stddev_Fields = {
  __typename?: 'option_flow_all_sides_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Option_Flow_All_Sides_Stddev_Pop_Fields = {
  __typename?: 'option_flow_all_sides_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Option_Flow_All_Sides_Stddev_Samp_Fields = {
  __typename?: 'option_flow_all_sides_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "option_flow_all_sides" */
export type Option_Flow_All_Sides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Option_Flow_All_Sides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Option_Flow_All_Sides_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  eventId?: InputMaybe<Scalars['uuid']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Option_Flow_All_Sides_Sum_Fields = {
  __typename?: 'option_flow_all_sides_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Option_Flow_All_Sides_Var_Pop_Fields = {
  __typename?: 'option_flow_all_sides_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Option_Flow_All_Sides_Var_Samp_Fields = {
  __typename?: 'option_flow_all_sides_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Option_Flow_All_Sides_Variance_Fields = {
  __typename?: 'option_flow_all_sides_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate avg on columns */
export type Option_Flow_Avg_Fields = {
  __typename?: 'option_flow_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "option_flow". All fields are combined with a logical 'AND'. */
export type Option_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Option_Flow_Bool_Exp>>;
  _not?: InputMaybe<Option_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Option_Flow_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Option_Flow_Max_Fields = {
  __typename?: 'option_flow_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Option_Flow_Min_Fields = {
  __typename?: 'option_flow_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "option_flow". */
export type Option_Flow_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** select columns of table "option_flow" */
export const Option_Flow_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Option_Flow_Select_Column = typeof Option_Flow_Select_Column[keyof typeof Option_Flow_Select_Column];
/** aggregate stddev on columns */
export type Option_Flow_Stddev_Fields = {
  __typename?: 'option_flow_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Option_Flow_Stddev_Pop_Fields = {
  __typename?: 'option_flow_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Option_Flow_Stddev_Samp_Fields = {
  __typename?: 'option_flow_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "option_flow" */
export type Option_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Option_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Option_Flow_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Option_Flow_Sum_Fields = {
  __typename?: 'option_flow_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Option_Flow_Var_Pop_Fields = {
  __typename?: 'option_flow_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Option_Flow_Var_Samp_Fields = {
  __typename?: 'option_flow_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Option_Flow_Variance_Fields = {
  __typename?: 'option_flow_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "options_eod" */
export type Options_Eod = {
  __typename?: 'options_eod';
  atmIv30d?: Maybe<Scalars['numeric']>;
  atmIv90d?: Maybe<Scalars['numeric']>;
  chainData: Scalars['jsonb'];
  charmExposureTotal?: Maybe<Scalars['numeric']>;
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  deltaExposureTotal?: Maybe<Scalars['numeric']>;
  gexCall: Scalars['numeric'];
  gexCallWallStrike?: Maybe<Scalars['numeric']>;
  gexNet: Scalars['numeric'];
  gexPeakStrike?: Maybe<Scalars['numeric']>;
  gexPut: Scalars['numeric'];
  gexPutWallStrike?: Maybe<Scalars['numeric']>;
  gexTotal: Scalars['numeric'];
  gexVolatilityTrigger?: Maybe<Scalars['numeric']>;
  gexZeroGammaLevel?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  oiData: Scalars['jsonb'];
  realizedVol20d?: Maybe<Scalars['numeric']>;
  skew25Delta?: Maybe<Scalars['numeric']>;
  spotPrice: Scalars['numeric'];
  ticker: Scalars['String'];
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeDate: Scalars['date'];
  updatedAt: Scalars['timestamptz'];
  vannaExposureTotal?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "options_eod" */
export type Options_EodChainDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "options_eod" */
export type Options_EodOiDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "options_eod" */
export type Options_Eod_Aggregate = {
  __typename?: 'options_eod_aggregate';
  aggregate?: Maybe<Options_Eod_Aggregate_Fields>;
  nodes: Array<Options_Eod>;
};

/** aggregate fields of "options_eod" */
export type Options_Eod_Aggregate_Fields = {
  __typename?: 'options_eod_aggregate_fields';
  avg?: Maybe<Options_Eod_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Options_Eod_Max_Fields>;
  min?: Maybe<Options_Eod_Min_Fields>;
  stddev?: Maybe<Options_Eod_Stddev_Fields>;
  stddev_pop?: Maybe<Options_Eod_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Options_Eod_Stddev_Samp_Fields>;
  sum?: Maybe<Options_Eod_Sum_Fields>;
  var_pop?: Maybe<Options_Eod_Var_Pop_Fields>;
  var_samp?: Maybe<Options_Eod_Var_Samp_Fields>;
  variance?: Maybe<Options_Eod_Variance_Fields>;
};


/** aggregate fields of "options_eod" */
export type Options_Eod_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Options_Eod_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Options_Eod_Append_Input = {
  chainData?: InputMaybe<Scalars['jsonb']>;
  oiData?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Options_Eod_Avg_Fields = {
  __typename?: 'options_eod_avg_fields';
  atmIv30d?: Maybe<Scalars['Float']>;
  atmIv90d?: Maybe<Scalars['Float']>;
  charmExposureTotal?: Maybe<Scalars['Float']>;
  deltaExposureTotal?: Maybe<Scalars['Float']>;
  gexCall?: Maybe<Scalars['Float']>;
  gexCallWallStrike?: Maybe<Scalars['Float']>;
  gexNet?: Maybe<Scalars['Float']>;
  gexPeakStrike?: Maybe<Scalars['Float']>;
  gexPut?: Maybe<Scalars['Float']>;
  gexPutWallStrike?: Maybe<Scalars['Float']>;
  gexTotal?: Maybe<Scalars['Float']>;
  gexVolatilityTrigger?: Maybe<Scalars['Float']>;
  gexZeroGammaLevel?: Maybe<Scalars['Float']>;
  realizedVol20d?: Maybe<Scalars['Float']>;
  skew25Delta?: Maybe<Scalars['Float']>;
  spotPrice?: Maybe<Scalars['Float']>;
  vannaExposureTotal?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "options_eod". All fields are combined with a logical 'AND'. */
export type Options_Eod_Bool_Exp = {
  _and?: InputMaybe<Array<Options_Eod_Bool_Exp>>;
  _not?: InputMaybe<Options_Eod_Bool_Exp>;
  _or?: InputMaybe<Array<Options_Eod_Bool_Exp>>;
  atmIv30d?: InputMaybe<Numeric_Comparison_Exp>;
  atmIv90d?: InputMaybe<Numeric_Comparison_Exp>;
  chainData?: InputMaybe<Jsonb_Comparison_Exp>;
  charmExposureTotal?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deltaExposureTotal?: InputMaybe<Numeric_Comparison_Exp>;
  gexCall?: InputMaybe<Numeric_Comparison_Exp>;
  gexCallWallStrike?: InputMaybe<Numeric_Comparison_Exp>;
  gexNet?: InputMaybe<Numeric_Comparison_Exp>;
  gexPeakStrike?: InputMaybe<Numeric_Comparison_Exp>;
  gexPut?: InputMaybe<Numeric_Comparison_Exp>;
  gexPutWallStrike?: InputMaybe<Numeric_Comparison_Exp>;
  gexTotal?: InputMaybe<Numeric_Comparison_Exp>;
  gexVolatilityTrigger?: InputMaybe<Numeric_Comparison_Exp>;
  gexZeroGammaLevel?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  oiData?: InputMaybe<Jsonb_Comparison_Exp>;
  realizedVol20d?: InputMaybe<Numeric_Comparison_Exp>;
  skew25Delta?: InputMaybe<Numeric_Comparison_Exp>;
  spotPrice?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeDate?: InputMaybe<Date_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vannaExposureTotal?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "options_eod" */
export const Options_Eod_Constraint = {
  /** unique or primary key constraint on columns "id" */
  OptionsEodPkey: 'options_eod_pkey',
  /** unique or primary key constraint on columns "ticker", "tradeDate" */
  OptionsEodTickerTradeDateKey: 'options_eod_ticker_tradeDate_key'
} as const;

export type Options_Eod_Constraint = typeof Options_Eod_Constraint[keyof typeof Options_Eod_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Options_Eod_Delete_At_Path_Input = {
  chainData?: InputMaybe<Array<Scalars['String']>>;
  oiData?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Options_Eod_Delete_Elem_Input = {
  chainData?: InputMaybe<Scalars['Int']>;
  oiData?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Options_Eod_Delete_Key_Input = {
  chainData?: InputMaybe<Scalars['String']>;
  oiData?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "options_eod" */
export type Options_Eod_Inc_Input = {
  atmIv30d?: InputMaybe<Scalars['numeric']>;
  atmIv90d?: InputMaybe<Scalars['numeric']>;
  charmExposureTotal?: InputMaybe<Scalars['numeric']>;
  deltaExposureTotal?: InputMaybe<Scalars['numeric']>;
  gexCall?: InputMaybe<Scalars['numeric']>;
  gexCallWallStrike?: InputMaybe<Scalars['numeric']>;
  gexNet?: InputMaybe<Scalars['numeric']>;
  gexPeakStrike?: InputMaybe<Scalars['numeric']>;
  gexPut?: InputMaybe<Scalars['numeric']>;
  gexPutWallStrike?: InputMaybe<Scalars['numeric']>;
  gexTotal?: InputMaybe<Scalars['numeric']>;
  gexVolatilityTrigger?: InputMaybe<Scalars['numeric']>;
  gexZeroGammaLevel?: InputMaybe<Scalars['numeric']>;
  realizedVol20d?: InputMaybe<Scalars['numeric']>;
  skew25Delta?: InputMaybe<Scalars['numeric']>;
  spotPrice?: InputMaybe<Scalars['numeric']>;
  vannaExposureTotal?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "options_eod" */
export type Options_Eod_Insert_Input = {
  atmIv30d?: InputMaybe<Scalars['numeric']>;
  atmIv90d?: InputMaybe<Scalars['numeric']>;
  chainData?: InputMaybe<Scalars['jsonb']>;
  charmExposureTotal?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deltaExposureTotal?: InputMaybe<Scalars['numeric']>;
  gexCall?: InputMaybe<Scalars['numeric']>;
  gexCallWallStrike?: InputMaybe<Scalars['numeric']>;
  gexNet?: InputMaybe<Scalars['numeric']>;
  gexPeakStrike?: InputMaybe<Scalars['numeric']>;
  gexPut?: InputMaybe<Scalars['numeric']>;
  gexPutWallStrike?: InputMaybe<Scalars['numeric']>;
  gexTotal?: InputMaybe<Scalars['numeric']>;
  gexVolatilityTrigger?: InputMaybe<Scalars['numeric']>;
  gexZeroGammaLevel?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  oiData?: InputMaybe<Scalars['jsonb']>;
  realizedVol20d?: InputMaybe<Scalars['numeric']>;
  skew25Delta?: InputMaybe<Scalars['numeric']>;
  spotPrice?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  tradeDate?: InputMaybe<Scalars['date']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vannaExposureTotal?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Options_Eod_Max_Fields = {
  __typename?: 'options_eod_max_fields';
  atmIv30d?: Maybe<Scalars['numeric']>;
  atmIv90d?: Maybe<Scalars['numeric']>;
  charmExposureTotal?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  deltaExposureTotal?: Maybe<Scalars['numeric']>;
  gexCall?: Maybe<Scalars['numeric']>;
  gexCallWallStrike?: Maybe<Scalars['numeric']>;
  gexNet?: Maybe<Scalars['numeric']>;
  gexPeakStrike?: Maybe<Scalars['numeric']>;
  gexPut?: Maybe<Scalars['numeric']>;
  gexPutWallStrike?: Maybe<Scalars['numeric']>;
  gexTotal?: Maybe<Scalars['numeric']>;
  gexVolatilityTrigger?: Maybe<Scalars['numeric']>;
  gexZeroGammaLevel?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  realizedVol20d?: Maybe<Scalars['numeric']>;
  skew25Delta?: Maybe<Scalars['numeric']>;
  spotPrice?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeDate?: Maybe<Scalars['date']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vannaExposureTotal?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Options_Eod_Min_Fields = {
  __typename?: 'options_eod_min_fields';
  atmIv30d?: Maybe<Scalars['numeric']>;
  atmIv90d?: Maybe<Scalars['numeric']>;
  charmExposureTotal?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  deltaExposureTotal?: Maybe<Scalars['numeric']>;
  gexCall?: Maybe<Scalars['numeric']>;
  gexCallWallStrike?: Maybe<Scalars['numeric']>;
  gexNet?: Maybe<Scalars['numeric']>;
  gexPeakStrike?: Maybe<Scalars['numeric']>;
  gexPut?: Maybe<Scalars['numeric']>;
  gexPutWallStrike?: Maybe<Scalars['numeric']>;
  gexTotal?: Maybe<Scalars['numeric']>;
  gexVolatilityTrigger?: Maybe<Scalars['numeric']>;
  gexZeroGammaLevel?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  realizedVol20d?: Maybe<Scalars['numeric']>;
  skew25Delta?: Maybe<Scalars['numeric']>;
  spotPrice?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeDate?: Maybe<Scalars['date']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vannaExposureTotal?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "options_eod" */
export type Options_Eod_Mutation_Response = {
  __typename?: 'options_eod_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Options_Eod>;
};

/** input type for inserting object relation for remote table "options_eod" */
export type Options_Eod_Obj_Rel_Insert_Input = {
  data: Options_Eod_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Options_Eod_On_Conflict>;
};

/** on_conflict condition type for table "options_eod" */
export type Options_Eod_On_Conflict = {
  constraint: Options_Eod_Constraint;
  update_columns?: Array<Options_Eod_Update_Column>;
  where?: InputMaybe<Options_Eod_Bool_Exp>;
};

/** Ordering options when selecting data from "options_eod". */
export type Options_Eod_Order_By = {
  atmIv30d?: InputMaybe<Order_By>;
  atmIv90d?: InputMaybe<Order_By>;
  chainData?: InputMaybe<Order_By>;
  charmExposureTotal?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  deltaExposureTotal?: InputMaybe<Order_By>;
  gexCall?: InputMaybe<Order_By>;
  gexCallWallStrike?: InputMaybe<Order_By>;
  gexNet?: InputMaybe<Order_By>;
  gexPeakStrike?: InputMaybe<Order_By>;
  gexPut?: InputMaybe<Order_By>;
  gexPutWallStrike?: InputMaybe<Order_By>;
  gexTotal?: InputMaybe<Order_By>;
  gexVolatilityTrigger?: InputMaybe<Order_By>;
  gexZeroGammaLevel?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oiData?: InputMaybe<Order_By>;
  realizedVol20d?: InputMaybe<Order_By>;
  skew25Delta?: InputMaybe<Order_By>;
  spotPrice?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vannaExposureTotal?: InputMaybe<Order_By>;
};

/** primary key columns input for table: options_eod */
export type Options_Eod_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Options_Eod_Prepend_Input = {
  chainData?: InputMaybe<Scalars['jsonb']>;
  oiData?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "options_eod" */
export const Options_Eod_Select_Column = {
  /** column name */
  AtmIv30d: 'atmIv30d',
  /** column name */
  AtmIv90d: 'atmIv90d',
  /** column name */
  ChainData: 'chainData',
  /** column name */
  CharmExposureTotal: 'charmExposureTotal',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  DeltaExposureTotal: 'deltaExposureTotal',
  /** column name */
  GexCall: 'gexCall',
  /** column name */
  GexCallWallStrike: 'gexCallWallStrike',
  /** column name */
  GexNet: 'gexNet',
  /** column name */
  GexPeakStrike: 'gexPeakStrike',
  /** column name */
  GexPut: 'gexPut',
  /** column name */
  GexPutWallStrike: 'gexPutWallStrike',
  /** column name */
  GexTotal: 'gexTotal',
  /** column name */
  GexVolatilityTrigger: 'gexVolatilityTrigger',
  /** column name */
  GexZeroGammaLevel: 'gexZeroGammaLevel',
  /** column name */
  Id: 'id',
  /** column name */
  OiData: 'oiData',
  /** column name */
  RealizedVol20d: 'realizedVol20d',
  /** column name */
  Skew25Delta: 'skew25Delta',
  /** column name */
  SpotPrice: 'spotPrice',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeDate: 'tradeDate',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  VannaExposureTotal: 'vannaExposureTotal'
} as const;

export type Options_Eod_Select_Column = typeof Options_Eod_Select_Column[keyof typeof Options_Eod_Select_Column];
/** input type for updating data in table "options_eod" */
export type Options_Eod_Set_Input = {
  atmIv30d?: InputMaybe<Scalars['numeric']>;
  atmIv90d?: InputMaybe<Scalars['numeric']>;
  chainData?: InputMaybe<Scalars['jsonb']>;
  charmExposureTotal?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deltaExposureTotal?: InputMaybe<Scalars['numeric']>;
  gexCall?: InputMaybe<Scalars['numeric']>;
  gexCallWallStrike?: InputMaybe<Scalars['numeric']>;
  gexNet?: InputMaybe<Scalars['numeric']>;
  gexPeakStrike?: InputMaybe<Scalars['numeric']>;
  gexPut?: InputMaybe<Scalars['numeric']>;
  gexPutWallStrike?: InputMaybe<Scalars['numeric']>;
  gexTotal?: InputMaybe<Scalars['numeric']>;
  gexVolatilityTrigger?: InputMaybe<Scalars['numeric']>;
  gexZeroGammaLevel?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  oiData?: InputMaybe<Scalars['jsonb']>;
  realizedVol20d?: InputMaybe<Scalars['numeric']>;
  skew25Delta?: InputMaybe<Scalars['numeric']>;
  spotPrice?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeDate?: InputMaybe<Scalars['date']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vannaExposureTotal?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Options_Eod_Stddev_Fields = {
  __typename?: 'options_eod_stddev_fields';
  atmIv30d?: Maybe<Scalars['Float']>;
  atmIv90d?: Maybe<Scalars['Float']>;
  charmExposureTotal?: Maybe<Scalars['Float']>;
  deltaExposureTotal?: Maybe<Scalars['Float']>;
  gexCall?: Maybe<Scalars['Float']>;
  gexCallWallStrike?: Maybe<Scalars['Float']>;
  gexNet?: Maybe<Scalars['Float']>;
  gexPeakStrike?: Maybe<Scalars['Float']>;
  gexPut?: Maybe<Scalars['Float']>;
  gexPutWallStrike?: Maybe<Scalars['Float']>;
  gexTotal?: Maybe<Scalars['Float']>;
  gexVolatilityTrigger?: Maybe<Scalars['Float']>;
  gexZeroGammaLevel?: Maybe<Scalars['Float']>;
  realizedVol20d?: Maybe<Scalars['Float']>;
  skew25Delta?: Maybe<Scalars['Float']>;
  spotPrice?: Maybe<Scalars['Float']>;
  vannaExposureTotal?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Options_Eod_Stddev_Pop_Fields = {
  __typename?: 'options_eod_stddev_pop_fields';
  atmIv30d?: Maybe<Scalars['Float']>;
  atmIv90d?: Maybe<Scalars['Float']>;
  charmExposureTotal?: Maybe<Scalars['Float']>;
  deltaExposureTotal?: Maybe<Scalars['Float']>;
  gexCall?: Maybe<Scalars['Float']>;
  gexCallWallStrike?: Maybe<Scalars['Float']>;
  gexNet?: Maybe<Scalars['Float']>;
  gexPeakStrike?: Maybe<Scalars['Float']>;
  gexPut?: Maybe<Scalars['Float']>;
  gexPutWallStrike?: Maybe<Scalars['Float']>;
  gexTotal?: Maybe<Scalars['Float']>;
  gexVolatilityTrigger?: Maybe<Scalars['Float']>;
  gexZeroGammaLevel?: Maybe<Scalars['Float']>;
  realizedVol20d?: Maybe<Scalars['Float']>;
  skew25Delta?: Maybe<Scalars['Float']>;
  spotPrice?: Maybe<Scalars['Float']>;
  vannaExposureTotal?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Options_Eod_Stddev_Samp_Fields = {
  __typename?: 'options_eod_stddev_samp_fields';
  atmIv30d?: Maybe<Scalars['Float']>;
  atmIv90d?: Maybe<Scalars['Float']>;
  charmExposureTotal?: Maybe<Scalars['Float']>;
  deltaExposureTotal?: Maybe<Scalars['Float']>;
  gexCall?: Maybe<Scalars['Float']>;
  gexCallWallStrike?: Maybe<Scalars['Float']>;
  gexNet?: Maybe<Scalars['Float']>;
  gexPeakStrike?: Maybe<Scalars['Float']>;
  gexPut?: Maybe<Scalars['Float']>;
  gexPutWallStrike?: Maybe<Scalars['Float']>;
  gexTotal?: Maybe<Scalars['Float']>;
  gexVolatilityTrigger?: Maybe<Scalars['Float']>;
  gexZeroGammaLevel?: Maybe<Scalars['Float']>;
  realizedVol20d?: Maybe<Scalars['Float']>;
  skew25Delta?: Maybe<Scalars['Float']>;
  spotPrice?: Maybe<Scalars['Float']>;
  vannaExposureTotal?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "options_eod" */
export type Options_Eod_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Options_Eod_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Options_Eod_Stream_Cursor_Value_Input = {
  atmIv30d?: InputMaybe<Scalars['numeric']>;
  atmIv90d?: InputMaybe<Scalars['numeric']>;
  chainData?: InputMaybe<Scalars['jsonb']>;
  charmExposureTotal?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deltaExposureTotal?: InputMaybe<Scalars['numeric']>;
  gexCall?: InputMaybe<Scalars['numeric']>;
  gexCallWallStrike?: InputMaybe<Scalars['numeric']>;
  gexNet?: InputMaybe<Scalars['numeric']>;
  gexPeakStrike?: InputMaybe<Scalars['numeric']>;
  gexPut?: InputMaybe<Scalars['numeric']>;
  gexPutWallStrike?: InputMaybe<Scalars['numeric']>;
  gexTotal?: InputMaybe<Scalars['numeric']>;
  gexVolatilityTrigger?: InputMaybe<Scalars['numeric']>;
  gexZeroGammaLevel?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  oiData?: InputMaybe<Scalars['jsonb']>;
  realizedVol20d?: InputMaybe<Scalars['numeric']>;
  skew25Delta?: InputMaybe<Scalars['numeric']>;
  spotPrice?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeDate?: InputMaybe<Scalars['date']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vannaExposureTotal?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Options_Eod_Sum_Fields = {
  __typename?: 'options_eod_sum_fields';
  atmIv30d?: Maybe<Scalars['numeric']>;
  atmIv90d?: Maybe<Scalars['numeric']>;
  charmExposureTotal?: Maybe<Scalars['numeric']>;
  deltaExposureTotal?: Maybe<Scalars['numeric']>;
  gexCall?: Maybe<Scalars['numeric']>;
  gexCallWallStrike?: Maybe<Scalars['numeric']>;
  gexNet?: Maybe<Scalars['numeric']>;
  gexPeakStrike?: Maybe<Scalars['numeric']>;
  gexPut?: Maybe<Scalars['numeric']>;
  gexPutWallStrike?: Maybe<Scalars['numeric']>;
  gexTotal?: Maybe<Scalars['numeric']>;
  gexVolatilityTrigger?: Maybe<Scalars['numeric']>;
  gexZeroGammaLevel?: Maybe<Scalars['numeric']>;
  realizedVol20d?: Maybe<Scalars['numeric']>;
  skew25Delta?: Maybe<Scalars['numeric']>;
  spotPrice?: Maybe<Scalars['numeric']>;
  vannaExposureTotal?: Maybe<Scalars['numeric']>;
};

/** update columns of table "options_eod" */
export const Options_Eod_Update_Column = {
  /** column name */
  AtmIv30d: 'atmIv30d',
  /** column name */
  AtmIv90d: 'atmIv90d',
  /** column name */
  ChainData: 'chainData',
  /** column name */
  CharmExposureTotal: 'charmExposureTotal',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  DeltaExposureTotal: 'deltaExposureTotal',
  /** column name */
  GexCall: 'gexCall',
  /** column name */
  GexCallWallStrike: 'gexCallWallStrike',
  /** column name */
  GexNet: 'gexNet',
  /** column name */
  GexPeakStrike: 'gexPeakStrike',
  /** column name */
  GexPut: 'gexPut',
  /** column name */
  GexPutWallStrike: 'gexPutWallStrike',
  /** column name */
  GexTotal: 'gexTotal',
  /** column name */
  GexVolatilityTrigger: 'gexVolatilityTrigger',
  /** column name */
  GexZeroGammaLevel: 'gexZeroGammaLevel',
  /** column name */
  Id: 'id',
  /** column name */
  OiData: 'oiData',
  /** column name */
  RealizedVol20d: 'realizedVol20d',
  /** column name */
  Skew25Delta: 'skew25Delta',
  /** column name */
  SpotPrice: 'spotPrice',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeDate: 'tradeDate',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  VannaExposureTotal: 'vannaExposureTotal'
} as const;

export type Options_Eod_Update_Column = typeof Options_Eod_Update_Column[keyof typeof Options_Eod_Update_Column];
export type Options_Eod_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Options_Eod_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Options_Eod_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Options_Eod_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Options_Eod_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Options_Eod_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Options_Eod_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Options_Eod_Set_Input>;
  /** filter the rows which have to be updated */
  where: Options_Eod_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Options_Eod_Var_Pop_Fields = {
  __typename?: 'options_eod_var_pop_fields';
  atmIv30d?: Maybe<Scalars['Float']>;
  atmIv90d?: Maybe<Scalars['Float']>;
  charmExposureTotal?: Maybe<Scalars['Float']>;
  deltaExposureTotal?: Maybe<Scalars['Float']>;
  gexCall?: Maybe<Scalars['Float']>;
  gexCallWallStrike?: Maybe<Scalars['Float']>;
  gexNet?: Maybe<Scalars['Float']>;
  gexPeakStrike?: Maybe<Scalars['Float']>;
  gexPut?: Maybe<Scalars['Float']>;
  gexPutWallStrike?: Maybe<Scalars['Float']>;
  gexTotal?: Maybe<Scalars['Float']>;
  gexVolatilityTrigger?: Maybe<Scalars['Float']>;
  gexZeroGammaLevel?: Maybe<Scalars['Float']>;
  realizedVol20d?: Maybe<Scalars['Float']>;
  skew25Delta?: Maybe<Scalars['Float']>;
  spotPrice?: Maybe<Scalars['Float']>;
  vannaExposureTotal?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Options_Eod_Var_Samp_Fields = {
  __typename?: 'options_eod_var_samp_fields';
  atmIv30d?: Maybe<Scalars['Float']>;
  atmIv90d?: Maybe<Scalars['Float']>;
  charmExposureTotal?: Maybe<Scalars['Float']>;
  deltaExposureTotal?: Maybe<Scalars['Float']>;
  gexCall?: Maybe<Scalars['Float']>;
  gexCallWallStrike?: Maybe<Scalars['Float']>;
  gexNet?: Maybe<Scalars['Float']>;
  gexPeakStrike?: Maybe<Scalars['Float']>;
  gexPut?: Maybe<Scalars['Float']>;
  gexPutWallStrike?: Maybe<Scalars['Float']>;
  gexTotal?: Maybe<Scalars['Float']>;
  gexVolatilityTrigger?: Maybe<Scalars['Float']>;
  gexZeroGammaLevel?: Maybe<Scalars['Float']>;
  realizedVol20d?: Maybe<Scalars['Float']>;
  skew25Delta?: Maybe<Scalars['Float']>;
  spotPrice?: Maybe<Scalars['Float']>;
  vannaExposureTotal?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Options_Eod_Variance_Fields = {
  __typename?: 'options_eod_variance_fields';
  atmIv30d?: Maybe<Scalars['Float']>;
  atmIv90d?: Maybe<Scalars['Float']>;
  charmExposureTotal?: Maybe<Scalars['Float']>;
  deltaExposureTotal?: Maybe<Scalars['Float']>;
  gexCall?: Maybe<Scalars['Float']>;
  gexCallWallStrike?: Maybe<Scalars['Float']>;
  gexNet?: Maybe<Scalars['Float']>;
  gexPeakStrike?: Maybe<Scalars['Float']>;
  gexPut?: Maybe<Scalars['Float']>;
  gexPutWallStrike?: Maybe<Scalars['Float']>;
  gexTotal?: Maybe<Scalars['Float']>;
  gexVolatilityTrigger?: Maybe<Scalars['Float']>;
  gexZeroGammaLevel?: Maybe<Scalars['Float']>;
  realizedVol20d?: Maybe<Scalars['Float']>;
  skew25Delta?: Maybe<Scalars['Float']>;
  spotPrice?: Maybe<Scalars['Float']>;
  vannaExposureTotal?: Maybe<Scalars['Float']>;
};

/** column ordering options */
export const Order_By = {
  /** in ascending order, nulls last */
  Asc: 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst: 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast: 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc: 'desc',
  /** in descending order, nulls first */
  DescNullsFirst: 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast: 'desc_nulls_last'
} as const;

export type Order_By = typeof Order_By[keyof typeof Order_By];
/** columns and relationships of "prelaunch_email_list" */
export type Prelaunch_Email_List = {
  __typename?: 'prelaunch_email_list';
  createdAt: Scalars['timestamptz'];
  email: Scalars['String'];
  id: Scalars['uuid'];
  ip?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "prelaunch_email_list" */
export type Prelaunch_Email_List_Aggregate = {
  __typename?: 'prelaunch_email_list_aggregate';
  aggregate?: Maybe<Prelaunch_Email_List_Aggregate_Fields>;
  nodes: Array<Prelaunch_Email_List>;
};

/** aggregate fields of "prelaunch_email_list" */
export type Prelaunch_Email_List_Aggregate_Fields = {
  __typename?: 'prelaunch_email_list_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Prelaunch_Email_List_Max_Fields>;
  min?: Maybe<Prelaunch_Email_List_Min_Fields>;
};


/** aggregate fields of "prelaunch_email_list" */
export type Prelaunch_Email_List_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prelaunch_Email_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "prelaunch_email_list". All fields are combined with a logical 'AND'. */
export type Prelaunch_Email_List_Bool_Exp = {
  _and?: InputMaybe<Array<Prelaunch_Email_List_Bool_Exp>>;
  _not?: InputMaybe<Prelaunch_Email_List_Bool_Exp>;
  _or?: InputMaybe<Array<Prelaunch_Email_List_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "prelaunch_email_list" */
export const Prelaunch_Email_List_Constraint = {
  /** unique or primary key constraint on columns "email" */
  PrelaunchEmailListEmailKey: 'prelaunch_email_list_email_key',
  /** unique or primary key constraint on columns "id" */
  PrelaunchEmailListPkey: 'prelaunch_email_list_pkey'
} as const;

export type Prelaunch_Email_List_Constraint = typeof Prelaunch_Email_List_Constraint[keyof typeof Prelaunch_Email_List_Constraint];
/** input type for inserting data into table "prelaunch_email_list" */
export type Prelaunch_Email_List_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Prelaunch_Email_List_Max_Fields = {
  __typename?: 'prelaunch_email_list_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Prelaunch_Email_List_Min_Fields = {
  __typename?: 'prelaunch_email_list_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "prelaunch_email_list" */
export type Prelaunch_Email_List_Mutation_Response = {
  __typename?: 'prelaunch_email_list_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Prelaunch_Email_List>;
};

/** on_conflict condition type for table "prelaunch_email_list" */
export type Prelaunch_Email_List_On_Conflict = {
  constraint: Prelaunch_Email_List_Constraint;
  update_columns?: Array<Prelaunch_Email_List_Update_Column>;
  where?: InputMaybe<Prelaunch_Email_List_Bool_Exp>;
};

/** Ordering options when selecting data from "prelaunch_email_list". */
export type Prelaunch_Email_List_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prelaunch_email_list */
export type Prelaunch_Email_List_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "prelaunch_email_list" */
export const Prelaunch_Email_List_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Email: 'email',
  /** column name */
  Id: 'id',
  /** column name */
  Ip: 'ip',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Prelaunch_Email_List_Select_Column = typeof Prelaunch_Email_List_Select_Column[keyof typeof Prelaunch_Email_List_Select_Column];
/** input type for updating data in table "prelaunch_email_list" */
export type Prelaunch_Email_List_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "prelaunch_email_list" */
export type Prelaunch_Email_List_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prelaunch_Email_List_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prelaunch_Email_List_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "prelaunch_email_list" */
export const Prelaunch_Email_List_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Email: 'email',
  /** column name */
  Id: 'id',
  /** column name */
  Ip: 'ip',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Prelaunch_Email_List_Update_Column = typeof Prelaunch_Email_List_Update_Column[keyof typeof Prelaunch_Email_List_Update_Column];
export type Prelaunch_Email_List_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prelaunch_Email_List_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prelaunch_Email_List_Bool_Exp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "active_option_tickers" */
  active_option_tickers: Array<Active_Option_Tickers>;
  /** fetch aggregated fields from the table: "active_option_tickers" */
  active_option_tickers_aggregate: Active_Option_Tickers_Aggregate;
  /** fetch data from the table: "affiliate_link_clicks" */
  affiliate_link_clicks: Array<Affiliate_Link_Clicks>;
  /** fetch aggregated fields from the table: "affiliate_link_clicks" */
  affiliate_link_clicks_aggregate: Affiliate_Link_Clicks_Aggregate;
  /** fetch data from the table: "affiliate_link_clicks" using primary key columns */
  affiliate_link_clicks_by_pk?: Maybe<Affiliate_Link_Clicks>;
  /** fetch data from the table: "affiliate_payouts" */
  affiliate_payouts: Array<Affiliate_Payouts>;
  /** fetch aggregated fields from the table: "affiliate_payouts" */
  affiliate_payouts_aggregate: Affiliate_Payouts_Aggregate;
  /** fetch data from the table: "affiliate_payouts" using primary key columns */
  affiliate_payouts_by_pk?: Maybe<Affiliate_Payouts>;
  /** fetch data from the table: "affiliate_referral_click_counts" */
  affiliate_referral_click_counts: Array<Affiliate_Referral_Click_Counts>;
  /** fetch aggregated fields from the table: "affiliate_referral_click_counts" */
  affiliate_referral_click_counts_aggregate: Affiliate_Referral_Click_Counts_Aggregate;
  /** fetch data from the table: "asset_signal_alerts" */
  asset_signal_alerts: Array<Asset_Signal_Alerts>;
  /** fetch aggregated fields from the table: "asset_signal_alerts" */
  asset_signal_alerts_aggregate: Asset_Signal_Alerts_Aggregate;
  /** fetch data from the table: "asset_signal_alerts" using primary key columns */
  asset_signal_alerts_by_pk?: Maybe<Asset_Signal_Alerts>;
  /** An array relationship */
  charges: Array<Charges>;
  /** An aggregate relationship */
  charges_aggregate: Charges_Aggregate;
  /** fetch data from the table: "charges" using primary key columns */
  charges_by_pk?: Maybe<Charges>;
  /** fetch data from the table: "congress_trades" */
  congress_trades: Array<Congress_Trades>;
  /** fetch aggregated fields from the table: "congress_trades" */
  congress_trades_aggregate: Congress_Trades_Aggregate;
  /** fetch data from the table: "congress_trades" using primary key columns */
  congress_trades_by_pk?: Maybe<Congress_Trades>;
  /** fetch data from the table: "cookie_strings" */
  cookie_strings: Array<Cookie_Strings>;
  /** fetch aggregated fields from the table: "cookie_strings" */
  cookie_strings_aggregate: Cookie_Strings_Aggregate;
  /** fetch data from the table: "cookie_strings" using primary key columns */
  cookie_strings_by_pk?: Maybe<Cookie_Strings>;
  /** fetch data from the table: "course_progress" */
  course_progress: Array<Course_Progress>;
  /** fetch aggregated fields from the table: "course_progress" */
  course_progress_aggregate: Course_Progress_Aggregate;
  /** fetch data from the table: "course_progress" using primary key columns */
  course_progress_by_pk?: Maybe<Course_Progress>;
  /** fetch data from the table: "course_progress_status" */
  course_progress_status: Array<Course_Progress_Status>;
  /** fetch aggregated fields from the table: "course_progress_status" */
  course_progress_status_aggregate: Course_Progress_Status_Aggregate;
  /** fetch data from the table: "course_progress_status" using primary key columns */
  course_progress_status_by_pk?: Maybe<Course_Progress_Status>;
  /** fetch data from the table: "daily_averages_exclude_today" */
  daily_averages_exclude_today: Array<Daily_Averages_Exclude_Today>;
  /** fetch aggregated fields from the table: "daily_averages_exclude_today" */
  daily_averages_exclude_today_aggregate: Daily_Averages_Exclude_Today_Aggregate;
  /** fetch data from the table: "daily_averages_include_today" */
  daily_averages_include_today: Array<Daily_Averages_Include_Today>;
  /** fetch aggregated fields from the table: "daily_averages_include_today" */
  daily_averages_include_today_aggregate: Daily_Averages_Include_Today_Aggregate;
  /** fetch data from the table: "daily_volume" */
  daily_volume: Array<Daily_Volume>;
  /** fetch aggregated fields from the table: "daily_volume" */
  daily_volume_aggregate: Daily_Volume_Aggregate;
  /** fetch data from the table: "dark_pool_levels" */
  dark_pool_levels: Array<Dark_Pool_Levels>;
  /** fetch aggregated fields from the table: "dark_pool_levels" */
  dark_pool_levels_aggregate: Dark_Pool_Levels_Aggregate;
  /** fetch data from the table: "dark_pool_levels_monthly" */
  dark_pool_levels_monthly: Array<Dark_Pool_Levels_Monthly>;
  /** fetch aggregated fields from the table: "dark_pool_levels_monthly" */
  dark_pool_levels_monthly_aggregate: Dark_Pool_Levels_Monthly_Aggregate;
  /** fetch data from the table: "demo_filtered_trades_spiderrock" */
  demo_filtered_trades_spiderrock: Array<Demo_Filtered_Trades_Spiderrock>;
  /** fetch aggregated fields from the table: "demo_filtered_trades_spiderrock" */
  demo_filtered_trades_spiderrock_aggregate: Demo_Filtered_Trades_Spiderrock_Aggregate;
  /** fetch data from the table: "demo_filtered_trades_spiderrock" using primary key columns */
  demo_filtered_trades_spiderrock_by_pk?: Maybe<Demo_Filtered_Trades_Spiderrock>;
  /** fetch data from the table: "demo_raw_trades_spiderrock" */
  demo_raw_trades_spiderrock: Array<Demo_Raw_Trades_Spiderrock>;
  /** fetch aggregated fields from the table: "demo_raw_trades_spiderrock" */
  demo_raw_trades_spiderrock_aggregate: Demo_Raw_Trades_Spiderrock_Aggregate;
  /** fetch data from the table: "demo_raw_trades_spiderrock" using primary key columns */
  demo_raw_trades_spiderrock_by_pk?: Maybe<Demo_Raw_Trades_Spiderrock>;
  /** fetch data from the table: "earnings_snp" */
  earnings_snp: Array<Earnings_Snp>;
  /** fetch aggregated fields from the table: "earnings_snp" */
  earnings_snp_aggregate: Earnings_Snp_Aggregate;
  /** fetch data from the table: "earnings_snp" using primary key columns */
  earnings_snp_by_pk?: Maybe<Earnings_Snp>;
  /** fetch data from the table: "email_alerts" */
  email_alerts: Array<Email_Alerts>;
  /** fetch aggregated fields from the table: "email_alerts" */
  email_alerts_aggregate: Email_Alerts_Aggregate;
  /** fetch data from the table: "email_alerts" using primary key columns */
  email_alerts_by_pk?: Maybe<Email_Alerts>;
  /** fetch data from the table: "email_list" */
  email_list: Array<Email_List>;
  /** fetch aggregated fields from the table: "email_list" */
  email_list_aggregate: Email_List_Aggregate;
  /** fetch data from the table: "email_list" using primary key columns */
  email_list_by_pk?: Maybe<Email_List>;
  /** fetch data from the table: "equities_eod" */
  equities_eod: Array<Equities_Eod>;
  /** fetch aggregated fields from the table: "equities_eod" */
  equities_eod_aggregate: Equities_Eod_Aggregate;
  /** fetch data from the table: "equities_eod" using primary key columns */
  equities_eod_by_pk?: Maybe<Equities_Eod>;
  /** fetch data from the table: "equity_pool_prints" */
  equity_pool_prints: Array<Equity_Pool_Prints>;
  /** fetch aggregated fields from the table: "equity_pool_prints" */
  equity_pool_prints_aggregate: Equity_Pool_Prints_Aggregate;
  /** fetch data from the table: "equity_pool_prints" using primary key columns */
  equity_pool_prints_by_pk?: Maybe<Equity_Pool_Prints>;
  /** fetch data from the table: "equity_print_feed_baseline" */
  equity_print_feed_baseline: Array<Equity_Print_Feed_Baseline>;
  /** fetch aggregated fields from the table: "equity_print_feed_baseline" */
  equity_print_feed_baseline_aggregate: Equity_Print_Feed_Baseline_Aggregate;
  /** fetch data from the table: "equity_print_feed_baseline" using primary key columns */
  equity_print_feed_baseline_by_pk?: Maybe<Equity_Print_Feed_Baseline>;
  /** fetch data from the table: "equity_print_feed_filtered" */
  equity_print_feed_filtered: Array<Equity_Print_Feed_Filtered>;
  /** fetch aggregated fields from the table: "equity_print_feed_filtered" */
  equity_print_feed_filtered_aggregate: Equity_Print_Feed_Filtered_Aggregate;
  /** fetch data from the table: "equity_print_feed_filtered" using primary key columns */
  equity_print_feed_filtered_by_pk?: Maybe<Equity_Print_Feed_Filtered>;
  /** fetch data from the table: "equity_print_flow" */
  equity_print_flow: Array<Equity_Print_Flow>;
  /** fetch aggregated fields from the table: "equity_print_flow" */
  equity_print_flow_aggregate: Equity_Print_Flow_Aggregate;
  /** fetch data from the table: "equity_print_flow_full" */
  equity_print_flow_full: Array<Equity_Print_Flow_Full>;
  /** fetch aggregated fields from the table: "equity_print_flow_full" */
  equity_print_flow_full_aggregate: Equity_Print_Flow_Full_Aggregate;
  /** fetch data from the table: "fa_call_moving_average" */
  fa_call_moving_average: Array<Fa_Call_Moving_Average>;
  /** fetch aggregated fields from the table: "fa_call_moving_average" */
  fa_call_moving_average_aggregate: Fa_Call_Moving_Average_Aggregate;
  /** fetch data from the table: "fa_put_moving_average" */
  fa_put_moving_average: Array<Fa_Put_Moving_Average>;
  /** fetch aggregated fields from the table: "fa_put_moving_average" */
  fa_put_moving_average_aggregate: Fa_Put_Moving_Average_Aggregate;
  /** fetch data from the table: "fa_trade_uploads" */
  fa_trade_uploads: Array<Fa_Trade_Uploads>;
  /** fetch aggregated fields from the table: "fa_trade_uploads" */
  fa_trade_uploads_aggregate: Fa_Trade_Uploads_Aggregate;
  /** fetch data from the table: "fa_trade_uploads" using primary key columns */
  fa_trade_uploads_by_pk?: Maybe<Fa_Trade_Uploads>;
  /** fetch data from the table: "fa_trades" */
  fa_trades: Array<Fa_Trades>;
  /** fetch aggregated fields from the table: "fa_trades" */
  fa_trades_aggregate: Fa_Trades_Aggregate;
  /** fetch data from the table: "fa_trades" using primary key columns */
  fa_trades_by_pk?: Maybe<Fa_Trades>;
  /** fetch data from the table: "feedback_boards" */
  feedback_boards: Array<Feedback_Boards>;
  /** fetch aggregated fields from the table: "feedback_boards" */
  feedback_boards_aggregate: Feedback_Boards_Aggregate;
  /** fetch data from the table: "feedback_boards" using primary key columns */
  feedback_boards_by_pk?: Maybe<Feedback_Boards>;
  /** fetch data from the table: "feedback_comments" */
  feedback_comments: Array<Feedback_Comments>;
  /** fetch aggregated fields from the table: "feedback_comments" */
  feedback_comments_aggregate: Feedback_Comments_Aggregate;
  /** fetch data from the table: "feedback_comments" using primary key columns */
  feedback_comments_by_pk?: Maybe<Feedback_Comments>;
  /** fetch data from the table: "feedback_media" */
  feedback_media: Array<Feedback_Media>;
  /** fetch aggregated fields from the table: "feedback_media" */
  feedback_media_aggregate: Feedback_Media_Aggregate;
  /** fetch data from the table: "feedback_media" using primary key columns */
  feedback_media_by_pk?: Maybe<Feedback_Media>;
  /** fetch data from the table: "feedback_post_contexts" */
  feedback_post_contexts: Array<Feedback_Post_Contexts>;
  /** fetch aggregated fields from the table: "feedback_post_contexts" */
  feedback_post_contexts_aggregate: Feedback_Post_Contexts_Aggregate;
  /** fetch data from the table: "feedback_post_contexts" using primary key columns */
  feedback_post_contexts_by_pk?: Maybe<Feedback_Post_Contexts>;
  /** fetch data from the table: "feedback_post_merges" */
  feedback_post_merges: Array<Feedback_Post_Merges>;
  /** fetch aggregated fields from the table: "feedback_post_merges" */
  feedback_post_merges_aggregate: Feedback_Post_Merges_Aggregate;
  /** fetch data from the table: "feedback_post_merges" using primary key columns */
  feedback_post_merges_by_pk?: Maybe<Feedback_Post_Merges>;
  /** fetch data from the table: "feedback_posts" */
  feedback_posts: Array<Feedback_Posts>;
  /** fetch aggregated fields from the table: "feedback_posts" */
  feedback_posts_aggregate: Feedback_Posts_Aggregate;
  /** fetch data from the table: "feedback_posts" using primary key columns */
  feedback_posts_by_pk?: Maybe<Feedback_Posts>;
  /** fetch data from the table: "feedback_posts_with_counts" */
  feedback_posts_with_counts: Array<Feedback_Posts_With_Counts>;
  /** fetch aggregated fields from the table: "feedback_posts_with_counts" */
  feedback_posts_with_counts_aggregate: Feedback_Posts_With_Counts_Aggregate;
  /** fetch data from the table: "feedback_release_posts" */
  feedback_release_posts: Array<Feedback_Release_Posts>;
  /** fetch aggregated fields from the table: "feedback_release_posts" */
  feedback_release_posts_aggregate: Feedback_Release_Posts_Aggregate;
  /** fetch data from the table: "feedback_release_posts" using primary key columns */
  feedback_release_posts_by_pk?: Maybe<Feedback_Release_Posts>;
  /** fetch data from the table: "feedback_releases" */
  feedback_releases: Array<Feedback_Releases>;
  /** fetch aggregated fields from the table: "feedback_releases" */
  feedback_releases_aggregate: Feedback_Releases_Aggregate;
  /** fetch data from the table: "feedback_releases" using primary key columns */
  feedback_releases_by_pk?: Maybe<Feedback_Releases>;
  /** fetch data from the table: "feedback_statuses" */
  feedback_statuses: Array<Feedback_Statuses>;
  /** fetch aggregated fields from the table: "feedback_statuses" */
  feedback_statuses_aggregate: Feedback_Statuses_Aggregate;
  /** fetch data from the table: "feedback_statuses" using primary key columns */
  feedback_statuses_by_pk?: Maybe<Feedback_Statuses>;
  /** fetch data from the table: "feedback_votes" */
  feedback_votes: Array<Feedback_Votes>;
  /** fetch aggregated fields from the table: "feedback_votes" */
  feedback_votes_aggregate: Feedback_Votes_Aggregate;
  /** fetch data from the table: "feedback_votes" using primary key columns */
  feedback_votes_by_pk?: Maybe<Feedback_Votes>;
  /** fetch data from the table: "flow_configurations" */
  flow_configurations: Array<Flow_Configurations>;
  /** fetch aggregated fields from the table: "flow_configurations" */
  flow_configurations_aggregate: Flow_Configurations_Aggregate;
  /** fetch data from the table: "flow_configurations" using primary key columns */
  flow_configurations_by_pk?: Maybe<Flow_Configurations>;
  /** fetch data from the table: "free_equity_print_flow" */
  free_equity_print_flow: Array<Free_Equity_Print_Flow>;
  /** fetch aggregated fields from the table: "free_equity_print_flow" */
  free_equity_print_flow_aggregate: Free_Equity_Print_Flow_Aggregate;
  /** fetch data from the table: "free_option_flow" */
  free_option_flow: Array<Free_Option_Flow>;
  /** fetch aggregated fields from the table: "free_option_flow" */
  free_option_flow_aggregate: Free_Option_Flow_Aggregate;
  /** fetch data from the table: "free_option_flow_all_sides" */
  free_option_flow_all_sides: Array<Free_Option_Flow_All_Sides>;
  /** fetch aggregated fields from the table: "free_option_flow_all_sides" */
  free_option_flow_all_sides_aggregate: Free_Option_Flow_All_Sides_Aggregate;
  /** fetch data from the table: "free_ticker_equity_print_flow" */
  free_ticker_equity_print_flow: Array<Free_Ticker_Equity_Print_Flow>;
  /** fetch aggregated fields from the table: "free_ticker_equity_print_flow" */
  free_ticker_equity_print_flow_aggregate: Free_Ticker_Equity_Print_Flow_Aggregate;
  /** fetch data from the table: "free_ticker_option_flow" */
  free_ticker_option_flow: Array<Free_Ticker_Option_Flow>;
  /** fetch aggregated fields from the table: "free_ticker_option_flow" */
  free_ticker_option_flow_aggregate: Free_Ticker_Option_Flow_Aggregate;
  /** fetch data from the table: "free_ticker_option_flow_all_sides" */
  free_ticker_option_flow_all_sides: Array<Free_Ticker_Option_Flow_All_Sides>;
  /** fetch aggregated fields from the table: "free_ticker_option_flow_all_sides" */
  free_ticker_option_flow_all_sides_aggregate: Free_Ticker_Option_Flow_All_Sides_Aggregate;
  /** fetch data from the table: "full_feed_equity_print_flow" */
  full_feed_equity_print_flow: Array<Full_Feed_Equity_Print_Flow>;
  /** fetch aggregated fields from the table: "full_feed_equity_print_flow" */
  full_feed_equity_print_flow_aggregate: Full_Feed_Equity_Print_Flow_Aggregate;
  /** fetch data from the table: "full_feed_option_flow" */
  full_feed_option_flow: Array<Full_Feed_Option_Flow>;
  /** fetch aggregated fields from the table: "full_feed_option_flow" */
  full_feed_option_flow_aggregate: Full_Feed_Option_Flow_Aggregate;
  /** fetch data from the table: "health_checks" */
  health_checks: Array<Health_Checks>;
  /** fetch aggregated fields from the table: "health_checks" */
  health_checks_aggregate: Health_Checks_Aggregate;
  /** fetch data from the table: "health_checks" using primary key columns */
  health_checks_by_pk?: Maybe<Health_Checks>;
  /** fetch data from the table: "insider_trades" */
  insider_trades: Array<Insider_Trades>;
  /** fetch aggregated fields from the table: "insider_trades" */
  insider_trades_aggregate: Insider_Trades_Aggregate;
  /** fetch data from the table: "insider_trades" using primary key columns */
  insider_trades_by_pk?: Maybe<Insider_Trades>;
  /** fetch data from the table: "insider_trades_top_long" */
  insider_trades_top_long: Array<Insider_Trades_Top_Long>;
  /** fetch aggregated fields from the table: "insider_trades_top_long" */
  insider_trades_top_long_aggregate: Insider_Trades_Top_Long_Aggregate;
  /** fetch data from the table: "insider_trades_top_short" */
  insider_trades_top_short: Array<Insider_Trades_Top_Short>;
  /** fetch aggregated fields from the table: "insider_trades_top_short" */
  insider_trades_top_short_aggregate: Insider_Trades_Top_Short_Aggregate;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoices_by_pk?: Maybe<Invoices>;
  /** fetch data from the table: "microsoft_access_tokens" */
  microsoft_access_tokens: Array<Microsoft_Access_Tokens>;
  /** fetch aggregated fields from the table: "microsoft_access_tokens" */
  microsoft_access_tokens_aggregate: Microsoft_Access_Tokens_Aggregate;
  /** fetch data from the table: "microsoft_access_tokens" using primary key columns */
  microsoft_access_tokens_by_pk?: Maybe<Microsoft_Access_Tokens>;
  /** fetch data from the table: "most_researched_tickers_daily_total" */
  most_researched_tickers_daily_total: Array<Most_Researched_Tickers_Daily_Total>;
  /** fetch aggregated fields from the table: "most_researched_tickers_daily_total" */
  most_researched_tickers_daily_total_aggregate: Most_Researched_Tickers_Daily_Total_Aggregate;
  /** fetch data from the table: "most_researched_tickers_daily_unique" */
  most_researched_tickers_daily_unique: Array<Most_Researched_Tickers_Daily_Unique>;
  /** fetch aggregated fields from the table: "most_researched_tickers_daily_unique" */
  most_researched_tickers_daily_unique_aggregate: Most_Researched_Tickers_Daily_Unique_Aggregate;
  /** fetch data from the table: "news_cache_stocks" */
  news_cache_stocks: Array<News_Cache_Stocks>;
  /** fetch aggregated fields from the table: "news_cache_stocks" */
  news_cache_stocks_aggregate: News_Cache_Stocks_Aggregate;
  /** fetch data from the table: "news_cache_stocks" using primary key columns */
  news_cache_stocks_by_pk?: Maybe<News_Cache_Stocks>;
  /** fetch data from the table: "newsletter_payloads" */
  newsletter_payloads: Array<Newsletter_Payloads>;
  /** fetch aggregated fields from the table: "newsletter_payloads" */
  newsletter_payloads_aggregate: Newsletter_Payloads_Aggregate;
  /** fetch data from the table: "newsletter_payloads" using primary key columns */
  newsletter_payloads_by_pk?: Maybe<Newsletter_Payloads>;
  /** fetch data from the table: "opc_saved_strategies" */
  opc_saved_strategies: Array<Opc_Saved_Strategies>;
  /** fetch aggregated fields from the table: "opc_saved_strategies" */
  opc_saved_strategies_aggregate: Opc_Saved_Strategies_Aggregate;
  /** fetch data from the table: "opc_saved_strategies" using primary key columns */
  opc_saved_strategies_by_pk?: Maybe<Opc_Saved_Strategies>;
  /** fetch data from the table: "opc_saved_strategy_positions" */
  opc_saved_strategy_positions: Array<Opc_Saved_Strategy_Positions>;
  /** fetch aggregated fields from the table: "opc_saved_strategy_positions" */
  opc_saved_strategy_positions_aggregate: Opc_Saved_Strategy_Positions_Aggregate;
  /** fetch data from the table: "opc_saved_strategy_positions" using primary key columns */
  opc_saved_strategy_positions_by_pk?: Maybe<Opc_Saved_Strategy_Positions>;
  /** fetch data from the table: "option_feed_baseline" */
  option_feed_baseline: Array<Option_Feed_Baseline>;
  /** fetch aggregated fields from the table: "option_feed_baseline" */
  option_feed_baseline_aggregate: Option_Feed_Baseline_Aggregate;
  /** fetch data from the table: "option_feed_baseline" using primary key columns */
  option_feed_baseline_by_pk?: Maybe<Option_Feed_Baseline>;
  /** fetch data from the table: "option_feed_filtered" */
  option_feed_filtered: Array<Option_Feed_Filtered>;
  /** fetch aggregated fields from the table: "option_feed_filtered" */
  option_feed_filtered_aggregate: Option_Feed_Filtered_Aggregate;
  /** fetch data from the table: "option_feed_filtered" using primary key columns */
  option_feed_filtered_by_pk?: Maybe<Option_Feed_Filtered>;
  /** fetch data from the table: "option_flow" */
  option_flow: Array<Option_Flow>;
  /** fetch aggregated fields from the table: "option_flow" */
  option_flow_aggregate: Option_Flow_Aggregate;
  /** fetch data from the table: "option_flow_all_sides" */
  option_flow_all_sides: Array<Option_Flow_All_Sides>;
  /** fetch aggregated fields from the table: "option_flow_all_sides" */
  option_flow_all_sides_aggregate: Option_Flow_All_Sides_Aggregate;
  /** fetch data from the table: "options_eod" */
  options_eod: Array<Options_Eod>;
  /** fetch aggregated fields from the table: "options_eod" */
  options_eod_aggregate: Options_Eod_Aggregate;
  /** fetch data from the table: "options_eod" using primary key columns */
  options_eod_by_pk?: Maybe<Options_Eod>;
  /** fetch data from the table: "prelaunch_email_list" */
  prelaunch_email_list: Array<Prelaunch_Email_List>;
  /** fetch aggregated fields from the table: "prelaunch_email_list" */
  prelaunch_email_list_aggregate: Prelaunch_Email_List_Aggregate;
  /** fetch data from the table: "prelaunch_email_list" using primary key columns */
  prelaunch_email_list_by_pk?: Maybe<Prelaunch_Email_List>;
  /** fetch data from the table: "ready_check" */
  ready_check: Array<Ready_Check>;
  /** fetch aggregated fields from the table: "ready_check" */
  ready_check_aggregate: Ready_Check_Aggregate;
  /** fetch data from the table: "ready_check" using primary key columns */
  ready_check_by_pk?: Maybe<Ready_Check>;
  /** fetch data from the table: "retention_feedback" */
  retention_feedback: Array<Retention_Feedback>;
  /** fetch aggregated fields from the table: "retention_feedback" */
  retention_feedback_aggregate: Retention_Feedback_Aggregate;
  /** fetch data from the table: "retention_feedback" using primary key columns */
  retention_feedback_by_pk?: Maybe<Retention_Feedback>;
  /** fetch data from the table: "retention_intervention_events" */
  retention_intervention_events: Array<Retention_Intervention_Events>;
  /** fetch aggregated fields from the table: "retention_intervention_events" */
  retention_intervention_events_aggregate: Retention_Intervention_Events_Aggregate;
  /** fetch data from the table: "retention_intervention_events" using primary key columns */
  retention_intervention_events_by_pk?: Maybe<Retention_Intervention_Events>;
  /** fetch data from the table: "retention_intervention_sessions" */
  retention_intervention_sessions: Array<Retention_Intervention_Sessions>;
  /** fetch aggregated fields from the table: "retention_intervention_sessions" */
  retention_intervention_sessions_aggregate: Retention_Intervention_Sessions_Aggregate;
  /** fetch data from the table: "retention_intervention_sessions" using primary key columns */
  retention_intervention_sessions_by_pk?: Maybe<Retention_Intervention_Sessions>;
  /** fetch data from the table: "retention_notification_deliveries" */
  retention_notification_deliveries: Array<Retention_Notification_Deliveries>;
  /** fetch aggregated fields from the table: "retention_notification_deliveries" */
  retention_notification_deliveries_aggregate: Retention_Notification_Deliveries_Aggregate;
  /** fetch data from the table: "retention_notification_deliveries" using primary key columns */
  retention_notification_deliveries_by_pk?: Maybe<Retention_Notification_Deliveries>;
  /** fetch data from the table: "retention_offer_exposures" */
  retention_offer_exposures: Array<Retention_Offer_Exposures>;
  /** fetch aggregated fields from the table: "retention_offer_exposures" */
  retention_offer_exposures_aggregate: Retention_Offer_Exposures_Aggregate;
  /** fetch data from the table: "retention_offer_exposures" using primary key columns */
  retention_offer_exposures_by_pk?: Maybe<Retention_Offer_Exposures>;
  /** An array relationship */
  sales: Array<Sales>;
  /** An aggregate relationship */
  sales_aggregate: Sales_Aggregate;
  /** fetch data from the table: "sales" using primary key columns */
  sales_by_pk?: Maybe<Sales>;
  /** fetch data from the table: "subscription_entitlements" */
  subscription_entitlements: Array<Subscription_Entitlements>;
  /** fetch aggregated fields from the table: "subscription_entitlements" */
  subscription_entitlements_aggregate: Subscription_Entitlements_Aggregate;
  /** fetch data from the table: "subscription_entitlements" using primary key columns */
  subscription_entitlements_by_pk?: Maybe<Subscription_Entitlements>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** fetch data from the table: "test_oct2023" */
  test_oct2023: Array<Test_Oct2023>;
  /** fetch aggregated fields from the table: "test_oct2023" */
  test_oct2023_aggregate: Test_Oct2023_Aggregate;
  /** fetch data from the table: "test_oct2023" using primary key columns */
  test_oct2023_by_pk?: Maybe<Test_Oct2023>;
  /** fetch data from the table: "ticker_details" */
  ticker_details: Array<Ticker_Details>;
  /** fetch aggregated fields from the table: "ticker_details" */
  ticker_details_aggregate: Ticker_Details_Aggregate;
  /** fetch data from the table: "ticker_details" using primary key columns */
  ticker_details_by_pk?: Maybe<Ticker_Details>;
  /** fetch data from the table: "ticker_equity_print_flow" */
  ticker_equity_print_flow: Array<Ticker_Equity_Print_Flow>;
  /** fetch aggregated fields from the table: "ticker_equity_print_flow" */
  ticker_equity_print_flow_aggregate: Ticker_Equity_Print_Flow_Aggregate;
  /** fetch data from the table: "ticker_option_flow" */
  ticker_option_flow: Array<Ticker_Option_Flow>;
  /** fetch aggregated fields from the table: "ticker_option_flow" */
  ticker_option_flow_aggregate: Ticker_Option_Flow_Aggregate;
  /** fetch data from the table: "ticker_option_flow_all_sides" */
  ticker_option_flow_all_sides: Array<Ticker_Option_Flow_All_Sides>;
  /** fetch aggregated fields from the table: "ticker_option_flow_all_sides" */
  ticker_option_flow_all_sides_aggregate: Ticker_Option_Flow_All_Sides_Aggregate;
  /** fetch data from the table: "ticker_research_all_views" */
  ticker_research_all_views: Array<Ticker_Research_All_Views>;
  /** fetch aggregated fields from the table: "ticker_research_all_views" */
  ticker_research_all_views_aggregate: Ticker_Research_All_Views_Aggregate;
  /** fetch data from the table: "ticker_research_all_views" using primary key columns */
  ticker_research_all_views_by_pk?: Maybe<Ticker_Research_All_Views>;
  /** fetch data from the table: "ticker_research_all_views_counts" */
  ticker_research_all_views_counts: Array<Ticker_Research_All_Views_Counts>;
  /** fetch aggregated fields from the table: "ticker_research_all_views_counts" */
  ticker_research_all_views_counts_aggregate: Ticker_Research_All_Views_Counts_Aggregate;
  /** fetch data from the table: "ticker_research_daily_views" */
  ticker_research_daily_views: Array<Ticker_Research_Daily_Views>;
  /** fetch aggregated fields from the table: "ticker_research_daily_views" */
  ticker_research_daily_views_aggregate: Ticker_Research_Daily_Views_Aggregate;
  /** fetch data from the table: "ticker_research_daily_views" using primary key columns */
  ticker_research_daily_views_by_pk?: Maybe<Ticker_Research_Daily_Views>;
  /** fetch data from the table: "timezone_location" */
  timezone_location: Array<Timezone_Location>;
  /** fetch aggregated fields from the table: "timezone_location" */
  timezone_location_aggregate: Timezone_Location_Aggregate;
  /** fetch data from the table: "timezone_location" using primary key columns */
  timezone_location_by_pk?: Maybe<Timezone_Location>;
  /** fetch data from the table: "top_tickers" */
  top_tickers: Array<Top_Tickers>;
  /** fetch aggregated fields from the table: "top_tickers" */
  top_tickers_aggregate: Top_Tickers_Aggregate;
  /** fetch data from the table: "top_tickers" using primary key columns */
  top_tickers_by_pk?: Maybe<Top_Tickers>;
  /** fetch data from the table: "usage_ping" */
  usage_ping: Array<Usage_Ping>;
  /** fetch aggregated fields from the table: "usage_ping" */
  usage_ping_aggregate: Usage_Ping_Aggregate;
  /** fetch data from the table: "usage_ping" using primary key columns */
  usage_ping_by_pk?: Maybe<Usage_Ping>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "watch_list" */
  watch_list: Array<Watch_List>;
  /** fetch aggregated fields from the table: "watch_list" */
  watch_list_aggregate: Watch_List_Aggregate;
  /** fetch data from the table: "watch_list" using primary key columns */
  watch_list_by_pk?: Maybe<Watch_List>;
  /** fetch data from the table: "weekly_option_flow" */
  weekly_option_flow: Array<Weekly_Option_Flow>;
  /** fetch aggregated fields from the table: "weekly_option_flow" */
  weekly_option_flow_aggregate: Weekly_Option_Flow_Aggregate;
  /** fetch data from the table: "weekly_option_flow_all_sides" */
  weekly_option_flow_all_sides: Array<Weekly_Option_Flow_All_Sides>;
  /** fetch aggregated fields from the table: "weekly_option_flow_all_sides" */
  weekly_option_flow_all_sides_aggregate: Weekly_Option_Flow_All_Sides_Aggregate;
};


export type Query_RootActive_Option_TickersArgs = {
  distinct_on?: InputMaybe<Array<Active_Option_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Option_Tickers_Order_By>>;
  where?: InputMaybe<Active_Option_Tickers_Bool_Exp>;
};


export type Query_RootActive_Option_Tickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Active_Option_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Option_Tickers_Order_By>>;
  where?: InputMaybe<Active_Option_Tickers_Bool_Exp>;
};


export type Query_RootAffiliate_Link_ClicksArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Link_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Link_Clicks_Order_By>>;
  where?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
};


export type Query_RootAffiliate_Link_Clicks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Link_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Link_Clicks_Order_By>>;
  where?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
};


export type Query_RootAffiliate_Link_Clicks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAffiliate_PayoutsArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Payouts_Order_By>>;
  where?: InputMaybe<Affiliate_Payouts_Bool_Exp>;
};


export type Query_RootAffiliate_Payouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Payouts_Order_By>>;
  where?: InputMaybe<Affiliate_Payouts_Bool_Exp>;
};


export type Query_RootAffiliate_Payouts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAffiliate_Referral_Click_CountsArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Order_By>>;
  where?: InputMaybe<Affiliate_Referral_Click_Counts_Bool_Exp>;
};


export type Query_RootAffiliate_Referral_Click_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Order_By>>;
  where?: InputMaybe<Affiliate_Referral_Click_Counts_Bool_Exp>;
};


export type Query_RootAsset_Signal_AlertsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Signal_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Signal_Alerts_Order_By>>;
  where?: InputMaybe<Asset_Signal_Alerts_Bool_Exp>;
};


export type Query_RootAsset_Signal_Alerts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Signal_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Signal_Alerts_Order_By>>;
  where?: InputMaybe<Asset_Signal_Alerts_Bool_Exp>;
};


export type Query_RootAsset_Signal_Alerts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootChargesArgs = {
  distinct_on?: InputMaybe<Array<Charges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Charges_Order_By>>;
  where?: InputMaybe<Charges_Bool_Exp>;
};


export type Query_RootCharges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Charges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Charges_Order_By>>;
  where?: InputMaybe<Charges_Bool_Exp>;
};


export type Query_RootCharges_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCongress_TradesArgs = {
  distinct_on?: InputMaybe<Array<Congress_Trades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Congress_Trades_Order_By>>;
  where?: InputMaybe<Congress_Trades_Bool_Exp>;
};


export type Query_RootCongress_Trades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Congress_Trades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Congress_Trades_Order_By>>;
  where?: InputMaybe<Congress_Trades_Bool_Exp>;
};


export type Query_RootCongress_Trades_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCookie_StringsArgs = {
  distinct_on?: InputMaybe<Array<Cookie_Strings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cookie_Strings_Order_By>>;
  where?: InputMaybe<Cookie_Strings_Bool_Exp>;
};


export type Query_RootCookie_Strings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cookie_Strings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cookie_Strings_Order_By>>;
  where?: InputMaybe<Cookie_Strings_Bool_Exp>;
};


export type Query_RootCookie_Strings_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootCourse_ProgressArgs = {
  distinct_on?: InputMaybe<Array<Course_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Progress_Order_By>>;
  where?: InputMaybe<Course_Progress_Bool_Exp>;
};


export type Query_RootCourse_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Progress_Order_By>>;
  where?: InputMaybe<Course_Progress_Bool_Exp>;
};


export type Query_RootCourse_Progress_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Progress_StatusArgs = {
  distinct_on?: InputMaybe<Array<Course_Progress_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Progress_Status_Order_By>>;
  where?: InputMaybe<Course_Progress_Status_Bool_Exp>;
};


export type Query_RootCourse_Progress_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Progress_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Progress_Status_Order_By>>;
  where?: InputMaybe<Course_Progress_Status_Bool_Exp>;
};


export type Query_RootCourse_Progress_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootDaily_Averages_Exclude_TodayArgs = {
  distinct_on?: InputMaybe<Array<Daily_Averages_Exclude_Today_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Averages_Exclude_Today_Order_By>>;
  where?: InputMaybe<Daily_Averages_Exclude_Today_Bool_Exp>;
};


export type Query_RootDaily_Averages_Exclude_Today_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Averages_Exclude_Today_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Averages_Exclude_Today_Order_By>>;
  where?: InputMaybe<Daily_Averages_Exclude_Today_Bool_Exp>;
};


export type Query_RootDaily_Averages_Include_TodayArgs = {
  distinct_on?: InputMaybe<Array<Daily_Averages_Include_Today_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Averages_Include_Today_Order_By>>;
  where?: InputMaybe<Daily_Averages_Include_Today_Bool_Exp>;
};


export type Query_RootDaily_Averages_Include_Today_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Averages_Include_Today_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Averages_Include_Today_Order_By>>;
  where?: InputMaybe<Daily_Averages_Include_Today_Bool_Exp>;
};


export type Query_RootDaily_VolumeArgs = {
  distinct_on?: InputMaybe<Array<Daily_Volume_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Volume_Order_By>>;
  where?: InputMaybe<Daily_Volume_Bool_Exp>;
};


export type Query_RootDaily_Volume_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Volume_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Volume_Order_By>>;
  where?: InputMaybe<Daily_Volume_Bool_Exp>;
};


export type Query_RootDark_Pool_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Dark_Pool_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Pool_Levels_Order_By>>;
  where?: InputMaybe<Dark_Pool_Levels_Bool_Exp>;
};


export type Query_RootDark_Pool_Levels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dark_Pool_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Pool_Levels_Order_By>>;
  where?: InputMaybe<Dark_Pool_Levels_Bool_Exp>;
};


export type Query_RootDark_Pool_Levels_MonthlyArgs = {
  distinct_on?: InputMaybe<Array<Dark_Pool_Levels_Monthly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Pool_Levels_Monthly_Order_By>>;
  where?: InputMaybe<Dark_Pool_Levels_Monthly_Bool_Exp>;
};


export type Query_RootDark_Pool_Levels_Monthly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dark_Pool_Levels_Monthly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Pool_Levels_Monthly_Order_By>>;
  where?: InputMaybe<Dark_Pool_Levels_Monthly_Bool_Exp>;
};


export type Query_RootDemo_Filtered_Trades_SpiderrockArgs = {
  distinct_on?: InputMaybe<Array<Demo_Filtered_Trades_Spiderrock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demo_Filtered_Trades_Spiderrock_Order_By>>;
  where?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Bool_Exp>;
};


export type Query_RootDemo_Filtered_Trades_Spiderrock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demo_Filtered_Trades_Spiderrock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demo_Filtered_Trades_Spiderrock_Order_By>>;
  where?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Bool_Exp>;
};


export type Query_RootDemo_Filtered_Trades_Spiderrock_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDemo_Raw_Trades_SpiderrockArgs = {
  distinct_on?: InputMaybe<Array<Demo_Raw_Trades_Spiderrock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demo_Raw_Trades_Spiderrock_Order_By>>;
  where?: InputMaybe<Demo_Raw_Trades_Spiderrock_Bool_Exp>;
};


export type Query_RootDemo_Raw_Trades_Spiderrock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demo_Raw_Trades_Spiderrock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demo_Raw_Trades_Spiderrock_Order_By>>;
  where?: InputMaybe<Demo_Raw_Trades_Spiderrock_Bool_Exp>;
};


export type Query_RootDemo_Raw_Trades_Spiderrock_By_PkArgs = {
  prtNumber: Scalars['bigint'];
};


export type Query_RootEarnings_SnpArgs = {
  distinct_on?: InputMaybe<Array<Earnings_Snp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Earnings_Snp_Order_By>>;
  where?: InputMaybe<Earnings_Snp_Bool_Exp>;
};


export type Query_RootEarnings_Snp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Earnings_Snp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Earnings_Snp_Order_By>>;
  where?: InputMaybe<Earnings_Snp_Bool_Exp>;
};


export type Query_RootEarnings_Snp_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEmail_AlertsArgs = {
  distinct_on?: InputMaybe<Array<Email_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Alerts_Order_By>>;
  where?: InputMaybe<Email_Alerts_Bool_Exp>;
};


export type Query_RootEmail_Alerts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Alerts_Order_By>>;
  where?: InputMaybe<Email_Alerts_Bool_Exp>;
};


export type Query_RootEmail_Alerts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEmail_ListArgs = {
  distinct_on?: InputMaybe<Array<Email_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_List_Order_By>>;
  where?: InputMaybe<Email_List_Bool_Exp>;
};


export type Query_RootEmail_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_List_Order_By>>;
  where?: InputMaybe<Email_List_Bool_Exp>;
};


export type Query_RootEmail_List_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEquities_EodArgs = {
  distinct_on?: InputMaybe<Array<Equities_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equities_Eod_Order_By>>;
  where?: InputMaybe<Equities_Eod_Bool_Exp>;
};


export type Query_RootEquities_Eod_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Equities_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equities_Eod_Order_By>>;
  where?: InputMaybe<Equities_Eod_Bool_Exp>;
};


export type Query_RootEquities_Eod_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEquity_Pool_PrintsArgs = {
  distinct_on?: InputMaybe<Array<Equity_Pool_Prints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Pool_Prints_Order_By>>;
  where?: InputMaybe<Equity_Pool_Prints_Bool_Exp>;
};


export type Query_RootEquity_Pool_Prints_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Equity_Pool_Prints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Pool_Prints_Order_By>>;
  where?: InputMaybe<Equity_Pool_Prints_Bool_Exp>;
};


export type Query_RootEquity_Pool_Prints_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEquity_Print_Feed_BaselineArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Feed_Baseline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Feed_Baseline_Order_By>>;
  where?: InputMaybe<Equity_Print_Feed_Baseline_Bool_Exp>;
};


export type Query_RootEquity_Print_Feed_Baseline_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Feed_Baseline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Feed_Baseline_Order_By>>;
  where?: InputMaybe<Equity_Print_Feed_Baseline_Bool_Exp>;
};


export type Query_RootEquity_Print_Feed_Baseline_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEquity_Print_Feed_FilteredArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Feed_Filtered_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Feed_Filtered_Order_By>>;
  where?: InputMaybe<Equity_Print_Feed_Filtered_Bool_Exp>;
};


export type Query_RootEquity_Print_Feed_Filtered_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Feed_Filtered_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Feed_Filtered_Order_By>>;
  where?: InputMaybe<Equity_Print_Feed_Filtered_Bool_Exp>;
};


export type Query_RootEquity_Print_Feed_Filtered_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEquity_Print_FlowArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Equity_Print_Flow_Bool_Exp>;
};


export type Query_RootEquity_Print_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Equity_Print_Flow_Bool_Exp>;
};


export type Query_RootEquity_Print_Flow_FullArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Flow_Full_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Flow_Full_Order_By>>;
  where?: InputMaybe<Equity_Print_Flow_Full_Bool_Exp>;
};


export type Query_RootEquity_Print_Flow_Full_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Flow_Full_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Flow_Full_Order_By>>;
  where?: InputMaybe<Equity_Print_Flow_Full_Bool_Exp>;
};


export type Query_RootFa_Call_Moving_AverageArgs = {
  distinct_on?: InputMaybe<Array<Fa_Call_Moving_Average_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Call_Moving_Average_Order_By>>;
  where?: InputMaybe<Fa_Call_Moving_Average_Bool_Exp>;
};


export type Query_RootFa_Call_Moving_Average_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fa_Call_Moving_Average_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Call_Moving_Average_Order_By>>;
  where?: InputMaybe<Fa_Call_Moving_Average_Bool_Exp>;
};


export type Query_RootFa_Put_Moving_AverageArgs = {
  distinct_on?: InputMaybe<Array<Fa_Put_Moving_Average_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Put_Moving_Average_Order_By>>;
  where?: InputMaybe<Fa_Put_Moving_Average_Bool_Exp>;
};


export type Query_RootFa_Put_Moving_Average_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fa_Put_Moving_Average_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Put_Moving_Average_Order_By>>;
  where?: InputMaybe<Fa_Put_Moving_Average_Bool_Exp>;
};


export type Query_RootFa_Trade_UploadsArgs = {
  distinct_on?: InputMaybe<Array<Fa_Trade_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Trade_Uploads_Order_By>>;
  where?: InputMaybe<Fa_Trade_Uploads_Bool_Exp>;
};


export type Query_RootFa_Trade_Uploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fa_Trade_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Trade_Uploads_Order_By>>;
  where?: InputMaybe<Fa_Trade_Uploads_Bool_Exp>;
};


export type Query_RootFa_Trade_Uploads_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFa_TradesArgs = {
  distinct_on?: InputMaybe<Array<Fa_Trades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Trades_Order_By>>;
  where?: InputMaybe<Fa_Trades_Bool_Exp>;
};


export type Query_RootFa_Trades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fa_Trades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Trades_Order_By>>;
  where?: InputMaybe<Fa_Trades_Bool_Exp>;
};


export type Query_RootFa_Trades_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeedback_BoardsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Boards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Boards_Order_By>>;
  where?: InputMaybe<Feedback_Boards_Bool_Exp>;
};


export type Query_RootFeedback_Boards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Boards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Boards_Order_By>>;
  where?: InputMaybe<Feedback_Boards_Bool_Exp>;
};


export type Query_RootFeedback_Boards_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeedback_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Comments_Order_By>>;
  where?: InputMaybe<Feedback_Comments_Bool_Exp>;
};


export type Query_RootFeedback_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Comments_Order_By>>;
  where?: InputMaybe<Feedback_Comments_Bool_Exp>;
};


export type Query_RootFeedback_Comments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeedback_MediaArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Media_Order_By>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};


export type Query_RootFeedback_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Media_Order_By>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};


export type Query_RootFeedback_Media_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeedback_Post_ContextsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Post_Contexts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Post_Contexts_Order_By>>;
  where?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
};


export type Query_RootFeedback_Post_Contexts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Post_Contexts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Post_Contexts_Order_By>>;
  where?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
};


export type Query_RootFeedback_Post_Contexts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeedback_Post_MergesArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Post_Merges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Post_Merges_Order_By>>;
  where?: InputMaybe<Feedback_Post_Merges_Bool_Exp>;
};


export type Query_RootFeedback_Post_Merges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Post_Merges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Post_Merges_Order_By>>;
  where?: InputMaybe<Feedback_Post_Merges_Bool_Exp>;
};


export type Query_RootFeedback_Post_Merges_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeedback_PostsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_Bool_Exp>;
};


export type Query_RootFeedback_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_Bool_Exp>;
};


export type Query_RootFeedback_Posts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeedback_Posts_With_CountsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_With_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_With_Counts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_With_Counts_Bool_Exp>;
};


export type Query_RootFeedback_Posts_With_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_With_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_With_Counts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_With_Counts_Bool_Exp>;
};


export type Query_RootFeedback_Release_PostsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Release_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Release_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
};


export type Query_RootFeedback_Release_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Release_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Release_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
};


export type Query_RootFeedback_Release_Posts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeedback_ReleasesArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Releases_Order_By>>;
  where?: InputMaybe<Feedback_Releases_Bool_Exp>;
};


export type Query_RootFeedback_Releases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Releases_Order_By>>;
  where?: InputMaybe<Feedback_Releases_Bool_Exp>;
};


export type Query_RootFeedback_Releases_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeedback_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Statuses_Order_By>>;
  where?: InputMaybe<Feedback_Statuses_Bool_Exp>;
};


export type Query_RootFeedback_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Statuses_Order_By>>;
  where?: InputMaybe<Feedback_Statuses_Bool_Exp>;
};


export type Query_RootFeedback_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeedback_VotesArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Votes_Order_By>>;
  where?: InputMaybe<Feedback_Votes_Bool_Exp>;
};


export type Query_RootFeedback_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Votes_Order_By>>;
  where?: InputMaybe<Feedback_Votes_Bool_Exp>;
};


export type Query_RootFeedback_Votes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFlow_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Flow_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Flow_Configurations_Order_By>>;
  where?: InputMaybe<Flow_Configurations_Bool_Exp>;
};


export type Query_RootFlow_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flow_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Flow_Configurations_Order_By>>;
  where?: InputMaybe<Flow_Configurations_Bool_Exp>;
};


export type Query_RootFlow_Configurations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFree_Equity_Print_FlowArgs = {
  distinct_on?: InputMaybe<Array<Free_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Free_Equity_Print_Flow_Bool_Exp>;
};


export type Query_RootFree_Equity_Print_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Free_Equity_Print_Flow_Bool_Exp>;
};


export type Query_RootFree_Option_FlowArgs = {
  distinct_on?: InputMaybe<Array<Free_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Option_Flow_Order_By>>;
  where?: InputMaybe<Free_Option_Flow_Bool_Exp>;
};


export type Query_RootFree_Option_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Option_Flow_Order_By>>;
  where?: InputMaybe<Free_Option_Flow_Bool_Exp>;
};


export type Query_RootFree_Option_Flow_All_SidesArgs = {
  distinct_on?: InputMaybe<Array<Free_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Free_Option_Flow_All_Sides_Bool_Exp>;
};


export type Query_RootFree_Option_Flow_All_Sides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Free_Option_Flow_All_Sides_Bool_Exp>;
};


export type Query_RootFree_Ticker_Equity_Print_FlowArgs = {
  distinct_on?: InputMaybe<Array<Free_Ticker_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Ticker_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Free_Ticker_Equity_Print_Flow_Bool_Exp>;
};


export type Query_RootFree_Ticker_Equity_Print_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Ticker_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Ticker_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Free_Ticker_Equity_Print_Flow_Bool_Exp>;
};


export type Query_RootFree_Ticker_Option_FlowArgs = {
  distinct_on?: InputMaybe<Array<Free_Ticker_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Ticker_Option_Flow_Order_By>>;
  where?: InputMaybe<Free_Ticker_Option_Flow_Bool_Exp>;
};


export type Query_RootFree_Ticker_Option_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Ticker_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Ticker_Option_Flow_Order_By>>;
  where?: InputMaybe<Free_Ticker_Option_Flow_Bool_Exp>;
};


export type Query_RootFree_Ticker_Option_Flow_All_SidesArgs = {
  distinct_on?: InputMaybe<Array<Free_Ticker_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Ticker_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Free_Ticker_Option_Flow_All_Sides_Bool_Exp>;
};


export type Query_RootFree_Ticker_Option_Flow_All_Sides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Ticker_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Ticker_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Free_Ticker_Option_Flow_All_Sides_Bool_Exp>;
};


export type Query_RootFull_Feed_Equity_Print_FlowArgs = {
  distinct_on?: InputMaybe<Array<Full_Feed_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Feed_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Full_Feed_Equity_Print_Flow_Bool_Exp>;
};


export type Query_RootFull_Feed_Equity_Print_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Full_Feed_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Feed_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Full_Feed_Equity_Print_Flow_Bool_Exp>;
};


export type Query_RootFull_Feed_Option_FlowArgs = {
  distinct_on?: InputMaybe<Array<Full_Feed_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Feed_Option_Flow_Order_By>>;
  where?: InputMaybe<Full_Feed_Option_Flow_Bool_Exp>;
};


export type Query_RootFull_Feed_Option_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Full_Feed_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Feed_Option_Flow_Order_By>>;
  where?: InputMaybe<Full_Feed_Option_Flow_Bool_Exp>;
};


export type Query_RootHealth_ChecksArgs = {
  distinct_on?: InputMaybe<Array<Health_Checks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Health_Checks_Order_By>>;
  where?: InputMaybe<Health_Checks_Bool_Exp>;
};


export type Query_RootHealth_Checks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Health_Checks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Health_Checks_Order_By>>;
  where?: InputMaybe<Health_Checks_Bool_Exp>;
};


export type Query_RootHealth_Checks_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootInsider_TradesArgs = {
  distinct_on?: InputMaybe<Array<Insider_Trades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Insider_Trades_Order_By>>;
  where?: InputMaybe<Insider_Trades_Bool_Exp>;
};


export type Query_RootInsider_Trades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insider_Trades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Insider_Trades_Order_By>>;
  where?: InputMaybe<Insider_Trades_Bool_Exp>;
};


export type Query_RootInsider_Trades_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootInsider_Trades_Top_LongArgs = {
  distinct_on?: InputMaybe<Array<Insider_Trades_Top_Long_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Insider_Trades_Top_Long_Order_By>>;
  where?: InputMaybe<Insider_Trades_Top_Long_Bool_Exp>;
};


export type Query_RootInsider_Trades_Top_Long_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insider_Trades_Top_Long_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Insider_Trades_Top_Long_Order_By>>;
  where?: InputMaybe<Insider_Trades_Top_Long_Bool_Exp>;
};


export type Query_RootInsider_Trades_Top_ShortArgs = {
  distinct_on?: InputMaybe<Array<Insider_Trades_Top_Short_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Insider_Trades_Top_Short_Order_By>>;
  where?: InputMaybe<Insider_Trades_Top_Short_Bool_Exp>;
};


export type Query_RootInsider_Trades_Top_Short_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insider_Trades_Top_Short_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Insider_Trades_Top_Short_Order_By>>;
  where?: InputMaybe<Insider_Trades_Top_Short_Bool_Exp>;
};


export type Query_RootInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Query_RootInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Query_RootInvoices_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMicrosoft_Access_TokensArgs = {
  distinct_on?: InputMaybe<Array<Microsoft_Access_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Microsoft_Access_Tokens_Order_By>>;
  where?: InputMaybe<Microsoft_Access_Tokens_Bool_Exp>;
};


export type Query_RootMicrosoft_Access_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Microsoft_Access_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Microsoft_Access_Tokens_Order_By>>;
  where?: InputMaybe<Microsoft_Access_Tokens_Bool_Exp>;
};


export type Query_RootMicrosoft_Access_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMost_Researched_Tickers_Daily_TotalArgs = {
  distinct_on?: InputMaybe<Array<Most_Researched_Tickers_Daily_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Most_Researched_Tickers_Daily_Total_Order_By>>;
  where?: InputMaybe<Most_Researched_Tickers_Daily_Total_Bool_Exp>;
};


export type Query_RootMost_Researched_Tickers_Daily_Total_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Most_Researched_Tickers_Daily_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Most_Researched_Tickers_Daily_Total_Order_By>>;
  where?: InputMaybe<Most_Researched_Tickers_Daily_Total_Bool_Exp>;
};


export type Query_RootMost_Researched_Tickers_Daily_UniqueArgs = {
  distinct_on?: InputMaybe<Array<Most_Researched_Tickers_Daily_Unique_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Most_Researched_Tickers_Daily_Unique_Order_By>>;
  where?: InputMaybe<Most_Researched_Tickers_Daily_Unique_Bool_Exp>;
};


export type Query_RootMost_Researched_Tickers_Daily_Unique_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Most_Researched_Tickers_Daily_Unique_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Most_Researched_Tickers_Daily_Unique_Order_By>>;
  where?: InputMaybe<Most_Researched_Tickers_Daily_Unique_Bool_Exp>;
};


export type Query_RootNews_Cache_StocksArgs = {
  distinct_on?: InputMaybe<Array<News_Cache_Stocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<News_Cache_Stocks_Order_By>>;
  where?: InputMaybe<News_Cache_Stocks_Bool_Exp>;
};


export type Query_RootNews_Cache_Stocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<News_Cache_Stocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<News_Cache_Stocks_Order_By>>;
  where?: InputMaybe<News_Cache_Stocks_Bool_Exp>;
};


export type Query_RootNews_Cache_Stocks_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootNewsletter_PayloadsArgs = {
  distinct_on?: InputMaybe<Array<Newsletter_Payloads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Newsletter_Payloads_Order_By>>;
  where?: InputMaybe<Newsletter_Payloads_Bool_Exp>;
};


export type Query_RootNewsletter_Payloads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Newsletter_Payloads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Newsletter_Payloads_Order_By>>;
  where?: InputMaybe<Newsletter_Payloads_Bool_Exp>;
};


export type Query_RootNewsletter_Payloads_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootOpc_Saved_StrategiesArgs = {
  distinct_on?: InputMaybe<Array<Opc_Saved_Strategies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opc_Saved_Strategies_Order_By>>;
  where?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
};


export type Query_RootOpc_Saved_Strategies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Opc_Saved_Strategies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opc_Saved_Strategies_Order_By>>;
  where?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
};


export type Query_RootOpc_Saved_Strategies_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOpc_Saved_Strategy_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Order_By>>;
  where?: InputMaybe<Opc_Saved_Strategy_Positions_Bool_Exp>;
};


export type Query_RootOpc_Saved_Strategy_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Order_By>>;
  where?: InputMaybe<Opc_Saved_Strategy_Positions_Bool_Exp>;
};


export type Query_RootOpc_Saved_Strategy_Positions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOption_Feed_BaselineArgs = {
  distinct_on?: InputMaybe<Array<Option_Feed_Baseline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Feed_Baseline_Order_By>>;
  where?: InputMaybe<Option_Feed_Baseline_Bool_Exp>;
};


export type Query_RootOption_Feed_Baseline_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Option_Feed_Baseline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Feed_Baseline_Order_By>>;
  where?: InputMaybe<Option_Feed_Baseline_Bool_Exp>;
};


export type Query_RootOption_Feed_Baseline_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOption_Feed_FilteredArgs = {
  distinct_on?: InputMaybe<Array<Option_Feed_Filtered_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Feed_Filtered_Order_By>>;
  where?: InputMaybe<Option_Feed_Filtered_Bool_Exp>;
};


export type Query_RootOption_Feed_Filtered_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Option_Feed_Filtered_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Feed_Filtered_Order_By>>;
  where?: InputMaybe<Option_Feed_Filtered_Bool_Exp>;
};


export type Query_RootOption_Feed_Filtered_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOption_FlowArgs = {
  distinct_on?: InputMaybe<Array<Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Flow_Order_By>>;
  where?: InputMaybe<Option_Flow_Bool_Exp>;
};


export type Query_RootOption_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Flow_Order_By>>;
  where?: InputMaybe<Option_Flow_Bool_Exp>;
};


export type Query_RootOption_Flow_All_SidesArgs = {
  distinct_on?: InputMaybe<Array<Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Option_Flow_All_Sides_Bool_Exp>;
};


export type Query_RootOption_Flow_All_Sides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Option_Flow_All_Sides_Bool_Exp>;
};


export type Query_RootOptions_EodArgs = {
  distinct_on?: InputMaybe<Array<Options_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Options_Eod_Order_By>>;
  where?: InputMaybe<Options_Eod_Bool_Exp>;
};


export type Query_RootOptions_Eod_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Options_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Options_Eod_Order_By>>;
  where?: InputMaybe<Options_Eod_Bool_Exp>;
};


export type Query_RootOptions_Eod_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPrelaunch_Email_ListArgs = {
  distinct_on?: InputMaybe<Array<Prelaunch_Email_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prelaunch_Email_List_Order_By>>;
  where?: InputMaybe<Prelaunch_Email_List_Bool_Exp>;
};


export type Query_RootPrelaunch_Email_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prelaunch_Email_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prelaunch_Email_List_Order_By>>;
  where?: InputMaybe<Prelaunch_Email_List_Bool_Exp>;
};


export type Query_RootPrelaunch_Email_List_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootReady_CheckArgs = {
  distinct_on?: InputMaybe<Array<Ready_Check_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ready_Check_Order_By>>;
  where?: InputMaybe<Ready_Check_Bool_Exp>;
};


export type Query_RootReady_Check_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ready_Check_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ready_Check_Order_By>>;
  where?: InputMaybe<Ready_Check_Bool_Exp>;
};


export type Query_RootReady_Check_By_PkArgs = {
  isReady: Scalars['Boolean'];
};


export type Query_RootRetention_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Retention_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Feedback_Order_By>>;
  where?: InputMaybe<Retention_Feedback_Bool_Exp>;
};


export type Query_RootRetention_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Feedback_Order_By>>;
  where?: InputMaybe<Retention_Feedback_Bool_Exp>;
};


export type Query_RootRetention_Feedback_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRetention_Intervention_EventsArgs = {
  distinct_on?: InputMaybe<Array<Retention_Intervention_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Intervention_Events_Order_By>>;
  where?: InputMaybe<Retention_Intervention_Events_Bool_Exp>;
};


export type Query_RootRetention_Intervention_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Intervention_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Intervention_Events_Order_By>>;
  where?: InputMaybe<Retention_Intervention_Events_Bool_Exp>;
};


export type Query_RootRetention_Intervention_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRetention_Intervention_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Retention_Intervention_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Intervention_Sessions_Order_By>>;
  where?: InputMaybe<Retention_Intervention_Sessions_Bool_Exp>;
};


export type Query_RootRetention_Intervention_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Intervention_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Intervention_Sessions_Order_By>>;
  where?: InputMaybe<Retention_Intervention_Sessions_Bool_Exp>;
};


export type Query_RootRetention_Intervention_Sessions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRetention_Notification_DeliveriesArgs = {
  distinct_on?: InputMaybe<Array<Retention_Notification_Deliveries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Notification_Deliveries_Order_By>>;
  where?: InputMaybe<Retention_Notification_Deliveries_Bool_Exp>;
};


export type Query_RootRetention_Notification_Deliveries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Notification_Deliveries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Notification_Deliveries_Order_By>>;
  where?: InputMaybe<Retention_Notification_Deliveries_Bool_Exp>;
};


export type Query_RootRetention_Notification_Deliveries_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRetention_Offer_ExposuresArgs = {
  distinct_on?: InputMaybe<Array<Retention_Offer_Exposures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Offer_Exposures_Order_By>>;
  where?: InputMaybe<Retention_Offer_Exposures_Bool_Exp>;
};


export type Query_RootRetention_Offer_Exposures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Offer_Exposures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Offer_Exposures_Order_By>>;
  where?: InputMaybe<Retention_Offer_Exposures_Bool_Exp>;
};


export type Query_RootRetention_Offer_Exposures_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSalesArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


export type Query_RootSales_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


export type Query_RootSales_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubscription_EntitlementsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Entitlements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Entitlements_Order_By>>;
  where?: InputMaybe<Subscription_Entitlements_Bool_Exp>;
};


export type Query_RootSubscription_Entitlements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Entitlements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Entitlements_Order_By>>;
  where?: InputMaybe<Subscription_Entitlements_Bool_Exp>;
};


export type Query_RootSubscription_Entitlements_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTest_Oct2023Args = {
  distinct_on?: InputMaybe<Array<Test_Oct2023_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Oct2023_Order_By>>;
  where?: InputMaybe<Test_Oct2023_Bool_Exp>;
};


export type Query_RootTest_Oct2023_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Oct2023_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Oct2023_Order_By>>;
  where?: InputMaybe<Test_Oct2023_Bool_Exp>;
};


export type Query_RootTest_Oct2023_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTicker_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Details_Order_By>>;
  where?: InputMaybe<Ticker_Details_Bool_Exp>;
};


export type Query_RootTicker_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Details_Order_By>>;
  where?: InputMaybe<Ticker_Details_Bool_Exp>;
};


export type Query_RootTicker_Details_By_PkArgs = {
  ticker: Scalars['String'];
};


export type Query_RootTicker_Equity_Print_FlowArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Ticker_Equity_Print_Flow_Bool_Exp>;
};


export type Query_RootTicker_Equity_Print_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Ticker_Equity_Print_Flow_Bool_Exp>;
};


export type Query_RootTicker_Option_FlowArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Option_Flow_Order_By>>;
  where?: InputMaybe<Ticker_Option_Flow_Bool_Exp>;
};


export type Query_RootTicker_Option_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Option_Flow_Order_By>>;
  where?: InputMaybe<Ticker_Option_Flow_Bool_Exp>;
};


export type Query_RootTicker_Option_Flow_All_SidesArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Ticker_Option_Flow_All_Sides_Bool_Exp>;
};


export type Query_RootTicker_Option_Flow_All_Sides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Ticker_Option_Flow_All_Sides_Bool_Exp>;
};


export type Query_RootTicker_Research_All_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_All_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_All_Views_Order_By>>;
  where?: InputMaybe<Ticker_Research_All_Views_Bool_Exp>;
};


export type Query_RootTicker_Research_All_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_All_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_All_Views_Order_By>>;
  where?: InputMaybe<Ticker_Research_All_Views_Bool_Exp>;
};


export type Query_RootTicker_Research_All_Views_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTicker_Research_All_Views_CountsArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_All_Views_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_All_Views_Counts_Order_By>>;
  where?: InputMaybe<Ticker_Research_All_Views_Counts_Bool_Exp>;
};


export type Query_RootTicker_Research_All_Views_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_All_Views_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_All_Views_Counts_Order_By>>;
  where?: InputMaybe<Ticker_Research_All_Views_Counts_Bool_Exp>;
};


export type Query_RootTicker_Research_Daily_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_Daily_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_Daily_Views_Order_By>>;
  where?: InputMaybe<Ticker_Research_Daily_Views_Bool_Exp>;
};


export type Query_RootTicker_Research_Daily_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_Daily_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_Daily_Views_Order_By>>;
  where?: InputMaybe<Ticker_Research_Daily_Views_Bool_Exp>;
};


export type Query_RootTicker_Research_Daily_Views_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTimezone_LocationArgs = {
  distinct_on?: InputMaybe<Array<Timezone_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Timezone_Location_Order_By>>;
  where?: InputMaybe<Timezone_Location_Bool_Exp>;
};


export type Query_RootTimezone_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Timezone_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Timezone_Location_Order_By>>;
  where?: InputMaybe<Timezone_Location_Bool_Exp>;
};


export type Query_RootTimezone_Location_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootTop_TickersArgs = {
  distinct_on?: InputMaybe<Array<Top_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Top_Tickers_Order_By>>;
  where?: InputMaybe<Top_Tickers_Bool_Exp>;
};


export type Query_RootTop_Tickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Top_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Top_Tickers_Order_By>>;
  where?: InputMaybe<Top_Tickers_Bool_Exp>;
};


export type Query_RootTop_Tickers_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUsage_PingArgs = {
  distinct_on?: InputMaybe<Array<Usage_Ping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Usage_Ping_Order_By>>;
  where?: InputMaybe<Usage_Ping_Bool_Exp>;
};


export type Query_RootUsage_Ping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Usage_Ping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Usage_Ping_Order_By>>;
  where?: InputMaybe<Usage_Ping_Bool_Exp>;
};


export type Query_RootUsage_Ping_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootWatch_ListArgs = {
  distinct_on?: InputMaybe<Array<Watch_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Watch_List_Order_By>>;
  where?: InputMaybe<Watch_List_Bool_Exp>;
};


export type Query_RootWatch_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Watch_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Watch_List_Order_By>>;
  where?: InputMaybe<Watch_List_Bool_Exp>;
};


export type Query_RootWatch_List_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWeekly_Option_FlowArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


export type Query_RootWeekly_Option_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


export type Query_RootWeekly_Option_Flow_All_SidesArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_All_Sides_Bool_Exp>;
};


export type Query_RootWeekly_Option_Flow_All_Sides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_All_Sides_Bool_Exp>;
};

/** columns and relationships of "ready_check" */
export type Ready_Check = {
  __typename?: 'ready_check';
  isReady: Scalars['Boolean'];
};

/** aggregated selection of "ready_check" */
export type Ready_Check_Aggregate = {
  __typename?: 'ready_check_aggregate';
  aggregate?: Maybe<Ready_Check_Aggregate_Fields>;
  nodes: Array<Ready_Check>;
};

/** aggregate fields of "ready_check" */
export type Ready_Check_Aggregate_Fields = {
  __typename?: 'ready_check_aggregate_fields';
  count: Scalars['Int'];
};


/** aggregate fields of "ready_check" */
export type Ready_Check_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ready_Check_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ready_check". All fields are combined with a logical 'AND'. */
export type Ready_Check_Bool_Exp = {
  _and?: InputMaybe<Array<Ready_Check_Bool_Exp>>;
  _not?: InputMaybe<Ready_Check_Bool_Exp>;
  _or?: InputMaybe<Array<Ready_Check_Bool_Exp>>;
  isReady?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "ready_check" */
export const Ready_Check_Constraint = {
  /** unique or primary key constraint on columns "isReady" */
  ReadyCheckPkey: 'ready_check_pkey'
} as const;

export type Ready_Check_Constraint = typeof Ready_Check_Constraint[keyof typeof Ready_Check_Constraint];
/** input type for inserting data into table "ready_check" */
export type Ready_Check_Insert_Input = {
  isReady?: InputMaybe<Scalars['Boolean']>;
};

/** response of any mutation on the table "ready_check" */
export type Ready_Check_Mutation_Response = {
  __typename?: 'ready_check_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ready_Check>;
};

/** on_conflict condition type for table "ready_check" */
export type Ready_Check_On_Conflict = {
  constraint: Ready_Check_Constraint;
  update_columns?: Array<Ready_Check_Update_Column>;
  where?: InputMaybe<Ready_Check_Bool_Exp>;
};

/** Ordering options when selecting data from "ready_check". */
export type Ready_Check_Order_By = {
  isReady?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ready_check */
export type Ready_Check_Pk_Columns_Input = {
  isReady: Scalars['Boolean'];
};

/** select columns of table "ready_check" */
export const Ready_Check_Select_Column = {
  /** column name */
  IsReady: 'isReady'
} as const;

export type Ready_Check_Select_Column = typeof Ready_Check_Select_Column[keyof typeof Ready_Check_Select_Column];
/** input type for updating data in table "ready_check" */
export type Ready_Check_Set_Input = {
  isReady?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "ready_check" */
export type Ready_Check_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ready_Check_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ready_Check_Stream_Cursor_Value_Input = {
  isReady?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "ready_check" */
export const Ready_Check_Update_Column = {
  /** column name */
  IsReady: 'isReady'
} as const;

export type Ready_Check_Update_Column = typeof Ready_Check_Update_Column[keyof typeof Ready_Check_Update_Column];
export type Ready_Check_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ready_Check_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ready_Check_Bool_Exp;
};

/** columns and relationships of "retention_feedback" */
export type Retention_Feedback = {
  __typename?: 'retention_feedback';
  body: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  feedbackType: Scalars['String'];
  id: Scalars['uuid'];
  retentionExpiresAt: Scalars['timestamptz'];
  /** An object relationship */
  session: Retention_Intervention_Sessions;
  sessionId: Scalars['uuid'];
};

/** aggregated selection of "retention_feedback" */
export type Retention_Feedback_Aggregate = {
  __typename?: 'retention_feedback_aggregate';
  aggregate?: Maybe<Retention_Feedback_Aggregate_Fields>;
  nodes: Array<Retention_Feedback>;
};

export type Retention_Feedback_Aggregate_Bool_Exp = {
  count?: InputMaybe<Retention_Feedback_Aggregate_Bool_Exp_Count>;
};

export type Retention_Feedback_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Retention_Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Retention_Feedback_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "retention_feedback" */
export type Retention_Feedback_Aggregate_Fields = {
  __typename?: 'retention_feedback_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Retention_Feedback_Max_Fields>;
  min?: Maybe<Retention_Feedback_Min_Fields>;
};


/** aggregate fields of "retention_feedback" */
export type Retention_Feedback_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Retention_Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "retention_feedback" */
export type Retention_Feedback_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Retention_Feedback_Max_Order_By>;
  min?: InputMaybe<Retention_Feedback_Min_Order_By>;
};

/** input type for inserting array relation for remote table "retention_feedback" */
export type Retention_Feedback_Arr_Rel_Insert_Input = {
  data: Array<Retention_Feedback_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Retention_Feedback_On_Conflict>;
};

/** Boolean expression to filter rows from the table "retention_feedback". All fields are combined with a logical 'AND'. */
export type Retention_Feedback_Bool_Exp = {
  _and?: InputMaybe<Array<Retention_Feedback_Bool_Exp>>;
  _not?: InputMaybe<Retention_Feedback_Bool_Exp>;
  _or?: InputMaybe<Array<Retention_Feedback_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  feedbackType?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  retentionExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  session?: InputMaybe<Retention_Intervention_Sessions_Bool_Exp>;
  sessionId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "retention_feedback" */
export const Retention_Feedback_Constraint = {
  /** unique or primary key constraint on columns "id" */
  RetentionFeedbackPkey: 'retention_feedback_pkey',
  /** unique or primary key constraint on columns "feedbackType", "sessionId" */
  RetentionFeedbackSessionIdFeedbackTypeKey: 'retention_feedback_sessionId_feedbackType_key'
} as const;

export type Retention_Feedback_Constraint = typeof Retention_Feedback_Constraint[keyof typeof Retention_Feedback_Constraint];
/** input type for inserting data into table "retention_feedback" */
export type Retention_Feedback_Insert_Input = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  feedbackType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  retentionExpiresAt?: InputMaybe<Scalars['timestamptz']>;
  session?: InputMaybe<Retention_Intervention_Sessions_Obj_Rel_Insert_Input>;
  sessionId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Retention_Feedback_Max_Fields = {
  __typename?: 'retention_feedback_max_fields';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  feedbackType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  retentionExpiresAt?: Maybe<Scalars['timestamptz']>;
  sessionId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "retention_feedback" */
export type Retention_Feedback_Max_Order_By = {
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  feedbackType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  retentionExpiresAt?: InputMaybe<Order_By>;
  sessionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Retention_Feedback_Min_Fields = {
  __typename?: 'retention_feedback_min_fields';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  feedbackType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  retentionExpiresAt?: Maybe<Scalars['timestamptz']>;
  sessionId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "retention_feedback" */
export type Retention_Feedback_Min_Order_By = {
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  feedbackType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  retentionExpiresAt?: InputMaybe<Order_By>;
  sessionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "retention_feedback" */
export type Retention_Feedback_Mutation_Response = {
  __typename?: 'retention_feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Retention_Feedback>;
};

/** on_conflict condition type for table "retention_feedback" */
export type Retention_Feedback_On_Conflict = {
  constraint: Retention_Feedback_Constraint;
  update_columns?: Array<Retention_Feedback_Update_Column>;
  where?: InputMaybe<Retention_Feedback_Bool_Exp>;
};

/** Ordering options when selecting data from "retention_feedback". */
export type Retention_Feedback_Order_By = {
  body?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  feedbackType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  retentionExpiresAt?: InputMaybe<Order_By>;
  session?: InputMaybe<Retention_Intervention_Sessions_Order_By>;
  sessionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: retention_feedback */
export type Retention_Feedback_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "retention_feedback" */
export const Retention_Feedback_Select_Column = {
  /** column name */
  Body: 'body',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  FeedbackType: 'feedbackType',
  /** column name */
  Id: 'id',
  /** column name */
  RetentionExpiresAt: 'retentionExpiresAt',
  /** column name */
  SessionId: 'sessionId'
} as const;

export type Retention_Feedback_Select_Column = typeof Retention_Feedback_Select_Column[keyof typeof Retention_Feedback_Select_Column];
/** input type for updating data in table "retention_feedback" */
export type Retention_Feedback_Set_Input = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  feedbackType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  retentionExpiresAt?: InputMaybe<Scalars['timestamptz']>;
  sessionId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "retention_feedback" */
export type Retention_Feedback_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Retention_Feedback_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Retention_Feedback_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  feedbackType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  retentionExpiresAt?: InputMaybe<Scalars['timestamptz']>;
  sessionId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "retention_feedback" */
export const Retention_Feedback_Update_Column = {
  /** column name */
  Body: 'body',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  FeedbackType: 'feedbackType',
  /** column name */
  Id: 'id',
  /** column name */
  RetentionExpiresAt: 'retentionExpiresAt',
  /** column name */
  SessionId: 'sessionId'
} as const;

export type Retention_Feedback_Update_Column = typeof Retention_Feedback_Update_Column[keyof typeof Retention_Feedback_Update_Column];
export type Retention_Feedback_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Retention_Feedback_Set_Input>;
  /** filter the rows which have to be updated */
  where: Retention_Feedback_Bool_Exp;
};

/** columns and relationships of "retention_intervention_events" */
export type Retention_Intervention_Events = {
  __typename?: 'retention_intervention_events';
  actor: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  eventName: Scalars['String'];
  id: Scalars['uuid'];
  idempotencyKey: Scalars['String'];
  occurredAt: Scalars['timestamptz'];
  properties: Scalars['jsonb'];
  schemaVersion: Scalars['String'];
  sequenceNumber: Scalars['Int'];
  /** An object relationship */
  session: Retention_Intervention_Sessions;
  sessionId: Scalars['uuid'];
};


/** columns and relationships of "retention_intervention_events" */
export type Retention_Intervention_EventsPropertiesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "retention_intervention_events" */
export type Retention_Intervention_Events_Aggregate = {
  __typename?: 'retention_intervention_events_aggregate';
  aggregate?: Maybe<Retention_Intervention_Events_Aggregate_Fields>;
  nodes: Array<Retention_Intervention_Events>;
};

export type Retention_Intervention_Events_Aggregate_Bool_Exp = {
  count?: InputMaybe<Retention_Intervention_Events_Aggregate_Bool_Exp_Count>;
};

export type Retention_Intervention_Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Retention_Intervention_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Retention_Intervention_Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "retention_intervention_events" */
export type Retention_Intervention_Events_Aggregate_Fields = {
  __typename?: 'retention_intervention_events_aggregate_fields';
  avg?: Maybe<Retention_Intervention_Events_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Retention_Intervention_Events_Max_Fields>;
  min?: Maybe<Retention_Intervention_Events_Min_Fields>;
  stddev?: Maybe<Retention_Intervention_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Retention_Intervention_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Retention_Intervention_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Retention_Intervention_Events_Sum_Fields>;
  var_pop?: Maybe<Retention_Intervention_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Retention_Intervention_Events_Var_Samp_Fields>;
  variance?: Maybe<Retention_Intervention_Events_Variance_Fields>;
};


/** aggregate fields of "retention_intervention_events" */
export type Retention_Intervention_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Retention_Intervention_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "retention_intervention_events" */
export type Retention_Intervention_Events_Aggregate_Order_By = {
  avg?: InputMaybe<Retention_Intervention_Events_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Retention_Intervention_Events_Max_Order_By>;
  min?: InputMaybe<Retention_Intervention_Events_Min_Order_By>;
  stddev?: InputMaybe<Retention_Intervention_Events_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Retention_Intervention_Events_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Retention_Intervention_Events_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Retention_Intervention_Events_Sum_Order_By>;
  var_pop?: InputMaybe<Retention_Intervention_Events_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Retention_Intervention_Events_Var_Samp_Order_By>;
  variance?: InputMaybe<Retention_Intervention_Events_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Retention_Intervention_Events_Append_Input = {
  properties?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "retention_intervention_events" */
export type Retention_Intervention_Events_Arr_Rel_Insert_Input = {
  data: Array<Retention_Intervention_Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Retention_Intervention_Events_On_Conflict>;
};

/** aggregate avg on columns */
export type Retention_Intervention_Events_Avg_Fields = {
  __typename?: 'retention_intervention_events_avg_fields';
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "retention_intervention_events" */
export type Retention_Intervention_Events_Avg_Order_By = {
  sequenceNumber?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "retention_intervention_events". All fields are combined with a logical 'AND'. */
export type Retention_Intervention_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Retention_Intervention_Events_Bool_Exp>>;
  _not?: InputMaybe<Retention_Intervention_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Retention_Intervention_Events_Bool_Exp>>;
  actor?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  eventName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idempotencyKey?: InputMaybe<String_Comparison_Exp>;
  occurredAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  properties?: InputMaybe<Jsonb_Comparison_Exp>;
  schemaVersion?: InputMaybe<String_Comparison_Exp>;
  sequenceNumber?: InputMaybe<Int_Comparison_Exp>;
  session?: InputMaybe<Retention_Intervention_Sessions_Bool_Exp>;
  sessionId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "retention_intervention_events" */
export const Retention_Intervention_Events_Constraint = {
  /** unique or primary key constraint on columns "id" */
  RetentionInterventionEventsPkey: 'retention_intervention_events_pkey',
  /** unique or primary key constraint on columns "idempotencyKey", "sessionId" */
  RetentionInterventionEventsSessionIdIdempotencyKeyKey: 'retention_intervention_events_sessionId_idempotencyKey_key',
  /** unique or primary key constraint on columns "sequenceNumber", "sessionId" */
  RetentionInterventionEventsSessionIdSequenceNumberKey: 'retention_intervention_events_sessionId_sequenceNumber_key'
} as const;

export type Retention_Intervention_Events_Constraint = typeof Retention_Intervention_Events_Constraint[keyof typeof Retention_Intervention_Events_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Retention_Intervention_Events_Delete_At_Path_Input = {
  properties?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Retention_Intervention_Events_Delete_Elem_Input = {
  properties?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Retention_Intervention_Events_Delete_Key_Input = {
  properties?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "retention_intervention_events" */
export type Retention_Intervention_Events_Inc_Input = {
  sequenceNumber?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "retention_intervention_events" */
export type Retention_Intervention_Events_Insert_Input = {
  actor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  properties?: InputMaybe<Scalars['jsonb']>;
  schemaVersion?: InputMaybe<Scalars['String']>;
  sequenceNumber?: InputMaybe<Scalars['Int']>;
  session?: InputMaybe<Retention_Intervention_Sessions_Obj_Rel_Insert_Input>;
  sessionId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Retention_Intervention_Events_Max_Fields = {
  __typename?: 'retention_intervention_events_max_fields';
  actor?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  eventName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  idempotencyKey?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  schemaVersion?: Maybe<Scalars['String']>;
  sequenceNumber?: Maybe<Scalars['Int']>;
  sessionId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "retention_intervention_events" */
export type Retention_Intervention_Events_Max_Order_By = {
  actor?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  eventName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotencyKey?: InputMaybe<Order_By>;
  occurredAt?: InputMaybe<Order_By>;
  schemaVersion?: InputMaybe<Order_By>;
  sequenceNumber?: InputMaybe<Order_By>;
  sessionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Retention_Intervention_Events_Min_Fields = {
  __typename?: 'retention_intervention_events_min_fields';
  actor?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  eventName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  idempotencyKey?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  schemaVersion?: Maybe<Scalars['String']>;
  sequenceNumber?: Maybe<Scalars['Int']>;
  sessionId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "retention_intervention_events" */
export type Retention_Intervention_Events_Min_Order_By = {
  actor?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  eventName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotencyKey?: InputMaybe<Order_By>;
  occurredAt?: InputMaybe<Order_By>;
  schemaVersion?: InputMaybe<Order_By>;
  sequenceNumber?: InputMaybe<Order_By>;
  sessionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "retention_intervention_events" */
export type Retention_Intervention_Events_Mutation_Response = {
  __typename?: 'retention_intervention_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Retention_Intervention_Events>;
};

/** on_conflict condition type for table "retention_intervention_events" */
export type Retention_Intervention_Events_On_Conflict = {
  constraint: Retention_Intervention_Events_Constraint;
  update_columns?: Array<Retention_Intervention_Events_Update_Column>;
  where?: InputMaybe<Retention_Intervention_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "retention_intervention_events". */
export type Retention_Intervention_Events_Order_By = {
  actor?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  eventName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotencyKey?: InputMaybe<Order_By>;
  occurredAt?: InputMaybe<Order_By>;
  properties?: InputMaybe<Order_By>;
  schemaVersion?: InputMaybe<Order_By>;
  sequenceNumber?: InputMaybe<Order_By>;
  session?: InputMaybe<Retention_Intervention_Sessions_Order_By>;
  sessionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: retention_intervention_events */
export type Retention_Intervention_Events_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Retention_Intervention_Events_Prepend_Input = {
  properties?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "retention_intervention_events" */
export const Retention_Intervention_Events_Select_Column = {
  /** column name */
  Actor: 'actor',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EventName: 'eventName',
  /** column name */
  Id: 'id',
  /** column name */
  IdempotencyKey: 'idempotencyKey',
  /** column name */
  OccurredAt: 'occurredAt',
  /** column name */
  Properties: 'properties',
  /** column name */
  SchemaVersion: 'schemaVersion',
  /** column name */
  SequenceNumber: 'sequenceNumber',
  /** column name */
  SessionId: 'sessionId'
} as const;

export type Retention_Intervention_Events_Select_Column = typeof Retention_Intervention_Events_Select_Column[keyof typeof Retention_Intervention_Events_Select_Column];
/** input type for updating data in table "retention_intervention_events" */
export type Retention_Intervention_Events_Set_Input = {
  actor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  properties?: InputMaybe<Scalars['jsonb']>;
  schemaVersion?: InputMaybe<Scalars['String']>;
  sequenceNumber?: InputMaybe<Scalars['Int']>;
  sessionId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Retention_Intervention_Events_Stddev_Fields = {
  __typename?: 'retention_intervention_events_stddev_fields';
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "retention_intervention_events" */
export type Retention_Intervention_Events_Stddev_Order_By = {
  sequenceNumber?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Retention_Intervention_Events_Stddev_Pop_Fields = {
  __typename?: 'retention_intervention_events_stddev_pop_fields';
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "retention_intervention_events" */
export type Retention_Intervention_Events_Stddev_Pop_Order_By = {
  sequenceNumber?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Retention_Intervention_Events_Stddev_Samp_Fields = {
  __typename?: 'retention_intervention_events_stddev_samp_fields';
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "retention_intervention_events" */
export type Retention_Intervention_Events_Stddev_Samp_Order_By = {
  sequenceNumber?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "retention_intervention_events" */
export type Retention_Intervention_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Retention_Intervention_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Retention_Intervention_Events_Stream_Cursor_Value_Input = {
  actor?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  properties?: InputMaybe<Scalars['jsonb']>;
  schemaVersion?: InputMaybe<Scalars['String']>;
  sequenceNumber?: InputMaybe<Scalars['Int']>;
  sessionId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Retention_Intervention_Events_Sum_Fields = {
  __typename?: 'retention_intervention_events_sum_fields';
  sequenceNumber?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "retention_intervention_events" */
export type Retention_Intervention_Events_Sum_Order_By = {
  sequenceNumber?: InputMaybe<Order_By>;
};

/** update columns of table "retention_intervention_events" */
export const Retention_Intervention_Events_Update_Column = {
  /** column name */
  Actor: 'actor',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EventName: 'eventName',
  /** column name */
  Id: 'id',
  /** column name */
  IdempotencyKey: 'idempotencyKey',
  /** column name */
  OccurredAt: 'occurredAt',
  /** column name */
  Properties: 'properties',
  /** column name */
  SchemaVersion: 'schemaVersion',
  /** column name */
  SequenceNumber: 'sequenceNumber',
  /** column name */
  SessionId: 'sessionId'
} as const;

export type Retention_Intervention_Events_Update_Column = typeof Retention_Intervention_Events_Update_Column[keyof typeof Retention_Intervention_Events_Update_Column];
export type Retention_Intervention_Events_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Retention_Intervention_Events_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Retention_Intervention_Events_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Retention_Intervention_Events_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Retention_Intervention_Events_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Retention_Intervention_Events_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Retention_Intervention_Events_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Retention_Intervention_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Retention_Intervention_Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Retention_Intervention_Events_Var_Pop_Fields = {
  __typename?: 'retention_intervention_events_var_pop_fields';
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "retention_intervention_events" */
export type Retention_Intervention_Events_Var_Pop_Order_By = {
  sequenceNumber?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Retention_Intervention_Events_Var_Samp_Fields = {
  __typename?: 'retention_intervention_events_var_samp_fields';
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "retention_intervention_events" */
export type Retention_Intervention_Events_Var_Samp_Order_By = {
  sequenceNumber?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Retention_Intervention_Events_Variance_Fields = {
  __typename?: 'retention_intervention_events_variance_fields';
  sequenceNumber?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "retention_intervention_events" */
export type Retention_Intervention_Events_Variance_Order_By = {
  sequenceNumber?: InputMaybe<Order_By>;
};

/** columns and relationships of "retention_intervention_sessions" */
export type Retention_Intervention_Sessions = {
  __typename?: 'retention_intervention_sessions';
  billingEffectiveAt?: Maybe<Scalars['timestamptz']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  contextSnapshot: Scalars['jsonb'];
  createdAt: Scalars['timestamptz'];
  engine: Scalars['String'];
  /** An array relationship */
  events: Array<Retention_Intervention_Events>;
  /** An aggregate relationship */
  events_aggregate: Retention_Intervention_Events_Aggregate;
  /** An array relationship */
  exposures: Array<Retention_Offer_Exposures>;
  /** An aggregate relationship */
  exposures_aggregate: Retention_Offer_Exposures_Aggregate;
  /** An array relationship */
  feedback: Array<Retention_Feedback>;
  /** An aggregate relationship */
  feedback_aggregate: Retention_Feedback_Aggregate;
  finalOutcome?: Maybe<Scalars['String']>;
  followUpCode?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  lastActivityAt: Scalars['timestamptz'];
  policyVersion: Scalars['String'];
  productType: Scalars['String'];
  reasonCode?: Maybe<Scalars['String']>;
  sourceSurface: Scalars['String'];
  startedAt: Scalars['timestamptz'];
  state: Scalars['String'];
  /** An object relationship */
  subscription: Subscriptions;
  subscriptionId: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};


/** columns and relationships of "retention_intervention_sessions" */
export type Retention_Intervention_SessionsContextSnapshotArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "retention_intervention_sessions" */
export type Retention_Intervention_SessionsEventsArgs = {
  distinct_on?: InputMaybe<Array<Retention_Intervention_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Intervention_Events_Order_By>>;
  where?: InputMaybe<Retention_Intervention_Events_Bool_Exp>;
};


/** columns and relationships of "retention_intervention_sessions" */
export type Retention_Intervention_SessionsEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Intervention_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Intervention_Events_Order_By>>;
  where?: InputMaybe<Retention_Intervention_Events_Bool_Exp>;
};


/** columns and relationships of "retention_intervention_sessions" */
export type Retention_Intervention_SessionsExposuresArgs = {
  distinct_on?: InputMaybe<Array<Retention_Offer_Exposures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Offer_Exposures_Order_By>>;
  where?: InputMaybe<Retention_Offer_Exposures_Bool_Exp>;
};


/** columns and relationships of "retention_intervention_sessions" */
export type Retention_Intervention_SessionsExposures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Offer_Exposures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Offer_Exposures_Order_By>>;
  where?: InputMaybe<Retention_Offer_Exposures_Bool_Exp>;
};


/** columns and relationships of "retention_intervention_sessions" */
export type Retention_Intervention_SessionsFeedbackArgs = {
  distinct_on?: InputMaybe<Array<Retention_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Feedback_Order_By>>;
  where?: InputMaybe<Retention_Feedback_Bool_Exp>;
};


/** columns and relationships of "retention_intervention_sessions" */
export type Retention_Intervention_SessionsFeedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Feedback_Order_By>>;
  where?: InputMaybe<Retention_Feedback_Bool_Exp>;
};

/** aggregated selection of "retention_intervention_sessions" */
export type Retention_Intervention_Sessions_Aggregate = {
  __typename?: 'retention_intervention_sessions_aggregate';
  aggregate?: Maybe<Retention_Intervention_Sessions_Aggregate_Fields>;
  nodes: Array<Retention_Intervention_Sessions>;
};

/** aggregate fields of "retention_intervention_sessions" */
export type Retention_Intervention_Sessions_Aggregate_Fields = {
  __typename?: 'retention_intervention_sessions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Retention_Intervention_Sessions_Max_Fields>;
  min?: Maybe<Retention_Intervention_Sessions_Min_Fields>;
};


/** aggregate fields of "retention_intervention_sessions" */
export type Retention_Intervention_Sessions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Retention_Intervention_Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Retention_Intervention_Sessions_Append_Input = {
  contextSnapshot?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "retention_intervention_sessions". All fields are combined with a logical 'AND'. */
export type Retention_Intervention_Sessions_Bool_Exp = {
  _and?: InputMaybe<Array<Retention_Intervention_Sessions_Bool_Exp>>;
  _not?: InputMaybe<Retention_Intervention_Sessions_Bool_Exp>;
  _or?: InputMaybe<Array<Retention_Intervention_Sessions_Bool_Exp>>;
  billingEffectiveAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  completedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  contextSnapshot?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  engine?: InputMaybe<String_Comparison_Exp>;
  events?: InputMaybe<Retention_Intervention_Events_Bool_Exp>;
  events_aggregate?: InputMaybe<Retention_Intervention_Events_Aggregate_Bool_Exp>;
  exposures?: InputMaybe<Retention_Offer_Exposures_Bool_Exp>;
  exposures_aggregate?: InputMaybe<Retention_Offer_Exposures_Aggregate_Bool_Exp>;
  feedback?: InputMaybe<Retention_Feedback_Bool_Exp>;
  feedback_aggregate?: InputMaybe<Retention_Feedback_Aggregate_Bool_Exp>;
  finalOutcome?: InputMaybe<String_Comparison_Exp>;
  followUpCode?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastActivityAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  policyVersion?: InputMaybe<String_Comparison_Exp>;
  productType?: InputMaybe<String_Comparison_Exp>;
  reasonCode?: InputMaybe<String_Comparison_Exp>;
  sourceSurface?: InputMaybe<String_Comparison_Exp>;
  startedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptionId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "retention_intervention_sessions" */
export const Retention_Intervention_Sessions_Constraint = {
  /** unique or primary key constraint on columns "id" */
  RetentionInterventionSessionsPkey: 'retention_intervention_sessions_pkey',
  /** unique or primary key constraint on columns "subscriptionId" */
  RetentionSessionsOneOpenCancellationPerSubscription: 'retention_sessions_one_open_cancellation_per_subscription'
} as const;

export type Retention_Intervention_Sessions_Constraint = typeof Retention_Intervention_Sessions_Constraint[keyof typeof Retention_Intervention_Sessions_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Retention_Intervention_Sessions_Delete_At_Path_Input = {
  contextSnapshot?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Retention_Intervention_Sessions_Delete_Elem_Input = {
  contextSnapshot?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Retention_Intervention_Sessions_Delete_Key_Input = {
  contextSnapshot?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "retention_intervention_sessions" */
export type Retention_Intervention_Sessions_Insert_Input = {
  billingEffectiveAt?: InputMaybe<Scalars['timestamptz']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  contextSnapshot?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  engine?: InputMaybe<Scalars['String']>;
  events?: InputMaybe<Retention_Intervention_Events_Arr_Rel_Insert_Input>;
  exposures?: InputMaybe<Retention_Offer_Exposures_Arr_Rel_Insert_Input>;
  feedback?: InputMaybe<Retention_Feedback_Arr_Rel_Insert_Input>;
  finalOutcome?: InputMaybe<Scalars['String']>;
  followUpCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastActivityAt?: InputMaybe<Scalars['timestamptz']>;
  policyVersion?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  reasonCode?: InputMaybe<Scalars['String']>;
  sourceSurface?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  state?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Subscriptions_Obj_Rel_Insert_Input>;
  subscriptionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Retention_Intervention_Sessions_Max_Fields = {
  __typename?: 'retention_intervention_sessions_max_fields';
  billingEffectiveAt?: Maybe<Scalars['timestamptz']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  engine?: Maybe<Scalars['String']>;
  finalOutcome?: Maybe<Scalars['String']>;
  followUpCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastActivityAt?: Maybe<Scalars['timestamptz']>;
  policyVersion?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  sourceSurface?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Retention_Intervention_Sessions_Min_Fields = {
  __typename?: 'retention_intervention_sessions_min_fields';
  billingEffectiveAt?: Maybe<Scalars['timestamptz']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  engine?: Maybe<Scalars['String']>;
  finalOutcome?: Maybe<Scalars['String']>;
  followUpCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastActivityAt?: Maybe<Scalars['timestamptz']>;
  policyVersion?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  sourceSurface?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "retention_intervention_sessions" */
export type Retention_Intervention_Sessions_Mutation_Response = {
  __typename?: 'retention_intervention_sessions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Retention_Intervention_Sessions>;
};

/** input type for inserting object relation for remote table "retention_intervention_sessions" */
export type Retention_Intervention_Sessions_Obj_Rel_Insert_Input = {
  data: Retention_Intervention_Sessions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Retention_Intervention_Sessions_On_Conflict>;
};

/** on_conflict condition type for table "retention_intervention_sessions" */
export type Retention_Intervention_Sessions_On_Conflict = {
  constraint: Retention_Intervention_Sessions_Constraint;
  update_columns?: Array<Retention_Intervention_Sessions_Update_Column>;
  where?: InputMaybe<Retention_Intervention_Sessions_Bool_Exp>;
};

/** Ordering options when selecting data from "retention_intervention_sessions". */
export type Retention_Intervention_Sessions_Order_By = {
  billingEffectiveAt?: InputMaybe<Order_By>;
  completedAt?: InputMaybe<Order_By>;
  contextSnapshot?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  engine?: InputMaybe<Order_By>;
  events_aggregate?: InputMaybe<Retention_Intervention_Events_Aggregate_Order_By>;
  exposures_aggregate?: InputMaybe<Retention_Offer_Exposures_Aggregate_Order_By>;
  feedback_aggregate?: InputMaybe<Retention_Feedback_Aggregate_Order_By>;
  finalOutcome?: InputMaybe<Order_By>;
  followUpCode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastActivityAt?: InputMaybe<Order_By>;
  policyVersion?: InputMaybe<Order_By>;
  productType?: InputMaybe<Order_By>;
  reasonCode?: InputMaybe<Order_By>;
  sourceSurface?: InputMaybe<Order_By>;
  startedAt?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscriptionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: retention_intervention_sessions */
export type Retention_Intervention_Sessions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Retention_Intervention_Sessions_Prepend_Input = {
  contextSnapshot?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "retention_intervention_sessions" */
export const Retention_Intervention_Sessions_Select_Column = {
  /** column name */
  BillingEffectiveAt: 'billingEffectiveAt',
  /** column name */
  CompletedAt: 'completedAt',
  /** column name */
  ContextSnapshot: 'contextSnapshot',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Engine: 'engine',
  /** column name */
  FinalOutcome: 'finalOutcome',
  /** column name */
  FollowUpCode: 'followUpCode',
  /** column name */
  Id: 'id',
  /** column name */
  LastActivityAt: 'lastActivityAt',
  /** column name */
  PolicyVersion: 'policyVersion',
  /** column name */
  ProductType: 'productType',
  /** column name */
  ReasonCode: 'reasonCode',
  /** column name */
  SourceSurface: 'sourceSurface',
  /** column name */
  StartedAt: 'startedAt',
  /** column name */
  State: 'state',
  /** column name */
  SubscriptionId: 'subscriptionId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Retention_Intervention_Sessions_Select_Column = typeof Retention_Intervention_Sessions_Select_Column[keyof typeof Retention_Intervention_Sessions_Select_Column];
/** input type for updating data in table "retention_intervention_sessions" */
export type Retention_Intervention_Sessions_Set_Input = {
  billingEffectiveAt?: InputMaybe<Scalars['timestamptz']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  contextSnapshot?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  engine?: InputMaybe<Scalars['String']>;
  finalOutcome?: InputMaybe<Scalars['String']>;
  followUpCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastActivityAt?: InputMaybe<Scalars['timestamptz']>;
  policyVersion?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  reasonCode?: InputMaybe<Scalars['String']>;
  sourceSurface?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  state?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "retention_intervention_sessions" */
export type Retention_Intervention_Sessions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Retention_Intervention_Sessions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Retention_Intervention_Sessions_Stream_Cursor_Value_Input = {
  billingEffectiveAt?: InputMaybe<Scalars['timestamptz']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  contextSnapshot?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  engine?: InputMaybe<Scalars['String']>;
  finalOutcome?: InputMaybe<Scalars['String']>;
  followUpCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastActivityAt?: InputMaybe<Scalars['timestamptz']>;
  policyVersion?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  reasonCode?: InputMaybe<Scalars['String']>;
  sourceSurface?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  state?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "retention_intervention_sessions" */
export const Retention_Intervention_Sessions_Update_Column = {
  /** column name */
  BillingEffectiveAt: 'billingEffectiveAt',
  /** column name */
  CompletedAt: 'completedAt',
  /** column name */
  ContextSnapshot: 'contextSnapshot',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Engine: 'engine',
  /** column name */
  FinalOutcome: 'finalOutcome',
  /** column name */
  FollowUpCode: 'followUpCode',
  /** column name */
  Id: 'id',
  /** column name */
  LastActivityAt: 'lastActivityAt',
  /** column name */
  PolicyVersion: 'policyVersion',
  /** column name */
  ProductType: 'productType',
  /** column name */
  ReasonCode: 'reasonCode',
  /** column name */
  SourceSurface: 'sourceSurface',
  /** column name */
  StartedAt: 'startedAt',
  /** column name */
  State: 'state',
  /** column name */
  SubscriptionId: 'subscriptionId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Retention_Intervention_Sessions_Update_Column = typeof Retention_Intervention_Sessions_Update_Column[keyof typeof Retention_Intervention_Sessions_Update_Column];
export type Retention_Intervention_Sessions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Retention_Intervention_Sessions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Retention_Intervention_Sessions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Retention_Intervention_Sessions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Retention_Intervention_Sessions_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Retention_Intervention_Sessions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Retention_Intervention_Sessions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Retention_Intervention_Sessions_Bool_Exp;
};

/** columns and relationships of "retention_notification_deliveries" */
export type Retention_Notification_Deliveries = {
  __typename?: 'retention_notification_deliveries';
  channel: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  lastErrorClass?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  session: Retention_Intervention_Sessions;
  sessionId: Scalars['uuid'];
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "retention_notification_deliveries" */
export type Retention_Notification_Deliveries_Aggregate = {
  __typename?: 'retention_notification_deliveries_aggregate';
  aggregate?: Maybe<Retention_Notification_Deliveries_Aggregate_Fields>;
  nodes: Array<Retention_Notification_Deliveries>;
};

/** aggregate fields of "retention_notification_deliveries" */
export type Retention_Notification_Deliveries_Aggregate_Fields = {
  __typename?: 'retention_notification_deliveries_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Retention_Notification_Deliveries_Max_Fields>;
  min?: Maybe<Retention_Notification_Deliveries_Min_Fields>;
};


/** aggregate fields of "retention_notification_deliveries" */
export type Retention_Notification_Deliveries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Retention_Notification_Deliveries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "retention_notification_deliveries". All fields are combined with a logical 'AND'. */
export type Retention_Notification_Deliveries_Bool_Exp = {
  _and?: InputMaybe<Array<Retention_Notification_Deliveries_Bool_Exp>>;
  _not?: InputMaybe<Retention_Notification_Deliveries_Bool_Exp>;
  _or?: InputMaybe<Array<Retention_Notification_Deliveries_Bool_Exp>>;
  channel?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastErrorClass?: InputMaybe<String_Comparison_Exp>;
  sentAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  session?: InputMaybe<Retention_Intervention_Sessions_Bool_Exp>;
  sessionId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "retention_notification_deliveries" */
export const Retention_Notification_Deliveries_Constraint = {
  /** unique or primary key constraint on columns "id" */
  RetentionNotificationDeliveriesPkey: 'retention_notification_deliveries_pkey',
  /** unique or primary key constraint on columns "channel", "sessionId" */
  RetentionNotificationDeliveriesSessionIdChannelKey: 'retention_notification_deliveries_sessionId_channel_key'
} as const;

export type Retention_Notification_Deliveries_Constraint = typeof Retention_Notification_Deliveries_Constraint[keyof typeof Retention_Notification_Deliveries_Constraint];
/** input type for inserting data into table "retention_notification_deliveries" */
export type Retention_Notification_Deliveries_Insert_Input = {
  channel?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastErrorClass?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['timestamptz']>;
  session?: InputMaybe<Retention_Intervention_Sessions_Obj_Rel_Insert_Input>;
  sessionId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Retention_Notification_Deliveries_Max_Fields = {
  __typename?: 'retention_notification_deliveries_max_fields';
  channel?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lastErrorClass?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['timestamptz']>;
  sessionId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Retention_Notification_Deliveries_Min_Fields = {
  __typename?: 'retention_notification_deliveries_min_fields';
  channel?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lastErrorClass?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['timestamptz']>;
  sessionId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "retention_notification_deliveries" */
export type Retention_Notification_Deliveries_Mutation_Response = {
  __typename?: 'retention_notification_deliveries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Retention_Notification_Deliveries>;
};

/** on_conflict condition type for table "retention_notification_deliveries" */
export type Retention_Notification_Deliveries_On_Conflict = {
  constraint: Retention_Notification_Deliveries_Constraint;
  update_columns?: Array<Retention_Notification_Deliveries_Update_Column>;
  where?: InputMaybe<Retention_Notification_Deliveries_Bool_Exp>;
};

/** Ordering options when selecting data from "retention_notification_deliveries". */
export type Retention_Notification_Deliveries_Order_By = {
  channel?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastErrorClass?: InputMaybe<Order_By>;
  sentAt?: InputMaybe<Order_By>;
  session?: InputMaybe<Retention_Intervention_Sessions_Order_By>;
  sessionId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: retention_notification_deliveries */
export type Retention_Notification_Deliveries_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "retention_notification_deliveries" */
export const Retention_Notification_Deliveries_Select_Column = {
  /** column name */
  Channel: 'channel',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  LastErrorClass: 'lastErrorClass',
  /** column name */
  SentAt: 'sentAt',
  /** column name */
  SessionId: 'sessionId',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Retention_Notification_Deliveries_Select_Column = typeof Retention_Notification_Deliveries_Select_Column[keyof typeof Retention_Notification_Deliveries_Select_Column];
/** input type for updating data in table "retention_notification_deliveries" */
export type Retention_Notification_Deliveries_Set_Input = {
  channel?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastErrorClass?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['timestamptz']>;
  sessionId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "retention_notification_deliveries" */
export type Retention_Notification_Deliveries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Retention_Notification_Deliveries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Retention_Notification_Deliveries_Stream_Cursor_Value_Input = {
  channel?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastErrorClass?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['timestamptz']>;
  sessionId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "retention_notification_deliveries" */
export const Retention_Notification_Deliveries_Update_Column = {
  /** column name */
  Channel: 'channel',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  LastErrorClass: 'lastErrorClass',
  /** column name */
  SentAt: 'sentAt',
  /** column name */
  SessionId: 'sessionId',
  /** column name */
  Status: 'status',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Retention_Notification_Deliveries_Update_Column = typeof Retention_Notification_Deliveries_Update_Column[keyof typeof Retention_Notification_Deliveries_Update_Column];
export type Retention_Notification_Deliveries_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Retention_Notification_Deliveries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Retention_Notification_Deliveries_Bool_Exp;
};

/** columns and relationships of "retention_offer_exposures" */
export type Retention_Offer_Exposures = {
  __typename?: 'retention_offer_exposures';
  acceptedAt?: Maybe<Scalars['timestamptz']>;
  clickedAt?: Maybe<Scalars['timestamptz']>;
  concessionType?: Maybe<Scalars['String']>;
  concessionValue?: Maybe<Scalars['numeric']>;
  createdAt: Scalars['timestamptz'];
  currency?: Maybe<Scalars['String']>;
  declinedAt?: Maybe<Scalars['timestamptz']>;
  eligibilityResult: Scalars['String'];
  exposedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  interventionType: Scalars['String'];
  offerId: Scalars['String'];
  offerVersion: Scalars['String'];
  policyVersion: Scalars['String'];
  providerAppliedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  session: Retention_Intervention_Sessions;
  sessionId: Scalars['uuid'];
  suppressionReason?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "retention_offer_exposures" */
export type Retention_Offer_Exposures_Aggregate = {
  __typename?: 'retention_offer_exposures_aggregate';
  aggregate?: Maybe<Retention_Offer_Exposures_Aggregate_Fields>;
  nodes: Array<Retention_Offer_Exposures>;
};

export type Retention_Offer_Exposures_Aggregate_Bool_Exp = {
  count?: InputMaybe<Retention_Offer_Exposures_Aggregate_Bool_Exp_Count>;
};

export type Retention_Offer_Exposures_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Retention_Offer_Exposures_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Retention_Offer_Exposures_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "retention_offer_exposures" */
export type Retention_Offer_Exposures_Aggregate_Fields = {
  __typename?: 'retention_offer_exposures_aggregate_fields';
  avg?: Maybe<Retention_Offer_Exposures_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Retention_Offer_Exposures_Max_Fields>;
  min?: Maybe<Retention_Offer_Exposures_Min_Fields>;
  stddev?: Maybe<Retention_Offer_Exposures_Stddev_Fields>;
  stddev_pop?: Maybe<Retention_Offer_Exposures_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Retention_Offer_Exposures_Stddev_Samp_Fields>;
  sum?: Maybe<Retention_Offer_Exposures_Sum_Fields>;
  var_pop?: Maybe<Retention_Offer_Exposures_Var_Pop_Fields>;
  var_samp?: Maybe<Retention_Offer_Exposures_Var_Samp_Fields>;
  variance?: Maybe<Retention_Offer_Exposures_Variance_Fields>;
};


/** aggregate fields of "retention_offer_exposures" */
export type Retention_Offer_Exposures_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Retention_Offer_Exposures_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Aggregate_Order_By = {
  avg?: InputMaybe<Retention_Offer_Exposures_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Retention_Offer_Exposures_Max_Order_By>;
  min?: InputMaybe<Retention_Offer_Exposures_Min_Order_By>;
  stddev?: InputMaybe<Retention_Offer_Exposures_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Retention_Offer_Exposures_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Retention_Offer_Exposures_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Retention_Offer_Exposures_Sum_Order_By>;
  var_pop?: InputMaybe<Retention_Offer_Exposures_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Retention_Offer_Exposures_Var_Samp_Order_By>;
  variance?: InputMaybe<Retention_Offer_Exposures_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Arr_Rel_Insert_Input = {
  data: Array<Retention_Offer_Exposures_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Retention_Offer_Exposures_On_Conflict>;
};

/** aggregate avg on columns */
export type Retention_Offer_Exposures_Avg_Fields = {
  __typename?: 'retention_offer_exposures_avg_fields';
  concessionValue?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Avg_Order_By = {
  concessionValue?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "retention_offer_exposures". All fields are combined with a logical 'AND'. */
export type Retention_Offer_Exposures_Bool_Exp = {
  _and?: InputMaybe<Array<Retention_Offer_Exposures_Bool_Exp>>;
  _not?: InputMaybe<Retention_Offer_Exposures_Bool_Exp>;
  _or?: InputMaybe<Array<Retention_Offer_Exposures_Bool_Exp>>;
  acceptedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  clickedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  concessionType?: InputMaybe<String_Comparison_Exp>;
  concessionValue?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  declinedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  eligibilityResult?: InputMaybe<String_Comparison_Exp>;
  exposedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interventionType?: InputMaybe<String_Comparison_Exp>;
  offerId?: InputMaybe<String_Comparison_Exp>;
  offerVersion?: InputMaybe<String_Comparison_Exp>;
  policyVersion?: InputMaybe<String_Comparison_Exp>;
  providerAppliedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  session?: InputMaybe<Retention_Intervention_Sessions_Bool_Exp>;
  sessionId?: InputMaybe<Uuid_Comparison_Exp>;
  suppressionReason?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "retention_offer_exposures" */
export const Retention_Offer_Exposures_Constraint = {
  /** unique or primary key constraint on columns "sessionId" */
  RetentionExposuresOneAcceptedPerSession: 'retention_exposures_one_accepted_per_session',
  /** unique or primary key constraint on columns "id" */
  RetentionOfferExposuresPkey: 'retention_offer_exposures_pkey',
  /** unique or primary key constraint on columns "offerId", "sessionId" */
  RetentionOfferExposuresSessionIdOfferIdKey: 'retention_offer_exposures_sessionId_offerId_key'
} as const;

export type Retention_Offer_Exposures_Constraint = typeof Retention_Offer_Exposures_Constraint[keyof typeof Retention_Offer_Exposures_Constraint];
/** input type for incrementing numeric columns in table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Inc_Input = {
  concessionValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Insert_Input = {
  acceptedAt?: InputMaybe<Scalars['timestamptz']>;
  clickedAt?: InputMaybe<Scalars['timestamptz']>;
  concessionType?: InputMaybe<Scalars['String']>;
  concessionValue?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  declinedAt?: InputMaybe<Scalars['timestamptz']>;
  eligibilityResult?: InputMaybe<Scalars['String']>;
  exposedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  interventionType?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerVersion?: InputMaybe<Scalars['String']>;
  policyVersion?: InputMaybe<Scalars['String']>;
  providerAppliedAt?: InputMaybe<Scalars['timestamptz']>;
  session?: InputMaybe<Retention_Intervention_Sessions_Obj_Rel_Insert_Input>;
  sessionId?: InputMaybe<Scalars['uuid']>;
  suppressionReason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Retention_Offer_Exposures_Max_Fields = {
  __typename?: 'retention_offer_exposures_max_fields';
  acceptedAt?: Maybe<Scalars['timestamptz']>;
  clickedAt?: Maybe<Scalars['timestamptz']>;
  concessionType?: Maybe<Scalars['String']>;
  concessionValue?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  declinedAt?: Maybe<Scalars['timestamptz']>;
  eligibilityResult?: Maybe<Scalars['String']>;
  exposedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  interventionType?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['String']>;
  offerVersion?: Maybe<Scalars['String']>;
  policyVersion?: Maybe<Scalars['String']>;
  providerAppliedAt?: Maybe<Scalars['timestamptz']>;
  sessionId?: Maybe<Scalars['uuid']>;
  suppressionReason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Max_Order_By = {
  acceptedAt?: InputMaybe<Order_By>;
  clickedAt?: InputMaybe<Order_By>;
  concessionType?: InputMaybe<Order_By>;
  concessionValue?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  declinedAt?: InputMaybe<Order_By>;
  eligibilityResult?: InputMaybe<Order_By>;
  exposedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interventionType?: InputMaybe<Order_By>;
  offerId?: InputMaybe<Order_By>;
  offerVersion?: InputMaybe<Order_By>;
  policyVersion?: InputMaybe<Order_By>;
  providerAppliedAt?: InputMaybe<Order_By>;
  sessionId?: InputMaybe<Order_By>;
  suppressionReason?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Retention_Offer_Exposures_Min_Fields = {
  __typename?: 'retention_offer_exposures_min_fields';
  acceptedAt?: Maybe<Scalars['timestamptz']>;
  clickedAt?: Maybe<Scalars['timestamptz']>;
  concessionType?: Maybe<Scalars['String']>;
  concessionValue?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  declinedAt?: Maybe<Scalars['timestamptz']>;
  eligibilityResult?: Maybe<Scalars['String']>;
  exposedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  interventionType?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['String']>;
  offerVersion?: Maybe<Scalars['String']>;
  policyVersion?: Maybe<Scalars['String']>;
  providerAppliedAt?: Maybe<Scalars['timestamptz']>;
  sessionId?: Maybe<Scalars['uuid']>;
  suppressionReason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Min_Order_By = {
  acceptedAt?: InputMaybe<Order_By>;
  clickedAt?: InputMaybe<Order_By>;
  concessionType?: InputMaybe<Order_By>;
  concessionValue?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  declinedAt?: InputMaybe<Order_By>;
  eligibilityResult?: InputMaybe<Order_By>;
  exposedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interventionType?: InputMaybe<Order_By>;
  offerId?: InputMaybe<Order_By>;
  offerVersion?: InputMaybe<Order_By>;
  policyVersion?: InputMaybe<Order_By>;
  providerAppliedAt?: InputMaybe<Order_By>;
  sessionId?: InputMaybe<Order_By>;
  suppressionReason?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Mutation_Response = {
  __typename?: 'retention_offer_exposures_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Retention_Offer_Exposures>;
};

/** on_conflict condition type for table "retention_offer_exposures" */
export type Retention_Offer_Exposures_On_Conflict = {
  constraint: Retention_Offer_Exposures_Constraint;
  update_columns?: Array<Retention_Offer_Exposures_Update_Column>;
  where?: InputMaybe<Retention_Offer_Exposures_Bool_Exp>;
};

/** Ordering options when selecting data from "retention_offer_exposures". */
export type Retention_Offer_Exposures_Order_By = {
  acceptedAt?: InputMaybe<Order_By>;
  clickedAt?: InputMaybe<Order_By>;
  concessionType?: InputMaybe<Order_By>;
  concessionValue?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  declinedAt?: InputMaybe<Order_By>;
  eligibilityResult?: InputMaybe<Order_By>;
  exposedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interventionType?: InputMaybe<Order_By>;
  offerId?: InputMaybe<Order_By>;
  offerVersion?: InputMaybe<Order_By>;
  policyVersion?: InputMaybe<Order_By>;
  providerAppliedAt?: InputMaybe<Order_By>;
  session?: InputMaybe<Retention_Intervention_Sessions_Order_By>;
  sessionId?: InputMaybe<Order_By>;
  suppressionReason?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: retention_offer_exposures */
export type Retention_Offer_Exposures_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "retention_offer_exposures" */
export const Retention_Offer_Exposures_Select_Column = {
  /** column name */
  AcceptedAt: 'acceptedAt',
  /** column name */
  ClickedAt: 'clickedAt',
  /** column name */
  ConcessionType: 'concessionType',
  /** column name */
  ConcessionValue: 'concessionValue',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Currency: 'currency',
  /** column name */
  DeclinedAt: 'declinedAt',
  /** column name */
  EligibilityResult: 'eligibilityResult',
  /** column name */
  ExposedAt: 'exposedAt',
  /** column name */
  Id: 'id',
  /** column name */
  InterventionType: 'interventionType',
  /** column name */
  OfferId: 'offerId',
  /** column name */
  OfferVersion: 'offerVersion',
  /** column name */
  PolicyVersion: 'policyVersion',
  /** column name */
  ProviderAppliedAt: 'providerAppliedAt',
  /** column name */
  SessionId: 'sessionId',
  /** column name */
  SuppressionReason: 'suppressionReason',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Retention_Offer_Exposures_Select_Column = typeof Retention_Offer_Exposures_Select_Column[keyof typeof Retention_Offer_Exposures_Select_Column];
/** input type for updating data in table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Set_Input = {
  acceptedAt?: InputMaybe<Scalars['timestamptz']>;
  clickedAt?: InputMaybe<Scalars['timestamptz']>;
  concessionType?: InputMaybe<Scalars['String']>;
  concessionValue?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  declinedAt?: InputMaybe<Scalars['timestamptz']>;
  eligibilityResult?: InputMaybe<Scalars['String']>;
  exposedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  interventionType?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerVersion?: InputMaybe<Scalars['String']>;
  policyVersion?: InputMaybe<Scalars['String']>;
  providerAppliedAt?: InputMaybe<Scalars['timestamptz']>;
  sessionId?: InputMaybe<Scalars['uuid']>;
  suppressionReason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Retention_Offer_Exposures_Stddev_Fields = {
  __typename?: 'retention_offer_exposures_stddev_fields';
  concessionValue?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Stddev_Order_By = {
  concessionValue?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Retention_Offer_Exposures_Stddev_Pop_Fields = {
  __typename?: 'retention_offer_exposures_stddev_pop_fields';
  concessionValue?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Stddev_Pop_Order_By = {
  concessionValue?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Retention_Offer_Exposures_Stddev_Samp_Fields = {
  __typename?: 'retention_offer_exposures_stddev_samp_fields';
  concessionValue?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Stddev_Samp_Order_By = {
  concessionValue?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Retention_Offer_Exposures_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Retention_Offer_Exposures_Stream_Cursor_Value_Input = {
  acceptedAt?: InputMaybe<Scalars['timestamptz']>;
  clickedAt?: InputMaybe<Scalars['timestamptz']>;
  concessionType?: InputMaybe<Scalars['String']>;
  concessionValue?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  declinedAt?: InputMaybe<Scalars['timestamptz']>;
  eligibilityResult?: InputMaybe<Scalars['String']>;
  exposedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  interventionType?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerVersion?: InputMaybe<Scalars['String']>;
  policyVersion?: InputMaybe<Scalars['String']>;
  providerAppliedAt?: InputMaybe<Scalars['timestamptz']>;
  sessionId?: InputMaybe<Scalars['uuid']>;
  suppressionReason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Retention_Offer_Exposures_Sum_Fields = {
  __typename?: 'retention_offer_exposures_sum_fields';
  concessionValue?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Sum_Order_By = {
  concessionValue?: InputMaybe<Order_By>;
};

/** update columns of table "retention_offer_exposures" */
export const Retention_Offer_Exposures_Update_Column = {
  /** column name */
  AcceptedAt: 'acceptedAt',
  /** column name */
  ClickedAt: 'clickedAt',
  /** column name */
  ConcessionType: 'concessionType',
  /** column name */
  ConcessionValue: 'concessionValue',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Currency: 'currency',
  /** column name */
  DeclinedAt: 'declinedAt',
  /** column name */
  EligibilityResult: 'eligibilityResult',
  /** column name */
  ExposedAt: 'exposedAt',
  /** column name */
  Id: 'id',
  /** column name */
  InterventionType: 'interventionType',
  /** column name */
  OfferId: 'offerId',
  /** column name */
  OfferVersion: 'offerVersion',
  /** column name */
  PolicyVersion: 'policyVersion',
  /** column name */
  ProviderAppliedAt: 'providerAppliedAt',
  /** column name */
  SessionId: 'sessionId',
  /** column name */
  SuppressionReason: 'suppressionReason',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Retention_Offer_Exposures_Update_Column = typeof Retention_Offer_Exposures_Update_Column[keyof typeof Retention_Offer_Exposures_Update_Column];
export type Retention_Offer_Exposures_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Retention_Offer_Exposures_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Retention_Offer_Exposures_Set_Input>;
  /** filter the rows which have to be updated */
  where: Retention_Offer_Exposures_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Retention_Offer_Exposures_Var_Pop_Fields = {
  __typename?: 'retention_offer_exposures_var_pop_fields';
  concessionValue?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Var_Pop_Order_By = {
  concessionValue?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Retention_Offer_Exposures_Var_Samp_Fields = {
  __typename?: 'retention_offer_exposures_var_samp_fields';
  concessionValue?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Var_Samp_Order_By = {
  concessionValue?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Retention_Offer_Exposures_Variance_Fields = {
  __typename?: 'retention_offer_exposures_variance_fields';
  concessionValue?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "retention_offer_exposures" */
export type Retention_Offer_Exposures_Variance_Order_By = {
  concessionValue?: InputMaybe<Order_By>;
};

/** columns and relationships of "sales" */
export type Sales = {
  __typename?: 'sales';
  /** An object relationship */
  affiliateLinkClick?: Maybe<Affiliate_Link_Clicks>;
  affiliateLinkClickId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  affiliateUser?: Maybe<Users>;
  affiliateUserId?: Maybe<Scalars['String']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  originalPrice?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  payingUser: Users;
  payingUserId: Scalars['String'];
  paymentProcessor: Scalars['String'];
  periodLength?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stripeCustomerId: Scalars['String'];
  stripePaymentStatus: Scalars['String'];
  stripePriceId: Scalars['String'];
  stripeProductId?: Maybe<Scalars['String']>;
  stripeSessionId: Scalars['String'];
  /** An object relationship */
  subscription?: Maybe<Subscriptions>;
  subscriptionId?: Maybe<Scalars['uuid']>;
  transactionObject?: Maybe<Scalars['jsonb']>;
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "sales" */
export type SalesTransactionObjectArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "sales" */
export type Sales_Aggregate = {
  __typename?: 'sales_aggregate';
  aggregate?: Maybe<Sales_Aggregate_Fields>;
  nodes: Array<Sales>;
};

export type Sales_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sales_Aggregate_Bool_Exp_Count>;
};

export type Sales_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sales_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sales_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sales" */
export type Sales_Aggregate_Fields = {
  __typename?: 'sales_aggregate_fields';
  avg?: Maybe<Sales_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sales_Max_Fields>;
  min?: Maybe<Sales_Min_Fields>;
  stddev?: Maybe<Sales_Stddev_Fields>;
  stddev_pop?: Maybe<Sales_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sales_Stddev_Samp_Fields>;
  sum?: Maybe<Sales_Sum_Fields>;
  var_pop?: Maybe<Sales_Var_Pop_Fields>;
  var_samp?: Maybe<Sales_Var_Samp_Fields>;
  variance?: Maybe<Sales_Variance_Fields>;
};


/** aggregate fields of "sales" */
export type Sales_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sales_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sales" */
export type Sales_Aggregate_Order_By = {
  avg?: InputMaybe<Sales_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sales_Max_Order_By>;
  min?: InputMaybe<Sales_Min_Order_By>;
  stddev?: InputMaybe<Sales_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sales_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sales_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sales_Sum_Order_By>;
  var_pop?: InputMaybe<Sales_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sales_Var_Samp_Order_By>;
  variance?: InputMaybe<Sales_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Sales_Append_Input = {
  transactionObject?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "sales" */
export type Sales_Arr_Rel_Insert_Input = {
  data: Array<Sales_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sales_On_Conflict>;
};

/** aggregate avg on columns */
export type Sales_Avg_Fields = {
  __typename?: 'sales_avg_fields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sales" */
export type Sales_Avg_Order_By = {
  amountPaid?: InputMaybe<Order_By>;
  originalPrice?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sales". All fields are combined with a logical 'AND'. */
export type Sales_Bool_Exp = {
  _and?: InputMaybe<Array<Sales_Bool_Exp>>;
  _not?: InputMaybe<Sales_Bool_Exp>;
  _or?: InputMaybe<Array<Sales_Bool_Exp>>;
  affiliateLinkClick?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
  affiliateLinkClickId?: InputMaybe<Uuid_Comparison_Exp>;
  affiliateUser?: InputMaybe<Users_Bool_Exp>;
  affiliateUserId?: InputMaybe<String_Comparison_Exp>;
  amountPaid?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  originalPrice?: InputMaybe<Numeric_Comparison_Exp>;
  payingUser?: InputMaybe<Users_Bool_Exp>;
  payingUserId?: InputMaybe<String_Comparison_Exp>;
  paymentProcessor?: InputMaybe<String_Comparison_Exp>;
  periodLength?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  stripeCustomerId?: InputMaybe<String_Comparison_Exp>;
  stripePaymentStatus?: InputMaybe<String_Comparison_Exp>;
  stripePriceId?: InputMaybe<String_Comparison_Exp>;
  stripeProductId?: InputMaybe<String_Comparison_Exp>;
  stripeSessionId?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptionId?: InputMaybe<Uuid_Comparison_Exp>;
  transactionObject?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sales" */
export const Sales_Constraint = {
  /** unique or primary key constraint on columns "id" */
  SalesPkey: 'sales_pkey'
} as const;

export type Sales_Constraint = typeof Sales_Constraint[keyof typeof Sales_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Sales_Delete_At_Path_Input = {
  transactionObject?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Sales_Delete_Elem_Input = {
  transactionObject?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Sales_Delete_Key_Input = {
  transactionObject?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "sales" */
export type Sales_Inc_Input = {
  amountPaid?: InputMaybe<Scalars['numeric']>;
  originalPrice?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "sales" */
export type Sales_Insert_Input = {
  affiliateLinkClick?: InputMaybe<Affiliate_Link_Clicks_Obj_Rel_Insert_Input>;
  affiliateLinkClickId?: InputMaybe<Scalars['uuid']>;
  affiliateUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  affiliateUserId?: InputMaybe<Scalars['String']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalPrice?: InputMaybe<Scalars['numeric']>;
  payingUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  payingUserId?: InputMaybe<Scalars['String']>;
  paymentProcessor?: InputMaybe<Scalars['String']>;
  periodLength?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeSessionId?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Subscriptions_Obj_Rel_Insert_Input>;
  subscriptionId?: InputMaybe<Scalars['uuid']>;
  transactionObject?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Sales_Max_Fields = {
  __typename?: 'sales_max_fields';
  affiliateLinkClickId?: Maybe<Scalars['uuid']>;
  affiliateUserId?: Maybe<Scalars['String']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  originalPrice?: Maybe<Scalars['numeric']>;
  payingUserId?: Maybe<Scalars['String']>;
  paymentProcessor?: Maybe<Scalars['String']>;
  periodLength?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  stripeSessionId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "sales" */
export type Sales_Max_Order_By = {
  affiliateLinkClickId?: InputMaybe<Order_By>;
  affiliateUserId?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originalPrice?: InputMaybe<Order_By>;
  payingUserId?: InputMaybe<Order_By>;
  paymentProcessor?: InputMaybe<Order_By>;
  periodLength?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  stripePaymentStatus?: InputMaybe<Order_By>;
  stripePriceId?: InputMaybe<Order_By>;
  stripeProductId?: InputMaybe<Order_By>;
  stripeSessionId?: InputMaybe<Order_By>;
  subscriptionId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sales_Min_Fields = {
  __typename?: 'sales_min_fields';
  affiliateLinkClickId?: Maybe<Scalars['uuid']>;
  affiliateUserId?: Maybe<Scalars['String']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  originalPrice?: Maybe<Scalars['numeric']>;
  payingUserId?: Maybe<Scalars['String']>;
  paymentProcessor?: Maybe<Scalars['String']>;
  periodLength?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentStatus?: Maybe<Scalars['String']>;
  stripePriceId?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  stripeSessionId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "sales" */
export type Sales_Min_Order_By = {
  affiliateLinkClickId?: InputMaybe<Order_By>;
  affiliateUserId?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originalPrice?: InputMaybe<Order_By>;
  payingUserId?: InputMaybe<Order_By>;
  paymentProcessor?: InputMaybe<Order_By>;
  periodLength?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  stripePaymentStatus?: InputMaybe<Order_By>;
  stripePriceId?: InputMaybe<Order_By>;
  stripeProductId?: InputMaybe<Order_By>;
  stripeSessionId?: InputMaybe<Order_By>;
  subscriptionId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sales" */
export type Sales_Mutation_Response = {
  __typename?: 'sales_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sales>;
};

/** on_conflict condition type for table "sales" */
export type Sales_On_Conflict = {
  constraint: Sales_Constraint;
  update_columns?: Array<Sales_Update_Column>;
  where?: InputMaybe<Sales_Bool_Exp>;
};

/** Ordering options when selecting data from "sales". */
export type Sales_Order_By = {
  affiliateLinkClick?: InputMaybe<Affiliate_Link_Clicks_Order_By>;
  affiliateLinkClickId?: InputMaybe<Order_By>;
  affiliateUser?: InputMaybe<Users_Order_By>;
  affiliateUserId?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originalPrice?: InputMaybe<Order_By>;
  payingUser?: InputMaybe<Users_Order_By>;
  payingUserId?: InputMaybe<Order_By>;
  paymentProcessor?: InputMaybe<Order_By>;
  periodLength?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  stripePaymentStatus?: InputMaybe<Order_By>;
  stripePriceId?: InputMaybe<Order_By>;
  stripeProductId?: InputMaybe<Order_By>;
  stripeSessionId?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscriptionId?: InputMaybe<Order_By>;
  transactionObject?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sales */
export type Sales_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Sales_Prepend_Input = {
  transactionObject?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "sales" */
export const Sales_Select_Column = {
  /** column name */
  AffiliateLinkClickId: 'affiliateLinkClickId',
  /** column name */
  AffiliateUserId: 'affiliateUserId',
  /** column name */
  AmountPaid: 'amountPaid',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  OriginalPrice: 'originalPrice',
  /** column name */
  PayingUserId: 'payingUserId',
  /** column name */
  PaymentProcessor: 'paymentProcessor',
  /** column name */
  PeriodLength: 'periodLength',
  /** column name */
  Status: 'status',
  /** column name */
  StripeCustomerId: 'stripeCustomerId',
  /** column name */
  StripePaymentStatus: 'stripePaymentStatus',
  /** column name */
  StripePriceId: 'stripePriceId',
  /** column name */
  StripeProductId: 'stripeProductId',
  /** column name */
  StripeSessionId: 'stripeSessionId',
  /** column name */
  SubscriptionId: 'subscriptionId',
  /** column name */
  TransactionObject: 'transactionObject',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Sales_Select_Column = typeof Sales_Select_Column[keyof typeof Sales_Select_Column];
/** input type for updating data in table "sales" */
export type Sales_Set_Input = {
  affiliateLinkClickId?: InputMaybe<Scalars['uuid']>;
  affiliateUserId?: InputMaybe<Scalars['String']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalPrice?: InputMaybe<Scalars['numeric']>;
  payingUserId?: InputMaybe<Scalars['String']>;
  paymentProcessor?: InputMaybe<Scalars['String']>;
  periodLength?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeSessionId?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['uuid']>;
  transactionObject?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Sales_Stddev_Fields = {
  __typename?: 'sales_stddev_fields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sales" */
export type Sales_Stddev_Order_By = {
  amountPaid?: InputMaybe<Order_By>;
  originalPrice?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sales_Stddev_Pop_Fields = {
  __typename?: 'sales_stddev_pop_fields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sales" */
export type Sales_Stddev_Pop_Order_By = {
  amountPaid?: InputMaybe<Order_By>;
  originalPrice?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sales_Stddev_Samp_Fields = {
  __typename?: 'sales_stddev_samp_fields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sales" */
export type Sales_Stddev_Samp_Order_By = {
  amountPaid?: InputMaybe<Order_By>;
  originalPrice?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sales" */
export type Sales_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sales_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sales_Stream_Cursor_Value_Input = {
  affiliateLinkClickId?: InputMaybe<Scalars['uuid']>;
  affiliateUserId?: InputMaybe<Scalars['String']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  originalPrice?: InputMaybe<Scalars['numeric']>;
  payingUserId?: InputMaybe<Scalars['String']>;
  paymentProcessor?: InputMaybe<Scalars['String']>;
  periodLength?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  stripePaymentStatus?: InputMaybe<Scalars['String']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  stripeSessionId?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['uuid']>;
  transactionObject?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Sales_Sum_Fields = {
  __typename?: 'sales_sum_fields';
  amountPaid?: Maybe<Scalars['numeric']>;
  originalPrice?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "sales" */
export type Sales_Sum_Order_By = {
  amountPaid?: InputMaybe<Order_By>;
  originalPrice?: InputMaybe<Order_By>;
};

/** update columns of table "sales" */
export const Sales_Update_Column = {
  /** column name */
  AffiliateLinkClickId: 'affiliateLinkClickId',
  /** column name */
  AffiliateUserId: 'affiliateUserId',
  /** column name */
  AmountPaid: 'amountPaid',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  OriginalPrice: 'originalPrice',
  /** column name */
  PayingUserId: 'payingUserId',
  /** column name */
  PaymentProcessor: 'paymentProcessor',
  /** column name */
  PeriodLength: 'periodLength',
  /** column name */
  Status: 'status',
  /** column name */
  StripeCustomerId: 'stripeCustomerId',
  /** column name */
  StripePaymentStatus: 'stripePaymentStatus',
  /** column name */
  StripePriceId: 'stripePriceId',
  /** column name */
  StripeProductId: 'stripeProductId',
  /** column name */
  StripeSessionId: 'stripeSessionId',
  /** column name */
  SubscriptionId: 'subscriptionId',
  /** column name */
  TransactionObject: 'transactionObject',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Sales_Update_Column = typeof Sales_Update_Column[keyof typeof Sales_Update_Column];
export type Sales_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Sales_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Sales_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Sales_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Sales_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sales_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Sales_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sales_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sales_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sales_Var_Pop_Fields = {
  __typename?: 'sales_var_pop_fields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sales" */
export type Sales_Var_Pop_Order_By = {
  amountPaid?: InputMaybe<Order_By>;
  originalPrice?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sales_Var_Samp_Fields = {
  __typename?: 'sales_var_samp_fields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sales" */
export type Sales_Var_Samp_Order_By = {
  amountPaid?: InputMaybe<Order_By>;
  originalPrice?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sales_Variance_Fields = {
  __typename?: 'sales_variance_fields';
  amountPaid?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sales" */
export type Sales_Variance_Order_By = {
  amountPaid?: InputMaybe<Order_By>;
  originalPrice?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** columns and relationships of "subscription_entitlements" */
export type Subscription_Entitlements = {
  __typename?: 'subscription_entitlements';
  note: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "subscription_entitlements" */
export type Subscription_Entitlements_Aggregate = {
  __typename?: 'subscription_entitlements_aggregate';
  aggregate?: Maybe<Subscription_Entitlements_Aggregate_Fields>;
  nodes: Array<Subscription_Entitlements>;
};

/** aggregate fields of "subscription_entitlements" */
export type Subscription_Entitlements_Aggregate_Fields = {
  __typename?: 'subscription_entitlements_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Subscription_Entitlements_Max_Fields>;
  min?: Maybe<Subscription_Entitlements_Min_Fields>;
};


/** aggregate fields of "subscription_entitlements" */
export type Subscription_Entitlements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Entitlements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "subscription_entitlements". All fields are combined with a logical 'AND'. */
export type Subscription_Entitlements_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Entitlements_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Entitlements_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Entitlements_Bool_Exp>>;
  note?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_entitlements" */
export const Subscription_Entitlements_Constraint = {
  /** unique or primary key constraint on columns "value" */
  SubscriptionEntitlementsPkey: 'subscription_entitlements_pkey'
} as const;

export type Subscription_Entitlements_Constraint = typeof Subscription_Entitlements_Constraint[keyof typeof Subscription_Entitlements_Constraint];
/** input type for inserting data into table "subscription_entitlements" */
export type Subscription_Entitlements_Insert_Input = {
  note?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Subscription_Entitlements_Max_Fields = {
  __typename?: 'subscription_entitlements_max_fields';
  note?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Subscription_Entitlements_Min_Fields = {
  __typename?: 'subscription_entitlements_min_fields';
  note?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "subscription_entitlements" */
export type Subscription_Entitlements_Mutation_Response = {
  __typename?: 'subscription_entitlements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Entitlements>;
};

/** on_conflict condition type for table "subscription_entitlements" */
export type Subscription_Entitlements_On_Conflict = {
  constraint: Subscription_Entitlements_Constraint;
  update_columns?: Array<Subscription_Entitlements_Update_Column>;
  where?: InputMaybe<Subscription_Entitlements_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_entitlements". */
export type Subscription_Entitlements_Order_By = {
  note?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_entitlements */
export type Subscription_Entitlements_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "subscription_entitlements" */
export const Subscription_Entitlements_Select_Column = {
  /** column name */
  Note: 'note',
  /** column name */
  Value: 'value'
} as const;

export type Subscription_Entitlements_Select_Column = typeof Subscription_Entitlements_Select_Column[keyof typeof Subscription_Entitlements_Select_Column];
/** input type for updating data in table "subscription_entitlements" */
export type Subscription_Entitlements_Set_Input = {
  note?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "subscription_entitlements" */
export type Subscription_Entitlements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Entitlements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Entitlements_Stream_Cursor_Value_Input = {
  note?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "subscription_entitlements" */
export const Subscription_Entitlements_Update_Column = {
  /** column name */
  Note: 'note',
  /** column name */
  Value: 'value'
} as const;

export type Subscription_Entitlements_Update_Column = typeof Subscription_Entitlements_Update_Column[keyof typeof Subscription_Entitlements_Update_Column];
export type Subscription_Entitlements_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscription_Entitlements_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscription_Entitlements_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "active_option_tickers" */
  active_option_tickers: Array<Active_Option_Tickers>;
  /** fetch aggregated fields from the table: "active_option_tickers" */
  active_option_tickers_aggregate: Active_Option_Tickers_Aggregate;
  /** fetch data from the table in a streaming manner: "active_option_tickers" */
  active_option_tickers_stream: Array<Active_Option_Tickers>;
  /** fetch data from the table: "affiliate_link_clicks" */
  affiliate_link_clicks: Array<Affiliate_Link_Clicks>;
  /** fetch aggregated fields from the table: "affiliate_link_clicks" */
  affiliate_link_clicks_aggregate: Affiliate_Link_Clicks_Aggregate;
  /** fetch data from the table: "affiliate_link_clicks" using primary key columns */
  affiliate_link_clicks_by_pk?: Maybe<Affiliate_Link_Clicks>;
  /** fetch data from the table in a streaming manner: "affiliate_link_clicks" */
  affiliate_link_clicks_stream: Array<Affiliate_Link_Clicks>;
  /** fetch data from the table: "affiliate_payouts" */
  affiliate_payouts: Array<Affiliate_Payouts>;
  /** fetch aggregated fields from the table: "affiliate_payouts" */
  affiliate_payouts_aggregate: Affiliate_Payouts_Aggregate;
  /** fetch data from the table: "affiliate_payouts" using primary key columns */
  affiliate_payouts_by_pk?: Maybe<Affiliate_Payouts>;
  /** fetch data from the table in a streaming manner: "affiliate_payouts" */
  affiliate_payouts_stream: Array<Affiliate_Payouts>;
  /** fetch data from the table: "affiliate_referral_click_counts" */
  affiliate_referral_click_counts: Array<Affiliate_Referral_Click_Counts>;
  /** fetch aggregated fields from the table: "affiliate_referral_click_counts" */
  affiliate_referral_click_counts_aggregate: Affiliate_Referral_Click_Counts_Aggregate;
  /** fetch data from the table in a streaming manner: "affiliate_referral_click_counts" */
  affiliate_referral_click_counts_stream: Array<Affiliate_Referral_Click_Counts>;
  /** fetch data from the table: "asset_signal_alerts" */
  asset_signal_alerts: Array<Asset_Signal_Alerts>;
  /** fetch aggregated fields from the table: "asset_signal_alerts" */
  asset_signal_alerts_aggregate: Asset_Signal_Alerts_Aggregate;
  /** fetch data from the table: "asset_signal_alerts" using primary key columns */
  asset_signal_alerts_by_pk?: Maybe<Asset_Signal_Alerts>;
  /** fetch data from the table in a streaming manner: "asset_signal_alerts" */
  asset_signal_alerts_stream: Array<Asset_Signal_Alerts>;
  /** An array relationship */
  charges: Array<Charges>;
  /** An aggregate relationship */
  charges_aggregate: Charges_Aggregate;
  /** fetch data from the table: "charges" using primary key columns */
  charges_by_pk?: Maybe<Charges>;
  /** fetch data from the table in a streaming manner: "charges" */
  charges_stream: Array<Charges>;
  /** fetch data from the table: "congress_trades" */
  congress_trades: Array<Congress_Trades>;
  /** fetch aggregated fields from the table: "congress_trades" */
  congress_trades_aggregate: Congress_Trades_Aggregate;
  /** fetch data from the table: "congress_trades" using primary key columns */
  congress_trades_by_pk?: Maybe<Congress_Trades>;
  /** fetch data from the table in a streaming manner: "congress_trades" */
  congress_trades_stream: Array<Congress_Trades>;
  /** fetch data from the table: "cookie_strings" */
  cookie_strings: Array<Cookie_Strings>;
  /** fetch aggregated fields from the table: "cookie_strings" */
  cookie_strings_aggregate: Cookie_Strings_Aggregate;
  /** fetch data from the table: "cookie_strings" using primary key columns */
  cookie_strings_by_pk?: Maybe<Cookie_Strings>;
  /** fetch data from the table in a streaming manner: "cookie_strings" */
  cookie_strings_stream: Array<Cookie_Strings>;
  /** fetch data from the table: "course_progress" */
  course_progress: Array<Course_Progress>;
  /** fetch aggregated fields from the table: "course_progress" */
  course_progress_aggregate: Course_Progress_Aggregate;
  /** fetch data from the table: "course_progress" using primary key columns */
  course_progress_by_pk?: Maybe<Course_Progress>;
  /** fetch data from the table: "course_progress_status" */
  course_progress_status: Array<Course_Progress_Status>;
  /** fetch aggregated fields from the table: "course_progress_status" */
  course_progress_status_aggregate: Course_Progress_Status_Aggregate;
  /** fetch data from the table: "course_progress_status" using primary key columns */
  course_progress_status_by_pk?: Maybe<Course_Progress_Status>;
  /** fetch data from the table in a streaming manner: "course_progress_status" */
  course_progress_status_stream: Array<Course_Progress_Status>;
  /** fetch data from the table in a streaming manner: "course_progress" */
  course_progress_stream: Array<Course_Progress>;
  /** fetch data from the table: "daily_averages_exclude_today" */
  daily_averages_exclude_today: Array<Daily_Averages_Exclude_Today>;
  /** fetch aggregated fields from the table: "daily_averages_exclude_today" */
  daily_averages_exclude_today_aggregate: Daily_Averages_Exclude_Today_Aggregate;
  /** fetch data from the table in a streaming manner: "daily_averages_exclude_today" */
  daily_averages_exclude_today_stream: Array<Daily_Averages_Exclude_Today>;
  /** fetch data from the table: "daily_averages_include_today" */
  daily_averages_include_today: Array<Daily_Averages_Include_Today>;
  /** fetch aggregated fields from the table: "daily_averages_include_today" */
  daily_averages_include_today_aggregate: Daily_Averages_Include_Today_Aggregate;
  /** fetch data from the table in a streaming manner: "daily_averages_include_today" */
  daily_averages_include_today_stream: Array<Daily_Averages_Include_Today>;
  /** fetch data from the table: "daily_volume" */
  daily_volume: Array<Daily_Volume>;
  /** fetch aggregated fields from the table: "daily_volume" */
  daily_volume_aggregate: Daily_Volume_Aggregate;
  /** fetch data from the table in a streaming manner: "daily_volume" */
  daily_volume_stream: Array<Daily_Volume>;
  /** fetch data from the table: "dark_pool_levels" */
  dark_pool_levels: Array<Dark_Pool_Levels>;
  /** fetch aggregated fields from the table: "dark_pool_levels" */
  dark_pool_levels_aggregate: Dark_Pool_Levels_Aggregate;
  /** fetch data from the table: "dark_pool_levels_monthly" */
  dark_pool_levels_monthly: Array<Dark_Pool_Levels_Monthly>;
  /** fetch aggregated fields from the table: "dark_pool_levels_monthly" */
  dark_pool_levels_monthly_aggregate: Dark_Pool_Levels_Monthly_Aggregate;
  /** fetch data from the table in a streaming manner: "dark_pool_levels_monthly" */
  dark_pool_levels_monthly_stream: Array<Dark_Pool_Levels_Monthly>;
  /** fetch data from the table in a streaming manner: "dark_pool_levels" */
  dark_pool_levels_stream: Array<Dark_Pool_Levels>;
  /** fetch data from the table: "demo_filtered_trades_spiderrock" */
  demo_filtered_trades_spiderrock: Array<Demo_Filtered_Trades_Spiderrock>;
  /** fetch aggregated fields from the table: "demo_filtered_trades_spiderrock" */
  demo_filtered_trades_spiderrock_aggregate: Demo_Filtered_Trades_Spiderrock_Aggregate;
  /** fetch data from the table: "demo_filtered_trades_spiderrock" using primary key columns */
  demo_filtered_trades_spiderrock_by_pk?: Maybe<Demo_Filtered_Trades_Spiderrock>;
  /** fetch data from the table in a streaming manner: "demo_filtered_trades_spiderrock" */
  demo_filtered_trades_spiderrock_stream: Array<Demo_Filtered_Trades_Spiderrock>;
  /** fetch data from the table: "demo_raw_trades_spiderrock" */
  demo_raw_trades_spiderrock: Array<Demo_Raw_Trades_Spiderrock>;
  /** fetch aggregated fields from the table: "demo_raw_trades_spiderrock" */
  demo_raw_trades_spiderrock_aggregate: Demo_Raw_Trades_Spiderrock_Aggregate;
  /** fetch data from the table: "demo_raw_trades_spiderrock" using primary key columns */
  demo_raw_trades_spiderrock_by_pk?: Maybe<Demo_Raw_Trades_Spiderrock>;
  /** fetch data from the table in a streaming manner: "demo_raw_trades_spiderrock" */
  demo_raw_trades_spiderrock_stream: Array<Demo_Raw_Trades_Spiderrock>;
  /** fetch data from the table: "earnings_snp" */
  earnings_snp: Array<Earnings_Snp>;
  /** fetch aggregated fields from the table: "earnings_snp" */
  earnings_snp_aggregate: Earnings_Snp_Aggregate;
  /** fetch data from the table: "earnings_snp" using primary key columns */
  earnings_snp_by_pk?: Maybe<Earnings_Snp>;
  /** fetch data from the table in a streaming manner: "earnings_snp" */
  earnings_snp_stream: Array<Earnings_Snp>;
  /** fetch data from the table: "email_alerts" */
  email_alerts: Array<Email_Alerts>;
  /** fetch aggregated fields from the table: "email_alerts" */
  email_alerts_aggregate: Email_Alerts_Aggregate;
  /** fetch data from the table: "email_alerts" using primary key columns */
  email_alerts_by_pk?: Maybe<Email_Alerts>;
  /** fetch data from the table in a streaming manner: "email_alerts" */
  email_alerts_stream: Array<Email_Alerts>;
  /** fetch data from the table: "email_list" */
  email_list: Array<Email_List>;
  /** fetch aggregated fields from the table: "email_list" */
  email_list_aggregate: Email_List_Aggregate;
  /** fetch data from the table: "email_list" using primary key columns */
  email_list_by_pk?: Maybe<Email_List>;
  /** fetch data from the table in a streaming manner: "email_list" */
  email_list_stream: Array<Email_List>;
  /** fetch data from the table: "equities_eod" */
  equities_eod: Array<Equities_Eod>;
  /** fetch aggregated fields from the table: "equities_eod" */
  equities_eod_aggregate: Equities_Eod_Aggregate;
  /** fetch data from the table: "equities_eod" using primary key columns */
  equities_eod_by_pk?: Maybe<Equities_Eod>;
  /** fetch data from the table in a streaming manner: "equities_eod" */
  equities_eod_stream: Array<Equities_Eod>;
  /** fetch data from the table: "equity_pool_prints" */
  equity_pool_prints: Array<Equity_Pool_Prints>;
  /** fetch aggregated fields from the table: "equity_pool_prints" */
  equity_pool_prints_aggregate: Equity_Pool_Prints_Aggregate;
  /** fetch data from the table: "equity_pool_prints" using primary key columns */
  equity_pool_prints_by_pk?: Maybe<Equity_Pool_Prints>;
  /** fetch data from the table in a streaming manner: "equity_pool_prints" */
  equity_pool_prints_stream: Array<Equity_Pool_Prints>;
  /** fetch data from the table: "equity_print_feed_baseline" */
  equity_print_feed_baseline: Array<Equity_Print_Feed_Baseline>;
  /** fetch aggregated fields from the table: "equity_print_feed_baseline" */
  equity_print_feed_baseline_aggregate: Equity_Print_Feed_Baseline_Aggregate;
  /** fetch data from the table: "equity_print_feed_baseline" using primary key columns */
  equity_print_feed_baseline_by_pk?: Maybe<Equity_Print_Feed_Baseline>;
  /** fetch data from the table in a streaming manner: "equity_print_feed_baseline" */
  equity_print_feed_baseline_stream: Array<Equity_Print_Feed_Baseline>;
  /** fetch data from the table: "equity_print_feed_filtered" */
  equity_print_feed_filtered: Array<Equity_Print_Feed_Filtered>;
  /** fetch aggregated fields from the table: "equity_print_feed_filtered" */
  equity_print_feed_filtered_aggregate: Equity_Print_Feed_Filtered_Aggregate;
  /** fetch data from the table: "equity_print_feed_filtered" using primary key columns */
  equity_print_feed_filtered_by_pk?: Maybe<Equity_Print_Feed_Filtered>;
  /** fetch data from the table in a streaming manner: "equity_print_feed_filtered" */
  equity_print_feed_filtered_stream: Array<Equity_Print_Feed_Filtered>;
  /** fetch data from the table: "equity_print_flow" */
  equity_print_flow: Array<Equity_Print_Flow>;
  /** fetch aggregated fields from the table: "equity_print_flow" */
  equity_print_flow_aggregate: Equity_Print_Flow_Aggregate;
  /** fetch data from the table: "equity_print_flow_full" */
  equity_print_flow_full: Array<Equity_Print_Flow_Full>;
  /** fetch aggregated fields from the table: "equity_print_flow_full" */
  equity_print_flow_full_aggregate: Equity_Print_Flow_Full_Aggregate;
  /** fetch data from the table in a streaming manner: "equity_print_flow_full" */
  equity_print_flow_full_stream: Array<Equity_Print_Flow_Full>;
  /** fetch data from the table in a streaming manner: "equity_print_flow" */
  equity_print_flow_stream: Array<Equity_Print_Flow>;
  /** fetch data from the table: "fa_call_moving_average" */
  fa_call_moving_average: Array<Fa_Call_Moving_Average>;
  /** fetch aggregated fields from the table: "fa_call_moving_average" */
  fa_call_moving_average_aggregate: Fa_Call_Moving_Average_Aggregate;
  /** fetch data from the table in a streaming manner: "fa_call_moving_average" */
  fa_call_moving_average_stream: Array<Fa_Call_Moving_Average>;
  /** fetch data from the table: "fa_put_moving_average" */
  fa_put_moving_average: Array<Fa_Put_Moving_Average>;
  /** fetch aggregated fields from the table: "fa_put_moving_average" */
  fa_put_moving_average_aggregate: Fa_Put_Moving_Average_Aggregate;
  /** fetch data from the table in a streaming manner: "fa_put_moving_average" */
  fa_put_moving_average_stream: Array<Fa_Put_Moving_Average>;
  /** fetch data from the table: "fa_trade_uploads" */
  fa_trade_uploads: Array<Fa_Trade_Uploads>;
  /** fetch aggregated fields from the table: "fa_trade_uploads" */
  fa_trade_uploads_aggregate: Fa_Trade_Uploads_Aggregate;
  /** fetch data from the table: "fa_trade_uploads" using primary key columns */
  fa_trade_uploads_by_pk?: Maybe<Fa_Trade_Uploads>;
  /** fetch data from the table in a streaming manner: "fa_trade_uploads" */
  fa_trade_uploads_stream: Array<Fa_Trade_Uploads>;
  /** fetch data from the table: "fa_trades" */
  fa_trades: Array<Fa_Trades>;
  /** fetch aggregated fields from the table: "fa_trades" */
  fa_trades_aggregate: Fa_Trades_Aggregate;
  /** fetch data from the table: "fa_trades" using primary key columns */
  fa_trades_by_pk?: Maybe<Fa_Trades>;
  /** fetch data from the table in a streaming manner: "fa_trades" */
  fa_trades_stream: Array<Fa_Trades>;
  /** fetch data from the table: "feedback_boards" */
  feedback_boards: Array<Feedback_Boards>;
  /** fetch aggregated fields from the table: "feedback_boards" */
  feedback_boards_aggregate: Feedback_Boards_Aggregate;
  /** fetch data from the table: "feedback_boards" using primary key columns */
  feedback_boards_by_pk?: Maybe<Feedback_Boards>;
  /** fetch data from the table in a streaming manner: "feedback_boards" */
  feedback_boards_stream: Array<Feedback_Boards>;
  /** fetch data from the table: "feedback_comments" */
  feedback_comments: Array<Feedback_Comments>;
  /** fetch aggregated fields from the table: "feedback_comments" */
  feedback_comments_aggregate: Feedback_Comments_Aggregate;
  /** fetch data from the table: "feedback_comments" using primary key columns */
  feedback_comments_by_pk?: Maybe<Feedback_Comments>;
  /** fetch data from the table in a streaming manner: "feedback_comments" */
  feedback_comments_stream: Array<Feedback_Comments>;
  /** fetch data from the table: "feedback_media" */
  feedback_media: Array<Feedback_Media>;
  /** fetch aggregated fields from the table: "feedback_media" */
  feedback_media_aggregate: Feedback_Media_Aggregate;
  /** fetch data from the table: "feedback_media" using primary key columns */
  feedback_media_by_pk?: Maybe<Feedback_Media>;
  /** fetch data from the table in a streaming manner: "feedback_media" */
  feedback_media_stream: Array<Feedback_Media>;
  /** fetch data from the table: "feedback_post_contexts" */
  feedback_post_contexts: Array<Feedback_Post_Contexts>;
  /** fetch aggregated fields from the table: "feedback_post_contexts" */
  feedback_post_contexts_aggregate: Feedback_Post_Contexts_Aggregate;
  /** fetch data from the table: "feedback_post_contexts" using primary key columns */
  feedback_post_contexts_by_pk?: Maybe<Feedback_Post_Contexts>;
  /** fetch data from the table in a streaming manner: "feedback_post_contexts" */
  feedback_post_contexts_stream: Array<Feedback_Post_Contexts>;
  /** fetch data from the table: "feedback_post_merges" */
  feedback_post_merges: Array<Feedback_Post_Merges>;
  /** fetch aggregated fields from the table: "feedback_post_merges" */
  feedback_post_merges_aggregate: Feedback_Post_Merges_Aggregate;
  /** fetch data from the table: "feedback_post_merges" using primary key columns */
  feedback_post_merges_by_pk?: Maybe<Feedback_Post_Merges>;
  /** fetch data from the table in a streaming manner: "feedback_post_merges" */
  feedback_post_merges_stream: Array<Feedback_Post_Merges>;
  /** fetch data from the table: "feedback_posts" */
  feedback_posts: Array<Feedback_Posts>;
  /** fetch aggregated fields from the table: "feedback_posts" */
  feedback_posts_aggregate: Feedback_Posts_Aggregate;
  /** fetch data from the table: "feedback_posts" using primary key columns */
  feedback_posts_by_pk?: Maybe<Feedback_Posts>;
  /** fetch data from the table in a streaming manner: "feedback_posts" */
  feedback_posts_stream: Array<Feedback_Posts>;
  /** fetch data from the table: "feedback_posts_with_counts" */
  feedback_posts_with_counts: Array<Feedback_Posts_With_Counts>;
  /** fetch aggregated fields from the table: "feedback_posts_with_counts" */
  feedback_posts_with_counts_aggregate: Feedback_Posts_With_Counts_Aggregate;
  /** fetch data from the table in a streaming manner: "feedback_posts_with_counts" */
  feedback_posts_with_counts_stream: Array<Feedback_Posts_With_Counts>;
  /** fetch data from the table: "feedback_release_posts" */
  feedback_release_posts: Array<Feedback_Release_Posts>;
  /** fetch aggregated fields from the table: "feedback_release_posts" */
  feedback_release_posts_aggregate: Feedback_Release_Posts_Aggregate;
  /** fetch data from the table: "feedback_release_posts" using primary key columns */
  feedback_release_posts_by_pk?: Maybe<Feedback_Release_Posts>;
  /** fetch data from the table in a streaming manner: "feedback_release_posts" */
  feedback_release_posts_stream: Array<Feedback_Release_Posts>;
  /** fetch data from the table: "feedback_releases" */
  feedback_releases: Array<Feedback_Releases>;
  /** fetch aggregated fields from the table: "feedback_releases" */
  feedback_releases_aggregate: Feedback_Releases_Aggregate;
  /** fetch data from the table: "feedback_releases" using primary key columns */
  feedback_releases_by_pk?: Maybe<Feedback_Releases>;
  /** fetch data from the table in a streaming manner: "feedback_releases" */
  feedback_releases_stream: Array<Feedback_Releases>;
  /** fetch data from the table: "feedback_statuses" */
  feedback_statuses: Array<Feedback_Statuses>;
  /** fetch aggregated fields from the table: "feedback_statuses" */
  feedback_statuses_aggregate: Feedback_Statuses_Aggregate;
  /** fetch data from the table: "feedback_statuses" using primary key columns */
  feedback_statuses_by_pk?: Maybe<Feedback_Statuses>;
  /** fetch data from the table in a streaming manner: "feedback_statuses" */
  feedback_statuses_stream: Array<Feedback_Statuses>;
  /** fetch data from the table: "feedback_votes" */
  feedback_votes: Array<Feedback_Votes>;
  /** fetch aggregated fields from the table: "feedback_votes" */
  feedback_votes_aggregate: Feedback_Votes_Aggregate;
  /** fetch data from the table: "feedback_votes" using primary key columns */
  feedback_votes_by_pk?: Maybe<Feedback_Votes>;
  /** fetch data from the table in a streaming manner: "feedback_votes" */
  feedback_votes_stream: Array<Feedback_Votes>;
  /** fetch data from the table: "flow_configurations" */
  flow_configurations: Array<Flow_Configurations>;
  /** fetch aggregated fields from the table: "flow_configurations" */
  flow_configurations_aggregate: Flow_Configurations_Aggregate;
  /** fetch data from the table: "flow_configurations" using primary key columns */
  flow_configurations_by_pk?: Maybe<Flow_Configurations>;
  /** fetch data from the table in a streaming manner: "flow_configurations" */
  flow_configurations_stream: Array<Flow_Configurations>;
  /** fetch data from the table: "free_equity_print_flow" */
  free_equity_print_flow: Array<Free_Equity_Print_Flow>;
  /** fetch aggregated fields from the table: "free_equity_print_flow" */
  free_equity_print_flow_aggregate: Free_Equity_Print_Flow_Aggregate;
  /** fetch data from the table in a streaming manner: "free_equity_print_flow" */
  free_equity_print_flow_stream: Array<Free_Equity_Print_Flow>;
  /** fetch data from the table: "free_option_flow" */
  free_option_flow: Array<Free_Option_Flow>;
  /** fetch aggregated fields from the table: "free_option_flow" */
  free_option_flow_aggregate: Free_Option_Flow_Aggregate;
  /** fetch data from the table: "free_option_flow_all_sides" */
  free_option_flow_all_sides: Array<Free_Option_Flow_All_Sides>;
  /** fetch aggregated fields from the table: "free_option_flow_all_sides" */
  free_option_flow_all_sides_aggregate: Free_Option_Flow_All_Sides_Aggregate;
  /** fetch data from the table in a streaming manner: "free_option_flow_all_sides" */
  free_option_flow_all_sides_stream: Array<Free_Option_Flow_All_Sides>;
  /** fetch data from the table in a streaming manner: "free_option_flow" */
  free_option_flow_stream: Array<Free_Option_Flow>;
  /** fetch data from the table: "free_ticker_equity_print_flow" */
  free_ticker_equity_print_flow: Array<Free_Ticker_Equity_Print_Flow>;
  /** fetch aggregated fields from the table: "free_ticker_equity_print_flow" */
  free_ticker_equity_print_flow_aggregate: Free_Ticker_Equity_Print_Flow_Aggregate;
  /** fetch data from the table in a streaming manner: "free_ticker_equity_print_flow" */
  free_ticker_equity_print_flow_stream: Array<Free_Ticker_Equity_Print_Flow>;
  /** fetch data from the table: "free_ticker_option_flow" */
  free_ticker_option_flow: Array<Free_Ticker_Option_Flow>;
  /** fetch aggregated fields from the table: "free_ticker_option_flow" */
  free_ticker_option_flow_aggregate: Free_Ticker_Option_Flow_Aggregate;
  /** fetch data from the table: "free_ticker_option_flow_all_sides" */
  free_ticker_option_flow_all_sides: Array<Free_Ticker_Option_Flow_All_Sides>;
  /** fetch aggregated fields from the table: "free_ticker_option_flow_all_sides" */
  free_ticker_option_flow_all_sides_aggregate: Free_Ticker_Option_Flow_All_Sides_Aggregate;
  /** fetch data from the table in a streaming manner: "free_ticker_option_flow_all_sides" */
  free_ticker_option_flow_all_sides_stream: Array<Free_Ticker_Option_Flow_All_Sides>;
  /** fetch data from the table in a streaming manner: "free_ticker_option_flow" */
  free_ticker_option_flow_stream: Array<Free_Ticker_Option_Flow>;
  /** fetch data from the table: "full_feed_equity_print_flow" */
  full_feed_equity_print_flow: Array<Full_Feed_Equity_Print_Flow>;
  /** fetch aggregated fields from the table: "full_feed_equity_print_flow" */
  full_feed_equity_print_flow_aggregate: Full_Feed_Equity_Print_Flow_Aggregate;
  /** fetch data from the table in a streaming manner: "full_feed_equity_print_flow" */
  full_feed_equity_print_flow_stream: Array<Full_Feed_Equity_Print_Flow>;
  /** fetch data from the table: "full_feed_option_flow" */
  full_feed_option_flow: Array<Full_Feed_Option_Flow>;
  /** fetch aggregated fields from the table: "full_feed_option_flow" */
  full_feed_option_flow_aggregate: Full_Feed_Option_Flow_Aggregate;
  /** fetch data from the table in a streaming manner: "full_feed_option_flow" */
  full_feed_option_flow_stream: Array<Full_Feed_Option_Flow>;
  /** fetch data from the table: "health_checks" */
  health_checks: Array<Health_Checks>;
  /** fetch aggregated fields from the table: "health_checks" */
  health_checks_aggregate: Health_Checks_Aggregate;
  /** fetch data from the table: "health_checks" using primary key columns */
  health_checks_by_pk?: Maybe<Health_Checks>;
  /** fetch data from the table in a streaming manner: "health_checks" */
  health_checks_stream: Array<Health_Checks>;
  /** fetch data from the table: "insider_trades" */
  insider_trades: Array<Insider_Trades>;
  /** fetch aggregated fields from the table: "insider_trades" */
  insider_trades_aggregate: Insider_Trades_Aggregate;
  /** fetch data from the table: "insider_trades" using primary key columns */
  insider_trades_by_pk?: Maybe<Insider_Trades>;
  /** fetch data from the table in a streaming manner: "insider_trades" */
  insider_trades_stream: Array<Insider_Trades>;
  /** fetch data from the table: "insider_trades_top_long" */
  insider_trades_top_long: Array<Insider_Trades_Top_Long>;
  /** fetch aggregated fields from the table: "insider_trades_top_long" */
  insider_trades_top_long_aggregate: Insider_Trades_Top_Long_Aggregate;
  /** fetch data from the table in a streaming manner: "insider_trades_top_long" */
  insider_trades_top_long_stream: Array<Insider_Trades_Top_Long>;
  /** fetch data from the table: "insider_trades_top_short" */
  insider_trades_top_short: Array<Insider_Trades_Top_Short>;
  /** fetch aggregated fields from the table: "insider_trades_top_short" */
  insider_trades_top_short_aggregate: Insider_Trades_Top_Short_Aggregate;
  /** fetch data from the table in a streaming manner: "insider_trades_top_short" */
  insider_trades_top_short_stream: Array<Insider_Trades_Top_Short>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoices_by_pk?: Maybe<Invoices>;
  /** fetch data from the table in a streaming manner: "invoices" */
  invoices_stream: Array<Invoices>;
  /** fetch data from the table: "microsoft_access_tokens" */
  microsoft_access_tokens: Array<Microsoft_Access_Tokens>;
  /** fetch aggregated fields from the table: "microsoft_access_tokens" */
  microsoft_access_tokens_aggregate: Microsoft_Access_Tokens_Aggregate;
  /** fetch data from the table: "microsoft_access_tokens" using primary key columns */
  microsoft_access_tokens_by_pk?: Maybe<Microsoft_Access_Tokens>;
  /** fetch data from the table in a streaming manner: "microsoft_access_tokens" */
  microsoft_access_tokens_stream: Array<Microsoft_Access_Tokens>;
  /** fetch data from the table: "most_researched_tickers_daily_total" */
  most_researched_tickers_daily_total: Array<Most_Researched_Tickers_Daily_Total>;
  /** fetch aggregated fields from the table: "most_researched_tickers_daily_total" */
  most_researched_tickers_daily_total_aggregate: Most_Researched_Tickers_Daily_Total_Aggregate;
  /** fetch data from the table in a streaming manner: "most_researched_tickers_daily_total" */
  most_researched_tickers_daily_total_stream: Array<Most_Researched_Tickers_Daily_Total>;
  /** fetch data from the table: "most_researched_tickers_daily_unique" */
  most_researched_tickers_daily_unique: Array<Most_Researched_Tickers_Daily_Unique>;
  /** fetch aggregated fields from the table: "most_researched_tickers_daily_unique" */
  most_researched_tickers_daily_unique_aggregate: Most_Researched_Tickers_Daily_Unique_Aggregate;
  /** fetch data from the table in a streaming manner: "most_researched_tickers_daily_unique" */
  most_researched_tickers_daily_unique_stream: Array<Most_Researched_Tickers_Daily_Unique>;
  /** fetch data from the table: "news_cache_stocks" */
  news_cache_stocks: Array<News_Cache_Stocks>;
  /** fetch aggregated fields from the table: "news_cache_stocks" */
  news_cache_stocks_aggregate: News_Cache_Stocks_Aggregate;
  /** fetch data from the table: "news_cache_stocks" using primary key columns */
  news_cache_stocks_by_pk?: Maybe<News_Cache_Stocks>;
  /** fetch data from the table in a streaming manner: "news_cache_stocks" */
  news_cache_stocks_stream: Array<News_Cache_Stocks>;
  /** fetch data from the table: "newsletter_payloads" */
  newsletter_payloads: Array<Newsletter_Payloads>;
  /** fetch aggregated fields from the table: "newsletter_payloads" */
  newsletter_payloads_aggregate: Newsletter_Payloads_Aggregate;
  /** fetch data from the table: "newsletter_payloads" using primary key columns */
  newsletter_payloads_by_pk?: Maybe<Newsletter_Payloads>;
  /** fetch data from the table in a streaming manner: "newsletter_payloads" */
  newsletter_payloads_stream: Array<Newsletter_Payloads>;
  /** fetch data from the table: "opc_saved_strategies" */
  opc_saved_strategies: Array<Opc_Saved_Strategies>;
  /** fetch aggregated fields from the table: "opc_saved_strategies" */
  opc_saved_strategies_aggregate: Opc_Saved_Strategies_Aggregate;
  /** fetch data from the table: "opc_saved_strategies" using primary key columns */
  opc_saved_strategies_by_pk?: Maybe<Opc_Saved_Strategies>;
  /** fetch data from the table in a streaming manner: "opc_saved_strategies" */
  opc_saved_strategies_stream: Array<Opc_Saved_Strategies>;
  /** fetch data from the table: "opc_saved_strategy_positions" */
  opc_saved_strategy_positions: Array<Opc_Saved_Strategy_Positions>;
  /** fetch aggregated fields from the table: "opc_saved_strategy_positions" */
  opc_saved_strategy_positions_aggregate: Opc_Saved_Strategy_Positions_Aggregate;
  /** fetch data from the table: "opc_saved_strategy_positions" using primary key columns */
  opc_saved_strategy_positions_by_pk?: Maybe<Opc_Saved_Strategy_Positions>;
  /** fetch data from the table in a streaming manner: "opc_saved_strategy_positions" */
  opc_saved_strategy_positions_stream: Array<Opc_Saved_Strategy_Positions>;
  /** fetch data from the table: "option_feed_baseline" */
  option_feed_baseline: Array<Option_Feed_Baseline>;
  /** fetch aggregated fields from the table: "option_feed_baseline" */
  option_feed_baseline_aggregate: Option_Feed_Baseline_Aggregate;
  /** fetch data from the table: "option_feed_baseline" using primary key columns */
  option_feed_baseline_by_pk?: Maybe<Option_Feed_Baseline>;
  /** fetch data from the table in a streaming manner: "option_feed_baseline" */
  option_feed_baseline_stream: Array<Option_Feed_Baseline>;
  /** fetch data from the table: "option_feed_filtered" */
  option_feed_filtered: Array<Option_Feed_Filtered>;
  /** fetch aggregated fields from the table: "option_feed_filtered" */
  option_feed_filtered_aggregate: Option_Feed_Filtered_Aggregate;
  /** fetch data from the table: "option_feed_filtered" using primary key columns */
  option_feed_filtered_by_pk?: Maybe<Option_Feed_Filtered>;
  /** fetch data from the table in a streaming manner: "option_feed_filtered" */
  option_feed_filtered_stream: Array<Option_Feed_Filtered>;
  /** fetch data from the table: "option_flow" */
  option_flow: Array<Option_Flow>;
  /** fetch aggregated fields from the table: "option_flow" */
  option_flow_aggregate: Option_Flow_Aggregate;
  /** fetch data from the table: "option_flow_all_sides" */
  option_flow_all_sides: Array<Option_Flow_All_Sides>;
  /** fetch aggregated fields from the table: "option_flow_all_sides" */
  option_flow_all_sides_aggregate: Option_Flow_All_Sides_Aggregate;
  /** fetch data from the table in a streaming manner: "option_flow_all_sides" */
  option_flow_all_sides_stream: Array<Option_Flow_All_Sides>;
  /** fetch data from the table in a streaming manner: "option_flow" */
  option_flow_stream: Array<Option_Flow>;
  /** fetch data from the table: "options_eod" */
  options_eod: Array<Options_Eod>;
  /** fetch aggregated fields from the table: "options_eod" */
  options_eod_aggregate: Options_Eod_Aggregate;
  /** fetch data from the table: "options_eod" using primary key columns */
  options_eod_by_pk?: Maybe<Options_Eod>;
  /** fetch data from the table in a streaming manner: "options_eod" */
  options_eod_stream: Array<Options_Eod>;
  /** fetch data from the table: "prelaunch_email_list" */
  prelaunch_email_list: Array<Prelaunch_Email_List>;
  /** fetch aggregated fields from the table: "prelaunch_email_list" */
  prelaunch_email_list_aggregate: Prelaunch_Email_List_Aggregate;
  /** fetch data from the table: "prelaunch_email_list" using primary key columns */
  prelaunch_email_list_by_pk?: Maybe<Prelaunch_Email_List>;
  /** fetch data from the table in a streaming manner: "prelaunch_email_list" */
  prelaunch_email_list_stream: Array<Prelaunch_Email_List>;
  /** fetch data from the table: "ready_check" */
  ready_check: Array<Ready_Check>;
  /** fetch aggregated fields from the table: "ready_check" */
  ready_check_aggregate: Ready_Check_Aggregate;
  /** fetch data from the table: "ready_check" using primary key columns */
  ready_check_by_pk?: Maybe<Ready_Check>;
  /** fetch data from the table in a streaming manner: "ready_check" */
  ready_check_stream: Array<Ready_Check>;
  /** fetch data from the table: "retention_feedback" */
  retention_feedback: Array<Retention_Feedback>;
  /** fetch aggregated fields from the table: "retention_feedback" */
  retention_feedback_aggregate: Retention_Feedback_Aggregate;
  /** fetch data from the table: "retention_feedback" using primary key columns */
  retention_feedback_by_pk?: Maybe<Retention_Feedback>;
  /** fetch data from the table in a streaming manner: "retention_feedback" */
  retention_feedback_stream: Array<Retention_Feedback>;
  /** fetch data from the table: "retention_intervention_events" */
  retention_intervention_events: Array<Retention_Intervention_Events>;
  /** fetch aggregated fields from the table: "retention_intervention_events" */
  retention_intervention_events_aggregate: Retention_Intervention_Events_Aggregate;
  /** fetch data from the table: "retention_intervention_events" using primary key columns */
  retention_intervention_events_by_pk?: Maybe<Retention_Intervention_Events>;
  /** fetch data from the table in a streaming manner: "retention_intervention_events" */
  retention_intervention_events_stream: Array<Retention_Intervention_Events>;
  /** fetch data from the table: "retention_intervention_sessions" */
  retention_intervention_sessions: Array<Retention_Intervention_Sessions>;
  /** fetch aggregated fields from the table: "retention_intervention_sessions" */
  retention_intervention_sessions_aggregate: Retention_Intervention_Sessions_Aggregate;
  /** fetch data from the table: "retention_intervention_sessions" using primary key columns */
  retention_intervention_sessions_by_pk?: Maybe<Retention_Intervention_Sessions>;
  /** fetch data from the table in a streaming manner: "retention_intervention_sessions" */
  retention_intervention_sessions_stream: Array<Retention_Intervention_Sessions>;
  /** fetch data from the table: "retention_notification_deliveries" */
  retention_notification_deliveries: Array<Retention_Notification_Deliveries>;
  /** fetch aggregated fields from the table: "retention_notification_deliveries" */
  retention_notification_deliveries_aggregate: Retention_Notification_Deliveries_Aggregate;
  /** fetch data from the table: "retention_notification_deliveries" using primary key columns */
  retention_notification_deliveries_by_pk?: Maybe<Retention_Notification_Deliveries>;
  /** fetch data from the table in a streaming manner: "retention_notification_deliveries" */
  retention_notification_deliveries_stream: Array<Retention_Notification_Deliveries>;
  /** fetch data from the table: "retention_offer_exposures" */
  retention_offer_exposures: Array<Retention_Offer_Exposures>;
  /** fetch aggregated fields from the table: "retention_offer_exposures" */
  retention_offer_exposures_aggregate: Retention_Offer_Exposures_Aggregate;
  /** fetch data from the table: "retention_offer_exposures" using primary key columns */
  retention_offer_exposures_by_pk?: Maybe<Retention_Offer_Exposures>;
  /** fetch data from the table in a streaming manner: "retention_offer_exposures" */
  retention_offer_exposures_stream: Array<Retention_Offer_Exposures>;
  /** An array relationship */
  sales: Array<Sales>;
  /** An aggregate relationship */
  sales_aggregate: Sales_Aggregate;
  /** fetch data from the table: "sales" using primary key columns */
  sales_by_pk?: Maybe<Sales>;
  /** fetch data from the table in a streaming manner: "sales" */
  sales_stream: Array<Sales>;
  /** fetch data from the table: "subscription_entitlements" */
  subscription_entitlements: Array<Subscription_Entitlements>;
  /** fetch aggregated fields from the table: "subscription_entitlements" */
  subscription_entitlements_aggregate: Subscription_Entitlements_Aggregate;
  /** fetch data from the table: "subscription_entitlements" using primary key columns */
  subscription_entitlements_by_pk?: Maybe<Subscription_Entitlements>;
  /** fetch data from the table in a streaming manner: "subscription_entitlements" */
  subscription_entitlements_stream: Array<Subscription_Entitlements>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** fetch data from the table in a streaming manner: "subscriptions" */
  subscriptions_stream: Array<Subscriptions>;
  /** fetch data from the table: "test_oct2023" */
  test_oct2023: Array<Test_Oct2023>;
  /** fetch aggregated fields from the table: "test_oct2023" */
  test_oct2023_aggregate: Test_Oct2023_Aggregate;
  /** fetch data from the table: "test_oct2023" using primary key columns */
  test_oct2023_by_pk?: Maybe<Test_Oct2023>;
  /** fetch data from the table in a streaming manner: "test_oct2023" */
  test_oct2023_stream: Array<Test_Oct2023>;
  /** fetch data from the table: "ticker_details" */
  ticker_details: Array<Ticker_Details>;
  /** fetch aggregated fields from the table: "ticker_details" */
  ticker_details_aggregate: Ticker_Details_Aggregate;
  /** fetch data from the table: "ticker_details" using primary key columns */
  ticker_details_by_pk?: Maybe<Ticker_Details>;
  /** fetch data from the table in a streaming manner: "ticker_details" */
  ticker_details_stream: Array<Ticker_Details>;
  /** fetch data from the table: "ticker_equity_print_flow" */
  ticker_equity_print_flow: Array<Ticker_Equity_Print_Flow>;
  /** fetch aggregated fields from the table: "ticker_equity_print_flow" */
  ticker_equity_print_flow_aggregate: Ticker_Equity_Print_Flow_Aggregate;
  /** fetch data from the table in a streaming manner: "ticker_equity_print_flow" */
  ticker_equity_print_flow_stream: Array<Ticker_Equity_Print_Flow>;
  /** fetch data from the table: "ticker_option_flow" */
  ticker_option_flow: Array<Ticker_Option_Flow>;
  /** fetch aggregated fields from the table: "ticker_option_flow" */
  ticker_option_flow_aggregate: Ticker_Option_Flow_Aggregate;
  /** fetch data from the table: "ticker_option_flow_all_sides" */
  ticker_option_flow_all_sides: Array<Ticker_Option_Flow_All_Sides>;
  /** fetch aggregated fields from the table: "ticker_option_flow_all_sides" */
  ticker_option_flow_all_sides_aggregate: Ticker_Option_Flow_All_Sides_Aggregate;
  /** fetch data from the table in a streaming manner: "ticker_option_flow_all_sides" */
  ticker_option_flow_all_sides_stream: Array<Ticker_Option_Flow_All_Sides>;
  /** fetch data from the table in a streaming manner: "ticker_option_flow" */
  ticker_option_flow_stream: Array<Ticker_Option_Flow>;
  /** fetch data from the table: "ticker_research_all_views" */
  ticker_research_all_views: Array<Ticker_Research_All_Views>;
  /** fetch aggregated fields from the table: "ticker_research_all_views" */
  ticker_research_all_views_aggregate: Ticker_Research_All_Views_Aggregate;
  /** fetch data from the table: "ticker_research_all_views" using primary key columns */
  ticker_research_all_views_by_pk?: Maybe<Ticker_Research_All_Views>;
  /** fetch data from the table: "ticker_research_all_views_counts" */
  ticker_research_all_views_counts: Array<Ticker_Research_All_Views_Counts>;
  /** fetch aggregated fields from the table: "ticker_research_all_views_counts" */
  ticker_research_all_views_counts_aggregate: Ticker_Research_All_Views_Counts_Aggregate;
  /** fetch data from the table in a streaming manner: "ticker_research_all_views_counts" */
  ticker_research_all_views_counts_stream: Array<Ticker_Research_All_Views_Counts>;
  /** fetch data from the table in a streaming manner: "ticker_research_all_views" */
  ticker_research_all_views_stream: Array<Ticker_Research_All_Views>;
  /** fetch data from the table: "ticker_research_daily_views" */
  ticker_research_daily_views: Array<Ticker_Research_Daily_Views>;
  /** fetch aggregated fields from the table: "ticker_research_daily_views" */
  ticker_research_daily_views_aggregate: Ticker_Research_Daily_Views_Aggregate;
  /** fetch data from the table: "ticker_research_daily_views" using primary key columns */
  ticker_research_daily_views_by_pk?: Maybe<Ticker_Research_Daily_Views>;
  /** fetch data from the table in a streaming manner: "ticker_research_daily_views" */
  ticker_research_daily_views_stream: Array<Ticker_Research_Daily_Views>;
  /** fetch data from the table: "timezone_location" */
  timezone_location: Array<Timezone_Location>;
  /** fetch aggregated fields from the table: "timezone_location" */
  timezone_location_aggregate: Timezone_Location_Aggregate;
  /** fetch data from the table: "timezone_location" using primary key columns */
  timezone_location_by_pk?: Maybe<Timezone_Location>;
  /** fetch data from the table in a streaming manner: "timezone_location" */
  timezone_location_stream: Array<Timezone_Location>;
  /** fetch data from the table: "top_tickers" */
  top_tickers: Array<Top_Tickers>;
  /** fetch aggregated fields from the table: "top_tickers" */
  top_tickers_aggregate: Top_Tickers_Aggregate;
  /** fetch data from the table: "top_tickers" using primary key columns */
  top_tickers_by_pk?: Maybe<Top_Tickers>;
  /** fetch data from the table in a streaming manner: "top_tickers" */
  top_tickers_stream: Array<Top_Tickers>;
  /** fetch data from the table: "usage_ping" */
  usage_ping: Array<Usage_Ping>;
  /** fetch aggregated fields from the table: "usage_ping" */
  usage_ping_aggregate: Usage_Ping_Aggregate;
  /** fetch data from the table: "usage_ping" using primary key columns */
  usage_ping_by_pk?: Maybe<Usage_Ping>;
  /** fetch data from the table in a streaming manner: "usage_ping" */
  usage_ping_stream: Array<Usage_Ping>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "watch_list" */
  watch_list: Array<Watch_List>;
  /** fetch aggregated fields from the table: "watch_list" */
  watch_list_aggregate: Watch_List_Aggregate;
  /** fetch data from the table: "watch_list" using primary key columns */
  watch_list_by_pk?: Maybe<Watch_List>;
  /** fetch data from the table in a streaming manner: "watch_list" */
  watch_list_stream: Array<Watch_List>;
  /** fetch data from the table: "weekly_option_flow" */
  weekly_option_flow: Array<Weekly_Option_Flow>;
  /** fetch aggregated fields from the table: "weekly_option_flow" */
  weekly_option_flow_aggregate: Weekly_Option_Flow_Aggregate;
  /** fetch data from the table: "weekly_option_flow_all_sides" */
  weekly_option_flow_all_sides: Array<Weekly_Option_Flow_All_Sides>;
  /** fetch aggregated fields from the table: "weekly_option_flow_all_sides" */
  weekly_option_flow_all_sides_aggregate: Weekly_Option_Flow_All_Sides_Aggregate;
  /** fetch data from the table in a streaming manner: "weekly_option_flow_all_sides" */
  weekly_option_flow_all_sides_stream: Array<Weekly_Option_Flow_All_Sides>;
  /** fetch data from the table in a streaming manner: "weekly_option_flow" */
  weekly_option_flow_stream: Array<Weekly_Option_Flow>;
};


export type Subscription_RootActive_Option_TickersArgs = {
  distinct_on?: InputMaybe<Array<Active_Option_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Option_Tickers_Order_By>>;
  where?: InputMaybe<Active_Option_Tickers_Bool_Exp>;
};


export type Subscription_RootActive_Option_Tickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Active_Option_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Option_Tickers_Order_By>>;
  where?: InputMaybe<Active_Option_Tickers_Bool_Exp>;
};


export type Subscription_RootActive_Option_Tickers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Active_Option_Tickers_Stream_Cursor_Input>>;
  where?: InputMaybe<Active_Option_Tickers_Bool_Exp>;
};


export type Subscription_RootAffiliate_Link_ClicksArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Link_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Link_Clicks_Order_By>>;
  where?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
};


export type Subscription_RootAffiliate_Link_Clicks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Link_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Link_Clicks_Order_By>>;
  where?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
};


export type Subscription_RootAffiliate_Link_Clicks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAffiliate_Link_Clicks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Affiliate_Link_Clicks_Stream_Cursor_Input>>;
  where?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
};


export type Subscription_RootAffiliate_PayoutsArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Payouts_Order_By>>;
  where?: InputMaybe<Affiliate_Payouts_Bool_Exp>;
};


export type Subscription_RootAffiliate_Payouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Payouts_Order_By>>;
  where?: InputMaybe<Affiliate_Payouts_Bool_Exp>;
};


export type Subscription_RootAffiliate_Payouts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAffiliate_Payouts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Affiliate_Payouts_Stream_Cursor_Input>>;
  where?: InputMaybe<Affiliate_Payouts_Bool_Exp>;
};


export type Subscription_RootAffiliate_Referral_Click_CountsArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Order_By>>;
  where?: InputMaybe<Affiliate_Referral_Click_Counts_Bool_Exp>;
};


export type Subscription_RootAffiliate_Referral_Click_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Order_By>>;
  where?: InputMaybe<Affiliate_Referral_Click_Counts_Bool_Exp>;
};


export type Subscription_RootAffiliate_Referral_Click_Counts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Affiliate_Referral_Click_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Affiliate_Referral_Click_Counts_Bool_Exp>;
};


export type Subscription_RootAsset_Signal_AlertsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Signal_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Signal_Alerts_Order_By>>;
  where?: InputMaybe<Asset_Signal_Alerts_Bool_Exp>;
};


export type Subscription_RootAsset_Signal_Alerts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Signal_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Signal_Alerts_Order_By>>;
  where?: InputMaybe<Asset_Signal_Alerts_Bool_Exp>;
};


export type Subscription_RootAsset_Signal_Alerts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAsset_Signal_Alerts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Asset_Signal_Alerts_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Signal_Alerts_Bool_Exp>;
};


export type Subscription_RootChargesArgs = {
  distinct_on?: InputMaybe<Array<Charges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Charges_Order_By>>;
  where?: InputMaybe<Charges_Bool_Exp>;
};


export type Subscription_RootCharges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Charges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Charges_Order_By>>;
  where?: InputMaybe<Charges_Bool_Exp>;
};


export type Subscription_RootCharges_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCharges_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Charges_Stream_Cursor_Input>>;
  where?: InputMaybe<Charges_Bool_Exp>;
};


export type Subscription_RootCongress_TradesArgs = {
  distinct_on?: InputMaybe<Array<Congress_Trades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Congress_Trades_Order_By>>;
  where?: InputMaybe<Congress_Trades_Bool_Exp>;
};


export type Subscription_RootCongress_Trades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Congress_Trades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Congress_Trades_Order_By>>;
  where?: InputMaybe<Congress_Trades_Bool_Exp>;
};


export type Subscription_RootCongress_Trades_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCongress_Trades_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Congress_Trades_Stream_Cursor_Input>>;
  where?: InputMaybe<Congress_Trades_Bool_Exp>;
};


export type Subscription_RootCookie_StringsArgs = {
  distinct_on?: InputMaybe<Array<Cookie_Strings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cookie_Strings_Order_By>>;
  where?: InputMaybe<Cookie_Strings_Bool_Exp>;
};


export type Subscription_RootCookie_Strings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cookie_Strings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cookie_Strings_Order_By>>;
  where?: InputMaybe<Cookie_Strings_Bool_Exp>;
};


export type Subscription_RootCookie_Strings_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCookie_Strings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cookie_Strings_Stream_Cursor_Input>>;
  where?: InputMaybe<Cookie_Strings_Bool_Exp>;
};


export type Subscription_RootCourse_ProgressArgs = {
  distinct_on?: InputMaybe<Array<Course_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Progress_Order_By>>;
  where?: InputMaybe<Course_Progress_Bool_Exp>;
};


export type Subscription_RootCourse_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Progress_Order_By>>;
  where?: InputMaybe<Course_Progress_Bool_Exp>;
};


export type Subscription_RootCourse_Progress_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Progress_StatusArgs = {
  distinct_on?: InputMaybe<Array<Course_Progress_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Progress_Status_Order_By>>;
  where?: InputMaybe<Course_Progress_Status_Bool_Exp>;
};


export type Subscription_RootCourse_Progress_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Progress_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Progress_Status_Order_By>>;
  where?: InputMaybe<Course_Progress_Status_Bool_Exp>;
};


export type Subscription_RootCourse_Progress_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCourse_Progress_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Progress_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Progress_Status_Bool_Exp>;
};


export type Subscription_RootCourse_Progress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Progress_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Progress_Bool_Exp>;
};


export type Subscription_RootDaily_Averages_Exclude_TodayArgs = {
  distinct_on?: InputMaybe<Array<Daily_Averages_Exclude_Today_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Averages_Exclude_Today_Order_By>>;
  where?: InputMaybe<Daily_Averages_Exclude_Today_Bool_Exp>;
};


export type Subscription_RootDaily_Averages_Exclude_Today_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Averages_Exclude_Today_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Averages_Exclude_Today_Order_By>>;
  where?: InputMaybe<Daily_Averages_Exclude_Today_Bool_Exp>;
};


export type Subscription_RootDaily_Averages_Exclude_Today_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Daily_Averages_Exclude_Today_Stream_Cursor_Input>>;
  where?: InputMaybe<Daily_Averages_Exclude_Today_Bool_Exp>;
};


export type Subscription_RootDaily_Averages_Include_TodayArgs = {
  distinct_on?: InputMaybe<Array<Daily_Averages_Include_Today_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Averages_Include_Today_Order_By>>;
  where?: InputMaybe<Daily_Averages_Include_Today_Bool_Exp>;
};


export type Subscription_RootDaily_Averages_Include_Today_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Averages_Include_Today_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Averages_Include_Today_Order_By>>;
  where?: InputMaybe<Daily_Averages_Include_Today_Bool_Exp>;
};


export type Subscription_RootDaily_Averages_Include_Today_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Daily_Averages_Include_Today_Stream_Cursor_Input>>;
  where?: InputMaybe<Daily_Averages_Include_Today_Bool_Exp>;
};


export type Subscription_RootDaily_VolumeArgs = {
  distinct_on?: InputMaybe<Array<Daily_Volume_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Volume_Order_By>>;
  where?: InputMaybe<Daily_Volume_Bool_Exp>;
};


export type Subscription_RootDaily_Volume_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Volume_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Daily_Volume_Order_By>>;
  where?: InputMaybe<Daily_Volume_Bool_Exp>;
};


export type Subscription_RootDaily_Volume_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Daily_Volume_Stream_Cursor_Input>>;
  where?: InputMaybe<Daily_Volume_Bool_Exp>;
};


export type Subscription_RootDark_Pool_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Dark_Pool_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Pool_Levels_Order_By>>;
  where?: InputMaybe<Dark_Pool_Levels_Bool_Exp>;
};


export type Subscription_RootDark_Pool_Levels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dark_Pool_Levels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Pool_Levels_Order_By>>;
  where?: InputMaybe<Dark_Pool_Levels_Bool_Exp>;
};


export type Subscription_RootDark_Pool_Levels_MonthlyArgs = {
  distinct_on?: InputMaybe<Array<Dark_Pool_Levels_Monthly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Pool_Levels_Monthly_Order_By>>;
  where?: InputMaybe<Dark_Pool_Levels_Monthly_Bool_Exp>;
};


export type Subscription_RootDark_Pool_Levels_Monthly_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dark_Pool_Levels_Monthly_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Pool_Levels_Monthly_Order_By>>;
  where?: InputMaybe<Dark_Pool_Levels_Monthly_Bool_Exp>;
};


export type Subscription_RootDark_Pool_Levels_Monthly_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dark_Pool_Levels_Monthly_Stream_Cursor_Input>>;
  where?: InputMaybe<Dark_Pool_Levels_Monthly_Bool_Exp>;
};


export type Subscription_RootDark_Pool_Levels_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dark_Pool_Levels_Stream_Cursor_Input>>;
  where?: InputMaybe<Dark_Pool_Levels_Bool_Exp>;
};


export type Subscription_RootDemo_Filtered_Trades_SpiderrockArgs = {
  distinct_on?: InputMaybe<Array<Demo_Filtered_Trades_Spiderrock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demo_Filtered_Trades_Spiderrock_Order_By>>;
  where?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Bool_Exp>;
};


export type Subscription_RootDemo_Filtered_Trades_Spiderrock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demo_Filtered_Trades_Spiderrock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demo_Filtered_Trades_Spiderrock_Order_By>>;
  where?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Bool_Exp>;
};


export type Subscription_RootDemo_Filtered_Trades_Spiderrock_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDemo_Filtered_Trades_Spiderrock_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Demo_Filtered_Trades_Spiderrock_Stream_Cursor_Input>>;
  where?: InputMaybe<Demo_Filtered_Trades_Spiderrock_Bool_Exp>;
};


export type Subscription_RootDemo_Raw_Trades_SpiderrockArgs = {
  distinct_on?: InputMaybe<Array<Demo_Raw_Trades_Spiderrock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demo_Raw_Trades_Spiderrock_Order_By>>;
  where?: InputMaybe<Demo_Raw_Trades_Spiderrock_Bool_Exp>;
};


export type Subscription_RootDemo_Raw_Trades_Spiderrock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demo_Raw_Trades_Spiderrock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demo_Raw_Trades_Spiderrock_Order_By>>;
  where?: InputMaybe<Demo_Raw_Trades_Spiderrock_Bool_Exp>;
};


export type Subscription_RootDemo_Raw_Trades_Spiderrock_By_PkArgs = {
  prtNumber: Scalars['bigint'];
};


export type Subscription_RootDemo_Raw_Trades_Spiderrock_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Demo_Raw_Trades_Spiderrock_Stream_Cursor_Input>>;
  where?: InputMaybe<Demo_Raw_Trades_Spiderrock_Bool_Exp>;
};


export type Subscription_RootEarnings_SnpArgs = {
  distinct_on?: InputMaybe<Array<Earnings_Snp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Earnings_Snp_Order_By>>;
  where?: InputMaybe<Earnings_Snp_Bool_Exp>;
};


export type Subscription_RootEarnings_Snp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Earnings_Snp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Earnings_Snp_Order_By>>;
  where?: InputMaybe<Earnings_Snp_Bool_Exp>;
};


export type Subscription_RootEarnings_Snp_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEarnings_Snp_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Earnings_Snp_Stream_Cursor_Input>>;
  where?: InputMaybe<Earnings_Snp_Bool_Exp>;
};


export type Subscription_RootEmail_AlertsArgs = {
  distinct_on?: InputMaybe<Array<Email_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Alerts_Order_By>>;
  where?: InputMaybe<Email_Alerts_Bool_Exp>;
};


export type Subscription_RootEmail_Alerts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Alerts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Alerts_Order_By>>;
  where?: InputMaybe<Email_Alerts_Bool_Exp>;
};


export type Subscription_RootEmail_Alerts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmail_Alerts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Alerts_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Alerts_Bool_Exp>;
};


export type Subscription_RootEmail_ListArgs = {
  distinct_on?: InputMaybe<Array<Email_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_List_Order_By>>;
  where?: InputMaybe<Email_List_Bool_Exp>;
};


export type Subscription_RootEmail_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_List_Order_By>>;
  where?: InputMaybe<Email_List_Bool_Exp>;
};


export type Subscription_RootEmail_List_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmail_List_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_List_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_List_Bool_Exp>;
};


export type Subscription_RootEquities_EodArgs = {
  distinct_on?: InputMaybe<Array<Equities_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equities_Eod_Order_By>>;
  where?: InputMaybe<Equities_Eod_Bool_Exp>;
};


export type Subscription_RootEquities_Eod_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Equities_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equities_Eod_Order_By>>;
  where?: InputMaybe<Equities_Eod_Bool_Exp>;
};


export type Subscription_RootEquities_Eod_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEquities_Eod_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Equities_Eod_Stream_Cursor_Input>>;
  where?: InputMaybe<Equities_Eod_Bool_Exp>;
};


export type Subscription_RootEquity_Pool_PrintsArgs = {
  distinct_on?: InputMaybe<Array<Equity_Pool_Prints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Pool_Prints_Order_By>>;
  where?: InputMaybe<Equity_Pool_Prints_Bool_Exp>;
};


export type Subscription_RootEquity_Pool_Prints_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Equity_Pool_Prints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Pool_Prints_Order_By>>;
  where?: InputMaybe<Equity_Pool_Prints_Bool_Exp>;
};


export type Subscription_RootEquity_Pool_Prints_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEquity_Pool_Prints_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Equity_Pool_Prints_Stream_Cursor_Input>>;
  where?: InputMaybe<Equity_Pool_Prints_Bool_Exp>;
};


export type Subscription_RootEquity_Print_Feed_BaselineArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Feed_Baseline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Feed_Baseline_Order_By>>;
  where?: InputMaybe<Equity_Print_Feed_Baseline_Bool_Exp>;
};


export type Subscription_RootEquity_Print_Feed_Baseline_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Feed_Baseline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Feed_Baseline_Order_By>>;
  where?: InputMaybe<Equity_Print_Feed_Baseline_Bool_Exp>;
};


export type Subscription_RootEquity_Print_Feed_Baseline_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEquity_Print_Feed_Baseline_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Equity_Print_Feed_Baseline_Stream_Cursor_Input>>;
  where?: InputMaybe<Equity_Print_Feed_Baseline_Bool_Exp>;
};


export type Subscription_RootEquity_Print_Feed_FilteredArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Feed_Filtered_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Feed_Filtered_Order_By>>;
  where?: InputMaybe<Equity_Print_Feed_Filtered_Bool_Exp>;
};


export type Subscription_RootEquity_Print_Feed_Filtered_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Feed_Filtered_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Feed_Filtered_Order_By>>;
  where?: InputMaybe<Equity_Print_Feed_Filtered_Bool_Exp>;
};


export type Subscription_RootEquity_Print_Feed_Filtered_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEquity_Print_Feed_Filtered_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Equity_Print_Feed_Filtered_Stream_Cursor_Input>>;
  where?: InputMaybe<Equity_Print_Feed_Filtered_Bool_Exp>;
};


export type Subscription_RootEquity_Print_FlowArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootEquity_Print_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootEquity_Print_Flow_FullArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Flow_Full_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Flow_Full_Order_By>>;
  where?: InputMaybe<Equity_Print_Flow_Full_Bool_Exp>;
};


export type Subscription_RootEquity_Print_Flow_Full_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Equity_Print_Flow_Full_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Equity_Print_Flow_Full_Order_By>>;
  where?: InputMaybe<Equity_Print_Flow_Full_Bool_Exp>;
};


export type Subscription_RootEquity_Print_Flow_Full_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Equity_Print_Flow_Full_Stream_Cursor_Input>>;
  where?: InputMaybe<Equity_Print_Flow_Full_Bool_Exp>;
};


export type Subscription_RootEquity_Print_Flow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Equity_Print_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootFa_Call_Moving_AverageArgs = {
  distinct_on?: InputMaybe<Array<Fa_Call_Moving_Average_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Call_Moving_Average_Order_By>>;
  where?: InputMaybe<Fa_Call_Moving_Average_Bool_Exp>;
};


export type Subscription_RootFa_Call_Moving_Average_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fa_Call_Moving_Average_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Call_Moving_Average_Order_By>>;
  where?: InputMaybe<Fa_Call_Moving_Average_Bool_Exp>;
};


export type Subscription_RootFa_Call_Moving_Average_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fa_Call_Moving_Average_Stream_Cursor_Input>>;
  where?: InputMaybe<Fa_Call_Moving_Average_Bool_Exp>;
};


export type Subscription_RootFa_Put_Moving_AverageArgs = {
  distinct_on?: InputMaybe<Array<Fa_Put_Moving_Average_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Put_Moving_Average_Order_By>>;
  where?: InputMaybe<Fa_Put_Moving_Average_Bool_Exp>;
};


export type Subscription_RootFa_Put_Moving_Average_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fa_Put_Moving_Average_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Put_Moving_Average_Order_By>>;
  where?: InputMaybe<Fa_Put_Moving_Average_Bool_Exp>;
};


export type Subscription_RootFa_Put_Moving_Average_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fa_Put_Moving_Average_Stream_Cursor_Input>>;
  where?: InputMaybe<Fa_Put_Moving_Average_Bool_Exp>;
};


export type Subscription_RootFa_Trade_UploadsArgs = {
  distinct_on?: InputMaybe<Array<Fa_Trade_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Trade_Uploads_Order_By>>;
  where?: InputMaybe<Fa_Trade_Uploads_Bool_Exp>;
};


export type Subscription_RootFa_Trade_Uploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fa_Trade_Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Trade_Uploads_Order_By>>;
  where?: InputMaybe<Fa_Trade_Uploads_Bool_Exp>;
};


export type Subscription_RootFa_Trade_Uploads_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFa_Trade_Uploads_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fa_Trade_Uploads_Stream_Cursor_Input>>;
  where?: InputMaybe<Fa_Trade_Uploads_Bool_Exp>;
};


export type Subscription_RootFa_TradesArgs = {
  distinct_on?: InputMaybe<Array<Fa_Trades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Trades_Order_By>>;
  where?: InputMaybe<Fa_Trades_Bool_Exp>;
};


export type Subscription_RootFa_Trades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fa_Trades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fa_Trades_Order_By>>;
  where?: InputMaybe<Fa_Trades_Bool_Exp>;
};


export type Subscription_RootFa_Trades_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFa_Trades_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fa_Trades_Stream_Cursor_Input>>;
  where?: InputMaybe<Fa_Trades_Bool_Exp>;
};


export type Subscription_RootFeedback_BoardsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Boards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Boards_Order_By>>;
  where?: InputMaybe<Feedback_Boards_Bool_Exp>;
};


export type Subscription_RootFeedback_Boards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Boards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Boards_Order_By>>;
  where?: InputMaybe<Feedback_Boards_Bool_Exp>;
};


export type Subscription_RootFeedback_Boards_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFeedback_Boards_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Boards_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Boards_Bool_Exp>;
};


export type Subscription_RootFeedback_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Comments_Order_By>>;
  where?: InputMaybe<Feedback_Comments_Bool_Exp>;
};


export type Subscription_RootFeedback_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Comments_Order_By>>;
  where?: InputMaybe<Feedback_Comments_Bool_Exp>;
};


export type Subscription_RootFeedback_Comments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFeedback_Comments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Comments_Bool_Exp>;
};


export type Subscription_RootFeedback_MediaArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Media_Order_By>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};


export type Subscription_RootFeedback_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Media_Order_By>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};


export type Subscription_RootFeedback_Media_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFeedback_Media_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Media_Bool_Exp>;
};


export type Subscription_RootFeedback_Post_ContextsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Post_Contexts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Post_Contexts_Order_By>>;
  where?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
};


export type Subscription_RootFeedback_Post_Contexts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Post_Contexts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Post_Contexts_Order_By>>;
  where?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
};


export type Subscription_RootFeedback_Post_Contexts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFeedback_Post_Contexts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Post_Contexts_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Post_Contexts_Bool_Exp>;
};


export type Subscription_RootFeedback_Post_MergesArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Post_Merges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Post_Merges_Order_By>>;
  where?: InputMaybe<Feedback_Post_Merges_Bool_Exp>;
};


export type Subscription_RootFeedback_Post_Merges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Post_Merges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Post_Merges_Order_By>>;
  where?: InputMaybe<Feedback_Post_Merges_Bool_Exp>;
};


export type Subscription_RootFeedback_Post_Merges_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFeedback_Post_Merges_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Post_Merges_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Post_Merges_Bool_Exp>;
};


export type Subscription_RootFeedback_PostsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_Bool_Exp>;
};


export type Subscription_RootFeedback_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_Bool_Exp>;
};


export type Subscription_RootFeedback_Posts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFeedback_Posts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Posts_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Posts_Bool_Exp>;
};


export type Subscription_RootFeedback_Posts_With_CountsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_With_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_With_Counts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_With_Counts_Bool_Exp>;
};


export type Subscription_RootFeedback_Posts_With_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Posts_With_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Posts_With_Counts_Order_By>>;
  where?: InputMaybe<Feedback_Posts_With_Counts_Bool_Exp>;
};


export type Subscription_RootFeedback_Posts_With_Counts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Posts_With_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Posts_With_Counts_Bool_Exp>;
};


export type Subscription_RootFeedback_Release_PostsArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Release_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Release_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
};


export type Subscription_RootFeedback_Release_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Release_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Release_Posts_Order_By>>;
  where?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
};


export type Subscription_RootFeedback_Release_Posts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFeedback_Release_Posts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Release_Posts_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Release_Posts_Bool_Exp>;
};


export type Subscription_RootFeedback_ReleasesArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Releases_Order_By>>;
  where?: InputMaybe<Feedback_Releases_Bool_Exp>;
};


export type Subscription_RootFeedback_Releases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Releases_Order_By>>;
  where?: InputMaybe<Feedback_Releases_Bool_Exp>;
};


export type Subscription_RootFeedback_Releases_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFeedback_Releases_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Releases_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Releases_Bool_Exp>;
};


export type Subscription_RootFeedback_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Statuses_Order_By>>;
  where?: InputMaybe<Feedback_Statuses_Bool_Exp>;
};


export type Subscription_RootFeedback_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Statuses_Order_By>>;
  where?: InputMaybe<Feedback_Statuses_Bool_Exp>;
};


export type Subscription_RootFeedback_Statuses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFeedback_Statuses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Statuses_Bool_Exp>;
};


export type Subscription_RootFeedback_VotesArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Votes_Order_By>>;
  where?: InputMaybe<Feedback_Votes_Bool_Exp>;
};


export type Subscription_RootFeedback_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Votes_Order_By>>;
  where?: InputMaybe<Feedback_Votes_Bool_Exp>;
};


export type Subscription_RootFeedback_Votes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFeedback_Votes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Votes_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Votes_Bool_Exp>;
};


export type Subscription_RootFlow_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Flow_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Flow_Configurations_Order_By>>;
  where?: InputMaybe<Flow_Configurations_Bool_Exp>;
};


export type Subscription_RootFlow_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flow_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Flow_Configurations_Order_By>>;
  where?: InputMaybe<Flow_Configurations_Bool_Exp>;
};


export type Subscription_RootFlow_Configurations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFlow_Configurations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Flow_Configurations_Stream_Cursor_Input>>;
  where?: InputMaybe<Flow_Configurations_Bool_Exp>;
};


export type Subscription_RootFree_Equity_Print_FlowArgs = {
  distinct_on?: InputMaybe<Array<Free_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Free_Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootFree_Equity_Print_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Free_Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootFree_Equity_Print_Flow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Free_Equity_Print_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Free_Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootFree_Option_FlowArgs = {
  distinct_on?: InputMaybe<Array<Free_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Option_Flow_Order_By>>;
  where?: InputMaybe<Free_Option_Flow_Bool_Exp>;
};


export type Subscription_RootFree_Option_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Option_Flow_Order_By>>;
  where?: InputMaybe<Free_Option_Flow_Bool_Exp>;
};


export type Subscription_RootFree_Option_Flow_All_SidesArgs = {
  distinct_on?: InputMaybe<Array<Free_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Free_Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootFree_Option_Flow_All_Sides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Free_Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootFree_Option_Flow_All_Sides_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Free_Option_Flow_All_Sides_Stream_Cursor_Input>>;
  where?: InputMaybe<Free_Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootFree_Option_Flow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Free_Option_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Free_Option_Flow_Bool_Exp>;
};


export type Subscription_RootFree_Ticker_Equity_Print_FlowArgs = {
  distinct_on?: InputMaybe<Array<Free_Ticker_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Ticker_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Free_Ticker_Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootFree_Ticker_Equity_Print_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Ticker_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Ticker_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Free_Ticker_Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootFree_Ticker_Equity_Print_Flow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Free_Ticker_Equity_Print_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Free_Ticker_Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootFree_Ticker_Option_FlowArgs = {
  distinct_on?: InputMaybe<Array<Free_Ticker_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Ticker_Option_Flow_Order_By>>;
  where?: InputMaybe<Free_Ticker_Option_Flow_Bool_Exp>;
};


export type Subscription_RootFree_Ticker_Option_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Ticker_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Ticker_Option_Flow_Order_By>>;
  where?: InputMaybe<Free_Ticker_Option_Flow_Bool_Exp>;
};


export type Subscription_RootFree_Ticker_Option_Flow_All_SidesArgs = {
  distinct_on?: InputMaybe<Array<Free_Ticker_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Ticker_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Free_Ticker_Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootFree_Ticker_Option_Flow_All_Sides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Free_Ticker_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Free_Ticker_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Free_Ticker_Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootFree_Ticker_Option_Flow_All_Sides_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Free_Ticker_Option_Flow_All_Sides_Stream_Cursor_Input>>;
  where?: InputMaybe<Free_Ticker_Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootFree_Ticker_Option_Flow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Free_Ticker_Option_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Free_Ticker_Option_Flow_Bool_Exp>;
};


export type Subscription_RootFull_Feed_Equity_Print_FlowArgs = {
  distinct_on?: InputMaybe<Array<Full_Feed_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Feed_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Full_Feed_Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootFull_Feed_Equity_Print_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Full_Feed_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Feed_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Full_Feed_Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootFull_Feed_Equity_Print_Flow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Full_Feed_Equity_Print_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Full_Feed_Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootFull_Feed_Option_FlowArgs = {
  distinct_on?: InputMaybe<Array<Full_Feed_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Feed_Option_Flow_Order_By>>;
  where?: InputMaybe<Full_Feed_Option_Flow_Bool_Exp>;
};


export type Subscription_RootFull_Feed_Option_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Full_Feed_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Feed_Option_Flow_Order_By>>;
  where?: InputMaybe<Full_Feed_Option_Flow_Bool_Exp>;
};


export type Subscription_RootFull_Feed_Option_Flow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Full_Feed_Option_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Full_Feed_Option_Flow_Bool_Exp>;
};


export type Subscription_RootHealth_ChecksArgs = {
  distinct_on?: InputMaybe<Array<Health_Checks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Health_Checks_Order_By>>;
  where?: InputMaybe<Health_Checks_Bool_Exp>;
};


export type Subscription_RootHealth_Checks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Health_Checks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Health_Checks_Order_By>>;
  where?: InputMaybe<Health_Checks_Bool_Exp>;
};


export type Subscription_RootHealth_Checks_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootHealth_Checks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Health_Checks_Stream_Cursor_Input>>;
  where?: InputMaybe<Health_Checks_Bool_Exp>;
};


export type Subscription_RootInsider_TradesArgs = {
  distinct_on?: InputMaybe<Array<Insider_Trades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Insider_Trades_Order_By>>;
  where?: InputMaybe<Insider_Trades_Bool_Exp>;
};


export type Subscription_RootInsider_Trades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insider_Trades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Insider_Trades_Order_By>>;
  where?: InputMaybe<Insider_Trades_Bool_Exp>;
};


export type Subscription_RootInsider_Trades_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInsider_Trades_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Insider_Trades_Stream_Cursor_Input>>;
  where?: InputMaybe<Insider_Trades_Bool_Exp>;
};


export type Subscription_RootInsider_Trades_Top_LongArgs = {
  distinct_on?: InputMaybe<Array<Insider_Trades_Top_Long_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Insider_Trades_Top_Long_Order_By>>;
  where?: InputMaybe<Insider_Trades_Top_Long_Bool_Exp>;
};


export type Subscription_RootInsider_Trades_Top_Long_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insider_Trades_Top_Long_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Insider_Trades_Top_Long_Order_By>>;
  where?: InputMaybe<Insider_Trades_Top_Long_Bool_Exp>;
};


export type Subscription_RootInsider_Trades_Top_Long_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Insider_Trades_Top_Long_Stream_Cursor_Input>>;
  where?: InputMaybe<Insider_Trades_Top_Long_Bool_Exp>;
};


export type Subscription_RootInsider_Trades_Top_ShortArgs = {
  distinct_on?: InputMaybe<Array<Insider_Trades_Top_Short_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Insider_Trades_Top_Short_Order_By>>;
  where?: InputMaybe<Insider_Trades_Top_Short_Bool_Exp>;
};


export type Subscription_RootInsider_Trades_Top_Short_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insider_Trades_Top_Short_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Insider_Trades_Top_Short_Order_By>>;
  where?: InputMaybe<Insider_Trades_Top_Short_Bool_Exp>;
};


export type Subscription_RootInsider_Trades_Top_Short_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Insider_Trades_Top_Short_Stream_Cursor_Input>>;
  where?: InputMaybe<Insider_Trades_Top_Short_Bool_Exp>;
};


export type Subscription_RootInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootInvoices_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInvoices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invoices_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootMicrosoft_Access_TokensArgs = {
  distinct_on?: InputMaybe<Array<Microsoft_Access_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Microsoft_Access_Tokens_Order_By>>;
  where?: InputMaybe<Microsoft_Access_Tokens_Bool_Exp>;
};


export type Subscription_RootMicrosoft_Access_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Microsoft_Access_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Microsoft_Access_Tokens_Order_By>>;
  where?: InputMaybe<Microsoft_Access_Tokens_Bool_Exp>;
};


export type Subscription_RootMicrosoft_Access_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMicrosoft_Access_Tokens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Microsoft_Access_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Microsoft_Access_Tokens_Bool_Exp>;
};


export type Subscription_RootMost_Researched_Tickers_Daily_TotalArgs = {
  distinct_on?: InputMaybe<Array<Most_Researched_Tickers_Daily_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Most_Researched_Tickers_Daily_Total_Order_By>>;
  where?: InputMaybe<Most_Researched_Tickers_Daily_Total_Bool_Exp>;
};


export type Subscription_RootMost_Researched_Tickers_Daily_Total_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Most_Researched_Tickers_Daily_Total_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Most_Researched_Tickers_Daily_Total_Order_By>>;
  where?: InputMaybe<Most_Researched_Tickers_Daily_Total_Bool_Exp>;
};


export type Subscription_RootMost_Researched_Tickers_Daily_Total_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Most_Researched_Tickers_Daily_Total_Stream_Cursor_Input>>;
  where?: InputMaybe<Most_Researched_Tickers_Daily_Total_Bool_Exp>;
};


export type Subscription_RootMost_Researched_Tickers_Daily_UniqueArgs = {
  distinct_on?: InputMaybe<Array<Most_Researched_Tickers_Daily_Unique_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Most_Researched_Tickers_Daily_Unique_Order_By>>;
  where?: InputMaybe<Most_Researched_Tickers_Daily_Unique_Bool_Exp>;
};


export type Subscription_RootMost_Researched_Tickers_Daily_Unique_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Most_Researched_Tickers_Daily_Unique_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Most_Researched_Tickers_Daily_Unique_Order_By>>;
  where?: InputMaybe<Most_Researched_Tickers_Daily_Unique_Bool_Exp>;
};


export type Subscription_RootMost_Researched_Tickers_Daily_Unique_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Most_Researched_Tickers_Daily_Unique_Stream_Cursor_Input>>;
  where?: InputMaybe<Most_Researched_Tickers_Daily_Unique_Bool_Exp>;
};


export type Subscription_RootNews_Cache_StocksArgs = {
  distinct_on?: InputMaybe<Array<News_Cache_Stocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<News_Cache_Stocks_Order_By>>;
  where?: InputMaybe<News_Cache_Stocks_Bool_Exp>;
};


export type Subscription_RootNews_Cache_Stocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<News_Cache_Stocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<News_Cache_Stocks_Order_By>>;
  where?: InputMaybe<News_Cache_Stocks_Bool_Exp>;
};


export type Subscription_RootNews_Cache_Stocks_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNews_Cache_Stocks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<News_Cache_Stocks_Stream_Cursor_Input>>;
  where?: InputMaybe<News_Cache_Stocks_Bool_Exp>;
};


export type Subscription_RootNewsletter_PayloadsArgs = {
  distinct_on?: InputMaybe<Array<Newsletter_Payloads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Newsletter_Payloads_Order_By>>;
  where?: InputMaybe<Newsletter_Payloads_Bool_Exp>;
};


export type Subscription_RootNewsletter_Payloads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Newsletter_Payloads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Newsletter_Payloads_Order_By>>;
  where?: InputMaybe<Newsletter_Payloads_Bool_Exp>;
};


export type Subscription_RootNewsletter_Payloads_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNewsletter_Payloads_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Newsletter_Payloads_Stream_Cursor_Input>>;
  where?: InputMaybe<Newsletter_Payloads_Bool_Exp>;
};


export type Subscription_RootOpc_Saved_StrategiesArgs = {
  distinct_on?: InputMaybe<Array<Opc_Saved_Strategies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opc_Saved_Strategies_Order_By>>;
  where?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
};


export type Subscription_RootOpc_Saved_Strategies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Opc_Saved_Strategies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opc_Saved_Strategies_Order_By>>;
  where?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
};


export type Subscription_RootOpc_Saved_Strategies_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOpc_Saved_Strategies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Opc_Saved_Strategies_Stream_Cursor_Input>>;
  where?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
};


export type Subscription_RootOpc_Saved_Strategy_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Order_By>>;
  where?: InputMaybe<Opc_Saved_Strategy_Positions_Bool_Exp>;
};


export type Subscription_RootOpc_Saved_Strategy_Positions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opc_Saved_Strategy_Positions_Order_By>>;
  where?: InputMaybe<Opc_Saved_Strategy_Positions_Bool_Exp>;
};


export type Subscription_RootOpc_Saved_Strategy_Positions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOpc_Saved_Strategy_Positions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Opc_Saved_Strategy_Positions_Stream_Cursor_Input>>;
  where?: InputMaybe<Opc_Saved_Strategy_Positions_Bool_Exp>;
};


export type Subscription_RootOption_Feed_BaselineArgs = {
  distinct_on?: InputMaybe<Array<Option_Feed_Baseline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Feed_Baseline_Order_By>>;
  where?: InputMaybe<Option_Feed_Baseline_Bool_Exp>;
};


export type Subscription_RootOption_Feed_Baseline_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Option_Feed_Baseline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Feed_Baseline_Order_By>>;
  where?: InputMaybe<Option_Feed_Baseline_Bool_Exp>;
};


export type Subscription_RootOption_Feed_Baseline_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOption_Feed_Baseline_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Option_Feed_Baseline_Stream_Cursor_Input>>;
  where?: InputMaybe<Option_Feed_Baseline_Bool_Exp>;
};


export type Subscription_RootOption_Feed_FilteredArgs = {
  distinct_on?: InputMaybe<Array<Option_Feed_Filtered_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Feed_Filtered_Order_By>>;
  where?: InputMaybe<Option_Feed_Filtered_Bool_Exp>;
};


export type Subscription_RootOption_Feed_Filtered_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Option_Feed_Filtered_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Feed_Filtered_Order_By>>;
  where?: InputMaybe<Option_Feed_Filtered_Bool_Exp>;
};


export type Subscription_RootOption_Feed_Filtered_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOption_Feed_Filtered_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Option_Feed_Filtered_Stream_Cursor_Input>>;
  where?: InputMaybe<Option_Feed_Filtered_Bool_Exp>;
};


export type Subscription_RootOption_FlowArgs = {
  distinct_on?: InputMaybe<Array<Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Flow_Order_By>>;
  where?: InputMaybe<Option_Flow_Bool_Exp>;
};


export type Subscription_RootOption_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Flow_Order_By>>;
  where?: InputMaybe<Option_Flow_Bool_Exp>;
};


export type Subscription_RootOption_Flow_All_SidesArgs = {
  distinct_on?: InputMaybe<Array<Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootOption_Flow_All_Sides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootOption_Flow_All_Sides_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Option_Flow_All_Sides_Stream_Cursor_Input>>;
  where?: InputMaybe<Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootOption_Flow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Option_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Option_Flow_Bool_Exp>;
};


export type Subscription_RootOptions_EodArgs = {
  distinct_on?: InputMaybe<Array<Options_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Options_Eod_Order_By>>;
  where?: InputMaybe<Options_Eod_Bool_Exp>;
};


export type Subscription_RootOptions_Eod_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Options_Eod_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Options_Eod_Order_By>>;
  where?: InputMaybe<Options_Eod_Bool_Exp>;
};


export type Subscription_RootOptions_Eod_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOptions_Eod_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Options_Eod_Stream_Cursor_Input>>;
  where?: InputMaybe<Options_Eod_Bool_Exp>;
};


export type Subscription_RootPrelaunch_Email_ListArgs = {
  distinct_on?: InputMaybe<Array<Prelaunch_Email_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prelaunch_Email_List_Order_By>>;
  where?: InputMaybe<Prelaunch_Email_List_Bool_Exp>;
};


export type Subscription_RootPrelaunch_Email_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prelaunch_Email_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prelaunch_Email_List_Order_By>>;
  where?: InputMaybe<Prelaunch_Email_List_Bool_Exp>;
};


export type Subscription_RootPrelaunch_Email_List_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPrelaunch_Email_List_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Prelaunch_Email_List_Stream_Cursor_Input>>;
  where?: InputMaybe<Prelaunch_Email_List_Bool_Exp>;
};


export type Subscription_RootReady_CheckArgs = {
  distinct_on?: InputMaybe<Array<Ready_Check_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ready_Check_Order_By>>;
  where?: InputMaybe<Ready_Check_Bool_Exp>;
};


export type Subscription_RootReady_Check_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ready_Check_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ready_Check_Order_By>>;
  where?: InputMaybe<Ready_Check_Bool_Exp>;
};


export type Subscription_RootReady_Check_By_PkArgs = {
  isReady: Scalars['Boolean'];
};


export type Subscription_RootReady_Check_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ready_Check_Stream_Cursor_Input>>;
  where?: InputMaybe<Ready_Check_Bool_Exp>;
};


export type Subscription_RootRetention_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Retention_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Feedback_Order_By>>;
  where?: InputMaybe<Retention_Feedback_Bool_Exp>;
};


export type Subscription_RootRetention_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Feedback_Order_By>>;
  where?: InputMaybe<Retention_Feedback_Bool_Exp>;
};


export type Subscription_RootRetention_Feedback_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRetention_Feedback_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Retention_Feedback_Stream_Cursor_Input>>;
  where?: InputMaybe<Retention_Feedback_Bool_Exp>;
};


export type Subscription_RootRetention_Intervention_EventsArgs = {
  distinct_on?: InputMaybe<Array<Retention_Intervention_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Intervention_Events_Order_By>>;
  where?: InputMaybe<Retention_Intervention_Events_Bool_Exp>;
};


export type Subscription_RootRetention_Intervention_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Intervention_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Intervention_Events_Order_By>>;
  where?: InputMaybe<Retention_Intervention_Events_Bool_Exp>;
};


export type Subscription_RootRetention_Intervention_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRetention_Intervention_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Retention_Intervention_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Retention_Intervention_Events_Bool_Exp>;
};


export type Subscription_RootRetention_Intervention_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Retention_Intervention_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Intervention_Sessions_Order_By>>;
  where?: InputMaybe<Retention_Intervention_Sessions_Bool_Exp>;
};


export type Subscription_RootRetention_Intervention_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Intervention_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Intervention_Sessions_Order_By>>;
  where?: InputMaybe<Retention_Intervention_Sessions_Bool_Exp>;
};


export type Subscription_RootRetention_Intervention_Sessions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRetention_Intervention_Sessions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Retention_Intervention_Sessions_Stream_Cursor_Input>>;
  where?: InputMaybe<Retention_Intervention_Sessions_Bool_Exp>;
};


export type Subscription_RootRetention_Notification_DeliveriesArgs = {
  distinct_on?: InputMaybe<Array<Retention_Notification_Deliveries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Notification_Deliveries_Order_By>>;
  where?: InputMaybe<Retention_Notification_Deliveries_Bool_Exp>;
};


export type Subscription_RootRetention_Notification_Deliveries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Notification_Deliveries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Notification_Deliveries_Order_By>>;
  where?: InputMaybe<Retention_Notification_Deliveries_Bool_Exp>;
};


export type Subscription_RootRetention_Notification_Deliveries_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRetention_Notification_Deliveries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Retention_Notification_Deliveries_Stream_Cursor_Input>>;
  where?: InputMaybe<Retention_Notification_Deliveries_Bool_Exp>;
};


export type Subscription_RootRetention_Offer_ExposuresArgs = {
  distinct_on?: InputMaybe<Array<Retention_Offer_Exposures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Offer_Exposures_Order_By>>;
  where?: InputMaybe<Retention_Offer_Exposures_Bool_Exp>;
};


export type Subscription_RootRetention_Offer_Exposures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Retention_Offer_Exposures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Retention_Offer_Exposures_Order_By>>;
  where?: InputMaybe<Retention_Offer_Exposures_Bool_Exp>;
};


export type Subscription_RootRetention_Offer_Exposures_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRetention_Offer_Exposures_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Retention_Offer_Exposures_Stream_Cursor_Input>>;
  where?: InputMaybe<Retention_Offer_Exposures_Bool_Exp>;
};


export type Subscription_RootSalesArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


export type Subscription_RootSales_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


export type Subscription_RootSales_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSales_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sales_Stream_Cursor_Input>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


export type Subscription_RootSubscription_EntitlementsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Entitlements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Entitlements_Order_By>>;
  where?: InputMaybe<Subscription_Entitlements_Bool_Exp>;
};


export type Subscription_RootSubscription_Entitlements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Entitlements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscription_Entitlements_Order_By>>;
  where?: InputMaybe<Subscription_Entitlements_Bool_Exp>;
};


export type Subscription_RootSubscription_Entitlements_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootSubscription_Entitlements_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Subscription_Entitlements_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscription_Entitlements_Bool_Exp>;
};


export type Subscription_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubscriptions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootTest_Oct2023Args = {
  distinct_on?: InputMaybe<Array<Test_Oct2023_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Oct2023_Order_By>>;
  where?: InputMaybe<Test_Oct2023_Bool_Exp>;
};


export type Subscription_RootTest_Oct2023_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Oct2023_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Oct2023_Order_By>>;
  where?: InputMaybe<Test_Oct2023_Bool_Exp>;
};


export type Subscription_RootTest_Oct2023_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTest_Oct2023_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Test_Oct2023_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_Oct2023_Bool_Exp>;
};


export type Subscription_RootTicker_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Details_Order_By>>;
  where?: InputMaybe<Ticker_Details_Bool_Exp>;
};


export type Subscription_RootTicker_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Details_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Details_Order_By>>;
  where?: InputMaybe<Ticker_Details_Bool_Exp>;
};


export type Subscription_RootTicker_Details_By_PkArgs = {
  ticker: Scalars['String'];
};


export type Subscription_RootTicker_Details_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ticker_Details_Stream_Cursor_Input>>;
  where?: InputMaybe<Ticker_Details_Bool_Exp>;
};


export type Subscription_RootTicker_Equity_Print_FlowArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Ticker_Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootTicker_Equity_Print_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Equity_Print_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Equity_Print_Flow_Order_By>>;
  where?: InputMaybe<Ticker_Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootTicker_Equity_Print_Flow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ticker_Equity_Print_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Ticker_Equity_Print_Flow_Bool_Exp>;
};


export type Subscription_RootTicker_Option_FlowArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Option_Flow_Order_By>>;
  where?: InputMaybe<Ticker_Option_Flow_Bool_Exp>;
};


export type Subscription_RootTicker_Option_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Option_Flow_Order_By>>;
  where?: InputMaybe<Ticker_Option_Flow_Bool_Exp>;
};


export type Subscription_RootTicker_Option_Flow_All_SidesArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Ticker_Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootTicker_Option_Flow_All_Sides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Ticker_Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootTicker_Option_Flow_All_Sides_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ticker_Option_Flow_All_Sides_Stream_Cursor_Input>>;
  where?: InputMaybe<Ticker_Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootTicker_Option_Flow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ticker_Option_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Ticker_Option_Flow_Bool_Exp>;
};


export type Subscription_RootTicker_Research_All_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_All_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_All_Views_Order_By>>;
  where?: InputMaybe<Ticker_Research_All_Views_Bool_Exp>;
};


export type Subscription_RootTicker_Research_All_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_All_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_All_Views_Order_By>>;
  where?: InputMaybe<Ticker_Research_All_Views_Bool_Exp>;
};


export type Subscription_RootTicker_Research_All_Views_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTicker_Research_All_Views_CountsArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_All_Views_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_All_Views_Counts_Order_By>>;
  where?: InputMaybe<Ticker_Research_All_Views_Counts_Bool_Exp>;
};


export type Subscription_RootTicker_Research_All_Views_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_All_Views_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_All_Views_Counts_Order_By>>;
  where?: InputMaybe<Ticker_Research_All_Views_Counts_Bool_Exp>;
};


export type Subscription_RootTicker_Research_All_Views_Counts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ticker_Research_All_Views_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Ticker_Research_All_Views_Counts_Bool_Exp>;
};


export type Subscription_RootTicker_Research_All_Views_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ticker_Research_All_Views_Stream_Cursor_Input>>;
  where?: InputMaybe<Ticker_Research_All_Views_Bool_Exp>;
};


export type Subscription_RootTicker_Research_Daily_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_Daily_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_Daily_Views_Order_By>>;
  where?: InputMaybe<Ticker_Research_Daily_Views_Bool_Exp>;
};


export type Subscription_RootTicker_Research_Daily_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_Daily_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_Daily_Views_Order_By>>;
  where?: InputMaybe<Ticker_Research_Daily_Views_Bool_Exp>;
};


export type Subscription_RootTicker_Research_Daily_Views_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTicker_Research_Daily_Views_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ticker_Research_Daily_Views_Stream_Cursor_Input>>;
  where?: InputMaybe<Ticker_Research_Daily_Views_Bool_Exp>;
};


export type Subscription_RootTimezone_LocationArgs = {
  distinct_on?: InputMaybe<Array<Timezone_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Timezone_Location_Order_By>>;
  where?: InputMaybe<Timezone_Location_Bool_Exp>;
};


export type Subscription_RootTimezone_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Timezone_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Timezone_Location_Order_By>>;
  where?: InputMaybe<Timezone_Location_Bool_Exp>;
};


export type Subscription_RootTimezone_Location_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootTimezone_Location_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Timezone_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Timezone_Location_Bool_Exp>;
};


export type Subscription_RootTop_TickersArgs = {
  distinct_on?: InputMaybe<Array<Top_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Top_Tickers_Order_By>>;
  where?: InputMaybe<Top_Tickers_Bool_Exp>;
};


export type Subscription_RootTop_Tickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Top_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Top_Tickers_Order_By>>;
  where?: InputMaybe<Top_Tickers_Bool_Exp>;
};


export type Subscription_RootTop_Tickers_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootTop_Tickers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Top_Tickers_Stream_Cursor_Input>>;
  where?: InputMaybe<Top_Tickers_Bool_Exp>;
};


export type Subscription_RootUsage_PingArgs = {
  distinct_on?: InputMaybe<Array<Usage_Ping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Usage_Ping_Order_By>>;
  where?: InputMaybe<Usage_Ping_Bool_Exp>;
};


export type Subscription_RootUsage_Ping_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Usage_Ping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Usage_Ping_Order_By>>;
  where?: InputMaybe<Usage_Ping_Bool_Exp>;
};


export type Subscription_RootUsage_Ping_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsage_Ping_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Usage_Ping_Stream_Cursor_Input>>;
  where?: InputMaybe<Usage_Ping_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootWatch_ListArgs = {
  distinct_on?: InputMaybe<Array<Watch_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Watch_List_Order_By>>;
  where?: InputMaybe<Watch_List_Bool_Exp>;
};


export type Subscription_RootWatch_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Watch_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Watch_List_Order_By>>;
  where?: InputMaybe<Watch_List_Bool_Exp>;
};


export type Subscription_RootWatch_List_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWatch_List_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Watch_List_Stream_Cursor_Input>>;
  where?: InputMaybe<Watch_List_Bool_Exp>;
};


export type Subscription_RootWeekly_Option_FlowArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


export type Subscription_RootWeekly_Option_Flow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


export type Subscription_RootWeekly_Option_Flow_All_SidesArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootWeekly_Option_Flow_All_Sides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_All_Sides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_All_Sides_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootWeekly_Option_Flow_All_Sides_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Weekly_Option_Flow_All_Sides_Stream_Cursor_Input>>;
  where?: InputMaybe<Weekly_Option_Flow_All_Sides_Bool_Exp>;
};


export type Subscription_RootWeekly_Option_Flow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Weekly_Option_Flow_Stream_Cursor_Input>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};

/** columns and relationships of "subscriptions" */
export type Subscriptions = {
  __typename?: 'subscriptions';
  /** An object relationship */
  affiliateLinkClick?: Maybe<Affiliate_Link_Clicks>;
  affiliateLinkClickId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  affiliateUser?: Maybe<Users>;
  affiliateUserId?: Maybe<Scalars['String']>;
  apiAccountId?: Maybe<Scalars['uuid']>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  currentPeriodEndsAt?: Maybe<Scalars['timestamptz']>;
  endedAt?: Maybe<Scalars['timestamptz']>;
  externalSubscriptionId: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  priceId?: Maybe<Scalars['String']>;
  /** An array relationship */
  sales: Array<Sales>;
  /** An aggregate relationship */
  sales_aggregate: Sales_Aggregate;
  status: Scalars['String'];
  stripeCustomerId: Scalars['String'];
  subscriptionObject: Scalars['jsonb'];
  trialEndAt?: Maybe<Scalars['timestamptz']>;
  trialStartAt?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsSalesArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsSales_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsSubscriptionObjectArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "subscriptions" */
export type Subscriptions_Aggregate = {
  __typename?: 'subscriptions_aggregate';
  aggregate?: Maybe<Subscriptions_Aggregate_Fields>;
  nodes: Array<Subscriptions>;
};

export type Subscriptions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Count>;
};

export type Subscriptions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscriptions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscriptions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_Fields = {
  __typename?: 'subscriptions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Subscriptions_Max_Fields>;
  min?: Maybe<Subscriptions_Min_Fields>;
};


/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subscriptions" */
export type Subscriptions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Subscriptions_Append_Input = {
  subscriptionObject?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "subscriptions" */
export type Subscriptions_Arr_Rel_Insert_Input = {
  data: Array<Subscriptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "subscriptions". All fields are combined with a logical 'AND'. */
export type Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  affiliateLinkClick?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
  affiliateLinkClickId?: InputMaybe<Uuid_Comparison_Exp>;
  affiliateUser?: InputMaybe<Users_Bool_Exp>;
  affiliateUserId?: InputMaybe<String_Comparison_Exp>;
  apiAccountId?: InputMaybe<Uuid_Comparison_Exp>;
  cancelAtPeriodEnd?: InputMaybe<Boolean_Comparison_Exp>;
  canceledAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentPeriodEndsAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  externalSubscriptionId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoices?: InputMaybe<Invoices_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Bool_Exp>;
  priceId?: InputMaybe<String_Comparison_Exp>;
  sales?: InputMaybe<Sales_Bool_Exp>;
  sales_aggregate?: InputMaybe<Sales_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  stripeCustomerId?: InputMaybe<String_Comparison_Exp>;
  subscriptionObject?: InputMaybe<Jsonb_Comparison_Exp>;
  trialEndAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  trialStartAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions" */
export const Subscriptions_Constraint = {
  /** unique or primary key constraint on columns "externalSubscriptionId" */
  SubscriptionsExternalSubscriptionIdKey: 'subscriptions_externalSubscriptionId_key',
  /** unique or primary key constraint on columns "id" */
  SubscriptionsPkey: 'subscriptions_pkey'
} as const;

export type Subscriptions_Constraint = typeof Subscriptions_Constraint[keyof typeof Subscriptions_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Subscriptions_Delete_At_Path_Input = {
  subscriptionObject?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Subscriptions_Delete_Elem_Input = {
  subscriptionObject?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Subscriptions_Delete_Key_Input = {
  subscriptionObject?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "subscriptions" */
export type Subscriptions_Insert_Input = {
  affiliateLinkClick?: InputMaybe<Affiliate_Link_Clicks_Obj_Rel_Insert_Input>;
  affiliateLinkClickId?: InputMaybe<Scalars['uuid']>;
  affiliateUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  affiliateUserId?: InputMaybe<Scalars['String']>;
  apiAccountId?: InputMaybe<Scalars['uuid']>;
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodEndsAt?: InputMaybe<Scalars['timestamptz']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoices?: InputMaybe<Invoices_Arr_Rel_Insert_Input>;
  priceId?: InputMaybe<Scalars['String']>;
  sales?: InputMaybe<Sales_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  subscriptionObject?: InputMaybe<Scalars['jsonb']>;
  trialEndAt?: InputMaybe<Scalars['timestamptz']>;
  trialStartAt?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Subscriptions_Max_Fields = {
  __typename?: 'subscriptions_max_fields';
  affiliateLinkClickId?: Maybe<Scalars['uuid']>;
  affiliateUserId?: Maybe<Scalars['String']>;
  apiAccountId?: Maybe<Scalars['uuid']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentPeriodEndsAt?: Maybe<Scalars['timestamptz']>;
  endedAt?: Maybe<Scalars['timestamptz']>;
  externalSubscriptionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  priceId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  trialEndAt?: Maybe<Scalars['timestamptz']>;
  trialStartAt?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "subscriptions" */
export type Subscriptions_Max_Order_By = {
  affiliateLinkClickId?: InputMaybe<Order_By>;
  affiliateUserId?: InputMaybe<Order_By>;
  apiAccountId?: InputMaybe<Order_By>;
  canceledAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentPeriodEndsAt?: InputMaybe<Order_By>;
  endedAt?: InputMaybe<Order_By>;
  externalSubscriptionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  priceId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  trialEndAt?: InputMaybe<Order_By>;
  trialStartAt?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscriptions_Min_Fields = {
  __typename?: 'subscriptions_min_fields';
  affiliateLinkClickId?: Maybe<Scalars['uuid']>;
  affiliateUserId?: Maybe<Scalars['String']>;
  apiAccountId?: Maybe<Scalars['uuid']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentPeriodEndsAt?: Maybe<Scalars['timestamptz']>;
  endedAt?: Maybe<Scalars['timestamptz']>;
  externalSubscriptionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  priceId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  trialEndAt?: Maybe<Scalars['timestamptz']>;
  trialStartAt?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "subscriptions" */
export type Subscriptions_Min_Order_By = {
  affiliateLinkClickId?: InputMaybe<Order_By>;
  affiliateUserId?: InputMaybe<Order_By>;
  apiAccountId?: InputMaybe<Order_By>;
  canceledAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentPeriodEndsAt?: InputMaybe<Order_By>;
  endedAt?: InputMaybe<Order_By>;
  externalSubscriptionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  priceId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  trialEndAt?: InputMaybe<Order_By>;
  trialStartAt?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions" */
export type Subscriptions_Mutation_Response = {
  __typename?: 'subscriptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions>;
};

/** input type for inserting object relation for remote table "subscriptions" */
export type Subscriptions_Obj_Rel_Insert_Input = {
  data: Subscriptions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};

/** on_conflict condition type for table "subscriptions" */
export type Subscriptions_On_Conflict = {
  constraint: Subscriptions_Constraint;
  update_columns?: Array<Subscriptions_Update_Column>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions". */
export type Subscriptions_Order_By = {
  affiliateLinkClick?: InputMaybe<Affiliate_Link_Clicks_Order_By>;
  affiliateLinkClickId?: InputMaybe<Order_By>;
  affiliateUser?: InputMaybe<Users_Order_By>;
  affiliateUserId?: InputMaybe<Order_By>;
  apiAccountId?: InputMaybe<Order_By>;
  cancelAtPeriodEnd?: InputMaybe<Order_By>;
  canceledAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentPeriodEndsAt?: InputMaybe<Order_By>;
  endedAt?: InputMaybe<Order_By>;
  externalSubscriptionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Order_By>;
  priceId?: InputMaybe<Order_By>;
  sales_aggregate?: InputMaybe<Sales_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  subscriptionObject?: InputMaybe<Order_By>;
  trialEndAt?: InputMaybe<Order_By>;
  trialStartAt?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions */
export type Subscriptions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Subscriptions_Prepend_Input = {
  subscriptionObject?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "subscriptions" */
export const Subscriptions_Select_Column = {
  /** column name */
  AffiliateLinkClickId: 'affiliateLinkClickId',
  /** column name */
  AffiliateUserId: 'affiliateUserId',
  /** column name */
  ApiAccountId: 'apiAccountId',
  /** column name */
  CancelAtPeriodEnd: 'cancelAtPeriodEnd',
  /** column name */
  CanceledAt: 'canceledAt',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentPeriodEndsAt: 'currentPeriodEndsAt',
  /** column name */
  EndedAt: 'endedAt',
  /** column name */
  ExternalSubscriptionId: 'externalSubscriptionId',
  /** column name */
  Id: 'id',
  /** column name */
  PriceId: 'priceId',
  /** column name */
  Status: 'status',
  /** column name */
  StripeCustomerId: 'stripeCustomerId',
  /** column name */
  SubscriptionObject: 'subscriptionObject',
  /** column name */
  TrialEndAt: 'trialEndAt',
  /** column name */
  TrialStartAt: 'trialStartAt',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Subscriptions_Select_Column = typeof Subscriptions_Select_Column[keyof typeof Subscriptions_Select_Column];
/** select "subscriptions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscriptions" */
export const Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  CancelAtPeriodEnd: 'cancelAtPeriodEnd'
} as const;

export type Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "subscriptions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscriptions" */
export const Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  CancelAtPeriodEnd: 'cancelAtPeriodEnd'
} as const;

export type Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "subscriptions" */
export type Subscriptions_Set_Input = {
  affiliateLinkClickId?: InputMaybe<Scalars['uuid']>;
  affiliateUserId?: InputMaybe<Scalars['String']>;
  apiAccountId?: InputMaybe<Scalars['uuid']>;
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodEndsAt?: InputMaybe<Scalars['timestamptz']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  subscriptionObject?: InputMaybe<Scalars['jsonb']>;
  trialEndAt?: InputMaybe<Scalars['timestamptz']>;
  trialStartAt?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "subscriptions" */
export type Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Stream_Cursor_Value_Input = {
  affiliateLinkClickId?: InputMaybe<Scalars['uuid']>;
  affiliateUserId?: InputMaybe<Scalars['String']>;
  apiAccountId?: InputMaybe<Scalars['uuid']>;
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentPeriodEndsAt?: InputMaybe<Scalars['timestamptz']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  priceId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  subscriptionObject?: InputMaybe<Scalars['jsonb']>;
  trialEndAt?: InputMaybe<Scalars['timestamptz']>;
  trialStartAt?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "subscriptions" */
export const Subscriptions_Update_Column = {
  /** column name */
  AffiliateLinkClickId: 'affiliateLinkClickId',
  /** column name */
  AffiliateUserId: 'affiliateUserId',
  /** column name */
  ApiAccountId: 'apiAccountId',
  /** column name */
  CancelAtPeriodEnd: 'cancelAtPeriodEnd',
  /** column name */
  CanceledAt: 'canceledAt',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentPeriodEndsAt: 'currentPeriodEndsAt',
  /** column name */
  EndedAt: 'endedAt',
  /** column name */
  ExternalSubscriptionId: 'externalSubscriptionId',
  /** column name */
  Id: 'id',
  /** column name */
  PriceId: 'priceId',
  /** column name */
  Status: 'status',
  /** column name */
  StripeCustomerId: 'stripeCustomerId',
  /** column name */
  SubscriptionObject: 'subscriptionObject',
  /** column name */
  TrialEndAt: 'trialEndAt',
  /** column name */
  TrialStartAt: 'trialStartAt',
  /** column name */
  Type: 'type',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Subscriptions_Update_Column = typeof Subscriptions_Update_Column[keyof typeof Subscriptions_Update_Column];
export type Subscriptions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Subscriptions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Subscriptions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Subscriptions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Subscriptions_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Subscriptions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Bool_Exp;
};

/** columns and relationships of "test_oct2023" */
export type Test_Oct2023 = {
  __typename?: 'test_oct2023';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "test_oct2023" */
export type Test_Oct2023_Aggregate = {
  __typename?: 'test_oct2023_aggregate';
  aggregate?: Maybe<Test_Oct2023_Aggregate_Fields>;
  nodes: Array<Test_Oct2023>;
};

/** aggregate fields of "test_oct2023" */
export type Test_Oct2023_Aggregate_Fields = {
  __typename?: 'test_oct2023_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Test_Oct2023_Max_Fields>;
  min?: Maybe<Test_Oct2023_Min_Fields>;
};


/** aggregate fields of "test_oct2023" */
export type Test_Oct2023_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_Oct2023_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "test_oct2023". All fields are combined with a logical 'AND'. */
export type Test_Oct2023_Bool_Exp = {
  _and?: InputMaybe<Array<Test_Oct2023_Bool_Exp>>;
  _not?: InputMaybe<Test_Oct2023_Bool_Exp>;
  _or?: InputMaybe<Array<Test_Oct2023_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "test_oct2023" */
export const Test_Oct2023_Constraint = {
  /** unique or primary key constraint on columns "id" */
  TestOct2023Pkey: 'test_oct2023_pkey'
} as const;

export type Test_Oct2023_Constraint = typeof Test_Oct2023_Constraint[keyof typeof Test_Oct2023_Constraint];
/** input type for inserting data into table "test_oct2023" */
export type Test_Oct2023_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Test_Oct2023_Max_Fields = {
  __typename?: 'test_oct2023_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Test_Oct2023_Min_Fields = {
  __typename?: 'test_oct2023_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "test_oct2023" */
export type Test_Oct2023_Mutation_Response = {
  __typename?: 'test_oct2023_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Test_Oct2023>;
};

/** on_conflict condition type for table "test_oct2023" */
export type Test_Oct2023_On_Conflict = {
  constraint: Test_Oct2023_Constraint;
  update_columns?: Array<Test_Oct2023_Update_Column>;
  where?: InputMaybe<Test_Oct2023_Bool_Exp>;
};

/** Ordering options when selecting data from "test_oct2023". */
export type Test_Oct2023_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: test_oct2023 */
export type Test_Oct2023_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "test_oct2023" */
export const Test_Oct2023_Select_Column = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type Test_Oct2023_Select_Column = typeof Test_Oct2023_Select_Column[keyof typeof Test_Oct2023_Select_Column];
/** input type for updating data in table "test_oct2023" */
export type Test_Oct2023_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "test_oct2023" */
export type Test_Oct2023_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_Oct2023_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_Oct2023_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "test_oct2023" */
export const Test_Oct2023_Update_Column = {
  /** column name */
  CreatedAt: 'created_at',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updated_at'
} as const;

export type Test_Oct2023_Update_Column = typeof Test_Oct2023_Update_Column[keyof typeof Test_Oct2023_Update_Column];
export type Test_Oct2023_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Test_Oct2023_Set_Input>;
  /** filter the rows which have to be updated */
  where: Test_Oct2023_Bool_Exp;
};

/** columns and relationships of "ticker_details" */
export type Ticker_Details = {
  __typename?: 'ticker_details';
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  earningsTimes: Array<Earnings_Snp>;
  /** An aggregate relationship */
  earningsTimes_aggregate: Earnings_Snp_Aggregate;
  exchangeShortName: Scalars['String'];
  industry?: Maybe<Scalars['String']>;
  ipoDate?: Maybe<Scalars['date']>;
  ipoYear?: Maybe<Scalars['Int']>;
  isActivelyTrading: Scalars['Boolean'];
  isEtf?: Maybe<Scalars['Boolean']>;
  isFund?: Maybe<Scalars['Boolean']>;
  marketCap?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  optionsEod?: Maybe<Options_Eod>;
  sector?: Maybe<Scalars['String']>;
  ticker: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "ticker_details" */
export type Ticker_DetailsEarningsTimesArgs = {
  distinct_on?: InputMaybe<Array<Earnings_Snp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Earnings_Snp_Order_By>>;
  where?: InputMaybe<Earnings_Snp_Bool_Exp>;
};


/** columns and relationships of "ticker_details" */
export type Ticker_DetailsEarningsTimes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Earnings_Snp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Earnings_Snp_Order_By>>;
  where?: InputMaybe<Earnings_Snp_Bool_Exp>;
};

/** aggregated selection of "ticker_details" */
export type Ticker_Details_Aggregate = {
  __typename?: 'ticker_details_aggregate';
  aggregate?: Maybe<Ticker_Details_Aggregate_Fields>;
  nodes: Array<Ticker_Details>;
};

/** aggregate fields of "ticker_details" */
export type Ticker_Details_Aggregate_Fields = {
  __typename?: 'ticker_details_aggregate_fields';
  avg?: Maybe<Ticker_Details_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ticker_Details_Max_Fields>;
  min?: Maybe<Ticker_Details_Min_Fields>;
  stddev?: Maybe<Ticker_Details_Stddev_Fields>;
  stddev_pop?: Maybe<Ticker_Details_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ticker_Details_Stddev_Samp_Fields>;
  sum?: Maybe<Ticker_Details_Sum_Fields>;
  var_pop?: Maybe<Ticker_Details_Var_Pop_Fields>;
  var_samp?: Maybe<Ticker_Details_Var_Samp_Fields>;
  variance?: Maybe<Ticker_Details_Variance_Fields>;
};


/** aggregate fields of "ticker_details" */
export type Ticker_Details_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ticker_Details_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ticker_Details_Avg_Fields = {
  __typename?: 'ticker_details_avg_fields';
  ipoYear?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ticker_details". All fields are combined with a logical 'AND'. */
export type Ticker_Details_Bool_Exp = {
  _and?: InputMaybe<Array<Ticker_Details_Bool_Exp>>;
  _not?: InputMaybe<Ticker_Details_Bool_Exp>;
  _or?: InputMaybe<Array<Ticker_Details_Bool_Exp>>;
  country?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  earningsTimes?: InputMaybe<Earnings_Snp_Bool_Exp>;
  earningsTimes_aggregate?: InputMaybe<Earnings_Snp_Aggregate_Bool_Exp>;
  exchangeShortName?: InputMaybe<String_Comparison_Exp>;
  industry?: InputMaybe<String_Comparison_Exp>;
  ipoDate?: InputMaybe<Date_Comparison_Exp>;
  ipoYear?: InputMaybe<Int_Comparison_Exp>;
  isActivelyTrading?: InputMaybe<Boolean_Comparison_Exp>;
  isEtf?: InputMaybe<Boolean_Comparison_Exp>;
  isFund?: InputMaybe<Boolean_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  optionsEod?: InputMaybe<Options_Eod_Bool_Exp>;
  sector?: InputMaybe<String_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ticker_details" */
export const Ticker_Details_Constraint = {
  /** unique or primary key constraint on columns "ticker" */
  TickerDetailsPkey: 'ticker_details_pkey'
} as const;

export type Ticker_Details_Constraint = typeof Ticker_Details_Constraint[keyof typeof Ticker_Details_Constraint];
/** input type for incrementing numeric columns in table "ticker_details" */
export type Ticker_Details_Inc_Input = {
  ipoYear?: InputMaybe<Scalars['Int']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "ticker_details" */
export type Ticker_Details_Insert_Input = {
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  earningsTimes?: InputMaybe<Earnings_Snp_Arr_Rel_Insert_Input>;
  exchangeShortName?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  ipoDate?: InputMaybe<Scalars['date']>;
  ipoYear?: InputMaybe<Scalars['Int']>;
  isActivelyTrading?: InputMaybe<Scalars['Boolean']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isFund?: InputMaybe<Scalars['Boolean']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  optionsEod?: InputMaybe<Options_Eod_Obj_Rel_Insert_Input>;
  sector?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ticker_Details_Max_Fields = {
  __typename?: 'ticker_details_max_fields';
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  exchangeShortName?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  ipoDate?: Maybe<Scalars['date']>;
  ipoYear?: Maybe<Scalars['Int']>;
  marketCap?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Ticker_Details_Min_Fields = {
  __typename?: 'ticker_details_min_fields';
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  exchangeShortName?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  ipoDate?: Maybe<Scalars['date']>;
  ipoYear?: Maybe<Scalars['Int']>;
  marketCap?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "ticker_details" */
export type Ticker_Details_Mutation_Response = {
  __typename?: 'ticker_details_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ticker_Details>;
};

/** input type for inserting object relation for remote table "ticker_details" */
export type Ticker_Details_Obj_Rel_Insert_Input = {
  data: Ticker_Details_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ticker_Details_On_Conflict>;
};

/** on_conflict condition type for table "ticker_details" */
export type Ticker_Details_On_Conflict = {
  constraint: Ticker_Details_Constraint;
  update_columns?: Array<Ticker_Details_Update_Column>;
  where?: InputMaybe<Ticker_Details_Bool_Exp>;
};

/** Ordering options when selecting data from "ticker_details". */
export type Ticker_Details_Order_By = {
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  earningsTimes_aggregate?: InputMaybe<Earnings_Snp_Aggregate_Order_By>;
  exchangeShortName?: InputMaybe<Order_By>;
  industry?: InputMaybe<Order_By>;
  ipoDate?: InputMaybe<Order_By>;
  ipoYear?: InputMaybe<Order_By>;
  isActivelyTrading?: InputMaybe<Order_By>;
  isEtf?: InputMaybe<Order_By>;
  isFund?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  optionsEod?: InputMaybe<Options_Eod_Order_By>;
  sector?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ticker_details */
export type Ticker_Details_Pk_Columns_Input = {
  ticker: Scalars['String'];
};

/** select columns of table "ticker_details" */
export const Ticker_Details_Select_Column = {
  /** column name */
  Country: 'country',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  ExchangeShortName: 'exchangeShortName',
  /** column name */
  Industry: 'industry',
  /** column name */
  IpoDate: 'ipoDate',
  /** column name */
  IpoYear: 'ipoYear',
  /** column name */
  IsActivelyTrading: 'isActivelyTrading',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsFund: 'isFund',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Name: 'name',
  /** column name */
  Sector: 'sector',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Ticker_Details_Select_Column = typeof Ticker_Details_Select_Column[keyof typeof Ticker_Details_Select_Column];
/** input type for updating data in table "ticker_details" */
export type Ticker_Details_Set_Input = {
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  exchangeShortName?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  ipoDate?: InputMaybe<Scalars['date']>;
  ipoYear?: InputMaybe<Scalars['Int']>;
  isActivelyTrading?: InputMaybe<Scalars['Boolean']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isFund?: InputMaybe<Scalars['Boolean']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Ticker_Details_Stddev_Fields = {
  __typename?: 'ticker_details_stddev_fields';
  ipoYear?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ticker_Details_Stddev_Pop_Fields = {
  __typename?: 'ticker_details_stddev_pop_fields';
  ipoYear?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ticker_Details_Stddev_Samp_Fields = {
  __typename?: 'ticker_details_stddev_samp_fields';
  ipoYear?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ticker_details" */
export type Ticker_Details_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticker_Details_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticker_Details_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  exchangeShortName?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  ipoDate?: InputMaybe<Scalars['date']>;
  ipoYear?: InputMaybe<Scalars['Int']>;
  isActivelyTrading?: InputMaybe<Scalars['Boolean']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isFund?: InputMaybe<Scalars['Boolean']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Ticker_Details_Sum_Fields = {
  __typename?: 'ticker_details_sum_fields';
  ipoYear?: Maybe<Scalars['Int']>;
  marketCap?: Maybe<Scalars['numeric']>;
};

/** update columns of table "ticker_details" */
export const Ticker_Details_Update_Column = {
  /** column name */
  Country: 'country',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  ExchangeShortName: 'exchangeShortName',
  /** column name */
  Industry: 'industry',
  /** column name */
  IpoDate: 'ipoDate',
  /** column name */
  IpoYear: 'ipoYear',
  /** column name */
  IsActivelyTrading: 'isActivelyTrading',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsFund: 'isFund',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Name: 'name',
  /** column name */
  Sector: 'sector',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Ticker_Details_Update_Column = typeof Ticker_Details_Update_Column[keyof typeof Ticker_Details_Update_Column];
export type Ticker_Details_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ticker_Details_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ticker_Details_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ticker_Details_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ticker_Details_Var_Pop_Fields = {
  __typename?: 'ticker_details_var_pop_fields';
  ipoYear?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ticker_Details_Var_Samp_Fields = {
  __typename?: 'ticker_details_var_samp_fields';
  ipoYear?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ticker_Details_Variance_Fields = {
  __typename?: 'ticker_details_variance_fields';
  ipoYear?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ticker_equity_print_flow" */
export type Ticker_Equity_Print_Flow = {
  __typename?: 'ticker_equity_print_flow';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  isEtf?: Maybe<Scalars['Boolean']>;
  isOutsideDailyRange?: Maybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: Maybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: Maybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: Maybe<Scalars['Boolean']>;
  isSignatureVolume?: Maybe<Scalars['Boolean']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeConditions?: Maybe<Scalars['jsonb']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "ticker_equity_print_flow" */
export type Ticker_Equity_Print_FlowTradeConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ticker_equity_print_flow" */
export type Ticker_Equity_Print_Flow_Aggregate = {
  __typename?: 'ticker_equity_print_flow_aggregate';
  aggregate?: Maybe<Ticker_Equity_Print_Flow_Aggregate_Fields>;
  nodes: Array<Ticker_Equity_Print_Flow>;
};

/** aggregate fields of "ticker_equity_print_flow" */
export type Ticker_Equity_Print_Flow_Aggregate_Fields = {
  __typename?: 'ticker_equity_print_flow_aggregate_fields';
  avg?: Maybe<Ticker_Equity_Print_Flow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ticker_Equity_Print_Flow_Max_Fields>;
  min?: Maybe<Ticker_Equity_Print_Flow_Min_Fields>;
  stddev?: Maybe<Ticker_Equity_Print_Flow_Stddev_Fields>;
  stddev_pop?: Maybe<Ticker_Equity_Print_Flow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ticker_Equity_Print_Flow_Stddev_Samp_Fields>;
  sum?: Maybe<Ticker_Equity_Print_Flow_Sum_Fields>;
  var_pop?: Maybe<Ticker_Equity_Print_Flow_Var_Pop_Fields>;
  var_samp?: Maybe<Ticker_Equity_Print_Flow_Var_Samp_Fields>;
  variance?: Maybe<Ticker_Equity_Print_Flow_Variance_Fields>;
};


/** aggregate fields of "ticker_equity_print_flow" */
export type Ticker_Equity_Print_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ticker_Equity_Print_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ticker_Equity_Print_Flow_Avg_Fields = {
  __typename?: 'ticker_equity_print_flow_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ticker_equity_print_flow". All fields are combined with a logical 'AND'. */
export type Ticker_Equity_Print_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Ticker_Equity_Print_Flow_Bool_Exp>>;
  _not?: InputMaybe<Ticker_Equity_Print_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Ticker_Equity_Print_Flow_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  ask?: InputMaybe<Numeric_Comparison_Exp>;
  askSize?: InputMaybe<Int_Comparison_Exp>;
  avgPrice?: InputMaybe<Numeric_Comparison_Exp>;
  avgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  bid?: InputMaybe<Numeric_Comparison_Exp>;
  bidSize?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  dayOverDayPercentChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayOverDayPriceChange?: InputMaybe<Numeric_Comparison_Exp>;
  dayVolume?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeId?: InputMaybe<Int_Comparison_Exp>;
  externalTradeId?: InputMaybe<String_Comparison_Exp>;
  high?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isEtf?: InputMaybe<Boolean_Comparison_Exp>;
  isOutsideDailyRange?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Boolean_Comparison_Exp>;
  isPriceGreaterThanOpen?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureEtfTicker?: InputMaybe<Boolean_Comparison_Exp>;
  isSignatureVolume?: InputMaybe<Boolean_Comparison_Exp>;
  lastTradePrice?: InputMaybe<Numeric_Comparison_Exp>;
  low?: InputMaybe<Numeric_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  open?: InputMaybe<Numeric_Comparison_Exp>;
  percentAboveAsk?: InputMaybe<Numeric_Comparison_Exp>;
  percentBelowBid?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfAvgVolume?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfMarketCap?: InputMaybe<Numeric_Comparison_Exp>;
  percentOfTodaysVolume?: InputMaybe<Numeric_Comparison_Exp>;
  prevClose?: InputMaybe<Numeric_Comparison_Exp>;
  prevHigh?: InputMaybe<Numeric_Comparison_Exp>;
  prevLow?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  realtimePrice?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  tapeId?: InputMaybe<Int_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  timestamp?: InputMaybe<Bigint_Comparison_Exp>;
  timestampIso?: InputMaybe<Timestamptz_Comparison_Exp>;
  tradeConditions?: InputMaybe<Jsonb_Comparison_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ticker_Equity_Print_Flow_Max_Fields = {
  __typename?: 'ticker_equity_print_flow_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Ticker_Equity_Print_Flow_Min_Fields = {
  __typename?: 'ticker_equity_print_flow_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  externalTradeId?: Maybe<Scalars['String']>;
  high?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  ticker?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['bigint']>;
  timestampIso?: Maybe<Scalars['timestamptz']>;
  tradeSide?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "ticker_equity_print_flow". */
export type Ticker_Equity_Print_Flow_Order_By = {
  amount?: InputMaybe<Order_By>;
  ask?: InputMaybe<Order_By>;
  askSize?: InputMaybe<Order_By>;
  avgPrice?: InputMaybe<Order_By>;
  avgVolume?: InputMaybe<Order_By>;
  bid?: InputMaybe<Order_By>;
  bidSize?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  dayOverDayPercentChange?: InputMaybe<Order_By>;
  dayOverDayPriceChange?: InputMaybe<Order_By>;
  dayVolume?: InputMaybe<Order_By>;
  exchangeId?: InputMaybe<Order_By>;
  externalTradeId?: InputMaybe<Order_By>;
  high?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isEtf?: InputMaybe<Order_By>;
  isOutsideDailyRange?: InputMaybe<Order_By>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Order_By>;
  isPriceGreaterThanOpen?: InputMaybe<Order_By>;
  isSignatureEtfTicker?: InputMaybe<Order_By>;
  isSignatureVolume?: InputMaybe<Order_By>;
  lastTradePrice?: InputMaybe<Order_By>;
  low?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  open?: InputMaybe<Order_By>;
  percentAboveAsk?: InputMaybe<Order_By>;
  percentBelowBid?: InputMaybe<Order_By>;
  percentOfAvgVolume?: InputMaybe<Order_By>;
  percentOfMarketCap?: InputMaybe<Order_By>;
  percentOfTodaysVolume?: InputMaybe<Order_By>;
  prevClose?: InputMaybe<Order_By>;
  prevHigh?: InputMaybe<Order_By>;
  prevLow?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  realtimePrice?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  tapeId?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  timestamp?: InputMaybe<Order_By>;
  timestampIso?: InputMaybe<Order_By>;
  tradeConditions?: InputMaybe<Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "ticker_equity_print_flow" */
export const Ticker_Equity_Print_Flow_Select_Column = {
  /** column name */
  Amount: 'amount',
  /** column name */
  Ask: 'ask',
  /** column name */
  AskSize: 'askSize',
  /** column name */
  AvgPrice: 'avgPrice',
  /** column name */
  AvgVolume: 'avgVolume',
  /** column name */
  Bid: 'bid',
  /** column name */
  BidSize: 'bidSize',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DayOverDayPercentChange: 'dayOverDayPercentChange',
  /** column name */
  DayOverDayPriceChange: 'dayOverDayPriceChange',
  /** column name */
  DayVolume: 'dayVolume',
  /** column name */
  ExchangeId: 'exchangeId',
  /** column name */
  ExternalTradeId: 'externalTradeId',
  /** column name */
  High: 'high',
  /** column name */
  Id: 'id',
  /** column name */
  IsEtf: 'isEtf',
  /** column name */
  IsOutsideDailyRange: 'isOutsideDailyRange',
  /** column name */
  IsPriceGreaterThanDailyAverage: 'isPriceGreaterThanDailyAverage',
  /** column name */
  IsPriceGreaterThanOpen: 'isPriceGreaterThanOpen',
  /** column name */
  IsSignatureEtfTicker: 'isSignatureEtfTicker',
  /** column name */
  IsSignatureVolume: 'isSignatureVolume',
  /** column name */
  LastTradePrice: 'lastTradePrice',
  /** column name */
  Low: 'low',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Open: 'open',
  /** column name */
  PercentAboveAsk: 'percentAboveAsk',
  /** column name */
  PercentBelowBid: 'percentBelowBid',
  /** column name */
  PercentOfAvgVolume: 'percentOfAvgVolume',
  /** column name */
  PercentOfMarketCap: 'percentOfMarketCap',
  /** column name */
  PercentOfTodaysVolume: 'percentOfTodaysVolume',
  /** column name */
  PrevClose: 'prevClose',
  /** column name */
  PrevHigh: 'prevHigh',
  /** column name */
  PrevLow: 'prevLow',
  /** column name */
  Price: 'price',
  /** column name */
  RealtimePrice: 'realtimePrice',
  /** column name */
  Size: 'size',
  /** column name */
  TapeId: 'tapeId',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  Timestamp: 'timestamp',
  /** column name */
  TimestampIso: 'timestampIso',
  /** column name */
  TradeConditions: 'tradeConditions',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Ticker_Equity_Print_Flow_Select_Column = typeof Ticker_Equity_Print_Flow_Select_Column[keyof typeof Ticker_Equity_Print_Flow_Select_Column];
/** aggregate stddev on columns */
export type Ticker_Equity_Print_Flow_Stddev_Fields = {
  __typename?: 'ticker_equity_print_flow_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ticker_Equity_Print_Flow_Stddev_Pop_Fields = {
  __typename?: 'ticker_equity_print_flow_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ticker_Equity_Print_Flow_Stddev_Samp_Fields = {
  __typename?: 'ticker_equity_print_flow_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ticker_equity_print_flow" */
export type Ticker_Equity_Print_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticker_Equity_Print_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticker_Equity_Print_Flow_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  ask?: InputMaybe<Scalars['numeric']>;
  askSize?: InputMaybe<Scalars['Int']>;
  avgPrice?: InputMaybe<Scalars['numeric']>;
  avgVolume?: InputMaybe<Scalars['numeric']>;
  bid?: InputMaybe<Scalars['numeric']>;
  bidSize?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  dayOverDayPercentChange?: InputMaybe<Scalars['numeric']>;
  dayOverDayPriceChange?: InputMaybe<Scalars['numeric']>;
  dayVolume?: InputMaybe<Scalars['numeric']>;
  exchangeId?: InputMaybe<Scalars['Int']>;
  externalTradeId?: InputMaybe<Scalars['String']>;
  high?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEtf?: InputMaybe<Scalars['Boolean']>;
  isOutsideDailyRange?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanDailyAverage?: InputMaybe<Scalars['Boolean']>;
  isPriceGreaterThanOpen?: InputMaybe<Scalars['Boolean']>;
  isSignatureEtfTicker?: InputMaybe<Scalars['Boolean']>;
  isSignatureVolume?: InputMaybe<Scalars['Boolean']>;
  lastTradePrice?: InputMaybe<Scalars['numeric']>;
  low?: InputMaybe<Scalars['numeric']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  open?: InputMaybe<Scalars['numeric']>;
  percentAboveAsk?: InputMaybe<Scalars['numeric']>;
  percentBelowBid?: InputMaybe<Scalars['numeric']>;
  percentOfAvgVolume?: InputMaybe<Scalars['numeric']>;
  percentOfMarketCap?: InputMaybe<Scalars['numeric']>;
  percentOfTodaysVolume?: InputMaybe<Scalars['numeric']>;
  prevClose?: InputMaybe<Scalars['numeric']>;
  prevHigh?: InputMaybe<Scalars['numeric']>;
  prevLow?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  realtimePrice?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  tapeId?: InputMaybe<Scalars['Int']>;
  ticker?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['bigint']>;
  timestampIso?: InputMaybe<Scalars['timestamptz']>;
  tradeConditions?: InputMaybe<Scalars['jsonb']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Ticker_Equity_Print_Flow_Sum_Fields = {
  __typename?: 'ticker_equity_print_flow_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  ask?: Maybe<Scalars['numeric']>;
  askSize?: Maybe<Scalars['Int']>;
  avgPrice?: Maybe<Scalars['numeric']>;
  avgVolume?: Maybe<Scalars['numeric']>;
  bid?: Maybe<Scalars['numeric']>;
  bidSize?: Maybe<Scalars['Int']>;
  dayOverDayPercentChange?: Maybe<Scalars['numeric']>;
  dayOverDayPriceChange?: Maybe<Scalars['numeric']>;
  dayVolume?: Maybe<Scalars['numeric']>;
  exchangeId?: Maybe<Scalars['Int']>;
  high?: Maybe<Scalars['numeric']>;
  lastTradePrice?: Maybe<Scalars['numeric']>;
  low?: Maybe<Scalars['numeric']>;
  marketCap?: Maybe<Scalars['numeric']>;
  open?: Maybe<Scalars['numeric']>;
  percentAboveAsk?: Maybe<Scalars['numeric']>;
  percentBelowBid?: Maybe<Scalars['numeric']>;
  percentOfAvgVolume?: Maybe<Scalars['numeric']>;
  percentOfMarketCap?: Maybe<Scalars['numeric']>;
  percentOfTodaysVolume?: Maybe<Scalars['numeric']>;
  prevClose?: Maybe<Scalars['numeric']>;
  prevHigh?: Maybe<Scalars['numeric']>;
  prevLow?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  realtimePrice?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  tapeId?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Ticker_Equity_Print_Flow_Var_Pop_Fields = {
  __typename?: 'ticker_equity_print_flow_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ticker_Equity_Print_Flow_Var_Samp_Fields = {
  __typename?: 'ticker_equity_print_flow_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ticker_Equity_Print_Flow_Variance_Fields = {
  __typename?: 'ticker_equity_print_flow_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  ask?: Maybe<Scalars['Float']>;
  askSize?: Maybe<Scalars['Float']>;
  avgPrice?: Maybe<Scalars['Float']>;
  avgVolume?: Maybe<Scalars['Float']>;
  bid?: Maybe<Scalars['Float']>;
  bidSize?: Maybe<Scalars['Float']>;
  dayOverDayPercentChange?: Maybe<Scalars['Float']>;
  dayOverDayPriceChange?: Maybe<Scalars['Float']>;
  dayVolume?: Maybe<Scalars['Float']>;
  exchangeId?: Maybe<Scalars['Float']>;
  high?: Maybe<Scalars['Float']>;
  lastTradePrice?: Maybe<Scalars['Float']>;
  low?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  open?: Maybe<Scalars['Float']>;
  percentAboveAsk?: Maybe<Scalars['Float']>;
  percentBelowBid?: Maybe<Scalars['Float']>;
  percentOfAvgVolume?: Maybe<Scalars['Float']>;
  percentOfMarketCap?: Maybe<Scalars['Float']>;
  percentOfTodaysVolume?: Maybe<Scalars['Float']>;
  prevClose?: Maybe<Scalars['Float']>;
  prevHigh?: Maybe<Scalars['Float']>;
  prevLow?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  realtimePrice?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  tapeId?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ticker_option_flow" */
export type Ticker_Option_Flow = {
  __typename?: 'ticker_option_flow';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtTypes?: Maybe<Scalars['jsonb']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "ticker_option_flow" */
export type Ticker_Option_FlowPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ticker_option_flow" */
export type Ticker_Option_Flow_Aggregate = {
  __typename?: 'ticker_option_flow_aggregate';
  aggregate?: Maybe<Ticker_Option_Flow_Aggregate_Fields>;
  nodes: Array<Ticker_Option_Flow>;
};

/** aggregate fields of "ticker_option_flow" */
export type Ticker_Option_Flow_Aggregate_Fields = {
  __typename?: 'ticker_option_flow_aggregate_fields';
  avg?: Maybe<Ticker_Option_Flow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ticker_Option_Flow_Max_Fields>;
  min?: Maybe<Ticker_Option_Flow_Min_Fields>;
  stddev?: Maybe<Ticker_Option_Flow_Stddev_Fields>;
  stddev_pop?: Maybe<Ticker_Option_Flow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ticker_Option_Flow_Stddev_Samp_Fields>;
  sum?: Maybe<Ticker_Option_Flow_Sum_Fields>;
  var_pop?: Maybe<Ticker_Option_Flow_Var_Pop_Fields>;
  var_samp?: Maybe<Ticker_Option_Flow_Var_Samp_Fields>;
  variance?: Maybe<Ticker_Option_Flow_Variance_Fields>;
};


/** aggregate fields of "ticker_option_flow" */
export type Ticker_Option_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ticker_Option_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "ticker_option_flow_all_sides" */
export type Ticker_Option_Flow_All_Sides = {
  __typename?: 'ticker_option_flow_all_sides';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtTypes?: Maybe<Scalars['jsonb']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "ticker_option_flow_all_sides" */
export type Ticker_Option_Flow_All_SidesPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ticker_option_flow_all_sides" */
export type Ticker_Option_Flow_All_Sides_Aggregate = {
  __typename?: 'ticker_option_flow_all_sides_aggregate';
  aggregate?: Maybe<Ticker_Option_Flow_All_Sides_Aggregate_Fields>;
  nodes: Array<Ticker_Option_Flow_All_Sides>;
};

/** aggregate fields of "ticker_option_flow_all_sides" */
export type Ticker_Option_Flow_All_Sides_Aggregate_Fields = {
  __typename?: 'ticker_option_flow_all_sides_aggregate_fields';
  avg?: Maybe<Ticker_Option_Flow_All_Sides_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ticker_Option_Flow_All_Sides_Max_Fields>;
  min?: Maybe<Ticker_Option_Flow_All_Sides_Min_Fields>;
  stddev?: Maybe<Ticker_Option_Flow_All_Sides_Stddev_Fields>;
  stddev_pop?: Maybe<Ticker_Option_Flow_All_Sides_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ticker_Option_Flow_All_Sides_Stddev_Samp_Fields>;
  sum?: Maybe<Ticker_Option_Flow_All_Sides_Sum_Fields>;
  var_pop?: Maybe<Ticker_Option_Flow_All_Sides_Var_Pop_Fields>;
  var_samp?: Maybe<Ticker_Option_Flow_All_Sides_Var_Samp_Fields>;
  variance?: Maybe<Ticker_Option_Flow_All_Sides_Variance_Fields>;
};


/** aggregate fields of "ticker_option_flow_all_sides" */
export type Ticker_Option_Flow_All_Sides_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ticker_Option_Flow_All_Sides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ticker_Option_Flow_All_Sides_Avg_Fields = {
  __typename?: 'ticker_option_flow_all_sides_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ticker_option_flow_all_sides". All fields are combined with a logical 'AND'. */
export type Ticker_Option_Flow_All_Sides_Bool_Exp = {
  _and?: InputMaybe<Array<Ticker_Option_Flow_All_Sides_Bool_Exp>>;
  _not?: InputMaybe<Ticker_Option_Flow_All_Sides_Bool_Exp>;
  _or?: InputMaybe<Array<Ticker_Option_Flow_All_Sides_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ticker_Option_Flow_All_Sides_Max_Fields = {
  __typename?: 'ticker_option_flow_all_sides_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Ticker_Option_Flow_All_Sides_Min_Fields = {
  __typename?: 'ticker_option_flow_all_sides_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "ticker_option_flow_all_sides". */
export type Ticker_Option_Flow_All_Sides_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** select columns of table "ticker_option_flow_all_sides" */
export const Ticker_Option_Flow_All_Sides_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Ticker_Option_Flow_All_Sides_Select_Column = typeof Ticker_Option_Flow_All_Sides_Select_Column[keyof typeof Ticker_Option_Flow_All_Sides_Select_Column];
/** aggregate stddev on columns */
export type Ticker_Option_Flow_All_Sides_Stddev_Fields = {
  __typename?: 'ticker_option_flow_all_sides_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ticker_Option_Flow_All_Sides_Stddev_Pop_Fields = {
  __typename?: 'ticker_option_flow_all_sides_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ticker_Option_Flow_All_Sides_Stddev_Samp_Fields = {
  __typename?: 'ticker_option_flow_all_sides_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ticker_option_flow_all_sides" */
export type Ticker_Option_Flow_All_Sides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticker_Option_Flow_All_Sides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticker_Option_Flow_All_Sides_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Ticker_Option_Flow_All_Sides_Sum_Fields = {
  __typename?: 'ticker_option_flow_all_sides_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Ticker_Option_Flow_All_Sides_Var_Pop_Fields = {
  __typename?: 'ticker_option_flow_all_sides_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ticker_Option_Flow_All_Sides_Var_Samp_Fields = {
  __typename?: 'ticker_option_flow_all_sides_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ticker_Option_Flow_All_Sides_Variance_Fields = {
  __typename?: 'ticker_option_flow_all_sides_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate avg on columns */
export type Ticker_Option_Flow_Avg_Fields = {
  __typename?: 'ticker_option_flow_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ticker_option_flow". All fields are combined with a logical 'AND'. */
export type Ticker_Option_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Ticker_Option_Flow_Bool_Exp>>;
  _not?: InputMaybe<Ticker_Option_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Ticker_Option_Flow_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ticker_Option_Flow_Max_Fields = {
  __typename?: 'ticker_option_flow_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Ticker_Option_Flow_Min_Fields = {
  __typename?: 'ticker_option_flow_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "ticker_option_flow". */
export type Ticker_Option_Flow_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** select columns of table "ticker_option_flow" */
export const Ticker_Option_Flow_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Ticker_Option_Flow_Select_Column = typeof Ticker_Option_Flow_Select_Column[keyof typeof Ticker_Option_Flow_Select_Column];
/** aggregate stddev on columns */
export type Ticker_Option_Flow_Stddev_Fields = {
  __typename?: 'ticker_option_flow_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ticker_Option_Flow_Stddev_Pop_Fields = {
  __typename?: 'ticker_option_flow_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ticker_Option_Flow_Stddev_Samp_Fields = {
  __typename?: 'ticker_option_flow_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ticker_option_flow" */
export type Ticker_Option_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticker_Option_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticker_Option_Flow_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Ticker_Option_Flow_Sum_Fields = {
  __typename?: 'ticker_option_flow_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Ticker_Option_Flow_Var_Pop_Fields = {
  __typename?: 'ticker_option_flow_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ticker_Option_Flow_Var_Samp_Fields = {
  __typename?: 'ticker_option_flow_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ticker_Option_Flow_Variance_Fields = {
  __typename?: 'ticker_option_flow_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ticker_research_all_views" */
export type Ticker_Research_All_Views = {
  __typename?: 'ticker_research_all_views';
  createdAt: Scalars['timestamptz'];
  date: Scalars['date'];
  id: Scalars['uuid'];
  ticker: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};

/** aggregated selection of "ticker_research_all_views" */
export type Ticker_Research_All_Views_Aggregate = {
  __typename?: 'ticker_research_all_views_aggregate';
  aggregate?: Maybe<Ticker_Research_All_Views_Aggregate_Fields>;
  nodes: Array<Ticker_Research_All_Views>;
};

export type Ticker_Research_All_Views_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ticker_Research_All_Views_Aggregate_Bool_Exp_Count>;
};

export type Ticker_Research_All_Views_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ticker_Research_All_Views_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ticker_Research_All_Views_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ticker_research_all_views" */
export type Ticker_Research_All_Views_Aggregate_Fields = {
  __typename?: 'ticker_research_all_views_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ticker_Research_All_Views_Max_Fields>;
  min?: Maybe<Ticker_Research_All_Views_Min_Fields>;
};


/** aggregate fields of "ticker_research_all_views" */
export type Ticker_Research_All_Views_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ticker_Research_All_Views_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ticker_research_all_views" */
export type Ticker_Research_All_Views_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ticker_Research_All_Views_Max_Order_By>;
  min?: InputMaybe<Ticker_Research_All_Views_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ticker_research_all_views" */
export type Ticker_Research_All_Views_Arr_Rel_Insert_Input = {
  data: Array<Ticker_Research_All_Views_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ticker_Research_All_Views_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ticker_research_all_views". All fields are combined with a logical 'AND'. */
export type Ticker_Research_All_Views_Bool_Exp = {
  _and?: InputMaybe<Array<Ticker_Research_All_Views_Bool_Exp>>;
  _not?: InputMaybe<Ticker_Research_All_Views_Bool_Exp>;
  _or?: InputMaybe<Array<Ticker_Research_All_Views_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ticker_research_all_views" */
export const Ticker_Research_All_Views_Constraint = {
  /** unique or primary key constraint on columns "id" */
  TickerResearchAllViewsPkey: 'ticker_research_all_views_pkey'
} as const;

export type Ticker_Research_All_Views_Constraint = typeof Ticker_Research_All_Views_Constraint[keyof typeof Ticker_Research_All_Views_Constraint];
/** columns and relationships of "ticker_research_all_views_counts" */
export type Ticker_Research_All_Views_Counts = {
  __typename?: 'ticker_research_all_views_counts';
  count?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
};

/** aggregated selection of "ticker_research_all_views_counts" */
export type Ticker_Research_All_Views_Counts_Aggregate = {
  __typename?: 'ticker_research_all_views_counts_aggregate';
  aggregate?: Maybe<Ticker_Research_All_Views_Counts_Aggregate_Fields>;
  nodes: Array<Ticker_Research_All_Views_Counts>;
};

/** aggregate fields of "ticker_research_all_views_counts" */
export type Ticker_Research_All_Views_Counts_Aggregate_Fields = {
  __typename?: 'ticker_research_all_views_counts_aggregate_fields';
  avg?: Maybe<Ticker_Research_All_Views_Counts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ticker_Research_All_Views_Counts_Max_Fields>;
  min?: Maybe<Ticker_Research_All_Views_Counts_Min_Fields>;
  stddev?: Maybe<Ticker_Research_All_Views_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Ticker_Research_All_Views_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ticker_Research_All_Views_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Ticker_Research_All_Views_Counts_Sum_Fields>;
  var_pop?: Maybe<Ticker_Research_All_Views_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Ticker_Research_All_Views_Counts_Var_Samp_Fields>;
  variance?: Maybe<Ticker_Research_All_Views_Counts_Variance_Fields>;
};


/** aggregate fields of "ticker_research_all_views_counts" */
export type Ticker_Research_All_Views_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ticker_Research_All_Views_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ticker_Research_All_Views_Counts_Avg_Fields = {
  __typename?: 'ticker_research_all_views_counts_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ticker_research_all_views_counts". All fields are combined with a logical 'AND'. */
export type Ticker_Research_All_Views_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Ticker_Research_All_Views_Counts_Bool_Exp>>;
  _not?: InputMaybe<Ticker_Research_All_Views_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Ticker_Research_All_Views_Counts_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  industry?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sector?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ticker_Research_All_Views_Counts_Max_Fields = {
  __typename?: 'ticker_research_all_views_counts_max_fields';
  count?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ticker_Research_All_Views_Counts_Min_Fields = {
  __typename?: 'ticker_research_all_views_counts_min_fields';
  count?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "ticker_research_all_views_counts". */
export type Ticker_Research_All_Views_Counts_Order_By = {
  count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  industry?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sector?: InputMaybe<Order_By>;
};

/** select columns of table "ticker_research_all_views_counts" */
export const Ticker_Research_All_Views_Counts_Select_Column = {
  /** column name */
  Count: 'count',
  /** column name */
  Id: 'id',
  /** column name */
  Industry: 'industry',
  /** column name */
  Name: 'name',
  /** column name */
  Sector: 'sector'
} as const;

export type Ticker_Research_All_Views_Counts_Select_Column = typeof Ticker_Research_All_Views_Counts_Select_Column[keyof typeof Ticker_Research_All_Views_Counts_Select_Column];
/** aggregate stddev on columns */
export type Ticker_Research_All_Views_Counts_Stddev_Fields = {
  __typename?: 'ticker_research_all_views_counts_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ticker_Research_All_Views_Counts_Stddev_Pop_Fields = {
  __typename?: 'ticker_research_all_views_counts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ticker_Research_All_Views_Counts_Stddev_Samp_Fields = {
  __typename?: 'ticker_research_all_views_counts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ticker_research_all_views_counts" */
export type Ticker_Research_All_Views_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticker_Research_All_Views_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticker_Research_All_Views_Counts_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Ticker_Research_All_Views_Counts_Sum_Fields = {
  __typename?: 'ticker_research_all_views_counts_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Ticker_Research_All_Views_Counts_Var_Pop_Fields = {
  __typename?: 'ticker_research_all_views_counts_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ticker_Research_All_Views_Counts_Var_Samp_Fields = {
  __typename?: 'ticker_research_all_views_counts_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ticker_Research_All_Views_Counts_Variance_Fields = {
  __typename?: 'ticker_research_all_views_counts_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** input type for inserting data into table "ticker_research_all_views" */
export type Ticker_Research_All_Views_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ticker_Research_All_Views_Max_Fields = {
  __typename?: 'ticker_research_all_views_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  ticker?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ticker_research_all_views" */
export type Ticker_Research_All_Views_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ticker_Research_All_Views_Min_Fields = {
  __typename?: 'ticker_research_all_views_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  ticker?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ticker_research_all_views" */
export type Ticker_Research_All_Views_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ticker_research_all_views" */
export type Ticker_Research_All_Views_Mutation_Response = {
  __typename?: 'ticker_research_all_views_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ticker_Research_All_Views>;
};

/** on_conflict condition type for table "ticker_research_all_views" */
export type Ticker_Research_All_Views_On_Conflict = {
  constraint: Ticker_Research_All_Views_Constraint;
  update_columns?: Array<Ticker_Research_All_Views_Update_Column>;
  where?: InputMaybe<Ticker_Research_All_Views_Bool_Exp>;
};

/** Ordering options when selecting data from "ticker_research_all_views". */
export type Ticker_Research_All_Views_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ticker_research_all_views */
export type Ticker_Research_All_Views_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ticker_research_all_views" */
export const Ticker_Research_All_Views_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  Id: 'id',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Ticker_Research_All_Views_Select_Column = typeof Ticker_Research_All_Views_Select_Column[keyof typeof Ticker_Research_All_Views_Select_Column];
/** input type for updating data in table "ticker_research_all_views" */
export type Ticker_Research_All_Views_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ticker_research_all_views" */
export type Ticker_Research_All_Views_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticker_Research_All_Views_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticker_Research_All_Views_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ticker_research_all_views" */
export const Ticker_Research_All_Views_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  Id: 'id',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Ticker_Research_All_Views_Update_Column = typeof Ticker_Research_All_Views_Update_Column[keyof typeof Ticker_Research_All_Views_Update_Column];
export type Ticker_Research_All_Views_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ticker_Research_All_Views_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ticker_Research_All_Views_Bool_Exp;
};

/** columns and relationships of "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views = {
  __typename?: 'ticker_research_daily_views';
  createdAt: Scalars['timestamptz'];
  date: Scalars['date'];
  id: Scalars['uuid'];
  ticker: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};

/** aggregated selection of "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views_Aggregate = {
  __typename?: 'ticker_research_daily_views_aggregate';
  aggregate?: Maybe<Ticker_Research_Daily_Views_Aggregate_Fields>;
  nodes: Array<Ticker_Research_Daily_Views>;
};

export type Ticker_Research_Daily_Views_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ticker_Research_Daily_Views_Aggregate_Bool_Exp_Count>;
};

export type Ticker_Research_Daily_Views_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ticker_Research_Daily_Views_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ticker_Research_Daily_Views_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views_Aggregate_Fields = {
  __typename?: 'ticker_research_daily_views_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ticker_Research_Daily_Views_Max_Fields>;
  min?: Maybe<Ticker_Research_Daily_Views_Min_Fields>;
};


/** aggregate fields of "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ticker_Research_Daily_Views_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ticker_Research_Daily_Views_Max_Order_By>;
  min?: InputMaybe<Ticker_Research_Daily_Views_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views_Arr_Rel_Insert_Input = {
  data: Array<Ticker_Research_Daily_Views_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ticker_Research_Daily_Views_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ticker_research_daily_views". All fields are combined with a logical 'AND'. */
export type Ticker_Research_Daily_Views_Bool_Exp = {
  _and?: InputMaybe<Array<Ticker_Research_Daily_Views_Bool_Exp>>;
  _not?: InputMaybe<Ticker_Research_Daily_Views_Bool_Exp>;
  _or?: InputMaybe<Array<Ticker_Research_Daily_Views_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ticker_research_daily_views" */
export const Ticker_Research_Daily_Views_Constraint = {
  /** unique or primary key constraint on columns "id" */
  TickerResearchDailyViewsPkey: 'ticker_research_daily_views_pkey',
  /** unique or primary key constraint on columns "userId", "date", "ticker" */
  TickerResearchDailyViewsTickerUserIdDateKey: 'ticker_research_daily_views_ticker_userId_date_key'
} as const;

export type Ticker_Research_Daily_Views_Constraint = typeof Ticker_Research_Daily_Views_Constraint[keyof typeof Ticker_Research_Daily_Views_Constraint];
/** input type for inserting data into table "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ticker_Research_Daily_Views_Max_Fields = {
  __typename?: 'ticker_research_daily_views_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  ticker?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ticker_Research_Daily_Views_Min_Fields = {
  __typename?: 'ticker_research_daily_views_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  ticker?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views_Mutation_Response = {
  __typename?: 'ticker_research_daily_views_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ticker_Research_Daily_Views>;
};

/** on_conflict condition type for table "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views_On_Conflict = {
  constraint: Ticker_Research_Daily_Views_Constraint;
  update_columns?: Array<Ticker_Research_Daily_Views_Update_Column>;
  where?: InputMaybe<Ticker_Research_Daily_Views_Bool_Exp>;
};

/** Ordering options when selecting data from "ticker_research_daily_views". */
export type Ticker_Research_Daily_Views_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ticker_research_daily_views */
export type Ticker_Research_Daily_Views_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ticker_research_daily_views" */
export const Ticker_Research_Daily_Views_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  Id: 'id',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Ticker_Research_Daily_Views_Select_Column = typeof Ticker_Research_Daily_Views_Select_Column[keyof typeof Ticker_Research_Daily_Views_Select_Column];
/** input type for updating data in table "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ticker_research_daily_views" */
export type Ticker_Research_Daily_Views_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticker_Research_Daily_Views_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticker_Research_Daily_Views_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ticker_research_daily_views" */
export const Ticker_Research_Daily_Views_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  Id: 'id',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Ticker_Research_Daily_Views_Update_Column = typeof Ticker_Research_Daily_Views_Update_Column[keyof typeof Ticker_Research_Daily_Views_Update_Column];
export type Ticker_Research_Daily_Views_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ticker_Research_Daily_Views_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ticker_Research_Daily_Views_Bool_Exp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export type Timetz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timetz']>;
  _gt?: InputMaybe<Scalars['timetz']>;
  _gte?: InputMaybe<Scalars['timetz']>;
  _in?: InputMaybe<Array<Scalars['timetz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timetz']>;
  _lte?: InputMaybe<Scalars['timetz']>;
  _neq?: InputMaybe<Scalars['timetz']>;
  _nin?: InputMaybe<Array<Scalars['timetz']>>;
};

/** columns and relationships of "timezone_location" */
export type Timezone_Location = {
  __typename?: 'timezone_location';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "timezone_location" */
export type Timezone_Location_Aggregate = {
  __typename?: 'timezone_location_aggregate';
  aggregate?: Maybe<Timezone_Location_Aggregate_Fields>;
  nodes: Array<Timezone_Location>;
};

/** aggregate fields of "timezone_location" */
export type Timezone_Location_Aggregate_Fields = {
  __typename?: 'timezone_location_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Timezone_Location_Max_Fields>;
  min?: Maybe<Timezone_Location_Min_Fields>;
};


/** aggregate fields of "timezone_location" */
export type Timezone_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Timezone_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "timezone_location". All fields are combined with a logical 'AND'. */
export type Timezone_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Timezone_Location_Bool_Exp>>;
  _not?: InputMaybe<Timezone_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Timezone_Location_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "timezone_location" */
export const Timezone_Location_Constraint = {
  /** unique or primary key constraint on columns "value" */
  TimezoneLocationPkey: 'timezone_location_pkey'
} as const;

export type Timezone_Location_Constraint = typeof Timezone_Location_Constraint[keyof typeof Timezone_Location_Constraint];
export const Timezone_Location_Enum = {
  Current: 'CURRENT',
  Wallstreet: 'WALLSTREET'
} as const;

export type Timezone_Location_Enum = typeof Timezone_Location_Enum[keyof typeof Timezone_Location_Enum];
/** Boolean expression to compare columns of type "timezone_location_enum". All fields are combined with logical 'AND'. */
export type Timezone_Location_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Timezone_Location_Enum>;
  _in?: InputMaybe<Array<Timezone_Location_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Timezone_Location_Enum>;
  _nin?: InputMaybe<Array<Timezone_Location_Enum>>;
};

/** input type for inserting data into table "timezone_location" */
export type Timezone_Location_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Timezone_Location_Max_Fields = {
  __typename?: 'timezone_location_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Timezone_Location_Min_Fields = {
  __typename?: 'timezone_location_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "timezone_location" */
export type Timezone_Location_Mutation_Response = {
  __typename?: 'timezone_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Timezone_Location>;
};

/** on_conflict condition type for table "timezone_location" */
export type Timezone_Location_On_Conflict = {
  constraint: Timezone_Location_Constraint;
  update_columns?: Array<Timezone_Location_Update_Column>;
  where?: InputMaybe<Timezone_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "timezone_location". */
export type Timezone_Location_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: timezone_location */
export type Timezone_Location_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "timezone_location" */
export const Timezone_Location_Select_Column = {
  /** column name */
  Description: 'description',
  /** column name */
  Value: 'value'
} as const;

export type Timezone_Location_Select_Column = typeof Timezone_Location_Select_Column[keyof typeof Timezone_Location_Select_Column];
/** input type for updating data in table "timezone_location" */
export type Timezone_Location_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "timezone_location" */
export type Timezone_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Timezone_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Timezone_Location_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "timezone_location" */
export const Timezone_Location_Update_Column = {
  /** column name */
  Description: 'description',
  /** column name */
  Value: 'value'
} as const;

export type Timezone_Location_Update_Column = typeof Timezone_Location_Update_Column[keyof typeof Timezone_Location_Update_Column];
export type Timezone_Location_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Timezone_Location_Set_Input>;
  /** filter the rows which have to be updated */
  where: Timezone_Location_Bool_Exp;
};

/** columns and relationships of "top_tickers" */
export type Top_Tickers = {
  __typename?: 'top_tickers';
  createdAt: Scalars['timestamptz'];
  fifth?: Maybe<Scalars['String']>;
  /** An array relationship */
  fifthTrades: Array<Weekly_Option_Flow>;
  /** An aggregate relationship */
  fifthTrades_aggregate: Weekly_Option_Flow_Aggregate;
  first?: Maybe<Scalars['String']>;
  /** An array relationship */
  firstTrades: Array<Weekly_Option_Flow>;
  /** An aggregate relationship */
  firstTrades_aggregate: Weekly_Option_Flow_Aggregate;
  fourth?: Maybe<Scalars['String']>;
  /** An array relationship */
  fourthTrades: Array<Weekly_Option_Flow>;
  /** An aggregate relationship */
  fourthTrades_aggregate: Weekly_Option_Flow_Aggregate;
  id: Scalars['String'];
  second?: Maybe<Scalars['String']>;
  /** An array relationship */
  secondTrades: Array<Weekly_Option_Flow>;
  /** An aggregate relationship */
  secondTrades_aggregate: Weekly_Option_Flow_Aggregate;
  third?: Maybe<Scalars['String']>;
  /** An array relationship */
  thirdTrades: Array<Weekly_Option_Flow>;
  /** An aggregate relationship */
  thirdTrades_aggregate: Weekly_Option_Flow_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "top_tickers" */
export type Top_TickersFifthTradesArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


/** columns and relationships of "top_tickers" */
export type Top_TickersFifthTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


/** columns and relationships of "top_tickers" */
export type Top_TickersFirstTradesArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


/** columns and relationships of "top_tickers" */
export type Top_TickersFirstTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


/** columns and relationships of "top_tickers" */
export type Top_TickersFourthTradesArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


/** columns and relationships of "top_tickers" */
export type Top_TickersFourthTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


/** columns and relationships of "top_tickers" */
export type Top_TickersSecondTradesArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


/** columns and relationships of "top_tickers" */
export type Top_TickersSecondTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


/** columns and relationships of "top_tickers" */
export type Top_TickersThirdTradesArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};


/** columns and relationships of "top_tickers" */
export type Top_TickersThirdTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weekly_Option_Flow_Order_By>>;
  where?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
};

/** aggregated selection of "top_tickers" */
export type Top_Tickers_Aggregate = {
  __typename?: 'top_tickers_aggregate';
  aggregate?: Maybe<Top_Tickers_Aggregate_Fields>;
  nodes: Array<Top_Tickers>;
};

/** aggregate fields of "top_tickers" */
export type Top_Tickers_Aggregate_Fields = {
  __typename?: 'top_tickers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Top_Tickers_Max_Fields>;
  min?: Maybe<Top_Tickers_Min_Fields>;
};


/** aggregate fields of "top_tickers" */
export type Top_Tickers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Top_Tickers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "top_tickers". All fields are combined with a logical 'AND'. */
export type Top_Tickers_Bool_Exp = {
  _and?: InputMaybe<Array<Top_Tickers_Bool_Exp>>;
  _not?: InputMaybe<Top_Tickers_Bool_Exp>;
  _or?: InputMaybe<Array<Top_Tickers_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fifth?: InputMaybe<String_Comparison_Exp>;
  fifthTrades?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
  fifthTrades_aggregate?: InputMaybe<Weekly_Option_Flow_Aggregate_Bool_Exp>;
  first?: InputMaybe<String_Comparison_Exp>;
  firstTrades?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
  firstTrades_aggregate?: InputMaybe<Weekly_Option_Flow_Aggregate_Bool_Exp>;
  fourth?: InputMaybe<String_Comparison_Exp>;
  fourthTrades?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
  fourthTrades_aggregate?: InputMaybe<Weekly_Option_Flow_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  second?: InputMaybe<String_Comparison_Exp>;
  secondTrades?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
  secondTrades_aggregate?: InputMaybe<Weekly_Option_Flow_Aggregate_Bool_Exp>;
  third?: InputMaybe<String_Comparison_Exp>;
  thirdTrades?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
  thirdTrades_aggregate?: InputMaybe<Weekly_Option_Flow_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "top_tickers" */
export const Top_Tickers_Constraint = {
  /** unique or primary key constraint on columns "id" */
  TopTickersPkey: 'top_tickers_pkey'
} as const;

export type Top_Tickers_Constraint = typeof Top_Tickers_Constraint[keyof typeof Top_Tickers_Constraint];
/** input type for inserting data into table "top_tickers" */
export type Top_Tickers_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fifth?: InputMaybe<Scalars['String']>;
  fifthTrades?: InputMaybe<Weekly_Option_Flow_Arr_Rel_Insert_Input>;
  first?: InputMaybe<Scalars['String']>;
  firstTrades?: InputMaybe<Weekly_Option_Flow_Arr_Rel_Insert_Input>;
  fourth?: InputMaybe<Scalars['String']>;
  fourthTrades?: InputMaybe<Weekly_Option_Flow_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  second?: InputMaybe<Scalars['String']>;
  secondTrades?: InputMaybe<Weekly_Option_Flow_Arr_Rel_Insert_Input>;
  third?: InputMaybe<Scalars['String']>;
  thirdTrades?: InputMaybe<Weekly_Option_Flow_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Top_Tickers_Max_Fields = {
  __typename?: 'top_tickers_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fifth?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['String']>;
  fourth?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  second?: Maybe<Scalars['String']>;
  third?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Top_Tickers_Min_Fields = {
  __typename?: 'top_tickers_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  fifth?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['String']>;
  fourth?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  second?: Maybe<Scalars['String']>;
  third?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "top_tickers" */
export type Top_Tickers_Mutation_Response = {
  __typename?: 'top_tickers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Top_Tickers>;
};

/** on_conflict condition type for table "top_tickers" */
export type Top_Tickers_On_Conflict = {
  constraint: Top_Tickers_Constraint;
  update_columns?: Array<Top_Tickers_Update_Column>;
  where?: InputMaybe<Top_Tickers_Bool_Exp>;
};

/** Ordering options when selecting data from "top_tickers". */
export type Top_Tickers_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  fifth?: InputMaybe<Order_By>;
  fifthTrades_aggregate?: InputMaybe<Weekly_Option_Flow_Aggregate_Order_By>;
  first?: InputMaybe<Order_By>;
  firstTrades_aggregate?: InputMaybe<Weekly_Option_Flow_Aggregate_Order_By>;
  fourth?: InputMaybe<Order_By>;
  fourthTrades_aggregate?: InputMaybe<Weekly_Option_Flow_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  second?: InputMaybe<Order_By>;
  secondTrades_aggregate?: InputMaybe<Weekly_Option_Flow_Aggregate_Order_By>;
  third?: InputMaybe<Order_By>;
  thirdTrades_aggregate?: InputMaybe<Weekly_Option_Flow_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: top_tickers */
export type Top_Tickers_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "top_tickers" */
export const Top_Tickers_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Fifth: 'fifth',
  /** column name */
  First: 'first',
  /** column name */
  Fourth: 'fourth',
  /** column name */
  Id: 'id',
  /** column name */
  Second: 'second',
  /** column name */
  Third: 'third',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Top_Tickers_Select_Column = typeof Top_Tickers_Select_Column[keyof typeof Top_Tickers_Select_Column];
/** input type for updating data in table "top_tickers" */
export type Top_Tickers_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fifth?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['String']>;
  fourth?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  second?: InputMaybe<Scalars['String']>;
  third?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "top_tickers" */
export type Top_Tickers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Top_Tickers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Top_Tickers_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fifth?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['String']>;
  fourth?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  second?: InputMaybe<Scalars['String']>;
  third?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "top_tickers" */
export const Top_Tickers_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Fifth: 'fifth',
  /** column name */
  First: 'first',
  /** column name */
  Fourth: 'fourth',
  /** column name */
  Id: 'id',
  /** column name */
  Second: 'second',
  /** column name */
  Third: 'third',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type Top_Tickers_Update_Column = typeof Top_Tickers_Update_Column[keyof typeof Top_Tickers_Update_Column];
export type Top_Tickers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Top_Tickers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Top_Tickers_Bool_Exp;
};

/** Boolean expression to compare columns of type "tsvector". All fields are combined with logical 'AND'. */
export type Tsvector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tsvector']>;
  _gt?: InputMaybe<Scalars['tsvector']>;
  _gte?: InputMaybe<Scalars['tsvector']>;
  _in?: InputMaybe<Array<Scalars['tsvector']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['tsvector']>;
  _lte?: InputMaybe<Scalars['tsvector']>;
  _neq?: InputMaybe<Scalars['tsvector']>;
  _nin?: InputMaybe<Array<Scalars['tsvector']>>;
};

/** columns and relationships of "usage_ping" */
export type Usage_Ping = {
  __typename?: 'usage_ping';
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  ip: Scalars['String'];
  pathname: Scalars['String'];
  platform?: Maybe<Scalars['String']>;
  queryString: Scalars['String'];
  region: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};

/** aggregated selection of "usage_ping" */
export type Usage_Ping_Aggregate = {
  __typename?: 'usage_ping_aggregate';
  aggregate?: Maybe<Usage_Ping_Aggregate_Fields>;
  nodes: Array<Usage_Ping>;
};

export type Usage_Ping_Aggregate_Bool_Exp = {
  count?: InputMaybe<Usage_Ping_Aggregate_Bool_Exp_Count>;
};

export type Usage_Ping_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Usage_Ping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Usage_Ping_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "usage_ping" */
export type Usage_Ping_Aggregate_Fields = {
  __typename?: 'usage_ping_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Usage_Ping_Max_Fields>;
  min?: Maybe<Usage_Ping_Min_Fields>;
};


/** aggregate fields of "usage_ping" */
export type Usage_Ping_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Usage_Ping_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "usage_ping" */
export type Usage_Ping_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Usage_Ping_Max_Order_By>;
  min?: InputMaybe<Usage_Ping_Min_Order_By>;
};

/** input type for inserting array relation for remote table "usage_ping" */
export type Usage_Ping_Arr_Rel_Insert_Input = {
  data: Array<Usage_Ping_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Usage_Ping_On_Conflict>;
};

/** Boolean expression to filter rows from the table "usage_ping". All fields are combined with a logical 'AND'. */
export type Usage_Ping_Bool_Exp = {
  _and?: InputMaybe<Array<Usage_Ping_Bool_Exp>>;
  _not?: InputMaybe<Usage_Ping_Bool_Exp>;
  _or?: InputMaybe<Array<Usage_Ping_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip?: InputMaybe<String_Comparison_Exp>;
  pathname?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  queryString?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "usage_ping" */
export const Usage_Ping_Constraint = {
  /** unique or primary key constraint on columns "id" */
  UsagePingPkey: 'usage_ping_pkey'
} as const;

export type Usage_Ping_Constraint = typeof Usage_Ping_Constraint[keyof typeof Usage_Ping_Constraint];
/** input type for inserting data into table "usage_ping" */
export type Usage_Ping_Insert_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  pathname?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Usage_Ping_Max_Fields = {
  __typename?: 'usage_ping_max_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  pathname?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "usage_ping" */
export type Usage_Ping_Max_Order_By = {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip?: InputMaybe<Order_By>;
  pathname?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  queryString?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Usage_Ping_Min_Fields = {
  __typename?: 'usage_ping_min_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ip?: Maybe<Scalars['String']>;
  pathname?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  queryString?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "usage_ping" */
export type Usage_Ping_Min_Order_By = {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip?: InputMaybe<Order_By>;
  pathname?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  queryString?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "usage_ping" */
export type Usage_Ping_Mutation_Response = {
  __typename?: 'usage_ping_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Usage_Ping>;
};

/** on_conflict condition type for table "usage_ping" */
export type Usage_Ping_On_Conflict = {
  constraint: Usage_Ping_Constraint;
  update_columns?: Array<Usage_Ping_Update_Column>;
  where?: InputMaybe<Usage_Ping_Bool_Exp>;
};

/** Ordering options when selecting data from "usage_ping". */
export type Usage_Ping_Order_By = {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip?: InputMaybe<Order_By>;
  pathname?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  queryString?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: usage_ping */
export type Usage_Ping_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "usage_ping" */
export const Usage_Ping_Select_Column = {
  /** column name */
  City: 'city',
  /** column name */
  Country: 'country',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  Ip: 'ip',
  /** column name */
  Pathname: 'pathname',
  /** column name */
  Platform: 'platform',
  /** column name */
  QueryString: 'queryString',
  /** column name */
  Region: 'region',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Usage_Ping_Select_Column = typeof Usage_Ping_Select_Column[keyof typeof Usage_Ping_Select_Column];
/** input type for updating data in table "usage_ping" */
export type Usage_Ping_Set_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  pathname?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "usage_ping" */
export type Usage_Ping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Usage_Ping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Usage_Ping_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  pathname?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  queryString?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "usage_ping" */
export const Usage_Ping_Update_Column = {
  /** column name */
  City: 'city',
  /** column name */
  Country: 'country',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  Ip: 'ip',
  /** column name */
  Pathname: 'pathname',
  /** column name */
  Platform: 'platform',
  /** column name */
  QueryString: 'queryString',
  /** column name */
  Region: 'region',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Usage_Ping_Update_Column = typeof Usage_Ping_Update_Column[keyof typeof Usage_Ping_Update_Column];
export type Usage_Ping_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Usage_Ping_Set_Input>;
  /** filter the rows which have to be updated */
  where: Usage_Ping_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  addressIsFlagged: Scalars['Boolean'];
  addressIsMatched: Scalars['Boolean'];
  affiliateEndedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  affiliateLinkClicks: Array<Affiliate_Link_Clicks>;
  /** An aggregate relationship */
  affiliateLinkClicks_aggregate: Affiliate_Link_Clicks_Aggregate;
  /** An array relationship */
  affiliatePayouts: Array<Affiliate_Payouts>;
  /** An aggregate relationship */
  affiliatePayouts_aggregate: Affiliate_Payouts_Aggregate;
  /** An array relationship */
  affiliateReferralClickCounts: Array<Affiliate_Referral_Click_Counts>;
  /** An aggregate relationship */
  affiliateReferralClickCounts_aggregate: Affiliate_Referral_Click_Counts_Aggregate;
  affiliateRevenueShare?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  affiliateSales: Array<Sales>;
  /** An aggregate relationship */
  affiliateSales_aggregate: Sales_Aggregate;
  affiliateStartedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  affiliateSubscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  affiliateSubscriptions_aggregate: Subscriptions_Aggregate;
  affiliateTier: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  /** An array relationship */
  courseProgress: Array<Course_Progress>;
  /** An aggregate relationship */
  courseProgress_aggregate: Course_Progress_Aggregate;
  createdAt: Scalars['timestamptz'];
  discordAccessToken?: Maybe<Scalars['String']>;
  discordAvatar?: Maybe<Scalars['String']>;
  discordDiscriminator?: Maybe<Scalars['String']>;
  discordEmail?: Maybe<Scalars['String']>;
  discordFlags?: Maybe<Scalars['Int']>;
  discordGuilds?: Maybe<Scalars['jsonb']>;
  discordId?: Maybe<Scalars['String']>;
  discordLocale?: Maybe<Scalars['String']>;
  discordMfaEnabled?: Maybe<Scalars['Boolean']>;
  discordPublicFlags?: Maybe<Scalars['Int']>;
  discordRefreshToken?: Maybe<Scalars['String']>;
  discordScope?: Maybe<Scalars['String']>;
  discordTokenExpiresIn?: Maybe<Scalars['Int']>;
  discordTokenType?: Maybe<Scalars['String']>;
  discordTokenUpdatedAt?: Maybe<Scalars['timestamptz']>;
  discordUsername?: Maybe<Scalars['String']>;
  discordVerified?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  emailInsights: Scalars['Boolean'];
  emailIsFlagged: Scalars['Boolean'];
  employer?: Maybe<Scalars['String']>;
  employerFinraHits: Scalars['Int'];
  employerIsFlagged: Scalars['Boolean'];
  employmentProfessionalStatus: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  /** An array relationship */
  flowConfigurations: Array<Flow_Configurations>;
  /** An aggregate relationship */
  flowConfigurations_aggregate: Flow_Configurations_Aggregate;
  id: Scalars['String'];
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  isDashboardLifetime: Scalars['Boolean'];
  isSoundEnabled: Scalars['Boolean'];
  isTechnicalAnalysisLifetime: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  launchAccessEndsAt?: Maybe<Scalars['timestamptz']>;
  nameIsFlagged: Scalars['Boolean'];
  /** An array relationship */
  opcSavedStrategies: Array<Opc_Saved_Strategies>;
  /** An aggregate relationship */
  opcSavedStrategies_aggregate: Opc_Saved_Strategies_Aggregate;
  opraAgreementCompletedAt?: Maybe<Scalars['timestamptz']>;
  opraAllTerms: Scalars['Boolean'];
  opraNotProfessional: Scalars['Boolean'];
  opraPersonalUse: Scalars['Boolean'];
  opraQualifyingPerson: Scalars['Boolean'];
  opraTos: Scalars['Boolean'];
  opraWillUpdateDetails: Scalars['Boolean'];
  optionFlowFilters?: Maybe<Scalars['jsonb']>;
  paypalEmail?: Maybe<Scalars['String']>;
  personFinraHits: Scalars['Int'];
  probabilityOfProfessional: Scalars['String'];
  /** An array relationship */
  sales: Array<Sales>;
  /** An aggregate relationship */
  sales_aggregate: Sales_Aggregate;
  state?: Maybe<Scalars['String']>;
  statusOfNonProAgreement: Scalars['String'];
  street?: Maybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** An array relationship */
  tickerResearchAllViews: Array<Ticker_Research_All_Views>;
  /** An aggregate relationship */
  tickerResearchAllViews_aggregate: Ticker_Research_All_Views_Aggregate;
  /** An array relationship */
  tickerResearchDailyViews: Array<Ticker_Research_Daily_Views>;
  /** An aggregate relationship */
  tickerResearchDailyViews_aggregate: Ticker_Research_Daily_Views_Aggregate;
  timezoneLocation: Timezone_Location_Enum;
  tradingviewAccessActiveAt?: Maybe<Scalars['timestamptz']>;
  tradingviewAccessInactiveAt?: Maybe<Scalars['timestamptz']>;
  tradingviewAccessStatus?: Maybe<Scalars['String']>;
  tradingviewUsername?: Maybe<Scalars['String']>;
  tradingviewUsernameAddedAt?: Maybe<Scalars['timestamptz']>;
  tradingviewUsernameCaseSensitive?: Maybe<Scalars['String']>;
  tradingviewUsernameInvalidAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  usagePings: Array<Usage_Ping>;
  /** An aggregate relationship */
  usagePings_aggregate: Usage_Ping_Aggregate;
  /** This is also used as the affiliate ID */
  username?: Maybe<Scalars['String']>;
  usernameCaseSensitive?: Maybe<Scalars['String']>;
  /** An array relationship */
  watchlist: Array<Watch_List>;
  /** An aggregate relationship */
  watchlist_aggregate: Watch_List_Aggregate;
};


/** columns and relationships of "users" */
export type UsersAffiliateLinkClicksArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Link_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Link_Clicks_Order_By>>;
  where?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAffiliateLinkClicks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Link_Clicks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Link_Clicks_Order_By>>;
  where?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAffiliatePayoutsArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Payouts_Order_By>>;
  where?: InputMaybe<Affiliate_Payouts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAffiliatePayouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Payouts_Order_By>>;
  where?: InputMaybe<Affiliate_Payouts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAffiliateReferralClickCountsArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Order_By>>;
  where?: InputMaybe<Affiliate_Referral_Click_Counts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAffiliateReferralClickCounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Affiliate_Referral_Click_Counts_Order_By>>;
  where?: InputMaybe<Affiliate_Referral_Click_Counts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAffiliateSalesArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAffiliateSales_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAffiliateSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAffiliateSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCourseProgressArgs = {
  distinct_on?: InputMaybe<Array<Course_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Progress_Order_By>>;
  where?: InputMaybe<Course_Progress_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersCourseProgress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Progress_Order_By>>;
  where?: InputMaybe<Course_Progress_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDiscordGuildsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersFlowConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Flow_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Flow_Configurations_Order_By>>;
  where?: InputMaybe<Flow_Configurations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFlowConfigurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flow_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Flow_Configurations_Order_By>>;
  where?: InputMaybe<Flow_Configurations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOpcSavedStrategiesArgs = {
  distinct_on?: InputMaybe<Array<Opc_Saved_Strategies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opc_Saved_Strategies_Order_By>>;
  where?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOpcSavedStrategies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Opc_Saved_Strategies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opc_Saved_Strategies_Order_By>>;
  where?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOptionFlowFiltersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersSalesArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSales_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sales_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sales_Order_By>>;
  where?: InputMaybe<Sales_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTickerResearchAllViewsArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_All_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_All_Views_Order_By>>;
  where?: InputMaybe<Ticker_Research_All_Views_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTickerResearchAllViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_All_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_All_Views_Order_By>>;
  where?: InputMaybe<Ticker_Research_All_Views_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTickerResearchDailyViewsArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_Daily_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_Daily_Views_Order_By>>;
  where?: InputMaybe<Ticker_Research_Daily_Views_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTickerResearchDailyViews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Research_Daily_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Research_Daily_Views_Order_By>>;
  where?: InputMaybe<Ticker_Research_Daily_Views_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsagePingsArgs = {
  distinct_on?: InputMaybe<Array<Usage_Ping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Usage_Ping_Order_By>>;
  where?: InputMaybe<Usage_Ping_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsagePings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Usage_Ping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Usage_Ping_Order_By>>;
  where?: InputMaybe<Usage_Ping_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersWatchlistArgs = {
  distinct_on?: InputMaybe<Array<Watch_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Watch_List_Order_By>>;
  where?: InputMaybe<Watch_List_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersWatchlist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Watch_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Watch_List_Order_By>>;
  where?: InputMaybe<Watch_List_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  discordGuilds?: InputMaybe<Scalars['jsonb']>;
  optionFlowFilters?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  affiliateRevenueShare?: Maybe<Scalars['Float']>;
  discordFlags?: Maybe<Scalars['Float']>;
  discordPublicFlags?: Maybe<Scalars['Float']>;
  discordTokenExpiresIn?: Maybe<Scalars['Float']>;
  employerFinraHits?: Maybe<Scalars['Float']>;
  personFinraHits?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  addressIsFlagged?: InputMaybe<Boolean_Comparison_Exp>;
  addressIsMatched?: InputMaybe<Boolean_Comparison_Exp>;
  affiliateEndedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  affiliateLinkClicks?: InputMaybe<Affiliate_Link_Clicks_Bool_Exp>;
  affiliateLinkClicks_aggregate?: InputMaybe<Affiliate_Link_Clicks_Aggregate_Bool_Exp>;
  affiliatePayouts?: InputMaybe<Affiliate_Payouts_Bool_Exp>;
  affiliatePayouts_aggregate?: InputMaybe<Affiliate_Payouts_Aggregate_Bool_Exp>;
  affiliateReferralClickCounts?: InputMaybe<Affiliate_Referral_Click_Counts_Bool_Exp>;
  affiliateReferralClickCounts_aggregate?: InputMaybe<Affiliate_Referral_Click_Counts_Aggregate_Bool_Exp>;
  affiliateRevenueShare?: InputMaybe<Numeric_Comparison_Exp>;
  affiliateSales?: InputMaybe<Sales_Bool_Exp>;
  affiliateSales_aggregate?: InputMaybe<Sales_Aggregate_Bool_Exp>;
  affiliateStartedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  affiliateSubscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  affiliateSubscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  affiliateTier?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  courseProgress?: InputMaybe<Course_Progress_Bool_Exp>;
  courseProgress_aggregate?: InputMaybe<Course_Progress_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  discordAccessToken?: InputMaybe<String_Comparison_Exp>;
  discordAvatar?: InputMaybe<String_Comparison_Exp>;
  discordDiscriminator?: InputMaybe<String_Comparison_Exp>;
  discordEmail?: InputMaybe<String_Comparison_Exp>;
  discordFlags?: InputMaybe<Int_Comparison_Exp>;
  discordGuilds?: InputMaybe<Jsonb_Comparison_Exp>;
  discordId?: InputMaybe<String_Comparison_Exp>;
  discordLocale?: InputMaybe<String_Comparison_Exp>;
  discordMfaEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  discordPublicFlags?: InputMaybe<Int_Comparison_Exp>;
  discordRefreshToken?: InputMaybe<String_Comparison_Exp>;
  discordScope?: InputMaybe<String_Comparison_Exp>;
  discordTokenExpiresIn?: InputMaybe<Int_Comparison_Exp>;
  discordTokenType?: InputMaybe<String_Comparison_Exp>;
  discordTokenUpdatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  discordUsername?: InputMaybe<String_Comparison_Exp>;
  discordVerified?: InputMaybe<Boolean_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  emailInsights?: InputMaybe<Boolean_Comparison_Exp>;
  emailIsFlagged?: InputMaybe<Boolean_Comparison_Exp>;
  employer?: InputMaybe<String_Comparison_Exp>;
  employerFinraHits?: InputMaybe<Int_Comparison_Exp>;
  employerIsFlagged?: InputMaybe<Boolean_Comparison_Exp>;
  employmentProfessionalStatus?: InputMaybe<String_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  flowConfigurations?: InputMaybe<Flow_Configurations_Bool_Exp>;
  flowConfigurations_aggregate?: InputMaybe<Flow_Configurations_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  invoices?: InputMaybe<Invoices_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Bool_Exp>;
  isDashboardLifetime?: InputMaybe<Boolean_Comparison_Exp>;
  isSoundEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  isTechnicalAnalysisLifetime?: InputMaybe<Boolean_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  launchAccessEndsAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  nameIsFlagged?: InputMaybe<Boolean_Comparison_Exp>;
  opcSavedStrategies?: InputMaybe<Opc_Saved_Strategies_Bool_Exp>;
  opcSavedStrategies_aggregate?: InputMaybe<Opc_Saved_Strategies_Aggregate_Bool_Exp>;
  opraAgreementCompletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  opraAllTerms?: InputMaybe<Boolean_Comparison_Exp>;
  opraNotProfessional?: InputMaybe<Boolean_Comparison_Exp>;
  opraPersonalUse?: InputMaybe<Boolean_Comparison_Exp>;
  opraQualifyingPerson?: InputMaybe<Boolean_Comparison_Exp>;
  opraTos?: InputMaybe<Boolean_Comparison_Exp>;
  opraWillUpdateDetails?: InputMaybe<Boolean_Comparison_Exp>;
  optionFlowFilters?: InputMaybe<Jsonb_Comparison_Exp>;
  paypalEmail?: InputMaybe<String_Comparison_Exp>;
  personFinraHits?: InputMaybe<Int_Comparison_Exp>;
  probabilityOfProfessional?: InputMaybe<String_Comparison_Exp>;
  sales?: InputMaybe<Sales_Bool_Exp>;
  sales_aggregate?: InputMaybe<Sales_Aggregate_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  statusOfNonProAgreement?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  stripeCustomerId?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  tickerResearchAllViews?: InputMaybe<Ticker_Research_All_Views_Bool_Exp>;
  tickerResearchAllViews_aggregate?: InputMaybe<Ticker_Research_All_Views_Aggregate_Bool_Exp>;
  tickerResearchDailyViews?: InputMaybe<Ticker_Research_Daily_Views_Bool_Exp>;
  tickerResearchDailyViews_aggregate?: InputMaybe<Ticker_Research_Daily_Views_Aggregate_Bool_Exp>;
  timezoneLocation?: InputMaybe<Timezone_Location_Enum_Comparison_Exp>;
  tradingviewAccessActiveAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  tradingviewAccessInactiveAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  tradingviewAccessStatus?: InputMaybe<String_Comparison_Exp>;
  tradingviewUsername?: InputMaybe<String_Comparison_Exp>;
  tradingviewUsernameAddedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  tradingviewUsernameCaseSensitive?: InputMaybe<String_Comparison_Exp>;
  tradingviewUsernameInvalidAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  usagePings?: InputMaybe<Usage_Ping_Bool_Exp>;
  usagePings_aggregate?: InputMaybe<Usage_Ping_Aggregate_Bool_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  usernameCaseSensitive?: InputMaybe<String_Comparison_Exp>;
  watchlist?: InputMaybe<Watch_List_Bool_Exp>;
  watchlist_aggregate?: InputMaybe<Watch_List_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export const Users_Constraint = {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey: 'users_email_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey: 'users_pkey',
  /** unique or primary key constraint on columns "stripeCustomerId" */
  UsersStripeCustomerIdKey: 'users_stripeCustomerId_key',
  /** unique or primary key constraint on columns "usernameCaseSensitive" */
  UsersUsernameCaseSensitiveKey: 'users_usernameCaseSensitive_key',
  /** unique or primary key constraint on columns "username" */
  UsersUsernameKey: 'users_username_key'
} as const;

export type Users_Constraint = typeof Users_Constraint[keyof typeof Users_Constraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  discordGuilds?: InputMaybe<Array<Scalars['String']>>;
  optionFlowFilters?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  discordGuilds?: InputMaybe<Scalars['Int']>;
  optionFlowFilters?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  discordGuilds?: InputMaybe<Scalars['String']>;
  optionFlowFilters?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  affiliateRevenueShare?: InputMaybe<Scalars['numeric']>;
  discordFlags?: InputMaybe<Scalars['Int']>;
  discordPublicFlags?: InputMaybe<Scalars['Int']>;
  discordTokenExpiresIn?: InputMaybe<Scalars['Int']>;
  employerFinraHits?: InputMaybe<Scalars['Int']>;
  personFinraHits?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  addressIsFlagged?: InputMaybe<Scalars['Boolean']>;
  addressIsMatched?: InputMaybe<Scalars['Boolean']>;
  affiliateEndedAt?: InputMaybe<Scalars['timestamptz']>;
  affiliateLinkClicks?: InputMaybe<Affiliate_Link_Clicks_Arr_Rel_Insert_Input>;
  affiliatePayouts?: InputMaybe<Affiliate_Payouts_Arr_Rel_Insert_Input>;
  affiliateReferralClickCounts?: InputMaybe<Affiliate_Referral_Click_Counts_Arr_Rel_Insert_Input>;
  affiliateRevenueShare?: InputMaybe<Scalars['numeric']>;
  affiliateSales?: InputMaybe<Sales_Arr_Rel_Insert_Input>;
  affiliateStartedAt?: InputMaybe<Scalars['timestamptz']>;
  affiliateSubscriptions?: InputMaybe<Subscriptions_Arr_Rel_Insert_Input>;
  affiliateTier?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  courseProgress?: InputMaybe<Course_Progress_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discordAccessToken?: InputMaybe<Scalars['String']>;
  discordAvatar?: InputMaybe<Scalars['String']>;
  discordDiscriminator?: InputMaybe<Scalars['String']>;
  discordEmail?: InputMaybe<Scalars['String']>;
  discordFlags?: InputMaybe<Scalars['Int']>;
  discordGuilds?: InputMaybe<Scalars['jsonb']>;
  discordId?: InputMaybe<Scalars['String']>;
  discordLocale?: InputMaybe<Scalars['String']>;
  discordMfaEnabled?: InputMaybe<Scalars['Boolean']>;
  discordPublicFlags?: InputMaybe<Scalars['Int']>;
  discordRefreshToken?: InputMaybe<Scalars['String']>;
  discordScope?: InputMaybe<Scalars['String']>;
  discordTokenExpiresIn?: InputMaybe<Scalars['Int']>;
  discordTokenType?: InputMaybe<Scalars['String']>;
  discordTokenUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  discordUsername?: InputMaybe<Scalars['String']>;
  discordVerified?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  emailInsights?: InputMaybe<Scalars['Boolean']>;
  emailIsFlagged?: InputMaybe<Scalars['Boolean']>;
  employer?: InputMaybe<Scalars['String']>;
  employerFinraHits?: InputMaybe<Scalars['Int']>;
  employerIsFlagged?: InputMaybe<Scalars['Boolean']>;
  employmentProfessionalStatus?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  flowConfigurations?: InputMaybe<Flow_Configurations_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  invoices?: InputMaybe<Invoices_Arr_Rel_Insert_Input>;
  isDashboardLifetime?: InputMaybe<Scalars['Boolean']>;
  isSoundEnabled?: InputMaybe<Scalars['Boolean']>;
  isTechnicalAnalysisLifetime?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  launchAccessEndsAt?: InputMaybe<Scalars['timestamptz']>;
  nameIsFlagged?: InputMaybe<Scalars['Boolean']>;
  opcSavedStrategies?: InputMaybe<Opc_Saved_Strategies_Arr_Rel_Insert_Input>;
  opraAgreementCompletedAt?: InputMaybe<Scalars['timestamptz']>;
  opraAllTerms?: InputMaybe<Scalars['Boolean']>;
  opraNotProfessional?: InputMaybe<Scalars['Boolean']>;
  opraPersonalUse?: InputMaybe<Scalars['Boolean']>;
  opraQualifyingPerson?: InputMaybe<Scalars['Boolean']>;
  opraTos?: InputMaybe<Scalars['Boolean']>;
  opraWillUpdateDetails?: InputMaybe<Scalars['Boolean']>;
  optionFlowFilters?: InputMaybe<Scalars['jsonb']>;
  paypalEmail?: InputMaybe<Scalars['String']>;
  personFinraHits?: InputMaybe<Scalars['Int']>;
  probabilityOfProfessional?: InputMaybe<Scalars['String']>;
  sales?: InputMaybe<Sales_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  statusOfNonProAgreement?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  subscriptions?: InputMaybe<Subscriptions_Arr_Rel_Insert_Input>;
  tickerResearchAllViews?: InputMaybe<Ticker_Research_All_Views_Arr_Rel_Insert_Input>;
  tickerResearchDailyViews?: InputMaybe<Ticker_Research_Daily_Views_Arr_Rel_Insert_Input>;
  timezoneLocation?: InputMaybe<Timezone_Location_Enum>;
  tradingviewAccessActiveAt?: InputMaybe<Scalars['timestamptz']>;
  tradingviewAccessInactiveAt?: InputMaybe<Scalars['timestamptz']>;
  tradingviewAccessStatus?: InputMaybe<Scalars['String']>;
  tradingviewUsername?: InputMaybe<Scalars['String']>;
  tradingviewUsernameAddedAt?: InputMaybe<Scalars['timestamptz']>;
  tradingviewUsernameCaseSensitive?: InputMaybe<Scalars['String']>;
  tradingviewUsernameInvalidAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usagePings?: InputMaybe<Usage_Ping_Arr_Rel_Insert_Input>;
  /** This is also used as the affiliate ID */
  username?: InputMaybe<Scalars['String']>;
  usernameCaseSensitive?: InputMaybe<Scalars['String']>;
  watchlist?: InputMaybe<Watch_List_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  affiliateEndedAt?: Maybe<Scalars['timestamptz']>;
  affiliateRevenueShare?: Maybe<Scalars['numeric']>;
  affiliateStartedAt?: Maybe<Scalars['timestamptz']>;
  affiliateTier?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  discordAccessToken?: Maybe<Scalars['String']>;
  discordAvatar?: Maybe<Scalars['String']>;
  discordDiscriminator?: Maybe<Scalars['String']>;
  discordEmail?: Maybe<Scalars['String']>;
  discordFlags?: Maybe<Scalars['Int']>;
  discordId?: Maybe<Scalars['String']>;
  discordLocale?: Maybe<Scalars['String']>;
  discordPublicFlags?: Maybe<Scalars['Int']>;
  discordRefreshToken?: Maybe<Scalars['String']>;
  discordScope?: Maybe<Scalars['String']>;
  discordTokenExpiresIn?: Maybe<Scalars['Int']>;
  discordTokenType?: Maybe<Scalars['String']>;
  discordTokenUpdatedAt?: Maybe<Scalars['timestamptz']>;
  discordUsername?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employer?: Maybe<Scalars['String']>;
  employerFinraHits?: Maybe<Scalars['Int']>;
  employmentProfessionalStatus?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  launchAccessEndsAt?: Maybe<Scalars['timestamptz']>;
  opraAgreementCompletedAt?: Maybe<Scalars['timestamptz']>;
  paypalEmail?: Maybe<Scalars['String']>;
  personFinraHits?: Maybe<Scalars['Int']>;
  probabilityOfProfessional?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  statusOfNonProAgreement?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  tradingviewAccessActiveAt?: Maybe<Scalars['timestamptz']>;
  tradingviewAccessInactiveAt?: Maybe<Scalars['timestamptz']>;
  tradingviewAccessStatus?: Maybe<Scalars['String']>;
  tradingviewUsername?: Maybe<Scalars['String']>;
  tradingviewUsernameAddedAt?: Maybe<Scalars['timestamptz']>;
  tradingviewUsernameCaseSensitive?: Maybe<Scalars['String']>;
  tradingviewUsernameInvalidAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** This is also used as the affiliate ID */
  username?: Maybe<Scalars['String']>;
  usernameCaseSensitive?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  affiliateEndedAt?: Maybe<Scalars['timestamptz']>;
  affiliateRevenueShare?: Maybe<Scalars['numeric']>;
  affiliateStartedAt?: Maybe<Scalars['timestamptz']>;
  affiliateTier?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  discordAccessToken?: Maybe<Scalars['String']>;
  discordAvatar?: Maybe<Scalars['String']>;
  discordDiscriminator?: Maybe<Scalars['String']>;
  discordEmail?: Maybe<Scalars['String']>;
  discordFlags?: Maybe<Scalars['Int']>;
  discordId?: Maybe<Scalars['String']>;
  discordLocale?: Maybe<Scalars['String']>;
  discordPublicFlags?: Maybe<Scalars['Int']>;
  discordRefreshToken?: Maybe<Scalars['String']>;
  discordScope?: Maybe<Scalars['String']>;
  discordTokenExpiresIn?: Maybe<Scalars['Int']>;
  discordTokenType?: Maybe<Scalars['String']>;
  discordTokenUpdatedAt?: Maybe<Scalars['timestamptz']>;
  discordUsername?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employer?: Maybe<Scalars['String']>;
  employerFinraHits?: Maybe<Scalars['Int']>;
  employmentProfessionalStatus?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  launchAccessEndsAt?: Maybe<Scalars['timestamptz']>;
  opraAgreementCompletedAt?: Maybe<Scalars['timestamptz']>;
  paypalEmail?: Maybe<Scalars['String']>;
  personFinraHits?: Maybe<Scalars['Int']>;
  probabilityOfProfessional?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  statusOfNonProAgreement?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  tradingviewAccessActiveAt?: Maybe<Scalars['timestamptz']>;
  tradingviewAccessInactiveAt?: Maybe<Scalars['timestamptz']>;
  tradingviewAccessStatus?: Maybe<Scalars['String']>;
  tradingviewUsername?: Maybe<Scalars['String']>;
  tradingviewUsernameAddedAt?: Maybe<Scalars['timestamptz']>;
  tradingviewUsernameCaseSensitive?: Maybe<Scalars['String']>;
  tradingviewUsernameInvalidAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** This is also used as the affiliate ID */
  username?: Maybe<Scalars['String']>;
  usernameCaseSensitive?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  addressIsFlagged?: InputMaybe<Order_By>;
  addressIsMatched?: InputMaybe<Order_By>;
  affiliateEndedAt?: InputMaybe<Order_By>;
  affiliateLinkClicks_aggregate?: InputMaybe<Affiliate_Link_Clicks_Aggregate_Order_By>;
  affiliatePayouts_aggregate?: InputMaybe<Affiliate_Payouts_Aggregate_Order_By>;
  affiliateReferralClickCounts_aggregate?: InputMaybe<Affiliate_Referral_Click_Counts_Aggregate_Order_By>;
  affiliateRevenueShare?: InputMaybe<Order_By>;
  affiliateSales_aggregate?: InputMaybe<Sales_Aggregate_Order_By>;
  affiliateStartedAt?: InputMaybe<Order_By>;
  affiliateSubscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  affiliateTier?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  courseProgress_aggregate?: InputMaybe<Course_Progress_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  discordAccessToken?: InputMaybe<Order_By>;
  discordAvatar?: InputMaybe<Order_By>;
  discordDiscriminator?: InputMaybe<Order_By>;
  discordEmail?: InputMaybe<Order_By>;
  discordFlags?: InputMaybe<Order_By>;
  discordGuilds?: InputMaybe<Order_By>;
  discordId?: InputMaybe<Order_By>;
  discordLocale?: InputMaybe<Order_By>;
  discordMfaEnabled?: InputMaybe<Order_By>;
  discordPublicFlags?: InputMaybe<Order_By>;
  discordRefreshToken?: InputMaybe<Order_By>;
  discordScope?: InputMaybe<Order_By>;
  discordTokenExpiresIn?: InputMaybe<Order_By>;
  discordTokenType?: InputMaybe<Order_By>;
  discordTokenUpdatedAt?: InputMaybe<Order_By>;
  discordUsername?: InputMaybe<Order_By>;
  discordVerified?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emailInsights?: InputMaybe<Order_By>;
  emailIsFlagged?: InputMaybe<Order_By>;
  employer?: InputMaybe<Order_By>;
  employerFinraHits?: InputMaybe<Order_By>;
  employerIsFlagged?: InputMaybe<Order_By>;
  employmentProfessionalStatus?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  flowConfigurations_aggregate?: InputMaybe<Flow_Configurations_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Order_By>;
  isDashboardLifetime?: InputMaybe<Order_By>;
  isSoundEnabled?: InputMaybe<Order_By>;
  isTechnicalAnalysisLifetime?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  launchAccessEndsAt?: InputMaybe<Order_By>;
  nameIsFlagged?: InputMaybe<Order_By>;
  opcSavedStrategies_aggregate?: InputMaybe<Opc_Saved_Strategies_Aggregate_Order_By>;
  opraAgreementCompletedAt?: InputMaybe<Order_By>;
  opraAllTerms?: InputMaybe<Order_By>;
  opraNotProfessional?: InputMaybe<Order_By>;
  opraPersonalUse?: InputMaybe<Order_By>;
  opraQualifyingPerson?: InputMaybe<Order_By>;
  opraTos?: InputMaybe<Order_By>;
  opraWillUpdateDetails?: InputMaybe<Order_By>;
  optionFlowFilters?: InputMaybe<Order_By>;
  paypalEmail?: InputMaybe<Order_By>;
  personFinraHits?: InputMaybe<Order_By>;
  probabilityOfProfessional?: InputMaybe<Order_By>;
  sales_aggregate?: InputMaybe<Sales_Aggregate_Order_By>;
  state?: InputMaybe<Order_By>;
  statusOfNonProAgreement?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  tickerResearchAllViews_aggregate?: InputMaybe<Ticker_Research_All_Views_Aggregate_Order_By>;
  tickerResearchDailyViews_aggregate?: InputMaybe<Ticker_Research_Daily_Views_Aggregate_Order_By>;
  timezoneLocation?: InputMaybe<Order_By>;
  tradingviewAccessActiveAt?: InputMaybe<Order_By>;
  tradingviewAccessInactiveAt?: InputMaybe<Order_By>;
  tradingviewAccessStatus?: InputMaybe<Order_By>;
  tradingviewUsername?: InputMaybe<Order_By>;
  tradingviewUsernameAddedAt?: InputMaybe<Order_By>;
  tradingviewUsernameCaseSensitive?: InputMaybe<Order_By>;
  tradingviewUsernameInvalidAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  usagePings_aggregate?: InputMaybe<Usage_Ping_Aggregate_Order_By>;
  username?: InputMaybe<Order_By>;
  usernameCaseSensitive?: InputMaybe<Order_By>;
  watchlist_aggregate?: InputMaybe<Watch_List_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  discordGuilds?: InputMaybe<Scalars['jsonb']>;
  optionFlowFilters?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export const Users_Select_Column = {
  /** column name */
  AddressIsFlagged: 'addressIsFlagged',
  /** column name */
  AddressIsMatched: 'addressIsMatched',
  /** column name */
  AffiliateEndedAt: 'affiliateEndedAt',
  /** column name */
  AffiliateRevenueShare: 'affiliateRevenueShare',
  /** column name */
  AffiliateStartedAt: 'affiliateStartedAt',
  /** column name */
  AffiliateTier: 'affiliateTier',
  /** column name */
  City: 'city',
  /** column name */
  Country: 'country',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DiscordAccessToken: 'discordAccessToken',
  /** column name */
  DiscordAvatar: 'discordAvatar',
  /** column name */
  DiscordDiscriminator: 'discordDiscriminator',
  /** column name */
  DiscordEmail: 'discordEmail',
  /** column name */
  DiscordFlags: 'discordFlags',
  /** column name */
  DiscordGuilds: 'discordGuilds',
  /** column name */
  DiscordId: 'discordId',
  /** column name */
  DiscordLocale: 'discordLocale',
  /** column name */
  DiscordMfaEnabled: 'discordMfaEnabled',
  /** column name */
  DiscordPublicFlags: 'discordPublicFlags',
  /** column name */
  DiscordRefreshToken: 'discordRefreshToken',
  /** column name */
  DiscordScope: 'discordScope',
  /** column name */
  DiscordTokenExpiresIn: 'discordTokenExpiresIn',
  /** column name */
  DiscordTokenType: 'discordTokenType',
  /** column name */
  DiscordTokenUpdatedAt: 'discordTokenUpdatedAt',
  /** column name */
  DiscordUsername: 'discordUsername',
  /** column name */
  DiscordVerified: 'discordVerified',
  /** column name */
  Email: 'email',
  /** column name */
  EmailInsights: 'emailInsights',
  /** column name */
  EmailIsFlagged: 'emailIsFlagged',
  /** column name */
  Employer: 'employer',
  /** column name */
  EmployerFinraHits: 'employerFinraHits',
  /** column name */
  EmployerIsFlagged: 'employerIsFlagged',
  /** column name */
  EmploymentProfessionalStatus: 'employmentProfessionalStatus',
  /** column name */
  FirstName: 'firstName',
  /** column name */
  Id: 'id',
  /** column name */
  IsDashboardLifetime: 'isDashboardLifetime',
  /** column name */
  IsSoundEnabled: 'isSoundEnabled',
  /** column name */
  IsTechnicalAnalysisLifetime: 'isTechnicalAnalysisLifetime',
  /** column name */
  LastName: 'lastName',
  /** column name */
  LaunchAccessEndsAt: 'launchAccessEndsAt',
  /** column name */
  NameIsFlagged: 'nameIsFlagged',
  /** column name */
  OpraAgreementCompletedAt: 'opraAgreementCompletedAt',
  /** column name */
  OpraAllTerms: 'opraAllTerms',
  /** column name */
  OpraNotProfessional: 'opraNotProfessional',
  /** column name */
  OpraPersonalUse: 'opraPersonalUse',
  /** column name */
  OpraQualifyingPerson: 'opraQualifyingPerson',
  /** column name */
  OpraTos: 'opraTos',
  /** column name */
  OpraWillUpdateDetails: 'opraWillUpdateDetails',
  /** column name */
  OptionFlowFilters: 'optionFlowFilters',
  /** column name */
  PaypalEmail: 'paypalEmail',
  /** column name */
  PersonFinraHits: 'personFinraHits',
  /** column name */
  ProbabilityOfProfessional: 'probabilityOfProfessional',
  /** column name */
  State: 'state',
  /** column name */
  StatusOfNonProAgreement: 'statusOfNonProAgreement',
  /** column name */
  Street: 'street',
  /** column name */
  StripeCustomerId: 'stripeCustomerId',
  /** column name */
  TimezoneLocation: 'timezoneLocation',
  /** column name */
  TradingviewAccessActiveAt: 'tradingviewAccessActiveAt',
  /** column name */
  TradingviewAccessInactiveAt: 'tradingviewAccessInactiveAt',
  /** column name */
  TradingviewAccessStatus: 'tradingviewAccessStatus',
  /** column name */
  TradingviewUsername: 'tradingviewUsername',
  /** column name */
  TradingviewUsernameAddedAt: 'tradingviewUsernameAddedAt',
  /** column name */
  TradingviewUsernameCaseSensitive: 'tradingviewUsernameCaseSensitive',
  /** column name */
  TradingviewUsernameInvalidAt: 'tradingviewUsernameInvalidAt',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Username: 'username',
  /** column name */
  UsernameCaseSensitive: 'usernameCaseSensitive'
} as const;

export type Users_Select_Column = typeof Users_Select_Column[keyof typeof Users_Select_Column];
/** input type for updating data in table "users" */
export type Users_Set_Input = {
  addressIsFlagged?: InputMaybe<Scalars['Boolean']>;
  addressIsMatched?: InputMaybe<Scalars['Boolean']>;
  affiliateEndedAt?: InputMaybe<Scalars['timestamptz']>;
  affiliateRevenueShare?: InputMaybe<Scalars['numeric']>;
  affiliateStartedAt?: InputMaybe<Scalars['timestamptz']>;
  affiliateTier?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discordAccessToken?: InputMaybe<Scalars['String']>;
  discordAvatar?: InputMaybe<Scalars['String']>;
  discordDiscriminator?: InputMaybe<Scalars['String']>;
  discordEmail?: InputMaybe<Scalars['String']>;
  discordFlags?: InputMaybe<Scalars['Int']>;
  discordGuilds?: InputMaybe<Scalars['jsonb']>;
  discordId?: InputMaybe<Scalars['String']>;
  discordLocale?: InputMaybe<Scalars['String']>;
  discordMfaEnabled?: InputMaybe<Scalars['Boolean']>;
  discordPublicFlags?: InputMaybe<Scalars['Int']>;
  discordRefreshToken?: InputMaybe<Scalars['String']>;
  discordScope?: InputMaybe<Scalars['String']>;
  discordTokenExpiresIn?: InputMaybe<Scalars['Int']>;
  discordTokenType?: InputMaybe<Scalars['String']>;
  discordTokenUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  discordUsername?: InputMaybe<Scalars['String']>;
  discordVerified?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  emailInsights?: InputMaybe<Scalars['Boolean']>;
  emailIsFlagged?: InputMaybe<Scalars['Boolean']>;
  employer?: InputMaybe<Scalars['String']>;
  employerFinraHits?: InputMaybe<Scalars['Int']>;
  employerIsFlagged?: InputMaybe<Scalars['Boolean']>;
  employmentProfessionalStatus?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDashboardLifetime?: InputMaybe<Scalars['Boolean']>;
  isSoundEnabled?: InputMaybe<Scalars['Boolean']>;
  isTechnicalAnalysisLifetime?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  launchAccessEndsAt?: InputMaybe<Scalars['timestamptz']>;
  nameIsFlagged?: InputMaybe<Scalars['Boolean']>;
  opraAgreementCompletedAt?: InputMaybe<Scalars['timestamptz']>;
  opraAllTerms?: InputMaybe<Scalars['Boolean']>;
  opraNotProfessional?: InputMaybe<Scalars['Boolean']>;
  opraPersonalUse?: InputMaybe<Scalars['Boolean']>;
  opraQualifyingPerson?: InputMaybe<Scalars['Boolean']>;
  opraTos?: InputMaybe<Scalars['Boolean']>;
  opraWillUpdateDetails?: InputMaybe<Scalars['Boolean']>;
  optionFlowFilters?: InputMaybe<Scalars['jsonb']>;
  paypalEmail?: InputMaybe<Scalars['String']>;
  personFinraHits?: InputMaybe<Scalars['Int']>;
  probabilityOfProfessional?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  statusOfNonProAgreement?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  timezoneLocation?: InputMaybe<Timezone_Location_Enum>;
  tradingviewAccessActiveAt?: InputMaybe<Scalars['timestamptz']>;
  tradingviewAccessInactiveAt?: InputMaybe<Scalars['timestamptz']>;
  tradingviewAccessStatus?: InputMaybe<Scalars['String']>;
  tradingviewUsername?: InputMaybe<Scalars['String']>;
  tradingviewUsernameAddedAt?: InputMaybe<Scalars['timestamptz']>;
  tradingviewUsernameCaseSensitive?: InputMaybe<Scalars['String']>;
  tradingviewUsernameInvalidAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** This is also used as the affiliate ID */
  username?: InputMaybe<Scalars['String']>;
  usernameCaseSensitive?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  affiliateRevenueShare?: Maybe<Scalars['Float']>;
  discordFlags?: Maybe<Scalars['Float']>;
  discordPublicFlags?: Maybe<Scalars['Float']>;
  discordTokenExpiresIn?: Maybe<Scalars['Float']>;
  employerFinraHits?: Maybe<Scalars['Float']>;
  personFinraHits?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  affiliateRevenueShare?: Maybe<Scalars['Float']>;
  discordFlags?: Maybe<Scalars['Float']>;
  discordPublicFlags?: Maybe<Scalars['Float']>;
  discordTokenExpiresIn?: Maybe<Scalars['Float']>;
  employerFinraHits?: Maybe<Scalars['Float']>;
  personFinraHits?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  affiliateRevenueShare?: Maybe<Scalars['Float']>;
  discordFlags?: Maybe<Scalars['Float']>;
  discordPublicFlags?: Maybe<Scalars['Float']>;
  discordTokenExpiresIn?: Maybe<Scalars['Float']>;
  employerFinraHits?: Maybe<Scalars['Float']>;
  personFinraHits?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  addressIsFlagged?: InputMaybe<Scalars['Boolean']>;
  addressIsMatched?: InputMaybe<Scalars['Boolean']>;
  affiliateEndedAt?: InputMaybe<Scalars['timestamptz']>;
  affiliateRevenueShare?: InputMaybe<Scalars['numeric']>;
  affiliateStartedAt?: InputMaybe<Scalars['timestamptz']>;
  affiliateTier?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discordAccessToken?: InputMaybe<Scalars['String']>;
  discordAvatar?: InputMaybe<Scalars['String']>;
  discordDiscriminator?: InputMaybe<Scalars['String']>;
  discordEmail?: InputMaybe<Scalars['String']>;
  discordFlags?: InputMaybe<Scalars['Int']>;
  discordGuilds?: InputMaybe<Scalars['jsonb']>;
  discordId?: InputMaybe<Scalars['String']>;
  discordLocale?: InputMaybe<Scalars['String']>;
  discordMfaEnabled?: InputMaybe<Scalars['Boolean']>;
  discordPublicFlags?: InputMaybe<Scalars['Int']>;
  discordRefreshToken?: InputMaybe<Scalars['String']>;
  discordScope?: InputMaybe<Scalars['String']>;
  discordTokenExpiresIn?: InputMaybe<Scalars['Int']>;
  discordTokenType?: InputMaybe<Scalars['String']>;
  discordTokenUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  discordUsername?: InputMaybe<Scalars['String']>;
  discordVerified?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  emailInsights?: InputMaybe<Scalars['Boolean']>;
  emailIsFlagged?: InputMaybe<Scalars['Boolean']>;
  employer?: InputMaybe<Scalars['String']>;
  employerFinraHits?: InputMaybe<Scalars['Int']>;
  employerIsFlagged?: InputMaybe<Scalars['Boolean']>;
  employmentProfessionalStatus?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDashboardLifetime?: InputMaybe<Scalars['Boolean']>;
  isSoundEnabled?: InputMaybe<Scalars['Boolean']>;
  isTechnicalAnalysisLifetime?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  launchAccessEndsAt?: InputMaybe<Scalars['timestamptz']>;
  nameIsFlagged?: InputMaybe<Scalars['Boolean']>;
  opraAgreementCompletedAt?: InputMaybe<Scalars['timestamptz']>;
  opraAllTerms?: InputMaybe<Scalars['Boolean']>;
  opraNotProfessional?: InputMaybe<Scalars['Boolean']>;
  opraPersonalUse?: InputMaybe<Scalars['Boolean']>;
  opraQualifyingPerson?: InputMaybe<Scalars['Boolean']>;
  opraTos?: InputMaybe<Scalars['Boolean']>;
  opraWillUpdateDetails?: InputMaybe<Scalars['Boolean']>;
  optionFlowFilters?: InputMaybe<Scalars['jsonb']>;
  paypalEmail?: InputMaybe<Scalars['String']>;
  personFinraHits?: InputMaybe<Scalars['Int']>;
  probabilityOfProfessional?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  statusOfNonProAgreement?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  timezoneLocation?: InputMaybe<Timezone_Location_Enum>;
  tradingviewAccessActiveAt?: InputMaybe<Scalars['timestamptz']>;
  tradingviewAccessInactiveAt?: InputMaybe<Scalars['timestamptz']>;
  tradingviewAccessStatus?: InputMaybe<Scalars['String']>;
  tradingviewUsername?: InputMaybe<Scalars['String']>;
  tradingviewUsernameAddedAt?: InputMaybe<Scalars['timestamptz']>;
  tradingviewUsernameCaseSensitive?: InputMaybe<Scalars['String']>;
  tradingviewUsernameInvalidAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  /** This is also used as the affiliate ID */
  username?: InputMaybe<Scalars['String']>;
  usernameCaseSensitive?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  affiliateRevenueShare?: Maybe<Scalars['numeric']>;
  discordFlags?: Maybe<Scalars['Int']>;
  discordPublicFlags?: Maybe<Scalars['Int']>;
  discordTokenExpiresIn?: Maybe<Scalars['Int']>;
  employerFinraHits?: Maybe<Scalars['Int']>;
  personFinraHits?: Maybe<Scalars['Int']>;
};

/** update columns of table "users" */
export const Users_Update_Column = {
  /** column name */
  AddressIsFlagged: 'addressIsFlagged',
  /** column name */
  AddressIsMatched: 'addressIsMatched',
  /** column name */
  AffiliateEndedAt: 'affiliateEndedAt',
  /** column name */
  AffiliateRevenueShare: 'affiliateRevenueShare',
  /** column name */
  AffiliateStartedAt: 'affiliateStartedAt',
  /** column name */
  AffiliateTier: 'affiliateTier',
  /** column name */
  City: 'city',
  /** column name */
  Country: 'country',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DiscordAccessToken: 'discordAccessToken',
  /** column name */
  DiscordAvatar: 'discordAvatar',
  /** column name */
  DiscordDiscriminator: 'discordDiscriminator',
  /** column name */
  DiscordEmail: 'discordEmail',
  /** column name */
  DiscordFlags: 'discordFlags',
  /** column name */
  DiscordGuilds: 'discordGuilds',
  /** column name */
  DiscordId: 'discordId',
  /** column name */
  DiscordLocale: 'discordLocale',
  /** column name */
  DiscordMfaEnabled: 'discordMfaEnabled',
  /** column name */
  DiscordPublicFlags: 'discordPublicFlags',
  /** column name */
  DiscordRefreshToken: 'discordRefreshToken',
  /** column name */
  DiscordScope: 'discordScope',
  /** column name */
  DiscordTokenExpiresIn: 'discordTokenExpiresIn',
  /** column name */
  DiscordTokenType: 'discordTokenType',
  /** column name */
  DiscordTokenUpdatedAt: 'discordTokenUpdatedAt',
  /** column name */
  DiscordUsername: 'discordUsername',
  /** column name */
  DiscordVerified: 'discordVerified',
  /** column name */
  Email: 'email',
  /** column name */
  EmailInsights: 'emailInsights',
  /** column name */
  EmailIsFlagged: 'emailIsFlagged',
  /** column name */
  Employer: 'employer',
  /** column name */
  EmployerFinraHits: 'employerFinraHits',
  /** column name */
  EmployerIsFlagged: 'employerIsFlagged',
  /** column name */
  EmploymentProfessionalStatus: 'employmentProfessionalStatus',
  /** column name */
  FirstName: 'firstName',
  /** column name */
  Id: 'id',
  /** column name */
  IsDashboardLifetime: 'isDashboardLifetime',
  /** column name */
  IsSoundEnabled: 'isSoundEnabled',
  /** column name */
  IsTechnicalAnalysisLifetime: 'isTechnicalAnalysisLifetime',
  /** column name */
  LastName: 'lastName',
  /** column name */
  LaunchAccessEndsAt: 'launchAccessEndsAt',
  /** column name */
  NameIsFlagged: 'nameIsFlagged',
  /** column name */
  OpraAgreementCompletedAt: 'opraAgreementCompletedAt',
  /** column name */
  OpraAllTerms: 'opraAllTerms',
  /** column name */
  OpraNotProfessional: 'opraNotProfessional',
  /** column name */
  OpraPersonalUse: 'opraPersonalUse',
  /** column name */
  OpraQualifyingPerson: 'opraQualifyingPerson',
  /** column name */
  OpraTos: 'opraTos',
  /** column name */
  OpraWillUpdateDetails: 'opraWillUpdateDetails',
  /** column name */
  OptionFlowFilters: 'optionFlowFilters',
  /** column name */
  PaypalEmail: 'paypalEmail',
  /** column name */
  PersonFinraHits: 'personFinraHits',
  /** column name */
  ProbabilityOfProfessional: 'probabilityOfProfessional',
  /** column name */
  State: 'state',
  /** column name */
  StatusOfNonProAgreement: 'statusOfNonProAgreement',
  /** column name */
  Street: 'street',
  /** column name */
  StripeCustomerId: 'stripeCustomerId',
  /** column name */
  TimezoneLocation: 'timezoneLocation',
  /** column name */
  TradingviewAccessActiveAt: 'tradingviewAccessActiveAt',
  /** column name */
  TradingviewAccessInactiveAt: 'tradingviewAccessInactiveAt',
  /** column name */
  TradingviewAccessStatus: 'tradingviewAccessStatus',
  /** column name */
  TradingviewUsername: 'tradingviewUsername',
  /** column name */
  TradingviewUsernameAddedAt: 'tradingviewUsernameAddedAt',
  /** column name */
  TradingviewUsernameCaseSensitive: 'tradingviewUsernameCaseSensitive',
  /** column name */
  TradingviewUsernameInvalidAt: 'tradingviewUsernameInvalidAt',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Username: 'username',
  /** column name */
  UsernameCaseSensitive: 'usernameCaseSensitive'
} as const;

export type Users_Update_Column = typeof Users_Update_Column[keyof typeof Users_Update_Column];
export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  affiliateRevenueShare?: Maybe<Scalars['Float']>;
  discordFlags?: Maybe<Scalars['Float']>;
  discordPublicFlags?: Maybe<Scalars['Float']>;
  discordTokenExpiresIn?: Maybe<Scalars['Float']>;
  employerFinraHits?: Maybe<Scalars['Float']>;
  personFinraHits?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  affiliateRevenueShare?: Maybe<Scalars['Float']>;
  discordFlags?: Maybe<Scalars['Float']>;
  discordPublicFlags?: Maybe<Scalars['Float']>;
  discordTokenExpiresIn?: Maybe<Scalars['Float']>;
  employerFinraHits?: Maybe<Scalars['Float']>;
  personFinraHits?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  affiliateRevenueShare?: Maybe<Scalars['Float']>;
  discordFlags?: Maybe<Scalars['Float']>;
  discordPublicFlags?: Maybe<Scalars['Float']>;
  discordTokenExpiresIn?: Maybe<Scalars['Float']>;
  employerFinraHits?: Maybe<Scalars['Float']>;
  personFinraHits?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "watch_list" */
export type Watch_List = {
  __typename?: 'watch_list';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  isWatching: Scalars['Boolean'];
  ticker: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['String'];
};

/** aggregated selection of "watch_list" */
export type Watch_List_Aggregate = {
  __typename?: 'watch_list_aggregate';
  aggregate?: Maybe<Watch_List_Aggregate_Fields>;
  nodes: Array<Watch_List>;
};

export type Watch_List_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Watch_List_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Watch_List_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Watch_List_Aggregate_Bool_Exp_Count>;
};

export type Watch_List_Aggregate_Bool_Exp_Bool_And = {
  arguments: Watch_List_Select_Column_Watch_List_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Watch_List_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Watch_List_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Watch_List_Select_Column_Watch_List_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Watch_List_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Watch_List_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Watch_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Watch_List_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "watch_list" */
export type Watch_List_Aggregate_Fields = {
  __typename?: 'watch_list_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Watch_List_Max_Fields>;
  min?: Maybe<Watch_List_Min_Fields>;
};


/** aggregate fields of "watch_list" */
export type Watch_List_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Watch_List_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "watch_list" */
export type Watch_List_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Watch_List_Max_Order_By>;
  min?: InputMaybe<Watch_List_Min_Order_By>;
};

/** input type for inserting array relation for remote table "watch_list" */
export type Watch_List_Arr_Rel_Insert_Input = {
  data: Array<Watch_List_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Watch_List_On_Conflict>;
};

/** Boolean expression to filter rows from the table "watch_list". All fields are combined with a logical 'AND'. */
export type Watch_List_Bool_Exp = {
  _and?: InputMaybe<Array<Watch_List_Bool_Exp>>;
  _not?: InputMaybe<Watch_List_Bool_Exp>;
  _or?: InputMaybe<Array<Watch_List_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isWatching?: InputMaybe<Boolean_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "watch_list" */
export const Watch_List_Constraint = {
  /** unique or primary key constraint on columns "id" */
  WatchListPkey: 'watch_list_pkey',
  /** unique or primary key constraint on columns "userId", "ticker" */
  WatchListUserIdTickerKey: 'watch_list_userId_ticker_key'
} as const;

export type Watch_List_Constraint = typeof Watch_List_Constraint[keyof typeof Watch_List_Constraint];
/** input type for inserting data into table "watch_list" */
export type Watch_List_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isWatching?: InputMaybe<Scalars['Boolean']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Watch_List_Max_Fields = {
  __typename?: 'watch_list_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ticker?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "watch_list" */
export type Watch_List_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Watch_List_Min_Fields = {
  __typename?: 'watch_list_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ticker?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "watch_list" */
export type Watch_List_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "watch_list" */
export type Watch_List_Mutation_Response = {
  __typename?: 'watch_list_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Watch_List>;
};

/** on_conflict condition type for table "watch_list" */
export type Watch_List_On_Conflict = {
  constraint: Watch_List_Constraint;
  update_columns?: Array<Watch_List_Update_Column>;
  where?: InputMaybe<Watch_List_Bool_Exp>;
};

/** Ordering options when selecting data from "watch_list". */
export type Watch_List_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isWatching?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: watch_list */
export type Watch_List_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "watch_list" */
export const Watch_List_Select_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  IsWatching: 'isWatching',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Watch_List_Select_Column = typeof Watch_List_Select_Column[keyof typeof Watch_List_Select_Column];
/** select "watch_list_aggregate_bool_exp_bool_and_arguments_columns" columns of table "watch_list" */
export const Watch_List_Select_Column_Watch_List_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = {
  /** column name */
  IsWatching: 'isWatching'
} as const;

export type Watch_List_Select_Column_Watch_List_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = typeof Watch_List_Select_Column_Watch_List_Aggregate_Bool_Exp_Bool_And_Arguments_Columns[keyof typeof Watch_List_Select_Column_Watch_List_Aggregate_Bool_Exp_Bool_And_Arguments_Columns];
/** select "watch_list_aggregate_bool_exp_bool_or_arguments_columns" columns of table "watch_list" */
export const Watch_List_Select_Column_Watch_List_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = {
  /** column name */
  IsWatching: 'isWatching'
} as const;

export type Watch_List_Select_Column_Watch_List_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = typeof Watch_List_Select_Column_Watch_List_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns[keyof typeof Watch_List_Select_Column_Watch_List_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns];
/** input type for updating data in table "watch_list" */
export type Watch_List_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isWatching?: InputMaybe<Scalars['Boolean']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "watch_list" */
export type Watch_List_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Watch_List_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Watch_List_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isWatching?: InputMaybe<Scalars['Boolean']>;
  ticker?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "watch_list" */
export const Watch_List_Update_Column = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeletedAt: 'deletedAt',
  /** column name */
  Id: 'id',
  /** column name */
  IsWatching: 'isWatching',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type Watch_List_Update_Column = typeof Watch_List_Update_Column[keyof typeof Watch_List_Update_Column];
export type Watch_List_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Watch_List_Set_Input>;
  /** filter the rows which have to be updated */
  where: Watch_List_Bool_Exp;
};

/** columns and relationships of "weekly_option_flow" */
export type Weekly_Option_Flow = {
  __typename?: 'weekly_option_flow';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtTypes?: Maybe<Scalars['jsonb']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "weekly_option_flow" */
export type Weekly_Option_FlowPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "weekly_option_flow" */
export type Weekly_Option_Flow_Aggregate = {
  __typename?: 'weekly_option_flow_aggregate';
  aggregate?: Maybe<Weekly_Option_Flow_Aggregate_Fields>;
  nodes: Array<Weekly_Option_Flow>;
};

export type Weekly_Option_Flow_Aggregate_Bool_Exp = {
  count?: InputMaybe<Weekly_Option_Flow_Aggregate_Bool_Exp_Count>;
};

export type Weekly_Option_Flow_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "weekly_option_flow" */
export type Weekly_Option_Flow_Aggregate_Fields = {
  __typename?: 'weekly_option_flow_aggregate_fields';
  avg?: Maybe<Weekly_Option_Flow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Weekly_Option_Flow_Max_Fields>;
  min?: Maybe<Weekly_Option_Flow_Min_Fields>;
  stddev?: Maybe<Weekly_Option_Flow_Stddev_Fields>;
  stddev_pop?: Maybe<Weekly_Option_Flow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Weekly_Option_Flow_Stddev_Samp_Fields>;
  sum?: Maybe<Weekly_Option_Flow_Sum_Fields>;
  var_pop?: Maybe<Weekly_Option_Flow_Var_Pop_Fields>;
  var_samp?: Maybe<Weekly_Option_Flow_Var_Samp_Fields>;
  variance?: Maybe<Weekly_Option_Flow_Variance_Fields>;
};


/** aggregate fields of "weekly_option_flow" */
export type Weekly_Option_Flow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Weekly_Option_Flow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "weekly_option_flow" */
export type Weekly_Option_Flow_Aggregate_Order_By = {
  avg?: InputMaybe<Weekly_Option_Flow_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Weekly_Option_Flow_Max_Order_By>;
  min?: InputMaybe<Weekly_Option_Flow_Min_Order_By>;
  stddev?: InputMaybe<Weekly_Option_Flow_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Weekly_Option_Flow_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Weekly_Option_Flow_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Weekly_Option_Flow_Sum_Order_By>;
  var_pop?: InputMaybe<Weekly_Option_Flow_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Weekly_Option_Flow_Var_Samp_Order_By>;
  variance?: InputMaybe<Weekly_Option_Flow_Variance_Order_By>;
};

/** columns and relationships of "weekly_option_flow_all_sides" */
export type Weekly_Option_Flow_All_Sides = {
  __typename?: 'weekly_option_flow_all_sides';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  prtTypes?: Maybe<Scalars['jsonb']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  /** An object relationship */
  tickerDetails?: Maybe<Ticker_Details>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "weekly_option_flow_all_sides" */
export type Weekly_Option_Flow_All_SidesPrtTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "weekly_option_flow_all_sides" */
export type Weekly_Option_Flow_All_Sides_Aggregate = {
  __typename?: 'weekly_option_flow_all_sides_aggregate';
  aggregate?: Maybe<Weekly_Option_Flow_All_Sides_Aggregate_Fields>;
  nodes: Array<Weekly_Option_Flow_All_Sides>;
};

/** aggregate fields of "weekly_option_flow_all_sides" */
export type Weekly_Option_Flow_All_Sides_Aggregate_Fields = {
  __typename?: 'weekly_option_flow_all_sides_aggregate_fields';
  avg?: Maybe<Weekly_Option_Flow_All_Sides_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Weekly_Option_Flow_All_Sides_Max_Fields>;
  min?: Maybe<Weekly_Option_Flow_All_Sides_Min_Fields>;
  stddev?: Maybe<Weekly_Option_Flow_All_Sides_Stddev_Fields>;
  stddev_pop?: Maybe<Weekly_Option_Flow_All_Sides_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Weekly_Option_Flow_All_Sides_Stddev_Samp_Fields>;
  sum?: Maybe<Weekly_Option_Flow_All_Sides_Sum_Fields>;
  var_pop?: Maybe<Weekly_Option_Flow_All_Sides_Var_Pop_Fields>;
  var_samp?: Maybe<Weekly_Option_Flow_All_Sides_Var_Samp_Fields>;
  variance?: Maybe<Weekly_Option_Flow_All_Sides_Variance_Fields>;
};


/** aggregate fields of "weekly_option_flow_all_sides" */
export type Weekly_Option_Flow_All_Sides_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Weekly_Option_Flow_All_Sides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Weekly_Option_Flow_All_Sides_Avg_Fields = {
  __typename?: 'weekly_option_flow_all_sides_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "weekly_option_flow_all_sides". All fields are combined with a logical 'AND'. */
export type Weekly_Option_Flow_All_Sides_Bool_Exp = {
  _and?: InputMaybe<Array<Weekly_Option_Flow_All_Sides_Bool_Exp>>;
  _not?: InputMaybe<Weekly_Option_Flow_All_Sides_Bool_Exp>;
  _or?: InputMaybe<Array<Weekly_Option_Flow_All_Sides_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Weekly_Option_Flow_All_Sides_Max_Fields = {
  __typename?: 'weekly_option_flow_all_sides_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Weekly_Option_Flow_All_Sides_Min_Fields = {
  __typename?: 'weekly_option_flow_all_sides_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "weekly_option_flow_all_sides". */
export type Weekly_Option_Flow_All_Sides_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** select columns of table "weekly_option_flow_all_sides" */
export const Weekly_Option_Flow_All_Sides_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Weekly_Option_Flow_All_Sides_Select_Column = typeof Weekly_Option_Flow_All_Sides_Select_Column[keyof typeof Weekly_Option_Flow_All_Sides_Select_Column];
/** aggregate stddev on columns */
export type Weekly_Option_Flow_All_Sides_Stddev_Fields = {
  __typename?: 'weekly_option_flow_all_sides_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Weekly_Option_Flow_All_Sides_Stddev_Pop_Fields = {
  __typename?: 'weekly_option_flow_all_sides_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Weekly_Option_Flow_All_Sides_Stddev_Samp_Fields = {
  __typename?: 'weekly_option_flow_all_sides_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "weekly_option_flow_all_sides" */
export type Weekly_Option_Flow_All_Sides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Weekly_Option_Flow_All_Sides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Weekly_Option_Flow_All_Sides_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Weekly_Option_Flow_All_Sides_Sum_Fields = {
  __typename?: 'weekly_option_flow_all_sides_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Weekly_Option_Flow_All_Sides_Var_Pop_Fields = {
  __typename?: 'weekly_option_flow_all_sides_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Weekly_Option_Flow_All_Sides_Var_Samp_Fields = {
  __typename?: 'weekly_option_flow_all_sides_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Weekly_Option_Flow_All_Sides_Variance_Fields = {
  __typename?: 'weekly_option_flow_all_sides_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** input type for inserting array relation for remote table "weekly_option_flow" */
export type Weekly_Option_Flow_Arr_Rel_Insert_Input = {
  data: Array<Weekly_Option_Flow_Insert_Input>;
};

/** aggregate avg on columns */
export type Weekly_Option_Flow_Avg_Fields = {
  __typename?: 'weekly_option_flow_avg_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "weekly_option_flow" */
export type Weekly_Option_Flow_Avg_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "weekly_option_flow". All fields are combined with a logical 'AND'. */
export type Weekly_Option_Flow_Bool_Exp = {
  _and?: InputMaybe<Array<Weekly_Option_Flow_Bool_Exp>>;
  _not?: InputMaybe<Weekly_Option_Flow_Bool_Exp>;
  _or?: InputMaybe<Array<Weekly_Option_Flow_Bool_Exp>>;
  askCount?: InputMaybe<Int_Comparison_Exp>;
  askVolume?: InputMaybe<Int_Comparison_Exp>;
  avgContractsPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgContractsPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgImpliedVolPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgOpenInterestPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  avgPremiumPerTrade?: InputMaybe<Numeric_Comparison_Exp>;
  avgTradesPerDay?: InputMaybe<Numeric_Comparison_Exp>;
  bidCount?: InputMaybe<Int_Comparison_Exp>;
  bidVolume?: InputMaybe<Int_Comparison_Exp>;
  charm?: InputMaybe<Numeric_Comparison_Exp>;
  color?: InputMaybe<Numeric_Comparison_Exp>;
  cp?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currentDailyVolume?: InputMaybe<Int_Comparison_Exp>;
  cxlVolume?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  datetimeCentral?: InputMaybe<Timestamp_Comparison_Exp>;
  datetimeMicroSeconds?: InputMaybe<Int_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAge?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAsk?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeAskSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeBid?: InputMaybe<Numeric_Comparison_Exp>;
  exchangeBidSize?: InputMaybe<Int_Comparison_Exp>;
  exchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  expireDay?: InputMaybe<Int_Comparison_Exp>;
  expireMonth?: InputMaybe<Int_Comparison_Exp>;
  expireYear?: InputMaybe<Int_Comparison_Exp>;
  firstPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  gamma?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  impliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  lambda?: InputMaybe<Numeric_Comparison_Exp>;
  lastExchangeTimestamp?: InputMaybe<Bigint_Comparison_Exp>;
  lastPrintNumber?: InputMaybe<Bigint_Comparison_Exp>;
  marketCap?: InputMaybe<Numeric_Comparison_Exp>;
  multihedge?: InputMaybe<String_Comparison_Exp>;
  nbboAsk?: InputMaybe<Numeric_Comparison_Exp>;
  nbboAskSize?: InputMaybe<Int_Comparison_Exp>;
  nbboBid?: InputMaybe<Numeric_Comparison_Exp>;
  nbboBidSize?: InputMaybe<Int_Comparison_Exp>;
  nbboMidIv?: InputMaybe<Numeric_Comparison_Exp>;
  numberOfGroupedTrades?: InputMaybe<Int_Comparison_Exp>;
  openInterest?: InputMaybe<Int_Comparison_Exp>;
  orderType?: InputMaybe<String_Comparison_Exp>;
  otmPercent?: InputMaybe<Numeric_Comparison_Exp>;
  premium?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceExternalApi?: InputMaybe<Numeric_Comparison_Exp>;
  probTouch?: InputMaybe<Numeric_Comparison_Exp>;
  prtProbability?: InputMaybe<Numeric_Comparison_Exp>;
  prtTypes?: InputMaybe<Jsonb_Comparison_Exp>;
  rho?: InputMaybe<Numeric_Comparison_Exp>;
  riskFreeRate?: InputMaybe<Numeric_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  speed?: InputMaybe<Numeric_Comparison_Exp>;
  spot?: InputMaybe<Numeric_Comparison_Exp>;
  strike?: InputMaybe<Numeric_Comparison_Exp>;
  surfAtmVol?: InputMaybe<Numeric_Comparison_Exp>;
  surfPrice?: InputMaybe<Numeric_Comparison_Exp>;
  surfVol?: InputMaybe<Numeric_Comparison_Exp>;
  theta?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  tickerDetails?: InputMaybe<Ticker_Details_Bool_Exp>;
  tradeSide?: InputMaybe<String_Comparison_Exp>;
  ultima?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vanna?: InputMaybe<Numeric_Comparison_Exp>;
  vega?: InputMaybe<Numeric_Comparison_Exp>;
  vera?: InputMaybe<Numeric_Comparison_Exp>;
  veta?: InputMaybe<Numeric_Comparison_Exp>;
  vomma?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalImpliedVol?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalOpenInterest?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalPremium?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalSize?: InputMaybe<Numeric_Comparison_Exp>;
  weeklyTotalTrades?: InputMaybe<Int_Comparison_Exp>;
  yearsToExpiry?: InputMaybe<Numeric_Comparison_Exp>;
  zomma?: InputMaybe<Numeric_Comparison_Exp>;
};

/** input type for inserting data into table "weekly_option_flow" */
export type Weekly_Option_Flow_Insert_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tickerDetails?: InputMaybe<Ticker_Details_Obj_Rel_Insert_Input>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Weekly_Option_Flow_Max_Fields = {
  __typename?: 'weekly_option_flow_max_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "weekly_option_flow" */
export type Weekly_Option_Flow_Max_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Weekly_Option_Flow_Min_Fields = {
  __typename?: 'weekly_option_flow_min_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  cp?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  datetimeCentral?: Maybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  multihedge?: Maybe<Scalars['String']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['String']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  tradeSide?: Maybe<Scalars['String']>;
  ultima?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "weekly_option_flow" */
export type Weekly_Option_Flow_Min_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "weekly_option_flow". */
export type Weekly_Option_Flow_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  cp?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  datetimeCentral?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  multihedge?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  orderType?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  prtTypes?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  tickerDetails?: InputMaybe<Ticker_Details_Order_By>;
  tradeSide?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** select columns of table "weekly_option_flow" */
export const Weekly_Option_Flow_Select_Column = {
  /** column name */
  AskCount: 'askCount',
  /** column name */
  AskVolume: 'askVolume',
  /** column name */
  AvgContractsPerDay: 'avgContractsPerDay',
  /** column name */
  AvgContractsPerTrade: 'avgContractsPerTrade',
  /** column name */
  AvgImpliedVolPerTrade: 'avgImpliedVolPerTrade',
  /** column name */
  AvgOpenInterestPerDay: 'avgOpenInterestPerDay',
  /** column name */
  AvgOpenInterestPerTrade: 'avgOpenInterestPerTrade',
  /** column name */
  AvgPremiumPerDay: 'avgPremiumPerDay',
  /** column name */
  AvgPremiumPerTrade: 'avgPremiumPerTrade',
  /** column name */
  AvgTradesPerDay: 'avgTradesPerDay',
  /** column name */
  BidCount: 'bidCount',
  /** column name */
  BidVolume: 'bidVolume',
  /** column name */
  Charm: 'charm',
  /** column name */
  Color: 'color',
  /** column name */
  Cp: 'cp',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  CurrentDailyVolume: 'currentDailyVolume',
  /** column name */
  CxlVolume: 'cxlVolume',
  /** column name */
  Date: 'date',
  /** column name */
  DatetimeCentral: 'datetimeCentral',
  /** column name */
  DatetimeMicroSeconds: 'datetimeMicroSeconds',
  /** column name */
  Delta: 'delta',
  /** column name */
  ExchangeAge: 'exchangeAge',
  /** column name */
  ExchangeAsk: 'exchangeAsk',
  /** column name */
  ExchangeAskSize: 'exchangeAskSize',
  /** column name */
  ExchangeBid: 'exchangeBid',
  /** column name */
  ExchangeBidSize: 'exchangeBidSize',
  /** column name */
  ExchangeTimestamp: 'exchangeTimestamp',
  /** column name */
  ExpireDay: 'expireDay',
  /** column name */
  ExpireMonth: 'expireMonth',
  /** column name */
  ExpireYear: 'expireYear',
  /** column name */
  FirstPrintNumber: 'firstPrintNumber',
  /** column name */
  Gamma: 'gamma',
  /** column name */
  Id: 'id',
  /** column name */
  ImpliedVol: 'impliedVol',
  /** column name */
  Lambda: 'lambda',
  /** column name */
  LastExchangeTimestamp: 'lastExchangeTimestamp',
  /** column name */
  LastPrintNumber: 'lastPrintNumber',
  /** column name */
  MarketCap: 'marketCap',
  /** column name */
  Multihedge: 'multihedge',
  /** column name */
  NbboAsk: 'nbboAsk',
  /** column name */
  NbboAskSize: 'nbboAskSize',
  /** column name */
  NbboBid: 'nbboBid',
  /** column name */
  NbboBidSize: 'nbboBidSize',
  /** column name */
  NbboMidIv: 'nbboMidIv',
  /** column name */
  NumberOfGroupedTrades: 'numberOfGroupedTrades',
  /** column name */
  OpenInterest: 'openInterest',
  /** column name */
  OrderType: 'orderType',
  /** column name */
  OtmPercent: 'otmPercent',
  /** column name */
  Premium: 'premium',
  /** column name */
  Price: 'price',
  /** column name */
  PriceExternalApi: 'priceExternalApi',
  /** column name */
  ProbTouch: 'probTouch',
  /** column name */
  PrtProbability: 'prtProbability',
  /** column name */
  PrtTypes: 'prtTypes',
  /** column name */
  Rho: 'rho',
  /** column name */
  RiskFreeRate: 'riskFreeRate',
  /** column name */
  Size: 'size',
  /** column name */
  Speed: 'speed',
  /** column name */
  Spot: 'spot',
  /** column name */
  Strike: 'strike',
  /** column name */
  SurfAtmVol: 'surfAtmVol',
  /** column name */
  SurfPrice: 'surfPrice',
  /** column name */
  SurfVol: 'surfVol',
  /** column name */
  Theta: 'theta',
  /** column name */
  Ticker: 'ticker',
  /** column name */
  TradeSide: 'tradeSide',
  /** column name */
  Ultima: 'ultima',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Vanna: 'vanna',
  /** column name */
  Vega: 'vega',
  /** column name */
  Vera: 'vera',
  /** column name */
  Veta: 'veta',
  /** column name */
  Vomma: 'vomma',
  /** column name */
  WeeklyTotalImpliedVol: 'weeklyTotalImpliedVol',
  /** column name */
  WeeklyTotalOpenInterest: 'weeklyTotalOpenInterest',
  /** column name */
  WeeklyTotalPremium: 'weeklyTotalPremium',
  /** column name */
  WeeklyTotalSize: 'weeklyTotalSize',
  /** column name */
  WeeklyTotalTrades: 'weeklyTotalTrades',
  /** column name */
  YearsToExpiry: 'yearsToExpiry',
  /** column name */
  Zomma: 'zomma'
} as const;

export type Weekly_Option_Flow_Select_Column = typeof Weekly_Option_Flow_Select_Column[keyof typeof Weekly_Option_Flow_Select_Column];
/** aggregate stddev on columns */
export type Weekly_Option_Flow_Stddev_Fields = {
  __typename?: 'weekly_option_flow_stddev_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "weekly_option_flow" */
export type Weekly_Option_Flow_Stddev_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Weekly_Option_Flow_Stddev_Pop_Fields = {
  __typename?: 'weekly_option_flow_stddev_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "weekly_option_flow" */
export type Weekly_Option_Flow_Stddev_Pop_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Weekly_Option_Flow_Stddev_Samp_Fields = {
  __typename?: 'weekly_option_flow_stddev_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "weekly_option_flow" */
export type Weekly_Option_Flow_Stddev_Samp_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "weekly_option_flow" */
export type Weekly_Option_Flow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Weekly_Option_Flow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Weekly_Option_Flow_Stream_Cursor_Value_Input = {
  askCount?: InputMaybe<Scalars['Int']>;
  askVolume?: InputMaybe<Scalars['Int']>;
  avgContractsPerDay?: InputMaybe<Scalars['numeric']>;
  avgContractsPerTrade?: InputMaybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: InputMaybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerDay?: InputMaybe<Scalars['numeric']>;
  avgPremiumPerTrade?: InputMaybe<Scalars['numeric']>;
  avgTradesPerDay?: InputMaybe<Scalars['numeric']>;
  bidCount?: InputMaybe<Scalars['Int']>;
  bidVolume?: InputMaybe<Scalars['Int']>;
  charm?: InputMaybe<Scalars['numeric']>;
  color?: InputMaybe<Scalars['numeric']>;
  cp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currentDailyVolume?: InputMaybe<Scalars['Int']>;
  cxlVolume?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  datetimeCentral?: InputMaybe<Scalars['timestamp']>;
  datetimeMicroSeconds?: InputMaybe<Scalars['Int']>;
  delta?: InputMaybe<Scalars['numeric']>;
  exchangeAge?: InputMaybe<Scalars['numeric']>;
  exchangeAsk?: InputMaybe<Scalars['numeric']>;
  exchangeAskSize?: InputMaybe<Scalars['Int']>;
  exchangeBid?: InputMaybe<Scalars['numeric']>;
  exchangeBidSize?: InputMaybe<Scalars['Int']>;
  exchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
  firstPrintNumber?: InputMaybe<Scalars['bigint']>;
  gamma?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  impliedVol?: InputMaybe<Scalars['numeric']>;
  lambda?: InputMaybe<Scalars['numeric']>;
  lastExchangeTimestamp?: InputMaybe<Scalars['bigint']>;
  lastPrintNumber?: InputMaybe<Scalars['bigint']>;
  marketCap?: InputMaybe<Scalars['numeric']>;
  multihedge?: InputMaybe<Scalars['String']>;
  nbboAsk?: InputMaybe<Scalars['numeric']>;
  nbboAskSize?: InputMaybe<Scalars['Int']>;
  nbboBid?: InputMaybe<Scalars['numeric']>;
  nbboBidSize?: InputMaybe<Scalars['Int']>;
  nbboMidIv?: InputMaybe<Scalars['numeric']>;
  numberOfGroupedTrades?: InputMaybe<Scalars['Int']>;
  openInterest?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  otmPercent?: InputMaybe<Scalars['numeric']>;
  premium?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceExternalApi?: InputMaybe<Scalars['numeric']>;
  probTouch?: InputMaybe<Scalars['numeric']>;
  prtProbability?: InputMaybe<Scalars['numeric']>;
  prtTypes?: InputMaybe<Scalars['jsonb']>;
  rho?: InputMaybe<Scalars['numeric']>;
  riskFreeRate?: InputMaybe<Scalars['numeric']>;
  size?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  spot?: InputMaybe<Scalars['numeric']>;
  strike?: InputMaybe<Scalars['numeric']>;
  surfAtmVol?: InputMaybe<Scalars['numeric']>;
  surfPrice?: InputMaybe<Scalars['numeric']>;
  surfVol?: InputMaybe<Scalars['numeric']>;
  theta?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  tradeSide?: InputMaybe<Scalars['String']>;
  ultima?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vanna?: InputMaybe<Scalars['numeric']>;
  vega?: InputMaybe<Scalars['numeric']>;
  vera?: InputMaybe<Scalars['numeric']>;
  veta?: InputMaybe<Scalars['numeric']>;
  vomma?: InputMaybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: InputMaybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: InputMaybe<Scalars['numeric']>;
  weeklyTotalPremium?: InputMaybe<Scalars['numeric']>;
  weeklyTotalSize?: InputMaybe<Scalars['numeric']>;
  weeklyTotalTrades?: InputMaybe<Scalars['Int']>;
  yearsToExpiry?: InputMaybe<Scalars['numeric']>;
  zomma?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Weekly_Option_Flow_Sum_Fields = {
  __typename?: 'weekly_option_flow_sum_fields';
  askCount?: Maybe<Scalars['Int']>;
  askVolume?: Maybe<Scalars['Int']>;
  avgContractsPerDay?: Maybe<Scalars['numeric']>;
  avgContractsPerTrade?: Maybe<Scalars['numeric']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerDay?: Maybe<Scalars['numeric']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['numeric']>;
  avgPremiumPerDay?: Maybe<Scalars['numeric']>;
  avgPremiumPerTrade?: Maybe<Scalars['numeric']>;
  avgTradesPerDay?: Maybe<Scalars['numeric']>;
  bidCount?: Maybe<Scalars['Int']>;
  bidVolume?: Maybe<Scalars['Int']>;
  charm?: Maybe<Scalars['numeric']>;
  color?: Maybe<Scalars['numeric']>;
  currentDailyVolume?: Maybe<Scalars['Int']>;
  cxlVolume?: Maybe<Scalars['Int']>;
  datetimeMicroSeconds?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['numeric']>;
  exchangeAge?: Maybe<Scalars['numeric']>;
  exchangeAsk?: Maybe<Scalars['numeric']>;
  exchangeAskSize?: Maybe<Scalars['Int']>;
  exchangeBid?: Maybe<Scalars['numeric']>;
  exchangeBidSize?: Maybe<Scalars['Int']>;
  exchangeTimestamp?: Maybe<Scalars['bigint']>;
  expireDay?: Maybe<Scalars['Int']>;
  expireMonth?: Maybe<Scalars['Int']>;
  expireYear?: Maybe<Scalars['Int']>;
  firstPrintNumber?: Maybe<Scalars['bigint']>;
  gamma?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  impliedVol?: Maybe<Scalars['numeric']>;
  lambda?: Maybe<Scalars['numeric']>;
  lastExchangeTimestamp?: Maybe<Scalars['bigint']>;
  lastPrintNumber?: Maybe<Scalars['bigint']>;
  marketCap?: Maybe<Scalars['numeric']>;
  nbboAsk?: Maybe<Scalars['numeric']>;
  nbboAskSize?: Maybe<Scalars['Int']>;
  nbboBid?: Maybe<Scalars['numeric']>;
  nbboBidSize?: Maybe<Scalars['Int']>;
  nbboMidIv?: Maybe<Scalars['numeric']>;
  numberOfGroupedTrades?: Maybe<Scalars['Int']>;
  openInterest?: Maybe<Scalars['Int']>;
  otmPercent?: Maybe<Scalars['numeric']>;
  premium?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  priceExternalApi?: Maybe<Scalars['numeric']>;
  probTouch?: Maybe<Scalars['numeric']>;
  prtProbability?: Maybe<Scalars['numeric']>;
  rho?: Maybe<Scalars['numeric']>;
  riskFreeRate?: Maybe<Scalars['numeric']>;
  size?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  spot?: Maybe<Scalars['numeric']>;
  strike?: Maybe<Scalars['numeric']>;
  surfAtmVol?: Maybe<Scalars['numeric']>;
  surfPrice?: Maybe<Scalars['numeric']>;
  surfVol?: Maybe<Scalars['numeric']>;
  theta?: Maybe<Scalars['numeric']>;
  ultima?: Maybe<Scalars['numeric']>;
  vanna?: Maybe<Scalars['numeric']>;
  vega?: Maybe<Scalars['numeric']>;
  vera?: Maybe<Scalars['numeric']>;
  veta?: Maybe<Scalars['numeric']>;
  vomma?: Maybe<Scalars['numeric']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['numeric']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['numeric']>;
  weeklyTotalPremium?: Maybe<Scalars['numeric']>;
  weeklyTotalSize?: Maybe<Scalars['numeric']>;
  weeklyTotalTrades?: Maybe<Scalars['Int']>;
  yearsToExpiry?: Maybe<Scalars['numeric']>;
  zomma?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "weekly_option_flow" */
export type Weekly_Option_Flow_Sum_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Weekly_Option_Flow_Var_Pop_Fields = {
  __typename?: 'weekly_option_flow_var_pop_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "weekly_option_flow" */
export type Weekly_Option_Flow_Var_Pop_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Weekly_Option_Flow_Var_Samp_Fields = {
  __typename?: 'weekly_option_flow_var_samp_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "weekly_option_flow" */
export type Weekly_Option_Flow_Var_Samp_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Weekly_Option_Flow_Variance_Fields = {
  __typename?: 'weekly_option_flow_variance_fields';
  askCount?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Float']>;
  avgContractsPerDay?: Maybe<Scalars['Float']>;
  avgContractsPerTrade?: Maybe<Scalars['Float']>;
  avgImpliedVolPerTrade?: Maybe<Scalars['Float']>;
  avgOpenInterestPerDay?: Maybe<Scalars['Float']>;
  avgOpenInterestPerTrade?: Maybe<Scalars['Float']>;
  avgPremiumPerDay?: Maybe<Scalars['Float']>;
  avgPremiumPerTrade?: Maybe<Scalars['Float']>;
  avgTradesPerDay?: Maybe<Scalars['Float']>;
  bidCount?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Float']>;
  charm?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['Float']>;
  currentDailyVolume?: Maybe<Scalars['Float']>;
  cxlVolume?: Maybe<Scalars['Float']>;
  datetimeMicroSeconds?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  exchangeAge?: Maybe<Scalars['Float']>;
  exchangeAsk?: Maybe<Scalars['Float']>;
  exchangeAskSize?: Maybe<Scalars['Float']>;
  exchangeBid?: Maybe<Scalars['Float']>;
  exchangeBidSize?: Maybe<Scalars['Float']>;
  exchangeTimestamp?: Maybe<Scalars['Float']>;
  expireDay?: Maybe<Scalars['Float']>;
  expireMonth?: Maybe<Scalars['Float']>;
  expireYear?: Maybe<Scalars['Float']>;
  firstPrintNumber?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  impliedVol?: Maybe<Scalars['Float']>;
  lambda?: Maybe<Scalars['Float']>;
  lastExchangeTimestamp?: Maybe<Scalars['Float']>;
  lastPrintNumber?: Maybe<Scalars['Float']>;
  marketCap?: Maybe<Scalars['Float']>;
  nbboAsk?: Maybe<Scalars['Float']>;
  nbboAskSize?: Maybe<Scalars['Float']>;
  nbboBid?: Maybe<Scalars['Float']>;
  nbboBidSize?: Maybe<Scalars['Float']>;
  nbboMidIv?: Maybe<Scalars['Float']>;
  numberOfGroupedTrades?: Maybe<Scalars['Float']>;
  openInterest?: Maybe<Scalars['Float']>;
  otmPercent?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceExternalApi?: Maybe<Scalars['Float']>;
  probTouch?: Maybe<Scalars['Float']>;
  prtProbability?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  riskFreeRate?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
  surfAtmVol?: Maybe<Scalars['Float']>;
  surfPrice?: Maybe<Scalars['Float']>;
  surfVol?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  ultima?: Maybe<Scalars['Float']>;
  vanna?: Maybe<Scalars['Float']>;
  vega?: Maybe<Scalars['Float']>;
  vera?: Maybe<Scalars['Float']>;
  veta?: Maybe<Scalars['Float']>;
  vomma?: Maybe<Scalars['Float']>;
  weeklyTotalImpliedVol?: Maybe<Scalars['Float']>;
  weeklyTotalOpenInterest?: Maybe<Scalars['Float']>;
  weeklyTotalPremium?: Maybe<Scalars['Float']>;
  weeklyTotalSize?: Maybe<Scalars['Float']>;
  weeklyTotalTrades?: Maybe<Scalars['Float']>;
  yearsToExpiry?: Maybe<Scalars['Float']>;
  zomma?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "weekly_option_flow" */
export type Weekly_Option_Flow_Variance_Order_By = {
  askCount?: InputMaybe<Order_By>;
  askVolume?: InputMaybe<Order_By>;
  avgContractsPerDay?: InputMaybe<Order_By>;
  avgContractsPerTrade?: InputMaybe<Order_By>;
  avgImpliedVolPerTrade?: InputMaybe<Order_By>;
  avgOpenInterestPerDay?: InputMaybe<Order_By>;
  avgOpenInterestPerTrade?: InputMaybe<Order_By>;
  avgPremiumPerDay?: InputMaybe<Order_By>;
  avgPremiumPerTrade?: InputMaybe<Order_By>;
  avgTradesPerDay?: InputMaybe<Order_By>;
  bidCount?: InputMaybe<Order_By>;
  bidVolume?: InputMaybe<Order_By>;
  charm?: InputMaybe<Order_By>;
  color?: InputMaybe<Order_By>;
  currentDailyVolume?: InputMaybe<Order_By>;
  cxlVolume?: InputMaybe<Order_By>;
  datetimeMicroSeconds?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  exchangeAge?: InputMaybe<Order_By>;
  exchangeAsk?: InputMaybe<Order_By>;
  exchangeAskSize?: InputMaybe<Order_By>;
  exchangeBid?: InputMaybe<Order_By>;
  exchangeBidSize?: InputMaybe<Order_By>;
  exchangeTimestamp?: InputMaybe<Order_By>;
  expireDay?: InputMaybe<Order_By>;
  expireMonth?: InputMaybe<Order_By>;
  expireYear?: InputMaybe<Order_By>;
  firstPrintNumber?: InputMaybe<Order_By>;
  gamma?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impliedVol?: InputMaybe<Order_By>;
  lambda?: InputMaybe<Order_By>;
  lastExchangeTimestamp?: InputMaybe<Order_By>;
  lastPrintNumber?: InputMaybe<Order_By>;
  marketCap?: InputMaybe<Order_By>;
  nbboAsk?: InputMaybe<Order_By>;
  nbboAskSize?: InputMaybe<Order_By>;
  nbboBid?: InputMaybe<Order_By>;
  nbboBidSize?: InputMaybe<Order_By>;
  nbboMidIv?: InputMaybe<Order_By>;
  numberOfGroupedTrades?: InputMaybe<Order_By>;
  openInterest?: InputMaybe<Order_By>;
  otmPercent?: InputMaybe<Order_By>;
  premium?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceExternalApi?: InputMaybe<Order_By>;
  probTouch?: InputMaybe<Order_By>;
  prtProbability?: InputMaybe<Order_By>;
  rho?: InputMaybe<Order_By>;
  riskFreeRate?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  speed?: InputMaybe<Order_By>;
  spot?: InputMaybe<Order_By>;
  strike?: InputMaybe<Order_By>;
  surfAtmVol?: InputMaybe<Order_By>;
  surfPrice?: InputMaybe<Order_By>;
  surfVol?: InputMaybe<Order_By>;
  theta?: InputMaybe<Order_By>;
  ultima?: InputMaybe<Order_By>;
  vanna?: InputMaybe<Order_By>;
  vega?: InputMaybe<Order_By>;
  vera?: InputMaybe<Order_By>;
  veta?: InputMaybe<Order_By>;
  vomma?: InputMaybe<Order_By>;
  weeklyTotalImpliedVol?: InputMaybe<Order_By>;
  weeklyTotalOpenInterest?: InputMaybe<Order_By>;
  weeklyTotalPremium?: InputMaybe<Order_By>;
  weeklyTotalSize?: InputMaybe<Order_By>;
  weeklyTotalTrades?: InputMaybe<Order_By>;
  yearsToExpiry?: InputMaybe<Order_By>;
  zomma?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "xid8". All fields are combined with logical 'AND'. */
export type Xid8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['xid8']>;
  _gt?: InputMaybe<Scalars['xid8']>;
  _gte?: InputMaybe<Scalars['xid8']>;
  _in?: InputMaybe<Array<Scalars['xid8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['xid8']>;
  _lte?: InputMaybe<Scalars['xid8']>;
  _neq?: InputMaybe<Scalars['xid8']>;
  _nin?: InputMaybe<Array<Scalars['xid8']>>;
};

export type GetDarkPoolLevelsQueryVariables = Exact<{
  ticker: Scalars['String'];
}>;


export type GetDarkPoolLevelsQuery = { __typename?: 'query_root', dark_pool_levels: Array<{ __typename?: 'dark_pool_levels', amount?: any | null, prints?: any | null, price?: any | null, ticker?: string | null, volume?: any | null }> };

export type GetDarkPoolLevelsMonthlyQueryVariables = Exact<{
  ticker: Scalars['String'];
}>;


export type GetDarkPoolLevelsMonthlyQuery = { __typename?: 'query_root', dark_pool_levels_monthly: Array<{ __typename?: 'dark_pool_levels_monthly', amount?: any | null, prints?: any | null, price?: any | null, ticker?: string | null, volume?: any | null }> };

export type GetDarkPoolTradesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDarkPoolTradesQuery = { __typename?: 'query_root', equity_print_flow: Array<{ __typename?: 'equity_print_flow', amount?: any | null, ask?: any | null, askSize?: number | null, bid?: any | null, bidSize?: number | null, createdAt?: any | null, date?: any | null, exchangeId?: number | null, id?: any | null, percentAboveAsk?: any | null, percentBelowBid?: any | null, price?: any | null, size?: number | null, ticker?: string | null, timestampIso?: any | null, tradeSide?: string | null, avgVolume?: any | null, dayVolume?: any | null, avgPrice?: any | null, high?: any | null, isSignatureVolume?: boolean | null, isOutsideDailyRange?: boolean | null, isPriceGreaterThanOpen?: boolean | null, lastTradePrice?: any | null, low?: any | null, marketCap?: any | null, open?: any | null, isEtf?: boolean | null, isSignatureEtfTicker?: boolean | null, tickerDetails?: { __typename?: 'ticker_details', name?: string | null, ticker: string, sector?: string | null } | null }> };

export type GetDarkPoolTradesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDarkPoolTradesCountQuery = { __typename?: 'query_root', equity_print_flow_aggregate: { __typename?: 'equity_print_flow_aggregate', aggregate?: { __typename?: 'equity_print_flow_aggregate_fields', count: number } | null } };

export type DarkPoolTradeFieldsFragment = { __typename?: 'equity_print_feed_baseline', id: any, amount: any, ask: any, askSize: number, avgPrice: any, avgVolume: any, bid: any, bidSize: number, createdAt: any, date: any, dayOverDayPercentChange: any, dayOverDayPriceChange: any, dayVolume: any, exchangeId: number, externalTradeId: string, high: any, isEtf: boolean, isOutsideDailyRange: boolean, isPriceGreaterThanDailyAverage: boolean, isPriceGreaterThanOpen: boolean, isSignatureEtfTicker: boolean, isSignatureVolume: boolean, lastTradePrice: any, low: any, marketCap: any, open: any, percentAboveAsk?: any | null, percentBelowBid?: any | null, percentOfAvgVolume?: any | null, percentOfMarketCap?: any | null, percentOfTodaysVolume?: any | null, prevClose: any, prevHigh: any, prevLow: any, price: any, realtimePrice: any, size: number, tapeId: number, ticker: string, timestamp: any, timestampIso: any, tradeConditions: any, tradeSide: string, updatedAt: any };

export type GetDarkPoolTradesBaselineQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetDarkPoolTradesBaselineQuery = { __typename?: 'query_root', equity_print_feed_baseline: Array<{ __typename?: 'equity_print_feed_baseline', id: any, amount: any, ask: any, askSize: number, avgPrice: any, avgVolume: any, bid: any, bidSize: number, createdAt: any, date: any, dayOverDayPercentChange: any, dayOverDayPriceChange: any, dayVolume: any, exchangeId: number, externalTradeId: string, high: any, isEtf: boolean, isOutsideDailyRange: boolean, isPriceGreaterThanDailyAverage: boolean, isPriceGreaterThanOpen: boolean, isSignatureEtfTicker: boolean, isSignatureVolume: boolean, lastTradePrice: any, low: any, marketCap: any, open: any, percentAboveAsk?: any | null, percentBelowBid?: any | null, percentOfAvgVolume?: any | null, percentOfMarketCap?: any | null, percentOfTodaysVolume?: any | null, prevClose: any, prevHigh: any, prevLow: any, price: any, realtimePrice: any, size: number, tapeId: number, ticker: string, timestamp: any, timestampIso: any, tradeConditions: any, tradeSide: string, updatedAt: any, tickerDetails?: { __typename?: 'ticker_details', name?: string | null, ticker: string, sector?: string | null } | null }> };

export type GetDarkPoolTradesCountBaselineQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDarkPoolTradesCountBaselineQuery = { __typename?: 'query_root', equity_print_feed_baseline_aggregate: { __typename?: 'equity_print_feed_baseline_aggregate', aggregate?: { __typename?: 'equity_print_feed_baseline_aggregate_fields', count: number } | null } };

export type GetDarkPoolTradesFullQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetDarkPoolTradesFullQuery = { __typename?: 'query_root', equity_print_flow_full: Array<{ __typename?: 'equity_print_flow_full', id?: any | null, amount?: any | null, ask?: any | null, askSize?: number | null, avgPrice?: any | null, avgVolume?: any | null, bid?: any | null, bidSize?: number | null, createdAt?: any | null, date?: any | null, dayOverDayPercentChange?: any | null, dayOverDayPriceChange?: any | null, dayVolume?: any | null, exchangeId?: number | null, externalTradeId?: string | null, high?: any | null, isEtf?: boolean | null, isOutsideDailyRange?: boolean | null, isPriceGreaterThanDailyAverage?: boolean | null, isPriceGreaterThanOpen?: boolean | null, isSignatureEtfTicker?: boolean | null, isSignatureVolume?: boolean | null, lastTradePrice?: any | null, low?: any | null, marketCap?: any | null, open?: any | null, percentAboveAsk?: any | null, percentBelowBid?: any | null, percentOfAvgVolume?: any | null, percentOfMarketCap?: any | null, percentOfTodaysVolume?: any | null, prevClose?: any | null, prevHigh?: any | null, prevLow?: any | null, price?: any | null, realtimePrice?: any | null, size?: number | null, tapeId?: number | null, ticker?: string | null, timestamp?: any | null, timestampIso?: any | null, tradeConditions?: any | null, tradeSide?: string | null, updatedAt?: any | null }> };

export type GetDarkPoolTradesCountFullQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDarkPoolTradesCountFullQuery = { __typename?: 'query_root', equity_print_flow_full_aggregate: { __typename?: 'equity_print_flow_full_aggregate', aggregate?: { __typename?: 'equity_print_flow_full_aggregate_fields', count: number } | null } };

export type GetHistoricalDarkPoolBaselineQueryVariables = Exact<{
  limit: Scalars['Int'];
  startDate: Scalars['date'];
  endDate: Scalars['date'];
}>;


export type GetHistoricalDarkPoolBaselineQuery = { __typename?: 'query_root', equity_print_feed_baseline: Array<{ __typename?: 'equity_print_feed_baseline', id: any, amount: any, ask: any, askSize: number, avgPrice: any, avgVolume: any, bid: any, bidSize: number, createdAt: any, date: any, dayOverDayPercentChange: any, dayOverDayPriceChange: any, dayVolume: any, exchangeId: number, externalTradeId: string, high: any, isEtf: boolean, isOutsideDailyRange: boolean, isPriceGreaterThanDailyAverage: boolean, isPriceGreaterThanOpen: boolean, isSignatureEtfTicker: boolean, isSignatureVolume: boolean, lastTradePrice: any, low: any, marketCap: any, open: any, percentAboveAsk?: any | null, percentBelowBid?: any | null, percentOfAvgVolume?: any | null, percentOfMarketCap?: any | null, percentOfTodaysVolume?: any | null, prevClose: any, prevHigh: any, prevLow: any, price: any, realtimePrice: any, size: number, tapeId: number, ticker: string, timestamp: any, timestampIso: any, tradeConditions: any, tradeSide: string, updatedAt: any, tickerDetails?: { __typename?: 'ticker_details', name?: string | null, ticker: string, sector?: string | null } | null }> };

export type GetHistoricalDarkPoolWithTickersBaselineQueryVariables = Exact<{
  limit: Scalars['Int'];
  tickers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  startDate: Scalars['date'];
  endDate: Scalars['date'];
}>;


export type GetHistoricalDarkPoolWithTickersBaselineQuery = { __typename?: 'query_root', equity_print_feed_baseline: Array<{ __typename?: 'equity_print_feed_baseline', id: any, amount: any, ask: any, askSize: number, avgPrice: any, avgVolume: any, bid: any, bidSize: number, createdAt: any, date: any, dayOverDayPercentChange: any, dayOverDayPriceChange: any, dayVolume: any, exchangeId: number, externalTradeId: string, high: any, isEtf: boolean, isOutsideDailyRange: boolean, isPriceGreaterThanDailyAverage: boolean, isPriceGreaterThanOpen: boolean, isSignatureEtfTicker: boolean, isSignatureVolume: boolean, lastTradePrice: any, low: any, marketCap: any, open: any, percentAboveAsk?: any | null, percentBelowBid?: any | null, percentOfAvgVolume?: any | null, percentOfMarketCap?: any | null, percentOfTodaysVolume?: any | null, prevClose: any, prevHigh: any, prevLow: any, price: any, realtimePrice: any, size: number, tapeId: number, ticker: string, timestamp: any, timestampIso: any, tradeConditions: any, tradeSide: string, updatedAt: any, tickerDetails?: { __typename?: 'ticker_details', name?: string | null, ticker: string, sector?: string | null } | null }> };

export type HasNewDarkPoolTradesQueryVariables = Exact<{
  since: Scalars['timestamptz'];
}>;


export type HasNewDarkPoolTradesQuery = { __typename?: 'query_root', equity_print_flow: Array<{ __typename?: 'equity_print_flow', id?: any | null, createdAt?: any | null }> };

export type GetMostResearchedTickersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMostResearchedTickersQuery = { __typename?: 'query_root', most_researched_tickers_daily_total: Array<{ __typename?: 'most_researched_tickers_daily_total', count?: any | null, id?: string | null }>, most_researched_tickers_daily_unique: Array<{ __typename?: 'most_researched_tickers_daily_unique', count?: any | null, id?: string | null }> };

export type GetAllAssetAlertSignalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAssetAlertSignalsQuery = { __typename?: 'query_root', asset_signal_alerts: Array<{ __typename?: 'asset_signal_alerts', asset: string, createdAt: any, date: any, id: any, price: any, signal: string, text: string, ticker: string }> };

export type GetAssetAlertSignalsGroupedByAssetQueryVariables = Exact<{
  assets: Array<Asset_Signal_Alerts_Bool_Exp> | Asset_Signal_Alerts_Bool_Exp;
}>;


export type GetAssetAlertSignalsGroupedByAssetQuery = { __typename?: 'query_root', asset_signal_alerts: Array<{ __typename?: 'asset_signal_alerts', asset: string, createdAt: any, date: any, id: any, price: any, signal: string, text: string, ticker: string }> };

export type GetAssetAlertSignalsForAssetClassQueryVariables = Exact<{
  asset: Scalars['String'];
}>;


export type GetAssetAlertSignalsForAssetClassQuery = { __typename?: 'query_root', asset_signal_alerts: Array<{ __typename?: 'asset_signal_alerts', asset: string, createdAt: any, date: any, id: any, price: any, signal: string, text: string, ticker: string }> };

export type GetAssetAlertSignalsByTickerQueryVariables = Exact<{
  asset: Scalars['String'];
  ticker: Scalars['String'];
}>;


export type GetAssetAlertSignalsByTickerQuery = { __typename?: 'query_root', asset_signal_alerts: Array<{ __typename?: 'asset_signal_alerts', asset: string, createdAt: any, date: any, id: any, price: any, signal: string, text: string, ticker: string }> };

export type InsertUsagePingMutationVariables = Exact<{
  pathname?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
  queryString?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
}>;


export type InsertUsagePingMutation = { __typename?: 'mutation_root', insert_usage_ping_one?: { __typename?: 'usage_ping', id: any } | null };

export type OptionFlowTickerFieldsFragment = { __typename?: 'option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null };

export type OptionFlowAllSidesTickerFieldsFragment = { __typename?: 'option_flow_all_sides', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null };

export type FreeOptionFlowTickerFieldsFragment = { __typename?: 'free_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null };

export type TickerOptionFlowTickerFieldsFragment = { __typename?: 'ticker_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null };

export type TickerOptionFlowAllSidesTickerFieldsFragment = { __typename?: 'ticker_option_flow_all_sides', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null };

export type FreeTickerOptionFlowTickerFieldsFragment = { __typename?: 'free_ticker_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null };

export type FullFeedTickerOptionFlowTickerFieldsFragment = { __typename?: 'full_feed_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null };

export type WeeklyOptionFlowTickerFieldsFragment = { __typename?: 'weekly_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null };

export type WeeklyOptionFlowAllSidesTickerFieldsFragment = { __typename?: 'weekly_option_flow_all_sides', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null };

export type OptionFeedFilteredTickerFieldsFragment = { __typename?: 'option_feed_filtered', cp: string, exchangeTimestamp: any, lastExchangeTimestamp?: any | null, expireDay: number, expireMonth: number, expireYear: number, id: any, createdAt: any, openInterest: number, orderType: string, premium: any, price: any, size: number, spot: any, priceExternalApi?: any | null, strike: any, ticker: string, tradeSide: string, currentDailyVolume: number, nbboAsk: any, nbboBid: any, otmPercent: any, date: any, impliedVol: any, delta: any, gamma: any, rho: any, theta: any, vega: any, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry: any, marketCap?: any | null, weeklyTotalSize: any, weeklyTotalTrades: number, weeklyTotalPremium: any, weeklyTotalOpenInterest: any, weeklyTotalImpliedVol: any, avgContractsPerDay: any, avgContractsPerTrade: any, avgImpliedVolPerTrade: any, avgOpenInterestPerDay: any, avgOpenInterestPerTrade: any, avgPremiumPerDay: any, avgPremiumPerTrade: any, avgTradesPerDay: any, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null };

export type UpdateTimezoneLocationMutationVariables = Exact<{
  id: Scalars['String'];
  timezoneLocation: Timezone_Location_Enum;
}>;


export type UpdateTimezoneLocationMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: string, timezoneLocation: Timezone_Location_Enum } | null };

export type UpdateTradingViewUsernameMutationVariables = Exact<{
  id: Scalars['String'];
  tradingviewUsername: Scalars['String'];
  tradingviewUsernameCaseSensitive: Scalars['String'];
}>;


export type UpdateTradingViewUsernameMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: string, tradingviewUsername?: string | null, tradingviewUsernameCaseSensitive?: string | null, tradingviewUsernameAddedAt?: any | null, tradingviewAccessStatus?: string | null, tradingviewAccessActiveAt?: any | null, tradingviewAccessInactiveAt?: any | null } | null };

export type UpdateUserSoundSettingMutationVariables = Exact<{
  id: Scalars['String'];
  isSoundEnabled: Scalars['Boolean'];
}>;


export type UpdateUserSoundSettingMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: string, isSoundEnabled: boolean } | null };

export type GetCurrentUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCurrentUserQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', createdAt: any, email: string, id: string, updatedAt: any, tradingviewUsername?: string | null, tradingviewUsernameCaseSensitive?: string | null, tradingviewUsernameAddedAt?: any | null, tradingviewAccessStatus?: string | null, tradingviewAccessActiveAt?: any | null, tradingviewAccessInactiveAt?: any | null, timezoneLocation: Timezone_Location_Enum, firstName?: string | null, lastName?: string | null, isSoundEnabled: boolean, isDashboardLifetime: boolean, isTechnicalAnalysisLifetime: boolean } | null };

export type GetInsiderTradesQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  where: Insider_Trades_Bool_Exp;
  order_by?: InputMaybe<Array<Insider_Trades_Order_By> | Insider_Trades_Order_By>;
}>;


export type GetInsiderTradesQuery = { __typename?: 'query_root', insider_trades: Array<{ __typename?: 'insider_trades', id: any, formType: string, securityName: string, ticker: string, transactionDate: any, transactionType: string, transactionValue: any, typeOfOwnerCategory: string, typeOfOwner: string, reportingCik: string, reportingName: string, securitiesOwned: any, securitiesTransacted: any, isDirector: boolean, isOfficer: boolean, isTenPercentOwner: boolean, link: string, numberOfTransactions: number, ownerJobTitle: string, price?: any | null, filingDate: string, filingDateTimestamp: any, companyCik: string, changeInPercentOwned?: any | null, acquistionOrDisposition: string, tickerDetails?: { __typename?: 'ticker_details', name?: string | null, ticker: string, sector?: string | null } | null }>, insider_trades_aggregate: { __typename?: 'insider_trades_aggregate', aggregate?: { __typename?: 'insider_trades_aggregate_fields', count: number } | null } };

export type GetInsiderTradesTopTickersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsiderTradesTopTickersQuery = { __typename?: 'query_root', insider_trades_top_long: Array<{ __typename?: 'insider_trades_top_long', netTransactionValue?: any | null, id?: string | null, ticker?: string | null }>, insider_trades_top_short: Array<{ __typename?: 'insider_trades_top_short', id?: string | null, netTransactionValue?: any | null, ticker?: string | null }> };

export type SearchInserTradesByNameQueryVariables = Exact<{
  reportingName: Scalars['String'];
}>;


export type SearchInserTradesByNameQuery = { __typename?: 'query_root', insider_trades: Array<{ __typename?: 'insider_trades', id: any, ticker: string, reportingName: string, reportingCik: string }> };

export type GetOptionsForGexQueryVariables = Exact<{
  ticker: Scalars['String'];
  minOpenInterest?: InputMaybe<Scalars['Int']>;
  expireDay?: InputMaybe<Scalars['Int']>;
  expireMonth?: InputMaybe<Scalars['Int']>;
  expireYear?: InputMaybe<Scalars['Int']>;
}>;


export type GetOptionsForGexQuery = { __typename?: 'query_root', option_flow: Array<{ __typename?: 'option_flow', id?: any | null, ticker?: string | null, strike?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, cp?: string | null, gamma?: any | null, delta?: any | null, openInterest?: number | null, impliedVol?: any | null, nbboAsk?: any | null, nbboBid?: any | null, price?: any | null, currentDailyVolume?: number | null, spot?: any | null }> };

export type GetAllOptionsForGexQueryVariables = Exact<{
  ticker: Scalars['String'];
  minOpenInterest?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllOptionsForGexQuery = { __typename?: 'query_root', option_flow: Array<{ __typename?: 'option_flow', id?: any | null, ticker?: string | null, strike?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, cp?: string | null, gamma?: any | null, delta?: any | null, openInterest?: number | null, impliedVol?: any | null, nbboAsk?: any | null, nbboBid?: any | null, price?: any | null, currentDailyVolume?: number | null, spot?: any | null }> };

export type GetUniqueExpiryDatesQueryVariables = Exact<{
  ticker: Scalars['String'];
}>;


export type GetUniqueExpiryDatesQuery = { __typename?: 'query_root', option_flow: Array<{ __typename?: 'option_flow', expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null }> };

export type GetAggregatedOptionsForGexQueryVariables = Exact<{
  ticker: Scalars['String'];
  minOpenInterest?: InputMaybe<Scalars['Int']>;
}>;


export type GetAggregatedOptionsForGexQuery = { __typename?: 'query_root', option_flow_aggregate: { __typename?: 'option_flow_aggregate', aggregate?: { __typename?: 'option_flow_aggregate_fields', count: number } | null, nodes: Array<{ __typename?: 'option_flow', strike?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, cp?: string | null, gamma?: any | null, openInterest?: number | null, impliedVol?: any | null, spot?: any | null, price?: any | null }> } };

export type GetTradingviewUsernameQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTradingviewUsernameQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', createdAt: any, email: string, id: string, updatedAt: any, tradingviewUsername?: string | null, tradingviewUsernameCaseSensitive?: string | null, tradingviewUsernameAddedAt?: any | null, tradingviewAccessStatus?: string | null, tradingviewAccessActiveAt?: any | null, tradingviewAccessInactiveAt?: any | null } | null };

export type UpsertWatchListItemMutationVariables = Exact<{
  isWatching: Scalars['Boolean'];
  ticker: Scalars['String'];
  userId: Scalars['String'];
}>;


export type UpsertWatchListItemMutation = { __typename?: 'mutation_root', insert_watch_list_one?: { __typename?: 'watch_list', createdAt: any, id: any, isWatching: boolean, ticker: string, updatedAt: any, deletedAt?: any | null, userId: string } | null };

export type SolfDeleteWathclistItemMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SolfDeleteWathclistItemMutation = { __typename?: 'mutation_root', update_watch_list_by_pk?: { __typename?: 'watch_list', createdAt: any, id: any, isWatching: boolean, ticker: string, updatedAt: any, deletedAt?: any | null, userId: string } | null };

export type GetWatchListQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetWatchListQuery = { __typename?: 'query_root', watch_list: Array<{ __typename?: 'watch_list', createdAt: any, id: any, isWatching: boolean, ticker: string, updatedAt: any, deletedAt?: any | null, userId: string }> };

export type GetNewsEventsByKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsEventsByKeyQuery = { __typename?: 'query_root', news_cache_stocks: Array<{ __typename?: 'news_cache_stocks', createdAt: any, id: string, response: any }> };

export type InsertFlowConfigurationsOneMutationVariables = Exact<{
  object: Flow_Configurations_Insert_Input;
}>;


export type InsertFlowConfigurationsOneMutation = { __typename?: 'mutation_root', insert_flow_configurations_one?: { __typename?: 'flow_configurations', id: any, title: string, description?: string | null, configuration: any, userId: string, createdAt: any, updatedAt: any } | null };

export type GetUserFlowConfigurationsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserFlowConfigurationsQuery = { __typename?: 'query_root', flow_configurations: Array<{ __typename?: 'flow_configurations', id: any, title: string, description?: string | null, configuration: any, createdAt: any, updatedAt: any }> };

export type ArchiveFlowConfigurationByPkMutationVariables = Exact<{
  id: Scalars['uuid'];
  archivedAt: Scalars['timestamptz'];
}>;


export type ArchiveFlowConfigurationByPkMutation = { __typename?: 'mutation_root', update_flow_configurations_by_pk?: { __typename?: 'flow_configurations', id: any } | null };

export type GetDarkPoolTradesCountFullFlowQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDarkPoolTradesCountFullFlowQuery = { __typename?: 'query_root', equity_print_flow_full_aggregate: { __typename?: 'equity_print_flow_full_aggregate', aggregate?: { __typename?: 'equity_print_flow_full_aggregate_fields', count: number } | null } };

export type GetLitPoolTradesCountFullFlowQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLitPoolTradesCountFullFlowQuery = { __typename?: 'query_root', equity_print_flow_full_aggregate: { __typename?: 'equity_print_flow_full_aggregate', aggregate?: { __typename?: 'equity_print_flow_full_aggregate_fields', count: number } | null } };

export type GetAllPoolTradesCountFullFlowQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPoolTradesCountFullFlowQuery = { __typename?: 'query_root', equity_print_flow_full_aggregate: { __typename?: 'equity_print_flow_full_aggregate', aggregate?: { __typename?: 'equity_print_flow_full_aggregate_fields', count: number } | null } };

export type GetAffiliateViewerQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAffiliateViewerQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: string, username?: string | null, usernameCaseSensitive?: string | null, affiliateTier: string, affiliateRevenueShare?: any | null, affiliateStartedAt?: any | null, affiliateEndedAt?: any | null, paypalEmail?: string | null, affiliateLinkClicks_aggregate: { __typename?: 'affiliate_link_clicks_aggregate', aggregate?: { __typename?: 'affiliate_link_clicks_aggregate_fields', count: number } | null }, affiliateSubscriptions: Array<{ __typename?: 'subscriptions', id: any, type?: string | null, status: string, createdAt: any, currentPeriodEndsAt?: any | null, canceledAt?: any | null, endedAt?: any | null, cancelAtPeriodEnd?: boolean | null, invoices: Array<{ __typename?: 'invoices', id: any, amountDue: any, amountPaid: any, charges: Array<{ __typename?: 'charges', createdAt: any, id: any, amountPaid: any, amountRefunded: any, affiliateAmountPaid?: any | null }> }> }>, affiliateReferralClickCounts: Array<{ __typename?: 'affiliate_referral_click_counts', affiliateUserId?: string | null, count?: any | null, mostRecentDate?: any | null, referralUrl?: string | null }> } | null };

export type UpdatePaypalEmailMutationVariables = Exact<{
  id: Scalars['String'];
  paypalEmail: Scalars['String'];
}>;


export type UpdatePaypalEmailMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: string, paypalEmail?: string | null } | null };

export type UpdateUserInsightsSettingMutationVariables = Exact<{
  id: Scalars['String'];
  emailInsights: Scalars['Boolean'];
}>;


export type UpdateUserInsightsSettingMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: string, emailInsights: boolean } | null };

export type UpdateUsernameMutationVariables = Exact<{
  id: Scalars['String'];
  username: Scalars['String'];
  usernameCaseSensitive: Scalars['String'];
}>;


export type UpdateUsernameMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: string, username?: string | null, usernameCaseSensitive?: string | null, affiliateStartedAt?: any | null } | null };

export type GetExistingUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetExistingUserQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: string } | null };

export type GetElectronicAgreementQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetElectronicAgreementQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', firstName?: string | null, lastName?: string | null, street?: string | null, city?: string | null, country?: string | null, state?: string | null, employer?: string | null, opraTos: boolean, opraQualifyingPerson: boolean, opraPersonalUse: boolean, opraNotProfessional: boolean, opraWillUpdateDetails: boolean, opraAllTerms: boolean } | null };

export type GetHistoricalOptionFlowQueryVariables = Exact<{
  limit: Scalars['Int'];
  startDate: Scalars['date'];
  endDate: Scalars['date'];
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetHistoricalOptionFlowQuery = { __typename?: 'query_root', option_feed_filtered: Array<{ __typename?: 'option_feed_filtered', cp: string, exchangeTimestamp: any, lastExchangeTimestamp?: any | null, expireDay: number, expireMonth: number, expireYear: number, id: any, createdAt: any, openInterest: number, orderType: string, premium: any, price: any, size: number, spot: any, priceExternalApi?: any | null, strike: any, ticker: string, tradeSide: string, currentDailyVolume: number, nbboAsk: any, nbboBid: any, otmPercent: any, date: any, impliedVol: any, delta: any, gamma: any, rho: any, theta: any, vega: any, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry: any, marketCap?: any | null, weeklyTotalSize: any, weeklyTotalTrades: number, weeklyTotalPremium: any, weeklyTotalOpenInterest: any, weeklyTotalImpliedVol: any, avgContractsPerDay: any, avgContractsPerTrade: any, avgImpliedVolPerTrade: any, avgOpenInterestPerDay: any, avgOpenInterestPerTrade: any, avgPremiumPerDay: any, avgPremiumPerTrade: any, avgTradesPerDay: any, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }>, daily_volume: Array<{ __typename?: 'daily_volume', ticker?: string | null, volume?: any | null }> };

export type GetHistoricalOptionFlowWithTickersQueryVariables = Exact<{
  limit: Scalars['Int'];
  tickers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  startDate: Scalars['date'];
  endDate: Scalars['date'];
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetHistoricalOptionFlowWithTickersQuery = { __typename?: 'query_root', option_feed_filtered: Array<{ __typename?: 'option_feed_filtered', cp: string, exchangeTimestamp: any, lastExchangeTimestamp?: any | null, expireDay: number, expireMonth: number, expireYear: number, id: any, createdAt: any, openInterest: number, orderType: string, premium: any, price: any, size: number, spot: any, priceExternalApi?: any | null, strike: any, ticker: string, tradeSide: string, currentDailyVolume: number, nbboAsk: any, nbboBid: any, otmPercent: any, date: any, impliedVol: any, delta: any, gamma: any, rho: any, theta: any, vega: any, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry: any, marketCap?: any | null, weeklyTotalSize: any, weeklyTotalTrades: number, weeklyTotalPremium: any, weeklyTotalOpenInterest: any, weeklyTotalImpliedVol: any, avgContractsPerDay: any, avgContractsPerTrade: any, avgImpliedVolPerTrade: any, avgOpenInterestPerDay: any, avgOpenInterestPerTrade: any, avgPremiumPerDay: any, avgPremiumPerTrade: any, avgTradesPerDay: any, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }>, daily_volume: Array<{ __typename?: 'daily_volume', ticker?: string | null, volume?: any | null }> };

export type GetOptionFlowQueryVariables = Exact<{
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetOptionFlowQuery = { __typename?: 'query_root', option_flow: Array<{ __typename?: 'option_flow_all_sides', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }>, daily_volume: Array<{ __typename?: 'daily_volume', ticker?: string | null, volume?: any | null }> };

export type GetFreeOptionFlowQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFreeOptionFlowQuery = { __typename?: 'query_root', free_option_flow: Array<{ __typename?: 'free_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }>, daily_volume: Array<{ __typename?: 'daily_volume', ticker?: string | null, volume?: any | null }> };

export type GetFreeOptionFlowCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFreeOptionFlowCountQuery = { __typename?: 'query_root', free_option_flow_aggregate: { __typename?: 'free_option_flow_aggregate', aggregate?: { __typename?: 'free_option_flow_aggregate_fields', count: number } | null } };

export type GetUserForDashboardQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserForDashboardQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: string, opraAgreementCompletedAt?: any | null, optionFlowFilters?: any | null, tradingviewUsername?: string | null, tradingviewUsernameCaseSensitive?: string | null, tradingviewUsernameAddedAt?: any | null, tradingviewAccessStatus?: string | null, tradingviewAccessActiveAt?: any | null, tradingviewAccessInactiveAt?: any | null } | null };

export type UpdateUserOptionFlowFiltersMutationVariables = Exact<{
  id: Scalars['String'];
  optionFlowFilters: Scalars['jsonb'];
}>;


export type UpdateUserOptionFlowFiltersMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: string, optionFlowFilters?: any | null } | null };

export type HasNewOptionFlowQueryVariables = Exact<{
  since: Scalars['timestamptz'];
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type HasNewOptionFlowQuery = { __typename?: 'query_root', option_flow: Array<{ __typename?: 'option_flow_all_sides', id?: any | null, createdAt?: any | null }> };

export type HasNewFreeOptionFlowQueryVariables = Exact<{
  since: Scalars['timestamptz'];
}>;


export type HasNewFreeOptionFlowQuery = { __typename?: 'query_root', free_option_flow: Array<{ __typename?: 'free_option_flow', id?: any | null, createdAt?: any | null }> };

export type GetOpcStrategiesForUserQueryVariables = Exact<{
  userId: Scalars['String'];
  expiration?: InputMaybe<Scalars['date']>;
}>;


export type GetOpcStrategiesForUserQuery = { __typename?: 'query_root', opc_saved_strategies: Array<{ __typename?: 'opc_saved_strategies', id: any, breakEvenPrices: any, cash: any, createdAt: any, delta: any, description: string, expiration: any, gamma: any, impliedVolatility: any, isStrategyShared: boolean, maxLoss?: any | null, maxProfit?: any | null, netCreditDebit: any, premiumTransacted: any, probabilityOfProfit: any, profitIndex: any, rho: any, riskFreeRate: any, stockPrice: any, stockShares: any, theta: any, ticker: string, title: string, value: any, vega: any, positions: Array<{ __typename?: 'opc_saved_strategy_positions', id: any, createdAt: any, delta: any, expiration: any, gamma: any, impliedVolatility: any, optionType: string, premium: any, purchaseDirection: string, quantity: number, rho: any, strike: any, theta: any, value: any, vega: any }> }> };

export type InsertOpcSavedStrategyMutationVariables = Exact<{
  object?: InputMaybe<Opc_Saved_Strategies_Insert_Input>;
}>;


export type InsertOpcSavedStrategyMutation = { __typename?: 'mutation_root', insert_opc_saved_strategies_one?: { __typename?: 'opc_saved_strategies', id: any, breakEvenPrices: any, cash: any, createdAt: any, delta: any, description: string, expiration: any, gamma: any, impliedVolatility: any, isStrategyShared: boolean, maxLoss?: any | null, maxProfit?: any | null, netCreditDebit: any, premiumTransacted: any, probabilityOfProfit: any, profitIndex: any, rho: any, riskFreeRate: any, stockPrice: any, stockShares: any, theta: any, ticker: string, title: string, value: any, vega: any, positions: Array<{ __typename?: 'opc_saved_strategy_positions', id: any, createdAt: any, delta: any, expiration: any, gamma: any, impliedVolatility: any, optionType: string, premium: any, purchaseDirection: string, quantity: number, rho: any, strike: any, theta: any, value: any, vega: any }> } | null };

export type ArchiveOpcSavedStrategyMutationVariables = Exact<{
  id: Scalars['uuid'];
  archivedAt: Scalars['timestamptz'];
}>;


export type ArchiveOpcSavedStrategyMutation = { __typename?: 'mutation_root', update_opc_saved_strategies_by_pk?: { __typename?: 'opc_saved_strategies', id: any } | null };

export type GetTickerOptionFlowQueryVariables = Exact<{
  ticker: Scalars['String'];
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sinceDate: Scalars['date'];
}>;


export type GetTickerOptionFlowQuery = { __typename?: 'query_root', ticker_option_flow: Array<{ __typename?: 'ticker_option_flow_all_sides', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }> };

export type GetTickerOptionFlowCountQueryVariables = Exact<{
  ticker: Scalars['String'];
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetTickerOptionFlowCountQuery = { __typename?: 'query_root', ticker_option_flow_aggregate: { __typename?: 'ticker_option_flow_all_sides_aggregate', aggregate?: { __typename?: 'ticker_option_flow_all_sides_aggregate_fields', count: number } | null } };

export type GetFullFeedTickerOptionFlowQueryVariables = Exact<{
  ticker: Scalars['String'];
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetFullFeedTickerOptionFlowQuery = { __typename?: 'query_root', full_feed_option_flow: Array<{ __typename?: 'full_feed_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }> };

export type GetFullFeedTickerOptionFlowCountQueryVariables = Exact<{
  ticker: Scalars['String'];
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetFullFeedTickerOptionFlowCountQuery = { __typename?: 'query_root', option_feed_baseline_aggregate: { __typename?: 'option_feed_baseline_aggregate', aggregate?: { __typename?: 'option_feed_baseline_aggregate_fields', count: number } | null } };

export type GetTickerDarkPoolTradesQueryVariables = Exact<{
  ticker: Scalars['String'];
  sinceDate: Scalars['date'];
}>;


export type GetTickerDarkPoolTradesQuery = { __typename?: 'query_root', ticker_equity_print_flow: Array<{ __typename?: 'ticker_equity_print_flow', amount?: any | null, ask?: any | null, askSize?: number | null, bid?: any | null, bidSize?: number | null, createdAt?: any | null, date?: any | null, exchangeId?: number | null, id?: any | null, percentAboveAsk?: any | null, percentBelowBid?: any | null, price?: any | null, size?: number | null, ticker?: string | null, timestampIso?: any | null, tradeSide?: string | null, avgVolume?: any | null, dayVolume?: any | null, avgPrice?: any | null, high?: any | null, isSignatureVolume?: boolean | null, isOutsideDailyRange?: boolean | null, isPriceGreaterThanOpen?: boolean | null, lastTradePrice?: any | null, low?: any | null, marketCap?: any | null, open?: any | null, isEtf?: boolean | null, isSignatureEtfTicker?: boolean | null, tickerDetails?: { __typename?: 'ticker_details', name?: string | null, ticker: string, sector?: string | null } | null }> };

export type GetTickerDarkPoolTradesCountQueryVariables = Exact<{
  ticker: Scalars['String'];
}>;


export type GetTickerDarkPoolTradesCountQuery = { __typename?: 'query_root', equity_print_feed_filtered_aggregate: { __typename?: 'equity_print_feed_filtered_aggregate', aggregate?: { __typename?: 'equity_print_feed_filtered_aggregate_fields', count: number } | null } };

export type GetFullFeedTickerEquityPrintFlowQueryVariables = Exact<{
  ticker: Scalars['String'];
  sinceDate: Scalars['date'];
}>;


export type GetFullFeedTickerEquityPrintFlowQuery = { __typename?: 'query_root', full_feed_equity_print_flow: Array<{ __typename?: 'full_feed_equity_print_flow', amount?: any | null, ask?: any | null, askSize?: number | null, bid?: any | null, bidSize?: number | null, createdAt?: any | null, date?: any | null, exchangeId?: number | null, id?: any | null, percentAboveAsk?: any | null, percentBelowBid?: any | null, price?: any | null, size?: number | null, ticker?: string | null, timestampIso?: any | null, tradeSide?: string | null, avgVolume?: any | null, dayVolume?: any | null, avgPrice?: any | null, high?: any | null, isSignatureVolume?: boolean | null, isOutsideDailyRange?: boolean | null, isPriceGreaterThanOpen?: boolean | null, lastTradePrice?: any | null, low?: any | null, marketCap?: any | null, open?: any | null, isEtf?: boolean | null, isSignatureEtfTicker?: boolean | null, tickerDetails?: { __typename?: 'ticker_details', name?: string | null, ticker: string, sector?: string | null } | null }> };

export type GetFullFeedTickerEquityPrintFlowCountQueryVariables = Exact<{
  ticker: Scalars['String'];
}>;


export type GetFullFeedTickerEquityPrintFlowCountQuery = { __typename?: 'query_root', equity_print_feed_baseline_aggregate: { __typename?: 'equity_print_feed_baseline_aggregate', aggregate?: { __typename?: 'equity_print_feed_baseline_aggregate_fields', count: number } | null } };

export type GetFreeTickerOptionFlowQueryVariables = Exact<{
  ticker: Scalars['String'];
  sinceDate: Scalars['date'];
}>;


export type GetFreeTickerOptionFlowQuery = { __typename?: 'query_root', free_ticker_option_flow: Array<{ __typename?: 'free_ticker_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }> };

export type GetFreeTickerOptionFlowCountQueryVariables = Exact<{
  ticker: Scalars['String'];
}>;


export type GetFreeTickerOptionFlowCountQuery = { __typename?: 'query_root', free_ticker_option_flow_aggregate: { __typename?: 'free_ticker_option_flow_aggregate', aggregate?: { __typename?: 'free_ticker_option_flow_aggregate_fields', count: number } | null } };

export type InsertTickerResearchViewMutationVariables = Exact<{
  date: Scalars['date'];
  userId: Scalars['String'];
  ticker: Scalars['String'];
}>;


export type InsertTickerResearchViewMutation = { __typename?: 'mutation_root', insert_ticker_research_all_views?: { __typename?: 'ticker_research_all_views_mutation_response', returning: Array<{ __typename?: 'ticker_research_all_views', id: any }> } | null, insert_ticker_research_daily_views?: { __typename?: 'ticker_research_daily_views_mutation_response', returning: Array<{ __typename?: 'ticker_research_daily_views', id: any }> } | null };

export type GetEquityPrintFlowFullQueryVariables = Exact<{
  ticker: Scalars['String'];
  sinceDate: Scalars['date'];
}>;


export type GetEquityPrintFlowFullQuery = { __typename?: 'query_root', equity_print_flow_full: Array<{ __typename?: 'equity_print_flow_full', id?: any | null, amount?: any | null, ask?: any | null, askSize?: number | null, avgPrice?: any | null, avgVolume?: any | null, bid?: any | null, bidSize?: number | null, createdAt?: any | null, date?: any | null, dayOverDayPercentChange?: any | null, dayOverDayPriceChange?: any | null, dayVolume?: any | null, exchangeId?: number | null, externalTradeId?: string | null, high?: any | null, isEtf?: boolean | null, isOutsideDailyRange?: boolean | null, isPriceGreaterThanDailyAverage?: boolean | null, isPriceGreaterThanOpen?: boolean | null, isSignatureEtfTicker?: boolean | null, isSignatureVolume?: boolean | null, lastTradePrice?: any | null, low?: any | null, marketCap?: any | null, open?: any | null, percentAboveAsk?: any | null, percentBelowBid?: any | null, percentOfAvgVolume?: any | null, percentOfMarketCap?: any | null, percentOfTodaysVolume?: any | null, prevClose?: any | null, prevHigh?: any | null, prevLow?: any | null, price?: any | null, realtimePrice?: any | null, size?: number | null, tapeId?: number | null, ticker?: string | null, timestamp?: any | null, timestampIso?: any | null, tradeConditions?: any | null, tradeSide?: string | null, updatedAt?: any | null }> };

export type HasNewTickerOptionFlowQueryVariables = Exact<{
  ticker: Scalars['String'];
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  since: Scalars['timestamptz'];
}>;


export type HasNewTickerOptionFlowQuery = { __typename?: 'query_root', ticker_option_flow: Array<{ __typename?: 'ticker_option_flow_all_sides', id?: any | null, createdAt?: any | null }> };

export type GetDarkPoolCountFullQueryVariables = Exact<{
  ticker: Scalars['String'];
}>;


export type GetDarkPoolCountFullQuery = { __typename?: 'query_root', equity_print_flow_full_aggregate: { __typename?: 'equity_print_flow_full_aggregate', aggregate?: { __typename?: 'equity_print_flow_full_aggregate_fields', count: number } | null } };

export type HasNewFullFeedTickerOptionFlowQueryVariables = Exact<{
  ticker: Scalars['String'];
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  since: Scalars['timestamptz'];
}>;


export type HasNewFullFeedTickerOptionFlowQuery = { __typename?: 'query_root', full_feed_option_flow: Array<{ __typename?: 'full_feed_option_flow', id?: any | null, createdAt?: any | null }> };

export type GetLitPoolCountFullQueryVariables = Exact<{
  ticker: Scalars['String'];
}>;


export type GetLitPoolCountFullQuery = { __typename?: 'query_root', equity_print_flow_full_aggregate: { __typename?: 'equity_print_flow_full_aggregate', aggregate?: { __typename?: 'equity_print_flow_full_aggregate_fields', count: number } | null } };

export type HasNewFreeTickerOptionFlowQueryVariables = Exact<{
  ticker: Scalars['String'];
  since: Scalars['timestamptz'];
}>;


export type HasNewFreeTickerOptionFlowQuery = { __typename?: 'query_root', free_ticker_option_flow: Array<{ __typename?: 'free_ticker_option_flow', id?: any | null, createdAt?: any | null }> };

export type GetAllPoolCountFullQueryVariables = Exact<{
  ticker: Scalars['String'];
}>;


export type GetAllPoolCountFullQuery = { __typename?: 'query_root', equity_print_flow_full_aggregate: { __typename?: 'equity_print_flow_full_aggregate', aggregate?: { __typename?: 'equity_print_flow_full_aggregate_fields', count: number } | null } };

export type HasNewTickerDarkPoolTradesQueryVariables = Exact<{
  ticker: Scalars['String'];
  since: Scalars['timestamptz'];
}>;


export type HasNewTickerDarkPoolTradesQuery = { __typename?: 'query_root', ticker_equity_print_flow: Array<{ __typename?: 'ticker_equity_print_flow', id?: any | null, createdAt?: any | null }> };

export type HasNewFullFeedTickerEquityPrintFlowQueryVariables = Exact<{
  ticker: Scalars['String'];
  since: Scalars['timestamptz'];
}>;


export type HasNewFullFeedTickerEquityPrintFlowQuery = { __typename?: 'query_root', full_feed_equity_print_flow: Array<{ __typename?: 'full_feed_equity_print_flow', id?: any | null, createdAt?: any | null }> };

export type GetTickerOptionFlowHistoricalQueryVariables = Exact<{
  ticker: Scalars['String'];
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  startDate: Scalars['date'];
  endDate: Scalars['date'];
}>;


export type GetTickerOptionFlowHistoricalQuery = { __typename?: 'query_root', option_feed_filtered: Array<{ __typename?: 'option_feed_filtered', cp: string, exchangeTimestamp: any, lastExchangeTimestamp?: any | null, expireDay: number, expireMonth: number, expireYear: number, id: any, createdAt: any, openInterest: number, orderType: string, premium: any, price: any, size: number, spot: any, priceExternalApi?: any | null, strike: any, ticker: string, tradeSide: string, currentDailyVolume: number, nbboAsk: any, nbboBid: any, otmPercent: any, date: any, impliedVol: any, delta: any, gamma: any, rho: any, theta: any, vega: any, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry: any, marketCap?: any | null, weeklyTotalSize: any, weeklyTotalTrades: number, weeklyTotalPremium: any, weeklyTotalOpenInterest: any, weeklyTotalImpliedVol: any, avgContractsPerDay: any, avgContractsPerTrade: any, avgImpliedVolPerTrade: any, avgOpenInterestPerDay: any, avgOpenInterestPerTrade: any, avgPremiumPerDay: any, avgPremiumPerTrade: any, avgTradesPerDay: any, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }> };

export type GetFullFeedTickerOptionFlowHistoricalQueryVariables = Exact<{
  ticker: Scalars['String'];
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  startDate: Scalars['date'];
  endDate: Scalars['date'];
}>;


export type GetFullFeedTickerOptionFlowHistoricalQuery = { __typename?: 'query_root', full_feed_option_flow: Array<{ __typename?: 'full_feed_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }> };

export type GetFreeTickerOptionFlowHistoricalQueryVariables = Exact<{
  ticker: Scalars['String'];
  startDate: Scalars['date'];
  endDate: Scalars['date'];
}>;


export type GetFreeTickerOptionFlowHistoricalQuery = { __typename?: 'query_root', free_ticker_option_flow: Array<{ __typename?: 'free_ticker_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }> };

export type GetTickerDarkPoolHistoricalBaselineQueryVariables = Exact<{
  ticker: Scalars['String'];
  startDate: Scalars['date'];
  endDate: Scalars['date'];
}>;


export type GetTickerDarkPoolHistoricalBaselineQuery = { __typename?: 'query_root', equity_print_feed_baseline: Array<{ __typename?: 'equity_print_feed_baseline', id: any, amount: any, ask: any, askSize: number, avgPrice: any, avgVolume: any, bid: any, bidSize: number, createdAt: any, date: any, dayOverDayPercentChange: any, dayOverDayPriceChange: any, dayVolume: any, exchangeId: number, externalTradeId: string, high: any, isEtf: boolean, isOutsideDailyRange: boolean, isPriceGreaterThanDailyAverage: boolean, isPriceGreaterThanOpen: boolean, isSignatureEtfTicker: boolean, isSignatureVolume: boolean, lastTradePrice: any, low: any, marketCap: any, open: any, percentAboveAsk?: any | null, percentBelowBid?: any | null, percentOfAvgVolume?: any | null, percentOfMarketCap?: any | null, percentOfTodaysVolume?: any | null, prevClose: any, prevHigh: any, prevLow: any, price: any, realtimePrice: any, size: number, tapeId: number, ticker: string, timestamp: any, timestampIso: any, tradeConditions: any, tradeSide: string, updatedAt: any, tickerDetails?: { __typename?: 'ticker_details', name?: string | null, ticker: string, sector?: string | null } | null }> };

export type GetEquityPrintFlowFullHistoricalQueryVariables = Exact<{
  ticker: Scalars['String'];
  startDate: Scalars['date'];
  endDate: Scalars['date'];
}>;


export type GetEquityPrintFlowFullHistoricalQuery = { __typename?: 'query_root', equity_print_flow_full: Array<{ __typename?: 'equity_print_flow_full', id?: any | null, amount?: any | null, ask?: any | null, askSize?: number | null, avgPrice?: any | null, avgVolume?: any | null, bid?: any | null, bidSize?: number | null, createdAt?: any | null, date?: any | null, dayOverDayPercentChange?: any | null, dayOverDayPriceChange?: any | null, dayVolume?: any | null, exchangeId?: number | null, externalTradeId?: string | null, high?: any | null, isEtf?: boolean | null, isOutsideDailyRange?: boolean | null, isPriceGreaterThanDailyAverage?: boolean | null, isPriceGreaterThanOpen?: boolean | null, isSignatureEtfTicker?: boolean | null, isSignatureVolume?: boolean | null, lastTradePrice?: any | null, low?: any | null, marketCap?: any | null, open?: any | null, percentAboveAsk?: any | null, percentBelowBid?: any | null, percentOfAvgVolume?: any | null, percentOfMarketCap?: any | null, percentOfTodaysVolume?: any | null, prevClose?: any | null, prevHigh?: any | null, prevLow?: any | null, price?: any | null, realtimePrice?: any | null, size?: number | null, tapeId?: number | null, ticker?: string | null, timestamp?: any | null, timestampIso?: any | null, tradeConditions?: any | null, tradeSide?: string | null, updatedAt?: any | null }> };

export type GetTopTickersQueryVariables = Exact<{
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetTopTickersQuery = { __typename?: 'query_root', top_tickers: Array<{ __typename?: 'top_tickers', id: string, first?: string | null, second?: string | null, third?: string | null, fourth?: string | null, fifth?: string | null, firstTrades: Array<{ __typename?: 'weekly_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }>, secondTrades: Array<{ __typename?: 'weekly_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }>, thirdTrades: Array<{ __typename?: 'weekly_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }>, fourthTrades: Array<{ __typename?: 'weekly_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }>, fifthTrades: Array<{ __typename?: 'weekly_option_flow', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }> }>, daily_volume: Array<{ __typename?: 'daily_volume', ticker?: string | null, volume?: any | null }> };

export type GetUserCourseProgressQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserCourseProgressQuery = { __typename?: 'query_root', course_progress: Array<{ __typename?: 'course_progress', user_id: string, id: any, lesson_id: string, masterclass_id: string, section_id: string, status: Course_Progress_Status_Enum }> };

export type UpsertCourseProgressMutationVariables = Exact<{
  lesson_id: Scalars['String'];
  masterclass_id: Scalars['String'];
  section_id: Scalars['String'];
  status: Course_Progress_Status_Enum;
  user_id: Scalars['String'];
  update_columns?: Array<Course_Progress_Update_Column> | Course_Progress_Update_Column;
}>;


export type UpsertCourseProgressMutation = { __typename?: 'mutation_root', insert_course_progress_one?: { __typename?: 'course_progress', id: any, lesson_id: string, masterclass_id: string, section_id: string, status: Course_Progress_Status_Enum, user_id: string } | null };

export type GetWeeklyOverviewQueryVariables = Exact<{
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetWeeklyOverviewQuery = { __typename?: 'query_root', weekly_option_flow: Array<{ __typename?: 'weekly_option_flow_all_sides', cp?: string | null, exchangeTimestamp?: any | null, lastExchangeTimestamp?: any | null, expireDay?: number | null, expireMonth?: number | null, expireYear?: number | null, id?: any | null, createdAt?: any | null, openInterest?: number | null, orderType?: string | null, premium?: any | null, price?: any | null, size?: number | null, spot?: any | null, priceExternalApi?: any | null, strike?: any | null, ticker?: string | null, tradeSide?: string | null, currentDailyVolume?: number | null, nbboAsk?: any | null, nbboBid?: any | null, otmPercent?: any | null, date?: any | null, impliedVol?: any | null, delta?: any | null, gamma?: any | null, rho?: any | null, theta?: any | null, vega?: any | null, vanna?: any | null, vomma?: any | null, charm?: any | null, zomma?: any | null, color?: any | null, speed?: any | null, veta?: any | null, vera?: any | null, ultima?: any | null, lambda?: any | null, probTouch?: any | null, riskFreeRate?: any | null, nbboMidIv?: any | null, yearsToExpiry?: any | null, marketCap?: any | null, weeklyTotalSize?: any | null, weeklyTotalTrades?: number | null, weeklyTotalPremium?: any | null, weeklyTotalOpenInterest?: any | null, weeklyTotalImpliedVol?: any | null, avgContractsPerDay?: any | null, avgContractsPerTrade?: any | null, avgImpliedVolPerTrade?: any | null, avgOpenInterestPerDay?: any | null, avgOpenInterestPerTrade?: any | null, avgPremiumPerDay?: any | null, avgPremiumPerTrade?: any | null, avgTradesPerDay?: any | null, tickerDetails?: { __typename?: 'ticker_details', ticker: string, sector?: string | null, name?: string | null } | null }>, daily_volume: Array<{ __typename?: 'daily_volume', ticker?: string | null, volume?: any | null }> };

export type GetWeeklyOverviewCountQueryVariables = Exact<{
  tradeSides?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetWeeklyOverviewCountQuery = { __typename?: 'query_root', weekly_option_flow_aggregate: { __typename?: 'weekly_option_flow_all_sides_aggregate', aggregate?: { __typename?: 'weekly_option_flow_all_sides_aggregate_fields', count: number } | null } };

export const DarkPoolTradeFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DarkPoolTradeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"equity_print_feed_baseline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"ask"}},{"kind":"Field","name":{"kind":"Name","value":"askSize"}},{"kind":"Field","name":{"kind":"Name","value":"avgPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPercentChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPriceChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayVolume"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeId"}},{"kind":"Field","name":{"kind":"Name","value":"externalTradeId"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"isEtf"}},{"kind":"Field","name":{"kind":"Name","value":"isOutsideDailyRange"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanDailyAverage"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanOpen"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureEtfTicker"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureVolume"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradePrice"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"percentAboveAsk"}},{"kind":"Field","name":{"kind":"Name","value":"percentBelowBid"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfAvgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfMarketCap"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfTodaysVolume"}},{"kind":"Field","name":{"kind":"Name","value":"prevClose"}},{"kind":"Field","name":{"kind":"Name","value":"prevHigh"}},{"kind":"Field","name":{"kind":"Name","value":"prevLow"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"realtimePrice"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"tapeId"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"timestampIso"}},{"kind":"Field","name":{"kind":"Name","value":"tradeConditions"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode;
export const OptionFlowTickerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"optionFlowTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"option_flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;
export const OptionFlowAllSidesTickerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"optionFlowAllSidesTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"option_flow_all_sides"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;
export const FreeOptionFlowTickerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"freeOptionFlowTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"free_option_flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;
export const TickerOptionFlowTickerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tickerOptionFlowTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ticker_option_flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;
export const TickerOptionFlowAllSidesTickerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tickerOptionFlowAllSidesTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ticker_option_flow_all_sides"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;
export const FreeTickerOptionFlowTickerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"freeTickerOptionFlowTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"free_ticker_option_flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;
export const FullFeedTickerOptionFlowTickerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fullFeedTickerOptionFlowTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"full_feed_option_flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;
export const WeeklyOptionFlowTickerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"weeklyOptionFlowTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"weekly_option_flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;
export const WeeklyOptionFlowAllSidesTickerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"weeklyOptionFlowAllSidesTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"weekly_option_flow_all_sides"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;
export const OptionFeedFilteredTickerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"optionFeedFilteredTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"option_feed_filtered"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;
export const GetDarkPoolLevelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDarkPoolLevels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dark_pool_levels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"prints"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetDarkPoolLevelsQuery__
 *
 * To run a query within a React component, call `useGetDarkPoolLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDarkPoolLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDarkPoolLevelsQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useGetDarkPoolLevelsQuery(baseOptions: Apollo.QueryHookOptions<GetDarkPoolLevelsQuery, GetDarkPoolLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDarkPoolLevelsQuery, GetDarkPoolLevelsQueryVariables>(GetDarkPoolLevelsDocument, options);
      }
export function useGetDarkPoolLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDarkPoolLevelsQuery, GetDarkPoolLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDarkPoolLevelsQuery, GetDarkPoolLevelsQueryVariables>(GetDarkPoolLevelsDocument, options);
        }
export type GetDarkPoolLevelsQueryHookResult = ReturnType<typeof useGetDarkPoolLevelsQuery>;
export type GetDarkPoolLevelsLazyQueryHookResult = ReturnType<typeof useGetDarkPoolLevelsLazyQuery>;
export type GetDarkPoolLevelsQueryResult = Apollo.QueryResult<GetDarkPoolLevelsQuery, GetDarkPoolLevelsQueryVariables>;
export const GetDarkPoolLevelsMonthlyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDarkPoolLevelsMonthly"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dark_pool_levels_monthly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"prints"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetDarkPoolLevelsMonthlyQuery__
 *
 * To run a query within a React component, call `useGetDarkPoolLevelsMonthlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDarkPoolLevelsMonthlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDarkPoolLevelsMonthlyQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useGetDarkPoolLevelsMonthlyQuery(baseOptions: Apollo.QueryHookOptions<GetDarkPoolLevelsMonthlyQuery, GetDarkPoolLevelsMonthlyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDarkPoolLevelsMonthlyQuery, GetDarkPoolLevelsMonthlyQueryVariables>(GetDarkPoolLevelsMonthlyDocument, options);
      }
export function useGetDarkPoolLevelsMonthlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDarkPoolLevelsMonthlyQuery, GetDarkPoolLevelsMonthlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDarkPoolLevelsMonthlyQuery, GetDarkPoolLevelsMonthlyQueryVariables>(GetDarkPoolLevelsMonthlyDocument, options);
        }
export type GetDarkPoolLevelsMonthlyQueryHookResult = ReturnType<typeof useGetDarkPoolLevelsMonthlyQuery>;
export type GetDarkPoolLevelsMonthlyLazyQueryHookResult = ReturnType<typeof useGetDarkPoolLevelsMonthlyLazyQuery>;
export type GetDarkPoolLevelsMonthlyQueryResult = Apollo.QueryResult<GetDarkPoolLevelsMonthlyQuery, GetDarkPoolLevelsMonthlyQueryVariables>;
export const GetDarkPoolTradesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDarkPoolTrades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"ask"}},{"kind":"Field","name":{"kind":"Name","value":"askSize"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"percentAboveAsk"}},{"kind":"Field","name":{"kind":"Name","value":"percentBelowBid"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"timestampIso"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"dayVolume"}},{"kind":"Field","name":{"kind":"Name","value":"avgPrice"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureVolume"}},{"kind":"Field","name":{"kind":"Name","value":"isOutsideDailyRange"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanOpen"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradePrice"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"isEtf"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureEtfTicker"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetDarkPoolTradesQuery__
 *
 * To run a query within a React component, call `useGetDarkPoolTradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDarkPoolTradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDarkPoolTradesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDarkPoolTradesQuery(baseOptions?: Apollo.QueryHookOptions<GetDarkPoolTradesQuery, GetDarkPoolTradesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDarkPoolTradesQuery, GetDarkPoolTradesQueryVariables>(GetDarkPoolTradesDocument, options);
      }
export function useGetDarkPoolTradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDarkPoolTradesQuery, GetDarkPoolTradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDarkPoolTradesQuery, GetDarkPoolTradesQueryVariables>(GetDarkPoolTradesDocument, options);
        }
export type GetDarkPoolTradesQueryHookResult = ReturnType<typeof useGetDarkPoolTradesQuery>;
export type GetDarkPoolTradesLazyQueryHookResult = ReturnType<typeof useGetDarkPoolTradesLazyQuery>;
export type GetDarkPoolTradesQueryResult = Apollo.QueryResult<GetDarkPoolTradesQuery, GetDarkPoolTradesQueryVariables>;
export const GetDarkPoolTradesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDarkPoolTradesCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetDarkPoolTradesCountQuery__
 *
 * To run a query within a React component, call `useGetDarkPoolTradesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDarkPoolTradesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDarkPoolTradesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDarkPoolTradesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetDarkPoolTradesCountQuery, GetDarkPoolTradesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDarkPoolTradesCountQuery, GetDarkPoolTradesCountQueryVariables>(GetDarkPoolTradesCountDocument, options);
      }
export function useGetDarkPoolTradesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDarkPoolTradesCountQuery, GetDarkPoolTradesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDarkPoolTradesCountQuery, GetDarkPoolTradesCountQueryVariables>(GetDarkPoolTradesCountDocument, options);
        }
export type GetDarkPoolTradesCountQueryHookResult = ReturnType<typeof useGetDarkPoolTradesCountQuery>;
export type GetDarkPoolTradesCountLazyQueryHookResult = ReturnType<typeof useGetDarkPoolTradesCountLazyQuery>;
export type GetDarkPoolTradesCountQueryResult = Apollo.QueryResult<GetDarkPoolTradesCountQuery, GetDarkPoolTradesCountQueryVariables>;
export const GetDarkPoolTradesBaselineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDarkPoolTradesBaseline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_feed_baseline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DarkPoolTradeFields"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DarkPoolTradeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"equity_print_feed_baseline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"ask"}},{"kind":"Field","name":{"kind":"Name","value":"askSize"}},{"kind":"Field","name":{"kind":"Name","value":"avgPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPercentChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPriceChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayVolume"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeId"}},{"kind":"Field","name":{"kind":"Name","value":"externalTradeId"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"isEtf"}},{"kind":"Field","name":{"kind":"Name","value":"isOutsideDailyRange"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanDailyAverage"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanOpen"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureEtfTicker"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureVolume"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradePrice"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"percentAboveAsk"}},{"kind":"Field","name":{"kind":"Name","value":"percentBelowBid"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfAvgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfMarketCap"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfTodaysVolume"}},{"kind":"Field","name":{"kind":"Name","value":"prevClose"}},{"kind":"Field","name":{"kind":"Name","value":"prevHigh"}},{"kind":"Field","name":{"kind":"Name","value":"prevLow"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"realtimePrice"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"tapeId"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"timestampIso"}},{"kind":"Field","name":{"kind":"Name","value":"tradeConditions"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetDarkPoolTradesBaselineQuery__
 *
 * To run a query within a React component, call `useGetDarkPoolTradesBaselineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDarkPoolTradesBaselineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDarkPoolTradesBaselineQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDarkPoolTradesBaselineQuery(baseOptions?: Apollo.QueryHookOptions<GetDarkPoolTradesBaselineQuery, GetDarkPoolTradesBaselineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDarkPoolTradesBaselineQuery, GetDarkPoolTradesBaselineQueryVariables>(GetDarkPoolTradesBaselineDocument, options);
      }
export function useGetDarkPoolTradesBaselineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDarkPoolTradesBaselineQuery, GetDarkPoolTradesBaselineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDarkPoolTradesBaselineQuery, GetDarkPoolTradesBaselineQueryVariables>(GetDarkPoolTradesBaselineDocument, options);
        }
export type GetDarkPoolTradesBaselineQueryHookResult = ReturnType<typeof useGetDarkPoolTradesBaselineQuery>;
export type GetDarkPoolTradesBaselineLazyQueryHookResult = ReturnType<typeof useGetDarkPoolTradesBaselineLazyQuery>;
export type GetDarkPoolTradesBaselineQueryResult = Apollo.QueryResult<GetDarkPoolTradesBaselineQuery, GetDarkPoolTradesBaselineQueryVariables>;
export const GetDarkPoolTradesCountBaselineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDarkPoolTradesCountBaseline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_feed_baseline_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetDarkPoolTradesCountBaselineQuery__
 *
 * To run a query within a React component, call `useGetDarkPoolTradesCountBaselineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDarkPoolTradesCountBaselineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDarkPoolTradesCountBaselineQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDarkPoolTradesCountBaselineQuery(baseOptions?: Apollo.QueryHookOptions<GetDarkPoolTradesCountBaselineQuery, GetDarkPoolTradesCountBaselineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDarkPoolTradesCountBaselineQuery, GetDarkPoolTradesCountBaselineQueryVariables>(GetDarkPoolTradesCountBaselineDocument, options);
      }
export function useGetDarkPoolTradesCountBaselineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDarkPoolTradesCountBaselineQuery, GetDarkPoolTradesCountBaselineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDarkPoolTradesCountBaselineQuery, GetDarkPoolTradesCountBaselineQueryVariables>(GetDarkPoolTradesCountBaselineDocument, options);
        }
export type GetDarkPoolTradesCountBaselineQueryHookResult = ReturnType<typeof useGetDarkPoolTradesCountBaselineQuery>;
export type GetDarkPoolTradesCountBaselineLazyQueryHookResult = ReturnType<typeof useGetDarkPoolTradesCountBaselineLazyQuery>;
export type GetDarkPoolTradesCountBaselineQueryResult = Apollo.QueryResult<GetDarkPoolTradesCountBaselineQuery, GetDarkPoolTradesCountBaselineQueryVariables>;
export const GetDarkPoolTradesFullDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDarkPoolTradesFull"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow_full"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"ask"}},{"kind":"Field","name":{"kind":"Name","value":"askSize"}},{"kind":"Field","name":{"kind":"Name","value":"avgPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPercentChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPriceChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayVolume"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeId"}},{"kind":"Field","name":{"kind":"Name","value":"externalTradeId"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"isEtf"}},{"kind":"Field","name":{"kind":"Name","value":"isOutsideDailyRange"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanDailyAverage"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanOpen"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureEtfTicker"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureVolume"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradePrice"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"percentAboveAsk"}},{"kind":"Field","name":{"kind":"Name","value":"percentBelowBid"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfAvgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfMarketCap"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfTodaysVolume"}},{"kind":"Field","name":{"kind":"Name","value":"prevClose"}},{"kind":"Field","name":{"kind":"Name","value":"prevHigh"}},{"kind":"Field","name":{"kind":"Name","value":"prevLow"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"realtimePrice"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"tapeId"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"timestampIso"}},{"kind":"Field","name":{"kind":"Name","value":"tradeConditions"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetDarkPoolTradesFullQuery__
 *
 * To run a query within a React component, call `useGetDarkPoolTradesFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDarkPoolTradesFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDarkPoolTradesFullQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDarkPoolTradesFullQuery(baseOptions?: Apollo.QueryHookOptions<GetDarkPoolTradesFullQuery, GetDarkPoolTradesFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDarkPoolTradesFullQuery, GetDarkPoolTradesFullQueryVariables>(GetDarkPoolTradesFullDocument, options);
      }
export function useGetDarkPoolTradesFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDarkPoolTradesFullQuery, GetDarkPoolTradesFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDarkPoolTradesFullQuery, GetDarkPoolTradesFullQueryVariables>(GetDarkPoolTradesFullDocument, options);
        }
export type GetDarkPoolTradesFullQueryHookResult = ReturnType<typeof useGetDarkPoolTradesFullQuery>;
export type GetDarkPoolTradesFullLazyQueryHookResult = ReturnType<typeof useGetDarkPoolTradesFullLazyQuery>;
export type GetDarkPoolTradesFullQueryResult = Apollo.QueryResult<GetDarkPoolTradesFullQuery, GetDarkPoolTradesFullQueryVariables>;
export const GetDarkPoolTradesCountFullDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDarkPoolTradesCountFull"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow_full_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetDarkPoolTradesCountFullQuery__
 *
 * To run a query within a React component, call `useGetDarkPoolTradesCountFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDarkPoolTradesCountFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDarkPoolTradesCountFullQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDarkPoolTradesCountFullQuery(baseOptions?: Apollo.QueryHookOptions<GetDarkPoolTradesCountFullQuery, GetDarkPoolTradesCountFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDarkPoolTradesCountFullQuery, GetDarkPoolTradesCountFullQueryVariables>(GetDarkPoolTradesCountFullDocument, options);
      }
export function useGetDarkPoolTradesCountFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDarkPoolTradesCountFullQuery, GetDarkPoolTradesCountFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDarkPoolTradesCountFullQuery, GetDarkPoolTradesCountFullQueryVariables>(GetDarkPoolTradesCountFullDocument, options);
        }
export type GetDarkPoolTradesCountFullQueryHookResult = ReturnType<typeof useGetDarkPoolTradesCountFullQuery>;
export type GetDarkPoolTradesCountFullLazyQueryHookResult = ReturnType<typeof useGetDarkPoolTradesCountFullLazyQuery>;
export type GetDarkPoolTradesCountFullQueryResult = Apollo.QueryResult<GetDarkPoolTradesCountFullQuery, GetDarkPoolTradesCountFullQueryVariables>;
export const GetHistoricalDarkPoolBaselineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHistoricalDarkPoolBaseline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_feed_baseline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ASK","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DarkPoolTradeFields"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DarkPoolTradeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"equity_print_feed_baseline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"ask"}},{"kind":"Field","name":{"kind":"Name","value":"askSize"}},{"kind":"Field","name":{"kind":"Name","value":"avgPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPercentChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPriceChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayVolume"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeId"}},{"kind":"Field","name":{"kind":"Name","value":"externalTradeId"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"isEtf"}},{"kind":"Field","name":{"kind":"Name","value":"isOutsideDailyRange"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanDailyAverage"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanOpen"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureEtfTicker"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureVolume"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradePrice"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"percentAboveAsk"}},{"kind":"Field","name":{"kind":"Name","value":"percentBelowBid"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfAvgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfMarketCap"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfTodaysVolume"}},{"kind":"Field","name":{"kind":"Name","value":"prevClose"}},{"kind":"Field","name":{"kind":"Name","value":"prevHigh"}},{"kind":"Field","name":{"kind":"Name","value":"prevLow"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"realtimePrice"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"tapeId"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"timestampIso"}},{"kind":"Field","name":{"kind":"Name","value":"tradeConditions"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetHistoricalDarkPoolBaselineQuery__
 *
 * To run a query within a React component, call `useGetHistoricalDarkPoolBaselineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalDarkPoolBaselineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalDarkPoolBaselineQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetHistoricalDarkPoolBaselineQuery(baseOptions: Apollo.QueryHookOptions<GetHistoricalDarkPoolBaselineQuery, GetHistoricalDarkPoolBaselineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricalDarkPoolBaselineQuery, GetHistoricalDarkPoolBaselineQueryVariables>(GetHistoricalDarkPoolBaselineDocument, options);
      }
export function useGetHistoricalDarkPoolBaselineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricalDarkPoolBaselineQuery, GetHistoricalDarkPoolBaselineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricalDarkPoolBaselineQuery, GetHistoricalDarkPoolBaselineQueryVariables>(GetHistoricalDarkPoolBaselineDocument, options);
        }
export type GetHistoricalDarkPoolBaselineQueryHookResult = ReturnType<typeof useGetHistoricalDarkPoolBaselineQuery>;
export type GetHistoricalDarkPoolBaselineLazyQueryHookResult = ReturnType<typeof useGetHistoricalDarkPoolBaselineLazyQuery>;
export type GetHistoricalDarkPoolBaselineQueryResult = Apollo.QueryResult<GetHistoricalDarkPoolBaselineQuery, GetHistoricalDarkPoolBaselineQueryVariables>;
export const GetHistoricalDarkPoolWithTickersBaselineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHistoricalDarkPoolWithTickersBaseline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tickers"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"","block":false}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_feed_baseline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tickers"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ASK","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DarkPoolTradeFields"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DarkPoolTradeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"equity_print_feed_baseline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"ask"}},{"kind":"Field","name":{"kind":"Name","value":"askSize"}},{"kind":"Field","name":{"kind":"Name","value":"avgPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPercentChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPriceChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayVolume"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeId"}},{"kind":"Field","name":{"kind":"Name","value":"externalTradeId"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"isEtf"}},{"kind":"Field","name":{"kind":"Name","value":"isOutsideDailyRange"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanDailyAverage"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanOpen"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureEtfTicker"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureVolume"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradePrice"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"percentAboveAsk"}},{"kind":"Field","name":{"kind":"Name","value":"percentBelowBid"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfAvgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfMarketCap"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfTodaysVolume"}},{"kind":"Field","name":{"kind":"Name","value":"prevClose"}},{"kind":"Field","name":{"kind":"Name","value":"prevHigh"}},{"kind":"Field","name":{"kind":"Name","value":"prevLow"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"realtimePrice"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"tapeId"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"timestampIso"}},{"kind":"Field","name":{"kind":"Name","value":"tradeConditions"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetHistoricalDarkPoolWithTickersBaselineQuery__
 *
 * To run a query within a React component, call `useGetHistoricalDarkPoolWithTickersBaselineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalDarkPoolWithTickersBaselineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalDarkPoolWithTickersBaselineQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      tickers: // value for 'tickers'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetHistoricalDarkPoolWithTickersBaselineQuery(baseOptions: Apollo.QueryHookOptions<GetHistoricalDarkPoolWithTickersBaselineQuery, GetHistoricalDarkPoolWithTickersBaselineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricalDarkPoolWithTickersBaselineQuery, GetHistoricalDarkPoolWithTickersBaselineQueryVariables>(GetHistoricalDarkPoolWithTickersBaselineDocument, options);
      }
export function useGetHistoricalDarkPoolWithTickersBaselineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricalDarkPoolWithTickersBaselineQuery, GetHistoricalDarkPoolWithTickersBaselineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricalDarkPoolWithTickersBaselineQuery, GetHistoricalDarkPoolWithTickersBaselineQueryVariables>(GetHistoricalDarkPoolWithTickersBaselineDocument, options);
        }
export type GetHistoricalDarkPoolWithTickersBaselineQueryHookResult = ReturnType<typeof useGetHistoricalDarkPoolWithTickersBaselineQuery>;
export type GetHistoricalDarkPoolWithTickersBaselineLazyQueryHookResult = ReturnType<typeof useGetHistoricalDarkPoolWithTickersBaselineLazyQuery>;
export type GetHistoricalDarkPoolWithTickersBaselineQueryResult = Apollo.QueryResult<GetHistoricalDarkPoolWithTickersBaselineQuery, GetHistoricalDarkPoolWithTickersBaselineQueryVariables>;
export const HasNewDarkPoolTradesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hasNewDarkPoolTrades"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHasNewDarkPoolTradesQuery__
 *
 * To run a query within a React component, call `useHasNewDarkPoolTradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasNewDarkPoolTradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasNewDarkPoolTradesQuery({
 *   variables: {
 *      since: // value for 'since'
 *   },
 * });
 */
export function useHasNewDarkPoolTradesQuery(baseOptions: Apollo.QueryHookOptions<HasNewDarkPoolTradesQuery, HasNewDarkPoolTradesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasNewDarkPoolTradesQuery, HasNewDarkPoolTradesQueryVariables>(HasNewDarkPoolTradesDocument, options);
      }
export function useHasNewDarkPoolTradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasNewDarkPoolTradesQuery, HasNewDarkPoolTradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasNewDarkPoolTradesQuery, HasNewDarkPoolTradesQueryVariables>(HasNewDarkPoolTradesDocument, options);
        }
export type HasNewDarkPoolTradesQueryHookResult = ReturnType<typeof useHasNewDarkPoolTradesQuery>;
export type HasNewDarkPoolTradesLazyQueryHookResult = ReturnType<typeof useHasNewDarkPoolTradesLazyQuery>;
export type HasNewDarkPoolTradesQueryResult = Apollo.QueryResult<HasNewDarkPoolTradesQuery, HasNewDarkPoolTradesQueryVariables>;
export const GetMostResearchedTickersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMostResearchedTickers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"most_researched_tickers_daily_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"most_researched_tickers_daily_unique"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetMostResearchedTickersQuery__
 *
 * To run a query within a React component, call `useGetMostResearchedTickersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMostResearchedTickersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMostResearchedTickersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMostResearchedTickersQuery(baseOptions?: Apollo.QueryHookOptions<GetMostResearchedTickersQuery, GetMostResearchedTickersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMostResearchedTickersQuery, GetMostResearchedTickersQueryVariables>(GetMostResearchedTickersDocument, options);
      }
export function useGetMostResearchedTickersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMostResearchedTickersQuery, GetMostResearchedTickersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMostResearchedTickersQuery, GetMostResearchedTickersQueryVariables>(GetMostResearchedTickersDocument, options);
        }
export type GetMostResearchedTickersQueryHookResult = ReturnType<typeof useGetMostResearchedTickersQuery>;
export type GetMostResearchedTickersLazyQueryHookResult = ReturnType<typeof useGetMostResearchedTickersLazyQuery>;
export type GetMostResearchedTickersQueryResult = Apollo.QueryResult<GetMostResearchedTickersQuery, GetMostResearchedTickersQueryVariables>;
export const GetAllAssetAlertSignalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllAssetAlertSignals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_signal_alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"500"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"signal"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetAllAssetAlertSignalsQuery__
 *
 * To run a query within a React component, call `useGetAllAssetAlertSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssetAlertSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAssetAlertSignalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAssetAlertSignalsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAssetAlertSignalsQuery, GetAllAssetAlertSignalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAssetAlertSignalsQuery, GetAllAssetAlertSignalsQueryVariables>(GetAllAssetAlertSignalsDocument, options);
      }
export function useGetAllAssetAlertSignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAssetAlertSignalsQuery, GetAllAssetAlertSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAssetAlertSignalsQuery, GetAllAssetAlertSignalsQueryVariables>(GetAllAssetAlertSignalsDocument, options);
        }
export type GetAllAssetAlertSignalsQueryHookResult = ReturnType<typeof useGetAllAssetAlertSignalsQuery>;
export type GetAllAssetAlertSignalsLazyQueryHookResult = ReturnType<typeof useGetAllAssetAlertSignalsLazyQuery>;
export type GetAllAssetAlertSignalsQueryResult = Apollo.QueryResult<GetAllAssetAlertSignalsQuery, GetAllAssetAlertSignalsQueryVariables>;
export const GetAssetAlertSignalsGroupedByAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssetAlertSignalsGroupedByAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assets"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"asset_signal_alerts_bool_exp"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_signal_alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"500"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assets"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"signal"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetAssetAlertSignalsGroupedByAssetQuery__
 *
 * To run a query within a React component, call `useGetAssetAlertSignalsGroupedByAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetAlertSignalsGroupedByAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetAlertSignalsGroupedByAssetQuery({
 *   variables: {
 *      assets: // value for 'assets'
 *   },
 * });
 */
export function useGetAssetAlertSignalsGroupedByAssetQuery(baseOptions: Apollo.QueryHookOptions<GetAssetAlertSignalsGroupedByAssetQuery, GetAssetAlertSignalsGroupedByAssetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetAlertSignalsGroupedByAssetQuery, GetAssetAlertSignalsGroupedByAssetQueryVariables>(GetAssetAlertSignalsGroupedByAssetDocument, options);
      }
export function useGetAssetAlertSignalsGroupedByAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetAlertSignalsGroupedByAssetQuery, GetAssetAlertSignalsGroupedByAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetAlertSignalsGroupedByAssetQuery, GetAssetAlertSignalsGroupedByAssetQueryVariables>(GetAssetAlertSignalsGroupedByAssetDocument, options);
        }
export type GetAssetAlertSignalsGroupedByAssetQueryHookResult = ReturnType<typeof useGetAssetAlertSignalsGroupedByAssetQuery>;
export type GetAssetAlertSignalsGroupedByAssetLazyQueryHookResult = ReturnType<typeof useGetAssetAlertSignalsGroupedByAssetLazyQuery>;
export type GetAssetAlertSignalsGroupedByAssetQueryResult = Apollo.QueryResult<GetAssetAlertSignalsGroupedByAssetQuery, GetAssetAlertSignalsGroupedByAssetQueryVariables>;
export const GetAssetAlertSignalsForAssetClassDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssetAlertSignalsForAssetClass"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_signal_alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"500"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"signal"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetAssetAlertSignalsForAssetClassQuery__
 *
 * To run a query within a React component, call `useGetAssetAlertSignalsForAssetClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetAlertSignalsForAssetClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetAlertSignalsForAssetClassQuery({
 *   variables: {
 *      asset: // value for 'asset'
 *   },
 * });
 */
export function useGetAssetAlertSignalsForAssetClassQuery(baseOptions: Apollo.QueryHookOptions<GetAssetAlertSignalsForAssetClassQuery, GetAssetAlertSignalsForAssetClassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetAlertSignalsForAssetClassQuery, GetAssetAlertSignalsForAssetClassQueryVariables>(GetAssetAlertSignalsForAssetClassDocument, options);
      }
export function useGetAssetAlertSignalsForAssetClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetAlertSignalsForAssetClassQuery, GetAssetAlertSignalsForAssetClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetAlertSignalsForAssetClassQuery, GetAssetAlertSignalsForAssetClassQueryVariables>(GetAssetAlertSignalsForAssetClassDocument, options);
        }
export type GetAssetAlertSignalsForAssetClassQueryHookResult = ReturnType<typeof useGetAssetAlertSignalsForAssetClassQuery>;
export type GetAssetAlertSignalsForAssetClassLazyQueryHookResult = ReturnType<typeof useGetAssetAlertSignalsForAssetClassLazyQuery>;
export type GetAssetAlertSignalsForAssetClassQueryResult = Apollo.QueryResult<GetAssetAlertSignalsForAssetClassQuery, GetAssetAlertSignalsForAssetClassQueryVariables>;
export const GetAssetAlertSignalsByTickerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssetAlertSignalsByTicker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset_signal_alerts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"500"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"signal"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetAssetAlertSignalsByTickerQuery__
 *
 * To run a query within a React component, call `useGetAssetAlertSignalsByTickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetAlertSignalsByTickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetAlertSignalsByTickerQuery({
 *   variables: {
 *      asset: // value for 'asset'
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useGetAssetAlertSignalsByTickerQuery(baseOptions: Apollo.QueryHookOptions<GetAssetAlertSignalsByTickerQuery, GetAssetAlertSignalsByTickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetAlertSignalsByTickerQuery, GetAssetAlertSignalsByTickerQueryVariables>(GetAssetAlertSignalsByTickerDocument, options);
      }
export function useGetAssetAlertSignalsByTickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetAlertSignalsByTickerQuery, GetAssetAlertSignalsByTickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetAlertSignalsByTickerQuery, GetAssetAlertSignalsByTickerQueryVariables>(GetAssetAlertSignalsByTickerDocument, options);
        }
export type GetAssetAlertSignalsByTickerQueryHookResult = ReturnType<typeof useGetAssetAlertSignalsByTickerQuery>;
export type GetAssetAlertSignalsByTickerLazyQueryHookResult = ReturnType<typeof useGetAssetAlertSignalsByTickerLazyQuery>;
export type GetAssetAlertSignalsByTickerQueryResult = Apollo.QueryResult<GetAssetAlertSignalsByTickerQuery, GetAssetAlertSignalsByTickerQueryVariables>;
export const InsertUsagePingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertUsagePing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pathname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"region"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_usage_ping_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pathname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pathname"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"queryString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ip"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"region"},"value":{"kind":"Variable","name":{"kind":"Name","value":"region"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type InsertUsagePingMutationFn = Apollo.MutationFunction<InsertUsagePingMutation, InsertUsagePingMutationVariables>;

/**
 * __useInsertUsagePingMutation__
 *
 * To run a mutation, you first call `useInsertUsagePingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUsagePingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUsagePingMutation, { data, loading, error }] = useInsertUsagePingMutation({
 *   variables: {
 *      pathname: // value for 'pathname'
 *      userId: // value for 'userId'
 *      queryString: // value for 'queryString'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *      ip: // value for 'ip'
 *      region: // value for 'region'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useInsertUsagePingMutation(baseOptions?: Apollo.MutationHookOptions<InsertUsagePingMutation, InsertUsagePingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUsagePingMutation, InsertUsagePingMutationVariables>(InsertUsagePingDocument, options);
      }
export type InsertUsagePingMutationHookResult = ReturnType<typeof useInsertUsagePingMutation>;
export type InsertUsagePingMutationResult = Apollo.MutationResult<InsertUsagePingMutation>;
export type InsertUsagePingMutationOptions = Apollo.BaseMutationOptions<InsertUsagePingMutation, InsertUsagePingMutationVariables>;
export const UpdateTimezoneLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTimezoneLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezoneLocation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timezone_location_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timezoneLocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezoneLocation"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezoneLocation"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateTimezoneLocationMutationFn = Apollo.MutationFunction<UpdateTimezoneLocationMutation, UpdateTimezoneLocationMutationVariables>;

/**
 * __useUpdateTimezoneLocationMutation__
 *
 * To run a mutation, you first call `useUpdateTimezoneLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimezoneLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimezoneLocationMutation, { data, loading, error }] = useUpdateTimezoneLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      timezoneLocation: // value for 'timezoneLocation'
 *   },
 * });
 */
export function useUpdateTimezoneLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimezoneLocationMutation, UpdateTimezoneLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimezoneLocationMutation, UpdateTimezoneLocationMutationVariables>(UpdateTimezoneLocationDocument, options);
      }
export type UpdateTimezoneLocationMutationHookResult = ReturnType<typeof useUpdateTimezoneLocationMutation>;
export type UpdateTimezoneLocationMutationResult = Apollo.MutationResult<UpdateTimezoneLocationMutation>;
export type UpdateTimezoneLocationMutationOptions = Apollo.BaseMutationOptions<UpdateTimezoneLocationMutation, UpdateTimezoneLocationMutationVariables>;
export const UpdateTradingViewUsernameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTradingViewUsername"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradingviewUsername"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradingviewUsernameCaseSensitive"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradingviewUsername"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradingviewUsername"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradingviewUsernameCaseSensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradingviewUsernameCaseSensitive"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradingviewUsernameAddedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewUsername"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewUsernameCaseSensitive"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewUsernameAddedAt"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewAccessStatus"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewAccessActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewAccessInactiveAt"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateTradingViewUsernameMutationFn = Apollo.MutationFunction<UpdateTradingViewUsernameMutation, UpdateTradingViewUsernameMutationVariables>;

/**
 * __useUpdateTradingViewUsernameMutation__
 *
 * To run a mutation, you first call `useUpdateTradingViewUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTradingViewUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTradingViewUsernameMutation, { data, loading, error }] = useUpdateTradingViewUsernameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tradingviewUsername: // value for 'tradingviewUsername'
 *      tradingviewUsernameCaseSensitive: // value for 'tradingviewUsernameCaseSensitive'
 *   },
 * });
 */
export function useUpdateTradingViewUsernameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTradingViewUsernameMutation, UpdateTradingViewUsernameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTradingViewUsernameMutation, UpdateTradingViewUsernameMutationVariables>(UpdateTradingViewUsernameDocument, options);
      }
export type UpdateTradingViewUsernameMutationHookResult = ReturnType<typeof useUpdateTradingViewUsernameMutation>;
export type UpdateTradingViewUsernameMutationResult = Apollo.MutationResult<UpdateTradingViewUsernameMutation>;
export type UpdateTradingViewUsernameMutationOptions = Apollo.BaseMutationOptions<UpdateTradingViewUsernameMutation, UpdateTradingViewUsernameMutationVariables>;
export const UpdateUserSoundSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserSoundSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSoundEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isSoundEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSoundEnabled"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSoundEnabled"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateUserSoundSettingMutationFn = Apollo.MutationFunction<UpdateUserSoundSettingMutation, UpdateUserSoundSettingMutationVariables>;

/**
 * __useUpdateUserSoundSettingMutation__
 *
 * To run a mutation, you first call `useUpdateUserSoundSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSoundSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSoundSettingMutation, { data, loading, error }] = useUpdateUserSoundSettingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isSoundEnabled: // value for 'isSoundEnabled'
 *   },
 * });
 */
export function useUpdateUserSoundSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSoundSettingMutation, UpdateUserSoundSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSoundSettingMutation, UpdateUserSoundSettingMutationVariables>(UpdateUserSoundSettingDocument, options);
      }
export type UpdateUserSoundSettingMutationHookResult = ReturnType<typeof useUpdateUserSoundSettingMutation>;
export type UpdateUserSoundSettingMutationResult = Apollo.MutationResult<UpdateUserSoundSettingMutation>;
export type UpdateUserSoundSettingMutationOptions = Apollo.BaseMutationOptions<UpdateUserSoundSettingMutation, UpdateUserSoundSettingMutationVariables>;
export const GetCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCurrentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewUsername"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewUsernameCaseSensitive"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewUsernameAddedAt"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewAccessStatus"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewAccessActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewAccessInactiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"timezoneLocation"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"isSoundEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isDashboardLifetime"}},{"kind":"Field","name":{"kind":"Name","value":"isTechnicalAnalysisLifetime"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetInsiderTradesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInsiderTrades"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"insider_trades_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"insider_trades_order_by"}}}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filingDateTimestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insider_trades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"securityName"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionDate"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"transactionValue"}},{"kind":"Field","name":{"kind":"Name","value":"typeOfOwnerCategory"}},{"kind":"Field","name":{"kind":"Name","value":"typeOfOwner"}},{"kind":"Field","name":{"kind":"Name","value":"reportingCik"}},{"kind":"Field","name":{"kind":"Name","value":"reportingName"}},{"kind":"Field","name":{"kind":"Name","value":"securitiesOwned"}},{"kind":"Field","name":{"kind":"Name","value":"securitiesTransacted"}},{"kind":"Field","name":{"kind":"Name","value":"isDirector"}},{"kind":"Field","name":{"kind":"Name","value":"isOfficer"}},{"kind":"Field","name":{"kind":"Name","value":"isTenPercentOwner"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfTransactions"}},{"kind":"Field","name":{"kind":"Name","value":"ownerJobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"filingDate"}},{"kind":"Field","name":{"kind":"Name","value":"filingDateTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"companyCik"}},{"kind":"Field","name":{"kind":"Name","value":"changeInPercentOwned"}},{"kind":"Field","name":{"kind":"Name","value":"acquistionOrDisposition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insider_trades_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetInsiderTradesQuery__
 *
 * To run a query within a React component, call `useGetInsiderTradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsiderTradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsiderTradesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetInsiderTradesQuery(baseOptions: Apollo.QueryHookOptions<GetInsiderTradesQuery, GetInsiderTradesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsiderTradesQuery, GetInsiderTradesQueryVariables>(GetInsiderTradesDocument, options);
      }
export function useGetInsiderTradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsiderTradesQuery, GetInsiderTradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsiderTradesQuery, GetInsiderTradesQueryVariables>(GetInsiderTradesDocument, options);
        }
export type GetInsiderTradesQueryHookResult = ReturnType<typeof useGetInsiderTradesQuery>;
export type GetInsiderTradesLazyQueryHookResult = ReturnType<typeof useGetInsiderTradesLazyQuery>;
export type GetInsiderTradesQueryResult = Apollo.QueryResult<GetInsiderTradesQuery, GetInsiderTradesQueryVariables>;
export const GetInsiderTradesTopTickersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInsiderTradesTopTickers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insider_trades_top_long"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"netTransactionValue"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insider_trades_top_short"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"netTransactionValue"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetInsiderTradesTopTickersQuery__
 *
 * To run a query within a React component, call `useGetInsiderTradesTopTickersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsiderTradesTopTickersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsiderTradesTopTickersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsiderTradesTopTickersQuery(baseOptions?: Apollo.QueryHookOptions<GetInsiderTradesTopTickersQuery, GetInsiderTradesTopTickersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsiderTradesTopTickersQuery, GetInsiderTradesTopTickersQueryVariables>(GetInsiderTradesTopTickersDocument, options);
      }
export function useGetInsiderTradesTopTickersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsiderTradesTopTickersQuery, GetInsiderTradesTopTickersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsiderTradesTopTickersQuery, GetInsiderTradesTopTickersQueryVariables>(GetInsiderTradesTopTickersDocument, options);
        }
export type GetInsiderTradesTopTickersQueryHookResult = ReturnType<typeof useGetInsiderTradesTopTickersQuery>;
export type GetInsiderTradesTopTickersLazyQueryHookResult = ReturnType<typeof useGetInsiderTradesTopTickersLazyQuery>;
export type GetInsiderTradesTopTickersQueryResult = Apollo.QueryResult<GetInsiderTradesTopTickersQuery, GetInsiderTradesTopTickersQueryVariables>;
export const SearchInserTradesByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchInserTradesByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportingName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insider_trades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reportingName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportingName"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"reportingName"}},{"kind":"Field","name":{"kind":"Name","value":"reportingCik"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSearchInserTradesByNameQuery__
 *
 * To run a query within a React component, call `useSearchInserTradesByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInserTradesByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInserTradesByNameQuery({
 *   variables: {
 *      reportingName: // value for 'reportingName'
 *   },
 * });
 */
export function useSearchInserTradesByNameQuery(baseOptions: Apollo.QueryHookOptions<SearchInserTradesByNameQuery, SearchInserTradesByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchInserTradesByNameQuery, SearchInserTradesByNameQueryVariables>(SearchInserTradesByNameDocument, options);
      }
export function useSearchInserTradesByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchInserTradesByNameQuery, SearchInserTradesByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchInserTradesByNameQuery, SearchInserTradesByNameQueryVariables>(SearchInserTradesByNameDocument, options);
        }
export type SearchInserTradesByNameQueryHookResult = ReturnType<typeof useSearchInserTradesByNameQuery>;
export type SearchInserTradesByNameLazyQueryHookResult = ReturnType<typeof useSearchInserTradesByNameLazyQuery>;
export type SearchInserTradesByNameQueryResult = Apollo.QueryResult<SearchInserTradesByNameQuery, SearchInserTradesByNameQueryVariables>;
export const GetOptionsForGexDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOptionsForGEX"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minOpenInterest"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expireDay"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expireMonth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expireYear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ASK","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"openInterest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minOpenInterest"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expireDay"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expireDay"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expireMonth"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expireMonth"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expireYear"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expireYear"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"strike"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"expireDay"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetOptionsForGexQuery__
 *
 * To run a query within a React component, call `useGetOptionsForGexQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptionsForGexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptionsForGexQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      minOpenInterest: // value for 'minOpenInterest'
 *      expireDay: // value for 'expireDay'
 *      expireMonth: // value for 'expireMonth'
 *      expireYear: // value for 'expireYear'
 *   },
 * });
 */
export function useGetOptionsForGexQuery(baseOptions: Apollo.QueryHookOptions<GetOptionsForGexQuery, GetOptionsForGexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOptionsForGexQuery, GetOptionsForGexQueryVariables>(GetOptionsForGexDocument, options);
      }
export function useGetOptionsForGexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOptionsForGexQuery, GetOptionsForGexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOptionsForGexQuery, GetOptionsForGexQueryVariables>(GetOptionsForGexDocument, options);
        }
export type GetOptionsForGexQueryHookResult = ReturnType<typeof useGetOptionsForGexQuery>;
export type GetOptionsForGexLazyQueryHookResult = ReturnType<typeof useGetOptionsForGexLazyQuery>;
export type GetOptionsForGexQueryResult = Apollo.QueryResult<GetOptionsForGexQuery, GetOptionsForGexQueryVariables>;
export const GetAllOptionsForGexDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllOptionsForGEX"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minOpenInterest"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ASK","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"openInterest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minOpenInterest"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"strike"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"expireDay"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetAllOptionsForGexQuery__
 *
 * To run a query within a React component, call `useGetAllOptionsForGexQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOptionsForGexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOptionsForGexQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      minOpenInterest: // value for 'minOpenInterest'
 *   },
 * });
 */
export function useGetAllOptionsForGexQuery(baseOptions: Apollo.QueryHookOptions<GetAllOptionsForGexQuery, GetAllOptionsForGexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllOptionsForGexQuery, GetAllOptionsForGexQueryVariables>(GetAllOptionsForGexDocument, options);
      }
export function useGetAllOptionsForGexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllOptionsForGexQuery, GetAllOptionsForGexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllOptionsForGexQuery, GetAllOptionsForGexQueryVariables>(GetAllOptionsForGexDocument, options);
        }
export type GetAllOptionsForGexQueryHookResult = ReturnType<typeof useGetAllOptionsForGexQuery>;
export type GetAllOptionsForGexLazyQueryHookResult = ReturnType<typeof useGetAllOptionsForGexLazyQuery>;
export type GetAllOptionsForGexQueryResult = Apollo.QueryResult<GetAllOptionsForGexQuery, GetAllOptionsForGexQueryVariables>;
export const GetUniqueExpiryDatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUniqueExpiryDates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"expireYear"},{"kind":"EnumValue","value":"expireMonth"},{"kind":"EnumValue","value":"expireDay"}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ASK","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expireYear"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expireMonth"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expireDay"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUniqueExpiryDatesQuery__
 *
 * To run a query within a React component, call `useGetUniqueExpiryDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqueExpiryDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqueExpiryDatesQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useGetUniqueExpiryDatesQuery(baseOptions: Apollo.QueryHookOptions<GetUniqueExpiryDatesQuery, GetUniqueExpiryDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniqueExpiryDatesQuery, GetUniqueExpiryDatesQueryVariables>(GetUniqueExpiryDatesDocument, options);
      }
export function useGetUniqueExpiryDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniqueExpiryDatesQuery, GetUniqueExpiryDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniqueExpiryDatesQuery, GetUniqueExpiryDatesQueryVariables>(GetUniqueExpiryDatesDocument, options);
        }
export type GetUniqueExpiryDatesQueryHookResult = ReturnType<typeof useGetUniqueExpiryDatesQuery>;
export type GetUniqueExpiryDatesLazyQueryHookResult = ReturnType<typeof useGetUniqueExpiryDatesLazyQuery>;
export type GetUniqueExpiryDatesQueryResult = Apollo.QueryResult<GetUniqueExpiryDatesQuery, GetUniqueExpiryDatesQueryVariables>;
export const GetAggregatedOptionsForGexDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAggregatedOptionsForGEX"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minOpenInterest"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option_flow_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ASK","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"openInterest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minOpenInterest"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetAggregatedOptionsForGexQuery__
 *
 * To run a query within a React component, call `useGetAggregatedOptionsForGexQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedOptionsForGexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedOptionsForGexQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      minOpenInterest: // value for 'minOpenInterest'
 *   },
 * });
 */
export function useGetAggregatedOptionsForGexQuery(baseOptions: Apollo.QueryHookOptions<GetAggregatedOptionsForGexQuery, GetAggregatedOptionsForGexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedOptionsForGexQuery, GetAggregatedOptionsForGexQueryVariables>(GetAggregatedOptionsForGexDocument, options);
      }
export function useGetAggregatedOptionsForGexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedOptionsForGexQuery, GetAggregatedOptionsForGexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedOptionsForGexQuery, GetAggregatedOptionsForGexQueryVariables>(GetAggregatedOptionsForGexDocument, options);
        }
export type GetAggregatedOptionsForGexQueryHookResult = ReturnType<typeof useGetAggregatedOptionsForGexQuery>;
export type GetAggregatedOptionsForGexLazyQueryHookResult = ReturnType<typeof useGetAggregatedOptionsForGexLazyQuery>;
export type GetAggregatedOptionsForGexQueryResult = Apollo.QueryResult<GetAggregatedOptionsForGexQuery, GetAggregatedOptionsForGexQueryVariables>;
export const GetTradingviewUsernameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTradingviewUsername"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewUsername"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewUsernameCaseSensitive"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewUsernameAddedAt"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewAccessStatus"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewAccessActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewAccessInactiveAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetTradingviewUsernameQuery__
 *
 * To run a query within a React component, call `useGetTradingviewUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTradingviewUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTradingviewUsernameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTradingviewUsernameQuery(baseOptions: Apollo.QueryHookOptions<GetTradingviewUsernameQuery, GetTradingviewUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTradingviewUsernameQuery, GetTradingviewUsernameQueryVariables>(GetTradingviewUsernameDocument, options);
      }
export function useGetTradingviewUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTradingviewUsernameQuery, GetTradingviewUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTradingviewUsernameQuery, GetTradingviewUsernameQueryVariables>(GetTradingviewUsernameDocument, options);
        }
export type GetTradingviewUsernameQueryHookResult = ReturnType<typeof useGetTradingviewUsernameQuery>;
export type GetTradingviewUsernameLazyQueryHookResult = ReturnType<typeof useGetTradingviewUsernameLazyQuery>;
export type GetTradingviewUsernameQueryResult = Apollo.QueryResult<GetTradingviewUsernameQuery, GetTradingviewUsernameQueryVariables>;
export const UpsertWatchListItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertWatchListItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isWatching"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_watch_list_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isWatching"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isWatching"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"watch_list_userId_ticker_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"isWatching"},{"kind":"EnumValue","value":"deletedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isWatching"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode;
export type UpsertWatchListItemMutationFn = Apollo.MutationFunction<UpsertWatchListItemMutation, UpsertWatchListItemMutationVariables>;

/**
 * __useUpsertWatchListItemMutation__
 *
 * To run a mutation, you first call `useUpsertWatchListItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertWatchListItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertWatchListItemMutation, { data, loading, error }] = useUpsertWatchListItemMutation({
 *   variables: {
 *      isWatching: // value for 'isWatching'
 *      ticker: // value for 'ticker'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpsertWatchListItemMutation(baseOptions?: Apollo.MutationHookOptions<UpsertWatchListItemMutation, UpsertWatchListItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertWatchListItemMutation, UpsertWatchListItemMutationVariables>(UpsertWatchListItemDocument, options);
      }
export type UpsertWatchListItemMutationHookResult = ReturnType<typeof useUpsertWatchListItemMutation>;
export type UpsertWatchListItemMutationResult = Apollo.MutationResult<UpsertWatchListItemMutation>;
export type UpsertWatchListItemMutationOptions = Apollo.BaseMutationOptions<UpsertWatchListItemMutation, UpsertWatchListItemMutationVariables>;
export const SolfDeleteWathclistItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"solfDeleteWathclistItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_watch_list_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isWatching"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode;
export type SolfDeleteWathclistItemMutationFn = Apollo.MutationFunction<SolfDeleteWathclistItemMutation, SolfDeleteWathclistItemMutationVariables>;

/**
 * __useSolfDeleteWathclistItemMutation__
 *
 * To run a mutation, you first call `useSolfDeleteWathclistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolfDeleteWathclistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solfDeleteWathclistItemMutation, { data, loading, error }] = useSolfDeleteWathclistItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSolfDeleteWathclistItemMutation(baseOptions?: Apollo.MutationHookOptions<SolfDeleteWathclistItemMutation, SolfDeleteWathclistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SolfDeleteWathclistItemMutation, SolfDeleteWathclistItemMutationVariables>(SolfDeleteWathclistItemDocument, options);
      }
export type SolfDeleteWathclistItemMutationHookResult = ReturnType<typeof useSolfDeleteWathclistItemMutation>;
export type SolfDeleteWathclistItemMutationResult = Apollo.MutationResult<SolfDeleteWathclistItemMutation>;
export type SolfDeleteWathclistItemMutationOptions = Apollo.BaseMutationOptions<SolfDeleteWathclistItemMutation, SolfDeleteWathclistItemMutationVariables>;
export const GetWatchListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWatchList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watch_list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isWatching"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetWatchListQuery__
 *
 * To run a query within a React component, call `useGetWatchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWatchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatchListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetWatchListQuery(baseOptions: Apollo.QueryHookOptions<GetWatchListQuery, GetWatchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWatchListQuery, GetWatchListQueryVariables>(GetWatchListDocument, options);
      }
export function useGetWatchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWatchListQuery, GetWatchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWatchListQuery, GetWatchListQueryVariables>(GetWatchListDocument, options);
        }
export type GetWatchListQueryHookResult = ReturnType<typeof useGetWatchListQuery>;
export type GetWatchListLazyQueryHookResult = ReturnType<typeof useGetWatchListLazyQuery>;
export type GetWatchListQueryResult = Apollo.QueryResult<GetWatchListQuery, GetWatchListQueryVariables>;
export const GetNewsEventsByKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getNewsEventsByKey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"news_cache_stocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"TOP_EVENTS","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetNewsEventsByKeyQuery__
 *
 * To run a query within a React component, call `useGetNewsEventsByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsEventsByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsEventsByKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsEventsByKeyQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsEventsByKeyQuery, GetNewsEventsByKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsEventsByKeyQuery, GetNewsEventsByKeyQueryVariables>(GetNewsEventsByKeyDocument, options);
      }
export function useGetNewsEventsByKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsEventsByKeyQuery, GetNewsEventsByKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsEventsByKeyQuery, GetNewsEventsByKeyQueryVariables>(GetNewsEventsByKeyDocument, options);
        }
export type GetNewsEventsByKeyQueryHookResult = ReturnType<typeof useGetNewsEventsByKeyQuery>;
export type GetNewsEventsByKeyLazyQueryHookResult = ReturnType<typeof useGetNewsEventsByKeyLazyQuery>;
export type GetNewsEventsByKeyQueryResult = Apollo.QueryResult<GetNewsEventsByKeyQuery, GetNewsEventsByKeyQueryVariables>;
export const InsertFlowConfigurationsOneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertFlowConfigurationsOne"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"flow_configurations_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_flow_configurations_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;
export type InsertFlowConfigurationsOneMutationFn = Apollo.MutationFunction<InsertFlowConfigurationsOneMutation, InsertFlowConfigurationsOneMutationVariables>;

/**
 * __useInsertFlowConfigurationsOneMutation__
 *
 * To run a mutation, you first call `useInsertFlowConfigurationsOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertFlowConfigurationsOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertFlowConfigurationsOneMutation, { data, loading, error }] = useInsertFlowConfigurationsOneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertFlowConfigurationsOneMutation(baseOptions?: Apollo.MutationHookOptions<InsertFlowConfigurationsOneMutation, InsertFlowConfigurationsOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertFlowConfigurationsOneMutation, InsertFlowConfigurationsOneMutationVariables>(InsertFlowConfigurationsOneDocument, options);
      }
export type InsertFlowConfigurationsOneMutationHookResult = ReturnType<typeof useInsertFlowConfigurationsOneMutation>;
export type InsertFlowConfigurationsOneMutationResult = Apollo.MutationResult<InsertFlowConfigurationsOneMutation>;
export type InsertFlowConfigurationsOneMutationOptions = Apollo.BaseMutationOptions<InsertFlowConfigurationsOneMutation, InsertFlowConfigurationsOneMutationVariables>;
export const GetUserFlowConfigurationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserFlowConfigurations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flow_configurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archivedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUserFlowConfigurationsQuery__
 *
 * To run a query within a React component, call `useGetUserFlowConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFlowConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFlowConfigurationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserFlowConfigurationsQuery(baseOptions: Apollo.QueryHookOptions<GetUserFlowConfigurationsQuery, GetUserFlowConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFlowConfigurationsQuery, GetUserFlowConfigurationsQueryVariables>(GetUserFlowConfigurationsDocument, options);
      }
export function useGetUserFlowConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFlowConfigurationsQuery, GetUserFlowConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFlowConfigurationsQuery, GetUserFlowConfigurationsQueryVariables>(GetUserFlowConfigurationsDocument, options);
        }
export type GetUserFlowConfigurationsQueryHookResult = ReturnType<typeof useGetUserFlowConfigurationsQuery>;
export type GetUserFlowConfigurationsLazyQueryHookResult = ReturnType<typeof useGetUserFlowConfigurationsLazyQuery>;
export type GetUserFlowConfigurationsQueryResult = Apollo.QueryResult<GetUserFlowConfigurationsQuery, GetUserFlowConfigurationsQueryVariables>;
export const ArchiveFlowConfigurationByPkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ArchiveFlowConfigurationByPk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archivedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_flow_configurations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archivedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archivedAt"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type ArchiveFlowConfigurationByPkMutationFn = Apollo.MutationFunction<ArchiveFlowConfigurationByPkMutation, ArchiveFlowConfigurationByPkMutationVariables>;

/**
 * __useArchiveFlowConfigurationByPkMutation__
 *
 * To run a mutation, you first call `useArchiveFlowConfigurationByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFlowConfigurationByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFlowConfigurationByPkMutation, { data, loading, error }] = useArchiveFlowConfigurationByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      archivedAt: // value for 'archivedAt'
 *   },
 * });
 */
export function useArchiveFlowConfigurationByPkMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveFlowConfigurationByPkMutation, ArchiveFlowConfigurationByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveFlowConfigurationByPkMutation, ArchiveFlowConfigurationByPkMutationVariables>(ArchiveFlowConfigurationByPkDocument, options);
      }
export type ArchiveFlowConfigurationByPkMutationHookResult = ReturnType<typeof useArchiveFlowConfigurationByPkMutation>;
export type ArchiveFlowConfigurationByPkMutationResult = Apollo.MutationResult<ArchiveFlowConfigurationByPkMutation>;
export type ArchiveFlowConfigurationByPkMutationOptions = Apollo.BaseMutationOptions<ArchiveFlowConfigurationByPkMutation, ArchiveFlowConfigurationByPkMutationVariables>;
export const GetDarkPoolTradesCountFullFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDarkPoolTradesCountFullFlow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow_full_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exchangeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"4"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetDarkPoolTradesCountFullFlowQuery__
 *
 * To run a query within a React component, call `useGetDarkPoolTradesCountFullFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDarkPoolTradesCountFullFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDarkPoolTradesCountFullFlowQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDarkPoolTradesCountFullFlowQuery(baseOptions?: Apollo.QueryHookOptions<GetDarkPoolTradesCountFullFlowQuery, GetDarkPoolTradesCountFullFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDarkPoolTradesCountFullFlowQuery, GetDarkPoolTradesCountFullFlowQueryVariables>(GetDarkPoolTradesCountFullFlowDocument, options);
      }
export function useGetDarkPoolTradesCountFullFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDarkPoolTradesCountFullFlowQuery, GetDarkPoolTradesCountFullFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDarkPoolTradesCountFullFlowQuery, GetDarkPoolTradesCountFullFlowQueryVariables>(GetDarkPoolTradesCountFullFlowDocument, options);
        }
export type GetDarkPoolTradesCountFullFlowQueryHookResult = ReturnType<typeof useGetDarkPoolTradesCountFullFlowQuery>;
export type GetDarkPoolTradesCountFullFlowLazyQueryHookResult = ReturnType<typeof useGetDarkPoolTradesCountFullFlowLazyQuery>;
export type GetDarkPoolTradesCountFullFlowQueryResult = Apollo.QueryResult<GetDarkPoolTradesCountFullFlowQuery, GetDarkPoolTradesCountFullFlowQueryVariables>;
export const GetLitPoolTradesCountFullFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLitPoolTradesCountFullFlow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow_full_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exchangeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"4"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetLitPoolTradesCountFullFlowQuery__
 *
 * To run a query within a React component, call `useGetLitPoolTradesCountFullFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLitPoolTradesCountFullFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLitPoolTradesCountFullFlowQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLitPoolTradesCountFullFlowQuery(baseOptions?: Apollo.QueryHookOptions<GetLitPoolTradesCountFullFlowQuery, GetLitPoolTradesCountFullFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLitPoolTradesCountFullFlowQuery, GetLitPoolTradesCountFullFlowQueryVariables>(GetLitPoolTradesCountFullFlowDocument, options);
      }
export function useGetLitPoolTradesCountFullFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLitPoolTradesCountFullFlowQuery, GetLitPoolTradesCountFullFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLitPoolTradesCountFullFlowQuery, GetLitPoolTradesCountFullFlowQueryVariables>(GetLitPoolTradesCountFullFlowDocument, options);
        }
export type GetLitPoolTradesCountFullFlowQueryHookResult = ReturnType<typeof useGetLitPoolTradesCountFullFlowQuery>;
export type GetLitPoolTradesCountFullFlowLazyQueryHookResult = ReturnType<typeof useGetLitPoolTradesCountFullFlowLazyQuery>;
export type GetLitPoolTradesCountFullFlowQueryResult = Apollo.QueryResult<GetLitPoolTradesCountFullFlowQuery, GetLitPoolTradesCountFullFlowQueryVariables>;
export const GetAllPoolTradesCountFullFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllPoolTradesCountFullFlow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow_full_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetAllPoolTradesCountFullFlowQuery__
 *
 * To run a query within a React component, call `useGetAllPoolTradesCountFullFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPoolTradesCountFullFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPoolTradesCountFullFlowQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPoolTradesCountFullFlowQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPoolTradesCountFullFlowQuery, GetAllPoolTradesCountFullFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPoolTradesCountFullFlowQuery, GetAllPoolTradesCountFullFlowQueryVariables>(GetAllPoolTradesCountFullFlowDocument, options);
      }
export function useGetAllPoolTradesCountFullFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPoolTradesCountFullFlowQuery, GetAllPoolTradesCountFullFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPoolTradesCountFullFlowQuery, GetAllPoolTradesCountFullFlowQueryVariables>(GetAllPoolTradesCountFullFlowDocument, options);
        }
export type GetAllPoolTradesCountFullFlowQueryHookResult = ReturnType<typeof useGetAllPoolTradesCountFullFlowQuery>;
export type GetAllPoolTradesCountFullFlowLazyQueryHookResult = ReturnType<typeof useGetAllPoolTradesCountFullFlowLazyQuery>;
export type GetAllPoolTradesCountFullFlowQueryResult = Apollo.QueryResult<GetAllPoolTradesCountFullFlowQuery, GetAllPoolTradesCountFullFlowQueryVariables>;
export const GetAffiliateViewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAffiliateViewer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"usernameCaseSensitive"}},{"kind":"Field","name":{"kind":"Name","value":"affiliateTier"}},{"kind":"Field","name":{"kind":"Name","value":"affiliateRevenueShare"}},{"kind":"Field","name":{"kind":"Name","value":"affiliateStartedAt"}},{"kind":"Field","name":{"kind":"Name","value":"affiliateEndedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paypalEmail"}},{"kind":"Field","name":{"kind":"Name","value":"affiliateLinkClicks_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"affiliateUserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"columns"},"value":{"kind":"EnumValue","value":"referralUrl"}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"affiliateSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"affiliateUserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"amountRefunded"}},{"kind":"Field","name":{"kind":"Name","value":"affiliateAmountPaid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountDue"}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"affiliateReferralClickCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"affiliateUserId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affiliateUserId"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"mostRecentDate"}},{"kind":"Field","name":{"kind":"Name","value":"referralUrl"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetAffiliateViewerQuery__
 *
 * To run a query within a React component, call `useGetAffiliateViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAffiliateViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAffiliateViewerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAffiliateViewerQuery(baseOptions: Apollo.QueryHookOptions<GetAffiliateViewerQuery, GetAffiliateViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAffiliateViewerQuery, GetAffiliateViewerQueryVariables>(GetAffiliateViewerDocument, options);
      }
export function useGetAffiliateViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAffiliateViewerQuery, GetAffiliateViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAffiliateViewerQuery, GetAffiliateViewerQueryVariables>(GetAffiliateViewerDocument, options);
        }
export type GetAffiliateViewerQueryHookResult = ReturnType<typeof useGetAffiliateViewerQuery>;
export type GetAffiliateViewerLazyQueryHookResult = ReturnType<typeof useGetAffiliateViewerLazyQuery>;
export type GetAffiliateViewerQueryResult = Apollo.QueryResult<GetAffiliateViewerQuery, GetAffiliateViewerQueryVariables>;
export const UpdatePaypalEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePaypalEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paypalEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paypalEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paypalEmail"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paypalEmail"}}]}}]}}]} as unknown as DocumentNode;
export type UpdatePaypalEmailMutationFn = Apollo.MutationFunction<UpdatePaypalEmailMutation, UpdatePaypalEmailMutationVariables>;

/**
 * __useUpdatePaypalEmailMutation__
 *
 * To run a mutation, you first call `useUpdatePaypalEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaypalEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaypalEmailMutation, { data, loading, error }] = useUpdatePaypalEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paypalEmail: // value for 'paypalEmail'
 *   },
 * });
 */
export function useUpdatePaypalEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaypalEmailMutation, UpdatePaypalEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaypalEmailMutation, UpdatePaypalEmailMutationVariables>(UpdatePaypalEmailDocument, options);
      }
export type UpdatePaypalEmailMutationHookResult = ReturnType<typeof useUpdatePaypalEmailMutation>;
export type UpdatePaypalEmailMutationResult = Apollo.MutationResult<UpdatePaypalEmailMutation>;
export type UpdatePaypalEmailMutationOptions = Apollo.BaseMutationOptions<UpdatePaypalEmailMutation, UpdatePaypalEmailMutationVariables>;
export const UpdateUserInsightsSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserInsightsSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailInsights"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"emailInsights"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailInsights"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emailInsights"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateUserInsightsSettingMutationFn = Apollo.MutationFunction<UpdateUserInsightsSettingMutation, UpdateUserInsightsSettingMutationVariables>;

/**
 * __useUpdateUserInsightsSettingMutation__
 *
 * To run a mutation, you first call `useUpdateUserInsightsSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInsightsSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserInsightsSettingMutation, { data, loading, error }] = useUpdateUserInsightsSettingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emailInsights: // value for 'emailInsights'
 *   },
 * });
 */
export function useUpdateUserInsightsSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserInsightsSettingMutation, UpdateUserInsightsSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserInsightsSettingMutation, UpdateUserInsightsSettingMutationVariables>(UpdateUserInsightsSettingDocument, options);
      }
export type UpdateUserInsightsSettingMutationHookResult = ReturnType<typeof useUpdateUserInsightsSettingMutation>;
export type UpdateUserInsightsSettingMutationResult = Apollo.MutationResult<UpdateUserInsightsSettingMutation>;
export type UpdateUserInsightsSettingMutationOptions = Apollo.BaseMutationOptions<UpdateUserInsightsSettingMutation, UpdateUserInsightsSettingMutationVariables>;
export const UpdateUsernameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUsername"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usernameCaseSensitive"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"usernameCaseSensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usernameCaseSensitive"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"affiliateStartedAt"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"usernameCaseSensitive"}},{"kind":"Field","name":{"kind":"Name","value":"affiliateStartedAt"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateUsernameMutationFn = Apollo.MutationFunction<UpdateUsernameMutation, UpdateUsernameMutationVariables>;

/**
 * __useUpdateUsernameMutation__
 *
 * To run a mutation, you first call `useUpdateUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsernameMutation, { data, loading, error }] = useUpdateUsernameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      username: // value for 'username'
 *      usernameCaseSensitive: // value for 'usernameCaseSensitive'
 *   },
 * });
 */
export function useUpdateUsernameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUsernameMutation, UpdateUsernameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUsernameMutation, UpdateUsernameMutationVariables>(UpdateUsernameDocument, options);
      }
export type UpdateUsernameMutationHookResult = ReturnType<typeof useUpdateUsernameMutation>;
export type UpdateUsernameMutationResult = Apollo.MutationResult<UpdateUsernameMutation>;
export type UpdateUsernameMutationOptions = Apollo.BaseMutationOptions<UpdateUsernameMutation, UpdateUsernameMutationVariables>;
export const GetExistingUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getExistingUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetExistingUserQuery__
 *
 * To run a query within a React component, call `useGetExistingUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExistingUserQuery(baseOptions: Apollo.QueryHookOptions<GetExistingUserQuery, GetExistingUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExistingUserQuery, GetExistingUserQueryVariables>(GetExistingUserDocument, options);
      }
export function useGetExistingUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExistingUserQuery, GetExistingUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExistingUserQuery, GetExistingUserQueryVariables>(GetExistingUserDocument, options);
        }
export type GetExistingUserQueryHookResult = ReturnType<typeof useGetExistingUserQuery>;
export type GetExistingUserLazyQueryHookResult = ReturnType<typeof useGetExistingUserLazyQuery>;
export type GetExistingUserQueryResult = Apollo.QueryResult<GetExistingUserQuery, GetExistingUserQueryVariables>;
export const GetElectronicAgreementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getElectronicAgreement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"employer"}},{"kind":"Field","name":{"kind":"Name","value":"opraTos"}},{"kind":"Field","name":{"kind":"Name","value":"opraQualifyingPerson"}},{"kind":"Field","name":{"kind":"Name","value":"opraPersonalUse"}},{"kind":"Field","name":{"kind":"Name","value":"opraNotProfessional"}},{"kind":"Field","name":{"kind":"Name","value":"opraWillUpdateDetails"}},{"kind":"Field","name":{"kind":"Name","value":"opraAllTerms"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetElectronicAgreementQuery__
 *
 * To run a query within a React component, call `useGetElectronicAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetElectronicAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetElectronicAgreementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetElectronicAgreementQuery(baseOptions: Apollo.QueryHookOptions<GetElectronicAgreementQuery, GetElectronicAgreementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetElectronicAgreementQuery, GetElectronicAgreementQueryVariables>(GetElectronicAgreementDocument, options);
      }
export function useGetElectronicAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetElectronicAgreementQuery, GetElectronicAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetElectronicAgreementQuery, GetElectronicAgreementQueryVariables>(GetElectronicAgreementDocument, options);
        }
export type GetElectronicAgreementQueryHookResult = ReturnType<typeof useGetElectronicAgreementQuery>;
export type GetElectronicAgreementLazyQueryHookResult = ReturnType<typeof useGetElectronicAgreementLazyQuery>;
export type GetElectronicAgreementQueryResult = Apollo.QueryResult<GetElectronicAgreementQuery, GetElectronicAgreementQueryVariables>;
export const GetHistoricalOptionFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHistoricalOptionFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option_feed_filtered"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"optionFeedFilteredTickerFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daily_volume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"optionFeedFilteredTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"option_feed_filtered"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetHistoricalOptionFlowQuery__
 *
 * To run a query within a React component, call `useGetHistoricalOptionFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalOptionFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalOptionFlowQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      tradeSides: // value for 'tradeSides'
 *   },
 * });
 */
export function useGetHistoricalOptionFlowQuery(baseOptions: Apollo.QueryHookOptions<GetHistoricalOptionFlowQuery, GetHistoricalOptionFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricalOptionFlowQuery, GetHistoricalOptionFlowQueryVariables>(GetHistoricalOptionFlowDocument, options);
      }
export function useGetHistoricalOptionFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricalOptionFlowQuery, GetHistoricalOptionFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricalOptionFlowQuery, GetHistoricalOptionFlowQueryVariables>(GetHistoricalOptionFlowDocument, options);
        }
export type GetHistoricalOptionFlowQueryHookResult = ReturnType<typeof useGetHistoricalOptionFlowQuery>;
export type GetHistoricalOptionFlowLazyQueryHookResult = ReturnType<typeof useGetHistoricalOptionFlowLazyQuery>;
export type GetHistoricalOptionFlowQueryResult = Apollo.QueryResult<GetHistoricalOptionFlowQuery, GetHistoricalOptionFlowQueryVariables>;
export const GetHistoricalOptionFlowWithTickersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHistoricalOptionFlowWithTickers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tickers"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"","block":false}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option_feed_filtered"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tickers"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"optionFeedFilteredTickerFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daily_volume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"optionFeedFilteredTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"option_feed_filtered"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetHistoricalOptionFlowWithTickersQuery__
 *
 * To run a query within a React component, call `useGetHistoricalOptionFlowWithTickersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalOptionFlowWithTickersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalOptionFlowWithTickersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      tickers: // value for 'tickers'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      tradeSides: // value for 'tradeSides'
 *   },
 * });
 */
export function useGetHistoricalOptionFlowWithTickersQuery(baseOptions: Apollo.QueryHookOptions<GetHistoricalOptionFlowWithTickersQuery, GetHistoricalOptionFlowWithTickersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricalOptionFlowWithTickersQuery, GetHistoricalOptionFlowWithTickersQueryVariables>(GetHistoricalOptionFlowWithTickersDocument, options);
      }
export function useGetHistoricalOptionFlowWithTickersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricalOptionFlowWithTickersQuery, GetHistoricalOptionFlowWithTickersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricalOptionFlowWithTickersQuery, GetHistoricalOptionFlowWithTickersQueryVariables>(GetHistoricalOptionFlowWithTickersDocument, options);
        }
export type GetHistoricalOptionFlowWithTickersQueryHookResult = ReturnType<typeof useGetHistoricalOptionFlowWithTickersQuery>;
export type GetHistoricalOptionFlowWithTickersLazyQueryHookResult = ReturnType<typeof useGetHistoricalOptionFlowWithTickersLazyQuery>;
export type GetHistoricalOptionFlowWithTickersQueryResult = Apollo.QueryResult<GetHistoricalOptionFlowWithTickersQuery, GetHistoricalOptionFlowWithTickersQueryVariables>;
export const GetOptionFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOptionFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"option_flow"},"name":{"kind":"Name","value":"option_flow_all_sides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"optionFlowAllSidesTickerFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daily_volume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"optionFlowAllSidesTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"option_flow_all_sides"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetOptionFlowQuery__
 *
 * To run a query within a React component, call `useGetOptionFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptionFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptionFlowQuery({
 *   variables: {
 *      tradeSides: // value for 'tradeSides'
 *   },
 * });
 */
export function useGetOptionFlowQuery(baseOptions?: Apollo.QueryHookOptions<GetOptionFlowQuery, GetOptionFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOptionFlowQuery, GetOptionFlowQueryVariables>(GetOptionFlowDocument, options);
      }
export function useGetOptionFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOptionFlowQuery, GetOptionFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOptionFlowQuery, GetOptionFlowQueryVariables>(GetOptionFlowDocument, options);
        }
export type GetOptionFlowQueryHookResult = ReturnType<typeof useGetOptionFlowQuery>;
export type GetOptionFlowLazyQueryHookResult = ReturnType<typeof useGetOptionFlowLazyQuery>;
export type GetOptionFlowQueryResult = Apollo.QueryResult<GetOptionFlowQuery, GetOptionFlowQueryVariables>;
export const GetFreeOptionFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFreeOptionFlow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"free_option_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ASK","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"freeOptionFlowTickerFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daily_volume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"freeOptionFlowTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"free_option_flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFreeOptionFlowQuery__
 *
 * To run a query within a React component, call `useGetFreeOptionFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreeOptionFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreeOptionFlowQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFreeOptionFlowQuery(baseOptions?: Apollo.QueryHookOptions<GetFreeOptionFlowQuery, GetFreeOptionFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFreeOptionFlowQuery, GetFreeOptionFlowQueryVariables>(GetFreeOptionFlowDocument, options);
      }
export function useGetFreeOptionFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreeOptionFlowQuery, GetFreeOptionFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFreeOptionFlowQuery, GetFreeOptionFlowQueryVariables>(GetFreeOptionFlowDocument, options);
        }
export type GetFreeOptionFlowQueryHookResult = ReturnType<typeof useGetFreeOptionFlowQuery>;
export type GetFreeOptionFlowLazyQueryHookResult = ReturnType<typeof useGetFreeOptionFlowLazyQuery>;
export type GetFreeOptionFlowQueryResult = Apollo.QueryResult<GetFreeOptionFlowQuery, GetFreeOptionFlowQueryVariables>;
export const GetFreeOptionFlowCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFreeOptionFlowCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"free_option_flow_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ASK","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFreeOptionFlowCountQuery__
 *
 * To run a query within a React component, call `useGetFreeOptionFlowCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreeOptionFlowCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreeOptionFlowCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFreeOptionFlowCountQuery(baseOptions?: Apollo.QueryHookOptions<GetFreeOptionFlowCountQuery, GetFreeOptionFlowCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFreeOptionFlowCountQuery, GetFreeOptionFlowCountQueryVariables>(GetFreeOptionFlowCountDocument, options);
      }
export function useGetFreeOptionFlowCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreeOptionFlowCountQuery, GetFreeOptionFlowCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFreeOptionFlowCountQuery, GetFreeOptionFlowCountQueryVariables>(GetFreeOptionFlowCountDocument, options);
        }
export type GetFreeOptionFlowCountQueryHookResult = ReturnType<typeof useGetFreeOptionFlowCountQuery>;
export type GetFreeOptionFlowCountLazyQueryHookResult = ReturnType<typeof useGetFreeOptionFlowCountLazyQuery>;
export type GetFreeOptionFlowCountQueryResult = Apollo.QueryResult<GetFreeOptionFlowCountQuery, GetFreeOptionFlowCountQueryVariables>;
export const GetUserForDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserForDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"opraAgreementCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"optionFlowFilters"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewUsername"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewUsernameCaseSensitive"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewUsernameAddedAt"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewAccessStatus"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewAccessActiveAt"}},{"kind":"Field","name":{"kind":"Name","value":"tradingviewAccessInactiveAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUserForDashboardQuery__
 *
 * To run a query within a React component, call `useGetUserForDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForDashboardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserForDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetUserForDashboardQuery, GetUserForDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserForDashboardQuery, GetUserForDashboardQueryVariables>(GetUserForDashboardDocument, options);
      }
export function useGetUserForDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserForDashboardQuery, GetUserForDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserForDashboardQuery, GetUserForDashboardQueryVariables>(GetUserForDashboardDocument, options);
        }
export type GetUserForDashboardQueryHookResult = ReturnType<typeof useGetUserForDashboardQuery>;
export type GetUserForDashboardLazyQueryHookResult = ReturnType<typeof useGetUserForDashboardLazyQuery>;
export type GetUserForDashboardQueryResult = Apollo.QueryResult<GetUserForDashboardQuery, GetUserForDashboardQueryVariables>;
export const UpdateUserOptionFlowFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserOptionFlowFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"optionFlowFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"optionFlowFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"optionFlowFilters"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"optionFlowFilters"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateUserOptionFlowFiltersMutationFn = Apollo.MutationFunction<UpdateUserOptionFlowFiltersMutation, UpdateUserOptionFlowFiltersMutationVariables>;

/**
 * __useUpdateUserOptionFlowFiltersMutation__
 *
 * To run a mutation, you first call `useUpdateUserOptionFlowFiltersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOptionFlowFiltersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOptionFlowFiltersMutation, { data, loading, error }] = useUpdateUserOptionFlowFiltersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      optionFlowFilters: // value for 'optionFlowFilters'
 *   },
 * });
 */
export function useUpdateUserOptionFlowFiltersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOptionFlowFiltersMutation, UpdateUserOptionFlowFiltersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOptionFlowFiltersMutation, UpdateUserOptionFlowFiltersMutationVariables>(UpdateUserOptionFlowFiltersDocument, options);
      }
export type UpdateUserOptionFlowFiltersMutationHookResult = ReturnType<typeof useUpdateUserOptionFlowFiltersMutation>;
export type UpdateUserOptionFlowFiltersMutationResult = Apollo.MutationResult<UpdateUserOptionFlowFiltersMutation>;
export type UpdateUserOptionFlowFiltersMutationOptions = Apollo.BaseMutationOptions<UpdateUserOptionFlowFiltersMutation, UpdateUserOptionFlowFiltersMutationVariables>;
export const HasNewOptionFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hasNewOptionFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"option_flow"},"name":{"kind":"Name","value":"option_flow_all_sides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHasNewOptionFlowQuery__
 *
 * To run a query within a React component, call `useHasNewOptionFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasNewOptionFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasNewOptionFlowQuery({
 *   variables: {
 *      since: // value for 'since'
 *      tradeSides: // value for 'tradeSides'
 *   },
 * });
 */
export function useHasNewOptionFlowQuery(baseOptions: Apollo.QueryHookOptions<HasNewOptionFlowQuery, HasNewOptionFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasNewOptionFlowQuery, HasNewOptionFlowQueryVariables>(HasNewOptionFlowDocument, options);
      }
export function useHasNewOptionFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasNewOptionFlowQuery, HasNewOptionFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasNewOptionFlowQuery, HasNewOptionFlowQueryVariables>(HasNewOptionFlowDocument, options);
        }
export type HasNewOptionFlowQueryHookResult = ReturnType<typeof useHasNewOptionFlowQuery>;
export type HasNewOptionFlowLazyQueryHookResult = ReturnType<typeof useHasNewOptionFlowLazyQuery>;
export type HasNewOptionFlowQueryResult = Apollo.QueryResult<HasNewOptionFlowQuery, HasNewOptionFlowQueryVariables>;
export const HasNewFreeOptionFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hasNewFreeOptionFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"free_option_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ASK","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHasNewFreeOptionFlowQuery__
 *
 * To run a query within a React component, call `useHasNewFreeOptionFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasNewFreeOptionFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasNewFreeOptionFlowQuery({
 *   variables: {
 *      since: // value for 'since'
 *   },
 * });
 */
export function useHasNewFreeOptionFlowQuery(baseOptions: Apollo.QueryHookOptions<HasNewFreeOptionFlowQuery, HasNewFreeOptionFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasNewFreeOptionFlowQuery, HasNewFreeOptionFlowQueryVariables>(HasNewFreeOptionFlowDocument, options);
      }
export function useHasNewFreeOptionFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasNewFreeOptionFlowQuery, HasNewFreeOptionFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasNewFreeOptionFlowQuery, HasNewFreeOptionFlowQueryVariables>(HasNewFreeOptionFlowDocument, options);
        }
export type HasNewFreeOptionFlowQueryHookResult = ReturnType<typeof useHasNewFreeOptionFlowQuery>;
export type HasNewFreeOptionFlowLazyQueryHookResult = ReturnType<typeof useHasNewFreeOptionFlowLazyQuery>;
export type HasNewFreeOptionFlowQueryResult = Apollo.QueryResult<HasNewFreeOptionFlowQuery, HasNewFreeOptionFlowQueryVariables>;
export const GetOpcStrategiesForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOpcStrategiesForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opc_saved_strategies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiration"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiration"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archivedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"breakEvenPrices"}},{"kind":"Field","name":{"kind":"Name","value":"cash"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVolatility"}},{"kind":"Field","name":{"kind":"Name","value":"isStrategyShared"}},{"kind":"Field","name":{"kind":"Name","value":"maxLoss"}},{"kind":"Field","name":{"kind":"Name","value":"maxProfit"}},{"kind":"Field","name":{"kind":"Name","value":"netCreditDebit"}},{"kind":"Field","name":{"kind":"Name","value":"premiumTransacted"}},{"kind":"Field","name":{"kind":"Name","value":"probabilityOfProfit"}},{"kind":"Field","name":{"kind":"Name","value":"profitIndex"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"stockPrice"}},{"kind":"Field","name":{"kind":"Name","value":"stockShares"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVolatility"}},{"kind":"Field","name":{"kind":"Name","value":"optionType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDirection"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetOpcStrategiesForUserQuery__
 *
 * To run a query within a React component, call `useGetOpcStrategiesForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpcStrategiesForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpcStrategiesForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      expiration: // value for 'expiration'
 *   },
 * });
 */
export function useGetOpcStrategiesForUserQuery(baseOptions: Apollo.QueryHookOptions<GetOpcStrategiesForUserQuery, GetOpcStrategiesForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpcStrategiesForUserQuery, GetOpcStrategiesForUserQueryVariables>(GetOpcStrategiesForUserDocument, options);
      }
export function useGetOpcStrategiesForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpcStrategiesForUserQuery, GetOpcStrategiesForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpcStrategiesForUserQuery, GetOpcStrategiesForUserQueryVariables>(GetOpcStrategiesForUserDocument, options);
        }
export type GetOpcStrategiesForUserQueryHookResult = ReturnType<typeof useGetOpcStrategiesForUserQuery>;
export type GetOpcStrategiesForUserLazyQueryHookResult = ReturnType<typeof useGetOpcStrategiesForUserLazyQuery>;
export type GetOpcStrategiesForUserQueryResult = Apollo.QueryResult<GetOpcStrategiesForUserQuery, GetOpcStrategiesForUserQueryVariables>;
export const InsertOpcSavedStrategyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertOpcSavedStrategy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"opc_saved_strategies_insert_input"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_opc_saved_strategies_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"breakEvenPrices"}},{"kind":"Field","name":{"kind":"Name","value":"cash"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVolatility"}},{"kind":"Field","name":{"kind":"Name","value":"isStrategyShared"}},{"kind":"Field","name":{"kind":"Name","value":"maxLoss"}},{"kind":"Field","name":{"kind":"Name","value":"maxProfit"}},{"kind":"Field","name":{"kind":"Name","value":"netCreditDebit"}},{"kind":"Field","name":{"kind":"Name","value":"premiumTransacted"}},{"kind":"Field","name":{"kind":"Name","value":"probabilityOfProfit"}},{"kind":"Field","name":{"kind":"Name","value":"profitIndex"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"stockPrice"}},{"kind":"Field","name":{"kind":"Name","value":"stockShares"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVolatility"}},{"kind":"Field","name":{"kind":"Name","value":"optionType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDirection"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}}]}}]}}]}}]} as unknown as DocumentNode;
export type InsertOpcSavedStrategyMutationFn = Apollo.MutationFunction<InsertOpcSavedStrategyMutation, InsertOpcSavedStrategyMutationVariables>;

/**
 * __useInsertOpcSavedStrategyMutation__
 *
 * To run a mutation, you first call `useInsertOpcSavedStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertOpcSavedStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertOpcSavedStrategyMutation, { data, loading, error }] = useInsertOpcSavedStrategyMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertOpcSavedStrategyMutation(baseOptions?: Apollo.MutationHookOptions<InsertOpcSavedStrategyMutation, InsertOpcSavedStrategyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertOpcSavedStrategyMutation, InsertOpcSavedStrategyMutationVariables>(InsertOpcSavedStrategyDocument, options);
      }
export type InsertOpcSavedStrategyMutationHookResult = ReturnType<typeof useInsertOpcSavedStrategyMutation>;
export type InsertOpcSavedStrategyMutationResult = Apollo.MutationResult<InsertOpcSavedStrategyMutation>;
export type InsertOpcSavedStrategyMutationOptions = Apollo.BaseMutationOptions<InsertOpcSavedStrategyMutation, InsertOpcSavedStrategyMutationVariables>;
export const ArchiveOpcSavedStrategyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"archiveOpcSavedStrategy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archivedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_opc_saved_strategies_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archivedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archivedAt"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type ArchiveOpcSavedStrategyMutationFn = Apollo.MutationFunction<ArchiveOpcSavedStrategyMutation, ArchiveOpcSavedStrategyMutationVariables>;

/**
 * __useArchiveOpcSavedStrategyMutation__
 *
 * To run a mutation, you first call `useArchiveOpcSavedStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveOpcSavedStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveOpcSavedStrategyMutation, { data, loading, error }] = useArchiveOpcSavedStrategyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      archivedAt: // value for 'archivedAt'
 *   },
 * });
 */
export function useArchiveOpcSavedStrategyMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveOpcSavedStrategyMutation, ArchiveOpcSavedStrategyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveOpcSavedStrategyMutation, ArchiveOpcSavedStrategyMutationVariables>(ArchiveOpcSavedStrategyDocument, options);
      }
export type ArchiveOpcSavedStrategyMutationHookResult = ReturnType<typeof useArchiveOpcSavedStrategyMutation>;
export type ArchiveOpcSavedStrategyMutationResult = Apollo.MutationResult<ArchiveOpcSavedStrategyMutation>;
export type ArchiveOpcSavedStrategyMutationOptions = Apollo.BaseMutationOptions<ArchiveOpcSavedStrategyMutation, ArchiveOpcSavedStrategyMutationVariables>;
export const GetTickerOptionFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTickerOptionFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sinceDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ticker_option_flow"},"name":{"kind":"Name","value":"ticker_option_flow_all_sides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sinceDate"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"tickerOptionFlowAllSidesTickerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tickerOptionFlowAllSidesTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ticker_option_flow_all_sides"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetTickerOptionFlowQuery__
 *
 * To run a query within a React component, call `useGetTickerOptionFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTickerOptionFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTickerOptionFlowQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      tradeSides: // value for 'tradeSides'
 *      sinceDate: // value for 'sinceDate'
 *   },
 * });
 */
export function useGetTickerOptionFlowQuery(baseOptions: Apollo.QueryHookOptions<GetTickerOptionFlowQuery, GetTickerOptionFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTickerOptionFlowQuery, GetTickerOptionFlowQueryVariables>(GetTickerOptionFlowDocument, options);
      }
export function useGetTickerOptionFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTickerOptionFlowQuery, GetTickerOptionFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTickerOptionFlowQuery, GetTickerOptionFlowQueryVariables>(GetTickerOptionFlowDocument, options);
        }
export type GetTickerOptionFlowQueryHookResult = ReturnType<typeof useGetTickerOptionFlowQuery>;
export type GetTickerOptionFlowLazyQueryHookResult = ReturnType<typeof useGetTickerOptionFlowLazyQuery>;
export type GetTickerOptionFlowQueryResult = Apollo.QueryResult<GetTickerOptionFlowQuery, GetTickerOptionFlowQueryVariables>;
export const GetTickerOptionFlowCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTickerOptionFlowCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ticker_option_flow_aggregate"},"name":{"kind":"Name","value":"ticker_option_flow_all_sides_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetTickerOptionFlowCountQuery__
 *
 * To run a query within a React component, call `useGetTickerOptionFlowCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTickerOptionFlowCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTickerOptionFlowCountQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      tradeSides: // value for 'tradeSides'
 *   },
 * });
 */
export function useGetTickerOptionFlowCountQuery(baseOptions: Apollo.QueryHookOptions<GetTickerOptionFlowCountQuery, GetTickerOptionFlowCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTickerOptionFlowCountQuery, GetTickerOptionFlowCountQueryVariables>(GetTickerOptionFlowCountDocument, options);
      }
export function useGetTickerOptionFlowCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTickerOptionFlowCountQuery, GetTickerOptionFlowCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTickerOptionFlowCountQuery, GetTickerOptionFlowCountQueryVariables>(GetTickerOptionFlowCountDocument, options);
        }
export type GetTickerOptionFlowCountQueryHookResult = ReturnType<typeof useGetTickerOptionFlowCountQuery>;
export type GetTickerOptionFlowCountLazyQueryHookResult = ReturnType<typeof useGetTickerOptionFlowCountLazyQuery>;
export type GetTickerOptionFlowCountQueryResult = Apollo.QueryResult<GetTickerOptionFlowCountQuery, GetTickerOptionFlowCountQueryVariables>;
export const GetFullFeedTickerOptionFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFullFeedTickerOptionFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_feed_option_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fullFeedTickerOptionFlowTickerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fullFeedTickerOptionFlowTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"full_feed_option_flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFullFeedTickerOptionFlowQuery__
 *
 * To run a query within a React component, call `useGetFullFeedTickerOptionFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullFeedTickerOptionFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullFeedTickerOptionFlowQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      tradeSides: // value for 'tradeSides'
 *   },
 * });
 */
export function useGetFullFeedTickerOptionFlowQuery(baseOptions: Apollo.QueryHookOptions<GetFullFeedTickerOptionFlowQuery, GetFullFeedTickerOptionFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullFeedTickerOptionFlowQuery, GetFullFeedTickerOptionFlowQueryVariables>(GetFullFeedTickerOptionFlowDocument, options);
      }
export function useGetFullFeedTickerOptionFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullFeedTickerOptionFlowQuery, GetFullFeedTickerOptionFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullFeedTickerOptionFlowQuery, GetFullFeedTickerOptionFlowQueryVariables>(GetFullFeedTickerOptionFlowDocument, options);
        }
export type GetFullFeedTickerOptionFlowQueryHookResult = ReturnType<typeof useGetFullFeedTickerOptionFlowQuery>;
export type GetFullFeedTickerOptionFlowLazyQueryHookResult = ReturnType<typeof useGetFullFeedTickerOptionFlowLazyQuery>;
export type GetFullFeedTickerOptionFlowQueryResult = Apollo.QueryResult<GetFullFeedTickerOptionFlowQuery, GetFullFeedTickerOptionFlowQueryVariables>;
export const GetFullFeedTickerOptionFlowCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFullFeedTickerOptionFlowCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option_feed_baseline_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFullFeedTickerOptionFlowCountQuery__
 *
 * To run a query within a React component, call `useGetFullFeedTickerOptionFlowCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullFeedTickerOptionFlowCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullFeedTickerOptionFlowCountQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      tradeSides: // value for 'tradeSides'
 *   },
 * });
 */
export function useGetFullFeedTickerOptionFlowCountQuery(baseOptions: Apollo.QueryHookOptions<GetFullFeedTickerOptionFlowCountQuery, GetFullFeedTickerOptionFlowCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullFeedTickerOptionFlowCountQuery, GetFullFeedTickerOptionFlowCountQueryVariables>(GetFullFeedTickerOptionFlowCountDocument, options);
      }
export function useGetFullFeedTickerOptionFlowCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullFeedTickerOptionFlowCountQuery, GetFullFeedTickerOptionFlowCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullFeedTickerOptionFlowCountQuery, GetFullFeedTickerOptionFlowCountQueryVariables>(GetFullFeedTickerOptionFlowCountDocument, options);
        }
export type GetFullFeedTickerOptionFlowCountQueryHookResult = ReturnType<typeof useGetFullFeedTickerOptionFlowCountQuery>;
export type GetFullFeedTickerOptionFlowCountLazyQueryHookResult = ReturnType<typeof useGetFullFeedTickerOptionFlowCountLazyQuery>;
export type GetFullFeedTickerOptionFlowCountQueryResult = Apollo.QueryResult<GetFullFeedTickerOptionFlowCountQuery, GetFullFeedTickerOptionFlowCountQueryVariables>;
export const GetTickerDarkPoolTradesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTickerDarkPoolTrades"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sinceDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker_equity_print_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sinceDate"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"ask"}},{"kind":"Field","name":{"kind":"Name","value":"askSize"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"percentAboveAsk"}},{"kind":"Field","name":{"kind":"Name","value":"percentBelowBid"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"timestampIso"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"dayVolume"}},{"kind":"Field","name":{"kind":"Name","value":"avgPrice"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureVolume"}},{"kind":"Field","name":{"kind":"Name","value":"isOutsideDailyRange"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanOpen"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradePrice"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"isEtf"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureEtfTicker"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetTickerDarkPoolTradesQuery__
 *
 * To run a query within a React component, call `useGetTickerDarkPoolTradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTickerDarkPoolTradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTickerDarkPoolTradesQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      sinceDate: // value for 'sinceDate'
 *   },
 * });
 */
export function useGetTickerDarkPoolTradesQuery(baseOptions: Apollo.QueryHookOptions<GetTickerDarkPoolTradesQuery, GetTickerDarkPoolTradesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTickerDarkPoolTradesQuery, GetTickerDarkPoolTradesQueryVariables>(GetTickerDarkPoolTradesDocument, options);
      }
export function useGetTickerDarkPoolTradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTickerDarkPoolTradesQuery, GetTickerDarkPoolTradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTickerDarkPoolTradesQuery, GetTickerDarkPoolTradesQueryVariables>(GetTickerDarkPoolTradesDocument, options);
        }
export type GetTickerDarkPoolTradesQueryHookResult = ReturnType<typeof useGetTickerDarkPoolTradesQuery>;
export type GetTickerDarkPoolTradesLazyQueryHookResult = ReturnType<typeof useGetTickerDarkPoolTradesLazyQuery>;
export type GetTickerDarkPoolTradesQueryResult = Apollo.QueryResult<GetTickerDarkPoolTradesQuery, GetTickerDarkPoolTradesQueryVariables>;
export const GetTickerDarkPoolTradesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTickerDarkPoolTradesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_feed_filtered_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetTickerDarkPoolTradesCountQuery__
 *
 * To run a query within a React component, call `useGetTickerDarkPoolTradesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTickerDarkPoolTradesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTickerDarkPoolTradesCountQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useGetTickerDarkPoolTradesCountQuery(baseOptions: Apollo.QueryHookOptions<GetTickerDarkPoolTradesCountQuery, GetTickerDarkPoolTradesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTickerDarkPoolTradesCountQuery, GetTickerDarkPoolTradesCountQueryVariables>(GetTickerDarkPoolTradesCountDocument, options);
      }
export function useGetTickerDarkPoolTradesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTickerDarkPoolTradesCountQuery, GetTickerDarkPoolTradesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTickerDarkPoolTradesCountQuery, GetTickerDarkPoolTradesCountQueryVariables>(GetTickerDarkPoolTradesCountDocument, options);
        }
export type GetTickerDarkPoolTradesCountQueryHookResult = ReturnType<typeof useGetTickerDarkPoolTradesCountQuery>;
export type GetTickerDarkPoolTradesCountLazyQueryHookResult = ReturnType<typeof useGetTickerDarkPoolTradesCountLazyQuery>;
export type GetTickerDarkPoolTradesCountQueryResult = Apollo.QueryResult<GetTickerDarkPoolTradesCountQuery, GetTickerDarkPoolTradesCountQueryVariables>;
export const GetFullFeedTickerEquityPrintFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFullFeedTickerEquityPrintFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sinceDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_feed_equity_print_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sinceDate"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"ask"}},{"kind":"Field","name":{"kind":"Name","value":"askSize"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"percentAboveAsk"}},{"kind":"Field","name":{"kind":"Name","value":"percentBelowBid"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"timestampIso"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"dayVolume"}},{"kind":"Field","name":{"kind":"Name","value":"avgPrice"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureVolume"}},{"kind":"Field","name":{"kind":"Name","value":"isOutsideDailyRange"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanOpen"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradePrice"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"isEtf"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureEtfTicker"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFullFeedTickerEquityPrintFlowQuery__
 *
 * To run a query within a React component, call `useGetFullFeedTickerEquityPrintFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullFeedTickerEquityPrintFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullFeedTickerEquityPrintFlowQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      sinceDate: // value for 'sinceDate'
 *   },
 * });
 */
export function useGetFullFeedTickerEquityPrintFlowQuery(baseOptions: Apollo.QueryHookOptions<GetFullFeedTickerEquityPrintFlowQuery, GetFullFeedTickerEquityPrintFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullFeedTickerEquityPrintFlowQuery, GetFullFeedTickerEquityPrintFlowQueryVariables>(GetFullFeedTickerEquityPrintFlowDocument, options);
      }
export function useGetFullFeedTickerEquityPrintFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullFeedTickerEquityPrintFlowQuery, GetFullFeedTickerEquityPrintFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullFeedTickerEquityPrintFlowQuery, GetFullFeedTickerEquityPrintFlowQueryVariables>(GetFullFeedTickerEquityPrintFlowDocument, options);
        }
export type GetFullFeedTickerEquityPrintFlowQueryHookResult = ReturnType<typeof useGetFullFeedTickerEquityPrintFlowQuery>;
export type GetFullFeedTickerEquityPrintFlowLazyQueryHookResult = ReturnType<typeof useGetFullFeedTickerEquityPrintFlowLazyQuery>;
export type GetFullFeedTickerEquityPrintFlowQueryResult = Apollo.QueryResult<GetFullFeedTickerEquityPrintFlowQuery, GetFullFeedTickerEquityPrintFlowQueryVariables>;
export const GetFullFeedTickerEquityPrintFlowCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFullFeedTickerEquityPrintFlowCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_feed_baseline_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFullFeedTickerEquityPrintFlowCountQuery__
 *
 * To run a query within a React component, call `useGetFullFeedTickerEquityPrintFlowCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullFeedTickerEquityPrintFlowCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullFeedTickerEquityPrintFlowCountQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useGetFullFeedTickerEquityPrintFlowCountQuery(baseOptions: Apollo.QueryHookOptions<GetFullFeedTickerEquityPrintFlowCountQuery, GetFullFeedTickerEquityPrintFlowCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullFeedTickerEquityPrintFlowCountQuery, GetFullFeedTickerEquityPrintFlowCountQueryVariables>(GetFullFeedTickerEquityPrintFlowCountDocument, options);
      }
export function useGetFullFeedTickerEquityPrintFlowCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullFeedTickerEquityPrintFlowCountQuery, GetFullFeedTickerEquityPrintFlowCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullFeedTickerEquityPrintFlowCountQuery, GetFullFeedTickerEquityPrintFlowCountQueryVariables>(GetFullFeedTickerEquityPrintFlowCountDocument, options);
        }
export type GetFullFeedTickerEquityPrintFlowCountQueryHookResult = ReturnType<typeof useGetFullFeedTickerEquityPrintFlowCountQuery>;
export type GetFullFeedTickerEquityPrintFlowCountLazyQueryHookResult = ReturnType<typeof useGetFullFeedTickerEquityPrintFlowCountLazyQuery>;
export type GetFullFeedTickerEquityPrintFlowCountQueryResult = Apollo.QueryResult<GetFullFeedTickerEquityPrintFlowCountQuery, GetFullFeedTickerEquityPrintFlowCountQueryVariables>;
export const GetFreeTickerOptionFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFreeTickerOptionFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sinceDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"free_ticker_option_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sinceDate"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"freeTickerOptionFlowTickerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"freeTickerOptionFlowTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"free_ticker_option_flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFreeTickerOptionFlowQuery__
 *
 * To run a query within a React component, call `useGetFreeTickerOptionFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreeTickerOptionFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreeTickerOptionFlowQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      sinceDate: // value for 'sinceDate'
 *   },
 * });
 */
export function useGetFreeTickerOptionFlowQuery(baseOptions: Apollo.QueryHookOptions<GetFreeTickerOptionFlowQuery, GetFreeTickerOptionFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFreeTickerOptionFlowQuery, GetFreeTickerOptionFlowQueryVariables>(GetFreeTickerOptionFlowDocument, options);
      }
export function useGetFreeTickerOptionFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreeTickerOptionFlowQuery, GetFreeTickerOptionFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFreeTickerOptionFlowQuery, GetFreeTickerOptionFlowQueryVariables>(GetFreeTickerOptionFlowDocument, options);
        }
export type GetFreeTickerOptionFlowQueryHookResult = ReturnType<typeof useGetFreeTickerOptionFlowQuery>;
export type GetFreeTickerOptionFlowLazyQueryHookResult = ReturnType<typeof useGetFreeTickerOptionFlowLazyQuery>;
export type GetFreeTickerOptionFlowQueryResult = Apollo.QueryResult<GetFreeTickerOptionFlowQuery, GetFreeTickerOptionFlowQueryVariables>;
export const GetFreeTickerOptionFlowCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFreeTickerOptionFlowCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"free_ticker_option_flow_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFreeTickerOptionFlowCountQuery__
 *
 * To run a query within a React component, call `useGetFreeTickerOptionFlowCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreeTickerOptionFlowCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreeTickerOptionFlowCountQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useGetFreeTickerOptionFlowCountQuery(baseOptions: Apollo.QueryHookOptions<GetFreeTickerOptionFlowCountQuery, GetFreeTickerOptionFlowCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFreeTickerOptionFlowCountQuery, GetFreeTickerOptionFlowCountQueryVariables>(GetFreeTickerOptionFlowCountDocument, options);
      }
export function useGetFreeTickerOptionFlowCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreeTickerOptionFlowCountQuery, GetFreeTickerOptionFlowCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFreeTickerOptionFlowCountQuery, GetFreeTickerOptionFlowCountQueryVariables>(GetFreeTickerOptionFlowCountDocument, options);
        }
export type GetFreeTickerOptionFlowCountQueryHookResult = ReturnType<typeof useGetFreeTickerOptionFlowCountQuery>;
export type GetFreeTickerOptionFlowCountLazyQueryHookResult = ReturnType<typeof useGetFreeTickerOptionFlowCountLazyQuery>;
export type GetFreeTickerOptionFlowCountQueryResult = Apollo.QueryResult<GetFreeTickerOptionFlowCountQuery, GetFreeTickerOptionFlowCountQueryVariables>;
export const InsertTickerResearchViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertTickerResearchView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_ticker_research_all_views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_ticker_research_daily_views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"ticker_research_daily_views_ticker_userId_date_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"updatedAt"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;
export type InsertTickerResearchViewMutationFn = Apollo.MutationFunction<InsertTickerResearchViewMutation, InsertTickerResearchViewMutationVariables>;

/**
 * __useInsertTickerResearchViewMutation__
 *
 * To run a mutation, you first call `useInsertTickerResearchViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertTickerResearchViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertTickerResearchViewMutation, { data, loading, error }] = useInsertTickerResearchViewMutation({
 *   variables: {
 *      date: // value for 'date'
 *      userId: // value for 'userId'
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useInsertTickerResearchViewMutation(baseOptions?: Apollo.MutationHookOptions<InsertTickerResearchViewMutation, InsertTickerResearchViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertTickerResearchViewMutation, InsertTickerResearchViewMutationVariables>(InsertTickerResearchViewDocument, options);
      }
export type InsertTickerResearchViewMutationHookResult = ReturnType<typeof useInsertTickerResearchViewMutation>;
export type InsertTickerResearchViewMutationResult = Apollo.MutationResult<InsertTickerResearchViewMutation>;
export type InsertTickerResearchViewMutationOptions = Apollo.BaseMutationOptions<InsertTickerResearchViewMutation, InsertTickerResearchViewMutationVariables>;
export const GetEquityPrintFlowFullDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEquityPrintFlowFull"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sinceDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow_full"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sinceDate"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"ask"}},{"kind":"Field","name":{"kind":"Name","value":"askSize"}},{"kind":"Field","name":{"kind":"Name","value":"avgPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPercentChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPriceChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayVolume"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeId"}},{"kind":"Field","name":{"kind":"Name","value":"externalTradeId"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"isEtf"}},{"kind":"Field","name":{"kind":"Name","value":"isOutsideDailyRange"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanDailyAverage"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanOpen"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureEtfTicker"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureVolume"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradePrice"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"percentAboveAsk"}},{"kind":"Field","name":{"kind":"Name","value":"percentBelowBid"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfAvgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfMarketCap"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfTodaysVolume"}},{"kind":"Field","name":{"kind":"Name","value":"prevClose"}},{"kind":"Field","name":{"kind":"Name","value":"prevHigh"}},{"kind":"Field","name":{"kind":"Name","value":"prevLow"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"realtimePrice"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"tapeId"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"timestampIso"}},{"kind":"Field","name":{"kind":"Name","value":"tradeConditions"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetEquityPrintFlowFullQuery__
 *
 * To run a query within a React component, call `useGetEquityPrintFlowFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquityPrintFlowFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquityPrintFlowFullQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      sinceDate: // value for 'sinceDate'
 *   },
 * });
 */
export function useGetEquityPrintFlowFullQuery(baseOptions: Apollo.QueryHookOptions<GetEquityPrintFlowFullQuery, GetEquityPrintFlowFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquityPrintFlowFullQuery, GetEquityPrintFlowFullQueryVariables>(GetEquityPrintFlowFullDocument, options);
      }
export function useGetEquityPrintFlowFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquityPrintFlowFullQuery, GetEquityPrintFlowFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquityPrintFlowFullQuery, GetEquityPrintFlowFullQueryVariables>(GetEquityPrintFlowFullDocument, options);
        }
export type GetEquityPrintFlowFullQueryHookResult = ReturnType<typeof useGetEquityPrintFlowFullQuery>;
export type GetEquityPrintFlowFullLazyQueryHookResult = ReturnType<typeof useGetEquityPrintFlowFullLazyQuery>;
export type GetEquityPrintFlowFullQueryResult = Apollo.QueryResult<GetEquityPrintFlowFullQuery, GetEquityPrintFlowFullQueryVariables>;
export const HasNewTickerOptionFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hasNewTickerOptionFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ticker_option_flow"},"name":{"kind":"Name","value":"ticker_option_flow_all_sides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHasNewTickerOptionFlowQuery__
 *
 * To run a query within a React component, call `useHasNewTickerOptionFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasNewTickerOptionFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasNewTickerOptionFlowQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      tradeSides: // value for 'tradeSides'
 *      since: // value for 'since'
 *   },
 * });
 */
export function useHasNewTickerOptionFlowQuery(baseOptions: Apollo.QueryHookOptions<HasNewTickerOptionFlowQuery, HasNewTickerOptionFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasNewTickerOptionFlowQuery, HasNewTickerOptionFlowQueryVariables>(HasNewTickerOptionFlowDocument, options);
      }
export function useHasNewTickerOptionFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasNewTickerOptionFlowQuery, HasNewTickerOptionFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasNewTickerOptionFlowQuery, HasNewTickerOptionFlowQueryVariables>(HasNewTickerOptionFlowDocument, options);
        }
export type HasNewTickerOptionFlowQueryHookResult = ReturnType<typeof useHasNewTickerOptionFlowQuery>;
export type HasNewTickerOptionFlowLazyQueryHookResult = ReturnType<typeof useHasNewTickerOptionFlowLazyQuery>;
export type HasNewTickerOptionFlowQueryResult = Apollo.QueryResult<HasNewTickerOptionFlowQuery, HasNewTickerOptionFlowQueryVariables>;
export const GetDarkPoolCountFullDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDarkPoolCountFull"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow_full_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"exchangeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"4"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetDarkPoolCountFullQuery__
 *
 * To run a query within a React component, call `useGetDarkPoolCountFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDarkPoolCountFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDarkPoolCountFullQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useGetDarkPoolCountFullQuery(baseOptions: Apollo.QueryHookOptions<GetDarkPoolCountFullQuery, GetDarkPoolCountFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDarkPoolCountFullQuery, GetDarkPoolCountFullQueryVariables>(GetDarkPoolCountFullDocument, options);
      }
export function useGetDarkPoolCountFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDarkPoolCountFullQuery, GetDarkPoolCountFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDarkPoolCountFullQuery, GetDarkPoolCountFullQueryVariables>(GetDarkPoolCountFullDocument, options);
        }
export type GetDarkPoolCountFullQueryHookResult = ReturnType<typeof useGetDarkPoolCountFullQuery>;
export type GetDarkPoolCountFullLazyQueryHookResult = ReturnType<typeof useGetDarkPoolCountFullLazyQuery>;
export type GetDarkPoolCountFullQueryResult = Apollo.QueryResult<GetDarkPoolCountFullQuery, GetDarkPoolCountFullQueryVariables>;
export const HasNewFullFeedTickerOptionFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hasNewFullFeedTickerOptionFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_feed_option_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHasNewFullFeedTickerOptionFlowQuery__
 *
 * To run a query within a React component, call `useHasNewFullFeedTickerOptionFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasNewFullFeedTickerOptionFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasNewFullFeedTickerOptionFlowQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      tradeSides: // value for 'tradeSides'
 *      since: // value for 'since'
 *   },
 * });
 */
export function useHasNewFullFeedTickerOptionFlowQuery(baseOptions: Apollo.QueryHookOptions<HasNewFullFeedTickerOptionFlowQuery, HasNewFullFeedTickerOptionFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasNewFullFeedTickerOptionFlowQuery, HasNewFullFeedTickerOptionFlowQueryVariables>(HasNewFullFeedTickerOptionFlowDocument, options);
      }
export function useHasNewFullFeedTickerOptionFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasNewFullFeedTickerOptionFlowQuery, HasNewFullFeedTickerOptionFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasNewFullFeedTickerOptionFlowQuery, HasNewFullFeedTickerOptionFlowQueryVariables>(HasNewFullFeedTickerOptionFlowDocument, options);
        }
export type HasNewFullFeedTickerOptionFlowQueryHookResult = ReturnType<typeof useHasNewFullFeedTickerOptionFlowQuery>;
export type HasNewFullFeedTickerOptionFlowLazyQueryHookResult = ReturnType<typeof useHasNewFullFeedTickerOptionFlowLazyQuery>;
export type HasNewFullFeedTickerOptionFlowQueryResult = Apollo.QueryResult<HasNewFullFeedTickerOptionFlowQuery, HasNewFullFeedTickerOptionFlowQueryVariables>;
export const GetLitPoolCountFullDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLitPoolCountFull"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow_full_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"exchangeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"4"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetLitPoolCountFullQuery__
 *
 * To run a query within a React component, call `useGetLitPoolCountFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLitPoolCountFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLitPoolCountFullQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useGetLitPoolCountFullQuery(baseOptions: Apollo.QueryHookOptions<GetLitPoolCountFullQuery, GetLitPoolCountFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLitPoolCountFullQuery, GetLitPoolCountFullQueryVariables>(GetLitPoolCountFullDocument, options);
      }
export function useGetLitPoolCountFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLitPoolCountFullQuery, GetLitPoolCountFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLitPoolCountFullQuery, GetLitPoolCountFullQueryVariables>(GetLitPoolCountFullDocument, options);
        }
export type GetLitPoolCountFullQueryHookResult = ReturnType<typeof useGetLitPoolCountFullQuery>;
export type GetLitPoolCountFullLazyQueryHookResult = ReturnType<typeof useGetLitPoolCountFullLazyQuery>;
export type GetLitPoolCountFullQueryResult = Apollo.QueryResult<GetLitPoolCountFullQuery, GetLitPoolCountFullQueryVariables>;
export const HasNewFreeTickerOptionFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hasNewFreeTickerOptionFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"free_ticker_option_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHasNewFreeTickerOptionFlowQuery__
 *
 * To run a query within a React component, call `useHasNewFreeTickerOptionFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasNewFreeTickerOptionFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasNewFreeTickerOptionFlowQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      since: // value for 'since'
 *   },
 * });
 */
export function useHasNewFreeTickerOptionFlowQuery(baseOptions: Apollo.QueryHookOptions<HasNewFreeTickerOptionFlowQuery, HasNewFreeTickerOptionFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasNewFreeTickerOptionFlowQuery, HasNewFreeTickerOptionFlowQueryVariables>(HasNewFreeTickerOptionFlowDocument, options);
      }
export function useHasNewFreeTickerOptionFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasNewFreeTickerOptionFlowQuery, HasNewFreeTickerOptionFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasNewFreeTickerOptionFlowQuery, HasNewFreeTickerOptionFlowQueryVariables>(HasNewFreeTickerOptionFlowDocument, options);
        }
export type HasNewFreeTickerOptionFlowQueryHookResult = ReturnType<typeof useHasNewFreeTickerOptionFlowQuery>;
export type HasNewFreeTickerOptionFlowLazyQueryHookResult = ReturnType<typeof useHasNewFreeTickerOptionFlowLazyQuery>;
export type HasNewFreeTickerOptionFlowQueryResult = Apollo.QueryResult<HasNewFreeTickerOptionFlowQuery, HasNewFreeTickerOptionFlowQueryVariables>;
export const GetAllPoolCountFullDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllPoolCountFull"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow_full_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetAllPoolCountFullQuery__
 *
 * To run a query within a React component, call `useGetAllPoolCountFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPoolCountFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPoolCountFullQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *   },
 * });
 */
export function useGetAllPoolCountFullQuery(baseOptions: Apollo.QueryHookOptions<GetAllPoolCountFullQuery, GetAllPoolCountFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPoolCountFullQuery, GetAllPoolCountFullQueryVariables>(GetAllPoolCountFullDocument, options);
      }
export function useGetAllPoolCountFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPoolCountFullQuery, GetAllPoolCountFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPoolCountFullQuery, GetAllPoolCountFullQueryVariables>(GetAllPoolCountFullDocument, options);
        }
export type GetAllPoolCountFullQueryHookResult = ReturnType<typeof useGetAllPoolCountFullQuery>;
export type GetAllPoolCountFullLazyQueryHookResult = ReturnType<typeof useGetAllPoolCountFullLazyQuery>;
export type GetAllPoolCountFullQueryResult = Apollo.QueryResult<GetAllPoolCountFullQuery, GetAllPoolCountFullQueryVariables>;
export const HasNewTickerDarkPoolTradesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hasNewTickerDarkPoolTrades"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker_equity_print_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHasNewTickerDarkPoolTradesQuery__
 *
 * To run a query within a React component, call `useHasNewTickerDarkPoolTradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasNewTickerDarkPoolTradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasNewTickerDarkPoolTradesQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      since: // value for 'since'
 *   },
 * });
 */
export function useHasNewTickerDarkPoolTradesQuery(baseOptions: Apollo.QueryHookOptions<HasNewTickerDarkPoolTradesQuery, HasNewTickerDarkPoolTradesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasNewTickerDarkPoolTradesQuery, HasNewTickerDarkPoolTradesQueryVariables>(HasNewTickerDarkPoolTradesDocument, options);
      }
export function useHasNewTickerDarkPoolTradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasNewTickerDarkPoolTradesQuery, HasNewTickerDarkPoolTradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasNewTickerDarkPoolTradesQuery, HasNewTickerDarkPoolTradesQueryVariables>(HasNewTickerDarkPoolTradesDocument, options);
        }
export type HasNewTickerDarkPoolTradesQueryHookResult = ReturnType<typeof useHasNewTickerDarkPoolTradesQuery>;
export type HasNewTickerDarkPoolTradesLazyQueryHookResult = ReturnType<typeof useHasNewTickerDarkPoolTradesLazyQuery>;
export type HasNewTickerDarkPoolTradesQueryResult = Apollo.QueryResult<HasNewTickerDarkPoolTradesQuery, HasNewTickerDarkPoolTradesQueryVariables>;
export const HasNewFullFeedTickerEquityPrintFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hasNewFullFeedTickerEquityPrintFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_feed_equity_print_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHasNewFullFeedTickerEquityPrintFlowQuery__
 *
 * To run a query within a React component, call `useHasNewFullFeedTickerEquityPrintFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasNewFullFeedTickerEquityPrintFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasNewFullFeedTickerEquityPrintFlowQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      since: // value for 'since'
 *   },
 * });
 */
export function useHasNewFullFeedTickerEquityPrintFlowQuery(baseOptions: Apollo.QueryHookOptions<HasNewFullFeedTickerEquityPrintFlowQuery, HasNewFullFeedTickerEquityPrintFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasNewFullFeedTickerEquityPrintFlowQuery, HasNewFullFeedTickerEquityPrintFlowQueryVariables>(HasNewFullFeedTickerEquityPrintFlowDocument, options);
      }
export function useHasNewFullFeedTickerEquityPrintFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasNewFullFeedTickerEquityPrintFlowQuery, HasNewFullFeedTickerEquityPrintFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasNewFullFeedTickerEquityPrintFlowQuery, HasNewFullFeedTickerEquityPrintFlowQueryVariables>(HasNewFullFeedTickerEquityPrintFlowDocument, options);
        }
export type HasNewFullFeedTickerEquityPrintFlowQueryHookResult = ReturnType<typeof useHasNewFullFeedTickerEquityPrintFlowQuery>;
export type HasNewFullFeedTickerEquityPrintFlowLazyQueryHookResult = ReturnType<typeof useHasNewFullFeedTickerEquityPrintFlowLazyQuery>;
export type HasNewFullFeedTickerEquityPrintFlowQueryResult = Apollo.QueryResult<HasNewFullFeedTickerEquityPrintFlowQuery, HasNewFullFeedTickerEquityPrintFlowQueryVariables>;
export const GetTickerOptionFlowHistoricalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTickerOptionFlowHistorical"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option_feed_filtered"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"optionFeedFilteredTickerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"optionFeedFilteredTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"option_feed_filtered"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetTickerOptionFlowHistoricalQuery__
 *
 * To run a query within a React component, call `useGetTickerOptionFlowHistoricalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTickerOptionFlowHistoricalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTickerOptionFlowHistoricalQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      tradeSides: // value for 'tradeSides'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetTickerOptionFlowHistoricalQuery(baseOptions: Apollo.QueryHookOptions<GetTickerOptionFlowHistoricalQuery, GetTickerOptionFlowHistoricalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTickerOptionFlowHistoricalQuery, GetTickerOptionFlowHistoricalQueryVariables>(GetTickerOptionFlowHistoricalDocument, options);
      }
export function useGetTickerOptionFlowHistoricalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTickerOptionFlowHistoricalQuery, GetTickerOptionFlowHistoricalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTickerOptionFlowHistoricalQuery, GetTickerOptionFlowHistoricalQueryVariables>(GetTickerOptionFlowHistoricalDocument, options);
        }
export type GetTickerOptionFlowHistoricalQueryHookResult = ReturnType<typeof useGetTickerOptionFlowHistoricalQuery>;
export type GetTickerOptionFlowHistoricalLazyQueryHookResult = ReturnType<typeof useGetTickerOptionFlowHistoricalLazyQuery>;
export type GetTickerOptionFlowHistoricalQueryResult = Apollo.QueryResult<GetTickerOptionFlowHistoricalQuery, GetTickerOptionFlowHistoricalQueryVariables>;
export const GetFullFeedTickerOptionFlowHistoricalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFullFeedTickerOptionFlowHistorical"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_feed_option_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fullFeedTickerOptionFlowTickerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fullFeedTickerOptionFlowTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"full_feed_option_flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFullFeedTickerOptionFlowHistoricalQuery__
 *
 * To run a query within a React component, call `useGetFullFeedTickerOptionFlowHistoricalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullFeedTickerOptionFlowHistoricalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullFeedTickerOptionFlowHistoricalQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      tradeSides: // value for 'tradeSides'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetFullFeedTickerOptionFlowHistoricalQuery(baseOptions: Apollo.QueryHookOptions<GetFullFeedTickerOptionFlowHistoricalQuery, GetFullFeedTickerOptionFlowHistoricalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullFeedTickerOptionFlowHistoricalQuery, GetFullFeedTickerOptionFlowHistoricalQueryVariables>(GetFullFeedTickerOptionFlowHistoricalDocument, options);
      }
export function useGetFullFeedTickerOptionFlowHistoricalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullFeedTickerOptionFlowHistoricalQuery, GetFullFeedTickerOptionFlowHistoricalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullFeedTickerOptionFlowHistoricalQuery, GetFullFeedTickerOptionFlowHistoricalQueryVariables>(GetFullFeedTickerOptionFlowHistoricalDocument, options);
        }
export type GetFullFeedTickerOptionFlowHistoricalQueryHookResult = ReturnType<typeof useGetFullFeedTickerOptionFlowHistoricalQuery>;
export type GetFullFeedTickerOptionFlowHistoricalLazyQueryHookResult = ReturnType<typeof useGetFullFeedTickerOptionFlowHistoricalLazyQuery>;
export type GetFullFeedTickerOptionFlowHistoricalQueryResult = Apollo.QueryResult<GetFullFeedTickerOptionFlowHistoricalQuery, GetFullFeedTickerOptionFlowHistoricalQueryVariables>;
export const GetFreeTickerOptionFlowHistoricalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFreeTickerOptionFlowHistorical"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"free_ticker_option_flow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"freeTickerOptionFlowTickerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"freeTickerOptionFlowTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"free_ticker_option_flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFreeTickerOptionFlowHistoricalQuery__
 *
 * To run a query within a React component, call `useGetFreeTickerOptionFlowHistoricalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreeTickerOptionFlowHistoricalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreeTickerOptionFlowHistoricalQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetFreeTickerOptionFlowHistoricalQuery(baseOptions: Apollo.QueryHookOptions<GetFreeTickerOptionFlowHistoricalQuery, GetFreeTickerOptionFlowHistoricalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFreeTickerOptionFlowHistoricalQuery, GetFreeTickerOptionFlowHistoricalQueryVariables>(GetFreeTickerOptionFlowHistoricalDocument, options);
      }
export function useGetFreeTickerOptionFlowHistoricalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreeTickerOptionFlowHistoricalQuery, GetFreeTickerOptionFlowHistoricalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFreeTickerOptionFlowHistoricalQuery, GetFreeTickerOptionFlowHistoricalQueryVariables>(GetFreeTickerOptionFlowHistoricalDocument, options);
        }
export type GetFreeTickerOptionFlowHistoricalQueryHookResult = ReturnType<typeof useGetFreeTickerOptionFlowHistoricalQuery>;
export type GetFreeTickerOptionFlowHistoricalLazyQueryHookResult = ReturnType<typeof useGetFreeTickerOptionFlowHistoricalLazyQuery>;
export type GetFreeTickerOptionFlowHistoricalQueryResult = Apollo.QueryResult<GetFreeTickerOptionFlowHistoricalQuery, GetFreeTickerOptionFlowHistoricalQueryVariables>;
export const GetTickerDarkPoolHistoricalBaselineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTickerDarkPoolHistoricalBaseline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_feed_baseline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DarkPoolTradeFields"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DarkPoolTradeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"equity_print_feed_baseline"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"ask"}},{"kind":"Field","name":{"kind":"Name","value":"askSize"}},{"kind":"Field","name":{"kind":"Name","value":"avgPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPercentChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPriceChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayVolume"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeId"}},{"kind":"Field","name":{"kind":"Name","value":"externalTradeId"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"isEtf"}},{"kind":"Field","name":{"kind":"Name","value":"isOutsideDailyRange"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanDailyAverage"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanOpen"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureEtfTicker"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureVolume"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradePrice"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"percentAboveAsk"}},{"kind":"Field","name":{"kind":"Name","value":"percentBelowBid"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfAvgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfMarketCap"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfTodaysVolume"}},{"kind":"Field","name":{"kind":"Name","value":"prevClose"}},{"kind":"Field","name":{"kind":"Name","value":"prevHigh"}},{"kind":"Field","name":{"kind":"Name","value":"prevLow"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"realtimePrice"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"tapeId"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"timestampIso"}},{"kind":"Field","name":{"kind":"Name","value":"tradeConditions"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetTickerDarkPoolHistoricalBaselineQuery__
 *
 * To run a query within a React component, call `useGetTickerDarkPoolHistoricalBaselineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTickerDarkPoolHistoricalBaselineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTickerDarkPoolHistoricalBaselineQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetTickerDarkPoolHistoricalBaselineQuery(baseOptions: Apollo.QueryHookOptions<GetTickerDarkPoolHistoricalBaselineQuery, GetTickerDarkPoolHistoricalBaselineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTickerDarkPoolHistoricalBaselineQuery, GetTickerDarkPoolHistoricalBaselineQueryVariables>(GetTickerDarkPoolHistoricalBaselineDocument, options);
      }
export function useGetTickerDarkPoolHistoricalBaselineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTickerDarkPoolHistoricalBaselineQuery, GetTickerDarkPoolHistoricalBaselineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTickerDarkPoolHistoricalBaselineQuery, GetTickerDarkPoolHistoricalBaselineQueryVariables>(GetTickerDarkPoolHistoricalBaselineDocument, options);
        }
export type GetTickerDarkPoolHistoricalBaselineQueryHookResult = ReturnType<typeof useGetTickerDarkPoolHistoricalBaselineQuery>;
export type GetTickerDarkPoolHistoricalBaselineLazyQueryHookResult = ReturnType<typeof useGetTickerDarkPoolHistoricalBaselineLazyQuery>;
export type GetTickerDarkPoolHistoricalBaselineQueryResult = Apollo.QueryResult<GetTickerDarkPoolHistoricalBaselineQuery, GetTickerDarkPoolHistoricalBaselineQueryVariables>;
export const GetEquityPrintFlowFullHistoricalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEquityPrintFlowFullHistorical"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equity_print_flow_full"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ticker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticker"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"ask"}},{"kind":"Field","name":{"kind":"Name","value":"askSize"}},{"kind":"Field","name":{"kind":"Name","value":"avgPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"bidSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPercentChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayOverDayPriceChange"}},{"kind":"Field","name":{"kind":"Name","value":"dayVolume"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeId"}},{"kind":"Field","name":{"kind":"Name","value":"externalTradeId"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"isEtf"}},{"kind":"Field","name":{"kind":"Name","value":"isOutsideDailyRange"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanDailyAverage"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceGreaterThanOpen"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureEtfTicker"}},{"kind":"Field","name":{"kind":"Name","value":"isSignatureVolume"}},{"kind":"Field","name":{"kind":"Name","value":"lastTradePrice"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"percentAboveAsk"}},{"kind":"Field","name":{"kind":"Name","value":"percentBelowBid"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfAvgVolume"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfMarketCap"}},{"kind":"Field","name":{"kind":"Name","value":"percentOfTodaysVolume"}},{"kind":"Field","name":{"kind":"Name","value":"prevClose"}},{"kind":"Field","name":{"kind":"Name","value":"prevHigh"}},{"kind":"Field","name":{"kind":"Name","value":"prevLow"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"realtimePrice"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"tapeId"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"timestampIso"}},{"kind":"Field","name":{"kind":"Name","value":"tradeConditions"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetEquityPrintFlowFullHistoricalQuery__
 *
 * To run a query within a React component, call `useGetEquityPrintFlowFullHistoricalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquityPrintFlowFullHistoricalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquityPrintFlowFullHistoricalQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetEquityPrintFlowFullHistoricalQuery(baseOptions: Apollo.QueryHookOptions<GetEquityPrintFlowFullHistoricalQuery, GetEquityPrintFlowFullHistoricalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquityPrintFlowFullHistoricalQuery, GetEquityPrintFlowFullHistoricalQueryVariables>(GetEquityPrintFlowFullHistoricalDocument, options);
      }
export function useGetEquityPrintFlowFullHistoricalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquityPrintFlowFullHistoricalQuery, GetEquityPrintFlowFullHistoricalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquityPrintFlowFullHistoricalQuery, GetEquityPrintFlowFullHistoricalQueryVariables>(GetEquityPrintFlowFullHistoricalDocument, options);
        }
export type GetEquityPrintFlowFullHistoricalQueryHookResult = ReturnType<typeof useGetEquityPrintFlowFullHistoricalQuery>;
export type GetEquityPrintFlowFullHistoricalLazyQueryHookResult = ReturnType<typeof useGetEquityPrintFlowFullHistoricalLazyQuery>;
export type GetEquityPrintFlowFullHistoricalQueryResult = Apollo.QueryResult<GetEquityPrintFlowFullHistoricalQuery, GetEquityPrintFlowFullHistoricalQueryVariables>;
export const GetTopTickersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTopTickers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"top_tickers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"second"}},{"kind":"Field","name":{"kind":"Name","value":"third"}},{"kind":"Field","name":{"kind":"Name","value":"fourth"}},{"kind":"Field","name":{"kind":"Name","value":"fifth"}},{"kind":"Field","name":{"kind":"Name","value":"firstTrades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"weeklyOptionFlowTickerFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondTrades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"weeklyOptionFlowTickerFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirdTrades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"weeklyOptionFlowTickerFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fourthTrades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"weeklyOptionFlowTickerFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fifthTrades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"weeklyOptionFlowTickerFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"daily_volume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"weeklyOptionFlowTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"weekly_option_flow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetTopTickersQuery__
 *
 * To run a query within a React component, call `useGetTopTickersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopTickersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopTickersQuery({
 *   variables: {
 *      tradeSides: // value for 'tradeSides'
 *   },
 * });
 */
export function useGetTopTickersQuery(baseOptions?: Apollo.QueryHookOptions<GetTopTickersQuery, GetTopTickersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopTickersQuery, GetTopTickersQueryVariables>(GetTopTickersDocument, options);
      }
export function useGetTopTickersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopTickersQuery, GetTopTickersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopTickersQuery, GetTopTickersQueryVariables>(GetTopTickersDocument, options);
        }
export type GetTopTickersQueryHookResult = ReturnType<typeof useGetTopTickersQuery>;
export type GetTopTickersLazyQueryHookResult = ReturnType<typeof useGetTopTickersLazyQuery>;
export type GetTopTickersQueryResult = Apollo.QueryResult<GetTopTickersQuery, GetTopTickersQueryVariables>;
export const GetUserCourseProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserCourseProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"course_progress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lesson_id"}},{"kind":"Field","name":{"kind":"Name","value":"masterclass_id"}},{"kind":"Field","name":{"kind":"Name","value":"section_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUserCourseProgressQuery__
 *
 * To run a query within a React component, call `useGetUserCourseProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCourseProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCourseProgressQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserCourseProgressQuery(baseOptions: Apollo.QueryHookOptions<GetUserCourseProgressQuery, GetUserCourseProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCourseProgressQuery, GetUserCourseProgressQueryVariables>(GetUserCourseProgressDocument, options);
      }
export function useGetUserCourseProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCourseProgressQuery, GetUserCourseProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCourseProgressQuery, GetUserCourseProgressQueryVariables>(GetUserCourseProgressDocument, options);
        }
export type GetUserCourseProgressQueryHookResult = ReturnType<typeof useGetUserCourseProgressQuery>;
export type GetUserCourseProgressLazyQueryHookResult = ReturnType<typeof useGetUserCourseProgressLazyQuery>;
export type GetUserCourseProgressQueryResult = Apollo.QueryResult<GetUserCourseProgressQuery, GetUserCourseProgressQueryVariables>;
export const UpsertCourseProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertCourseProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lesson_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"masterclass_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"course_progress_status_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update_columns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"course_progress_update_column"}}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"status"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_course_progress_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lesson_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lesson_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"masterclass_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"masterclass_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"section_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"course_progress_user_id_lesson_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update_columns"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lesson_id"}},{"kind":"Field","name":{"kind":"Name","value":"masterclass_id"}},{"kind":"Field","name":{"kind":"Name","value":"section_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode;
export type UpsertCourseProgressMutationFn = Apollo.MutationFunction<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>;

/**
 * __useUpsertCourseProgressMutation__
 *
 * To run a mutation, you first call `useUpsertCourseProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCourseProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCourseProgressMutation, { data, loading, error }] = useUpsertCourseProgressMutation({
 *   variables: {
 *      lesson_id: // value for 'lesson_id'
 *      masterclass_id: // value for 'masterclass_id'
 *      section_id: // value for 'section_id'
 *      status: // value for 'status'
 *      user_id: // value for 'user_id'
 *      update_columns: // value for 'update_columns'
 *   },
 * });
 */
export function useUpsertCourseProgressMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>(UpsertCourseProgressDocument, options);
      }
export type UpsertCourseProgressMutationHookResult = ReturnType<typeof useUpsertCourseProgressMutation>;
export type UpsertCourseProgressMutationResult = Apollo.MutationResult<UpsertCourseProgressMutation>;
export type UpsertCourseProgressMutationOptions = Apollo.BaseMutationOptions<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>;
export const GetWeeklyOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWeeklyOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"weekly_option_flow"},"name":{"kind":"Name","value":"weekly_option_flow_all_sides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"weeklyOptionFlowAllSidesTickerFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daily_volume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"weeklyOptionFlowAllSidesTickerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"weekly_option_flow_all_sides"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cp"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"lastExchangeTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"expireDay"}},{"kind":"Field","name":{"kind":"Name","value":"expireMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expireYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"openInterest"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"premium"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"spot"}},{"kind":"Field","name":{"kind":"Name","value":"priceExternalApi"}},{"kind":"Field","name":{"kind":"Name","value":"strike"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"tradeSide"}},{"kind":"Field","name":{"kind":"Name","value":"currentDailyVolume"}},{"kind":"Field","name":{"kind":"Name","value":"tickerDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nbboAsk"}},{"kind":"Field","name":{"kind":"Name","value":"nbboBid"}},{"kind":"Field","name":{"kind":"Name","value":"otmPercent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"impliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"gamma"}},{"kind":"Field","name":{"kind":"Name","value":"rho"}},{"kind":"Field","name":{"kind":"Name","value":"theta"}},{"kind":"Field","name":{"kind":"Name","value":"vega"}},{"kind":"Field","name":{"kind":"Name","value":"vanna"}},{"kind":"Field","name":{"kind":"Name","value":"vomma"}},{"kind":"Field","name":{"kind":"Name","value":"charm"}},{"kind":"Field","name":{"kind":"Name","value":"zomma"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"speed"}},{"kind":"Field","name":{"kind":"Name","value":"veta"}},{"kind":"Field","name":{"kind":"Name","value":"vera"}},{"kind":"Field","name":{"kind":"Name","value":"ultima"}},{"kind":"Field","name":{"kind":"Name","value":"lambda"}},{"kind":"Field","name":{"kind":"Name","value":"probTouch"}},{"kind":"Field","name":{"kind":"Name","value":"riskFreeRate"}},{"kind":"Field","name":{"kind":"Name","value":"nbboMidIv"}},{"kind":"Field","name":{"kind":"Name","value":"yearsToExpiry"}},{"kind":"Field","name":{"kind":"Name","value":"marketCap"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalSize"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalTrades"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalPremium"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalOpenInterest"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyTotalImpliedVol"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractsPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgImpliedVolPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgOpenInterestPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"avgPremiumPerTrade"}},{"kind":"Field","name":{"kind":"Name","value":"avgTradesPerDay"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetWeeklyOverviewQuery__
 *
 * To run a query within a React component, call `useGetWeeklyOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyOverviewQuery({
 *   variables: {
 *      tradeSides: // value for 'tradeSides'
 *   },
 * });
 */
export function useGetWeeklyOverviewQuery(baseOptions?: Apollo.QueryHookOptions<GetWeeklyOverviewQuery, GetWeeklyOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWeeklyOverviewQuery, GetWeeklyOverviewQueryVariables>(GetWeeklyOverviewDocument, options);
      }
export function useGetWeeklyOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWeeklyOverviewQuery, GetWeeklyOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWeeklyOverviewQuery, GetWeeklyOverviewQueryVariables>(GetWeeklyOverviewDocument, options);
        }
export type GetWeeklyOverviewQueryHookResult = ReturnType<typeof useGetWeeklyOverviewQuery>;
export type GetWeeklyOverviewLazyQueryHookResult = ReturnType<typeof useGetWeeklyOverviewLazyQuery>;
export type GetWeeklyOverviewQueryResult = Apollo.QueryResult<GetWeeklyOverviewQuery, GetWeeklyOverviewQueryVariables>;
export const GetWeeklyOverviewCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWeeklyOverviewCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ASK","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"weekly_option_flow_aggregate"},"name":{"kind":"Name","value":"weekly_option_flow_all_sides_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tradeSide"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeSides"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetWeeklyOverviewCountQuery__
 *
 * To run a query within a React component, call `useGetWeeklyOverviewCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyOverviewCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyOverviewCountQuery({
 *   variables: {
 *      tradeSides: // value for 'tradeSides'
 *   },
 * });
 */
export function useGetWeeklyOverviewCountQuery(baseOptions?: Apollo.QueryHookOptions<GetWeeklyOverviewCountQuery, GetWeeklyOverviewCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWeeklyOverviewCountQuery, GetWeeklyOverviewCountQueryVariables>(GetWeeklyOverviewCountDocument, options);
      }
export function useGetWeeklyOverviewCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWeeklyOverviewCountQuery, GetWeeklyOverviewCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWeeklyOverviewCountQuery, GetWeeklyOverviewCountQueryVariables>(GetWeeklyOverviewCountDocument, options);
        }
export type GetWeeklyOverviewCountQueryHookResult = ReturnType<typeof useGetWeeklyOverviewCountQuery>;
export type GetWeeklyOverviewCountLazyQueryHookResult = ReturnType<typeof useGetWeeklyOverviewCountLazyQuery>;
export type GetWeeklyOverviewCountQueryResult = Apollo.QueryResult<GetWeeklyOverviewCountQuery, GetWeeklyOverviewCountQueryVariables>;